/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v1.0.0`
 * OpenAPI spec version: 1.0.0
 */
/**
 * 상세 정보
 */
export type ErrorInfoDetails = { [key: string]: unknown };

export interface ErrorInfo {
  /** 에러 코드 */
  code: string;
  /** 에러 메시지 */
  message: string;
  /** 상세 정보 */
  details?: ErrorInfoDetails;
}

/**
 * 응답 데이터 (성공 시에만 포함)
 */
export type BaseResponseDtoData = { [key: string]: unknown };

export interface BaseResponseDto {
  /** API 호출 성공 여부 */
  success: boolean;
  /** 응답 데이터 (성공 시에만 포함) */
  data?: BaseResponseDtoData;
  /** 에러 정보 (실패 시에만 포함) */
  error?: ErrorInfo;
  /** 응답 생성 시각 (ISO 8601) */
  timestamp: string;
  /** HTTP 상태 코드 */
  statusCode?: number;
  /** 요청 처리 메시지 */
  message?: string;
}

export interface BuyerDto {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  userType?: string | null;
  /** @nullable */
  isActive?: boolean | null;
  /** @nullable */
  profileImageUrl?: string | null;
  /** @nullable */
  authId?: string | null;
  /** @nullable */
  lastLoginAt?: string | null;
  /** @nullable */
  gender?: string | null;
  /** @nullable */
  birthDate?: string | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  updatedAt?: string | null;
  /** @nullable */
  trustScore?: number | null;
  /**
   * 구매자 신뢰도 퍼센타일 (1, 5, 10, 15, 20, 30, null)
   * @nullable
   */
  trustPercentile?: number | null;
}

export interface SupplierDto {
  id: string;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  userType?: string | null;
  /** @nullable */
  isActive?: boolean | null;
  /** @nullable */
  trustBadge?: string | null;
  /** @nullable */
  trustPercentile?: number | null;
  /**
   * 인증 총점 (0-20)
   * @nullable
   */
  certificationTotalScore?: number | null;
  /**
   * 총 참여 점수 (0-20)
   * @nullable
   */
  totalParticipationScore?: number | null;
  /**
   * 계약 건수 점수 (0-20)
   * @nullable
   */
  contractCountScore?: number | null;
  /**
   * 총 금액 점수 (0-20)
   * @nullable
   */
  totalAmountScore?: number | null;
  /**
   * 총 수수료 점수 (0-20)
   * @nullable
   */
  totalCommissionScore?: number | null;
  /**
   * 최근 참여 점수 (0-20)
   * @nullable
   */
  recentParticipationScore?: number | null;
  /** @nullable */
  profileImageUrl?: string | null;
  /** @nullable */
  authId?: string | null;
  /** @nullable */
  lastLoginAt?: string | null;
  /** @nullable */
  supplierId?: string | null;
  /** @nullable */
  companyName?: string | null;
  /** @nullable */
  businessNumber?: string | null;
  /** @nullable */
  ceoName?: string | null;
  /** @nullable */
  companyPhone?: string | null;
  /** @nullable */
  managerName?: string | null;
  /** @nullable */
  managerPhone?: string | null;
  /** @nullable */
  businessType?: string | null;
  /** @nullable */
  province?: string | null;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  district?: string | null;
  /** @nullable */
  addressDetail?: string | null;
  /** @nullable */
  addressFull?: string | null;
  /** @nullable */
  companySealUrl?: string | null;
  /** @nullable */
  bankName?: string | null;
  /** @nullable */
  bankAccountNumber?: string | null;
  /** @nullable */
  bankAccountHolder?: string | null;
  /** @nullable */
  trustScore?: number | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  updatedAt?: string | null;
}

export interface ChatRoomQuoteRequestDto {
  /** 견적 요청 ID */
  id: string;
  /** 프로젝트명 */
  projectName: string;
  /** 견적 요청 번호 */
  requestNumber: string;
  /** 견적 요청 상태 */
  status: string;
}

/**
 * 채팅방 상태
 */
export type ChatRoomStatus =
  (typeof ChatRoomStatus)[keyof typeof ChatRoomStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatRoomStatus = {
  active: "active",
  contract_active: "contract_active",
  read_only: "read_only",
  inactive: "inactive",
  CLOSED: "CLOSED",
  archived: "archived",
} as const;

export interface ChatRoomLastMessageDto {
  /** 메시지 내용 */
  content: string;
  /** 메시지 타입 */
  type: string;
  /** 발신자 타입 */
  senderType: string;
}

/**
 * 발신자 타입
 */
export type QuoteMessageResponseDtoSenderType =
  (typeof QuoteMessageResponseDtoSenderType)[keyof typeof QuoteMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type QuoteMessageResponseDtoMessageType =
  (typeof QuoteMessageResponseDtoMessageType)[keyof typeof QuoteMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteMessageResponseDtoMessageType = {
  quote: "quote",
} as const;

/**
 * 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻.
 */
export type QuoteMessageResponseDtoTranslationStatus =
  (typeof QuoteMessageResponseDtoTranslationStatus)[keyof typeof QuoteMessageResponseDtoTranslationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteMessageResponseDtoTranslationStatus = {
  PENDING: "PENDING",
  DONE: "DONE",
  SKIPPED: "SKIPPED",
  FAILED: "FAILED",
} as const;

/**
 * 단가 입력 축 — EXCLUSIVE(단가가 공급가액, 부가세 가산) | INCLUSIVE(단가가 부가세 포함가, 총액에서 역산)
 */
export type QuoteMessageResponseDtoQuoteDataTaxType =
  (typeof QuoteMessageResponseDtoQuoteDataTaxType)[keyof typeof QuoteMessageResponseDtoQuoteDataTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteMessageResponseDtoQuoteDataTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

/**
 * 재고 상태(설계도 01 Phase C). 재고를 적은 공급사의 줄에만 있다 — 수량은 싣지 않는다
 */
export type QuoteMessageResponseDtoQuoteDataItemsItemStockState =
  (typeof QuoteMessageResponseDtoQuoteDataItemsItemStockState)[keyof typeof QuoteMessageResponseDtoQuoteDataItemsItemStockState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteMessageResponseDtoQuoteDataItemsItemStockState = {
  IN_STOCK: "IN_STOCK",
  SHORT: "SHORT",
} as const;

export type QuoteMessageResponseDtoQuoteDataItemsItem = {
  /** 항목명 */
  name?: string;
  /** 사양 */
  spec?: string;
  /** 설명 */
  notes?: string;
  /** 수량 */
  quantity?: number;
  /** 단위 */
  unit?: string;
  /** 단가 */
  unitPrice?: number;
  /** 재고 상태(설계도 01 Phase C). 재고를 적은 공급사의 줄에만 있다 — 수량은 싣지 않는다 */
  stockState?: QuoteMessageResponseDtoQuoteDataItemsItemStockState;
  /** 납품 소요일(재고 상태가 SHORT 일 때 나머지 납기) */
  leadTimeDays?: number;
  /** 화면 문구 — «즉시납품 가능» / «부분 보유 · 나머지 N일» */
  stockBadge?: string;
  /** 금액 (quantity × unitPrice) */
  amount?: number;
};

export type QuoteMessageResponseDtoQuoteDataSupplier = {
  /** 공급사 사용자 ID */
  id?: string;
  /** 공급사 회사명 */
  companyName?: string;
  /** 사업자 등록번호 */
  businessNumber?: string;
  /** 대표자명 */
  ceoName?: string;
  /** 주소 */
  addressFull?: string;
  /** 업종 */
  businessType?: string;
  /** 전화번호 */
  companyPhone?: string;
  /** 담당자명 */
  managerName?: string;
  /** 담당자 연락처 */
  managerPhone?: string;
  /** 회사 인장 URL */
  companySealUrl?: string;
  /** 신뢰도 배지 */
  trustBadge?: string;
  /** 검증 여부 */
  isVerified?: boolean;
};

export type QuoteMessageResponseDtoQuoteDataBuyer = {
  /** 담당자 이름 */
  name?: string;
  /** 담당자 연락처 */
  phone?: string;
};

export type QuoteMessageResponseDtoQuoteDataAttachmentsItem = {
  /** 파일명 */
  fileName?: string;
  /** 파일 공개 URL */
  url?: string;
  /** 스토리지 경로 (재서명에 사용) */
  filePath?: string;
  /** 파일 크기 (바이트) */
  fileSize?: number;
  /** MIME 타입 */
  contentType?: string;
};

/**
 * 견적서 데이터 (풍부한 정보 포함)
 */
export type QuoteMessageResponseDtoQuoteData = {
  quoteResponseId?: string;
  /** 버전 레코드 ID */
  quoteVersionId?: string;
  versionNumber?: number;
  totalAmount?: number;
  /** 단가 입력 축 — EXCLUSIVE(단가가 공급가액, 부가세 가산) | INCLUSIVE(단가가 부가세 포함가, 총액에서 역산) */
  taxType?: QuoteMessageResponseDtoQuoteDataTaxType;
  /** 공급가액 (부가세 제외) */
  supplyAmount?: number;
  /** 부가세 */
  taxAmount?: number;
  /** 이전 버전 금액 */
  previousAmount?: number;
  /** 버전 생성일 */
  createdAt?: string;
  /** 버전 수정일 */
  updatedAt?: string;
  /** 납기 — 발주 후 N일 (0 = 발주 즉시). 없으면 미기재 */
  deliveryDays?: number;
  /** 견적 유효기간 (YYYY-MM-DD). 없으면 미기재 */
  validUntil?: string;
  items?: QuoteMessageResponseDtoQuoteDataItemsItem[];
  supplier?: QuoteMessageResponseDtoQuoteDataSupplier;
  buyer?: QuoteMessageResponseDtoQuoteDataBuyer;
  /** PDF 다운로드 URL (Supabase Storage) */
  pdfUrl?: string;
  /** 견적 설명 */
  description?: string;
  /** 프로젝트명 */
  projectName?: string;
  /** 계약 완료 여부 (FREE plan 다운로드 제한용) */
  isContracted?: boolean;
  /** 계약 ID */
  contractId?: string;
  /** 첨부파일 목록 */
  attachments?: QuoteMessageResponseDtoQuoteDataAttachmentsItem[];
};

export interface QuoteMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: QuoteMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: QuoteMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 번역문 (트레이드 방에서만 채워진다). 원문은 message 그대로. */
  translatedMessage?: string;
  /** 번역문의 언어. ko | id */
  translatedLang?: string;
  /** 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻. */
  translationStatus?: QuoteMessageResponseDtoTranslationStatus;
  /** 견적서 데이터 (풍부한 정보 포함) */
  quoteData?: QuoteMessageResponseDtoQuoteData;
}

/**
 * 방 채널: domestic(국내) | trade(씨마켓 트레이드). trade 방은 견적·계약·결제·서류요청이 막혀 있고 발주자 신원이 늘 가려진다.
 */
export type ChatRoomResponseDtoChannel =
  (typeof ChatRoomResponseDtoChannel)[keyof typeof ChatRoomResponseDtoChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatRoomResponseDtoChannel = {
  domestic: "domestic",
  trade: "trade",
} as const;

export interface ChatRoomResponseDto {
  /** 채팅방 ID */
  id: string;
  /** 견적 요청 ID */
  quoteRequestId: string;
  /** 구매자 ID (Phase 2: user_id → buyer_id) */
  buyerId: string;
  /** 공급자 ID (필수) - 채팅방 생성 시 자동 설정됨 */
  supplierId: string;
  /** 견적 응답 ID (채팅방이 견적 응답과 연결된 경우) */
  quoteResponseId?: string;
  /** 계약 ID (계약 체결 후 설정) */
  contractId?: string;
  /** 구매자 정보 (users + buyers + quote_requests 테이블) */
  userInfo?: BuyerDto;
  /** 공급자 회사 정보 (users + suppliers 테이블) */
  supplierInfo: SupplierDto;
  /** 견적 요청 정보 (JOIN된 데이터) */
  quoteRequest?: ChatRoomQuoteRequestDto;
  /** Supabase Realtime 채널명 (Backend SSoT) */
  channelName: string;
  /** 채팅방 상태 */
  status: ChatRoomStatus;
  /** 마지막 메시지 시간 (ISO 8601 형식) */
  lastMessageAt?: string;
  /** 생성일시 (ISO 8601 형식) */
  createdAt: string;
  /** 수정일시 (ISO 8601 형식) */
  updatedAt: string;
  /** 마지막 메시지 정보 (성능 최적화) */
  lastMessage?: ChatRoomLastMessageDto;
  /**
   * 안읽은 메시지 수 (Watermark 패턴 기반 계산)
   * @minimum 0
   */
  unreadCount?: number;
  /** 마지막으로 읽은 메시지 ID (Watermark - 구매자용) */
  lastReadMessageIdBuyer?: string;
  /** 마지막으로 읽은 메시지 ID (Watermark - 공급자용) */
  lastReadMessageIdSupplier?: string;
  /** 최신 견적 메시지 (Info Panel 표시용) */
  latestQuoteMessage?: QuoteMessageResponseDto;
  /** 익명 사용자 여부 (상대방 정보의 블러 처리 여부 결정) */
  isAnonymous: boolean;
  /** 구독할 Realtime 이벤트 목록 (Broadcast 패턴) */
  events: string[];
  /** 방 채널: domestic(국내) | trade(씨마켓 트레이드). trade 방은 견적·계약·결제·서류요청이 막혀 있고 발주자 신원이 늘 가려진다. */
  channel: ChatRoomResponseDtoChannel;
  /** 발주자가 읽는 말 (트레이드 방에서만 채워진다). ko | id */
  buyerLang?: string;
  /** 공급사가 읽는 말 (트레이드 방에서만 채워진다). ko | id */
  supplierLang?: string;
}

export interface PaginationMetaDto {
  /** 전체 항목 수 */
  totalCount: number;
  /** 현재 페이지 항목 수 */
  itemCount: number;
  /** 페이지당 항목 수 */
  pageSize: number;
  /** 전체 페이지 수 */
  totalPages: number;
  /** 현재 페이지 */
  currentPage: number;
  /** 다음 페이지 존재 여부 */
  hasNext: boolean;
  /** 이전 페이지 존재 여부 */
  hasPrev: boolean;
  /** 커서 기반 페이징을 위한 다음 커서 */
  nextCursor?: string;
}

export interface PaginatedResponseDto {
  /** 응답 데이터 배열 */
  items: string[];
  /** 페이지네이션 메타 정보 */
  meta: PaginationMetaDto;
}

/**
 * 발신자 타입
 */
export type TextMessageResponseDtoSenderType =
  (typeof TextMessageResponseDtoSenderType)[keyof typeof TextMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TextMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type TextMessageResponseDtoMessageType =
  (typeof TextMessageResponseDtoMessageType)[keyof typeof TextMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TextMessageResponseDtoMessageType = {
  text: "text",
} as const;

/**
 * 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻.
 */
export type TextMessageResponseDtoTranslationStatus =
  (typeof TextMessageResponseDtoTranslationStatus)[keyof typeof TextMessageResponseDtoTranslationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TextMessageResponseDtoTranslationStatus = {
  PENDING: "PENDING",
  DONE: "DONE",
  SKIPPED: "SKIPPED",
  FAILED: "FAILED",
} as const;

export interface TextMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: TextMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: TextMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 번역문 (트레이드 방에서만 채워진다). 원문은 message 그대로. */
  translatedMessage?: string;
  /** 번역문의 언어. ko | id */
  translatedLang?: string;
  /** 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻. */
  translationStatus?: TextMessageResponseDtoTranslationStatus;
}

export interface ChatMessageAttachmentDto {
  /** 첨부파일 ID */
  id: string;
  /** 파일명 */
  fileName: string;
  /** 파일 크기 (바이트) */
  fileSize: number;
  /** 파일 타입 */
  fileType: string;
  /** MIME 타입 */
  contentType: string;
  /** 파일 URL */
  url: string;
  /** 파일 설명 */
  description?: string;
  /** 이미지 파일 여부 */
  isImage: boolean;
  /** 업로드 일시 (ISO 8601 형식) */
  createdAt: string;
  /** 파일 업로드 상태 (pending: 업로드 중, completed: 완료, failed: 실패) */
  uploadStatus: string;
  /** true이면 supplier에게 노출하지 않는 첨부 (buyer 채팅창 전용). 계약서류 자동 발급/SEMO 견적서에서 사용. */
  hiddenFromSupplier?: boolean;
}

/**
 * 발신자 타입
 */
export type AttachmentMessageResponseDtoSenderType =
  (typeof AttachmentMessageResponseDtoSenderType)[keyof typeof AttachmentMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttachmentMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type AttachmentMessageResponseDtoMessageType =
  (typeof AttachmentMessageResponseDtoMessageType)[keyof typeof AttachmentMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttachmentMessageResponseDtoMessageType = {
  attachment: "attachment",
} as const;

/**
 * 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻.
 */
export type AttachmentMessageResponseDtoTranslationStatus =
  (typeof AttachmentMessageResponseDtoTranslationStatus)[keyof typeof AttachmentMessageResponseDtoTranslationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttachmentMessageResponseDtoTranslationStatus = {
  PENDING: "PENDING",
  DONE: "DONE",
  SKIPPED: "SKIPPED",
  FAILED: "FAILED",
} as const;

export interface AttachmentMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: AttachmentMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: AttachmentMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 번역문 (트레이드 방에서만 채워진다). 원문은 message 그대로. */
  translatedMessage?: string;
  /** 번역문의 언어. ko | id */
  translatedLang?: string;
  /** 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻. */
  translationStatus?: AttachmentMessageResponseDtoTranslationStatus;
  /** 첨부파일 정보 */
  attachment?: ChatMessageAttachmentDto;
}

/**
 * 계약 상태
 */
export type ContractInfoDtoStatus =
  (typeof ContractInfoDtoStatus)[keyof typeof ContractInfoDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractInfoDtoStatus = {
  complete: "complete",
  cancelled: "cancelled",
  pending: "pending",
} as const;

/**
 * 결제 거래의 수단(payment_transactions 축). CMARKET_CARD 는 씨마켓 결제창을 거쳐 공급기업 가맹점으로 승인된 건이다. 계약 시 고른 현금/카드는 이 필드가 아니라 paymentChannel 이다.
 */
export type ContractInfoDtoPaymentMethod =
  (typeof ContractInfoDtoPaymentMethod)[keyof typeof ContractInfoDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractInfoDtoPaymentMethod = {
  CARD: "CARD",
  CASH: "CASH",
  DIRECT: "DIRECT",
  CMARKET_CARD: "CMARKET_CARD",
} as const;

/**
 * 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.
 * @nullable
 */
export type ContractInfoDtoPaymentChannel =
  | (typeof ContractInfoDtoPaymentChannel)[keyof typeof ContractInfoDtoPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractInfoDtoPaymentChannel = {
  cash: "cash",
  card: "card",
} as const;

/**
 * 씨마켓 계산서 진행 상태 (contracts.tax_invoice_status 실시간 조회). REQUESTED=발행요청됨, ISSUED=발행완료. NULL 은 아직 아무 통지도 오지 않은 상태다. 현금 계약에서 카드의 isPaid 와 같은 자리를 맡는다 — 스냅샷이 아니라 매 조회마다 계약에서 읽는다.
 * @nullable
 */
export type ContractInfoDtoTaxInvoiceStatus =
  | (typeof ContractInfoDtoTaxInvoiceStatus)[keyof typeof ContractInfoDtoTaxInvoiceStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractInfoDtoTaxInvoiceStatus = {
  REQUESTED: "REQUESTED",
  ISSUED: "ISSUED",
  CANCELLED: "CANCELLED",
} as const;

export type ContractInfoDtoItemsItem = {
  name?: string;
  spec?: string;
  quantity?: number;
  unit?: string;
  unitPrice?: number;
  amount?: number;
};

export interface ContractInfoDto {
  /** 계약 ID */
  contractId: string;
  /** 결제 ID */
  paymentId: string;
  /** Innopay 거래 고유번호 (TID) */
  tid?: string;
  /** 총 계약 금액 */
  totalAmount: number;
  /** 계약 체결 일시 */
  contractedAt: string;
  /** 계약 상태 */
  status: ContractInfoDtoStatus;
  /** 결제 거래의 수단(payment_transactions 축). CMARKET_CARD 는 씨마켓 결제창을 거쳐 공급기업 가맹점으로 승인된 건이다. 계약 시 고른 현금/카드는 이 필드가 아니라 paymentChannel 이다. */
  paymentMethod?: ContractInfoDtoPaymentMethod;
  /**
   * 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.
   * @nullable
   */
  paymentChannel?: ContractInfoDtoPaymentChannel;
  /**
   * 씨마켓 계산서 진행 상태 (contracts.tax_invoice_status 실시간 조회). REQUESTED=발행요청됨, ISSUED=발행완료. NULL 은 아직 아무 통지도 오지 않은 상태다. 현금 계약에서 카드의 isPaid 와 같은 자리를 맡는다 — 스냅샷이 아니라 매 조회마다 계약에서 읽는다.
   * @nullable
   */
  taxInvoiceStatus?: ContractInfoDtoTaxInvoiceStatus;
  /** 이 계약의 대금·계산서를 씨마켓에서 정리하는가(계약-먼저 길인가). 세모 안심결제 계약은 false — 대금은 세모가 이미 받았고 씨마켓에 갈 일이 없다. 카드의 「대금 정리」 칸을 그릴지 이 값 하나로 정한다. 지급 수단으로 되짚지 말 것. */
  settlesOnCmarket?: boolean;
  /** 공급자 상호명 */
  supplierCompanyName?: string;
  /** 공급자 대표자명 */
  supplierCeoName?: string;
  /** 공급자 사업자등록번호 */
  supplierBusinessNumber?: string;
  /** 공급자 주소 */
  supplierAddress?: string;
  /** 공급자 연락처 */
  supplierPhone?: string;
  /** 공급자 이메일 */
  supplierEmail?: string;
  /** 구매자 상호명/기관명 */
  buyerAgencyName?: string;
  /** 구매자 담당자명 */
  buyerManagerName?: string;
  /** 구매자 배송지 주소 */
  buyerAddress?: string;
  /** 배송지 주소 (legacy or alternate) */
  deliveryAddress?: string;
  /** [deprecated] 담당자 개인 연락처 — 더는 채우지 않는다(항상 빈 문자열) */
  buyerManagerPhone?: string;
  /** 발주기관 대표번호 (담당자 개인 휴대폰이 아니다) */
  buyerOrganizationPhone?: string;
  /** 구매자 사업자번호 (보조) */
  buyerBusinessNumber?: string;
  /** 대표 상품/서비스명 */
  itemName?: string;
  /** 상세 품목 리스트 (거래명세서용) */
  items?: ContractInfoDtoItemsItem[];
  /** 카드 승인번호 (Innopay) */
  authCode?: string;
  /** 취소 사유 (cancelled 상태일 때) */
  reason?: string;
  /** 결제 방법 스냅샷. true=선결제, false=후불결제. */
  isPrepaid?: boolean;
  /**
   * 결제 완료 시각. NULL 이면 미결제.
   * @nullable
   */
  paidAt?: string | null;
}

/**
 * 발신자 타입
 */
export type ContractMessageResponseDtoSenderType =
  (typeof ContractMessageResponseDtoSenderType)[keyof typeof ContractMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type ContractMessageResponseDtoMessageType =
  (typeof ContractMessageResponseDtoMessageType)[keyof typeof ContractMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractMessageResponseDtoMessageType = {
  contract: "contract",
} as const;

/**
 * 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻.
 */
export type ContractMessageResponseDtoTranslationStatus =
  (typeof ContractMessageResponseDtoTranslationStatus)[keyof typeof ContractMessageResponseDtoTranslationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractMessageResponseDtoTranslationStatus = {
  PENDING: "PENDING",
  DONE: "DONE",
  SKIPPED: "SKIPPED",
  FAILED: "FAILED",
} as const;

export interface ContractMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: ContractMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: ContractMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 번역문 (트레이드 방에서만 채워진다). 원문은 message 그대로. */
  translatedMessage?: string;
  /** 번역문의 언어. ko | id */
  translatedLang?: string;
  /** 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻. */
  translationStatus?: ContractMessageResponseDtoTranslationStatus;
  /** 계약 정보 */
  contractInfo: ContractInfoDto;
}

/**
 * 기업 소재지(시·도 시·군·구)
 */
export type AutoMatchOpeningDtoRegion = { [key: string]: unknown };

/**
 * 기업 로고 주소
 */
export type AutoMatchOpeningDtoLogoUrl = { [key: string]: unknown };

export type AutoMatchOpeningDtoFactsItem = {
  label?: string;
  value?: string;
};

export interface AutoMatchOpeningDto {
  /** 요청 유형 이름 */
  label: string;
  /** 매칭 근거 칩 */
  reasons: string[];
  /** 매칭된 기업 이름 */
  companyName: string;
  /** 기업 소재지(시·도 시·군·구) */
  region?: AutoMatchOpeningDtoRegion;
  /** 기업 로고 주소 */
  logoUrl?: AutoMatchOpeningDtoLogoUrl;
  /** 요청 내용 한 줄씩(보험 가입 의뢰: 종목·보험 기간·기존 계약·견적 마감 — 아는 값만, 2026-10-20) */
  facts?: AutoMatchOpeningDtoFactsItem[];
}

/**
 * 발신자 타입
 */
export type SystemMessageResponseDtoSenderType =
  (typeof SystemMessageResponseDtoSenderType)[keyof typeof SystemMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SystemMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type SystemMessageResponseDtoMessageType =
  (typeof SystemMessageResponseDtoMessageType)[keyof typeof SystemMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SystemMessageResponseDtoMessageType = {
  system: "system",
} as const;

/**
 * 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻.
 */
export type SystemMessageResponseDtoTranslationStatus =
  (typeof SystemMessageResponseDtoTranslationStatus)[keyof typeof SystemMessageResponseDtoTranslationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SystemMessageResponseDtoTranslationStatus = {
  PENDING: "PENDING",
  DONE: "DONE",
  SKIPPED: "SKIPPED",
  FAILED: "FAILED",
} as const;

export interface SystemMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: SystemMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: SystemMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 번역문 (트레이드 방에서만 채워진다). 원문은 message 그대로. */
  translatedMessage?: string;
  /** 번역문의 언어. ko | id */
  translatedLang?: string;
  /** 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻. */
  translationStatus?: SystemMessageResponseDtoTranslationStatus;
  /** 자동 매칭 방 첫 메시지 카드 재료 */
  autoMatch?: AutoMatchOpeningDto;
}

/**
 * 결제 상태
 */
export type PaymentPendingDataDtoStatus =
  (typeof PaymentPendingDataDtoStatus)[keyof typeof PaymentPendingDataDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentPendingDataDtoStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  EXPIRED: "EXPIRED",
} as const;

export interface PaymentPendingDataDto {
  /** 주문번호 (MOID) */
  moid: string;
  /** 결제 대기 금액 */
  amount: number;
  /** 입금 계좌번호 (가상계좌/무통장) */
  bankAccount: string;
  /** 생성 일시 */
  createdAt: string;
  /** 만료 일시 (입금 기한) */
  expiresAt: string;
  /** 거절 일시 */
  rejectedAt?: string;
  /** 거절 사유 */
  rejectionReason?: string;
  /** 결제 상태 */
  status?: PaymentPendingDataDtoStatus;
  /** 승인 일시 */
  approvedAt?: string;
}

/**
 * 발신자 타입
 */
export type PaymentPendingMessageResponseDtoSenderType =
  (typeof PaymentPendingMessageResponseDtoSenderType)[keyof typeof PaymentPendingMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentPendingMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type PaymentPendingMessageResponseDtoMessageType =
  (typeof PaymentPendingMessageResponseDtoMessageType)[keyof typeof PaymentPendingMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentPendingMessageResponseDtoMessageType = {
  payment_pending: "payment_pending",
} as const;

/**
 * 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻.
 */
export type PaymentPendingMessageResponseDtoTranslationStatus =
  (typeof PaymentPendingMessageResponseDtoTranslationStatus)[keyof typeof PaymentPendingMessageResponseDtoTranslationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentPendingMessageResponseDtoTranslationStatus = {
  PENDING: "PENDING",
  DONE: "DONE",
  SKIPPED: "SKIPPED",
  FAILED: "FAILED",
} as const;

export interface PaymentPendingMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: PaymentPendingMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: PaymentPendingMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 번역문 (트레이드 방에서만 채워진다). 원문은 message 그대로. */
  translatedMessage?: string;
  /** 번역문의 언어. ko | id */
  translatedLang?: string;
  /** 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻. */
  translationStatus?: PaymentPendingMessageResponseDtoTranslationStatus;
  /** 입금 대기 정보 */
  paymentPendingData: PaymentPendingDataDto;
}

/**
 * 취소 요청 주체 (buyer: 발주기관, supplier: 공급사). 승인/반려 버튼은 상대방에게만 노출해야 함. 레거시 메시지는 buyer로 응답됨.
 */
export type CancellationRequestDataDtoRequesterRole =
  (typeof CancellationRequestDataDtoRequesterRole)[keyof typeof CancellationRequestDataDtoRequesterRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancellationRequestDataDtoRequesterRole = {
  buyer: "buyer",
  supplier: "supplier",
} as const;

/**
 * 결제 수단
 */
export type CancellationRequestDataDtoPaymentMethod =
  (typeof CancellationRequestDataDtoPaymentMethod)[keyof typeof CancellationRequestDataDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancellationRequestDataDtoPaymentMethod = {
  CARD: "CARD",
  CASH: "CASH",
  DIRECT: "DIRECT",
} as const;

/**
 * 요청 상태
 */
export type CancellationRequestDataDtoStatus =
  (typeof CancellationRequestDataDtoStatus)[keyof typeof CancellationRequestDataDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancellationRequestDataDtoStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
} as const;

export interface CancellationRequestDataDto {
  /** 환불 ID */
  refundId: string;
  /** 계약 ID */
  contractId: string;
  /** 취소 사유 */
  requestReason: string;
  /** 취소 요청 주체 (buyer: 발주기관, supplier: 공급사). 승인/반려 버튼은 상대방에게만 노출해야 함. 레거시 메시지는 buyer로 응답됨. */
  requesterRole: CancellationRequestDataDtoRequesterRole;
  /** 반려 사유 */
  rejectionReason?: string;
  /** 거래 번호 (환불) */
  tid?: string;
  /** 결제 수단 */
  paymentMethod?: CancellationRequestDataDtoPaymentMethod;
  /** 취소 금액 */
  totalAmount?: number;
  /** 요청 상태 */
  status: CancellationRequestDataDtoStatus;
}

/**
 * 발신자 타입
 */
export type CancellationRequestMessageResponseDtoSenderType =
  (typeof CancellationRequestMessageResponseDtoSenderType)[keyof typeof CancellationRequestMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancellationRequestMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type CancellationRequestMessageResponseDtoMessageType =
  (typeof CancellationRequestMessageResponseDtoMessageType)[keyof typeof CancellationRequestMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancellationRequestMessageResponseDtoMessageType = {
  cancellation_request: "cancellation_request",
} as const;

/**
 * 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻.
 */
export type CancellationRequestMessageResponseDtoTranslationStatus =
  (typeof CancellationRequestMessageResponseDtoTranslationStatus)[keyof typeof CancellationRequestMessageResponseDtoTranslationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancellationRequestMessageResponseDtoTranslationStatus = {
  PENDING: "PENDING",
  DONE: "DONE",
  SKIPPED: "SKIPPED",
  FAILED: "FAILED",
} as const;

export interface CancellationRequestMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: CancellationRequestMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: CancellationRequestMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 번역문 (트레이드 방에서만 채워진다). 원문은 message 그대로. */
  translatedMessage?: string;
  /** 번역문의 언어. ko | id */
  translatedLang?: string;
  /** 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻. */
  translationStatus?: CancellationRequestMessageResponseDtoTranslationStatus;
  /** 계약 취소 요청 정보 */
  cancellationRequestData: CancellationRequestDataDto;
}

/**
 * 리뷰 상태
 */
export type ReviewSubmittedDataDtoStatus =
  (typeof ReviewSubmittedDataDtoStatus)[keyof typeof ReviewSubmittedDataDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewSubmittedDataDtoStatus = {
  submitted: "submitted",
} as const;

export interface ReviewSubmittedDataDto {
  /** 계약 ID */
  contractId: string;
  /** 리뷰 ID */
  reviewId: string;
  /** 리뷰 상태 */
  status: ReviewSubmittedDataDtoStatus;
}

/**
 * 발신자 타입
 */
export type ReviewSubmittedMessageResponseDtoSenderType =
  (typeof ReviewSubmittedMessageResponseDtoSenderType)[keyof typeof ReviewSubmittedMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewSubmittedMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type ReviewSubmittedMessageResponseDtoMessageType =
  (typeof ReviewSubmittedMessageResponseDtoMessageType)[keyof typeof ReviewSubmittedMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewSubmittedMessageResponseDtoMessageType = {
  review_submitted: "review_submitted",
} as const;

/**
 * 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻.
 */
export type ReviewSubmittedMessageResponseDtoTranslationStatus =
  (typeof ReviewSubmittedMessageResponseDtoTranslationStatus)[keyof typeof ReviewSubmittedMessageResponseDtoTranslationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewSubmittedMessageResponseDtoTranslationStatus = {
  PENDING: "PENDING",
  DONE: "DONE",
  SKIPPED: "SKIPPED",
  FAILED: "FAILED",
} as const;

export interface ReviewSubmittedMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: ReviewSubmittedMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: ReviewSubmittedMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 번역문 (트레이드 방에서만 채워진다). 원문은 message 그대로. */
  translatedMessage?: string;
  /** 번역문의 언어. ko | id */
  translatedLang?: string;
  /** 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻. */
  translationStatus?: ReviewSubmittedMessageResponseDtoTranslationStatus;
  /** 리뷰 작성 완료 정보 */
  reviewSubmittedData: ReviewSubmittedDataDto;
}

export interface ContractDocumentOptionDto {
  /** c-market 서류 코드 */
  paperCode: number;
  /** 서류 이름 */
  name: string;
  /** 운영자 기본값 여부 - 선택 화면에서 미리 체크 */
  isDefault: boolean;
  /** 시스템 자동 생성 가능 여부 (false: 공급사 직접 제출 대상) */
  autoGenerated: boolean;
}

/**
 * auto: 즉시 자동 생성. auto_pending_input: 자동 생성이지만 supplier 별도 입력값 필요. manual: 직접 제출
 */
export type ContractDocumentItemDtoKind =
  (typeof ContractDocumentItemDtoKind)[keyof typeof ContractDocumentItemDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractDocumentItemDtoKind = {
  auto: "auto",
  auto_pending_input: "auto_pending_input",
  manual: "manual",
} as const;

/**
 * 대기(pending) vs 완료(completed)
 */
export type ContractDocumentItemDtoStatus =
  (typeof ContractDocumentItemDtoStatus)[keyof typeof ContractDocumentItemDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractDocumentItemDtoStatus = {
  pending: "pending",
  completed: "completed",
} as const;

/**
 * 다운로드 가능한 파일 URL (완료 시 존재)
 */
export type ContractDocumentItemDtoFileUrl = { [key: string]: unknown };

/**
 * 원본 파일명 (완료 시 존재)
 */
export type ContractDocumentItemDtoFileName = { [key: string]: unknown };

/**
 * 파일 크기 (bytes)
 */
export type ContractDocumentItemDtoFileSize = { [key: string]: unknown };

/**
 * MIME 타입
 */
export type ContractDocumentItemDtoContentType = { [key: string]: unknown };

/**
 * 업로드 시각 (ISO 8601)
 */
export type ContractDocumentItemDtoUploadedAt = { [key: string]: unknown };

export interface ContractDocumentItemDto {
  /** contract_documents.id */
  id: string;
  /** c-market paperCode */
  paperCode: number;
  /** 서류 이름 */
  name: string;
  /** auto: 즉시 자동 생성. auto_pending_input: 자동 생성이지만 supplier 별도 입력값 필요. manual: 직접 제출 */
  kind: ContractDocumentItemDtoKind;
  /** 대기(pending) vs 완료(completed) */
  status: ContractDocumentItemDtoStatus;
  /** 다운로드 가능한 파일 URL (완료 시 존재) */
  fileUrl?: ContractDocumentItemDtoFileUrl;
  /** 원본 파일명 (완료 시 존재) */
  fileName?: ContractDocumentItemDtoFileName;
  /** 파일 크기 (bytes) */
  fileSize?: ContractDocumentItemDtoFileSize;
  /** MIME 타입 */
  contentType?: ContractDocumentItemDtoContentType;
  /** 업로드 시각 (ISO 8601) */
  uploadedAt?: ContractDocumentItemDtoUploadedAt;
}

export type ContractRestrictionConfirmSnapshotDtoAnswersItem =
  (typeof ContractRestrictionConfirmSnapshotDtoAnswersItem)[keyof typeof ContractRestrictionConfirmSnapshotDtoAnswersItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractRestrictionConfirmSnapshotDtoAnswersItem = {
  YES: "YES",
  NO: "NO",
} as const;

/**
 * 발주기관 최종 확인 응답. 전 문항 "NO" 는 null(확인 절차 없음). "예" 포함 상태에서 buyer 미확인이면 null, 확인 후 잠긴다.
 * @nullable
 */
export type ContractRestrictionConfirmSnapshotDtoBuyerConfirmation =
  | (typeof ContractRestrictionConfirmSnapshotDtoBuyerConfirmation)[keyof typeof ContractRestrictionConfirmSnapshotDtoBuyerConfirmation]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractRestrictionConfirmSnapshotDtoBuyerConfirmation = {
  YES: "YES",
  NO: "NO",
} as const;

/**
 * buyer 확인 제출 시각 (ISO 8601). 미제출이면 null.
 * @nullable
 */
export type ContractRestrictionConfirmSnapshotDtoConfirmedAt = {
  [key: string]: unknown;
} | null;

export interface ContractRestrictionConfirmSnapshotDto {
  /** 8개 문항 응답 원본 */
  answers: ContractRestrictionConfirmSnapshotDtoAnswersItem[];
  /** "예"로 응답한 문항 인덱스(0-based). 비어있으면 경고 없음. */
  flaggedIndexes: number[];
  /** supplier 제출 시각 (ISO 8601) */
  submittedAt: string;
  /**
   * 발주기관 최종 확인 응답. 전 문항 "NO" 는 null(확인 절차 없음). "예" 포함 상태에서 buyer 미확인이면 null, 확인 후 잠긴다.
   * @nullable
   */
  buyerConfirmation: ContractRestrictionConfirmSnapshotDtoBuyerConfirmation;
  /**
   * buyer 확인 제출 시각 (ISO 8601). 미제출이면 null.
   * @nullable
   */
  confirmedAt: ContractRestrictionConfirmSnapshotDtoConfirmedAt;
}

/**
 * c-market 거래유형 (quote_requests.category_type 매핑)
 */
export type DocumentRequestDataDtoBidType =
  (typeof DocumentRequestDataDtoBidType)[keyof typeof DocumentRequestDataDtoBidType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentRequestDataDtoBidType = {
  goods: "goods",
  service: "service",
  construction: "construction",
  sale: "sale",
} as const;

/**
 * 요청 상태
 */
export type DocumentRequestDataDtoStatus =
  (typeof DocumentRequestDataDtoStatus)[keyof typeof DocumentRequestDataDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentRequestDataDtoStatus = {
  pending: "pending",
  requested: "requested",
} as const;

/**
 * 견적요청의 결제 방법 스냅샷 (2026-07-31). 2026-08-04 부터 신규는 전량 postpaid 라 카드 렌더 판단에는 쓰지 않는다(표시·디버깅용). 결제 CTA 는 paymentChannel 이 정한다.
 */
export type DocumentRequestDataDtoPaymentMethod =
  (typeof DocumentRequestDataDtoPaymentMethod)[keyof typeof DocumentRequestDataDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentRequestDataDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 계약 시 고른 결제 수단 (contracts.payment_channel 실시간 조회). cash → [계산서 발행요청], card → [카드결제하기]. null 이면 카드가 결제 CTA 를 그리지 않는다 — 컬럼 신설(2026-08-04) 이전 레거시 계약이 여기 해당한다.
 * @nullable
 */
export type DocumentRequestDataDtoPaymentChannel =
  | (typeof DocumentRequestDataDtoPaymentChannel)[keyof typeof DocumentRequestDataDtoPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentRequestDataDtoPaymentChannel = {
  cash: "cash",
  card: "card",
} as const;

/**
 * 씨마켓 계산서 진행 상태 (contracts.tax_invoice_status 실시간 조회). REQUESTED=발행요청됨, ISSUED=발행완료. 현금 계약에서 isPaid 와 같은 자리를 맡는다.
 * @nullable
 */
export type DocumentRequestDataDtoTaxInvoiceStatus =
  | (typeof DocumentRequestDataDtoTaxInvoiceStatus)[keyof typeof DocumentRequestDataDtoTaxInvoiceStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentRequestDataDtoTaxInvoiceStatus = {
  REQUESTED: "REQUESTED",
  ISSUED: "ISSUED",
  CANCELLED: "CANCELLED",
} as const;

export interface DocumentRequestDataDto {
  /** 계약 ID */
  contractId: string;
  /** c-market 거래유형 (quote_requests.category_type 매핑) */
  bidType: DocumentRequestDataDtoBidType;
  /** 선택 가능한 계약서류 목록 (pending 카드 렌더용 스냅샷) */
  documents: ContractDocumentOptionDto[];
  /** 요청 상태 */
  status: DocumentRequestDataDtoStatus;
  /** 발급 완료된 c-market 계약서류 코드 */
  issuedPaperCodes: number[];
  /** [계약 서류 관리] 카드 항목 목록. status="requested" 로 전환된 이후에만 채워진다. */
  contractDocuments?: ContractDocumentItemDto[];
  /** 견적요청의 결제 방법 스냅샷 (2026-07-31). 2026-08-04 부터 신규는 전량 postpaid 라 카드 렌더 판단에는 쓰지 않는다(표시·디버깅용). 결제 CTA 는 paymentChannel 이 정한다. */
  paymentMethod?: DocumentRequestDataDtoPaymentMethod;
  /**
   * 계약 시 고른 결제 수단 (contracts.payment_channel 실시간 조회). cash → [계산서 발행요청], card → [카드결제하기]. null 이면 카드가 결제 CTA 를 그리지 않는다 — 컬럼 신설(2026-08-04) 이전 레거시 계약이 여기 해당한다.
   * @nullable
   */
  paymentChannel?: DocumentRequestDataDtoPaymentChannel;
  /** 결제 완료 여부 (contracts.paid_at 유무). CONTRACT 메시지 카드와 같은 판정을 쓴다. */
  isPaid?: boolean;
  /**
   * 씨마켓 계산서 진행 상태 (contracts.tax_invoice_status 실시간 조회). REQUESTED=발행요청됨, ISSUED=발행완료. 현금 계약에서 isPaid 와 같은 자리를 맡는다.
   * @nullable
   */
  taxInvoiceStatus?: DocumentRequestDataDtoTaxInvoiceStatus;
  /** paperCode 135(수의계약체결제한여부확인서) 제출 스냅샷 (2026-08-02). 미제출이면 undefined. */
  restrictionConfirm?: ContractRestrictionConfirmSnapshotDto;
}

/**
 * 발신자 타입
 */
export type DocumentRequestMessageResponseDtoSenderType =
  (typeof DocumentRequestMessageResponseDtoSenderType)[keyof typeof DocumentRequestMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentRequestMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type DocumentRequestMessageResponseDtoMessageType =
  (typeof DocumentRequestMessageResponseDtoMessageType)[keyof typeof DocumentRequestMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentRequestMessageResponseDtoMessageType = {
  document_request: "document_request",
} as const;

/**
 * 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻.
 */
export type DocumentRequestMessageResponseDtoTranslationStatus =
  (typeof DocumentRequestMessageResponseDtoTranslationStatus)[keyof typeof DocumentRequestMessageResponseDtoTranslationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentRequestMessageResponseDtoTranslationStatus = {
  PENDING: "PENDING",
  DONE: "DONE",
  SKIPPED: "SKIPPED",
  FAILED: "FAILED",
} as const;

export interface DocumentRequestMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: DocumentRequestMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: DocumentRequestMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 번역문 (트레이드 방에서만 채워진다). 원문은 message 그대로. */
  translatedMessage?: string;
  /** 번역문의 언어. ko | id */
  translatedLang?: string;
  /** 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻. */
  translationStatus?: DocumentRequestMessageResponseDtoTranslationStatus;
  /** 계약서류 선택 요청 정보 */
  documentRequestData: DocumentRequestDataDto;
}

/**
 * 발주기관 최종 확인 응답. 미제출이면 null.
 * @nullable
 */
export type ContractRestrictionConfirmDataDtoBuyerConfirmation =
  | (typeof ContractRestrictionConfirmDataDtoBuyerConfirmation)[keyof typeof ContractRestrictionConfirmDataDtoBuyerConfirmation]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractRestrictionConfirmDataDtoBuyerConfirmation = {
  YES: "YES",
  NO: "NO",
} as const;

/**
 * buyer 확인 제출 시각 (ISO 8601). 미제출이면 null.
 * @nullable
 */
export type ContractRestrictionConfirmDataDtoConfirmedAt = {
  [key: string]: unknown;
} | null;

export interface ContractRestrictionConfirmDataDto {
  /** 계약 ID */
  contractId: string;
  /** 짝이 되는 [계약 서류 관리] 카드 메시지 ID */
  documentRequestMessageId: string;
  /** 8개 문항 응답 원본 */
  answers: string[];
  /** "예"로 응답한 문항 인덱스(0..7) */
  flaggedIndexes: number[];
  /** 공급사 제출 시각 (ISO 8601) */
  submittedAt: string;
  /**
   * 발주기관 최종 확인 응답. 미제출이면 null.
   * @nullable
   */
  buyerConfirmation: ContractRestrictionConfirmDataDtoBuyerConfirmation;
  /**
   * buyer 확인 제출 시각 (ISO 8601). 미제출이면 null.
   * @nullable
   */
  confirmedAt: ContractRestrictionConfirmDataDtoConfirmedAt;
}

/**
 * 발신자 타입
 */
export type ContractRestrictionConfirmMessageResponseDtoSenderType =
  (typeof ContractRestrictionConfirmMessageResponseDtoSenderType)[keyof typeof ContractRestrictionConfirmMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractRestrictionConfirmMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type ContractRestrictionConfirmMessageResponseDtoMessageType =
  (typeof ContractRestrictionConfirmMessageResponseDtoMessageType)[keyof typeof ContractRestrictionConfirmMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractRestrictionConfirmMessageResponseDtoMessageType = {
  contract_restriction_confirm: "contract_restriction_confirm",
} as const;

/**
 * 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻.
 */
export type ContractRestrictionConfirmMessageResponseDtoTranslationStatus =
  (typeof ContractRestrictionConfirmMessageResponseDtoTranslationStatus)[keyof typeof ContractRestrictionConfirmMessageResponseDtoTranslationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractRestrictionConfirmMessageResponseDtoTranslationStatus = {
  PENDING: "PENDING",
  DONE: "DONE",
  SKIPPED: "SKIPPED",
  FAILED: "FAILED",
} as const;

export interface ContractRestrictionConfirmMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: ContractRestrictionConfirmMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: ContractRestrictionConfirmMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 번역문 (트레이드 방에서만 채워진다). 원문은 message 그대로. */
  translatedMessage?: string;
  /** 번역문의 언어. ko | id */
  translatedLang?: string;
  /** 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻. */
  translationStatus?: ContractRestrictionConfirmMessageResponseDtoTranslationStatus;
  /** 수의계약 체결 제한 확인 요청 정보 */
  contractRestrictionConfirmData: ContractRestrictionConfirmDataDto;
}

export type ChatMessagesResponseDtoItemsItem =
  | TextMessageResponseDto
  | AttachmentMessageResponseDto
  | QuoteMessageResponseDto
  | ContractMessageResponseDto
  | SystemMessageResponseDto
  | PaymentPendingMessageResponseDto
  | CancellationRequestMessageResponseDto
  | ReviewSubmittedMessageResponseDto
  | DocumentRequestMessageResponseDto
  | ContractRestrictionConfirmMessageResponseDto;

export interface ChatMessagesResponseDto {
  /** 채팅 메시지 목록 */
  items: ChatMessagesResponseDtoItemsItem[];
  /**
   * 다음 커서
   * @nullable
   */
  nextCursor: string | null;
  /** 추가 데이터 여부 */
  hasMore: boolean;
}

/**
 * 발신자 타입
 */
export type BaseChatMessageResponseDtoSenderType =
  (typeof BaseChatMessageResponseDtoSenderType)[keyof typeof BaseChatMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseChatMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입 (Discriminator)
 */
export type BaseChatMessageResponseDtoMessageType =
  (typeof BaseChatMessageResponseDtoMessageType)[keyof typeof BaseChatMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseChatMessageResponseDtoMessageType = {
  text: "text",
  attachment: "attachment",
  quote: "quote",
  contract: "contract",
  system: "system",
  payment_pending: "payment_pending",
  cancellation_request: "cancellation_request",
  review_submitted: "review_submitted",
  document_request: "document_request",
  contract_restriction_confirm: "contract_restriction_confirm",
} as const;

/**
 * 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻.
 */
export type BaseChatMessageResponseDtoTranslationStatus =
  (typeof BaseChatMessageResponseDtoTranslationStatus)[keyof typeof BaseChatMessageResponseDtoTranslationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseChatMessageResponseDtoTranslationStatus = {
  PENDING: "PENDING",
  DONE: "DONE",
  SKIPPED: "SKIPPED",
  FAILED: "FAILED",
} as const;

export interface BaseChatMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: BaseChatMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 (Discriminator) */
  messageType: BaseChatMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 번역문 (트레이드 방에서만 채워진다). 원문은 message 그대로. */
  translatedMessage?: string;
  /** 번역문의 언어. ko | id */
  translatedLang?: string;
  /** 번역 상태: PENDING(대기) | DONE(완료) | SKIPPED(같은 말이라 건너뜀) | FAILED(실패). 없으면 번역 대상이 아니었다는 뜻. */
  translationStatus?: BaseChatMessageResponseDtoTranslationStatus;
}

export interface CreateMessageDto {
  /**
   * 메시지 내용 (필수)
   * @maxLength 1000
   */
  content: string;
  /** 답글 대상 메시지 ID */
  replyToId?: string;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
}

export interface GeneratedContractDocumentDto {
  paperCode: number;
  name: string;
  fileUrl: string;
}

export interface RequestContractDocumentsDto {
  /** 계약서류 선택 요청 메시지 ID */
  messageId: string;
  /** 발급할 c-market 계약서류 코드 */
  paperCodes: number[];
  /** c-market 멱등성 키. 같은 사용자 동작의 재시도에는 같은 값을 사용 */
  idempotencyKey: string;
}

export type ContractRestrictionConfirmDtoAnswersItem =
  (typeof ContractRestrictionConfirmDtoAnswersItem)[keyof typeof ContractRestrictionConfirmDtoAnswersItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractRestrictionConfirmDtoAnswersItem = {
  YES: "YES",
  NO: "NO",
} as const;

export interface ContractRestrictionConfirmDto {
  /** 8개 문항 응답 ("YES" | "NO"). "YES" 포함 시 발주기관 확인 절차로 진입. */
  answers: ContractRestrictionConfirmDtoAnswersItem[];
}

/**
 * 입사일 (YYYY-MM-DD)
 * @nullable
 */
export type RetireeRosterRowDtoJoinDate = { [key: string]: unknown } | null;

/**
 * 간부·보직자 직급 (예: 3급)
 * @nullable
 */
export type RetireeRosterRowDtoRetireType = { [key: string]: unknown } | null;

/**
 * 근무기간 (개월 단위 숫자 문자열)
 * @nullable
 */
export type RetireeRosterRowDtoServicePeriod = {
  [key: string]: unknown;
} | null;

/**
 * 비고
 * @nullable
 */
export type RetireeRosterRowDtoEtc = { [key: string]: unknown } | null;

export interface RetireeRosterRowDto {
  name: string;
  position: string;
  /**
   * 입사일 (YYYY-MM-DD)
   * @nullable
   */
  joinDate?: RetireeRosterRowDtoJoinDate;
  /**
   * 간부·보직자 직급 (예: 3급)
   * @nullable
   */
  retireType?: RetireeRosterRowDtoRetireType;
  /**
   * 근무기간 (개월 단위 숫자 문자열)
   * @nullable
   */
  servicePeriod?: RetireeRosterRowDtoServicePeriod;
  /**
   * 비고
   * @nullable
   */
  etc?: RetireeRosterRowDtoEtc;
}

export interface RetireeRosterDto {
  rows: RetireeRosterRowDto[];
}

export interface SubmitContractDocumentInputDto {
  /** c-market 멱등성 키 */
  idempotencyKey: string;
  /** paperCode=135 (수의계약체결제한여부확인서) 응답 */
  contractRestrictionConfirm?: ContractRestrictionConfirmDto;
  /** paperCode=164/188/195/222 응답. 해당없음은 rows=[] 로 전달 (c-market spec) */
  retireeRoster?: RetireeRosterDto;
}

/**
 * 발주기관 최종 확인 응답
 */
export type SubmitContractDocumentBuyerConfirmationDtoBuyerConfirmation =
  (typeof SubmitContractDocumentBuyerConfirmationDtoBuyerConfirmation)[keyof typeof SubmitContractDocumentBuyerConfirmationDtoBuyerConfirmation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubmitContractDocumentBuyerConfirmationDtoBuyerConfirmation = {
  YES: "YES",
  NO: "NO",
} as const;

export interface SubmitContractDocumentBuyerConfirmationDto {
  /** c-market 멱등성 키 */
  idempotencyKey: string;
  /** 발주기관 최종 확인 응답 */
  buyerConfirmation: SubmitContractDocumentBuyerConfirmationDtoBuyerConfirmation;
}

export interface MarkRoomAsReadDto {
  /** 마지막으로 읽은 메시지 ID (Watermark) */
  lastReadMessageId: string;
}

/**
 * 재고 배지(자동견적, 설계도 01 Phase C). IN_STOCK=즉시납품 가능, SHORT=부분 보유. 없으면 키 없음. 수량은 싣지 않는다.
 */
export type QuoteResponseItemDtoStockState =
  (typeof QuoteResponseItemDtoStockState)[keyof typeof QuoteResponseItemDtoStockState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteResponseItemDtoStockState = {
  IN_STOCK: "IN_STOCK",
  SHORT: "SHORT",
} as const;

/** 연결 견적(자동 구매 흐름 «연결 건») 줄의 시약 칸 */
export interface QuoteReagentLineDto {
  /** 요청 줄 번호(1부터) */
  lineNo: number;
  /** CAS 번호 */
  cas: string;
  /** 제조사 */
  manufacturer: string;
  /** 품번 */
  catalogNo: string;
  /** 농도·순도 */
  concentration: string;
  /** 등급 */
  grade: string;
  /** 포장 용량 */
  packSize: number;
  /** 포장 단위(mL·L·g·kg) */
  packUnit: string;
  /** 남은 유통기한(개월) */
  remainingShelfLifeMonths: number;
  /** 배송 방법 — DIRECT 직배송 · HAZMAT_CARRIER 위험물 운송 · PARCEL 택배 */
  deliveryMethod: string;
}

export interface QuoteResponseItemDto {
  /** 품목명 */
  name: string;
  /**
   * 단가 (원 단위, 부가세 포함)
   * @minimum 1
   * @maximum 10000000000000
   */
  unitPrice: number;
  /**
   * 수량
   * @minimum 1
   * @maximum 1000000000
   */
  quantity: number;
  /** 단위 (예: 세트, EA, 박스) */
  unit: string;
  /**
   * 품목별 총액 (quantity × unitPrice)
   * @minimum 0
   * @maximum 10000000000000
   */
  amount: number;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 품목 코드 */
  itemCode?: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 카탈로그 단가 업데이트 여부 (기존 단가가 있을 때만 참조됨) */
  updateCatalog?: number;
  /** 표준 아이템 ID (items_v2_base.id) */
  itemId?: string;
  /** 재고 배지(자동견적, 설계도 01 Phase C). IN_STOCK=즉시납품 가능, SHORT=부분 보유. 없으면 키 없음. 수량은 싣지 않는다. */
  stockState?: QuoteResponseItemDtoStockState;
  /**
   * SHORT 일 때 나머지 납기(일). 있을 때만.
   * @minimum 0
   * @maximum 365
   */
  leadTimeDays?: number;
  /** 연결 견적(자동 구매 흐름) 줄의 시약 칸 — 연결 건에서만 저장한다. 일반 견적이면 보내지 않는다. */
  reagent?: QuoteReagentLineDto;
}

export interface AttachmentMetadataDto {
  /** 파일명 */
  fileName: string;
  /** 파일 공개 URL */
  url: string;
  /** 스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다. */
  filePath?: string;
  /** 파일 크기 (바이트) */
  fileSize: number;
  /** MIME 타입 */
  contentType?: string;
}

/**
 * 단가 입력 축 — EXCLUSIVE(공급가액 단가, 기본) | INCLUSIVE(부가세 포함 단가). INCLUSIVE 면 품목 합계가 총액이고 공급가액은 총액에서 역산한 값이다.
 */
export type CreateQuoteResponseVersionDtoTaxType =
  (typeof CreateQuoteResponseVersionDtoTaxType)[keyof typeof CreateQuoteResponseVersionDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuoteResponseVersionDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface CreateQuoteResponseVersionDto {
  /** 견적 응답 ID (내부용 - PDF 파일명 생성) */
  id?: string;
  /** 버전 번호 (내부용 - PDF 파일명 생성) */
  versionNumber?: number;
  /**
   * 견적 총액 (원, 부가세 10% 포함)
   * @minimum 0
   * @maximum 100000000000000
   */
  totalAmount: number;
  /**
   * 부가가치세(VAT) 금액 (선택사항)
   * @minimum 0
   * @maximum 10000000000000
   */
  taxAmount?: number;
  /** 단가 입력 축 — EXCLUSIVE(공급가액 단가, 기본) | INCLUSIVE(부가세 포함 단가). INCLUSIVE 면 품목 합계가 총액이고 공급가액은 총액에서 역산한 값이다. */
  taxType?: CreateQuoteResponseVersionDtoTaxType;
  /**
   * 납기 — 발주 후 N일 (0~365). 미기재면 null. 버전 단위 값이다.
   * @minimum 0
   * @maximum 365
   */
  deliveryDays?: number;
  /** 견적 유효기간 (YYYY-MM-DD, 오늘 이후). 미기재면 null — PDF 는 종전대로 발행일+30일을 찍는다. */
  validUntil?: string;
  /**
   * 견적 품목 상세 목록 (물품 카테고리일 때 필수, 업체용 - 단가 필수) - 각 품목은 반드시 unit(단위), unitPrice(단가), amount(금액)를 포함해야 합니다. amount = quantity × unitPrice. 총액은 모든 품목의 금액 합계에 10% VAT를 포함한 금액입니다. 제조·용역, 공사, 중고 판매 카테고리에서는 선택사항입니다.
   * @nullable
   */
  items?: QuoteResponseItemDto[] | null;
  /**
   * 버전 생성 사유 (선택사항) - 예: "initial_submission", "buyer_requested_update", "협상 후 금액 조정"
   * @maxLength 500
   */
  description?: string;
  /** 첨부파일 목록 (선택사항, 최대 10개) */
  attachments?: AttachmentMetadataDto[];
  /** 연결 견적(자동 구매 흐름) 전용 — 판매자 고지(화관법 제29조의2) «고지함». 연결 건에서만 읽는다. */
  sellerNoticeAcknowledged?: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
}

/**
 * 처리 상태
 */
export type QuoteResponseFlowResultDtoStatus =
  (typeof QuoteResponseFlowResultDtoStatus)[keyof typeof QuoteResponseFlowResultDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteResponseFlowResultDtoStatus = {
  submitted: "submitted",
  processing: "processing",
} as const;

export interface QuoteResponseFlowResultDto {
  /** 생성된 견적 응답 ID */
  quoteResponseId: string;
  /** 버전 번호 (첫 응답은 항상 1) */
  versionNumber: number;
  /** 채팅방 ID */
  chatRoomId: string;
  /** 처리 상태 */
  status: QuoteResponseFlowResultDtoStatus;
  /** 생성 시간 (ISO 8601) */
  createdAt: string;
}

export interface RecipientInfoDto {
  /** 담당자 이름 */
  name?: string;
  /** 담당자 연락처 */
  phone?: string;
}

/**
 * 재고 배지: IN_STOCK=즉시납품 가능, SHORT=부분 보유. 없으면 키 없음
 */
export type QuoteItemDtoStockState =
  (typeof QuoteItemDtoStockState)[keyof typeof QuoteItemDtoStockState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteItemDtoStockState = {
  IN_STOCK: "IN_STOCK",
  SHORT: "SHORT",
} as const;

export interface QuoteItemDto {
  /**
   * 품목명 (필수)
   * @maxLength 255
   */
  name: string;
  /**
   * 단가 (부가세 포함, 원 단위)
   * @minimum 0
   */
  unitPrice: number;
  /**
   * 단위 (예: EA, 박스, 세트)
   * @maxLength 10
   */
  unit: string;
  /**
   * 규격 1 (예: A4, 500ml)
   * @maxLength 255
   */
  spec1?: string;
  /**
   * 규격 2 - 재질/타입 (예: 80g, 스테인리스)
   * @maxLength 255
   */
  spec2?: string;
  /**
   * 규격 3 - 패키징 (예: 2500매/박스)
   * @maxLength 255
   */
  spec3?: string;
  /**
   * 수량 (견적응답 전용 - items 테이블에는 없음)
   * @minimum 1
   */
  quantity: number;
  /**
   * 품목별 총액 (단가 x 수량, 견적응답 전용)
   * @minimum 0
   */
  amount: number;
  /**
   * 상품코드 (items 테이블 선택사항)
   * @maxLength 100
   */
  itemCode?: string;
  /**
   * 제조사 (items 테이블 선택사항)
   * @maxLength 100
   */
  manufacturer?: string;
  /**
   * 브랜드 (items 테이블 선택사항)
   * @maxLength 100
   */
  brand?: string;
  /** 시스템 아이템 ID (자동 견적 매칭용) */
  itemId?: string;
  /** 재고 배지: IN_STOCK=즉시납품 가능, SHORT=부분 보유. 없으면 키 없음 */
  stockState?: QuoteItemDtoStockState;
  /** SHORT 일 때 나머지 납기(일) */
  leadTimeDays?: number;
}

export interface QuoteAttachmentDto {
  /** 첨부파일 ID (UUID) */
  id?: string;
  /**
   * 파일 이름
   * @maxLength 255
   */
  fileName: string;
  /** 파일 경로 */
  filePath?: string;
  /** 파일 접근 URL */
  url?: string;
  /**
   * 파일 크기 (bytes)
   * @maximum 10485760
   */
  fileSize?: number;
  /** MIME 타입 */
  mimeType?: string;
}

/**
 * 견적 응답 상태
 */
export type QuoteResponseResponseDtoStatus =
  (typeof QuoteResponseResponseDtoStatus)[keyof typeof QuoteResponseResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteResponseResponseDtoStatus = {
  pending: "pending",
  submitted: "submitted",
  withdrawn: "withdrawn",
  expired: "expired",
} as const;

export interface QuoteResponseResponseDto {
  /** 견적 응답 ID (UUID) */
  id: string;
  /** 견적 요청 ID */
  quoteRequestId: string;
  /** 공급자 정보 */
  supplier: SupplierDto;
  /** 공급자 ID */
  supplierId: string;
  /** 수신자 정보 */
  recipientInfo?: RecipientInfoDto;
  /** 견적번호 */
  quoteNumber?: string;
  /** 발행일 (ISO 8601) */
  issueDate?: string;
  /** 견적 설명/비고 */
  description?: string;
  /**
   * 견적 총액 (원, 부가세 제외)
   * @minimum 0
   */
  totalAmount: number;
  /**
   * 공급 금액 (원)
   * @minimum 0
   */
  supplyAmount?: number;
  /**
   * 부가가치세(VAT) 금액 (원)
   * @minimum 0
   */
  vatAmount?: number;
  /** 세금 유형 (VAT, TAX, NONE) */
  taxType?: string;
  /** 견적 품목 상세 목록 */
  items: QuoteItemDto[];
  /** 첨부파일 목록 */
  attachments?: QuoteAttachmentDto[];
  /** 유효기간 (타임스탬프) */
  validUntil?: number;
  /**
   * 배송기간 (일)
   * @minimum 0
   */
  deliveryDays?: number;
  /**
   * 견적 응답 버전 번호
   * @minimum 1
   */
  versionNumber?: number;
  /**
   * PDF 파일 URL
   * @nullable
   */
  pdfUrl?: string | null;
  /** 견적 응답 상태 */
  status: QuoteResponseResponseDtoStatus;
  /** 채팅방 ID (vendor와의 협상 채팅) */
  chatRoomId?: string;
  /** 생성 일시 (ISO 8601) */
  createdAt?: string;
  /** 수정 일시 (ISO 8601) */
  updatedAt?: string;
  /** 익명 여부 (블러 처리 필요) */
  isAnonymous: boolean;
  /** 계약 여부 */
  isContracted: boolean;
}

export interface PdfUrlResponseDto {
  /** 생성된 PDF의 Public URL */
  pdfUrl: string;
}

export interface PdfGenerationResponseDto {
  /** PDF 파일 공개 URL (Supabase Storage에서 접근 가능) */
  pdfUrl: string;
  /** PDF 파일명 */
  fileName: string;
  /**
   * PDF 파일 크기 (바이트 단위)
   * @minimum 0
   */
  fileSize: number;
  /** PDF 파일 해시 (SHA-256, 파일 검증용) */
  fileHash: string;
}

export interface QuotePdfItemDto {
  /** 품명 (Product name) */
  name: string;
  /** 규격 (Specification) */
  spec?: string;
  /**
   * 수량 (Quantity)
   * @minimum 1
   */
  quantity: number;
  /** 단위 (Unit) */
  unit: string;
  /**
   * 단가 (Unit price)
   * @minimum 0
   */
  unitPrice: number;
  /**
   * 금액 (Total price)
   * @minimum 0
   */
  totalPrice: number;
}

export interface QuotePdfAttachmentDto {
  /** 파일명 (File name) */
  fileName: string;
  /** 파일 URL (File URL) */
  fileUrl: string;
}

/**
 * 카테고리 (제품/서비스)
 */
export type CreateQuotePdfDtoCategoryType =
  (typeof CreateQuotePdfDtoCategoryType)[keyof typeof CreateQuotePdfDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuotePdfDtoCategoryType = {
  product: "product",
  service: "service",
} as const;

export interface CreateQuotePdfDto {
  /** 공급자 회사명 */
  supplierName: string;
  /** 공급자 대표자명 */
  supplierCeoName: string;
  /** 사업자등록번호 */
  supplierRegistrationNumber: string;
  /** 공급자 주소 */
  supplierAddress: string;
  /** 공급자 전화번호 */
  supplierPhone: string;
  /** 공급자 이메일 */
  supplierEmail: string;
  /** 회사 직인 URL (선택) */
  companySealUrl?: string;
  /** 구매자명 (또는 회사명) */
  buyerName: string;
  /** 공고번호 (선택) */
  announcementNumber?: string;
  /** 견적 항목 목록 */
  items: QuotePdfItemDto[];
  /**
   * 공급가액 (부가세 제외)
   * @minimum 0
   */
  subtotal: number;
  /**
   * 부가세 (10%)
   * @minimum 0
   */
  tax: number;
  /**
   * 총 금액 (공급가액 + 부가세)
   * @minimum 0
   */
  totalAmount: number;
  /** 카테고리 (제품/서비스) */
  categoryType: CreateQuotePdfDtoCategoryType;
  /** 설명 (선택) */
  description?: string;
  /** 첨부파일 목록 (선택) */
  attachments?: QuotePdfAttachmentDto[];
}

/**
 * 카테고리 (제품/서비스)
 */
export type CreateContractPdfDtoCategoryType =
  (typeof CreateContractPdfDtoCategoryType)[keyof typeof CreateContractPdfDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateContractPdfDtoCategoryType = {
  product: "product",
  service: "service",
} as const;

export interface CreateContractPdfDto {
  /** 공급자 회사명 */
  supplierName: string;
  /** 공급자 대표자명 */
  supplierCeoName: string;
  /** 사업자등록번호 */
  supplierRegistrationNumber: string;
  /** 공급자 주소 */
  supplierAddress: string;
  /** 공급자 전화번호 */
  supplierPhone: string;
  /** 공급자 이메일 */
  supplierEmail: string;
  /** 회사 직인 URL (선택) */
  companySealUrl?: string;
  /** 구매자명 (또는 회사명) */
  buyerName: string;
  /** 공고번호 (선택) */
  announcementNumber?: string;
  /** 견적 항목 목록 */
  items: QuotePdfItemDto[];
  /**
   * 공급가액 (부가세 제외)
   * @minimum 0
   */
  subtotal: number;
  /**
   * 부가세 (10%)
   * @minimum 0
   */
  tax: number;
  /**
   * 총 금액 (공급가액 + 부가세)
   * @minimum 0
   */
  totalAmount: number;
  /** 카테고리 (제품/서비스) */
  categoryType: CreateContractPdfDtoCategoryType;
  /** 설명 (선택) */
  description?: string;
  /** 첨부파일 목록 (선택) */
  attachments?: QuotePdfAttachmentDto[];
  /** 계약번호 */
  contractNumber: string;
  /** 계약일자 (ISO8601) */
  contractDate: string;
  /** 결제 트랜잭션 ID */
  paymentTransactionId: string;
  /** 결제 승인일시 (ISO8601) */
  paymentApprovedAt: string;
}

export interface SystemConfigResponseDto {
  /** PRO 플랜 1개월 무료 체험 활성화 여부 */
  proTrialEnabled: boolean;
  /** 무료 체험 일수 */
  proTrialDays: number;
}

export interface AddressResponseDto {
  /** 주소 ID (UUID) */
  id: string;
  /** 사용자 ID (UUID) */
  userId: string;
  /** 주소 라벨 (회사, 집, 창고 등) */
  label?: string;
  /** 기본 배송지 여부 */
  isDefault: boolean;
  /** 우편번호 (5자리 숫자) */
  postalCode: string;
  /** 시/도 (광역시 또는 도 단위) */
  province: string;
  /** 시/군/구 (기초자치단체) */
  city: string;
  /** 읍/면/동 (선택사항) */
  district?: string;
  /** 도로명 주소 */
  streetAddress: string;
  /** 상세 주소 (건물명, 동/호 등) */
  addressDetail?: string;
  /** 수령인 이름 */
  recipientName?: string;
  /** 수령인 연락처 (휴대폰 또는 일반전화) */
  recipientPhone?: string;
  /** 생성일 (ISO 8601 형식) */
  createdAt?: string;
  /** 수정일 (ISO 8601 형식) */
  updatedAt?: string;
}

/**
 * 사용자 타입 (buyer: 구매자, supplier: 공급자, admin: 관리자)
 */
export type UserInfoDtoUserType =
  (typeof UserInfoDtoUserType)[keyof typeof UserInfoDtoUserType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserInfoDtoUserType = {
  buyer: "buyer",
  supplier: "supplier",
  admin: "admin",
} as const;

/**
 * 기본 배송지 정보
 * @nullable
 */
export type UserInfoDtoDefaultAddress = AddressResponseDto | null;

export interface UserInfoDto {
  /** 내부 사용자 ID (UUID) */
  id: string;
  /** 사용자가 입력한 ID (username) */
  userId?: string;
  /** Supabase Auth ID */
  authId?: string;
  /** 사용자 연락처 이메일 */
  contactEmail: string;
  /** 사용자 성명 */
  name?: string;
  /** 사용자 전화번호 */
  phone?: string;
  /**
   * 프로필 이미지 URL
   * @nullable
   */
  profileImageUrl?: string | null;
  /** 이메일 인증 여부 */
  emailVerified?: boolean;
  /**
   * NICE 본인인증 완료 날짜 (ISO 8601 형식)
   * @nullable
   */
  niceVerifiedAt?: string | null;
  /** 사용자 타입 (buyer: 구매자, supplier: 공급자, admin: 관리자) */
  userType?: UserInfoDtoUserType;
  /** 마스터 관리자 여부 (관리자 계정일 때만 제공) */
  isMaster?: boolean;
  /** 사용자 생성 날짜 (ISO 8601 형식) */
  createdAt?: string;
  /**
   * 기본 배송지 정보
   * @nullable
   */
  defaultAddress?: UserInfoDtoDefaultAddress;
}

export interface LoginResponseDto {
  user: UserInfoDto;
  /** Access Token */
  accessToken: string;
  /** Refresh Token */
  refreshToken: string;
  /** Access Token 만료 시간 (초) */
  expiresIn: number;
  /** 토큰 타입 */
  tokenType: string;
  message: string;
}

export interface LoginDto {
  /**
   * 사용자 ID 또는 이메일
   * @minLength 3
   */
  userId: string;
  /**
   * 사용자 비밀번호
   * @minLength 6
   */
  password: string;
  /** 로그인 상태 유지 여부 */
  rememberMe?: boolean;
}

export interface SignupResponseDto {
  user: UserInfoDto;
  /** Access Token */
  accessToken: string;
  /** Refresh Token */
  refreshToken: string;
  /** Expires In (seconds) */
  expiresIn: number;
  /** Token Type */
  tokenType: string;
  message: string;
}

/**
 * 성별 - NICE 인증에서 확인된 성별
 */
export type Gender = (typeof Gender)[keyof typeof Gender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Gender = {
  M: "M",
  F: "F",
  O: "O",
} as const;

export interface NiceDataDto {
  /** NICE CI 해시값 - 중복가입 방지용 고유 식별자 */
  ciHash: string;
  /** NICE DI 해시값 - 서비스별 중복가입 확인용 식별자 */
  diHash: string;
  /**
   * 실명 - NICE 본인인증에서 확인된 이름
   * @maxLength 50
   */
  name: string;
  /**
   * 생년월일 - NICE 인증에서 확인된 8자리 생년월일 (YYYYMMDD)
   * @pattern ^[0-9]{8}$
   */
  birthDate: string;
  /** 성별 - NICE 인증에서 확인된 성별 */
  gender: Gender;
  /**
   * 휴대폰 번호 - NICE 인증에서 확인된 휴대폰 번호 (하이픈 있거나 없음)
   * @pattern ^0(?:[1][0-9]|[2-9]\d?)-?\d{3,4}-?\d{4}$
   */
  phone: string;
}

/**
 * 약관 타입 - terms: 이용약관(필수), privacy: 개인정보처리방침(필수), marketing: 마케팅수신(선택)
 */
export type TermDtoType = (typeof TermDtoType)[keyof typeof TermDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TermDtoType = {
  terms: "terms",
  privacy: "privacy",
  marketing: "marketing",
} as const;

export interface TermDto {
  /** 약관 타입 - terms: 이용약관(필수), privacy: 개인정보처리방침(필수), marketing: 마케팅수신(선택) */
  type: TermDtoType;
  /** 약관 동의 여부 - terms와 privacy는 필수(true), marketing은 선택 */
  agreed: boolean;
  /** 약관 버전 */
  version: string;
}

export interface SignupCompleteDto {
  /**
   * 사용자 ID - 로그인용 고유 식별자 (4-50자, 영문/숫자/_/- 만 허용)
   * @minLength 3
   */
  userId: string;
  /**
   * 비밀번호 - 최소 6자 이상
   * @minLength 6
   */
  password: string;
  /** NICE 본인인증 데이터 - 인증 완료 후 받은 사용자 정보 */
  niceData: NiceDataDto;
  /** 검증 완료된 NICE 인증 요청 번호 (POST /auth/nice/callback 응답의 requestNo) */
  verificationRequestNo: string;
  /** 약관 동의 목록 - terms와 privacy는 필수 동의, marketing은 선택 동의 */
  terms: TermDto[];
}

export interface RefreshResponseDto {
  /** New Access Token */
  accessToken: string;
  /** New Refresh Token */
  refreshToken: string;
  /** Expires In (seconds) */
  expiresIn: number;
  /** Token Type */
  tokenType: string;
  message: string;
  timestamp: string;
}

export interface RefreshDto {
  /** Refresh Token */
  refreshToken: string;
}

export interface LogoutResponseDto {
  message: string;
  timestamp: string;
}

export interface TermsDefinitionResponseDto {
  id: string;
  type: string;
  version: string;
  title: string;
  content: string;
  isRequired: boolean;
}

export interface ChangePasswordDto {
  /** 현재 비밀번호 */
  currentPassword: string;
  /** 새로운 비밀번호 */
  newPassword: string;
}

export interface VerifyCiHashResponseDto {
  /** 검증 성공 여부 */
  success: boolean;
  /** 비밀번호 재설정용 임시 토큰 (15분 유효) */
  resetToken: string;
}

export interface VerifyCiHashApiResponse {
  /** API 호출 성공 여부 */
  success: boolean;
  /** 작업 성공 메시지 */
  message: string;
  /** CI Hash 검증 응답 데이터 */
  data: VerifyCiHashResponseDto;
  /** 응답 생성 시각 (ISO 8601) */
  timestamp: string;
}

export interface VerifyCiHashDto {
  /** 사용자 ID */
  userId: string;
  /** NICE 본인인증으로 받은 CI Hash */
  ciHash: string;
}

export interface ConfirmPasswordResetResponseDto {
  /** 비밀번호 변경 완료 메시지 */
  message: string;
}

export interface ConfirmPasswordResetApiResponse {
  /** API 호출 성공 여부 */
  success: boolean;
  /** 작업 성공 메시지 */
  message: string;
  /** 비밀번호 변경 응답 데이터 */
  data: ConfirmPasswordResetResponseDto;
  /** 응답 생성 시각 (ISO 8601) */
  timestamp: string;
}

export interface ConfirmPasswordResetDto {
  /** CI Hash 검증 시 받은 재설정 토큰 */
  resetToken: string;
  /** 새 비밀번호 (최소 8자) */
  newPassword: string;
}

export interface FindUserIdDto {
  /**
   * 사용자 실명 - 회원가입 시 입력한 이름
   * @maxLength 50
   */
  name: string;
  /**
   * 휴대폰 번호 - 하이픈 있거나 없음
   * @pattern ^0(?:[1][0-9]|[2-9]\\d?)-?\\d{3,4}-?\\d{4}$
   */
  phone: string;
}

export interface FindUserIdResponseDto {
  /** 사용자 존재 여부 - true면 userId 포함, false면 null */
  exists: boolean;
  /**
   * 사용자 비즈니스 ID (user_id) - 영문/숫자/언더스코어 형식 (exists가 false면 null)
   * @nullable
   */
  userId: string | null;
}

export interface CheckUserIdAvailabilityDto {
  /** 사용자 ID */
  userId: string;
}

export interface CheckUserIdAvailabilityResponseDto {
  /** ID 사용 가능 여부 */
  available: boolean;
  /** 상태 메시지 */
  message: string;
}

/**
 * 공급자 정보
 */
export type UserResponseDtoSupplierInfo = { [key: string]: unknown };

export interface UserResponseDto {
  /** 사용자 고유 ID (UUID) */
  id: string;
  /** 사용자가 입력한 ID (username) */
  userId: string;
  /** 사용자 성명 */
  name: string;
  /** 연락처 이메일 */
  contactEmail?: string;
  /** 사용자 전화번호 */
  phone: string;
  /** 생년월일 (YYYY-MM-DD 형식) */
  birthDate?: string;
  /** 성별 (M: 남성, F: 여성) */
  gender?: string;
  /** 통신사 */
  telecom?: string;
  /** 계정 활성 상태 */
  isActive: boolean;
  /** 사용자 유형 */
  userType: string;
  /** 프로필 이미지 URL */
  profileImageUrl?: string;
  /** 마지막 로그인 시간 (ISO 8601 형식) */
  lastLoginAt?: string;
  /** 사용자 생성 날짜 (ISO 8601 형식) */
  createdAt: string;
  /** 프로필 수정일 (ISO 8601 형식) */
  updatedAt?: string;
  /** 공급자 정보 */
  supplierInfo?: UserResponseDtoSupplierInfo;
  /** Supabase Auth 사용자 ID (UUID) */
  authId: string;
  /** 탈퇴 신청 일시 (ISO 8601 형식) */
  withdrawalRequestedAt?: string;
  /** NICE 인증 완료 시간 (ISO 8601 형식) */
  niceVerifiedAt?: string;
  /** NICE 응답번호 */
  niceResponseNo?: string;
  /** CI (연계정보) */
  ci?: string;
  /** DI (중복가입확인정보) */
  di?: string;
  /** C마켓 공급자 ID */
  supplierId?: string;
  /** 카카오 알림톡 수신 여부 */
  kakaoNotificationEnabled: boolean;
}

export interface UpdateUserDto {
  /** 새로운 이메일 주소 */
  email?: string;
  /** 프로필 이미지의 공개 URL */
  profileImageUrl?: string;
}

export interface ProfileImageUploadResponseDto {
  /** 업로드된 이미지의 공개 URL */
  imageUrl: string;
  /** 원본 파일명 */
  fileName: string;
  /** 파일 크기 (바이트) */
  fileSize: number;
  /** 파일 MIME 타입 */
  contentType: string;
}

export interface VerificationDateResponseDto {
  /**
   * 본인인증 완료 시간 (ISO 8601)
   * @nullable
   */
  verifiedAt?: string | null;
  /**
   * 본인인증 이후 경과 일수
   * @nullable
   */
  daysAgo?: number | null;
  /** 본인인증 여부 */
  isVerified: boolean;
  /**
   * 인증 상태 메시지
   * @nullable
   */
  displayText?: string | null;
}

export interface UpsertAddressDto {
  /**
   * 주소 라벨
   * @maxLength 50
   */
  label?: string;
  /** 기본 주소 설정 */
  isDefault: boolean;
  /**
   * 우편번호
   * @maxLength 10
   */
  postalCode: string;
  /**
   * 시/도
   * @maxLength 50
   */
  province: string;
  /**
   * 시/군/구
   * @maxLength 50
   */
  city: string;
  /**
   * 읍/면/동 (누락 시 null 저장)
   * @maxLength 50
   * @nullable
   */
  district?: string | null;
  /**
   * 도로명 주소
   * @maxLength 200
   */
  streetAddress: string;
  /**
   * 상세 주소
   * @maxLength 200
   */
  addressDetail?: string;
  /**
   * 수령인 이름
   * @maxLength 50
   */
  recipientName: string;
  /**
   * 수령인 연락처
   * @maxLength 20
   */
  recipientPhone?: string;
  /**
   * 주소 ID (선택사항)
   * @nullable
   */
  id?: string | null;
}

export interface SendVerificationCodeResponseDto {
  /** 마스킹된 이메일 주소 */
  maskedEmail: string;
  /** 코드 만료 시간 (초) */
  expiresIn: number;
}

export interface SendEmailVerificationCodeDto {
  /** 인증받을 이메일 주소 */
  email: string;
}

export interface EmailVerificationResponseDto {
  /** 인증된 이메일 주소 */
  email: string;
  /** 이메일 인증 성공 여부 */
  isVerified: boolean;
  /** 이메일 인증 완료 시간 (ISO 8601) */
  verifiedAt?: string;
}

export interface VerifyEmailCodeDto {
  /** 인증 코드를 받은 이메일 주소 */
  email: string;
  /**
   * 6자리 인증 코드
   * @minLength 6
   * @maxLength 6
   */
  code: string;
}

export interface NotificationSettingsResponseDto {
  /** 설정 ID (UUID) */
  id: string;
  /** 사용자 ID (UUID) */
  userId: string;
  /** 시스템 알람 수신 여부 */
  systemEnabled: boolean;
  /** 프로젝트 알람 수신 여부 */
  projectEnabled: boolean;
  /** 채팅 알람 수신 여부 */
  chatEnabled: boolean;
  /** 결제 알람 수신 여부 */
  paymentEnabled: boolean;
  /** 후기 알람 수신 여부 */
  reviewEnabled: boolean;
  /** 카카오 알림톡 수신 여부 */
  kakaoTalkEnabled: boolean;
  /** 생성일 (ISO 8601 형식) */
  createdAt: string;
  /** 수정일 (ISO 8601 형식) */
  updatedAt: string;
}

export interface UpdateNotificationSettingsDto {
  /** 시스템 알람 수신 여부 */
  systemEnabled?: boolean;
  /** 프로젝트 알람 수신 여부 */
  projectEnabled?: boolean;
  /** 채팅 알람 수신 여부 */
  chatEnabled?: boolean;
  /** 결제 알람 수신 여부 */
  paymentEnabled?: boolean;
  /** 후기 알람 수신 여부 */
  reviewEnabled?: boolean;
  /** 카카오 알림톡 수신 여부 */
  kakaoTalkEnabled?: boolean;
}

export interface MarketingConsentResponseDto {
  /** 마케팅 정보 수신 동의 여부 */
  agreed: boolean;
  /**
   * 동의 시점
   * @nullable
   */
  agreedAt?: string | null;
  /**
   * 철회 시점
   * @nullable
   */
  revokedAt?: string | null;
  /**
   * 동의 채널
   * @nullable
   */
  consentChannel?: string | null;
  /**
   * 약관 버전
   * @nullable
   */
  version?: string | null;
}

export interface UpdateMarketingConsentDto {
  /** 마케팅 정보 수신 동의 여부 */
  agreed: boolean;
}

export interface UpdateAutoQuoteDto {
  /** 자동 견적 응답 활성화 여부 */
  enabled: boolean;
}

export interface WithdrawUserDto {
  /**
   * Current password for verification
   * @minLength 6
   */
  password: string;
  /** Reason for withdrawal */
  reason: string;
  /** Detailed reason for withdrawal (optional) */
  detail?: string;
}

export interface ReviewTopTagDto {
  /** 태그 문구 */
  label: string;
  /** 태그 횟수 */
  count: number;
}

export interface ProfileReviewSummaryDto {
  /** 총 리뷰 수 */
  totalReviews: number;
  /** 평균 평점 (1-5) */
  averageRating: number;
  /** 긍정 리뷰 수 (평점 4-5) */
  positiveReviewCount: number;
  /** 부정 리뷰 수 (평점 1-2) */
  negativeReviewCount: number;
  /** 긍정 태그 상위 */
  topTags: ReviewTopTagDto[];
}

/**
 * 발급 기관
 * @nullable
 */
export type SupplierCertificationDtoIssuer = { [key: string]: unknown } | null;

/**
 * 인증 번호
 * @nullable
 */
export type SupplierCertificationDtoCertNumber = {
  [key: string]: unknown;
} | null;

/**
 * 발급일
 * @nullable
 */
export type SupplierCertificationDtoIssuedAt = {
  [key: string]: unknown;
} | null;

/**
 * 만료일
 * @nullable
 */
export type SupplierCertificationDtoExpiresAt = {
  [key: string]: unknown;
} | null;

/**
 * 검증 상태
 */
export type SupplierCertificationDtoStatus =
  (typeof SupplierCertificationDtoStatus)[keyof typeof SupplierCertificationDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierCertificationDtoStatus = {
  PENDING: "PENDING",
  VERIFIED: "VERIFIED",
  REJECTED: "REJECTED",
} as const;

/**
 * 출처 — SELF: 세모에서 직접 업로드, CMARKET: 씨마켓 회원프로필 동기화, G2B: 나라장터 등록 업종(둘 다 세모에서 수정·삭제 불가)
 */
export type SupplierCertificationDtoSource =
  (typeof SupplierCertificationDtoSource)[keyof typeof SupplierCertificationDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierCertificationDtoSource = {
  SELF: "SELF",
  CMARKET: "CMARKET",
  G2B: "G2B",
} as const;

/**
 * 종류 (CERTIFICATION/LICENSE/CUSTOM, 씨마켓 동기화분만)
 * @nullable
 */
export type SupplierCertificationDtoKind = { [key: string]: unknown } | null;

/**
 * 반려 사유
 * @nullable
 */
export type SupplierCertificationDtoRejectionReason = {
  [key: string]: unknown;
} | null;

/**
 * 업로드 파일 URL (본인/어드민만)
 * @nullable
 */
export type SupplierCertificationDtoFileUrl = { [key: string]: unknown } | null;

/**
 * 업로드 파일명
 * @nullable
 */
export type SupplierCertificationDtoFileName = {
  [key: string]: unknown;
} | null;

export interface SupplierCertificationDto {
  /** 인증서 ID */
  id: string;
  /** 인증서 명칭 */
  name: string;
  /**
   * 발급 기관
   * @nullable
   */
  issuer?: SupplierCertificationDtoIssuer;
  /**
   * 인증 번호
   * @nullable
   */
  certNumber?: SupplierCertificationDtoCertNumber;
  /**
   * 발급일
   * @nullable
   */
  issuedAt?: SupplierCertificationDtoIssuedAt;
  /**
   * 만료일
   * @nullable
   */
  expiresAt?: SupplierCertificationDtoExpiresAt;
  /** 검증 상태 */
  status: SupplierCertificationDtoStatus;
  /** 출처 — SELF: 세모에서 직접 업로드, CMARKET: 씨마켓 회원프로필 동기화, G2B: 나라장터 등록 업종(둘 다 세모에서 수정·삭제 불가) */
  source: SupplierCertificationDtoSource;
  /**
   * 종류 (CERTIFICATION/LICENSE/CUSTOM, 씨마켓 동기화분만)
   * @nullable
   */
  kind?: SupplierCertificationDtoKind;
  /**
   * 반려 사유
   * @nullable
   */
  rejectionReason?: SupplierCertificationDtoRejectionReason;
  /**
   * 업로드 파일 URL (본인/어드민만)
   * @nullable
   */
  fileUrl?: SupplierCertificationDtoFileUrl;
  /**
   * 업로드 파일명
   * @nullable
   */
  fileName?: SupplierCertificationDtoFileName;
  /** 등록일시 */
  createdAt: string;
  /** 가입 창구에서 낸 것인가(마스터 목록만, 2026-10-19) */
  fromSignup?: boolean;
}

/**
 * 유효 인증 기준 만료일 (YYYY-MM-DD)
 * @nullable
 */
export type ProfileProcurementCategoryDtoValidUntil = {
  [key: string]: unknown;
} | null;

export interface ProfileProcurementCategoryDto {
  /** 씨마켓 의무구매 토큰 (I·O1·O2·O3·L·R·S·K, 기술개발제품=P0, 녹색제품=Q0) */
  code: string;
  /** 표시 이름 */
  label: string;
  /**
   * 유효 인증 기준 만료일 (YYYY-MM-DD)
   * @nullable
   */
  validUntil?: ProfileProcurementCategoryDtoValidUntil;
}

export interface ProfileTopInstitutionDto {
  /** 기관명 */
  name: string;
  /** 기간 내 완료 계약 수 */
  contractCount: number;
}

export interface ProfileRecentTransactionsDto {
  /** 집계 기간 (년) */
  years: number;
  /** 완료 계약 수 (취소·삭제·대행 매입분 제외) */
  contractCount: number;
  /** 거래기관 수 (사업자번호 기준) */
  institutionCount: number;
  /** 거래 많은 기관 상위 — 공개 견적에서 온 계약만 이름을 쓰고, 계약 전(익명)이면 빈 배열 */
  topInstitutions: ProfileTopInstitutionDto[];
}

export interface ProfileCompletenessDto {
  /** 완성도 (0-100) */
  percent: number;
  /** 비어 있는 항목 키 목록 */
  missing: string[];
}

/**
 * 회사명 (익명이면 null)
 * @nullable
 */
export type MySupplierProfileDtoCompanyName = { [key: string]: unknown } | null;

/**
 * 대표자명 (익명이면 null)
 * @nullable
 */
export type MySupplierProfileDtoCeoName = { [key: string]: unknown } | null;

/**
 * 지역 (시/도 + 시군구, 익명에도 공개)
 * @nullable
 */
export type MySupplierProfileDtoRegion = { [key: string]: unknown } | null;

/**
 * 홈페이지 URL
 * @nullable
 */
export type MySupplierProfileDtoHomepageUrl = { [key: string]: unknown } | null;

/**
 * 회사 로고 URL
 * @nullable
 */
export type MySupplierProfileDtoLogoUrl = { [key: string]: unknown } | null;

/**
 * 홈페이지 랜딩 썸네일 URL (assets 사본)
 * @nullable
 */
export type MySupplierProfileDtoLandingThumbnailUrl = {
  [key: string]: unknown;
} | null;

/**
 * 회사 소개
 * @nullable
 */
export type MySupplierProfileDtoCompanyIntro = {
  [key: string]: unknown;
} | null;

/**
 * 취급 품목 요약
 * @nullable
 */
export type MySupplierProfileDtoProductDescription = {
  [key: string]: unknown;
} | null;

/**
 * 설립일
 * @nullable
 */
export type MySupplierProfileDtoEstablishedAt = {
  [key: string]: unknown;
} | null;

/**
 * 업력 (년차, 설립일 미입력 시 null)
 * @nullable
 */
export type MySupplierProfileDtoYearsInBusiness = {
  [key: string]: unknown;
} | null;

/**
 * 세모 가입일
 * @nullable
 */
export type MySupplierProfileDtoJoinedAt = { [key: string]: unknown } | null;

/**
 * 신뢰도 점수 (0-100)
 * @nullable
 */
export type MySupplierProfileDtoTrustScore = { [key: string]: unknown } | null;

/**
 * 신뢰도 상위 백분위 (1=상위 1%)
 * @nullable
 */
export type MySupplierProfileDtoTrustPercentile = {
  [key: string]: unknown;
} | null;

/**
 * 최근 3년 거래 실적 (집계 실패 시 null) — 계약 전(익명)이면 거래기관 이름은 빈 배열
 * @nullable
 */
export type MySupplierProfileDtoRecentTransactions =
  ProfileRecentTransactionsDto | null;

/**
 * 최근 활동 시각 (로그인·채팅 발신·견적 제출 중 가장 늦은 때)
 * @nullable
 */
export type MySupplierProfileDtoLastActiveAt = {
  [key: string]: unknown;
} | null;

export interface MySupplierProfileDto {
  /** 공급사 사용자 ID (users.id) */
  supplierId: string;
  /** 신원 공개 여부 (계약 체결·PRO 플랜·본인·어드민이면 true) */
  isRevealed: boolean;
  /**
   * 회사명 (익명이면 null)
   * @nullable
   */
  companyName?: MySupplierProfileDtoCompanyName;
  /**
   * 대표자명 (익명이면 null)
   * @nullable
   */
  ceoName?: MySupplierProfileDtoCeoName;
  /**
   * 지역 (시/도 + 시군구, 익명에도 공개)
   * @nullable
   */
  region?: MySupplierProfileDtoRegion;
  /**
   * 홈페이지 URL
   * @nullable
   */
  homepageUrl?: MySupplierProfileDtoHomepageUrl;
  /**
   * 회사 로고 URL
   * @nullable
   */
  logoUrl?: MySupplierProfileDtoLogoUrl;
  /**
   * 홈페이지 랜딩 썸네일 URL (assets 사본)
   * @nullable
   */
  landingThumbnailUrl?: MySupplierProfileDtoLandingThumbnailUrl;
  /**
   * 회사 소개
   * @nullable
   */
  companyIntro?: MySupplierProfileDtoCompanyIntro;
  /**
   * 취급 품목 요약
   * @nullable
   */
  productDescription?: MySupplierProfileDtoProductDescription;
  /**
   * 설립일
   * @nullable
   */
  establishedAt?: MySupplierProfileDtoEstablishedAt;
  /**
   * 업력 (년차, 설립일 미입력 시 null)
   * @nullable
   */
  yearsInBusiness?: MySupplierProfileDtoYearsInBusiness;
  /**
   * 세모 가입일
   * @nullable
   */
  joinedAt?: MySupplierProfileDtoJoinedAt;
  /**
   * 신뢰도 점수 (0-100)
   * @nullable
   */
  trustScore?: MySupplierProfileDtoTrustScore;
  /**
   * 신뢰도 상위 백분위 (1=상위 1%)
   * @nullable
   */
  trustPercentile?: MySupplierProfileDtoTrustPercentile;
  /** 후기 요약 */
  reviewSummary: ProfileReviewSummaryDto;
  /** 검증된 인증서 수 */
  certificationCount: number;
  /** 검증된 인증서 목록 (익명이면 빈 배열 — 개수만 공개) */
  certifications: SupplierCertificationDto[];
  /** 공공기관 의무구매 대상 인증 분야 (씨마켓 판정 · 만료 지난 분야 제외 · 익명에도 공개) */
  procurementCategories: ProfileProcurementCategoryDto[];
  /**
   * 최근 3년 거래 실적 (집계 실패 시 null) — 계약 전(익명)이면 거래기관 이름은 빈 배열
   * @nullable
   */
  recentTransactions?: MySupplierProfileDtoRecentTransactions;
  /**
   * 최근 활동 시각 (로그인·채팅 발신·견적 제출 중 가장 늦은 때)
   * @nullable
   */
  lastActiveAt?: MySupplierProfileDtoLastActiveAt;
  /** 프로필 완성도 */
  completeness: ProfileCompletenessDto;
}

export interface UpdateSupplierProfileRequestDto {
  /** 홈페이지 URL (변경 시 랜딩 썸네일 재캡처) */
  homepageUrl?: string;
  /** 설립일 */
  establishedAt?: string;
  /** 회사 소개 */
  companyIntro?: string;
  /** 취급 품목 요약 (255자) */
  productDescription?: string;
}

export interface SupplierLogoUploadResponseDto {
  /** 업로드된 로고 공개 URL */
  logoUrl: string;
}

/**
 * 회사명 (익명이면 null)
 * @nullable
 */
export type SupplierPublicProfileDtoCompanyName = {
  [key: string]: unknown;
} | null;

/**
 * 대표자명 (익명이면 null)
 * @nullable
 */
export type SupplierPublicProfileDtoCeoName = { [key: string]: unknown } | null;

/**
 * 지역 (시/도 + 시군구, 익명에도 공개)
 * @nullable
 */
export type SupplierPublicProfileDtoRegion = { [key: string]: unknown } | null;

/**
 * 홈페이지 URL
 * @nullable
 */
export type SupplierPublicProfileDtoHomepageUrl = {
  [key: string]: unknown;
} | null;

/**
 * 회사 로고 URL
 * @nullable
 */
export type SupplierPublicProfileDtoLogoUrl = { [key: string]: unknown } | null;

/**
 * 홈페이지 랜딩 썸네일 URL (assets 사본)
 * @nullable
 */
export type SupplierPublicProfileDtoLandingThumbnailUrl = {
  [key: string]: unknown;
} | null;

/**
 * 회사 소개
 * @nullable
 */
export type SupplierPublicProfileDtoCompanyIntro = {
  [key: string]: unknown;
} | null;

/**
 * 취급 품목 요약
 * @nullable
 */
export type SupplierPublicProfileDtoProductDescription = {
  [key: string]: unknown;
} | null;

/**
 * 설립일
 * @nullable
 */
export type SupplierPublicProfileDtoEstablishedAt = {
  [key: string]: unknown;
} | null;

/**
 * 업력 (년차, 설립일 미입력 시 null)
 * @nullable
 */
export type SupplierPublicProfileDtoYearsInBusiness = {
  [key: string]: unknown;
} | null;

/**
 * 세모 가입일
 * @nullable
 */
export type SupplierPublicProfileDtoJoinedAt = {
  [key: string]: unknown;
} | null;

/**
 * 신뢰도 점수 (0-100)
 * @nullable
 */
export type SupplierPublicProfileDtoTrustScore = {
  [key: string]: unknown;
} | null;

/**
 * 신뢰도 상위 백분위 (1=상위 1%)
 * @nullable
 */
export type SupplierPublicProfileDtoTrustPercentile = {
  [key: string]: unknown;
} | null;

/**
 * 최근 3년 거래 실적 (집계 실패 시 null) — 계약 전(익명)이면 거래기관 이름은 빈 배열
 * @nullable
 */
export type SupplierPublicProfileDtoRecentTransactions =
  ProfileRecentTransactionsDto | null;

/**
 * 최근 활동 시각 (로그인·채팅 발신·견적 제출 중 가장 늦은 때)
 * @nullable
 */
export type SupplierPublicProfileDtoLastActiveAt = {
  [key: string]: unknown;
} | null;

export interface SupplierPublicProfileDto {
  /** 공급사 사용자 ID (users.id) */
  supplierId: string;
  /** 신원 공개 여부 (계약 체결·PRO 플랜·본인·어드민이면 true) */
  isRevealed: boolean;
  /**
   * 회사명 (익명이면 null)
   * @nullable
   */
  companyName?: SupplierPublicProfileDtoCompanyName;
  /**
   * 대표자명 (익명이면 null)
   * @nullable
   */
  ceoName?: SupplierPublicProfileDtoCeoName;
  /**
   * 지역 (시/도 + 시군구, 익명에도 공개)
   * @nullable
   */
  region?: SupplierPublicProfileDtoRegion;
  /**
   * 홈페이지 URL
   * @nullable
   */
  homepageUrl?: SupplierPublicProfileDtoHomepageUrl;
  /**
   * 회사 로고 URL
   * @nullable
   */
  logoUrl?: SupplierPublicProfileDtoLogoUrl;
  /**
   * 홈페이지 랜딩 썸네일 URL (assets 사본)
   * @nullable
   */
  landingThumbnailUrl?: SupplierPublicProfileDtoLandingThumbnailUrl;
  /**
   * 회사 소개
   * @nullable
   */
  companyIntro?: SupplierPublicProfileDtoCompanyIntro;
  /**
   * 취급 품목 요약
   * @nullable
   */
  productDescription?: SupplierPublicProfileDtoProductDescription;
  /**
   * 설립일
   * @nullable
   */
  establishedAt?: SupplierPublicProfileDtoEstablishedAt;
  /**
   * 업력 (년차, 설립일 미입력 시 null)
   * @nullable
   */
  yearsInBusiness?: SupplierPublicProfileDtoYearsInBusiness;
  /**
   * 세모 가입일
   * @nullable
   */
  joinedAt?: SupplierPublicProfileDtoJoinedAt;
  /**
   * 신뢰도 점수 (0-100)
   * @nullable
   */
  trustScore?: SupplierPublicProfileDtoTrustScore;
  /**
   * 신뢰도 상위 백분위 (1=상위 1%)
   * @nullable
   */
  trustPercentile?: SupplierPublicProfileDtoTrustPercentile;
  /** 후기 요약 */
  reviewSummary: ProfileReviewSummaryDto;
  /** 검증된 인증서 수 */
  certificationCount: number;
  /** 검증된 인증서 목록 (익명이면 빈 배열 — 개수만 공개) */
  certifications: SupplierCertificationDto[];
  /** 공공기관 의무구매 대상 인증 분야 (씨마켓 판정 · 만료 지난 분야 제외 · 익명에도 공개) */
  procurementCategories: ProfileProcurementCategoryDto[];
  /**
   * 최근 3년 거래 실적 (집계 실패 시 null) — 계약 전(익명)이면 거래기관 이름은 빈 배열
   * @nullable
   */
  recentTransactions?: SupplierPublicProfileDtoRecentTransactions;
  /**
   * 최근 활동 시각 (로그인·채팅 발신·견적 제출 중 가장 늦은 때)
   * @nullable
   */
  lastActiveAt?: SupplierPublicProfileDtoLastActiveAt;
}

/**
 * 검증 결과
 */
export type VerifySupplierCertificationRequestDtoStatus =
  (typeof VerifySupplierCertificationRequestDtoStatus)[keyof typeof VerifySupplierCertificationRequestDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VerifySupplierCertificationRequestDtoStatus = {
  VERIFIED: "VERIFIED",
  REJECTED: "REJECTED",
} as const;

export interface VerifySupplierCertificationRequestDto {
  /** 검증 결과 */
  status: VerifySupplierCertificationRequestDtoStatus;
  /** 반려 사유 (REJECTED 시) */
  rejectionReason?: string;
}

export interface ContractListSupplierDto {
  /** 공급자 회사명 */
  name: string;
}

/**
 * 견적 요청 상태
 */
export type QuoteRequestInfoDtoStatus =
  (typeof QuoteRequestInfoDtoStatus)[keyof typeof QuoteRequestInfoDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestInfoDtoStatus = {
  TEMP_SAVE: "TEMP_SAVE",
  WAITING_APPROVAL: "WAITING_APPROVAL",
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CANCELLED: "CANCELLED",
} as const;

export interface QuoteRequestInfoDto {
  /** 견적 요청 ID */
  id: string;
  /** 견적 요청 번호 (UI 표시용 - SE 제외) */
  requestNumber: string;
  /** 프로젝트명 */
  projectName: string;
  /** 견적 요청 상태 */
  status: QuoteRequestInfoDtoStatus;
  /**
   * 마감일 (ISO 8601)
   * @nullable
   */
  deadline: string | null;
  /**
   * 응답 수
   * @minimum 0
   */
  responseCount: number;
}

export interface ContractListBuyerDto {
  /** 구매자명 */
  name?: string;
}

export interface ContractLabelValueDto {
  /** 내부 코드 */
  value: string;
  /** 표시 라벨 */
  label: string;
}

/**
 * 계약 상태
 */
export type ContractListResponseDtoStatus =
  (typeof ContractListResponseDtoStatus)[keyof typeof ContractListResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractListResponseDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
} as const;

/**
 * 정산상태
 */
export type ContractListResponseDtoSettlementStatus =
  (typeof ContractListResponseDtoSettlementStatus)[keyof typeof ContractListResponseDtoSettlementStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractListResponseDtoSettlementStatus = {
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  DEFERRED: "DEFERRED",
} as const;

/**
 * 결제방식 (결제 수단 유형: CARD, BANK_TRANSFER)
 * @nullable
 */
export type ContractListResponseDtoPaymentMethod =
  | (typeof ContractListResponseDtoPaymentMethod)[keyof typeof ContractListResponseDtoPaymentMethod]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractListResponseDtoPaymentMethod = {
  CARD: "CARD",
  BANK_TRANSFER: "BANK_TRANSFER",
} as const;

/**
 * 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. 위 `paymentMethod` 는 **결제 거래**의 수단(DIRECT/CMARKET_CARD 등)이라 이것과 다른 축이다 — 현금/카드 배지는 반드시 이 필드로 그릴 것.
 * @nullable
 */
export type ContractListResponseDtoPaymentChannel =
  | (typeof ContractListResponseDtoPaymentChannel)[keyof typeof ContractListResponseDtoPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractListResponseDtoPaymentChannel = {
  cash: "cash",
  card: "card",
} as const;

/**
 * 씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨.
 * @nullable
 */
export type ContractListResponseDtoTaxInvoiceStatus =
  | (typeof ContractListResponseDtoTaxInvoiceStatus)[keyof typeof ContractListResponseDtoTaxInvoiceStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractListResponseDtoTaxInvoiceStatus = {
  REQUESTED: "REQUESTED",
  ISSUED: "ISSUED",
  CANCELLED: "CANCELLED",
} as const;

/**
 * 씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키.
 * @nullable
 */
export type ContractListResponseDtoTaxInvoiceTargetId = {
  [key: string]: unknown;
} | null;

/**
 * 발주자 정보
 * @nullable
 */
export type ContractListResponseDtoBuyer = ContractListBuyerDto | null;

/**
 * 공사 유형 (공사 카테고리인 경우)
 * @nullable
 */
export type ContractListResponseDtoConstructionType =
  ContractLabelValueDto | null;

/**
 * 공사 장소 (공사 카테고리인 경우)
 * @nullable
 */
export type ContractListResponseDtoSpaceType = ContractLabelValueDto | null;

/**
 * 공사 면적 (공사 카테고리인 경우)
 * @nullable
 */
export type ContractListResponseDtoConstructionArea =
  ContractLabelValueDto | null;

/**
 * 계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.
 * @nullable
 */
export type ContractListResponseDtoCancellationRequestedBy =
  | (typeof ContractListResponseDtoCancellationRequestedBy)[keyof typeof ContractListResponseDtoCancellationRequestedBy]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractListResponseDtoCancellationRequestedBy = {
  buyer: "buyer",
  supplier: "supplier",
} as const;

export interface ContractListResponseDto {
  /** 계약 ID (UUID) */
  id: string;
  /** 계약 번호 (UI 표시용 - SE 제외) */
  contractNumber: string;
  /** 계약 상태 */
  status: ContractListResponseDtoStatus;
  /** 총 금액 */
  totalAmount: number;
  /**
   * 계약서 PDF URL (생성 중이면 null)
   * @nullable
   */
  pdfUrl: string | null;
  /** 공급자 정보 */
  supplier: ContractListSupplierDto;
  /** 견적 요청 정보 (참조용) */
  quoteRequest: QuoteRequestInfoDto;
  /**
   * 이 계약이 선 견적 응답 **버전** id. 씨마켓이 이 계약의 결제창을 되짚는 유일한 키다 — 결제창 발행 시 이 값을 멱등키로 보냈고(`externalRef`), 씨마켓은 그 값으로 계약 ↔ 결제창을 1:1 로 묶어 두었다. 계약 목록에서 [카드결제]/[카드영수증] 을 그리는 재료.
   * @nullable
   */
  quoteResponseVersionId?: string | null;
  /** 정산상태 */
  settlementStatus: ContractListResponseDtoSettlementStatus;
  /**
   * 결제방식 (결제 수단 유형: CARD, BANK_TRANSFER)
   * @nullable
   */
  paymentMethod?: ContractListResponseDtoPaymentMethod;
  /**
   * 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. 위 `paymentMethod` 는 **결제 거래**의 수단(DIRECT/CMARKET_CARD 등)이라 이것과 다른 축이다 — 현금/카드 배지는 반드시 이 필드로 그릴 것.
   * @nullable
   */
  paymentChannel?: ContractListResponseDtoPaymentChannel;
  /**
   * 씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨.
   * @nullable
   */
  taxInvoiceStatus?: ContractListResponseDtoTaxInvoiceStatus;
  /**
   * 씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키.
   * @nullable
   */
  taxInvoiceTargetId?: ContractListResponseDtoTaxInvoiceTargetId;
  /**
   * 발주자 정보
   * @nullable
   */
  buyer?: ContractListResponseDtoBuyer;
  /**
   * 공사 유형 (공사 카테고리인 경우)
   * @nullable
   */
  constructionType?: ContractListResponseDtoConstructionType;
  /**
   * 공사 장소 (공사 카테고리인 경우)
   * @nullable
   */
  spaceType?: ContractListResponseDtoSpaceType;
  /**
   * 공사 면적 (공사 카테고리인 경우)
   * @nullable
   */
  constructionArea?: ContractListResponseDtoConstructionArea;
  /**
   * 계약 취소 사유 (발주기관이 취소 요청 시 입력한 값. 취소 요청 접수 시점부터 세팅되며, 취소 확정 후에도 원본이 유지됨)
   * @nullable
   */
  cancellationReason?: string | null;
  /**
   * 계약 취소 요청 일시 (환불 승인 대기 상태일 때부터 존재)
   * @nullable
   */
  cancellationRequestedAt?: string | null;
  /**
   * 계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.
   * @nullable
   */
  cancellationRequestedBy?: ContractListResponseDtoCancellationRequestedBy;
  /**
   * 계약 취소 일시 (status=CANCELED일 때만 존재)
   * @nullable
   */
  canceledAt?: string | null;
  /** 계약 생성 일시 (ISO 8601) */
  createdAt: string;
}

export interface ContractSupplierDto {
  /** 공급자 ID */
  id: string;
  /** 공급자 회사명 */
  name: string;
  /** 대표자명 */
  ceoName: string;
  /** 사업자등록번호 */
  businessNumber: string;
  /** 회사 주소 */
  address?: string;
  /** 회사 전화번호 */
  phone?: string;
  /** 공급자 이메일 */
  email?: string;
  /** 담당자명 */
  managerName?: string;
  /** 담당자 전화번호 */
  managerPhone?: string;
  /** 회사 직인 URL */
  companySealUrl?: string;
  /** 은행명 */
  bankName?: string;
  /** 계좌번호 */
  bankAccountNumber?: string;
  /** 예금주 */
  bankAccountHolder?: string;
}

export interface ContractBuyerDto {
  /** 구매자명 */
  name?: string;
  /** 발주기관명 */
  company?: string;
  /** 발주기관 대표자 */
  representativeName?: string;
  /** 발주기관 사업자등록번호 */
  businessNumber?: string;
  /** 발주기관 주소 */
  address?: string;
  /** 구매자 전화번호 */
  phone?: string;
  /** 구매자 이메일 */
  email?: string;
}

/**
 * 계약 상태
 */
export type ContractResponseDtoStatus =
  (typeof ContractResponseDtoStatus)[keyof typeof ContractResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractResponseDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
} as const;

/**
 * 계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.
 * @nullable
 */
export type ContractResponseDtoCancellationRequestedBy =
  | (typeof ContractResponseDtoCancellationRequestedBy)[keyof typeof ContractResponseDtoCancellationRequestedBy]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractResponseDtoCancellationRequestedBy = {
  buyer: "buyer",
  supplier: "supplier",
} as const;

/**
 * 카테고리 유형
 */
export type ContractResponseDtoCategoryType =
  (typeof ContractResponseDtoCategoryType)[keyof typeof ContractResponseDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractResponseDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 결제방식 (결제 수단 유형: CARD, BANK_TRANSFER)
 */
export type ContractResponseDtoPaymentMethod =
  (typeof ContractResponseDtoPaymentMethod)[keyof typeof ContractResponseDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractResponseDtoPaymentMethod = {
  CARD: "CARD",
  BANK_TRANSFER: "BANK_TRANSFER",
} as const;

/**
 * 정산상태
 */
export type ContractResponseDtoSettlementStatus =
  (typeof ContractResponseDtoSettlementStatus)[keyof typeof ContractResponseDtoSettlementStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractResponseDtoSettlementStatus = {
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  DEFERRED: "DEFERRED",
} as const;

/**
 * 발주자 정보
 * @nullable
 */
export type ContractResponseDtoBuyer = ContractBuyerDto | null;

/**
 * 배송지 정보
 * @nullable
 */
export type ContractResponseDtoDeliveryAddress = AddressResponseDto | null;

/**
 * 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.
 * @nullable
 */
export type ContractResponseDtoPaymentChannel =
  | (typeof ContractResponseDtoPaymentChannel)[keyof typeof ContractResponseDtoPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractResponseDtoPaymentChannel = {
  cash: "cash",
  card: "card",
} as const;

/**
 * 씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨. 발행 자체는 씨마켓 나의 계약 관리에서 일어난다.
 * @nullable
 */
export type ContractResponseDtoTaxInvoiceStatus =
  | (typeof ContractResponseDtoTaxInvoiceStatus)[keyof typeof ContractResponseDtoTaxInvoiceStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractResponseDtoTaxInvoiceStatus = {
  REQUESTED: "REQUESTED",
  ISSUED: "ISSUED",
  CANCELLED: "CANCELLED",
} as const;

/**
 * 씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키다. NULL 이면 씨마켓에 발행 대상이 없는 계약(미연동 계정이거나 등록 실패).
 * @nullable
 */
export type ContractResponseDtoTaxInvoiceTargetId = {
  [key: string]: unknown;
} | null;

export interface ContractResponseDto {
  /** 계약 ID */
  id: string;
  /** 결제 거래 ID */
  paymentTransactionId: string;
  /** 계약번호 */
  contractNumber: string;
  /** 총 금액 */
  totalAmount: number;
  /** 세금 (선택사항) */
  taxAmount?: number;
  /** 계약 상태 */
  status: ContractResponseDtoStatus;
  /**
   * 계약서 PDF URL
   * @nullable
   */
  pdfUrl: string | null;
  /** 계약서 PDF 생성 일시 (ISO 8601) */
  pdfGeneratedAt: string;
  /** 계약 항목 */
  items: QuoteItemDto[];
  /** 공급자 정보 */
  supplier: ContractSupplierDto;
  /** 견적 설명/비고 */
  description?: string;
  /** 계약 생성 일시 (ISO 8601) */
  createdAt: string;
  /** 계약 수정 일시 (ISO 8601) */
  updatedAt: string;
  /**
   * 계약 취소 일시 (status=CANCELED일 때만 존재)
   * @nullable
   */
  canceledAt?: string | null;
  /**
   * 계약 취소 사유 (발주기관이 취소 요청 시 입력한 값. 취소 요청 접수 시점부터 세팅되며, 취소 확정 후에도 원본이 유지됨)
   * @nullable
   */
  cancellationReason?: string | null;
  /**
   * 계약 취소 요청 일시 (환불 승인 대기 상태일 때부터 존재)
   * @nullable
   */
  cancellationRequestedAt?: string | null;
  /**
   * 계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.
   * @nullable
   */
  cancellationRequestedBy?: ContractResponseDtoCancellationRequestedBy;
  /**
   * 구매확정 일시 (status=COMPLETED일 때만 존재)
   * @nullable
   */
  completedAt?: string | null;
  /** 프로젝트명 (거래명) */
  projectName?: string;
  /** 카테고리 유형 */
  categoryType?: ContractResponseDtoCategoryType;
  /** 견적 요청 ID */
  quoteRequestId?: string;
  /** 견적 응답 버전 ID (2026-07-31). 계약 카드의 [결제하기] 가 씨마켓 결제창을 발행할 때 이 값을 필요로 한다. */
  quoteResponseVersionId?: string;
  /** 채팅방 ID (채팅 시작용) */
  chatRoomId?: string;
  /** 채팅 메시지 ID */
  chatMessageId?: string;
  /** 리뷰 ID (작성된 리뷰가 있는 경우) */
  reviewId?: string;
  /** 결제방식 (결제 수단 유형: CARD, BANK_TRANSFER) */
  paymentMethod?: ContractResponseDtoPaymentMethod;
  /** 정산상태 */
  settlementStatus: ContractResponseDtoSettlementStatus;
  /**
   * 환불 상태 (REQUESTED, APPROVED, REJECTED, PROCESSING, COMPLETED, FAILED)
   * @nullable
   */
  refundStatus?: string | null;
  /**
   * 환불 반려 사유 (refundStatus=REJECTED일 때만 존재)
   * @nullable
   */
  rejectionReason?: string | null;
  /**
   * 발주자 정보
   * @nullable
   */
  buyer?: ContractResponseDtoBuyer;
  /**
   * 배송지 정보
   * @nullable
   */
  deliveryAddress?: ContractResponseDtoDeliveryAddress;
  /** 결제 방법 (계약 시점 스냅샷). true=선결제(prepaid, 계약 체결과 결제 동시), false=후불결제(postpaid, 결제 없이 계약 체결 후 별도 결제). */
  isPrepaid: boolean;
  /**
   * 결제 완료 시각. NULL 이면 미결제(postpaid 만 가능). prepaid 는 created_at 과 동일.
   * @nullable
   */
  paidAt?: string | null;
  /**
   * 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.
   * @nullable
   */
  paymentChannel?: ContractResponseDtoPaymentChannel;
  /**
   * 씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨. 발행 자체는 씨마켓 나의 계약 관리에서 일어난다.
   * @nullable
   */
  taxInvoiceStatus?: ContractResponseDtoTaxInvoiceStatus;
  /**
   * 씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키다. NULL 이면 씨마켓에 발행 대상이 없는 계약(미연동 계정이거나 등록 실패).
   * @nullable
   */
  taxInvoiceTargetId?: ContractResponseDtoTaxInvoiceTargetId;
}

/**
 * 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. 미전달 시 미상(NULL)으로 저장된다.
 */
export type CreateContractRequestDtoPaymentChannel =
  (typeof CreateContractRequestDtoPaymentChannel)[keyof typeof CreateContractRequestDtoPaymentChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateContractRequestDtoPaymentChannel = {
  cash: "cash",
  card: "card",
} as const;

export interface CreateContractRequestDto {
  /** 결제 거래 ID (MOID). 직접 결제 시 생략 가능. */
  paymentTransactionId?: string;
  /** 견적 응답 버전 ID */
  quoteResponseVersionId: string;
  /** 총 금액 */
  totalAmount: number;
  /** 세금 (선택사항) */
  taxAmount?: number;
  /** 계약 항목 */
  items: QuoteItemDto[];
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. 미전달 시 미상(NULL)으로 저장된다. */
  paymentChannel?: CreateContractRequestDtoPaymentChannel;
}

export interface ContractCardPaymentStatusResponseDto {
  /** 씨마켓 카드결제 가맹 가입 안내를 띄워야 하는가. 씨마켓 결제창으로 받아야 하는 카드 계약인데 공급사가 아직 가맹이 아닐 때만 true. 세모 안심결제 계약·현금 계약·판정할 수 없는 경우는 false. */
  cmarketCardSignupRequired: boolean;
}

/**
 * 이 송장의 배송 상태
 */
export type ContractShipmentParcelDtoDeliveryStatus =
  (typeof ContractShipmentParcelDtoDeliveryStatus)[keyof typeof ContractShipmentParcelDtoDeliveryStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractShipmentParcelDtoDeliveryStatus = {
  READY: "READY",
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  EXCEPTION: "EXCEPTION",
  RETURNED: "RETURNED",
  CANCELED: "CANCELED",
} as const;

export interface ContractShipmentParcelDto {
  /** 이 발송 안 송장 순번(1부터) */
  seq: number;
  trackingNo: string;
  /** @nullable */
  trackingUrl: string | null;
  /** 이 송장의 배송 상태 */
  deliveryStatus: ContractShipmentParcelDtoDeliveryStatus;
  /** @nullable */
  deliveredAt: string | null;
}

export interface ContractShipmentItemDto {
  itemIndex: number;
  /** @nullable */
  itemName: string | null;
  /** @nullable */
  unit: string | null;
  quantity: number;
  /**
   * 카탈로그 품목 id(있을 때만)
   * @nullable
   */
  itemId: string | null;
}

export interface ContractShipmentTrackingEventDto {
  /** @nullable */
  at: string | null;
  /**
   * 위치(집화점·터미널 등)
   * @nullable
   */
  where: string | null;
  /**
   * 처리 내용
   * @nullable
   */
  kind: string | null;
  /**
   * 스마트택배 단계 1~6
   * @nullable
   */
  level: number | null;
}

/**
 * 신고 종류(파손 · 수량 누락 · 오배송 · 미수령 · 기타)
 */
export type ContractShipmentDisputeDtoCode =
  (typeof ContractShipmentDisputeDtoCode)[keyof typeof ContractShipmentDisputeDtoCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractShipmentDisputeDtoCode = {
  DAMAGED: "DAMAGED",
  MISSING_ITEMS: "MISSING_ITEMS",
  WRONG_ITEM: "WRONG_ITEM",
  NOT_RECEIVED: "NOT_RECEIVED",
  OTHER: "OTHER",
} as const;

export interface ContractShipmentDisputeDto {
  /** 신고 종류(파손 · 수량 누락 · 오배송 · 미수령 · 기타) */
  code: ContractShipmentDisputeDtoCode;
  /**
   * 발주기관이 적은 신고 내용
   * @nullable
   */
  note: string | null;
  /** 신고 시각 */
  at: string;
}

export interface ContractShipmentDeliveryProofDto {
  /** 공급사가 적은 건넨 일시 */
  handedAt: string;
  /** 받은 분(인수자) 이름 */
  receiverName: string;
  /** @nullable */
  receiverDept: string | null;
  /** @nullable */
  note: string | null;
}

/**
 * 옛 화면 호환용 3값. 배송 중·배달 출발·배송 예외는 `SHIPPED`, 반송은 `CANCELED`(발송량에서 빠진다)로 접힌다. 정확한 상태는 `deliveryStatus`.
 */
export type ContractShipmentDtoStatus =
  (typeof ContractShipmentDtoStatus)[keyof typeof ContractShipmentDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractShipmentDtoStatus = {
  SHIPPED: "SHIPPED",
  DELIVERED: "DELIVERED",
  CANCELED: "CANCELED",
} as const;

/**
 * 배송 상태(정확한 값). 택배사 데이터와 공급사 수기 처리가 움직인다.
 */
export type ContractShipmentDtoDeliveryStatus =
  (typeof ContractShipmentDtoDeliveryStatus)[keyof typeof ContractShipmentDtoDeliveryStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractShipmentDtoDeliveryStatus = {
  READY: "READY",
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  EXCEPTION: "EXCEPTION",
  RETURNED: "RETURNED",
  CANCELED: "CANCELED",
} as const;

/**
 * 발주기관 수령 상태. 배송 완료 전 `NOT_DUE` → 대기 `AWAITING` → 확인 `RECEIVED` / 기한 경과 자동 확정 `AUTO_RECEIVED`. 받는 쪽이 문제를 신고하면 `DISPUTED`(자동 확정이 멈춘다).
 */
export type ContractShipmentDtoAcceptanceStatus =
  (typeof ContractShipmentDtoAcceptanceStatus)[keyof typeof ContractShipmentDtoAcceptanceStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractShipmentDtoAcceptanceStatus = {
  NOT_DUE: "NOT_DUE",
  AWAITING: "AWAITING",
  RECEIVED: "RECEIVED",
  AUTO_RECEIVED: "AUTO_RECEIVED",
  DISPUTED: "DISPUTED",
} as const;

/**
 * 배송 예외 종류(배송 상태가 `EXCEPTION` 일 때)
 * @nullable
 */
export type ContractShipmentDtoExceptionCode =
  | (typeof ContractShipmentDtoExceptionCode)[keyof typeof ContractShipmentDtoExceptionCode]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractShipmentDtoExceptionCode = {
  DELAYED: "DELAYED",
  ATTEMPT_FAILED: "ATTEMPT_FAILED",
  HELD: "HELD",
  DAMAGED: "DAMAGED",
  LOST: "LOST",
  OTHER: "OTHER",
} as const;

/**
 * 마지막 문제 신고 기록(없으면 null). 지금 신고 중인지는 `acceptanceStatus` 가 `DISPUTED` 인지로 안다
 * @nullable
 */
export type ContractShipmentDtoDispute = ContractShipmentDisputeDto | null;

/**
 * 공급사 «전달 완료 알리기» 증빙(인수자 이름 등). 그 경로로 기록한 송장에만 있다
 * @nullable
 */
export type ContractShipmentDtoDeliveryProof =
  ContractShipmentDeliveryProofDto | null;

export interface ContractShipmentDto {
  id: string;
  contractId: string;
  /** 계약 안 순번(1부터) */
  shipmentNo: number;
  /** @nullable */
  courierCode: string | null;
  /** @nullable */
  courierName: string | null;
  /** @nullable */
  trackingNo: string | null;
  /**
   * 택배사 조회 페이지 링크(코드·번호가 있을 때)
   * @nullable
   */
  trackingUrl: string | null;
  /** 송장 전부(상자마다). 첫 송장 = trackingNo. 발송이 «도착» 이 되려면 모두 도착해야 한다 */
  trackingNumbers: ContractShipmentParcelDto[];
  /** 옛 화면 호환용 3값. 배송 중·배달 출발·배송 예외는 `SHIPPED`, 반송은 `CANCELED`(발송량에서 빠진다)로 접힌다. 정확한 상태는 `deliveryStatus`. */
  status: ContractShipmentDtoStatus;
  shippedAt: string;
  /** @nullable */
  deliveredAt: string | null;
  /**
   * 발주기관 수령 확인 시각
   * @nullable
   */
  receivedAt: string | null;
  /** @nullable */
  note: string | null;
  items: ContractShipmentItemDto[];
  createdAt: string;
  /**
   * 택배 조회 단계 1 준비중·2 집화·3 배송중·4 지점도착·5 배달출발·6 완료. 조회 전이면 null
   * @nullable
   */
  trackingLevel: number | null;
  /**
   * 단계 문구(«배송중» 등). 조회 전이면 null
   * @nullable
   */
  trackingLabel: string | null;
  /** 조회 이벤트(시간순) */
  trackingEvents: ContractShipmentTrackingEventDto[];
  /**
   * 마지막 조회 시도 시각
   * @nullable
   */
  lastSyncedAt: string | null;
  /**
   * 마지막 조회 실패 사유(한도 초과 등). 성공이면 null
   * @nullable
   */
  syncError: string | null;
  /** 배송 상태(정확한 값). 택배사 데이터와 공급사 수기 처리가 움직인다. */
  deliveryStatus: ContractShipmentDtoDeliveryStatus;
  /** 발주기관 수령 상태. 배송 완료 전 `NOT_DUE` → 대기 `AWAITING` → 확인 `RECEIVED` / 기한 경과 자동 확정 `AUTO_RECEIVED`. 받는 쪽이 문제를 신고하면 `DISPUTED`(자동 확정이 멈춘다). */
  acceptanceStatus: ContractShipmentDtoAcceptanceStatus;
  /**
   * 배송 예외 종류(배송 상태가 `EXCEPTION` 일 때)
   * @nullable
   */
  exceptionCode: ContractShipmentDtoExceptionCode;
  /**
   * 이 시각이 지나도 수령 확인이 없으면 자동 확정된다(배송 완료 후 대기 중일 때)
   * @nullable
   */
  autoReceiveAt: string | null;
  /**
   * 마지막 문제 신고 기록(없으면 null). 지금 신고 중인지는 `acceptanceStatus` 가 `DISPUTED` 인지로 안다
   * @nullable
   */
  dispute: ContractShipmentDtoDispute;
  /** 송장 버전(낙관적 잠금용) */
  version: number;
  /** 사람이 봐야 하는 송장인가(배송 예외 · 조회 종료 · 조회 실패 · 문제 신고 중) */
  needsAttention: boolean;
  /** 택배사가 도착을 알려 주는 송장인가(송장번호 · 활성 택배사 · 조회 제공사 지원). false 면 공급사가 «전달 완료 알리기» 를 쓴다 */
  autoTracked: boolean;
  /**
   * 도착(DELIVERED)을 기록한 주체 — POLL·WEBHOOK 택배사 · SUPPLIER 공급사 알림 · BUYER·INSPECTION 기관 · ADMIN·SYSTEM 운영
   * @nullable
   */
  deliveredSource: string | null;
  /**
   * 수령 확인 출처(BUYER · AUTO · ADMIN · INSPECTION)
   * @nullable
   */
  receivedSource: string | null;
  /**
   * 등록 취소 사유(취소된 송장만)
   * @nullable
   */
  cancelReason: string | null;
  /**
   * 등록 취소 시각(취소된 송장만)
   * @nullable
   */
  canceledAt: string | null;
  /**
   * 공급사 «전달 완료 알리기» 증빙(인수자 이름 등). 그 경로로 기록한 송장에만 있다
   * @nullable
   */
  deliveryProof: ContractShipmentDtoDeliveryProof;
}

export interface ContractShipmentProgressDto {
  itemIndex: number;
  name: string;
  unit: string;
  /** 계약 수량 */
  quantity: number;
  /** 누적 발송(취소분 제외) */
  shipped: number;
  /** 남은 수량 */
  remaining: number;
}

export interface ContractShipmentListDto {
  shipments: ContractShipmentDto[];
  progress: ContractShipmentProgressDto[];
  /** 모든 품목이 계약 수량만큼 발송됐는가 */
  allShipped: boolean;
  /** 모든 발송이 배송 완료(수령 확인 포함)됐는가 */
  allDelivered: boolean;
  /** 택배 자동 조회(스마트택배)가 켜져 있는가. 꺼져 있으면 링크·수기 상태만 */
  trackingAvailable: boolean;
}

export interface ReceiveContractShipmentDto {
  /**
   * 수령 확인 사유 — 택배 조회 중인 송장을 도착 전에 확인할 때 필요하다(서버 규칙은 SHIPPING_REASON_RULES 가 켜진 뒤 적용: 없으면 SHIPMENT_REASON_REQUIRED). 앞뒤 공백은 뗀다.
   * @maxLength 500
   */
  reason?: string;
}

export interface CompleteContractRequestDto {
  /** 좋은 점 태그 (최대 6개) */
  positiveAspects: string[];
  /** 아쉬운 점 태그 (최대 4개) */
  negativeAspects?: string[];
  /**
   * 상세 후기 (최소 10자)
   * @minLength 10
   */
  detailedReview: string;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
}

export interface CancelContractRequestDto {
  /**
   * 계약 취소 사유 (canonical). reason 또는 refund_reason 중 최소 하나는 필수.
   * @minLength 1
   */
  reason?: string;
  /**
   * [Deprecated] 취소 사유의 구버전 필드명. reason 필드로 마이그레이션 예정. reason이 없을 때만 fallback으로 사용됨.
   * @deprecated
   * @minLength 1
   */
  refund_reason?: string;
  /** 환불 받을 은행명 (현금 결제 & 발주기관 요청 시에만 유효) */
  refund_bank?: string;
  /** 환불 받을 계좌번호 (현금 결제 시 필수) */
  refund_account_number?: string;
  /** 환불 계좌 예금주 (현금 결제 시 필수) */
  refund_account_holder?: string;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
}

/**
 * 매칭 출처(설계도 「견적 물품 매칭 엔진」). suggest=엔진 후보를 골랐다 · manual=자동완성/직접 검색 · auto=자동 부착을 그대로 뒀다. itemId 가 있을 때만 뜻이 있다.
 */
export type CreateQuoteRequestItemDtoMatchSource =
  (typeof CreateQuoteRequestItemDtoMatchSource)[keyof typeof CreateQuoteRequestItemDtoMatchSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuoteRequestItemDtoMatchSource = {
  suggest: "suggest",
  manual: "manual",
  auto: "auto",
} as const;

export interface CreateQuoteRequestItemDto {
  /** 품목명 */
  name: string;
  /**
   * 수량
   * @minimum 1
   */
  quantity: number;
  /** 단위 (예: 세트, EA, 박스) */
  unit: string;
  /**
   * 금액 (원 단위, 예상 금액 또는 0)
   * @minimum 0
   */
  amount: number;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 품목 코드 */
  itemCode?: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 품목 ID (items_v2_base.id) - 자동완성 선택 시에만 제공 */
  itemId?: string;
  /** 매칭 출처(설계도 「견적 물품 매칭 엔진」). suggest=엔진 후보를 골랐다 · manual=자동완성/직접 검색 · auto=자동 부착을 그대로 뒀다. itemId 가 있을 때만 뜻이 있다. */
  matchSource?: CreateQuoteRequestItemDtoMatchSource;
  /** 엔진 확신도(0~0.98). 화면이 받은 값을 그대로 돌려보낸다. */
  matchConfidence?: number;
}

export interface LabelValuePair {
  /** English code identifier */
  value: string;
  /** Korean UI label for display */
  label: string;
}

/**
 * Construction type code
 */
export type ConstructionTypeLabelValueValue =
  (typeof ConstructionTypeLabelValueValue)[keyof typeof ConstructionTypeLabelValueValue];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionTypeLabelValueValue = {
  facility_maintenance: "facility_maintenance",
  interior_architecture: "interior_architecture",
  waterproofing_plaster_painting: "waterproofing_plaster_painting",
  mechanical_equipment: "mechanical_equipment",
  metal_structure_window: "metal_structure_window",
  paving: "paving",
  electrical: "electrical",
  scaffolding_demolition: "scaffolding_demolition",
  asbestos_removal: "asbestos_removal",
  rebar_concrete: "rebar_concrete",
  fire_safety: "fire_safety",
  landscaping: "landscaping",
  roofing_assembly: "roofing_assembly",
  elevator: "elevator",
  gas_facility: "gas_facility",
  hvac: "hvac",
  telecommunications: "telecommunications",
  cctv: "cctv",
  "365_corner": "365_corner",
  civil_construction: "civil_construction",
  building_construction: "building_construction",
  specialized_construction: "specialized_construction",
  water_sewage: "water_sewage",
  stone_work: "stone_work",
  earthwork: "earthwork",
  grouting: "grouting",
  dredging: "dredging",
  outdoor_signage: "outdoor_signage",
  other: "other",
} as const;

export interface ConstructionTypeLabelValue {
  /** Construction type code */
  value: ConstructionTypeLabelValueValue;
  /** Korean label for display */
  label: string;
}

/**
 * Space type code
 */
export type SpaceTypeLabelValueValue =
  (typeof SpaceTypeLabelValueValue)[keyof typeof SpaceTypeLabelValueValue];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SpaceTypeLabelValueValue = {
  office: "office",
  retail: "retail",
  factory: "factory",
  warehouse: "warehouse",
} as const;

export interface SpaceTypeLabelValue {
  /** Space type code */
  value: SpaceTypeLabelValueValue;
  /** Korean label for display */
  label: string;
}

/**
 * Construction area code
 */
export type ConstructionAreaLabelValueValue =
  (typeof ConstructionAreaLabelValueValue)[keyof typeof ConstructionAreaLabelValueValue];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionAreaLabelValueValue = {
  NUMBER_30: "30",
  NUMBER_50: "50",
  NUMBER_100: "100",
  NUMBER_200: "200",
} as const;

export interface ConstructionAreaLabelValue {
  /** Construction area code */
  value: ConstructionAreaLabelValueValue;
  /** Korean label for display */
  label: string;
}

/**
 * 단가 출처 — G2B_WORK(조달청 공종 단가)·G2B_MATERIAL(조달청 자재 가격)
 * @nullable
 */
export type QuoteRequestBoqLineDtoPriceSource =
  | (typeof QuoteRequestBoqLineDtoPriceSource)[keyof typeof QuoteRequestBoqLineDtoPriceSource]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestBoqLineDtoPriceSource = {
  G2B_WORK: "G2B_WORK",
  G2B_MATERIAL: "G2B_MATERIAL",
} as const;

/**
 * 줄 출처 — TEMPLATE(표준 내역서)·DOCUMENT(올린 파일 분석)·MANUAL(직접 입력)·AI(내역서 초안)·RULE(규칙 초안 — 고객 설명 속 수량)
 * @nullable
 */
export type QuoteRequestBoqLineDtoOrigin =
  | (typeof QuoteRequestBoqLineDtoOrigin)[keyof typeof QuoteRequestBoqLineDtoOrigin]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestBoqLineDtoOrigin = {
  TEMPLATE: "TEMPLATE",
  DOCUMENT: "DOCUMENT",
  MANUAL: "MANUAL",
  AI: "AI",
  RULE: "RULE",
} as const;

export interface QuoteRequestBoqLineDto {
  /**
   * 공종·구분(내역서 머리글). 예: 철근콘크리트공사
   * @maxLength 100
   * @nullable
   */
  section?: string | null;
  /**
   * 품명·공종명 (필수, 1~300자)
   * @minLength 1
   * @maxLength 300
   */
  name: string;
  /**
   * 규격
   * @maxLength 500
   * @nullable
   */
  spec?: string | null;
  /**
   * 단위. 예: m3, 식, 인
   * @maxLength 30
   * @nullable
   */
  unit?: string | null;
  /**
   * 수량 (0 이상). 비워 두면 null
   * @minimum 0
   * @maximum 1000000000
   * @nullable
   */
  quantity?: number | null;
  /**
   * 단가 출처 — G2B_WORK(조달청 공종 단가)·G2B_MATERIAL(조달청 자재 가격)
   * @nullable
   */
  priceSource?: QuoteRequestBoqLineDtoPriceSource;
  /**
   * 조달청 원장 코드 (priceSource 와 짝)
   * @maxLength 40
   * @nullable
   */
  priceCode?: string | null;
  /**
   * 조달청 원장 합계 단가 참고값(원, 0 이상). 공급사 응찰가가 아니라 참고용이다
   * @minimum 0
   * @nullable
   */
  referenceUnitPrice?: number | null;
  /**
   * 줄 출처 — TEMPLATE(표준 내역서)·DOCUMENT(올린 파일 분석)·MANUAL(직접 입력)·AI(내역서 초안)·RULE(규칙 초안 — 고객 설명 속 수량)
   * @nullable
   */
  origin?: QuoteRequestBoqLineDtoOrigin;
  /**
   * 근거 — 수량을 정한 고객 입력 원문 인용(예: «시공 평수: 15평») 또는 «첨부 ‘파일명’». 300자 이하
   * @maxLength 300
   * @nullable
   */
  basis?: string | null;
  /** 확인 필요 — 수량을 정하지 못한 AI·표준 내역서 줄이면 true. 비우면 false */
  needsReview?: boolean;
}

/**
 * USER=구매자가 답함 · GUESS=시스템이 채움(확인 필요) · EMPTY=비어 있음(업체가 확인)
 */
export type QuoteRequestServiceSowSectionDtoSource =
  (typeof QuoteRequestServiceSowSectionDtoSource)[keyof typeof QuoteRequestServiceSowSectionDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestServiceSowSectionDtoSource = {
  USER: "USER",
  GUESS: "GUESS",
  EMPTY: "EMPTY",
} as const;

export interface QuoteRequestServiceSowSectionDto {
  /**
   * 항목 키(scope·period …)
   * @maxLength 40
   */
  key: string;
  /**
   * 항목 제목(과업 범위 …)
   * @maxLength 40
   */
  title: string;
  /**
   * 항목 내용 — 비어 있으면 EMPTY
   * @maxLength 1000
   */
  body: string;
  /** USER=구매자가 답함 · GUESS=시스템이 채움(확인 필요) · EMPTY=비어 있음(업체가 확인) */
  source: QuoteRequestServiceSowSectionDtoSource;
}

export interface QuoteRequestServiceSowDto {
  /**
   * 용역 유형 이름(boqWorkType 과 같은 값)
   * @maxLength 60
   * @nullable
   */
  serviceType?: string | null;
  sections: QuoteRequestServiceSowSectionDto[];
}

/**
 * 카테고리 타입
 */
export type CreateQuoteRequestDtoCategoryType =
  (typeof CreateQuoteRequestDtoCategoryType)[keyof typeof CreateQuoteRequestDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuoteRequestDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 예산 타입
 * @nullable
 */
export type CreateQuoteRequestDtoBudgetType =
  | (typeof CreateQuoteRequestDtoBudgetType)[keyof typeof CreateQuoteRequestDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuoteRequestDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type CreateQuoteRequestDtoPaymentMethod =
  (typeof CreateQuoteRequestDtoPaymentMethod)[keyof typeof CreateQuoteRequestDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuoteRequestDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다.
 */
export type CreateQuoteRequestDtoPreferredPaymentChannel =
  (typeof CreateQuoteRequestDtoPreferredPaymentChannel)[keyof typeof CreateQuoteRequestDtoPreferredPaymentChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuoteRequestDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 배송일 값 (사용자 입력값)
 * @nullable
 */
export type CreateQuoteRequestDtoDueDateValue =
  | (typeof CreateQuoteRequestDtoDueDateValue)[keyof typeof CreateQuoteRequestDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuoteRequestDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

/**
 * 공사 타입 (공사 카테고리 전용)
 * @nullable
 */
export type CreateQuoteRequestDtoConstructionType =
  ConstructionTypeLabelValue | null;

/**
 * 공간 타입 (공사 카테고리 전용)
 * @nullable
 */
export type CreateQuoteRequestDtoSpaceType = SpaceTypeLabelValue | null;

/**
 * 공사 면적 (공사 카테고리 전용)
 * @nullable
 */
export type CreateQuoteRequestDtoConstructionArea =
  ConstructionAreaLabelValue | null;

/**
 * 과업지시서 초안 (용역 전용). 항목마다 출처 USER(답함)·GUESS(시스템이 채움)·EMPTY(비어 있음)
 * @nullable
 */
export type CreateQuoteRequestDtoServiceSow = QuoteRequestServiceSowDto | null;

export interface CreateQuoteRequestDto {
  /** 프로젝트명 (물품 구매(product) 카테고리는 선택 — 미입력 시 물품 목록으로 자동 생성, 그 외 카테고리는 필수) */
  projectName?: string;
  /** 카테고리 타입 */
  categoryType: CreateQuoteRequestDtoCategoryType;
  /** 담당자 연락처 (필수) */
  managerContact: string;
  /** 담당자명 */
  managerName: string;
  /** 주소 ID (addresses 테이블 외래키) */
  addressId: string;
  /**
   * 주소 상세정보 (예: 동 101호, 3층 등의 추가 정보)
   * @nullable
   */
  addressDetail?: string | null;
  /**
   * 견적 요청 설명 및 추가 사항
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: CreateQuoteRequestDtoBudgetType;
  /**
   * 예산 금액 (원화)
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod?: CreateQuoteRequestDtoPaymentMethod;
  /** 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다. */
  preferredPaymentChannel?: CreateQuoteRequestDtoPreferredPaymentChannel;
  /**
   * 동일 지역만 선택 여부
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /** 바로 업체 찾기로 등록 — 6곳 방은 등록 직후 auto-match/start 가 연다(등록 이벤트의 자동 매칭은 건너뜀) */
  quickMatch?: boolean;
  /**
   * 배송일 값 (사용자 입력값)
   * @nullable
   */
  dueDateValue?: CreateQuoteRequestDtoDueDateValue;
  /**
   * 배송일 (ISO 8601 형식)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 업로드된 파일들의 메타데이터 배열
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /**
   * 항목 목록 (Product 카테고리에만 필수)
   * @nullable
   */
  items?: CreateQuoteRequestItemDto[] | null;
  /**
   * 추가 조건 (물품 구매 카테고리 전용)
   * @nullable
   */
  additionalConditions?: LabelValuePair[] | null;
  /**
   * 추가 요청사항 (모든 카테고리 선택 가능)
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
  /**
   * 공사 타입 (공사 카테고리 전용)
   * @nullable
   */
  constructionType?: CreateQuoteRequestDtoConstructionType;
  /**
   * 공간 타입 (공사 카테고리 전용)
   * @nullable
   */
  spaceType?: CreateQuoteRequestDtoSpaceType;
  /**
   * 공사 면적 (공사 카테고리 전용)
   * @nullable
   */
  constructionArea?: CreateQuoteRequestDtoConstructionArea;
  /**
   * 표준 내역서 줄 (공사·용역 카테고리 전용, 최대 500줄). items 와 별개로 저장되며 물품 매칭·알림 대상이 아니다
   * @nullable
   */
  boqLines?: QuoteRequestBoqLineDto[] | null;
  /**
   * 내역서 종목 키 (공사·용역 카테고리 전용). 공사는 종목 enum 값, 용역은 유형 이름 — GET /cost-estimate/work-types 의 type
   * @maxLength 60
   * @nullable
   */
  boqWorkType?: string | null;
  /**
   * 과업지시서 초안 (용역 전용). 항목마다 출처 USER(답함)·GUESS(시스템이 채움)·EMPTY(비어 있음)
   * @nullable
   */
  serviceSow?: CreateQuoteRequestDtoServiceSow;
  /**
   * 용역 유형 이름 (용역 전용) — GET /cost-estimate/work-types 의 용역 type. 업체 매칭이 이 값으로 자격을 고른다
   * @maxLength 50
   * @nullable
   */
  serviceType?: string | null;
}

export interface QuoteRequestSimpleAddressDto {
  /** 시/도 */
  province: string;
  /** 시/군/구 */
  city: string;
  /**
   * 읍/면/동
   * @nullable
   */
  district?: string | null;
  /**
   * 우편번호 (작성자 본인만)
   * @nullable
   */
  postalCode?: string | null;
  /**
   * 기본주소 (작성자 본인만)
   * @nullable
   */
  addressLine1?: string | null;
  /**
   * 상세주소 (작성자 본인만)
   * @nullable
   */
  addressLine2?: string | null;
  /**
   * 수령인 (작성자 본인만)
   * @nullable
   */
  recipientName?: string | null;
}

/**
 * 상태
 */
export type QuoteRequestListItemDtoStatus =
  (typeof QuoteRequestListItemDtoStatus)[keyof typeof QuoteRequestListItemDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestListItemDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

/**
 * 카테고리 타입
 */
export type QuoteRequestListItemDtoCategoryType =
  (typeof QuoteRequestListItemDtoCategoryType)[keyof typeof QuoteRequestListItemDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestListItemDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 지역 정보
 * @nullable
 */
export type QuoteRequestListItemDtoAddress =
  QuoteRequestSimpleAddressDto | null;

/**
 * 예산 타입
 * @nullable
 */
export type QuoteRequestListItemDtoBudgetType =
  | (typeof QuoteRequestListItemDtoBudgetType)[keyof typeof QuoteRequestListItemDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestListItemDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type QuoteRequestListItemDtoPaymentMethod =
  (typeof QuoteRequestListItemDtoPaymentMethod)[keyof typeof QuoteRequestListItemDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestListItemDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
 * @nullable
 */
export type QuoteRequestListItemDtoPreferredPaymentChannel =
  | (typeof QuoteRequestListItemDtoPreferredPaymentChannel)[keyof typeof QuoteRequestListItemDtoPreferredPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestListItemDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 배송일 (구체적/협의가능)
 * @nullable
 */
export type QuoteRequestListItemDtoDueDateValue =
  | (typeof QuoteRequestListItemDtoDueDateValue)[keyof typeof QuoteRequestListItemDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestListItemDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

/**
 * 공사 유형
 * @nullable
 */
export type QuoteRequestListItemDtoConstructionType =
  ConstructionTypeLabelValue | null;

/**
 * 공간 유형
 * @nullable
 */
export type QuoteRequestListItemDtoSpaceType = SpaceTypeLabelValue | null;

/**
 * 공사 면적
 * @nullable
 */
export type QuoteRequestListItemDtoConstructionArea =
  ConstructionAreaLabelValue | null;

export interface QuoteRequestListItemDto {
  /** 견적 요청 ID (UUID) */
  id: string;
  /** 견적 요청 번호 */
  requestNumber: string;
  /** 프로젝트명 */
  projectName: string;
  /**
   * 발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)
   * @nullable
   */
  organizationName?: string | null;
  /** 상태 */
  status: QuoteRequestListItemDtoStatus;
  /** 카테고리 타입 */
  categoryType: QuoteRequestListItemDtoCategoryType;
  /** 마감일시 (ISO 8601). 신규 등록은 한국시간 18:00 고정. */
  deadline: string;
  /**
   * 생성일 (ISO 8601)
   * @nullable
   */
  createdAt?: string | null;
  /**
   * 수정일 (ISO 8601)
   * @nullable
   */
  updatedAt?: string | null;
  /** 사용자 ID (UUID) */
  userId: string;
  /**
   * 담당자명
   * @nullable
   */
  managerName?: string | null;
  /**
   * 담당자 연락처
   * @nullable
   */
  managerContact?: string | null;
  /**
   * 주소 ID
   * @nullable
   */
  addressId?: string | null;
  /**
   * 지역 정보
   * @nullable
   */
  address?: QuoteRequestListItemDtoAddress;
  /**
   * 동일 지역만
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: QuoteRequestListItemDtoBudgetType;
  /**
   * 예산 금액
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod: QuoteRequestListItemDtoPaymentMethod;
  /** 결제 방법 (boolean form). true=선결제, false=후불결제. */
  isPrepaid: boolean;
  /**
   * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
   * @nullable
   */
  preferredPaymentChannel: QuoteRequestListItemDtoPreferredPaymentChannel;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /**
   * 배송일 (구체적/협의가능)
   * @nullable
   */
  dueDateValue?: QuoteRequestListItemDtoDueDateValue;
  /**
   * 희망 배송일 (ISO 8601)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 공사 유형
   * @nullable
   */
  constructionType?: QuoteRequestListItemDtoConstructionType;
  /**
   * 공간 유형
   * @nullable
   */
  spaceType?: QuoteRequestListItemDtoSpaceType;
  /**
   * 공사 면적
   * @nullable
   */
  constructionArea?: QuoteRequestListItemDtoConstructionArea;
  /** 받은 견적 응답 개수 */
  responseCount: number;
  /**
   * 현재 판매자의 응답 여부
   * @nullable
   */
  hasResponded?: boolean | null;
  /** 판매자가 작성한 견적 응답 ID */
  quoteResponseId?: string;
  /** 자동 견적 가능 여부 (공급자 전용) */
  canAutoQuote?: boolean;
  /** 이 공급사가 맞춤 업체로 골라진 요청인가(공급자 전용) — 공고 등록 알림을 받았거나 공사·용역 자동 매칭 방에 들어갔다. 공고함 «맞춤» 탭의 근거. */
  matchedForMe?: boolean;
  /**
   * 현재 판매자 본인의 비취소 계약 존재 여부 (공급자 전용). 견적요청 단위 status=CONTRACT_IN_PROGRESS 와 달리 타사 계약에는 켜지지 않는다. null=판정 불가(발주기관 조회 등).
   * @nullable
   */
  hasMyContract?: boolean | null;
  /** 자동 구매 흐름 «연결 건»이면 true. 연결 건이 아니거나 기능이 꺼져 있으면(기본) 이 칸 자체가 없다. */
  isProcureLink?: true;
}

export interface QuoteResponseSummaryDto {
  /** 견적 응답 ID */
  id: string;
  /** 공급자명 */
  supplierName: string;
  /** 공급자 ID (세모 내부 UUID) */
  supplierId: string;
  /**
   * 씨마켓 공급사 회원 ID. 익명화 대상이거나 씨마켓 회원이 아니면 null
   * @nullable
   */
  supplierMemberId: string | null;
  /** 견적 금액 */
  totalAmount: number;
  /** 공급자 신뢰 점수 */
  trustScore: number;
  /**
   * 공급자 신뢰 백분위
   * @nullable
   */
  trustPercentile?: number | null;
  /**
   * 채팅방 ID
   * @nullable
   */
  chatRoomId: string | null;
  /** 익명 여부 (블러 처리 필요) */
  isAnonymous: boolean;
  /** 계약 여부 (채팅방 기준) */
  isContracted: boolean;
  /** 공급사 첨부. URL 은 1시간 서명. 익명화 대상이면 빈 배열 */
  attachments: AttachmentMetadataDto[];
  /**
   * 납기 — 발주 후 N일 (0 = 발주 즉시). 최신 버전 기준, 미기재면 null (설계도 09)
   * @nullable
   */
  deliveryDays?: number | null;
  /**
   * 견적 유효기간 YYYY-MM-DD. 최신 버전 기준, 미기재면 null (설계도 09)
   * @nullable
   */
  validUntil?: string | null;
  /** 생성일 */
  createdAt: string;
}

/**
 * 계약 상태
 */
export type QuoteRequestContractSummaryDtoStatus =
  (typeof QuoteRequestContractSummaryDtoStatus)[keyof typeof QuoteRequestContractSummaryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestContractSummaryDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
} as const;

/**
 * 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.
 * @nullable
 */
export type QuoteRequestContractSummaryDtoPaymentChannel =
  | (typeof QuoteRequestContractSummaryDtoPaymentChannel)[keyof typeof QuoteRequestContractSummaryDtoPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestContractSummaryDtoPaymentChannel = {
  cash: "cash",
  card: "card",
} as const;

export interface QuoteRequestContractSummaryDto {
  /** 계약 ID (UUID) */
  id: string;
  /** 계약 번호 (UI 표시용) */
  contractNumber: string;
  /** 계약 상태 */
  status: QuoteRequestContractSummaryDtoStatus;
  /** 계약 취소 여부 */
  isCanceled: boolean;
  /**
   * 계약 취소 요청 일시 (ISO 8601)
   * @nullable
   */
  cancellationRequestedAt?: string | null;
  /**
   * 계약 취소 완료 일시 (ISO 8601)
   * @nullable
   */
  canceledAt?: string | null;
  /**
   * 계약 취소 사유
   * @nullable
   */
  cancellationReason?: string | null;
  /** 계약 공급사 ID (UUID) */
  supplierId: string;
  /**
   * 계약 공급사 상호. 씨마켓 «계약 업체» 칸이 그리는 값 — 참여 업체 목록과 짝맞추지 않아도 되도록 여기서 함께 내려보낸다.
   * @nullable
   */
  supplierName?: string | null;
  /**
   * 이 계약이 선 견적 응답 **버전** id. 씨마켓이 이 계약의 결제창을 되짚는 유일한 키다 — 결제창 발행 시 이 값을 멱등키로 보냈고, 씨마켓은 그 값으로 계약 ↔ 결제창을 1:1 로 묶어 두었다.
   * @nullable
   */
  quoteResponseVersionId?: string | null;
  /**
   * 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.
   * @nullable
   */
  paymentChannel?: QuoteRequestContractSummaryDtoPaymentChannel;
  /** 계약 생성 일시 (ISO 8601) */
  createdAt: string;
}

export interface QuoteRequestChatRoomSummaryDto {
  /** 채팅방 ID (UUID) */
  id: string;
  /** 공급사 ID (세모 내부 UUID) */
  supplierId: string;
  /**
   * 공급사 상호. 자동 연결 방은 계약 전에도 회사명이 보이고, 그 밖의 방은 참여 목록과 같은 익명화 규칙을 따른다
   * @nullable
   */
  supplierName?: string | null;
  /** 방 종류 — 'auto_match'=세모 자동 연결(견적 없이 열린 방), 'quote_discussion'=견적 상담 방. 다른 값이 더해질 수 있다 */
  roomType: string;
  /** 이 방에 견적이 연결돼 있는지(quote_response_id 존재). 자동 연결 방은 업체가 견적을 보내기 전까지 false */
  hasQuote: boolean;
  /**
   * 마지막 메시지 일시 (ISO 8601). 대화가 없으면 null
   * @nullable
   */
  lastMessageAt?: string | null;
  /**
   * 방 생성 일시 (ISO 8601)
   * @nullable
   */
  createdAt?: string | null;
}

/**
 * 줄의 종류(매칭 엔진). product=물품(매칭 대상) · service · manufacturing · disposal · attachment_ref · unclear. 없으면 product.
 */
export type QuoteRequestItemResponseDtoKind =
  (typeof QuoteRequestItemResponseDtoKind)[keyof typeof QuoteRequestItemResponseDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestItemResponseDtoKind = {
  product: "product",
  service: "service",
  manufacturing: "manufacturing",
  disposal: "disposal",
  attachment_ref: "attachment_ref",
  unclear: "unclear",
} as const;

export interface QuoteRequestItemResponseDto {
  /** 품목명 */
  name: string;
  /** 수량 */
  quantity: number;
  /** 단위 */
  unit: string;
  /** 금액 */
  amount: number;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 품목 코드 */
  itemCode?: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 품목 ID */
  itemId?: string;
  /** 매칭된 표준 품목명 */
  itemName?: string;
  /** 매칭된 표준 품목 코드 */
  itemCodeMatch?: string;
  /** 매칭된 표준 품목 단가 */
  itemPrice?: number;
  /** 매칭된 표준 품목 이미지 URL */
  itemImageUrl?: string;
  /** 매칭된 표준 품목 규격 요약 */
  itemSpec?: string;
  /** 줄의 종류(매칭 엔진). product=물품(매칭 대상) · service · manufacturing · disposal · attachment_ref · unclear. 없으면 product. */
  kind?: QuoteRequestItemResponseDtoKind;
  /** 매칭 출처: suggest · manual · auto:alias · auto:code · auto:score · register */
  matchSource?: string;
  /** 매칭 확신도(엔진, 0~0.98) */
  matchConfidence?: number;
  /** 매칭 시각(ISO) */
  matchedAt?: string;
}

/**
 * 상태
 */
export type ProductQuoteRequestDetailDtoStatus =
  (typeof ProductQuoteRequestDetailDtoStatus)[keyof typeof ProductQuoteRequestDetailDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductQuoteRequestDetailDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

/**
 * 카테고리 타입
 */
export type ProductQuoteRequestDetailDtoCategoryType =
  (typeof ProductQuoteRequestDetailDtoCategoryType)[keyof typeof ProductQuoteRequestDetailDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductQuoteRequestDetailDtoCategoryType = {
  product: "product",
} as const;

/**
 * 주소 정보
 * @nullable
 */
export type ProductQuoteRequestDetailDtoAddress =
  QuoteRequestSimpleAddressDto | null;

/**
 * 예산 타입
 * @nullable
 */
export type ProductQuoteRequestDetailDtoBudgetType =
  | (typeof ProductQuoteRequestDetailDtoBudgetType)[keyof typeof ProductQuoteRequestDetailDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductQuoteRequestDetailDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type ProductQuoteRequestDetailDtoPaymentMethod =
  (typeof ProductQuoteRequestDetailDtoPaymentMethod)[keyof typeof ProductQuoteRequestDetailDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductQuoteRequestDetailDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
 * @nullable
 */
export type ProductQuoteRequestDetailDtoPreferredPaymentChannel =
  | (typeof ProductQuoteRequestDetailDtoPreferredPaymentChannel)[keyof typeof ProductQuoteRequestDetailDtoPreferredPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductQuoteRequestDetailDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 스마트 견적 생성 상태
 */
export type ProductQuoteRequestDetailDtoAutoQuoteStatus =
  (typeof ProductQuoteRequestDetailDtoAutoQuoteStatus)[keyof typeof ProductQuoteRequestDetailDtoAutoQuoteStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductQuoteRequestDetailDtoAutoQuoteStatus = {
  none: "none",
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed",
} as const;

/**
 * 배송일 (구체적/협의가능)
 * @nullable
 */
export type ProductQuoteRequestDetailDtoDueDateValue =
  | (typeof ProductQuoteRequestDetailDtoDueDateValue)[keyof typeof ProductQuoteRequestDetailDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductQuoteRequestDetailDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

/**
 * 용역 과업지시서 초안 (2026-10-08). 항목마다 출처(USER·GUESS·EMPTY). 용역 외·없으면 null
 * @nullable
 */
export type ProductQuoteRequestDetailDtoServiceSow =
  QuoteRequestServiceSowDto | null;

export interface ProductQuoteRequestDetailDto {
  /** 견적 요청 ID (UUID) */
  id: string;
  /** 견적 요청 번호 */
  requestNumber: string;
  /** 프로젝트명 */
  projectName: string;
  /** 사용자 ID (작성자) */
  userId: string;
  /** 현재 인증 사용자가 이 견적 요청의 등록자인지 여부 (클라이언트 소유권 판단용) */
  isOwner?: boolean;
  /** 상태 */
  status: ProductQuoteRequestDetailDtoStatus;
  /** 카테고리 타입 */
  categoryType: ProductQuoteRequestDetailDtoCategoryType;
  /**
   * 담당자명
   * @nullable
   */
  managerName?: string | null;
  /**
   * 담당자 연락처
   * @nullable
   */
  managerContact?: string | null;
  /**
   * 발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)
   * @nullable
   */
  organizationName?: string | null;
  /**
   * 발주기관 대표번호 (담당자 개인 휴대폰이 아니다. 공개 공고에서만, 비공개는 본인·어드민 외 null)
   * @nullable
   */
  organizationPhone?: string | null;
  /** 주소 ID */
  addressId: string;
  /**
   * 주소 정보
   * @nullable
   */
  address?: ProductQuoteRequestDetailDtoAddress;
  /**
   * 설명
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: ProductQuoteRequestDetailDtoBudgetType;
  /**
   * 예산 금액
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod: ProductQuoteRequestDetailDtoPaymentMethod;
  /** 결제 방법 (boolean form). true=선결제, false=후불결제. */
  isPrepaid: boolean;
  /**
   * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
   * @nullable
   */
  preferredPaymentChannel: ProductQuoteRequestDetailDtoPreferredPaymentChannel;
  /**
   * 동일 지역만
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /** 마감일시 (ISO 8601). 신규 등록은 한국시간 18:00 고정. */
  deadline: string;
  /**
   * 생성일 (ISO 8601)
   * @nullable
   */
  createdAt?: string | null;
  /**
   * 수정일 (ISO 8601)
   * @nullable
   */
  updatedAt?: string | null;
  /**
   * 승인 일시 (ISO 8601)
   * @nullable
   */
  approvedAt?: string | null;
  /**
   * 마감 일시 (ISO 8601)
   * @nullable
   */
  closedAt?: string | null;
  /**
   * 마감 사유
   * @nullable
   */
  closeReason?: string | null;
  /**
   * 보류 일시 (ISO 8601)
   * @nullable
   */
  onHoldAt?: string | null;
  /**
   * 첨부파일 목록
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /** 견적 응답 수 */
  responseCount: number;
  /** 견적 응답 목록 */
  responses: QuoteResponseSummaryDto[];
  /** 자동 견적 발송 여부 */
  willGenerateAutoQuotes: boolean;
  /** 스마트 견적 생성 상태 */
  autoQuoteStatus: ProductQuoteRequestDetailDtoAutoQuoteStatus;
  /** 현재 사용자에게 노출 가능한 연결 계약 목록 (external 상세에서 제공) */
  contracts: QuoteRequestContractSummaryDto[];
  /** 이 견적요청에 딸린 채팅방 목록 — 공고 주인(발주기관)·운영자에게만 실린다(공급사·다른 발주기관에게는 생략). 세모 자동 연결로 견적 없이 열린 방(roomType=auto_match)까지 담는다. 감춘·지운 방은 빠진다 */
  chatRooms?: QuoteRequestChatRoomSummaryDto[];
  /**
   * 배송일 (구체적/협의가능)
   * @nullable
   */
  dueDateValue?: ProductQuoteRequestDetailDtoDueDateValue;
  /**
   * 희망 배송일 (ISO 8601)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 추가 요청사항
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
  /**
   * 표준 내역서 줄 (공사·용역 전용). 없으면 null. items 와 별개 — 물품 매칭 대상 아님
   * @nullable
   */
  boqLines: QuoteRequestBoqLineDto[] | null;
  /**
   * 내역서 종목 키 — 공사는 종목 enum 값, 용역은 유형 이름(GET /cost-estimate/work-types 의 type). 없으면 null
   * @nullable
   */
  boqWorkType: string | null;
  /**
   * 용역 과업지시서 초안 (2026-10-08). 항목마다 출처(USER·GUESS·EMPTY). 용역 외·없으면 null
   * @nullable
   */
  serviceSow: ProductQuoteRequestDetailDtoServiceSow;
  /**
   * 용역 유형 (2026-10-17) — 고객이 등록 화면에서 고른 용역 유형 이름(GET /cost-estimate/work-types 의 용역 type). 용역 외·안 고름은 null
   * @nullable
   */
  serviceType: string | null;
  /** 물품 목록 */
  items: QuoteRequestItemResponseDto[];
  /**
   * 추가 조건
   * @nullable
   */
  additionalConditions?: LabelValuePair[] | null;
  /** 자동 구매 흐름 «연결 건»이면 true. 연결 건이 아니거나 기능이 꺼져 있으면(기본) 이 칸 자체가 없다. */
  isProcureLink?: true;
}

/**
 * 상태
 */
export type ConstructionQuoteRequestDetailDtoStatus =
  (typeof ConstructionQuoteRequestDetailDtoStatus)[keyof typeof ConstructionQuoteRequestDetailDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionQuoteRequestDetailDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

/**
 * 카테고리 타입
 */
export type ConstructionQuoteRequestDetailDtoCategoryType =
  (typeof ConstructionQuoteRequestDetailDtoCategoryType)[keyof typeof ConstructionQuoteRequestDetailDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionQuoteRequestDetailDtoCategoryType = {
  construction: "construction",
} as const;

/**
 * 주소 정보
 * @nullable
 */
export type ConstructionQuoteRequestDetailDtoAddress =
  QuoteRequestSimpleAddressDto | null;

/**
 * 예산 타입
 * @nullable
 */
export type ConstructionQuoteRequestDetailDtoBudgetType =
  | (typeof ConstructionQuoteRequestDetailDtoBudgetType)[keyof typeof ConstructionQuoteRequestDetailDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionQuoteRequestDetailDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type ConstructionQuoteRequestDetailDtoPaymentMethod =
  (typeof ConstructionQuoteRequestDetailDtoPaymentMethod)[keyof typeof ConstructionQuoteRequestDetailDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionQuoteRequestDetailDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
 * @nullable
 */
export type ConstructionQuoteRequestDetailDtoPreferredPaymentChannel =
  | (typeof ConstructionQuoteRequestDetailDtoPreferredPaymentChannel)[keyof typeof ConstructionQuoteRequestDetailDtoPreferredPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionQuoteRequestDetailDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 스마트 견적 생성 상태
 */
export type ConstructionQuoteRequestDetailDtoAutoQuoteStatus =
  (typeof ConstructionQuoteRequestDetailDtoAutoQuoteStatus)[keyof typeof ConstructionQuoteRequestDetailDtoAutoQuoteStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionQuoteRequestDetailDtoAutoQuoteStatus = {
  none: "none",
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed",
} as const;

/**
 * 배송일 (구체적/협의가능)
 * @nullable
 */
export type ConstructionQuoteRequestDetailDtoDueDateValue =
  | (typeof ConstructionQuoteRequestDetailDtoDueDateValue)[keyof typeof ConstructionQuoteRequestDetailDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionQuoteRequestDetailDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

/**
 * 용역 과업지시서 초안 (2026-10-08). 항목마다 출처(USER·GUESS·EMPTY). 용역 외·없으면 null
 * @nullable
 */
export type ConstructionQuoteRequestDetailDtoServiceSow =
  QuoteRequestServiceSowDto | null;

export interface ConstructionQuoteRequestDetailDto {
  /** 견적 요청 ID (UUID) */
  id: string;
  /** 견적 요청 번호 */
  requestNumber: string;
  /** 프로젝트명 */
  projectName: string;
  /** 사용자 ID (작성자) */
  userId: string;
  /** 현재 인증 사용자가 이 견적 요청의 등록자인지 여부 (클라이언트 소유권 판단용) */
  isOwner?: boolean;
  /** 상태 */
  status: ConstructionQuoteRequestDetailDtoStatus;
  /** 카테고리 타입 */
  categoryType: ConstructionQuoteRequestDetailDtoCategoryType;
  /**
   * 담당자명
   * @nullable
   */
  managerName?: string | null;
  /**
   * 담당자 연락처
   * @nullable
   */
  managerContact?: string | null;
  /**
   * 발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)
   * @nullable
   */
  organizationName?: string | null;
  /**
   * 발주기관 대표번호 (담당자 개인 휴대폰이 아니다. 공개 공고에서만, 비공개는 본인·어드민 외 null)
   * @nullable
   */
  organizationPhone?: string | null;
  /** 주소 ID */
  addressId: string;
  /**
   * 주소 정보
   * @nullable
   */
  address?: ConstructionQuoteRequestDetailDtoAddress;
  /**
   * 설명
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: ConstructionQuoteRequestDetailDtoBudgetType;
  /**
   * 예산 금액
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod: ConstructionQuoteRequestDetailDtoPaymentMethod;
  /** 결제 방법 (boolean form). true=선결제, false=후불결제. */
  isPrepaid: boolean;
  /**
   * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
   * @nullable
   */
  preferredPaymentChannel: ConstructionQuoteRequestDetailDtoPreferredPaymentChannel;
  /**
   * 동일 지역만
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /** 마감일시 (ISO 8601). 신규 등록은 한국시간 18:00 고정. */
  deadline: string;
  /**
   * 생성일 (ISO 8601)
   * @nullable
   */
  createdAt?: string | null;
  /**
   * 수정일 (ISO 8601)
   * @nullable
   */
  updatedAt?: string | null;
  /**
   * 승인 일시 (ISO 8601)
   * @nullable
   */
  approvedAt?: string | null;
  /**
   * 마감 일시 (ISO 8601)
   * @nullable
   */
  closedAt?: string | null;
  /**
   * 마감 사유
   * @nullable
   */
  closeReason?: string | null;
  /**
   * 보류 일시 (ISO 8601)
   * @nullable
   */
  onHoldAt?: string | null;
  /**
   * 첨부파일 목록
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /** 견적 응답 수 */
  responseCount: number;
  /** 견적 응답 목록 */
  responses: QuoteResponseSummaryDto[];
  /** 자동 견적 발송 여부 */
  willGenerateAutoQuotes: boolean;
  /** 스마트 견적 생성 상태 */
  autoQuoteStatus: ConstructionQuoteRequestDetailDtoAutoQuoteStatus;
  /** 현재 사용자에게 노출 가능한 연결 계약 목록 (external 상세에서 제공) */
  contracts: QuoteRequestContractSummaryDto[];
  /** 이 견적요청에 딸린 채팅방 목록 — 공고 주인(발주기관)·운영자에게만 실린다(공급사·다른 발주기관에게는 생략). 세모 자동 연결로 견적 없이 열린 방(roomType=auto_match)까지 담는다. 감춘·지운 방은 빠진다 */
  chatRooms?: QuoteRequestChatRoomSummaryDto[];
  /**
   * 배송일 (구체적/협의가능)
   * @nullable
   */
  dueDateValue?: ConstructionQuoteRequestDetailDtoDueDateValue;
  /**
   * 희망 배송일 (ISO 8601)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 추가 요청사항
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
  /**
   * 표준 내역서 줄 (공사·용역 전용). 없으면 null. items 와 별개 — 물품 매칭 대상 아님
   * @nullable
   */
  boqLines: QuoteRequestBoqLineDto[] | null;
  /**
   * 내역서 종목 키 — 공사는 종목 enum 값, 용역은 유형 이름(GET /cost-estimate/work-types 의 type). 없으면 null
   * @nullable
   */
  boqWorkType: string | null;
  /**
   * 용역 과업지시서 초안 (2026-10-08). 항목마다 출처(USER·GUESS·EMPTY). 용역 외·없으면 null
   * @nullable
   */
  serviceSow: ConstructionQuoteRequestDetailDtoServiceSow;
  /**
   * 용역 유형 (2026-10-17) — 고객이 등록 화면에서 고른 용역 유형 이름(GET /cost-estimate/work-types 의 용역 type). 용역 외·안 고름은 null
   * @nullable
   */
  serviceType: string | null;
  /** 공사 유형 */
  constructionType: ConstructionTypeLabelValue;
  /** 공간 유형 */
  spaceType: SpaceTypeLabelValue;
  /** 공사 면적 */
  constructionArea: ConstructionAreaLabelValue;
}

/**
 * 상태
 */
export type ManufacturingQuoteRequestDetailDtoStatus =
  (typeof ManufacturingQuoteRequestDetailDtoStatus)[keyof typeof ManufacturingQuoteRequestDetailDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManufacturingQuoteRequestDetailDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

/**
 * 카테고리 타입
 */
export type ManufacturingQuoteRequestDetailDtoCategoryType =
  (typeof ManufacturingQuoteRequestDetailDtoCategoryType)[keyof typeof ManufacturingQuoteRequestDetailDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManufacturingQuoteRequestDetailDtoCategoryType = {
  manufacturing: "manufacturing",
} as const;

/**
 * 주소 정보
 * @nullable
 */
export type ManufacturingQuoteRequestDetailDtoAddress =
  QuoteRequestSimpleAddressDto | null;

/**
 * 예산 타입
 * @nullable
 */
export type ManufacturingQuoteRequestDetailDtoBudgetType =
  | (typeof ManufacturingQuoteRequestDetailDtoBudgetType)[keyof typeof ManufacturingQuoteRequestDetailDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManufacturingQuoteRequestDetailDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type ManufacturingQuoteRequestDetailDtoPaymentMethod =
  (typeof ManufacturingQuoteRequestDetailDtoPaymentMethod)[keyof typeof ManufacturingQuoteRequestDetailDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManufacturingQuoteRequestDetailDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
 * @nullable
 */
export type ManufacturingQuoteRequestDetailDtoPreferredPaymentChannel =
  | (typeof ManufacturingQuoteRequestDetailDtoPreferredPaymentChannel)[keyof typeof ManufacturingQuoteRequestDetailDtoPreferredPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManufacturingQuoteRequestDetailDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 스마트 견적 생성 상태
 */
export type ManufacturingQuoteRequestDetailDtoAutoQuoteStatus =
  (typeof ManufacturingQuoteRequestDetailDtoAutoQuoteStatus)[keyof typeof ManufacturingQuoteRequestDetailDtoAutoQuoteStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManufacturingQuoteRequestDetailDtoAutoQuoteStatus = {
  none: "none",
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed",
} as const;

/**
 * 배송일 (구체적/협의가능)
 * @nullable
 */
export type ManufacturingQuoteRequestDetailDtoDueDateValue =
  | (typeof ManufacturingQuoteRequestDetailDtoDueDateValue)[keyof typeof ManufacturingQuoteRequestDetailDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManufacturingQuoteRequestDetailDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

/**
 * 용역 과업지시서 초안 (2026-10-08). 항목마다 출처(USER·GUESS·EMPTY). 용역 외·없으면 null
 * @nullable
 */
export type ManufacturingQuoteRequestDetailDtoServiceSow =
  QuoteRequestServiceSowDto | null;

export interface ManufacturingQuoteRequestDetailDto {
  /** 견적 요청 ID (UUID) */
  id: string;
  /** 견적 요청 번호 */
  requestNumber: string;
  /** 프로젝트명 */
  projectName: string;
  /** 사용자 ID (작성자) */
  userId: string;
  /** 현재 인증 사용자가 이 견적 요청의 등록자인지 여부 (클라이언트 소유권 판단용) */
  isOwner?: boolean;
  /** 상태 */
  status: ManufacturingQuoteRequestDetailDtoStatus;
  /** 카테고리 타입 */
  categoryType: ManufacturingQuoteRequestDetailDtoCategoryType;
  /**
   * 담당자명
   * @nullable
   */
  managerName?: string | null;
  /**
   * 담당자 연락처
   * @nullable
   */
  managerContact?: string | null;
  /**
   * 발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)
   * @nullable
   */
  organizationName?: string | null;
  /**
   * 발주기관 대표번호 (담당자 개인 휴대폰이 아니다. 공개 공고에서만, 비공개는 본인·어드민 외 null)
   * @nullable
   */
  organizationPhone?: string | null;
  /** 주소 ID */
  addressId: string;
  /**
   * 주소 정보
   * @nullable
   */
  address?: ManufacturingQuoteRequestDetailDtoAddress;
  /**
   * 설명
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: ManufacturingQuoteRequestDetailDtoBudgetType;
  /**
   * 예산 금액
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod: ManufacturingQuoteRequestDetailDtoPaymentMethod;
  /** 결제 방법 (boolean form). true=선결제, false=후불결제. */
  isPrepaid: boolean;
  /**
   * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
   * @nullable
   */
  preferredPaymentChannel: ManufacturingQuoteRequestDetailDtoPreferredPaymentChannel;
  /**
   * 동일 지역만
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /** 마감일시 (ISO 8601). 신규 등록은 한국시간 18:00 고정. */
  deadline: string;
  /**
   * 생성일 (ISO 8601)
   * @nullable
   */
  createdAt?: string | null;
  /**
   * 수정일 (ISO 8601)
   * @nullable
   */
  updatedAt?: string | null;
  /**
   * 승인 일시 (ISO 8601)
   * @nullable
   */
  approvedAt?: string | null;
  /**
   * 마감 일시 (ISO 8601)
   * @nullable
   */
  closedAt?: string | null;
  /**
   * 마감 사유
   * @nullable
   */
  closeReason?: string | null;
  /**
   * 보류 일시 (ISO 8601)
   * @nullable
   */
  onHoldAt?: string | null;
  /**
   * 첨부파일 목록
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /** 견적 응답 수 */
  responseCount: number;
  /** 견적 응답 목록 */
  responses: QuoteResponseSummaryDto[];
  /** 자동 견적 발송 여부 */
  willGenerateAutoQuotes: boolean;
  /** 스마트 견적 생성 상태 */
  autoQuoteStatus: ManufacturingQuoteRequestDetailDtoAutoQuoteStatus;
  /** 현재 사용자에게 노출 가능한 연결 계약 목록 (external 상세에서 제공) */
  contracts: QuoteRequestContractSummaryDto[];
  /** 이 견적요청에 딸린 채팅방 목록 — 공고 주인(발주기관)·운영자에게만 실린다(공급사·다른 발주기관에게는 생략). 세모 자동 연결로 견적 없이 열린 방(roomType=auto_match)까지 담는다. 감춘·지운 방은 빠진다 */
  chatRooms?: QuoteRequestChatRoomSummaryDto[];
  /**
   * 배송일 (구체적/협의가능)
   * @nullable
   */
  dueDateValue?: ManufacturingQuoteRequestDetailDtoDueDateValue;
  /**
   * 희망 배송일 (ISO 8601)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 추가 요청사항
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
  /**
   * 표준 내역서 줄 (공사·용역 전용). 없으면 null. items 와 별개 — 물품 매칭 대상 아님
   * @nullable
   */
  boqLines: QuoteRequestBoqLineDto[] | null;
  /**
   * 내역서 종목 키 — 공사는 종목 enum 값, 용역은 유형 이름(GET /cost-estimate/work-types 의 type). 없으면 null
   * @nullable
   */
  boqWorkType: string | null;
  /**
   * 용역 과업지시서 초안 (2026-10-08). 항목마다 출처(USER·GUESS·EMPTY). 용역 외·없으면 null
   * @nullable
   */
  serviceSow: ManufacturingQuoteRequestDetailDtoServiceSow;
  /**
   * 용역 유형 (2026-10-17) — 고객이 등록 화면에서 고른 용역 유형 이름(GET /cost-estimate/work-types 의 용역 type). 용역 외·안 고름은 null
   * @nullable
   */
  serviceType: string | null;
}

/**
 * 상태
 */
export type UsedQuoteRequestDetailDtoStatus =
  (typeof UsedQuoteRequestDetailDtoStatus)[keyof typeof UsedQuoteRequestDetailDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedQuoteRequestDetailDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

/**
 * 카테고리 타입
 */
export type UsedQuoteRequestDetailDtoCategoryType =
  (typeof UsedQuoteRequestDetailDtoCategoryType)[keyof typeof UsedQuoteRequestDetailDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedQuoteRequestDetailDtoCategoryType = {
  used: "used",
} as const;

/**
 * 주소 정보
 * @nullable
 */
export type UsedQuoteRequestDetailDtoAddress =
  QuoteRequestSimpleAddressDto | null;

/**
 * 예산 타입
 * @nullable
 */
export type UsedQuoteRequestDetailDtoBudgetType =
  | (typeof UsedQuoteRequestDetailDtoBudgetType)[keyof typeof UsedQuoteRequestDetailDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedQuoteRequestDetailDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type UsedQuoteRequestDetailDtoPaymentMethod =
  (typeof UsedQuoteRequestDetailDtoPaymentMethod)[keyof typeof UsedQuoteRequestDetailDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedQuoteRequestDetailDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
 * @nullable
 */
export type UsedQuoteRequestDetailDtoPreferredPaymentChannel =
  | (typeof UsedQuoteRequestDetailDtoPreferredPaymentChannel)[keyof typeof UsedQuoteRequestDetailDtoPreferredPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedQuoteRequestDetailDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 스마트 견적 생성 상태
 */
export type UsedQuoteRequestDetailDtoAutoQuoteStatus =
  (typeof UsedQuoteRequestDetailDtoAutoQuoteStatus)[keyof typeof UsedQuoteRequestDetailDtoAutoQuoteStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedQuoteRequestDetailDtoAutoQuoteStatus = {
  none: "none",
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed",
} as const;

/**
 * 배송일 (구체적/협의가능)
 * @nullable
 */
export type UsedQuoteRequestDetailDtoDueDateValue =
  | (typeof UsedQuoteRequestDetailDtoDueDateValue)[keyof typeof UsedQuoteRequestDetailDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedQuoteRequestDetailDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

/**
 * 용역 과업지시서 초안 (2026-10-08). 항목마다 출처(USER·GUESS·EMPTY). 용역 외·없으면 null
 * @nullable
 */
export type UsedQuoteRequestDetailDtoServiceSow =
  QuoteRequestServiceSowDto | null;

export interface UsedQuoteRequestDetailDto {
  /** 견적 요청 ID (UUID) */
  id: string;
  /** 견적 요청 번호 */
  requestNumber: string;
  /** 프로젝트명 */
  projectName: string;
  /** 사용자 ID (작성자) */
  userId: string;
  /** 현재 인증 사용자가 이 견적 요청의 등록자인지 여부 (클라이언트 소유권 판단용) */
  isOwner?: boolean;
  /** 상태 */
  status: UsedQuoteRequestDetailDtoStatus;
  /** 카테고리 타입 */
  categoryType: UsedQuoteRequestDetailDtoCategoryType;
  /**
   * 담당자명
   * @nullable
   */
  managerName?: string | null;
  /**
   * 담당자 연락처
   * @nullable
   */
  managerContact?: string | null;
  /**
   * 발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)
   * @nullable
   */
  organizationName?: string | null;
  /**
   * 발주기관 대표번호 (담당자 개인 휴대폰이 아니다. 공개 공고에서만, 비공개는 본인·어드민 외 null)
   * @nullable
   */
  organizationPhone?: string | null;
  /** 주소 ID */
  addressId: string;
  /**
   * 주소 정보
   * @nullable
   */
  address?: UsedQuoteRequestDetailDtoAddress;
  /**
   * 설명
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: UsedQuoteRequestDetailDtoBudgetType;
  /**
   * 예산 금액
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod: UsedQuoteRequestDetailDtoPaymentMethod;
  /** 결제 방법 (boolean form). true=선결제, false=후불결제. */
  isPrepaid: boolean;
  /**
   * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
   * @nullable
   */
  preferredPaymentChannel: UsedQuoteRequestDetailDtoPreferredPaymentChannel;
  /**
   * 동일 지역만
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /** 마감일시 (ISO 8601). 신규 등록은 한국시간 18:00 고정. */
  deadline: string;
  /**
   * 생성일 (ISO 8601)
   * @nullable
   */
  createdAt?: string | null;
  /**
   * 수정일 (ISO 8601)
   * @nullable
   */
  updatedAt?: string | null;
  /**
   * 승인 일시 (ISO 8601)
   * @nullable
   */
  approvedAt?: string | null;
  /**
   * 마감 일시 (ISO 8601)
   * @nullable
   */
  closedAt?: string | null;
  /**
   * 마감 사유
   * @nullable
   */
  closeReason?: string | null;
  /**
   * 보류 일시 (ISO 8601)
   * @nullable
   */
  onHoldAt?: string | null;
  /**
   * 첨부파일 목록
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /** 견적 응답 수 */
  responseCount: number;
  /** 견적 응답 목록 */
  responses: QuoteResponseSummaryDto[];
  /** 자동 견적 발송 여부 */
  willGenerateAutoQuotes: boolean;
  /** 스마트 견적 생성 상태 */
  autoQuoteStatus: UsedQuoteRequestDetailDtoAutoQuoteStatus;
  /** 현재 사용자에게 노출 가능한 연결 계약 목록 (external 상세에서 제공) */
  contracts: QuoteRequestContractSummaryDto[];
  /** 이 견적요청에 딸린 채팅방 목록 — 공고 주인(발주기관)·운영자에게만 실린다(공급사·다른 발주기관에게는 생략). 세모 자동 연결로 견적 없이 열린 방(roomType=auto_match)까지 담는다. 감춘·지운 방은 빠진다 */
  chatRooms?: QuoteRequestChatRoomSummaryDto[];
  /**
   * 배송일 (구체적/협의가능)
   * @nullable
   */
  dueDateValue?: UsedQuoteRequestDetailDtoDueDateValue;
  /**
   * 희망 배송일 (ISO 8601)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 추가 요청사항
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
  /**
   * 표준 내역서 줄 (공사·용역 전용). 없으면 null. items 와 별개 — 물품 매칭 대상 아님
   * @nullable
   */
  boqLines: QuoteRequestBoqLineDto[] | null;
  /**
   * 내역서 종목 키 — 공사는 종목 enum 값, 용역은 유형 이름(GET /cost-estimate/work-types 의 type). 없으면 null
   * @nullable
   */
  boqWorkType: string | null;
  /**
   * 용역 과업지시서 초안 (2026-10-08). 항목마다 출처(USER·GUESS·EMPTY). 용역 외·없으면 null
   * @nullable
   */
  serviceSow: UsedQuoteRequestDetailDtoServiceSow;
  /**
   * 용역 유형 (2026-10-17) — 고객이 등록 화면에서 고른 용역 유형 이름(GET /cost-estimate/work-types 의 용역 type). 용역 외·안 고름은 null
   * @nullable
   */
  serviceType: string | null;
}

export interface CheckAutoQuoteItemDto {
  /** 항목명 */
  name: string;
  /** 마스터 품목 ID (Autocomplete 선택 시) */
  itemId?: string;
}

export interface CheckAutoQuoteRequestDto {
  /** 체크할 항목 목록 */
  items: CheckAutoQuoteItemDto[];
}

export interface SuggestedBundleDto {
  /** 번들에 포함된 품목명 목록 */
  itemNames: string[];
  /** 이 조합을 처리 가능한 업체 수 */
  supplierCount: number;
  /** 전체 품목 대비 커버리지 (0~1) */
  coverage: number;
}

/**
 * 매칭 상태
 */
export type ItemAnalysisDtoStatus =
  (typeof ItemAnalysisDtoStatus)[keyof typeof ItemAnalysisDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemAnalysisDtoStatus = {
  matched: "matched",
  bundle_conflict: "bundle_conflict",
  no_supplier: "no_supplier",
} as const;

export interface ItemAnalysisDto {
  /** 품목명 */
  name: string;
  /** 마스터 품목 ID */
  itemId?: string;
  /** 매칭 상태 */
  status: ItemAnalysisDtoStatus;
  /** 이 품목을 취급하는 총 업체 수 */
  supplierCount: number;
}

export interface CheckAutoQuoteResponseDto {
  /** 전체 품목 자동 견적 가능 여부 */
  canAutoQuote: boolean;
  /** 전체 품목 매칭 시 업체 수 (canAutoQuote가 true일 때만 의미 있음) */
  supplierCount: number;
  /** 즉시 견적 가능한 최적의 품목 조합 추천 목록 */
  suggestedBundles?: SuggestedBundleDto[];
  /** 품목별 상세 분석 결과 */
  itemAnalysis?: ItemAnalysisDto[];
  /** 자동 견적이 불가능하게 만드는 품목명 목록 (하위 호환성 유지) */
  unmatchedItemNames?: string[];
}

export interface RecentItemDto {
  /** 카탈로그 물품 ID (items_v2_base.id) */
  itemId: string;
  /** 그때 적은 품명 */
  name: string;
  /** @nullable */
  spec1?: string | null;
  /** @nullable */
  spec2?: string | null;
  /** @nullable */
  spec3?: string | null;
  /** 단위 */
  unit: string;
  /** 그때 수량 */
  quantity: number;
  /**
   * 매칭된 카탈로그 물품명
   * @nullable
   */
  itemName?: string | null;
  /** 마지막으로 쓴 요청 번호 */
  requestNumber: string;
  /** 마지막으로 쓴 시각(ISO) */
  lastUsedAt: string;
}

/**
 * 카테고리 타입
 */
export type UpdateQuoteRequestDtoCategoryType =
  (typeof UpdateQuoteRequestDtoCategoryType)[keyof typeof UpdateQuoteRequestDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateQuoteRequestDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 예산 타입
 * @nullable
 */
export type UpdateQuoteRequestDtoBudgetType =
  | (typeof UpdateQuoteRequestDtoBudgetType)[keyof typeof UpdateQuoteRequestDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateQuoteRequestDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type UpdateQuoteRequestDtoPaymentMethod =
  (typeof UpdateQuoteRequestDtoPaymentMethod)[keyof typeof UpdateQuoteRequestDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateQuoteRequestDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다.
 */
export type UpdateQuoteRequestDtoPreferredPaymentChannel =
  (typeof UpdateQuoteRequestDtoPreferredPaymentChannel)[keyof typeof UpdateQuoteRequestDtoPreferredPaymentChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateQuoteRequestDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 배송일 값 (사용자 입력값)
 * @nullable
 */
export type UpdateQuoteRequestDtoDueDateValue =
  | (typeof UpdateQuoteRequestDtoDueDateValue)[keyof typeof UpdateQuoteRequestDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateQuoteRequestDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

/**
 * 공사 타입 (공사 카테고리 전용)
 * @nullable
 */
export type UpdateQuoteRequestDtoConstructionType =
  ConstructionTypeLabelValue | null;

/**
 * 공간 타입 (공사 카테고리 전용)
 * @nullable
 */
export type UpdateQuoteRequestDtoSpaceType = SpaceTypeLabelValue | null;

/**
 * 공사 면적 (공사 카테고리 전용)
 * @nullable
 */
export type UpdateQuoteRequestDtoConstructionArea =
  ConstructionAreaLabelValue | null;

/**
 * 과업지시서 초안 (용역 전용). 항목마다 출처 USER(답함)·GUESS(시스템이 채움)·EMPTY(비어 있음)
 * @nullable
 */
export type UpdateQuoteRequestDtoServiceSow = QuoteRequestServiceSowDto | null;

export interface UpdateQuoteRequestDto {
  /** 프로젝트명 (물품 구매(product) 카테고리는 선택 — 미입력 시 물품 목록으로 자동 생성, 그 외 카테고리는 필수) */
  projectName?: string;
  /** 카테고리 타입 */
  categoryType?: UpdateQuoteRequestDtoCategoryType;
  /** 담당자 연락처 (필수) */
  managerContact?: string;
  /** 담당자명 */
  managerName?: string;
  /** 주소 ID (addresses 테이블 외래키) */
  addressId?: string;
  /**
   * 주소 상세정보 (예: 동 101호, 3층 등의 추가 정보)
   * @nullable
   */
  addressDetail?: string | null;
  /**
   * 견적 요청 설명 및 추가 사항
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: UpdateQuoteRequestDtoBudgetType;
  /**
   * 예산 금액 (원화)
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod?: UpdateQuoteRequestDtoPaymentMethod;
  /** 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다. */
  preferredPaymentChannel?: UpdateQuoteRequestDtoPreferredPaymentChannel;
  /**
   * 동일 지역만 선택 여부
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /** 바로 업체 찾기로 등록 — 6곳 방은 등록 직후 auto-match/start 가 연다(등록 이벤트의 자동 매칭은 건너뜀) */
  quickMatch?: boolean;
  /**
   * 배송일 값 (사용자 입력값)
   * @nullable
   */
  dueDateValue?: UpdateQuoteRequestDtoDueDateValue;
  /**
   * 배송일 (ISO 8601 형식)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 업로드된 파일들의 메타데이터 배열
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /**
   * 항목 목록 (Product 카테고리에만 필수)
   * @nullable
   */
  items?: CreateQuoteRequestItemDto[] | null;
  /**
   * 추가 조건 (물품 구매 카테고리 전용)
   * @nullable
   */
  additionalConditions?: LabelValuePair[] | null;
  /**
   * 추가 요청사항 (모든 카테고리 선택 가능)
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
  /**
   * 공사 타입 (공사 카테고리 전용)
   * @nullable
   */
  constructionType?: UpdateQuoteRequestDtoConstructionType;
  /**
   * 공간 타입 (공사 카테고리 전용)
   * @nullable
   */
  spaceType?: UpdateQuoteRequestDtoSpaceType;
  /**
   * 공사 면적 (공사 카테고리 전용)
   * @nullable
   */
  constructionArea?: UpdateQuoteRequestDtoConstructionArea;
  /**
   * 표준 내역서 줄 (공사·용역 카테고리 전용, 최대 500줄). items 와 별개로 저장되며 물품 매칭·알림 대상이 아니다
   * @nullable
   */
  boqLines?: QuoteRequestBoqLineDto[] | null;
  /**
   * 내역서 종목 키 (공사·용역 카테고리 전용). 공사는 종목 enum 값, 용역은 유형 이름 — GET /cost-estimate/work-types 의 type
   * @maxLength 60
   * @nullable
   */
  boqWorkType?: string | null;
  /**
   * 과업지시서 초안 (용역 전용). 항목마다 출처 USER(답함)·GUESS(시스템이 채움)·EMPTY(비어 있음)
   * @nullable
   */
  serviceSow?: UpdateQuoteRequestDtoServiceSow;
  /**
   * 용역 유형 이름 (용역 전용) — GET /cost-estimate/work-types 의 용역 type. 업체 매칭이 이 값으로 자격을 고른다
   * @maxLength 50
   * @nullable
   */
  serviceType?: string | null;
}

export interface CloseQuoteRequestDto {
  /** 마감 사유 */
  closeReason?: string;
}

export interface ReachDto {
  /** 요청이 닿은 공급사 수 */
  reached: number;
  /** 직접 열어 본 공급사 수 */
  viewed: number;
  /** 지금 견적을 쓰는 공급사 수 */
  composing: number;
  empty: boolean;
  headline: string;
}

export type DeliveryBadgeDtoReaction =
  (typeof DeliveryBadgeDtoReaction)[keyof typeof DeliveryBadgeDtoReaction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliveryBadgeDtoReaction = {
  fast: "fast",
  accurate: "accurate",
  packaging: "packaging",
} as const;

export interface DeliveryBadgeDto {
  reaction: DeliveryBadgeDtoReaction;
  label: string;
  count: number;
}

export interface BuyerResponseReactionDto {
  responseId: string;
  /** @nullable */
  readAt?: string | null;
  starred: boolean;
  contracted: boolean;
  deliveryBadges: DeliveryBadgeDto[];
}

export type BuyerFeedbackDtoReasonsItem =
  (typeof BuyerFeedbackDtoReasonsItem)[keyof typeof BuyerFeedbackDtoReasonsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BuyerFeedbackDtoReasonsItem = {
  price: "price",
  delivery: "delivery",
  spec: "spec",
  trust: "trust",
} as const;

export interface BuyerFeedbackDto {
  available: boolean;
  notSelectedCount: number;
  enabled: boolean;
  reasons: BuyerFeedbackDtoReasonsItem[];
}

export interface ResponsivenessDto {
  /** 견적이 붙었고 끝났거나 이미 반응한 최근 요청 수 */
  considered: number;
  /** 그중 ⭐·선정·선정 사유를 남긴 요청 수 */
  reacted: number;
  /** «반응 잘 주는 기관» */
  responsive: boolean;
}

export interface BuyerRequestReactionsDto {
  quoteRequestId: string;
  status: string;
  reach: ReachDto;
  responses: BuyerResponseReactionDto[];
  feedback: BuyerFeedbackDto;
  responsiveness: ResponsivenessDto;
}

export interface MarkReadResponseDto {
  /** 처리 성공 여부 */
  success: boolean;
  /** 처리된 알람 ID */
  notificationId: string;
}

export interface SetStarResponseDto {
  starred: boolean;
  /** @nullable */
  starredAt?: string | null;
}

export interface SetStarDto {
  /** 후보(⭐)로 올리면 true, 내리면 false */
  starred: boolean;
}

export type FeedbackSettingDtoReasonsItem =
  (typeof FeedbackSettingDtoReasonsItem)[keyof typeof FeedbackSettingDtoReasonsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedbackSettingDtoReasonsItem = {
  price: "price",
  delivery: "delivery",
  spec: "spec",
  trust: "trust",
} as const;

export interface FeedbackSettingDto {
  enabled: boolean;
  reasons: FeedbackSettingDtoReasonsItem[];
}

export type SetFeedbackDtoReasonsItem =
  (typeof SetFeedbackDtoReasonsItem)[keyof typeof SetFeedbackDtoReasonsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetFeedbackDtoReasonsItem = {
  price: "price",
  delivery: "delivery",
  spec: "spec",
  trust: "trust",
} as const;

export interface SetFeedbackDto {
  /** 떨어진 공급사에게 한 줄 피드백을 보낼지 */
  enabled: boolean;
  /** 선정 사유 칩(가격·납기·사양·신뢰) */
  reasons: SetFeedbackDtoReasonsItem[];
}

export type DeliveryReactionOptionDtoReaction =
  (typeof DeliveryReactionOptionDtoReaction)[keyof typeof DeliveryReactionOptionDtoReaction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliveryReactionOptionDtoReaction = {
  fast: "fast",
  accurate: "accurate",
  packaging: "packaging",
} as const;

export interface DeliveryReactionOptionDto {
  reaction: DeliveryReactionOptionDtoReaction;
  label: string;
}

export type DeliveryReactionDtoReactionsItem =
  (typeof DeliveryReactionDtoReactionsItem)[keyof typeof DeliveryReactionDtoReactionsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliveryReactionDtoReactionsItem = {
  fast: "fast",
  accurate: "accurate",
  packaging: "packaging",
} as const;

export interface DeliveryReactionDto {
  contractId: string;
  eligible: boolean;
  reactions: DeliveryReactionDtoReactionsItem[];
  options: DeliveryReactionOptionDto[];
}

/**
 * 빨랐어요(fast) · 정확해요(accurate) · 포장 좋아요(packaging)
 */
export type AddDeliveryReactionDtoReaction =
  (typeof AddDeliveryReactionDtoReaction)[keyof typeof AddDeliveryReactionDtoReaction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddDeliveryReactionDtoReaction = {
  fast: "fast",
  accurate: "accurate",
  packaging: "packaging",
} as const;

export interface AddDeliveryReactionDto {
  /** 빨랐어요(fast) · 정확해요(accurate) · 포장 좋아요(packaging) */
  reaction: AddDeliveryReactionDtoReaction;
}

export interface TouchPresenceResponseDto {
  /** 적었나(요청 주인·지운 요청이면 false) */
  recorded: boolean;
}

export interface TouchPresenceDto {
  /** 견적 작성 화면 하트비트면 true(열람만이면 생략) */
  composing?: boolean;
}

export interface PriceRankDto {
  rank: number;
  of: number;
}

/**
 * 가격 순위(낮을수록 1위)
 * @nullable
 */
export type LossFeedbackDtoPriceRank = PriceRankDto | null;

/**
 * @nullable
 */
export type LossFeedbackDtoPriceGap =
  | (typeof LossFeedbackDtoPriceGap)[keyof typeof LossFeedbackDtoPriceGap]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LossFeedbackDtoPriceGap = {
  lowest: "lowest",
  within_5: "within_5",
  within_10: "within_10",
  over_10: "over_10",
} as const;

/**
 * @nullable
 */
export type LossFeedbackDtoDelivery =
  | (typeof LossFeedbackDtoDelivery)[keyof typeof LossFeedbackDtoDelivery]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LossFeedbackDtoDelivery = {
  faster: "faster",
  same: "same",
  slower: "slower",
} as const;

/**
 * @nullable
 */
export type LossFeedbackDtoDeliveryAgainst =
  | (typeof LossFeedbackDtoDeliveryAgainst)[keyof typeof LossFeedbackDtoDeliveryAgainst]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LossFeedbackDtoDeliveryAgainst = {
  selected: "selected",
  fastest: "fastest",
} as const;

export type LossFeedbackDtoReasonsItem =
  (typeof LossFeedbackDtoReasonsItem)[keyof typeof LossFeedbackDtoReasonsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LossFeedbackDtoReasonsItem = {
  price: "price",
  delivery: "delivery",
  spec: "spec",
  trust: "trust",
} as const;

export interface LossFeedbackDto {
  /**
   * 가격 순위(낮을수록 1위)
   * @nullable
   */
  priceRank?: LossFeedbackDtoPriceRank;
  /** @nullable */
  priceGap?: LossFeedbackDtoPriceGap;
  /** @nullable */
  delivery?: LossFeedbackDtoDelivery;
  /** @nullable */
  deliveryAgainst?: LossFeedbackDtoDeliveryAgainst;
  reasons: LossFeedbackDtoReasonsItem[];
  line: string;
}

export type SupplierMyResponseDtoResult =
  (typeof SupplierMyResponseDtoResult)[keyof typeof SupplierMyResponseDtoResult];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierMyResponseDtoResult = {
  pending: "pending",
  selected: "selected",
  not_selected: "not_selected",
  closed_without_selection: "closed_without_selection",
} as const;

/**
 * @nullable
 */
export type SupplierMyResponseDtoFeedback = LossFeedbackDto | null;

export interface SupplierMyResponseDto {
  responseId: string;
  /** @nullable */
  readAt?: string | null;
  starred: boolean;
  result: SupplierMyResponseDtoResult;
  /** @nullable */
  feedback?: SupplierMyResponseDtoFeedback;
  feedbackOff: boolean;
}

/**
 * @nullable
 */
export type SupplierRequestReactionsDtoMine = SupplierMyResponseDto | null;

export interface SupplierRequestReactionsDto {
  quoteRequestId: string;
  buyer: ResponsivenessDto;
  /** @nullable */
  mine?: SupplierRequestReactionsDtoMine;
}

export type SupplierSignalDtoResult =
  (typeof SupplierSignalDtoResult)[keyof typeof SupplierSignalDtoResult];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierSignalDtoResult = {
  pending: "pending",
  selected: "selected",
  not_selected: "not_selected",
  closed_without_selection: "closed_without_selection",
} as const;

export interface SupplierSignalDto {
  quoteRequestId: string;
  responseId: string;
  /** @nullable */
  readAt?: string | null;
  starred: boolean;
  result: SupplierSignalDtoResult;
}

/**
 * BOTH=업체 선정 기안문 + 붙임 비교표, COMPARISON=비교표만
 */
export type QuoteCompareInclude =
  (typeof QuoteCompareInclude)[keyof typeof QuoteCompareInclude];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteCompareInclude = {
  BOTH: "BOTH",
  COMPARISON: "COMPARISON",
} as const;

export interface QuoteCompareLabelValueDto {
  /** 항목 이름 */
  label: string;
  /** 값 — 비면 그 줄을 뺀다 */
  value: string;
}

export interface QuoteCompareRowDto {
  /** 업체 표기 — 화면에 보이는 그대로 */
  label: string;
  /** 합계(원본) — 모르면 비운다 */
  totalAmount?: number;
  /** 공급가액 — 모르면 비운다 */
  supplyAmount?: number;
  /** 부가세 — 모르면 비운다 */
  vatAmount?: number;
  /** 단가 — 모르면 비운다 */
  unitPrice?: number;
  /** 납기 문구 — 모르면 비운다 */
  delivery?: string;
  /** 주요 조건·특이사항 — 모르면 비운다 */
  note?: string;
  /** 예정가격(예산) 대비 % — 기준값이 화면에 보일 때만 */
  ratioPercent?: number;
  /** 최저가 */
  lowest: boolean;
  /** 선정 */
  selected: boolean;
  /** 구매자가 ⭐ 최종 후보로 올린 견적(세모견적 «반응») */
  candidate?: boolean;
  /** 원본과 계산 값이 어긋난 설명 — 있으면 합계 칸을 노랗게 칠하고 각주로 남긴다 */
  mismatch?: string;
}

export interface QuoteCompareSectionDto {
  /** 비교표 머리글(공고명 등) — 비면 뺀다 */
  heading?: string;
  /** 비교표 위 요약 — 있는 값만 */
  meta?: QuoteCompareLabelValueDto[];
  /** 합계 열 이름 — 화면과 같은 말 */
  amountLabel: string;
  /** 대비 열 이름 — 비면 그 열을 그리지 않는다 */
  ratioLabel?: string;
  rows: QuoteCompareRowDto[];
  /** 각주(철회·비공개 제외 등) */
  notes?: string[];
}

export interface QuoteCompareSelectionDto {
  /** 선정 업체 표기 */
  vendor: string;
  /** 계약(선정) 금액 — 모르면 비운다 */
  amount?: number;
  /** 금액 한글 표기 — 비면 뺀다 */
  amountInWords?: string;
  /** 금액 원본과 계산이 어긋난 설명 */
  amountMismatch?: string;
  /** 선정 사유 칩 */
  reasons?: string[];
  /** 선정 사유 글 */
  reasonText?: string;
}

export interface QuoteComparePdfRequestDto {
  /** BOTH=업체 선정 기안문 + 붙임 비교표, COMPARISON=비교표만 */
  include: QuoteCompareInclude;
  /** 기안 제목 */
  title: string;
  /** 기관명 — 화면이 확실히 알 때만. 없으면 그 자리를 뺀다 */
  organization?: string;
  /** 작성일 YYYY-MM-DD — 없으면 뺀다 */
  draftDate?: string;
  /** 목적 */
  purpose?: string;
  /** 추진 근거 — 있는 값만 */
  basis?: QuoteCompareLabelValueDto[];
  comparison: QuoteCompareSectionDto;
  /** 선정 — 고르지 않았으면 비운다 */
  selection?: QuoteCompareSelectionDto;
  /** 향후 일정 — 비면 빈 칸으로 둔다 */
  schedule?: string;
}

/**
 * 만기가 가장 가까운 잔액
 * @nullable
 */
export type AdminPointBalanceRowDtoExpiringSoon = {
  [key: string]: unknown;
} | null;

export interface AdminPointBalanceRowDto {
  /** 씨마켓 회원/사번 */
  memberNo: string;
  total: number;
  /**
   * 만기가 가장 가까운 잔액
   * @nullable
   */
  expiringSoon: AdminPointBalanceRowDtoExpiringSoon;
}

export interface AdminPointBalanceListDto {
  members: AdminPointBalanceRowDto[];
}

export type StorefrontPointEntryDtoType =
  (typeof StorefrontPointEntryDtoType)[keyof typeof StorefrontPointEntryDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontPointEntryDtoType = {
  CHARGE: "CHARGE",
  SPEND: "SPEND",
  REFUND: "REFUND",
  DEDUCT: "DEDUCT",
  EXPIRE: "EXPIRE",
} as const;

/**
 * @nullable
 */
export type StorefrontPointEntryDtoOrderNo = { [key: string]: unknown } | null;

/**
 * 충전 로트의 사용기한 / 만료가 닫은 로트의 기한
 * @nullable
 */
export type StorefrontPointEntryDtoExpiresAt = {
  [key: string]: unknown;
} | null;

/**
 * @nullable
 */
export type StorefrontPointEntryDtoReason = { [key: string]: unknown } | null;

/**
 * 관리자 행위의 주체
 * @nullable
 */
export type StorefrontPointEntryDtoActor = { [key: string]: unknown } | null;

export interface StorefrontPointEntryDto {
  id: string;
  type: StorefrontPointEntryDtoType;
  /** 부호 있는 변동량(충전·환불 +, 사용·차감·만료 -) */
  amount: number;
  balanceAfter: number;
  /** @nullable */
  orderNo: StorefrontPointEntryDtoOrderNo;
  /**
   * 충전 로트의 사용기한 / 만료가 닫은 로트의 기한
   * @nullable
   */
  expiresAt: StorefrontPointEntryDtoExpiresAt;
  /** @nullable */
  reason: StorefrontPointEntryDtoReason;
  /**
   * 관리자 행위의 주체
   * @nullable
   */
  actor: StorefrontPointEntryDtoActor;
  createdAt: string;
}

export interface AdminPointLedgerDto {
  entries: StorefrontPointEntryDto[];
}

export interface StorefrontPointExpiringDto {
  /** 만기가 가장 가까운 잔액 */
  amount: number;
  expiresAt: string;
}

/**
 * @nullable
 */
export type StorefrontPointSummaryDtoExpiringSoon =
  StorefrontPointExpiringDto | null;

export interface StorefrontPointSummaryDto {
  /** 사용 가능 포인트(살아 있는 로트의 합) */
  total: number;
  /** @nullable */
  expiringSoon: StorefrontPointSummaryDtoExpiringSoon;
}

export interface AdminPointMutationResultDto {
  /** 처리 후 잔액 */
  balance: StorefrontPointSummaryDto;
}

/**
 * 이 충전분(로트)의 사용기한. 비우면 무기한.
 * @nullable
 */
export type AdminPointChargeDtoExpiresAt = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type AdminPointChargeDtoReason = { [key: string]: unknown } | null;

export interface AdminPointChargeDto {
  memberNo: string;
  /** 충전 포인트(양수 정수) */
  amount: number;
  /**
   * 이 충전분(로트)의 사용기한. 비우면 무기한.
   * @nullable
   */
  expiresAt?: AdminPointChargeDtoExpiresAt;
  /** @nullable */
  reason?: AdminPointChargeDtoReason;
}

export interface AdminPointDeductDto {
  memberNo: string;
  /** 차감 포인트(양수 정수) */
  amount: number;
  /** 사유 — 관리자 차감은 사유 없이 성립하지 않는다 */
  reason: string;
}

export interface AdminStorefrontDto {
  id: string;
  slug: string;
  name: string;
  /** @nullable */
  description?: string | null;
  isActive: boolean;
  /** true=부가세 포함가로 표시, false=공급가액으로 표시 */
  includeVat: boolean;
  /**
   * 직접구매(DIRECT) 수수료율(bp, 500 = 5%). null = 전역 수수료 정책. 씨마켓몰(PER_ORDERER)에서만 뜻이 있다.
   * @nullable
   */
  directFeeBp?: number | null;
  /** 연결된 활성 업체 수 */
  supplierCount: number;
  /** 노출 중인 상품 수 */
  offeringCount: number;
  createdAt: string;
}

export interface CreateStorefrontDto {
  /** 피드 경로에 쓰이는 식별자(생성 후 불변) */
  slug: string;
  name: string;
  description?: string;
}

export interface SuccessResultDto {
  success: boolean;
}

export interface UpdateStorefrontDto {
  /** true=부가세 포함가로 표시, false=공급가액으로 표시 */
  includeVat?: boolean;
  name?: string;
  description?: string;
  isActive?: boolean;
}

export interface StorefrontSupplierDto {
  id: string;
  supplierId: string;
  /** @nullable */
  supplierName?: string | null;
  /** 이 업체가 취급하는 품목 수 */
  handledItemCount: number;
  /** 이 쇼핑몰에 노출 중인 수 */
  offeringCount: number;
  isActive: boolean;
}

export interface LinkSupplierDto {
  /** 공급사 ID (suppliers.id) */
  supplierId: string;
}

export interface UnlinkSupplierResultDto {
  /** 연결 해제로 노출이 중지된 상품 수 */
  deactivatedOfferings: number;
}

export type CandidateItemDtoBasePriceTaxType =
  (typeof CandidateItemDtoBasePriceTaxType)[keyof typeof CandidateItemDtoBasePriceTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidateItemDtoBasePriceTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface CandidateItemDto {
  itemId: string;
  name: string;
  /** @nullable */
  categoryName?: string | null;
  /** @nullable */
  manufacturer?: string | null;
  /** @nullable */
  spec1?: string | null;
  /** @nullable */
  unit?: string | null;
  /** 이 공급사의 일반 단가(참고용) — 입력한 그대로. 축은 basePriceTaxType. 후보 목록은 공급가(VAT 별도) 기준 싼 순 */
  basePrice: number;
  /** basePrice 의 부가세 축. EXCLUSIVE=공급가액, INCLUSIVE=부가세 포함가 */
  basePriceTaxType: CandidateItemDtoBasePriceTaxType;
  /** 이 업체 이름으로 이미 담겨 있는가 */
  isOffered: boolean;
  /** 같은 품목을 이미 내고 있는 **다른** 업체 수. 2기부터 한 품목을 여러 곳이 낼 수 있고, 손님은 익명 단가 리스트에서 최저가를 고른다 — 담는다고 남의 줄이 밀려나지 않는다 */
  competitorCount: number;
}

export interface CandidateListResponseDto {
  items: CandidateItemDto[];
  /** 검색 조건에 맞는 전체 건수 */
  total: number;
}

export interface AdminOfferingDto {
  id: string;
  itemId: string;
  itemName: string;
  supplierId: string;
  /** @nullable */
  supplierName?: string | null;
  /**
   * 공급사가 이 몰용으로 입력한 단가. null 이면 아직 안 넣어 노출되지 않는다
   * @nullable
   */
  supplierPrice?: number | null;
  /**
   * 이 공급사의 일반 공급가(참고용, 비교에만 쓴다)
   * @nullable
   */
  basePrice?: number | null;
  /** 공급사가 단가를 넣어 실제 노출 중인지 */
  isListed: boolean;
  isActive: boolean;
}

export interface AddOfferingsResultDto {
  /** 새로 담긴 건수 */
  created: number;
  /** 다른 업체에서 교체된 건수 */
  replaced: number;
}

export interface OfferingInputDto {
  /** 품목 ID (items_v2_base.id) */
  itemId: string;
  /** 이 품목을 파는 공급사 */
  supplierId: string;
}

export interface CreateOfferingsDto {
  /**
   * 한 번에 여러 건을 담는다(최대 500건)
   * @maxItems 500
   */
  items: OfferingInputDto[];
}

export interface UpdateOfferingDto {
  /** 공급사 교체 */
  supplierId?: string;
  isActive?: boolean;
  /**
   * 몰 판매가(원). null 이면 단가를 지운다 — 그 줄은 노출에서 빠진다
   * @nullable
   */
  supplierPrice?: number | null;
}

export interface AdminOrderInspectionDto {
  /** 검수 세션 상태 — `OPEN` · `COMPLETED` · `CANCELED`. */
  status: string;
  /**
   * 검수 담당자가 여는 촬영·대조 링크
   * @nullable
   */
  verificationUrl: string | null;
  /**
   * 완료된 검수의 보고서 주소
   * @nullable
   */
  reportUrl: string | null;
  /**
   * 라벨이 일치한 건수
   * @nullable
   */
  matchedCount: number | null;
  /**
   * 대조하지 못한 건수. 남아 있어도 검수는 완료될 수 있다.
   * @nullable
   */
  unmatchedCount: number | null;
  /**
   * 검수 완료 시각(ISO 8601)
   * @nullable
   */
  completedAt: string | null;
}

export interface AdminOrderContractDto {
  /** 계약 id */
  id: string;
  /** 계약번호 */
  contractNumber: string;
  /** 이 계약의 공급사 id */
  supplierId: string;
  /**
   * 계산서 보류 사유. 값이 있으면 **그 계약의 계산서 발행이 막혀 있다**. null 이면 열려 있다.
   * @nullable
   */
  taxInvoiceHoldReason: string | null;
}

/**
 * 검수 세션. null 이면 대조할 품목이 없어 검수를 열지 않은 주문이다(= 계산서 게이트도 없다).
 * @nullable
 */
export type AdminStorefrontOrderDtoInspection = AdminOrderInspectionDto | null;

export interface AdminStorefrontOrderDto {
  /** 주문 id */
  id: string;
  /** 주문번호 */
  orderNo: string;
  /** 주문 상태 — `PLACED` · `QUOTING` · `QUOTE_CLOSED` · `SENT_TO_ERP` · `CONTRACTED` · `SHIPPING` · `DELIVERED` · `INSPECTED` · `SETTLED` · `CANCELED`. */
  status: string;
  /**
   * 주문한 사람의 사번
   * @nullable
   */
  employeeNo: string | null;
  /** 공급가액 합계 */
  totalSupply: number;
  /** 부가세 합계 */
  totalVat: number;
  /**
   * ERP 가 회신한 구매요구번호
   * @nullable
   */
  erpRequisitionNo: string | null;
  /**
   * 이 주문으로 올라간 견적 공고 id. 아직 안 올렸으면 null.
   * @nullable
   */
  quoteRequestId: string | null;
  /** 주문 시각(ISO 8601) */
  createdAt: string;
  /**
   * 취소 시각(ISO 8601). 취소되지 않았으면 null.
   * @nullable
   */
  canceledAt: string | null;
  /**
   * 검수 세션. null 이면 대조할 품목이 없어 검수를 열지 않은 주문이다(= 계산서 게이트도 없다).
   * @nullable
   */
  inspection: AdminStorefrontOrderDtoInspection;
  /** 이 주문에 걸린 계약들 */
  contracts: AdminOrderContractDto[];
}

export interface AdminStorefrontOrderListDto {
  orders: AdminStorefrontOrderDto[];
  /** 필터 조건에 맞는 전체 건수 */
  total: number;
}

export interface AdminOrderPaymentAttentionDto {
  /** 주문번호 */
  orderNo: string;
  /**
   * 주문의 지금 상태. 주문 행을 못 찾으면 null.
   * @nullable
   */
  orderStatus: string | null;
  /** 몰 결제수단 — `TAX_INVOICE` · `CARD` · `POINT`. */
  method: string;
  /** 원장 사본 상태 — `REGISTERED`(등록·결제 전) · `PAID`(선불 결제됨). 이 목록에는 열린 원장만 나온다. */
  status: string;
  /** 결제 금액(원) */
  amount: number;
  /** 결제 결과를 모르는 행 — 씨마켓 결제 상태(카드 mall_card_payment / 포인트 원장 MALL_ORDER)를 사람이 확인해야 한다. 세모는 이 행의 돈을 움직이지 않는다. */
  paymentUnknown: boolean;
  /**
   * 멈춘 사유. `PAYMENT_UNKNOWN:` 으로 시작하면 결제 결과 불명.
   * @nullable
   */
  failureReason: string | null;
  /**
   * 씨마켓 선통지가 전부 끝난 시각. null 이면 등록이 도중에 끊겼다.
   * @nullable
   */
  registeredAt: string | null;
  /**
   * 선불 결제 시각
   * @nullable
   */
  paidAt: string | null;
  /**
   * 복구 스윕이 마지막으로 시도한 시각
   * @nullable
   */
  lastReconciledAt: string | null;
  /** 원장 행 생성 시각(= 주문 직후) */
  createdAt: string;
  /** 원장 행 마지막 변경 시각 */
  updatedAt: string;
}

export interface AdminOrderPaymentAttentionListDto {
  rows: AdminOrderPaymentAttentionDto[];
  /** 조건에 맞는 전체 건수 */
  total: number;
}

export interface ForceReleaseInspectionResultDto {
  /** 보류가 풀린 계약 수. 0 이면 아직 계약이 서지 않은 주문이다. */
  releasedContracts: number;
}

export interface ForceReleaseInspectionDto {
  /**
   * 강제 해제 사유. 계약 행에 그대로 남아 「왜 검수 없이 계산서가 나갔나」에 답한다.
   * @minLength 5
   */
  reason: string;
}

export interface ForceOrderActionResultDto {
  /** 처리 후 주문 상태. */
  status: string;
}

export interface ForceOrderActionDto {
  /**
   * 강제 처리 사유. 송장·확정 버튼 없이 상태를 옮긴 근거로 로그에 남는다.
   * @minLength 5
   */
  reason: string;
}

export type AdminStorefrontDirectFeeDtoSource =
  (typeof AdminStorefrontDirectFeeDtoSource)[keyof typeof AdminStorefrontDirectFeeDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminStorefrontDirectFeeDtoSource = {
  STOREFRONT_BP: "STOREFRONT_BP",
  DEFAULT_BP: "DEFAULT_BP",
} as const;

export interface AdminStorefrontDirectFeeDto {
  storefrontId: string;
  slug: string;
  /**
   * 몰 요율(bp). null = 기본 5%(500bp).
   * @nullable
   */
  directFeeBp: number | null;
  /** 씨마켓몰 기본 수수료(bp) — 안전결제와 같은 5%. 세모 전역 정책과 무관. */
  defaultBp: number;
  /** 지금 새 주문에 적용될 요율(bp) — 몰 요율, 없으면 기본 5% */
  effectiveBp: number;
  source: AdminStorefrontDirectFeeDtoSource;
}

export interface UpdateStorefrontDirectFeeDto {
  /**
   * 이 몰의 직접구매 수수료율(bp, 500 = 5%). null 이면 전역 수수료 정책을 따른다. 이미 청구된 건은 소급하지 않는다.
   * @nullable
   */
  directFeeBp: number | null;
}

export type AdminMallUnitFeeDtoUnitStatus =
  (typeof AdminMallUnitFeeDtoUnitStatus)[keyof typeof AdminMallUnitFeeDtoUnitStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminMallUnitFeeDtoUnitStatus = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
  CANCELED: "CANCELED",
} as const;

/**
 * @nullable
 */
export type AdminMallUnitFeeDtoRoute =
  | (typeof AdminMallUnitFeeDtoRoute)[keyof typeof AdminMallUnitFeeDtoRoute]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminMallUnitFeeDtoRoute = {
  SAFE: "SAFE",
  DIRECT: "DIRECT",
} as const;

/**
 * @nullable
 */
export type AdminMallUnitFeeDtoDealType =
  | (typeof AdminMallUnitFeeDtoDealType)[keyof typeof AdminMallUnitFeeDtoDealType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminMallUnitFeeDtoDealType = {
  SUPPLIER_DIRECT: "SUPPLIER_DIRECT",
  CMARKET_AGENCY: "CMARKET_AGENCY",
} as const;

export type AdminMallUnitFeeDtoQuotedSource =
  (typeof AdminMallUnitFeeDtoQuotedSource)[keyof typeof AdminMallUnitFeeDtoQuotedSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminMallUnitFeeDtoQuotedSource = {
  UNIT_AMOUNT: "UNIT_AMOUNT",
  UNIT_BP: "UNIT_BP",
  STOREFRONT_BP: "STOREFRONT_BP",
  DEFAULT_BP: "DEFAULT_BP",
} as const;

export interface AdminMallUnitFeeDto {
  /** 이행 단위 id */
  unitId: string;
  orderNo: string;
  /** 주문 상태 */
  orderStatus: string;
  supplierId: string;
  unitStatus: AdminMallUnitFeeDtoUnitStatus;
  /** @nullable */
  route?: AdminMallUnitFeeDtoRoute;
  /** @nullable */
  dealType?: AdminMallUnitFeeDtoDealType;
  /** 이 단위가 씨마켓 수수료 청구 대상인가(DIRECT × SUPPLIER_DIRECT × PER_ORDERER). SAFE 는 씨마켓 몰 원장이 걷는다. */
  billable: boolean;
  /** 이 공급사 몫 공급가액(수수료 기준) */
  supply: number;
  vat: number;
  /** @nullable */
  feeBpOverride?: number | null;
  /** @nullable */
  feeAmountOverride?: number | null;
  /**
   * 몰 요율(bp)
   * @nullable
   */
  storefrontDirectFeeBp?: number | null;
  /** 씨마켓몰 기본 수수료(bp) — 5% */
  defaultBp: number;
  /** 지금 규칙으로 계산한 청구 금액(원) — 결제 금액(공급가액+부가세) × 요율, 10원 미만 절사. 등록된 금액과 다르면 정정이 필요한 상태다. */
  quotedAmount: number;
  /**
   * 적용 요율(bp). 정액이면 null.
   * @nullable
   */
  quotedBp?: number | null;
  quotedSource: AdminMallUnitFeeDtoQuotedSource;
  /**
   * 씨마켓 청구 참조
   * @nullable
   */
  billReference?: string | null;
  /**
   * 마지막으로 등록한 청구 금액
   * @nullable
   */
  billAmount?: number | null;
  /**
   * 살아 있는 청구의 등록 시각. null = 청구 없음.
   * @nullable
   */
  billRegisteredAt?: string | null;
  /**
   * 비대상 유예 표식 시각(수수료 0원·씨마켓 짝 없음). 7일 뒤 재시도.
   * @nullable
   */
  billIneligibleAt?: string | null;
  /**
   * 마지막으로 청구를 접은 시각
   * @nullable
   */
  billCanceledAt?: string | null;
}

export interface AdminMallUnitFeeListDto {
  units: AdminMallUnitFeeDto[];
}

/**
 * REGISTERED = 새 청구 · DUPLICATE = 같은 청구가 이미 살아 있음 · INELIGIBLE = 0원/씨마켓 짝 없음(유예) · SKIPPED = 아직 구매확정 전이거나 비대상(조정값만 저장됨) · PAID_KEPT = 기납부라 종전 청구 유지 · FAILED = 씨마켓 호출 실패
 */
export type AdminMallUnitFeeBillOutcomeDtoStatus =
  (typeof AdminMallUnitFeeBillOutcomeDtoStatus)[keyof typeof AdminMallUnitFeeBillOutcomeDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminMallUnitFeeBillOutcomeDtoStatus = {
  REGISTERED: "REGISTERED",
  DUPLICATE: "DUPLICATE",
  INELIGIBLE: "INELIGIBLE",
  SKIPPED: "SKIPPED",
  PAID_KEPT: "PAID_KEPT",
  FAILED: "FAILED",
} as const;

export interface AdminMallUnitFeeBillOutcomeDto {
  /** REGISTERED = 새 청구 · DUPLICATE = 같은 청구가 이미 살아 있음 · INELIGIBLE = 0원/씨마켓 짝 없음(유예) · SKIPPED = 아직 구매확정 전이거나 비대상(조정값만 저장됨) · PAID_KEPT = 기납부라 종전 청구 유지 · FAILED = 씨마켓 호출 실패 */
  status: AdminMallUnitFeeBillOutcomeDtoStatus;
  /** @nullable */
  reason?: string | null;
  /** @nullable */
  amount?: number | null;
}

export interface UpdateMallUnitFeeResultDto {
  unit: AdminMallUnitFeeDto;
  bill: AdminMallUnitFeeBillOutcomeDto;
}

export interface UpdateMallUnitFeeDto {
  /**
   * 이 단위에만 적용할 요율(bp). null 로 보내면 지운다. 정액과 같이 보낼 수 없다.
   * @nullable
   */
  feeBpOverride?: number | null;
  /**
   * 이 단위에만 적용할 정액(원). 0 = 청구 없음. null 로 보내면 지운다. 요율과 같이 보낼 수 없다.
   * @nullable
   */
  feeAmountOverride?: number | null;
  /** true 면 요율·정액 조정을 모두 지우고 몰 요율/전역으로 되돌린다. */
  clear?: boolean;
}

export interface BulkOfferResultDto {
  dryRun: boolean;
  /** 조건에 맞는 공급사 품목 수 */
  candidates: number;
  /** 새로 담길(담긴) 수 */
  willCreate: number;
  /** 실제로 만들어진 수(dryRun 이면 0) */
  created: number;
  /** 이미 담겨 노출 대상인 수 */
  alreadyActive: number;
  /** 이미 담겼지만 비활성인 수 — 일괄 활성화로 되살릴 수 있다 */
  alreadyInactive: number;
  /** 제외 목록에 걸려 건너뛴 수 */
  excluded: number;
  /**
   * 되돌리기의 단위
   * @nullable
   */
  batchId?: string | null;
}

/**
 * linked 면 승인과 동시에 공급사 단가로 노출된다. manual 이면 공급사가 몰 단가를 적어야 노출된다
 */
export type BulkOfferDtoPriceSource =
  (typeof BulkOfferDtoPriceSource)[keyof typeof BulkOfferDtoPriceSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BulkOfferDtoPriceSource = {
  manual: "manual",
  linked: "linked",
} as const;

export interface BulkOfferDto {
  /** 어느 업체의 품목을 담을지 */
  supplierId: string;
  /** 품명 부분일치. 비우면 전 품목 */
  q?: string;
  /** 카테고리 한정. 대분류를 주면 그 아래 소분류까지 전부 대상 */
  categoryIds?: string[];
  /** 공급가 하한(원) */
  priceMin?: number;
  /** 공급가 상한(원) */
  priceMax?: number;
  /** linked 면 승인과 동시에 공급사 단가로 노출된다. manual 이면 공급사가 몰 단가를 적어야 노출된다 */
  priceSource?: BulkOfferDtoPriceSource;
  /** linked 일 때 얹을 가산율(만분율). 0 이면 공급사 단가 그대로 */
  markupBp?: number;
  /** true 면 건수만 계산하고 아무것도 만들지 않는다 */
  dryRun?: boolean;
}

export interface BulkActiveResultDto {
  dryRun: boolean;
  willChange: number;
  changed: number;
  /** @nullable */
  batchId?: string | null;
}

export interface BulkActiveDto {
  /** 업체 한정. 비우면 이 몰의 전 상품 */
  supplierId?: string;
  /** true=노출 재개, false=노출 중지 */
  isActive: boolean;
  itemIds?: string[];
  dryRun?: boolean;
}

export interface BulkPriceSampleDto {
  name: string;
  /** @nullable */
  oldPrice?: number | null;
  /** @nullable */
  newPrice?: number | null;
  /** 변동 배수. 1 에서 멀수록 확인이 필요하다 */
  ratio: number;
}

export type BulkPriceResultDtoMode =
  (typeof BulkPriceResultDtoMode)[keyof typeof BulkPriceResultDtoMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BulkPriceResultDtoMode = {
  copy_base: "copy_base",
  link: "link",
  unlink: "unlink",
  clear: "clear",
} as const;

export interface BulkPriceResultDto {
  dryRun: boolean;
  mode: BulkPriceResultDtoMode;
  /** 조건에 걸린 줄 수 */
  targets: number;
  /** 값이 바뀔(바뀐) 줄 수 */
  willChange: number;
  /** 실제로 바뀐 줄 수(dryRun 이면 0) */
  changed: number;
  /** 조건에 안 맞아 건너뛴 줄 수 */
  skipped: number;
  /** 공급사 단가가 없어 복사할 값이 없는 줄 수 */
  noBasePrice: number;
  /** 변동폭이 큰 순 최대 20건. 2만 건에서 오타를 찾는 유일한 창 */
  samples: BulkPriceSampleDto[];
  /** @nullable */
  batchId?: string | null;
}

/**
 * copy_base=내 단가 복사 / link=내 단가에 연동(이후 자동 추종) / unlink=지금 값으로 굳히기 / clear=몰 단가 지우기
 */
export type BulkPriceDtoMode =
  (typeof BulkPriceDtoMode)[keyof typeof BulkPriceDtoMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BulkPriceDtoMode = {
  copy_base: "copy_base",
  link: "link",
  unlink: "unlink",
  clear: "clear",
} as const;

export interface BulkPriceDto {
  /** copy_base=내 단가 복사 / link=내 단가에 연동(이후 자동 추종) / unlink=지금 값으로 굳히기 / clear=몰 단가 지우기 */
  mode: BulkPriceDtoMode;
  /** 가산율(만분율) */
  markupBp?: number;
  /** 이미 값이 있는 줄도 덮어쓸지. 기본은 빈 칸만 채운다 */
  overwrite?: boolean;
  /** 지정하면 그 품목만. 비우면 이 몰의 내 전 품목 */
  itemIds?: string[];
  dryRun?: boolean;
}

export type BatchDtoAction =
  (typeof BatchDtoAction)[keyof typeof BatchDtoAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchDtoAction = {
  bulk_offer: "bulk_offer",
  bulk_price: "bulk_price",
  bulk_active: "bulk_active",
  rule_apply: "rule_apply",
} as const;

/**
 * @nullable
 */
export type BatchDtoParams = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type BatchDtoResult = { [key: string]: unknown } | null;

export interface BatchDto {
  id: string;
  action: BatchDtoAction;
  /** @nullable */
  supplierId?: string | null;
  /** @nullable */
  supplierName?: string | null;
  /** 바뀐 줄 수 */
  affected: number;
  /** @nullable */
  params?: BatchDtoParams;
  /** @nullable */
  result?: BatchDtoResult;
  /** @nullable */
  undoneAt?: string | null;
  /** @nullable */
  undoneCount?: number | null;
  createdAt: string;
  /** 되돌릴 수 있는 작업인지 */
  canUndo: boolean;
}

export interface BatchListResponseDto {
  items: BatchDto[];
  total: number;
}

export interface UndoBatchResultDto {
  batchId: string;
  /** 되돌린 줄 수 */
  undone: number;
  /** 그 뒤에 공급사가 손대서 그대로 둔 줄 수 */
  skipped: number;
}

export type RuleDtoScope = (typeof RuleDtoScope)[keyof typeof RuleDtoScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RuleDtoScope = {
  all: "all",
  category: "category",
} as const;

export type RuleDtoAutoPriceSource =
  (typeof RuleDtoAutoPriceSource)[keyof typeof RuleDtoAutoPriceSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RuleDtoAutoPriceSource = {
  none: "none",
  linked: "linked",
} as const;

export interface RuleDto {
  id: string;
  supplierId: string;
  /** @nullable */
  supplierName?: string | null;
  scope: RuleDtoScope;
  /** @nullable */
  categoryIds?: string[] | null;
  /** @nullable */
  q?: string | null;
  /** @nullable */
  priceMin?: number | null;
  /** @nullable */
  priceMax?: number | null;
  autoPriceSource: RuleDtoAutoPriceSource;
  autoMarkupBp: number;
  isActive: boolean;
  /** @nullable */
  lastAppliedAt?: string | null;
  /** @nullable */
  lastAppliedCount?: number | null;
  createdAt: string;
}

export type CreateRuleDtoScope =
  (typeof CreateRuleDtoScope)[keyof typeof CreateRuleDtoScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateRuleDtoScope = {
  all: "all",
  category: "category",
} as const;

/**
 * linked 면 규칙이 넣은 품목이 공급사 단가로 곧바로 노출된다
 */
export type CreateRuleDtoAutoPriceSource =
  (typeof CreateRuleDtoAutoPriceSource)[keyof typeof CreateRuleDtoAutoPriceSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateRuleDtoAutoPriceSource = {
  none: "none",
  linked: "linked",
} as const;

export interface CreateRuleDto {
  supplierId: string;
  scope?: CreateRuleDtoScope;
  categoryIds?: string[];
  q?: string;
  priceMin?: number;
  priceMax?: number;
  /** linked 면 규칙이 넣은 품목이 공급사 단가로 곧바로 노출된다 */
  autoPriceSource?: CreateRuleDtoAutoPriceSource;
  autoMarkupBp?: number;
}

export type UpdateRuleDtoScope =
  (typeof UpdateRuleDtoScope)[keyof typeof UpdateRuleDtoScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateRuleDtoScope = {
  all: "all",
  category: "category",
} as const;

export type UpdateRuleDtoAutoPriceSource =
  (typeof UpdateRuleDtoAutoPriceSource)[keyof typeof UpdateRuleDtoAutoPriceSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateRuleDtoAutoPriceSource = {
  none: "none",
  linked: "linked",
} as const;

export interface UpdateRuleDto {
  isActive?: boolean;
  scope?: UpdateRuleDtoScope;
  categoryIds?: string[];
  q?: string;
  autoPriceSource?: UpdateRuleDtoAutoPriceSource;
  autoMarkupBp?: number;
}

export interface ApplyRulesResultDto {
  /** 적용한 규칙 수 */
  rules: number;
  /** 새로 담긴 품목 수 */
  created: number;
}

export interface ExclusionDto {
  id: string;
  itemId: string;
  /** @nullable */
  itemName?: string | null;
  /** @nullable */
  supplierId?: string | null;
  /** @nullable */
  reason?: string | null;
  createdAt: string;
}

export interface CreateExclusionDto {
  itemId: string;
  /** 비우면 이 몰 전체에서 제외(어느 업체가 내든 안 담긴다) */
  supplierId?: string;
  reason?: string;
}

export type OfferingRequestDtoStatus =
  (typeof OfferingRequestDtoStatus)[keyof typeof OfferingRequestDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OfferingRequestDtoStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
} as const;

export interface OfferingRequestDto {
  id: string;
  storefrontId: string;
  supplierId: string;
  /** @nullable */
  supplierName?: string | null;
  itemId: string;
  /** @nullable */
  itemName?: string | null;
  /** @nullable */
  basePrice?: number | null;
  /** @nullable */
  note?: string | null;
  status: OfferingRequestDtoStatus;
  /** @nullable */
  decisionNote?: string | null;
  createdAt: string;
}

export interface RequestListResponseDto {
  items: OfferingRequestDto[];
  total: number;
}

export type DecideRequestDtoStatus =
  (typeof DecideRequestDtoStatus)[keyof typeof DecideRequestDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DecideRequestDtoStatus = {
  approved: "approved",
  rejected: "rejected",
} as const;

/**
 * 승인할 때 만들 줄의 가격 출처
 */
export type DecideRequestDtoPriceSource =
  (typeof DecideRequestDtoPriceSource)[keyof typeof DecideRequestDtoPriceSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DecideRequestDtoPriceSource = {
  manual: "manual",
  linked: "linked",
} as const;

export interface DecideRequestDto {
  status: DecideRequestDtoStatus;
  /** 승인할 때 만들 줄의 가격 출처 */
  priceSource?: DecideRequestDtoPriceSource;
  decisionNote?: string;
}

export interface SupplierPriceAxisStatusDto {
  supplierId: string;
  /** @nullable */
  supplierName?: string | null;
  /** 활성 단가 수 */
  priceCount: number;
  /** 그중 부가세 포함가로 라벨된 수 */
  inclusiveCount: number;
  /** 과세/면세를 모르는 품목 수 */
  unknownTaxCategoryCount: number;
  /**
   * 축을 확인한 시각. 비어 있으면 몰이 이 업체 단가를 환산하지 않는다
   * @nullable
   */
  verifiedAt?: string | null;
  /** @nullable */
  note?: string | null;
}

/**
 * 면세·영세면 공급가액과 총액이 같다
 * @nullable
 */
export type PriceAxisSampleDtoTaxCategory =
  | (typeof PriceAxisSampleDtoTaxCategory)[keyof typeof PriceAxisSampleDtoTaxCategory]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceAxisSampleDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

export interface PriceAxisSampleDto {
  name: string;
  /** 지금 저장돼 있는 값(안 바뀐다) */
  basePrice: number;
  /** 정정 후 이 단가가 뜻하게 되는 공급가액 */
  supplyPrice: number;
  /** 정정 후 부가세까지 더한 총액 */
  totalPrice: number;
  /**
   * 면세·영세면 공급가액과 총액이 같다
   * @nullable
   */
  taxCategory?: PriceAxisSampleDtoTaxCategory;
}

export type SetSupplierPriceAxisResultDtoTaxType =
  (typeof SetSupplierPriceAxisResultDtoTaxType)[keyof typeof SetSupplierPriceAxisResultDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetSupplierPriceAxisResultDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface SetSupplierPriceAxisResultDto {
  dryRun: boolean;
  taxType: SetSupplierPriceAxisResultDtoTaxType;
  /** 이 업체의 활성 단가 수 */
  targets: number;
  /** 축이 바뀔(바뀐) 행 수 */
  willChange: number;
  /** 실제로 바뀐 행 수(dryRun 이면 0) */
  changed: number;
  /** 과세/면세를 모르는 품목 수. 이 품목들은 도장을 찍어도 환산하지 않는다 — 면세를 과세로 단정하면 가격이 조용히 9% 떨어진다 */
  unknownTaxCategory: number;
  /** 면세·영세 품목 수(축과 무관하게 값이 그대로다) */
  vatFree: number;
  /** 고가 순 최대 20건 */
  samples: PriceAxisSampleDto[];
  /** @nullable */
  batchId?: string | null;
}

/**
 * EXCLUSIVE=이 업체 단가는 공급가액 / INCLUSIVE=부가세 포함가. 값은 그대로 두고 축만 바꾼다
 */
export type SetSupplierPriceAxisDtoTaxType =
  (typeof SetSupplierPriceAxisDtoTaxType)[keyof typeof SetSupplierPriceAxisDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetSupplierPriceAxisDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface SetSupplierPriceAxisDto {
  /** EXCLUSIVE=이 업체 단가는 공급가액 / INCLUSIVE=부가세 포함가. 값은 그대로 두고 축만 바꾼다 */
  taxType: SetSupplierPriceAxisDtoTaxType;
  /** 일부 품목만 정정할 때. 비우면 이 업체의 활성 단가 전부 */
  itemIds?: string[];
  /** 축이 사실과 맞는지 확인했다는 도장. 이걸 찍어야 몰이 이 업체 단가를 환산한다. 일부 품목만 정정할 때는 찍히지 않는다 — 나머지 미확인분까지 환산 대상이 되기 때문이다 */
  markVerified?: boolean;
  /** 무엇으로 확인했는지(원본 파일 헤더·업체 회신·세금계산서 대조 등). 나중에 «왜 이렇게 정했나» 에 답하는 유일한 근거다 */
  note?: string;
  dryRun?: boolean;
}

export type SetTaxCategoryResultDtoTaxCategory =
  (typeof SetTaxCategoryResultDtoTaxCategory)[keyof typeof SetTaxCategoryResultDtoTaxCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetTaxCategoryResultDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

export interface SetTaxCategoryResultDto {
  dryRun: boolean;
  taxCategory: SetTaxCategoryResultDtoTaxCategory;
  targets: number;
  willChange: number;
  changed: number;
}

/**
 * TAXABLE=과세 / EXEMPT=면세 / ZERO_RATED=영세율
 */
export type SetTaxCategoryDtoTaxCategory =
  (typeof SetTaxCategoryDtoTaxCategory)[keyof typeof SetTaxCategoryDtoTaxCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetTaxCategoryDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

export interface SetTaxCategoryDto {
  /** TAXABLE=과세 / EXEMPT=면세 / ZERO_RATED=영세율 */
  taxCategory: SetTaxCategoryDtoTaxCategory;
  itemIds?: string[];
  /** 이 업체가 취급하는 품목 전부를 대상으로 할 때 */
  supplierId?: string;
  /** 비어 있는 것만 채운다. 품목은 업체 사이에 공유되므로, 이미 지정된 값을 덮으면 남이 확인해 둔 사실까지 지워진다 */
  onlyUnset?: boolean;
  dryRun?: boolean;
}

export type PriceAxisBatchDtoTaxType =
  (typeof PriceAxisBatchDtoTaxType)[keyof typeof PriceAxisBatchDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceAxisBatchDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export type PriceAxisBatchDtoPreviousTaxType =
  (typeof PriceAxisBatchDtoPreviousTaxType)[keyof typeof PriceAxisBatchDtoPreviousTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceAxisBatchDtoPreviousTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface PriceAxisBatchDto {
  id: string;
  supplierId: string;
  /** @nullable */
  supplierName?: string | null;
  taxType: PriceAxisBatchDtoTaxType;
  previousTaxType: PriceAxisBatchDtoPreviousTaxType;
  affected: number;
  /** 이 정정으로 «확인됨» 도장이 찍혔는지 */
  markedVerified: boolean;
  /** @nullable */
  note?: string | null;
  /** @nullable */
  undoneAt?: string | null;
  /** @nullable */
  undoneCount?: number | null;
  createdAt: string;
}

export interface UndoPriceAxisResultDto {
  batchId: string;
  undone: number;
}

export interface RecalculateTrustScoresResponseDto {
  /** 업데이트 성공한 공급업체 수 */
  updated_count: number;
  /** 업데이트 실패한 공급업체 수 */
  failed_count: number;
  /** 작업 소요 시간 (밀리초) */
  duration_ms: number;
}

/**
 * 백분위 구간 (1, 5, 10, 15, 20, 30, null)
 * @nullable
 */
export type SupplierTrustScoreDtoPercentile =
  | (typeof SupplierTrustScoreDtoPercentile)[keyof typeof SupplierTrustScoreDtoPercentile]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierTrustScoreDtoPercentile = {
  NUMBER_1: 1,
  NUMBER_5: 5,
  NUMBER_10: 10,
  NUMBER_15: 15,
  NUMBER_20: 20,
  NUMBER_30: 30,
} as const;

export interface SupplierTrustScoreDto {
  /**
   * 총점 (6개 컴포넌트 합산, 0-100)
   * @minimum 0
   * @maximum 100
   */
  total: number;
  /**
   * 인증 총점 (0-20)
   * @minimum 0
   * @maximum 20
   */
  certificationTotalScore: number;
  /**
   * 총 참여 점수 (0-10)
   * @minimum 0
   * @maximum 10
   */
  totalParticipationScore: number;
  /**
   * 계약 건수 점수 (0-20)
   * @minimum 0
   * @maximum 20
   */
  contractCountScore: number;
  /**
   * 총 금액 점수 (0-20)
   * @minimum 0
   * @maximum 20
   */
  totalAmountScore: number;
  /**
   * 총 수수료 점수 (0-20)
   * @minimum 0
   * @maximum 20
   */
  totalCommissionScore: number;
  /**
   * 최근 참여 점수 (0-10)
   * @minimum 0
   * @maximum 10
   */
  recentParticipationScore: number;
  /**
   * 백분위 구간 (1, 5, 10, 15, 20, 30, null)
   * @nullable
   */
  percentile: SupplierTrustScoreDtoPercentile;
  /**
   * 신뢰 점수 업데이트 시각
   * @nullable
   */
  updatedAt: string | null;
}

/**
 * 구독 상태 — TRIAL 무료 / ACTIVE 이용 중 / PAST_DUE 미납 / CANCELED 해지
 */
export type SupplierSemoSubscriptionDtoStatus =
  (typeof SupplierSemoSubscriptionDtoStatus)[keyof typeof SupplierSemoSubscriptionDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierSemoSubscriptionDtoStatus = {
  TRIAL: "TRIAL",
  ACTIVE: "ACTIVE",
  PAST_DUE: "PAST_DUE",
  CANCELED: "CANCELED",
} as const;

export interface SupplierSemoSubscriptionDto {
  /** 구독 ID */
  id: string;
  /** 구독 상태 — TRIAL 무료 / ACTIVE 이용 중 / PAST_DUE 미납 / CANCELED 해지 */
  status: SupplierSemoSubscriptionDtoStatus;
  /** 무료 끝나는 날(YYYY-MM-DD) */
  trialEndsAt: string;
  /** 다음 결제일(YYYY-MM-DD) */
  nextPaymentDate: string;
  /** 연속으로 거절된 횟수(미납) */
  failedAttempts: number;
  /**
   * 기간 끝 해지를 신청한 시각(없으면 null)
   * @nullable
   */
  cancelRequestedAt: string | null;
  /** 미납·해지라 새 기회(매칭·공고 알림)에서 빠지는 중인가 */
  blocksNewOpportunities: boolean;
}

/**
 * 가입 주문 상태
 */
export type SupplierSemoSignupDtoStatus =
  (typeof SupplierSemoSignupDtoStatus)[keyof typeof SupplierSemoSignupDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierSemoSignupDtoStatus = {
  MEMBER_CREATED: "MEMBER_CREATED",
  PAYING: "PAYING",
  PAYMENT_UNKNOWN: "PAYMENT_UNKNOWN",
  PAID: "PAID",
  ACTIVE: "ACTIVE",
  PAYMENT_FAILED: "PAYMENT_FAILED",
  REFUNDED: "REFUNDED",
} as const;

/**
 * 구독(없으면 null)
 * @nullable
 */
export type SupplierSemoSignupDtoSubscription =
  SupplierSemoSubscriptionDto | null;

export interface SupplierSemoSignupDto {
  /** 가입 주문 ID */
  orderId: string;
  /** 가입 주문 상태 */
  status: SupplierSemoSignupDtoStatus;
  /** 가입비(원) */
  feeAmount: number;
  /**
   * 가입비 결제 시각
   * @nullable
   */
  paidAt: string | null;
  /**
   * 가입비 환불 시각
   * @nullable
   */
  refundedAt: string | null;
  /** 들어온 경로(링크 ref)의 이름 */
  entryRefLabel: string;
  /**
   * «어떻게 알고 오셨나요» 답(답 안 했으면 null)
   * @nullable
   */
  heardFromLabel: string | null;
  /**
   * «기타» 등 직접 적은 말
   * @nullable
   */
  heardFromNote: string | null;
  /**
   * 구독(없으면 null)
   * @nullable
   */
  subscription: SupplierSemoSignupDtoSubscription;
}

/**
 * 가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입
 */
export type SupplierWithTrustScoreDtoSource =
  (typeof SupplierWithTrustScoreDtoSource)[keyof typeof SupplierWithTrustScoreDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierWithTrustScoreDtoSource = {
  direct: "direct",
  cmarket: "cmarket",
} as const;

/**
 * 세모 가입 창구(가입비·구독)로 왔으면 가입 주문·구독 요약, 아니면 null. 목록에서만 채운다(2026-10-18)
 * @nullable
 */
export type SupplierWithTrustScoreDtoSemoSignup = SupplierSemoSignupDto | null;

export interface SupplierWithTrustScoreDto {
  /** Supplier ID (UUID) */
  id: string;
  /**
   * User ID (로그인 ID)
   * @nullable
   */
  userId: string | null;
  /**
   * 이름
   * @nullable
   */
  name: string | null;
  /**
   * 연락용 이메일
   * @nullable
   */
  contactEmail: string | null;
  /**
   * 전화번호
   * @nullable
   */
  phone: string | null;
  /** 회사명 */
  companyName: string;
  /** 사업자 등록번호 */
  businessNumber: string;
  /** CEO 이름 */
  ceoName: string;
  /**
   * 회사 직인 이미지 URL
   * @nullable
   */
  companySealUrl: string | null;
  /** 회사 전화번호 */
  companyPhone: string;
  /** 담당자 이름 (suppliers.manager_name — users.name 은 상호다) */
  managerName: string;
  /** 담당자 연락처 (suppliers.manager_phone) */
  managerPhone: string;
  /**
   * 외부 Supplier ID (C-Market ID)
   * @nullable
   */
  externalSupplierId: string | null;
  /** 활성 상태 */
  isActive: boolean;
  /** 자동 견적 활성화 여부 */
  autoQuoteEnabled: boolean;
  /** 카카오 알림톡 수신 여부 */
  kakaoNotificationEnabled: boolean;
  /**
   * 마지막 로그인 일시
   * @nullable
   */
  lastLoginAt: string | null;
  /**
   * 생성 일시
   * @nullable
   */
  createdAt: string | null;
  /**
   * 마지막 업데이트 일시
   * @nullable
   */
  updatedAt: string | null;
  /** 신뢰 점수 정보 (6개 개별 점수 + 총점 + 백분위) */
  trustScore: SupplierTrustScoreDto;
  /** 가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입 */
  source: SupplierWithTrustScoreDtoSource;
  /**
   * 참여 수 — 들어간 견적 요청 대화방 수(지운 것·감춘 것 제외). 목록에서만 채우고 단건 조회는 null
   * @nullable
   */
  participationCount: number | null;
  /**
   * 견적 수 — 실제로 낸 견적 수(지운 것·감춘 것 제외). 목록에서만 채운다
   * @nullable
   */
  quoteCount: number | null;
  /**
   * 계약 수 — 취소가 아닌 계약(진행 중 + 완료). 목록에서만 채운다
   * @nullable
   */
  contractCount: number | null;
  /**
   * 세모 가입 창구(가입비·구독)로 왔으면 가입 주문·구독 요약, 아니면 null. 목록에서만 채운다(2026-10-18)
   * @nullable
   */
  semoSignup: SupplierWithTrustScoreDtoSemoSignup;
}

export interface EmbedJoinResponseDto {
  /** Embed URL (OTT는 URL fragment #token=... 에 포함) */
  embedUrl: string;
}

export interface UpdateSupplierKakaoNotificationDto {
  /** 알림톡 수신 여부 — true 면 발송, false 면 미발송 */
  enabled: boolean;
}

export interface UpdateSupplierActiveDto {
  /** 활성 여부 — false 면 로그인·세션 발급이 모두 막힌다(정지) */
  isActive: boolean;
}

/**
 * 성별 (M/F)
 * @nullable
 */
export type BuyerWithTrustScoreDtoGender =
  | (typeof BuyerWithTrustScoreDtoGender)[keyof typeof BuyerWithTrustScoreDtoGender]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BuyerWithTrustScoreDtoGender = {
  M: "M",
  F: "F",
} as const;

/**
 * 신뢰 백분위 (1, 5, 10, 15, 20, 30, null = 하위 70%)
 * @nullable
 */
export type BuyerWithTrustScoreDtoTrustPercentile =
  | (typeof BuyerWithTrustScoreDtoTrustPercentile)[keyof typeof BuyerWithTrustScoreDtoTrustPercentile]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BuyerWithTrustScoreDtoTrustPercentile = {
  NUMBER_1: 1,
  NUMBER_5: 5,
  NUMBER_10: 10,
  NUMBER_15: 15,
  NUMBER_20: 20,
  NUMBER_30: 30,
} as const;

/**
 * 가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입
 */
export type BuyerWithTrustScoreDtoSource =
  (typeof BuyerWithTrustScoreDtoSource)[keyof typeof BuyerWithTrustScoreDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BuyerWithTrustScoreDtoSource = {
  direct: "direct",
  cmarket: "cmarket",
} as const;

export interface BuyerWithTrustScoreDto {
  /** 구매자 ID */
  id: string;
  /**
   * 사용자 ID (users.id)
   * @nullable
   */
  userId: string | null;
  /**
   * 연락용 이메일
   * @nullable
   */
  contactEmail: string | null;
  /**
   * 휴대폰 번호
   * @nullable
   */
  phone: string | null;
  /**
   * 이름
   * @nullable
   */
  name: string | null;
  /**
   * 성별 (M/F)
   * @nullable
   */
  gender: BuyerWithTrustScoreDtoGender;
  /**
   * 생년월일 (YYYY-MM-DD)
   * @nullable
   */
  birthDate: string | null;
  /**
   * 신뢰 점수 (0-100)
   * @nullable
   */
  trustScore: number | null;
  /**
   * 신뢰 백분위 (1, 5, 10, 15, 20, 30, null = 하위 70%)
   * @nullable
   */
  trustPercentile: BuyerWithTrustScoreDtoTrustPercentile;
  /** 활성 상태 */
  isActive: boolean;
  /** 카카오 알림톡 수신 여부 */
  kakaoNotificationEnabled: boolean;
  /**
   * 마지막 로그인 일시
   * @nullable
   */
  lastLoginAt: string | null;
  /** 생성 날짜 */
  createdAt: string;
  /** 가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입 */
  source: BuyerWithTrustScoreDtoSource;
  /**
   * 씨마켓 발주기관명 (자체가입은 null)
   * @nullable
   */
  organizationName?: string | null;
  /**
   * 씨마켓 회원 ID (자체가입은 null)
   * @nullable
   */
  externalBuyerId?: string | null;
}

export interface PaymentCardDto {
  /** 카드 고유 식별자 (UUID) */
  id: string;
  /** 마스킹된 카드번호 (PCI-DSS 준수) */
  maskedCardNumber: string;
  /** 카드사 코드 (01: 비씨, 02: 국민, 06: 신한 등) */
  cardCode?: string;
  /** 주 결제수단 여부 */
  isPrimary: boolean;
  /** 카드 등록일시 */
  registeredAt: string;
}

/**
 * Subscription plan type
 */
export type SubscriptionResponseDtoPlanType =
  (typeof SubscriptionResponseDtoPlanType)[keyof typeof SubscriptionResponseDtoPlanType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionResponseDtoPlanType = {
  FREE: "FREE",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
  TEST: "TEST",
} as const;

/**
 * Billing cycle
 */
export type SubscriptionResponseDtoBillingCycle =
  (typeof SubscriptionResponseDtoBillingCycle)[keyof typeof SubscriptionResponseDtoBillingCycle];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionResponseDtoBillingCycle = {
  MONTHLY: "MONTHLY",
} as const;

/**
 * Subscription status
 */
export type SubscriptionResponseDtoStatus =
  (typeof SubscriptionResponseDtoStatus)[keyof typeof SubscriptionResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionResponseDtoStatus = {
  ACTIVE: "ACTIVE",
  CANCELED: "CANCELED",
  FAILED: "FAILED",
} as const;

/**
 * Pending plan type (for scheduled plan changes)
 * @nullable
 */
export type SubscriptionResponseDtoPendingPlanType =
  | (typeof SubscriptionResponseDtoPendingPlanType)[keyof typeof SubscriptionResponseDtoPendingPlanType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionResponseDtoPendingPlanType = {
  FREE: "FREE",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
  TEST: "TEST",
} as const;

export interface SubscriptionResponseDto {
  /** Subscription ID */
  id: string;
  /** Buyer ID */
  buyerId: string;
  /** Subscription plan type */
  planType: SubscriptionResponseDtoPlanType;
  /** Monthly subscription amount in KRW */
  amount: number;
  /** Billing cycle */
  billingCycle: SubscriptionResponseDtoBillingCycle;
  /** Next payment date (YYYY-MM-DD) */
  nextPaymentDate: string;
  /** Subscription status */
  status: SubscriptionResponseDtoStatus;
  /** Created at timestamp */
  createdAt: string;
  /** Last updated at timestamp */
  updatedAt: string;
  /**
   * Canceled at timestamp (if canceled)
   * @nullable
   */
  canceledAt?: string | null;
  /**
   * Cancellation reason (if provided)
   * @nullable
   */
  cancellationReason?: string | null;
  /**
   * Pending plan type (for scheduled plan changes)
   * @nullable
   */
  pendingPlanType?: SubscriptionResponseDtoPendingPlanType;
  /**
   * Scheduled plan change date (YYYY-MM-DD)
   * @nullable
   */
  scheduledPlanChangeAt?: string | null;
  /** Whether the subscription is currently under a promotion */
  isPromotional: boolean;
  /** Whether the subscription is a free trial (e.g. signup bonus) */
  isTrial: boolean;
  /**
   * Applied promotion code (if any)
   * @nullable
   */
  promotionCode?: string | null;
  /** Whether this is a permanent subscription (no expiry, nextPaymentDate >= 2090) */
  isPermanent: boolean;
}

export interface TermsAgreementResponseDto {
  /** Terms type (terms, privacy, marketing) */
  type: string;
  /** Whether user agreed */
  agreed: boolean;
  /** Terms version */
  version: string;
  /** Date of agreement */
  agreedAt: string;
  /**
   * Date of revocation (if applicable)
   * @nullable
   */
  revokedAt?: string | null;
  /**
   * Channel through which consent was given
   * @nullable
   */
  consentChannel?: string | null;
  /**
   * IP address at time of agreement
   * @nullable
   */
  ipAddress?: string | null;
  /**
   * User agent at time of agreement
   * @nullable
   */
  userAgent?: string | null;
}

/**
 * 성별 (M/F)
 * @nullable
 */
export type BuyerDetailDtoGender =
  | (typeof BuyerDetailDtoGender)[keyof typeof BuyerDetailDtoGender]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BuyerDetailDtoGender = {
  M: "M",
  F: "F",
} as const;

/**
 * 신뢰 백분위 (1, 5, 10, 15, 20, 30, null = 하위 70%)
 * @nullable
 */
export type BuyerDetailDtoTrustPercentile =
  | (typeof BuyerDetailDtoTrustPercentile)[keyof typeof BuyerDetailDtoTrustPercentile]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BuyerDetailDtoTrustPercentile = {
  NUMBER_1: 1,
  NUMBER_5: 5,
  NUMBER_10: 10,
  NUMBER_15: 15,
  NUMBER_20: 20,
  NUMBER_30: 30,
} as const;

/**
 * 가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입
 */
export type BuyerDetailDtoSource =
  (typeof BuyerDetailDtoSource)[keyof typeof BuyerDetailDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BuyerDetailDtoSource = {
  direct: "direct",
  cmarket: "cmarket",
} as const;

export interface BuyerDetailDto {
  /** 구매자 ID */
  id: string;
  /**
   * 사용자 ID (users.id)
   * @nullable
   */
  userId: string | null;
  /**
   * 연락용 이메일
   * @nullable
   */
  contactEmail: string | null;
  /**
   * 휴대폰 번호
   * @nullable
   */
  phone: string | null;
  /**
   * 이름
   * @nullable
   */
  name: string | null;
  /**
   * 성별 (M/F)
   * @nullable
   */
  gender: BuyerDetailDtoGender;
  /**
   * 생년월일 (YYYY-MM-DD)
   * @nullable
   */
  birthDate: string | null;
  /**
   * 신뢰 점수 (0-100)
   * @nullable
   */
  trustScore: number | null;
  /**
   * 신뢰 백분위 (1, 5, 10, 15, 20, 30, null = 하위 70%)
   * @nullable
   */
  trustPercentile: BuyerDetailDtoTrustPercentile;
  /** 활성 상태 */
  isActive: boolean;
  /** 카카오 알림톡 수신 여부 */
  kakaoNotificationEnabled: boolean;
  /**
   * 마지막 로그인 일시
   * @nullable
   */
  lastLoginAt: string | null;
  /** 생성 날짜 */
  createdAt: string;
  /** 가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입 */
  source: BuyerDetailDtoSource;
  /**
   * 씨마켓 발주기관명 (자체가입은 null)
   * @nullable
   */
  organizationName?: string | null;
  /**
   * 씨마켓 회원 ID (자체가입은 null)
   * @nullable
   */
  externalBuyerId?: string | null;
  /** Registered addresses */
  addresses: AddressResponseDto[];
  /** Payment cards */
  cards: PaymentCardDto[];
  /** Subscription plans */
  subscriptions: SubscriptionResponseDto[];
  /** Terms and agreements history */
  termsAgreements: TermsAgreementResponseDto[];
  /**
   * Withdrawal reason (if withdrawn)
   * @nullable
   */
  withdrawalReason?: string | null;
}

export interface RefundDetailedResponseDto {
  /** 환불 ID */
  id: string;
  /** 결제 트랜잭션 ID */
  paymentTransactionId: string;
  /** 환불 상태 */
  status: string;
  /** 환불 상태 설명 */
  statusDescription: string;
  /** 환불 금액 */
  refundAmount: number;
  /** 환불 사유 */
  refundReason: string;
  /** 환불 요청 일시 */
  requestedAt: string;
  /** 환불 요청자 ID */
  requestedBy?: string;
  /** 환불 승인 일시 */
  approvedAt?: string;
  /** 환불 승인자 ID */
  approvedBy?: string;
  /** 승인 메모 */
  approvalNote?: string;
  /** 환불 거부 일시 */
  rejectedAt?: string;
  /** 환불 거부자 ID */
  rejectedBy?: string;
  /** 거부 사유 */
  rejectionReason?: string;
  /** 환불 완료 일시 */
  completedAt?: string;
  /** 환불 실패 일시 */
  failedAt?: string;
  /** 에러 코드 */
  errorCode?: string;
  /** 에러 메시지 */
  errorMessage?: string;
  /** 환불 은행 */
  refundBank?: string;
  /** 환불 계좌번호 */
  refundAccountNumber?: string;
  /** 환불 예금주 */
  refundAccountHolder?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
}

/**
 * 결제 상태
 */
export type PaymentTransactionResponseDtoStatus =
  (typeof PaymentTransactionResponseDtoStatus)[keyof typeof PaymentTransactionResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentTransactionResponseDtoStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  FAILED: "FAILED",
  CANCELED: "CANCELED",
  EXPIRED: "EXPIRED",
} as const;

/**
 * 결제 수단 (CARD | CASH | DIRECT)
 */
export type PaymentTransactionResponseDtoPaymentMethod =
  (typeof PaymentTransactionResponseDtoPaymentMethod)[keyof typeof PaymentTransactionResponseDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentTransactionResponseDtoPaymentMethod = {
  CARD: "CARD",
  CASH: "CASH",
  DIRECT: "DIRECT",
} as const;

export interface PaymentTransactionResponseDto {
  /** 결제 트랜잭션 ID (MOID - Merchant Order ID) */
  id: string;
  /** 견적 응답 버전 ID (UUID) */
  quoteResponseVersionId: string;
  /**
   * 결제 카드 ID (UUID)
   * @nullable
   */
  paymentCardId: string | null;
  /** 결제 상태 */
  status: PaymentTransactionResponseDtoStatus;
  /**
   * PG 거래 번호 (Innopay 거래 ID)
   * @nullable
   */
  tid: string | null;
  /**
   * 결제 승인 시각 (ISO 8601)
   * @nullable
   */
  approvedAt: string | null;
  /**
   * 에러 코드 (Innopay API 에러 코드)
   * @nullable
   */
  errorCode: string | null;
  /**
   * 에러 메시지 (Innopay API 에러 메시지)
   * @nullable
   */
  errorMessage: string | null;
  /** 생성 시각 (ISO 8601) */
  createdAt: string;
  /** 수정 시각 (ISO 8601) */
  updatedAt: string;
  /** 사용자 ID (UUID) */
  userId: string;
  /**
   * 환불 ID (UUID)
   * @nullable
   */
  refundId: string | null;
  /** 결제 수단 (CARD | CASH | DIRECT) */
  paymentMethod: PaymentTransactionResponseDtoPaymentMethod;
  /**
   * 결제 만료 시각 (ISO 8601)
   * @nullable
   */
  expiresAt: string | null;
  /**
   * 결제 취소 시각 (ISO 8601)
   * @nullable
   */
  canceledAt: string | null;
}

export interface PendingCashPaymentDto {
  /** 결제 거래 번호 (MOID) */
  id: string;
  /** 사용자 ID (UUID) */
  userId: string;
  /** 사용자명 */
  userName: string;
  /** 사용자 이메일 */
  userEmail: string;
  /** 결제 금액 */
  amount: number;
  /** 세금 */
  taxAmount: number;
  /**
   * 프로젝트명 (nullable)
   * @nullable
   */
  projectName: string | null;
  /** 견적 응답 버전 ID */
  quoteResponseVersionId: string;
  /** 생성 시간 */
  createdAt: string;
  /** 만료 시간 (생성 시간으로부터 15분) */
  expiresAt: string;
  /**
   * 반려 시간 (null이면 아직 반려되지 않음)
   * @nullable
   */
  rejectedAt: string | null;
  /**
   * 반려 사유 (null이면 아직 반려되지 않음)
   * @nullable
   */
  rejectionReason: string | null;
}

export interface AdminCashPaymentDto {
  /** MOID */
  id: string;
  /** User ID */
  userId: string;
  /** User Name */
  userName: string;
  /** User Email */
  userEmail: string;
  /**
   * User Contact Email
   * @nullable
   */
  contactEmail: string | null;
  /** Payment Amount */
  amount: number;
  /** Tax Amount */
  taxAmount: number;
  /**
   * Project Name
   * @nullable
   */
  projectName: string | null;
  /** Quote Response Version ID */
  quoteResponseVersionId: string;
  /** Created At */
  createdAt: string;
  /** Expires At */
  expiresAt: string;
  /** Payment Status */
  status: string;
  /**
   * Approved At
   * @nullable
   */
  approvedAt: string | null;
  /**
   * Rejected At
   * @nullable
   */
  rejectedAt: string | null;
  /**
   * Canceled At
   * @nullable
   */
  canceledAt: string | null;
  /**
   * Rejection Reason
   * @nullable
   */
  rejectionReason: string | null;
}

export interface RejectPaymentDto {
  /** 반려 사유 */
  reason: string;
}

export interface AdminBulkUploadResultDto {
  /** 성공한 행 개수 */
  successCount: number;
  /** 실패한 행 개수 */
  errorCount: number;
  /** 에러 상세 메시지 목록 */
  errors: string[];
  /** 성공한 항목 이름 목록 */
  successItems?: string[];
}

export interface CategoryTreeNodeDto {
  /** 카테고리 ID (UUID) */
  id: string;
  /** 카테고리 이름 */
  name: string;
  /**
   * 카테고리 레벨
   * @minimum 1
   * @maximum 4
   */
  level: number;
  /**
   * 표시 순서
   * @minimum 0
   */
  displayOrder: number;
  /**
   * 아이콘 이름
   * @nullable
   */
  icon?: string | null;
  /**
   * 카테고리 설명
   * @nullable
   */
  description?: string | null;
  /** 활성 상태 */
  isActive: boolean;
  /** 자식 카테고리 목록 (재귀적) */
  children: CategoryTreeNodeDto[];
  /**
   * 하위 상품 개수
   * @minimum 0
   */
  productCount?: number;
}

export interface AdminCategoryItemDto {
  /**
   * CAS 등록번호 — 상품명에서 추출한 값. 시약이 아니면 null (KOSHA 매칭 여부와 무관하게 채워진다)
   * @nullable
   */
  casNo?: string | null;
  /**
   * 국내 기존화학물질 고유번호 (KE 번호). KOSHA 미등록이거나 미부여면 null
   * @nullable
   */
  keNo?: string | null;
  /**
   * UN 번호 (국제 위험물 운송번호). 위험물이 아니면 null
   * @nullable
   */
  unNo?: string | null;
  /**
   * EC 번호 (EU EINECS/ELINCS)
   * @nullable
   */
  enNo?: string | null;
  /**
   * KOSHA 기준 국문 표준 물질명
   * @nullable
   */
  chemNameKor?: string | null;
  /** 품목 ID (items_v2_base.id - UUID) */
  id: string;
  /** 상품명 */
  name: string;
  /**
   * 카테고리 ID (items_v2_categories.id - UUID)
   * @nullable
   */
  categoryId: string | null;
  /** 카테고리 경로 (표시용) */
  categoryPath: string;
  /** 기준 가격 (정가) */
  price: number;
  /**
   * 최저가 거래 단가
   * @nullable
   */
  lowestPrice: number | null;
  /**
   * 최저가 거래 날짜
   * @nullable
   */
  lowestPriceDate: string | null;
  /**
   * 최저가 거래 공급자명
   * @nullable
   */
  lowestPriceSupplierName: string | null;
  /** 카테고리 레벨 (0-3) */
  level: number;
  /**
   * 부모 카테고리 UUID
   * @nullable
   */
  parentId: string | null;
  /**
   * 제조사
   * @nullable
   */
  manufacturer: string | null;
  /**
   * 브랜드
   * @nullable
   */
  brand: string | null;
  /**
   * 상품코드
   * @nullable
   */
  code: string | null;
  /** 단위 */
  unit: string;
  /**
   * 이미지 URL
   * @nullable
   */
  imageUrl: string | null;
  /**
   * 규격1
   * @nullable
   */
  spec1: string | null;
  /**
   * 규격2
   * @nullable
   */
  spec2: string | null;
  /**
   * 규격3
   * @nullable
   */
  spec3: string | null;
  /** 취급 공급자 수 */
  supplierCount: number;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
}

export interface CategoryResponseDto {
  /** 카테고리 ID (UUID) */
  id: string;
  /** 카테고리 이름 */
  name: string;
  /**
   * 부모 카테고리 ID (null이면 최상위)
   * @nullable
   */
  parentId?: string | null;
  /**
   * 카테고리 레벨 (1-4)
   * @minimum 1
   * @maximum 4
   */
  level: number;
  /**
   * 표시 순서
   * @minimum 0
   */
  displayOrder: number;
  /**
   * 아이콘 이름
   * @nullable
   */
  icon?: string | null;
  /**
   * 카테고리 설명
   * @nullable
   */
  description?: string | null;
  /** 활성 상태 */
  isActive: boolean;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
}

export interface CreateCategoryDto {
  /**
   * 카테고리 이름
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * 부모 카테고리 ID (null이면 최상위)
   * @nullable
   */
  parentId?: string | null;
  /**
   * 카테고리 레벨 (1-4)
   * @minimum 1
   * @maximum 4
   */
  level: number;
  /**
   * 표시 순서 (0 이상)
   * @minimum 0
   */
  displayOrder?: number;
  /** 아이콘 */
  icon?: string;
  /** 카테고리 설명 */
  description?: string;
}

export interface UpdateCategoryDto {
  /**
   * 카테고리 이름
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /**
   * 표시 순서 (0 이상)
   * @minimum 0
   */
  displayOrder?: number;
  /**
   * 아이콘
   * @nullable
   */
  icon?: string | null;
  /**
   * 카테고리 설명
   * @nullable
   */
  description?: string | null;
  /** 활성 상태 (true=활성, false=비활성) */
  isActive?: boolean;
}

export interface ReorderCategoryDto {
  /**
   * 새로운 표시 순서 (0 이상)
   * @minimum 0
   */
  newOrder: number;
}

export interface FrequentCategoryDto {
  /** 말단 카테고리 id */
  categoryId: string;
  /** 말단 카테고리 이름(칩 글자) */
  name: string;
  /** «상위 > 하위» 전체 경로(칩 툴팁) */
  path: string;
  /** 최근 90일 사용 횟수 */
  useCount: number;
}

export interface DuplicateItemCandidateDto {
  /** 유사한 항목들을 묶는 그룹 ID (기준 물품의 ID) */
  groupId: string;
  /** 물품 ID */
  itemId: string;
  /** 물품명 */
  name: string;
  /**
   * 브랜드
   * @nullable
   */
  brand?: string | null;
  /**
   * 제조사
   * @nullable
   */
  manufacturer?: string | null;
  /**
   * 상품 코드(모델명)
   * @nullable
   */
  code?: string | null;
  /**
   * 최저가 거래단가
   * @nullable
   */
  price?: number | null;
  /** 공급사 수 */
  supplierCount: number;
  /** 기준 물품과의 유사도 점수 (0.0 ~ 1.0) */
  similarityScore: number;
  /**
   * 규격1
   * @nullable
   */
  spec1?: string | null;
  /**
   * 규격2
   * @nullable
   */
  spec2?: string | null;
  /**
   * 규격3
   * @nullable
   */
  spec3?: string | null;
  /** 그룹의 최고 유사도. 목록 정렬과 구간(밴드) 판정이 모두 이 값을 쓴다. */
  groupMaxScore: number;
}

export interface DuplicateCandidateBandDto {
  /** 구간 하한 (포함) */
  bandMin: number;
  /**
   * 구간 상한 (미포함). null 이면 상한 없음 — 완전 일치(1.0)를 담는 구간이다.
   * @nullable
   */
  bandMax: number | null;
  /** 이 구간에 속하는 그룹 수 */
  groupCount: number;
}

export interface DuplicateRecalculationStatusDto {
  /** 진행 중인 작업 존재 여부 */
  isProcessing: boolean;
}

/**
 * 상태 (기존, 추가, 충돌)
 */
export type MergePreviewSupplierDtoStatus =
  (typeof MergePreviewSupplierDtoStatus)[keyof typeof MergePreviewSupplierDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MergePreviewSupplierDtoStatus = {
  EXISTING: "EXISTING",
  ADDED: "ADDED",
  CONFLICT: "CONFLICT",
} as const;

export interface MergePreviewSupplierDto {
  /** 공급사 ID (UUID 또는 문자열) */
  supplierId: string;
  /** 공급사명 */
  supplierName: string;
  /** 상태 (기존, 추가, 충돌) */
  status: MergePreviewSupplierDtoStatus;
  /** 최종 예상 단가 */
  finalPrice: number;
  /** 충돌 시 보여줄 참고용 단가 (마스터 단가 등) */
  originalPrice?: number;
}

export interface MergePreviewResponseDto {
  /** 마스터 물품의 기존 공급자 수 */
  beforeCount: number;
  /** 병합 후 예상되는 순수 총 공급자 수 */
  afterCount: number;
  /** 마스터 물품과 이미 겹치는 공급사들의 ID 목록 (UUID 또는 문자열 ID) */
  overlappingSupplierIds: string[];
  /** 최종 예상 공급사 목록 */
  expectedSuppliers: MergePreviewSupplierDto[];
}

export interface MergeItemsDto {
  /** 대표(마스터) 물품 ID (이 물품으로 거래 이력 등이 모두 이관됩니다) */
  masterItemId: string;
  /** 병합되어 비활성화될 중복 물품 ID 목록 */
  duplicateItemIds: string[];
}

export interface MergeItemsResponseDto {
  /** 성공 여부 */
  success: boolean;
  /** 대표 물품 ID */
  masterItemId: string;
  /** 병합된 물품 개수 */
  mergedCount: number;
}

export interface AdminProductImageUploadResponseDto {
  /** 업로드된 이미지의 공개 URL (items.image_url 에 저장할 값) */
  imageUrl: string;
  /** 버킷 내 저장 경로 */
  filePath: string;
  /** 업로드한 원본 파일명 */
  fileName: string;
  /** 파일 크기 (bytes) */
  fileSize: number;
  /** 확장자에서 정규화한 Content-Type */
  mimeType: string;
}

export interface CreateProductResponseDto {
  /** 상품 ID */
  id: string;
  /** 상품명 */
  name: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 상품 코드 */
  code?: string;
  /** 단위 */
  unit: string;
  /** 가격 */
  price?: number;
  /** 이미지 URL */
  imageUrl?: string;
  /** 카테고리 ID */
  categoryId?: string;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 등록 Admin ID */
  createdByAdminId: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
}

export interface CreateAdminProductDto {
  /** 상품명 (필수) */
  name: string;
  /** 제조사 (선택) */
  manufacturer?: string;
  /** 브랜드 (선택) */
  brand?: string;
  /** 품목코드 (선택) */
  code?: string;
  /** 단위 (필수) */
  unit: string;
  /** 정가 (필수) */
  price: number;
  /** 이미지 URL (선택) */
  imageUrl?: string;
  /** 카테고리 ID (필수, UUID) */
  categoryId: string;
  /** 규격1 (선택) */
  spec1?: string;
  /** 규격2 (선택) */
  spec2?: string;
  /** 규격3 (선택) */
  spec3?: string;
}

/**
 * 상태 — needs_info 는 보완 요청(사유는 adminComment)
 */
export type SupplierItemRequestSummaryDtoStatus =
  (typeof SupplierItemRequestSummaryDtoStatus)[keyof typeof SupplierItemRequestSummaryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierItemRequestSummaryDtoStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  needs_info: "needs_info",
} as const;

export interface SupplierItemRequestSummaryDto {
  /** 요청 ID */
  id: string;
  /** Supplier ID (UUID) */
  supplierId: string;
  /** 업체명 (상호) */
  companyName?: string;
  /** 업체 코드 (Supplier ID) */
  supplierCode?: string;
  /** 상품명 */
  name: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /**
   * 단위
   * @nullable
   */
  unit: string | null;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 카테고리 ID */
  categoryId?: string;
  /** 카테고리명 */
  categoryName?: string;
  /** 요청 사유 */
  requestReason?: string;
  /** 상태 — needs_info 는 보완 요청(사유는 adminComment) */
  status: SupplierItemRequestSummaryDtoStatus;
  /** Admin 반려·보완 요청 사유 */
  adminComment?: string;
  /** 생성 일시 */
  createdAt?: string;
  /**
   * 수정 일시
   * @nullable
   */
  updatedAt: string | null;
}

/**
 * 추가 카테고리 IDs
 */
export type SupplierItemRequestDetailResponseDtoAdditionalCategoryIds = {
  [key: string]: unknown;
};

/**
 * 상태 — needs_info 는 보완 요청(사유는 adminComment)
 */
export type SupplierItemRequestDetailResponseDtoStatus =
  (typeof SupplierItemRequestDetailResponseDtoStatus)[keyof typeof SupplierItemRequestDetailResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierItemRequestDetailResponseDtoStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  needs_info: "needs_info",
} as const;

export interface SupplierItemRequestDetailResponseDto {
  /** 요청 ID */
  id: string;
  /** Supplier ID */
  supplierId: string;
  /** 업체명 (상호) */
  companyName?: string;
  /** 업체 코드 (Supplier ID) */
  supplierCode?: string;
  /** 상품명 */
  name: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /**
   * 단위
   * @nullable
   */
  unit: string | null;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 카테고리 ID */
  categoryId?: string;
  /** 카테고리명 */
  categoryName?: string;
  /** 추가 카테고리 IDs */
  additionalCategoryIds?: SupplierItemRequestDetailResponseDtoAdditionalCategoryIds;
  /** 요청 사유 */
  requestReason?: string;
  /** 상태 — needs_info 는 보완 요청(사유는 adminComment) */
  status: SupplierItemRequestDetailResponseDtoStatus;
  /** Admin 반려·보완 요청 사유 */
  adminComment?: string;
  /** 승인한 Admin ID */
  approvedByAdminId?: string;
  /** 승인 시 생성된 물품 ID */
  approvedItemId?: string;
  /** 생성 일시 */
  createdAt?: string;
  /**
   * 수정 일시
   * @nullable
   */
  updatedAt: string | null;
}

export interface ApprovalResultResponseDto {
  /** 요청 상태 */
  status: string;
  /** 요청 ID */
  requestId: string;
  /** 생성된 물품 ID */
  approvedItemId: string;
}

export interface ApproveSupplierItemRequestDto {
  /** 카테고리 ID (승인 시 지정/변경 가능) */
  categoryId?: string;
  /** 상품명 (승인 시 변경 가능) */
  name?: string;
  /** 단위 (승인 시 변경 가능) */
  unit?: string;
  /** 제조사 (승인 시 변경 가능) */
  manufacturer?: string;
  /** 브랜드 (승인 시 변경 가능) */
  brand?: string;
  /** 규격 1 (승인 시 변경 가능) */
  spec1?: string;
  /** 규격 2 (승인 시 변경 가능) */
  spec2?: string;
  /** 규격 3 (승인 시 변경 가능) */
  spec3?: string;
  /** 관리자 코멘트 (승인/반려 시) */
  adminComment?: string;
}

export interface RejectionResultResponseDto {
  /** 요청 상태 */
  status: string;
  /** 요청 ID */
  requestId: string;
  /** 거부 사유 */
  comment: string;
}

export interface RejectSupplierItemRequestDto {
  /** 거부 사유 */
  comment: string;
}

export interface QuoteLineMatchCandidateSpecsDto {
  /**
   * 규격1
   * @nullable
   */
  spec1?: string | null;
  /**
   * 규격2
   * @nullable
   */
  spec2?: string | null;
  /**
   * 규격3
   * @nullable
   */
  spec3?: string | null;
}

export interface QuoteLineMatchCandidateDto {
  /** 품목 ID (items_v2_base.id) */
  itemId: string;
  /** 상품명 */
  name: string;
  /**
   * 단위
   * @nullable
   */
  unit?: string | null;
  /**
   * 규격(합친 문자열)
   * @nullable
   */
  spec1?: string | null;
  /** 마스터 규격 칸별 원본(spec1~3, 합치지 않음) */
  specs?: QuoteLineMatchCandidateSpecsDto;
  /**
   * 모델명·제품번호(items_v2_base.code)
   * @nullable
   */
  code?: string | null;
  /**
   * 세모 상품코드(items_v2_base.product_code)
   * @nullable
   */
  productCode?: string | null;
  /**
   * 대표 이미지 URL
   * @nullable
   */
  imageUrl?: string | null;
  /**
   * 카테고리 경로(대 > 중 …)
   * @nullable
   */
  categoryName?: string | null;
  /** @nullable */
  brand?: string | null;
  /** @nullable */
  manufacturer?: string | null;
  /** @nullable */
  categoryId?: string | null;
  /**
   * 최저 거래 단가
   * @nullable
   */
  lowestPrice?: number | null;
  /** 취급 공급사 수 */
  supplierCount: number;
  /** 자동견적을 켠 공급사 수 */
  autoQuoteSupplierCount: number;
  /** 자동견적 가능 여부 */
  canAutoQuote: boolean;
  /** 이 후보를 낸 레인(alias·code·lexical·semantic·llm) */
  lanes: string[];
  /** 합산 점수 0~0.98 */
  score: number;
  /** 줄 단위와 물품 단위가 어긋난다 */
  unitMismatch: boolean;
}

export interface QuoteLineSuggestedNewDto {
  name: string;
  /** @nullable */
  brand?: string | null;
  /** @nullable */
  spec1?: string | null;
  /** @nullable */
  unit?: string | null;
}

export type QuoteLineMatchResultDtoKind =
  (typeof QuoteLineMatchResultDtoKind)[keyof typeof QuoteLineMatchResultDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteLineMatchResultDtoKind = {
  product: "product",
  service: "service",
  manufacturing: "manufacturing",
  disposal: "disposal",
  attachment_ref: "attachment_ref",
  unclear: "unclear",
} as const;

/**
 * 자동 부착 / 후보 제안 / 신규 후보 / 매칭 대상 아님
 */
export type QuoteLineMatchResultDtoBand =
  (typeof QuoteLineMatchResultDtoBand)[keyof typeof QuoteLineMatchResultDtoBand];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteLineMatchResultDtoBand = {
  auto: "auto",
  suggest: "suggest",
  new: "new",
  skip: "skip",
} as const;

/**
 * @nullable
 */
export type QuoteLineMatchResultDtoAutoReason =
  | (typeof QuoteLineMatchResultDtoAutoReason)[keyof typeof QuoteLineMatchResultDtoAutoReason]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteLineMatchResultDtoAutoReason = {
  "alias-buyer": "alias-buyer",
  "code-single": "code-single",
  score: "score",
} as const;

/**
 * 신규 등록 폼 미리 채움 값
 * @nullable
 */
export type QuoteLineMatchResultDtoSuggestedNew =
  QuoteLineSuggestedNewDto | null;

/**
 * ⑤ LLM 검증: chosen=후보 하나를 앞으로 올림 · none=후보 중엔 없다고 봄 · null=안 부름
 * @nullable
 */
export type QuoteLineMatchResultDtoVerified =
  | (typeof QuoteLineMatchResultDtoVerified)[keyof typeof QuoteLineMatchResultDtoVerified]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteLineMatchResultDtoVerified = {
  chosen: "chosen",
  none: "none",
} as const;

/**
 * ⑤ 가 고른 후보에 대한 LLM 확신 — sure(같은 물품 확실) · likely(아마도) · 안 골랐으면 null. 띠는 바꾸지 않는다(결정 A).
 * @nullable
 */
export type QuoteLineMatchResultDtoVerifiedConfidence =
  | (typeof QuoteLineMatchResultDtoVerifiedConfidence)[keyof typeof QuoteLineMatchResultDtoVerifiedConfidence]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteLineMatchResultDtoVerifiedConfidence = {
  sure: "sure",
  likely: "likely",
} as const;

export interface QuoteLineMatchResultDto {
  /** 요청 lines 의 순번 */
  index: number;
  kind: QuoteLineMatchResultDtoKind;
  /** 자동 부착 / 후보 제안 / 신규 후보 / 매칭 대상 아님 */
  band: QuoteLineMatchResultDtoBand;
  /**
   * 확신도 0~0.98
   * @nullable
   */
  confidence?: number | null;
  /** 별칭 키(정규화한 이름+규격+브랜드) */
  aliasKey: string;
  /** 뽑힌 모델번호 */
  codes: string[];
  /** @nullable */
  brand?: string | null;
  candidates: QuoteLineMatchCandidateDto[];
  /** @nullable */
  autoReason?: QuoteLineMatchResultDtoAutoReason;
  /**
   * 신규 등록 폼 미리 채움 값
   * @nullable
   */
  suggestedNew?: QuoteLineMatchResultDtoSuggestedNew;
  /** 검색 인프라 장애로 PG 폴백을 탔다(점수 낮춤) */
  degraded: boolean;
  /**
   * ⑤ LLM 검증: chosen=후보 하나를 앞으로 올림 · none=후보 중엔 없다고 봄 · null=안 부름
   * @nullable
   */
  verified?: QuoteLineMatchResultDtoVerified;
  /**
   * ⑤ 가 고른 후보에 대한 LLM 확신 — sure(같은 물품 확실) · likely(아마도) · 안 골랐으면 null. 띠는 바꾸지 않는다(결정 A).
   * @nullable
   */
  verifiedConfidence?: QuoteLineMatchResultDtoVerifiedConfidence;
}

export interface LinkSupplierItemRequestDto {
  /** 연결할 기존 물품 ID (items_v2_base.id) */
  itemId: string;
  /** 관리자 코멘트 — 공급사 요청 내역에 보인다 */
  adminComment?: string;
}

export interface InfoRequestResultResponseDto {
  /** 요청 상태 */
  status: string;
  /** 요청 ID */
  requestId: string;
  /** 보완 요청 사유 */
  comment: string;
}

export interface RequestInfoSupplierItemRequestDto {
  /** 보완 요청 사유 — 공급사 요청 내역에 그대로 보인다 */
  comment: string;
}

export interface ItemEditValuesDto {
  /**
   * 상품명
   * @nullable
   */
  name?: string | null;
  /**
   * 사진 URL — 업로드(POST external/items/edit-requests/image)가 돌려준 값을 그대로 넣는다
   * @nullable
   */
  imageUrl?: string | null;
  /**
   * 상세규격 1
   * @nullable
   */
  spec1?: string | null;
  /**
   * 상세규격 2
   * @nullable
   */
  spec2?: string | null;
  /**
   * 상세규격 3
   * @nullable
   */
  spec3?: string | null;
  /**
   * 단위
   * @nullable
   */
  unit?: string | null;
  /**
   * 제조사
   * @nullable
   */
  manufacturer?: string | null;
  /**
   * 브랜드
   * @nullable
   */
  brand?: string | null;
}

/**
 * 상태
 */
export type SupplierItemEditRequestSummaryDtoStatus =
  (typeof SupplierItemEditRequestSummaryDtoStatus)[keyof typeof SupplierItemEditRequestSummaryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierItemEditRequestSummaryDtoStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  needs_info: "needs_info",
} as const;

export type SupplierItemEditRequestSummaryDtoChangedFieldsItem =
  (typeof SupplierItemEditRequestSummaryDtoChangedFieldsItem)[keyof typeof SupplierItemEditRequestSummaryDtoChangedFieldsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierItemEditRequestSummaryDtoChangedFieldsItem = {
  name: "name",
  imageUrl: "imageUrl",
  spec1: "spec1",
  spec2: "spec2",
  spec3: "spec3",
  unit: "unit",
  manufacturer: "manufacturer",
  brand: "brand",
} as const;

export type SupplierItemEditRequestSummaryDtoStaleFieldsItem =
  (typeof SupplierItemEditRequestSummaryDtoStaleFieldsItem)[keyof typeof SupplierItemEditRequestSummaryDtoStaleFieldsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierItemEditRequestSummaryDtoStaleFieldsItem = {
  name: "name",
  imageUrl: "imageUrl",
  spec1: "spec1",
  spec2: "spec2",
  spec3: "spec3",
  unit: "unit",
  manufacturer: "manufacturer",
  brand: "brand",
} as const;

export interface SupplierItemEditRequestSummaryDto {
  /** 요청 ID */
  id: string;
  /** 공급사 ID (UUID) */
  supplierId: string;
  /** 업체명 (상호) */
  companyName?: string;
  /** 대상 물품 ID */
  itemId: string;
  /**
   * 대상 물품 품명(현재 마스터 값)
   * @nullable
   */
  itemName: string | null;
  /**
   * 물품 코드(product_code)
   * @nullable
   */
  itemCode: string | null;
  /** 카테고리 경로 (대분류 > 중분류) */
  categoryPath?: string;
  /** 상태 */
  status: SupplierItemEditRequestSummaryDtoStatus;
  /** 공급사가 고친 칸 */
  changedFields: SupplierItemEditRequestSummaryDtoChangedFieldsItem[];
  /**
   * 승인 시 실제로 반영한 칸. 대기·반려면 null
   * @nullable
   */
  appliedFields: string[] | null;
  /** 이후 — 제안 값 */
  proposed: ItemEditValuesDto;
  /** 이전 — 제출 당시 마스터 값 */
  before: ItemEditValuesDto;
  /** 지금 마스터 값(같은 칸만) — 제안이 큐에서 기다리는 동안 관리자가 먼저 고쳤을 수 있다 */
  current: ItemEditValuesDto;
  /** «이전»과 지금 마스터 값이 어긋난 칸 — 제출 뒤 마스터가 바뀐 자리다. 승인 전에 눈으로 확인할 것 */
  staleFields: SupplierItemEditRequestSummaryDtoStaleFieldsItem[];
  /**
   * 수정 사유
   * @nullable
   */
  requestReason: string | null;
  /**
   * 관리자 메모 · 반려/보완 사유
   * @nullable
   */
  adminComment: string | null;
  /**
   * 검토한 관리자 ID
   * @nullable
   */
  reviewedByAdminId: string | null;
  /**
   * 검토 시각
   * @nullable
   */
  reviewedAt: string | null;
  /** 제출 시각 */
  createdAt: string;
  /**
   * 갱신 시각
   * @nullable
   */
  updatedAt: string | null;
}

export interface SupplierItemEditRequestCountsDto {
  /** 대기 */
  pending: number;
  /** 승인 */
  approved: number;
  /** 반려 */
  rejected: number;
  /** 보완 요청 */
  needsInfo: number;
}

export type ApproveSupplierItemEditRequestDtoFieldsItem =
  (typeof ApproveSupplierItemEditRequestDtoFieldsItem)[keyof typeof ApproveSupplierItemEditRequestDtoFieldsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApproveSupplierItemEditRequestDtoFieldsItem = {
  name: "name",
  imageUrl: "imageUrl",
  spec1: "spec1",
  spec2: "spec2",
  spec3: "spec3",
  unit: "unit",
  manufacturer: "manufacturer",
  brand: "brand",
} as const;

export interface ApproveSupplierItemEditRequestDto {
  /** 마스터에 반영할 칸. 비우면 제안 전체를 받는다. 값: name · imageUrl · spec1 · spec2 · spec3 · unit · manufacturer · brand */
  fields?: ApproveSupplierItemEditRequestDtoFieldsItem[];
  /** 관리자 메모 — 공급사 수정 요청 내역에 그대로 보인다 */
  adminComment?: string;
}

export interface RejectSupplierItemEditRequestDto {
  /** 사유 — 공급사 수정 요청 내역에 그대로 보인다 */
  comment: string;
}

export interface UpdateProductResponseDto {
  /** 상품 ID */
  id: string;
  /** 상품명 */
  name: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 상품 코드 */
  code?: string;
  /** 단위 */
  unit: string;
  /** 가격 */
  price?: number;
  /** 이미지 URL */
  imageUrl?: string;
  /** 카테고리 ID */
  categoryId?: string;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 수정 일시 */
  updatedAt: string;
}

export interface UpdateAdminProductDto {
  /** 상품명 (선택) */
  name?: string;
  /** 제조사 (선택) */
  manufacturer?: string;
  /** 브랜드 (선택) */
  brand?: string;
  /** 품목코드 (선택) */
  code?: string;
  /** 단위 (선택) */
  unit?: string;
  /** 정가 (선택) */
  price?: number;
  /** 이미지 URL (선택) */
  imageUrl?: string;
  /** 카테고리 ID (선택, UUID) */
  categoryId?: string;
  /** 규격1 (선택) */
  spec1?: string;
  /** 규격2 (선택) */
  spec2?: string;
  /** 규격3 (선택) */
  spec3?: string;
}

export interface GetProductResponseDto {
  /** 상품 ID */
  id: string;
  /** 상품명 */
  name: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 상품 코드 */
  code?: string;
  /** 단위 */
  unit: string;
  /** 가격 */
  price?: number;
  /** 이미지 URL */
  imageUrl?: string;
  /** 카테고리 ID */
  categoryId?: string;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 등록 Admin ID */
  createdByAdminId: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
}

export interface PriceHistoryPointDto {
  /** 날짜 (YYYY-MM-DD or YYYY-MM) */
  date: string;
  /** 가격 */
  price: number;
}

/**
 * 최근 거래가의 부가세 축. INCLUSIVE 면 부가세 포함가라, 공급가액 단가와 나란히 놓고 그냥 비교하면 안 된다(10% 만큼 싸 보인다).
 */
export type VendorStatsResponseDtoTaxType =
  (typeof VendorStatsResponseDtoTaxType)[keyof typeof VendorStatsResponseDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VendorStatsResponseDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface VendorStatsResponseDto {
  /** 공급사 ID */
  id: string;
  /** 공급사명 (업체명_상호) */
  name: string;
  /** 담당자명 */
  managerName?: string;
  /** 담당자 휴대폰 */
  managerPhone?: string;
  /** 최근 거래가 — 업체가 입력한 그대로(축은 taxType). 순서는 이 숫자가 아니라 supplyPrice 기준. */
  price: number;
  /** 최근 거래가의 부가세 축. INCLUSIVE 면 부가세 포함가라, 공급가액 단가와 나란히 놓고 그냥 비교하면 안 된다(10% 만큼 싸 보인다). */
  taxType: VendorStatsResponseDtoTaxType;
  /** 최근 거래가를 공급가(VAT 별도) 기준 원 단위로 — 포함가 X 는 ⌊(20X+11)/22⌋. 업체끼리 순위·최저가(isLowest)는 이 기준으로 정한다(2026-10-30). */
  supplyPrice: number;
  /** 최근 거래일 (ISO) */
  updatedAt: string;
  /** 최저가 여부 — 공급가(VAT 별도) 기준으로 비교한다. 부가세 포함 단가는 공급가로 바꿔 견준다. */
  isLowest: boolean;
  /** 가격 변동 추이 */
  history: PriceHistoryPointDto[];
}

export interface DeleteProductResponseDto {
  /** 삭제된 상품 ID */
  id: string;
}

export interface MsdsCatalogSyncStartedDto {
  /** 처리 안내 메시지 */
  message: string;
}

export interface MsdsCatalogStatusDto {
  /** 적재된 화학물질 수 (CAS 기준) */
  total: number;
  /** KE 번호를 가진 화학물질 수 */
  withKeNo: number;
  /**
   * 최종 적재 시각 (한 번도 적재하지 않았으면 null)
   * @nullable
   */
  lastSyncedAt: string | null;
}

/**
 * 사용자 유형
 */
export type AdminInfoDtoUserType =
  (typeof AdminInfoDtoUserType)[keyof typeof AdminInfoDtoUserType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminInfoDtoUserType = {
  admin: "admin",
} as const;

export interface AdminInfoDto {
  /** 관리자 ID (UUID) */
  id: string;
  /** 사용자 ID */
  userId: string;
  /** 관리자 이름 */
  name?: string;
  /** 사용자 유형 */
  userType: AdminInfoDtoUserType;
  /** 계정 활성화 여부 */
  isActive: boolean;
  /** 생성 시간 */
  createdAt: string;
}

export interface AdminSignupResponseDto {
  /** 성공 메시지 */
  message: string;
  /** 회원가입된 관리자 정보 */
  admin: AdminInfoDto;
  /** 액세스 토큰 (JWT) */
  accessToken: string;
  /** Refresh Token */
  refreshToken: string;
  /** Expires In (seconds) */
  expiresIn: number;
  /** Token Type */
  tokenType: string;
}

export interface AdminSignupDto {
  /**
   * 관리자 사용자 ID
   * @minLength 3
   */
  userId: string;
  /**
   * 관리자 비밀번호
   * @minLength 6
   */
  password: string;
  /** 가입 인증 키 */
  secretKey: string;
}

export interface AdminLoginResponseDto {
  /** 성공 메시지 */
  message: string;
  /** 로그인한 관리자 정보 */
  admin: AdminInfoDto;
  /** 액세스 토큰 (JWT) */
  accessToken: string;
  /** Refresh Token */
  refreshToken: string;
  /** Expires In (seconds) */
  expiresIn: number;
  /** Token Type */
  tokenType: string;
}

export interface AdminLoginDto {
  /**
   * 관리자 사용자 ID
   * @minLength 3
   */
  userId: string;
  /**
   * 관리자 비밀번호
   * @minLength 6
   */
  password: string;
  /** 로그인 상태 유지 */
  rememberMe?: boolean;
}

/**
 * 신뢰등급
 */
export type PriceBandListItemDtoGrade =
  (typeof PriceBandListItemDtoGrade)[keyof typeof PriceBandListItemDtoGrade];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceBandListItemDtoGrade = {
  A: "A",
  B: "B",
  C: "C",
} as const;

export interface PriceBandListItemDto {
  /** SKU ID (12자리 안정 해시) */
  skuId: string;
  /** 대표 품명 */
  itemName: string;
  /**
   * 규격
   * @nullable
   */
  itemSpec: string | null;
  /** 신뢰등급 */
  grade: PriceBandListItemDtoGrade;
  /** 총 관측수 */
  skuN: number;
  /** 고유 공급사 수 */
  skuSuppliers: number;
  /**
   * 가격추세 라벨 — 급등|상승|보합|하락|급락, null 이면 trendBasis 로 사유 확인
   * @nullable
   */
  trendLabel: string | null;
  /**
   * 최근/이전 6개월 등락률(%)
   * @nullable
   */
  trendPct?: number | null;
  /**
   * trendLabel=null 일 때 사유 — 'no_recent_data'|'insufficient_history'
   * @nullable
   */
  trendBasis: string | null;
  /**
   * 수량 10배 증가 시 할인율(%), 항상 0~68.4
   * @nullable
   */
  qtyDiscountPct: number | null;
}

export interface PriceBandTierDto {
  /** 티어 순번 (0~11) */
  tierIdx: number;
  /** 티어 라벨 (예: "2-3", "1000+") */
  tier: string;
  /** 티어 하한 수량 */
  tierLo: number;
  /**
   * 티어 상한 수량 (null=상한 없음, 마지막 티어)
   * @nullable
   */
  tierHi: number | null;
  /** 실측 없음(β 보간 추정치) 여부 */
  isEstimated: boolean;
  /** 실측 관측수 (추정 셀은 0) */
  n: number;
  /** 낙찰 관측수 */
  nWon: number;
  /** 고유 공급사 수 */
  suppliers: number;
  /**
   * 가중 25백분위가 (추정 셀은 null)
   * @nullable
   */
  p25: number | null;
  /**
   * 가중 중앙값 (실측 또는 β 보간)
   * @nullable
   */
  p50: number | null;
  /**
   * 가중 75백분위가 (추정 셀은 null)
   * @nullable
   */
  p75: number | null;
  /** @nullable */
  priceMin: number | null;
  /** @nullable */
  priceMax: number | null;
  /**
   * 낙찰가 가중중앙값 (낙찰 관측 3건 이상일 때만)
   * @nullable
   */
  wonP50: number | null;
  /** @nullable */
  latestQuote: string | null;
  /**
   * 보간에 실제 쓰인 β (beta_sku 와 동일, 하위호환용)
   * @nullable
   */
  betaUsed: number | null;
  /**
   * SKU 자체 실측 기울기(또는 전역 β 폴백)
   * @nullable
   */
  betaSku: number | null;
  /**
   * 'sku'|'global'
   * @nullable
   */
  slopeSource: string | null;
}

export interface PriceBandTrendPointDto {
  /** 연월 (YYYY-MM) */
  ym: string;
  /** 그 달 관측수 */
  n: number;
  /**
   * SKU 중앙수량 기준 β 수량보정 중앙값
   * @nullable
   */
  p50Adj: number | null;
  /**
   * n>=3 일 때만 존재
   * @nullable
   */
  p25Adj: number | null;
  /**
   * n>=3 일 때만 존재
   * @nullable
   */
  p75Adj: number | null;
  /**
   * 수량보정 안 한 원본 중앙값
   * @nullable
   */
  p50Raw: number | null;
}

export interface PriceBandRawPointDto {
  /** 이 관측이 속한 티어 순번 */
  tierIdx: number;
  /** 실제 거래 수량 */
  qty: number;
  /**
   * 실제 단가
   * @nullable
   */
  price: number | null;
  /** 낙찰 관측 여부 */
  won: boolean;
}

export interface PriceBandSupplierTrendPointDto {
  /** 연월 (YYYY-MM) */
  ym: string;
  /** 그 달 이 공급사의 응찰 건수 */
  n: number;
  /** 그 달 이 공급사의 낙찰 건수 */
  nWon: number;
  /**
   * SKU 중앙수량 기준 β 수량보정 중앙 단가
   * @nullable
   */
  p50Adj: number | null;
  /**
   * 수량보정 안 한 원본 중앙 단가
   * @nullable
   */
  p50Raw: number | null;
  /**
   * 그 달 응찰 건의 중앙 수량 (보정 근거 확인용)
   * @nullable
   */
  qtyMedian: number | null;
}

export interface PriceBandSupplierSeriesDto {
  /** 공급사 ID */
  supplierId: string;
  /**
   * 상호
   * @nullable
   */
  supplierName: string | null;
  /** 이 SKU 에 대한 총 응찰 건수 */
  totalN: number;
  /** 이 SKU 에 대한 총 낙찰 건수 */
  totalWon: number;
  /** 첫 응찰 연월 (YYYY-MM) */
  firstYm: string;
  /** 마지막 응찰 연월 (YYYY-MM) */
  lastYm: string;
  /** 월별 시계열 (오름차순) */
  points: PriceBandSupplierTrendPointDto[];
}

export type PriceBandDetailDtoGrade =
  (typeof PriceBandDetailDtoGrade)[keyof typeof PriceBandDetailDtoGrade];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceBandDetailDtoGrade = {
  A: "A",
  B: "B",
  C: "C",
} as const;

export interface PriceBandDetailDto {
  skuId: string;
  skuKey: string;
  itemName: string;
  /** @nullable */
  itemSpec: string | null;
  /** @nullable */
  catName: string | null;
  grade: PriceBandDetailDtoGrade;
  skuN: number;
  skuNWon: number;
  skuSuppliers: number;
  /** @nullable */
  skuFirstQuote: string | null;
  /** @nullable */
  skuLastQuote: string | null;
  /**
   * 전체 관측 가중중앙값(최신성 가중, 티어 무관)
   * @nullable
   */
  skuP50All: number | null;
  /** @nullable */
  skuQtyMedian: number | null;
  /** @nullable */
  qtyDiscountPct: number | null;
  /** @nullable */
  trendLabel: string | null;
  /** @nullable */
  trendPct: number | null;
  /** @nullable */
  trendMonthsTotal: number | null;
  /** @nullable */
  trendBasis: string | null;
  /**
   * 전역 β (폴백/리포팅용 대표값)
   * @nullable
   */
  betaGlobal: number | null;
  /** 이 데이터의 배치 기준일 (compute.py --asof) */
  asof: string;
  /** 12개 수량티어 */
  tiers: PriceBandTierDto[];
  /** 월별 시간추이 */
  trend: PriceBandTrendPointDto[];
  /** 원시 관측치(최대 500개, 차트 산점도 전용) */
  points: PriceBandRawPointDto[];
  /** 공급사별 월간 가격 추이. 총 응찰 건수 내림차순. 배치에서 SKU당 상위 10곳만 적재하므로 꼬리 공급사는 빠져 있다 */
  supplierTrend: PriceBandSupplierSeriesDto[];
}

export interface AdminAddressDto {
  /** 주소 ID */
  id: string;
  /** 수령인명 */
  recipientName?: string;
  /** 연락처 */
  phone?: string;
  /** 우편번호 */
  postalCode?: string;
  /** 시/도 */
  province?: string;
  /** 시/군/구 */
  city?: string;
  /** 읍/면/동 */
  district?: string;
  /** 기본 주소 (도로명) */
  addressLine1?: string;
  /** 상세 주소 */
  addressLine2?: string;
}

export interface AdminUserSummaryDto {
  /** 사용자 ID */
  id: string;
  /** 사용자명 */
  name: string;
  /** 연락처 이메일 */
  contactEmail: string;
  /** 연락처 */
  phone: string;
  /** 회사명 */
  companyName?: string;
  /** 프로필 이미지 URL */
  profileImageUrl?: string;
  /** 신뢰도 백분위 */
  trustPercentile?: number;
}

export interface AdminProjectParticipantDto {
  /** 공급사 ID */
  supplierId: string;
  /** 업체명 (없으면 사용자 이름) */
  companyName: string;
  /**
   * 최신 견적 금액(원). 아직 견적을 내지 않았으면 null
   * @nullable
   */
  totalAmount?: number | null;
}

/**
 * 줄의 종류(매칭 엔진). product=물품(매칭 대상) · service · manufacturing · disposal · attachment_ref · unclear. 없으면 product.
 */
export type AdminProjectItemDtoKind =
  (typeof AdminProjectItemDtoKind)[keyof typeof AdminProjectItemDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectItemDtoKind = {
  product: "product",
  service: "service",
  manufacturing: "manufacturing",
  disposal: "disposal",
  attachment_ref: "attachment_ref",
  unclear: "unclear",
} as const;

export interface AdminProjectItemDto {
  /** 품목명 */
  name: string;
  /** 수량 */
  quantity: number;
  /** 단위 */
  unit: string;
  /** 금액 */
  amount: number;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 품목 코드 */
  itemCode?: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 품목 ID */
  itemId?: string;
  /** 매칭된 표준 품목명 */
  itemName?: string;
  /** 매칭된 표준 품목 코드 */
  itemCodeMatch?: string;
  /** 매칭된 표준 품목 단가 */
  itemPrice?: number;
  /** 매칭된 표준 품목 이미지 URL */
  itemImageUrl?: string;
  /** 매칭된 표준 품목 규격 요약 */
  itemSpec?: string;
  /** 줄의 종류(매칭 엔진). product=물품(매칭 대상) · service · manufacturing · disposal · attachment_ref · unclear. 없으면 product. */
  kind?: AdminProjectItemDtoKind;
  /** 매칭 출처: suggest · manual · auto:alias · auto:code · auto:score · register */
  matchSource?: string;
  /** 매칭 확신도(엔진, 0~0.98) */
  matchConfidence?: number;
  /** 매칭 시각(ISO) */
  matchedAt?: string;
  /** 이 줄로 이미 견적을 낸 업체명 목록. 비어 있지 않으면 매칭을 바꿀 수 없다(서버도 409 로 막는다) — 매칭을 바꾸면 이미 나간 견적이 무엇에 대한 금액인지 알 수 없게 되기 때문이다. */
  quotedSupplierNames?: string[];
}

export interface AdminProjectNoteDto {
  /** 메모 ID */
  id: string;
  /** 메모 내용 */
  body: string;
  /**
   * 작성 관리자 users.id. 계정이 삭제되면 null 이 되고 본문은 남는다. 삭제 버튼 노출 판단에 쓴다(자기 메모만 지울 수 있다).
   * @nullable
   */
  authorId?: string | null;
  /** 작성자 표시명. 이름이 없으면 이메일, 둘 다 없으면 "알 수 없음" */
  authorName: string;
  /** 작성 시각 (ISO 8601) */
  createdAt: string;
}

/**
 * 가입 경로. `cmarket` 이면 씨마켓을 통해 들어온 공고다(`users.source`).
 */
export type AdminProjectBuyerDtoSource =
  (typeof AdminProjectBuyerDtoSource)[keyof typeof AdminProjectBuyerDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectBuyerDtoSource = {
  direct: "direct",
  cmarket: "cmarket",
} as const;

export interface AdminProjectBuyerDto {
  /**
   * 발주기관명(`buyers.organization_name`). 세모 직가입 개인 구매자는 값이 없다.
   * @nullable
   */
  organizationName?: string | null;
  /** 계정 이름(`users.name`). 씨마켓 연동 건에서는 기관명이 아니라 담당자 직함이다 — 기관명 아래 보조 정보로만 쓴다. */
  accountName: string;
  /**
   * 씨마켓 회원 아이디(`buyers.external_buyer_id`). 씨마켓 연동 건에만 값이 있다.
   * @nullable
   */
  externalBuyerId?: string | null;
  /** 가입 경로. `cmarket` 이면 씨마켓을 통해 들어온 공고다(`users.source`). */
  source: AdminProjectBuyerDtoSource;
  /**
   * 실무 담당자명(`buyers.manager_name`)
   * @nullable
   */
  managerName?: string | null;
  /**
   * 담당자 부서/직위 — 툴팁에서 계정 이름의 정체를 설명한다.
   * @nullable
   */
  managerTitle?: string | null;
  /** 연락처 이메일 */
  contactEmail: string;
  /**
   * 연락처
   * @nullable
   */
  phone?: string | null;
}

export interface AdminProjectContractLinkDto {
  /** 계약 ID */
  id: string;
  /**
   * 계약번호
   * @nullable
   */
  contractNumber?: string | null;
  /** 계약 상태 DB 원값 */
  status: string;
  /**
   * 계약 금액(원)
   * @nullable
   */
  totalAmount?: number | null;
  /**
   * 계약 체결일
   * @nullable
   */
  createdAt?: string | null;
}

export interface AdminProjectMatchSummaryDto {
  /** 물품 줄 수. 0 이면 물품 목록이 없는 공고다. */
  totalItems: number;
  /** 표준 물품에 매칭된 줄 수 */
  matchedItems: number;
  /** 자동견적이 실제로 나갈 수 있는 줄 수 — 매칭됐고 취급 공급사가 1곳 이상인 줄. matchedItems 보다 작으면 매칭을 더 해도 견적이 늘지 않는다. */
  quotableItems: number;
}

/**
 * 상태. 계약 이력이 없으면 DB 원값(`IN_PROGRESS`·`ON_HOLD`·`CLOSED`)이고, 있으면 조회 전용 파생값으로 덮어써 실려 나간다 — 취소되지 않은 계약이 있으면 `CONTRACT_IN_PROGRESS`(계약 진행), 남은 것이 전부 취소분이면 `CONTRACT_CANCELED`(계약 취소). 파생값은 DB 에 저장되지 않는다. 화면은 `ON_HOLD`·`CLOSED` 를 모두 "시간 마감" 한 칸으로 그린다.
 */
export type AdminProjectDtoStatus =
  (typeof AdminProjectDtoStatus)[keyof typeof AdminProjectDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
  CONTRACT_CANCELED: "CONTRACT_CANCELED",
} as const;

/**
 * 거래 모델. brokerage=중개(발주기관↔공급사 직접), agency=구매대행(엔씨하이가 사서 판다)
 */
export type AdminProjectDtoTransactionModel =
  (typeof AdminProjectDtoTransactionModel)[keyof typeof AdminProjectDtoTransactionModel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectDtoTransactionModel = {
  brokerage: "brokerage",
  agency: "agency",
} as const;

/**
 * 카테고리 타입
 */
export type AdminProjectDtoCategoryType =
  (typeof AdminProjectDtoCategoryType)[keyof typeof AdminProjectDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 마감 주체. `BUYER`(발주기관이 직접 [마감하기]) · `ADMIN`(관리자 대행 마감) · `DEADLINE`(마감일이 지나 스케줄러가 내림). 아직 진행중이면 null. 이 컬럼이 생기기 전에 마감된 건은 `BUYER` 로 읽는다 — 그때는 관리자에게 마감 수단 자체가 없었다.
 * @nullable
 */
export type AdminProjectDtoClosedBy =
  | (typeof AdminProjectDtoClosedBy)[keyof typeof AdminProjectDtoClosedBy]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectDtoClosedBy = {
  BUYER: "BUYER",
  ADMIN: "ADMIN",
  DEADLINE: "DEADLINE",
} as const;

/**
 * 어느 길로 온 공고인가. domestic(국내) · trade(씨마켓 트레이드 — 인니 발주자, 채팅만 열림). 트레이드 공고의 마감·연장은 씨마켓이 관리한다.
 */
export type AdminProjectDtoChannel =
  (typeof AdminProjectDtoChannel)[keyof typeof AdminProjectDtoChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectDtoChannel = {
  domestic: "domestic",
  trade: "trade",
} as const;

/**
 * 가장 최근 메모. 목록의 마우스 오버 미리보기에 쓴다 — 메모가 있는지 알려면 상세로 들어가야 하는 동선을 없앤다. 메모가 없으면 null.
 * @nullable
 */
export type AdminProjectDtoLatestNote = AdminProjectNoteDto | null;

export interface AdminProjectDto {
  /** 프로젝트 ID */
  id: string;
  /** 프로젝트명 */
  projectName: string;
  /** 견적 요청 번호 */
  requestNumber: string;
  /** 상태. 계약 이력이 없으면 DB 원값(`IN_PROGRESS`·`ON_HOLD`·`CLOSED`)이고, 있으면 조회 전용 파생값으로 덮어써 실려 나간다 — 취소되지 않은 계약이 있으면 `CONTRACT_IN_PROGRESS`(계약 진행), 남은 것이 전부 취소분이면 `CONTRACT_CANCELED`(계약 취소). 파생값은 DB 에 저장되지 않는다. 화면은 `ON_HOLD`·`CLOSED` 를 모두 "시간 마감" 한 칸으로 그린다. */
  status: AdminProjectDtoStatus;
  /** 거래 모델. brokerage=중개(발주기관↔공급사 직접), agency=구매대행(엔씨하이가 사서 판다) */
  transactionModel: AdminProjectDtoTransactionModel;
  /** 취소되지 않은 계약 수. 계약 이력이 없거나 전부 취소됐으면 0. 2 이상이면 화면은 상태 대신 "계약 N건" 만 보여준다 — 여러 계약의 상태를 하나로 접으면 그게 어느 계약 얘기인지 알 수 없어지기 때문이다. */
  activeContractCount: number;
  /** 구매자 ID */
  userId: string;
  /** 생성일 */
  createdAt: string;
  /** 수정일 */
  updatedAt: string;
  /** 설명 */
  description?: string;
  /** 주소 정보 */
  address: AdminAddressDto;
  /** 구매자 정보 */
  user: AdminUserSummaryDto;
  /** 담당자명 */
  managerName?: string;
  /** 담당자 연락처 */
  managerContact: string;
  /** 카테고리 타입 */
  categoryType: AdminProjectDtoCategoryType;
  /** 마감 사유 */
  closeReason?: string;
  /**
   * 마감 시각 (ISO 8601). 마감 전이면 null. 마감일이 지나 스케줄러가 내린 건은 누른 사람이 없으므로 이 값도 비어 있다 — 그때의 기준 시각은 `deadline` 이다.
   * @nullable
   */
  closedAt?: string | null;
  /**
   * 마감 주체. `BUYER`(발주기관이 직접 [마감하기]) · `ADMIN`(관리자 대행 마감) · `DEADLINE`(마감일이 지나 스케줄러가 내림). 아직 진행중이면 null. 이 컬럼이 생기기 전에 마감된 건은 `BUYER` 로 읽는다 — 그때는 관리자에게 마감 수단 자체가 없었다.
   * @nullable
   */
  closedBy?: AdminProjectDtoClosedBy;
  /**
   * 마감을 누른 사람 이름. 주체가 `ADMIN` 일 때 «관리자 · 홍길동» 으로 쓴다. 이름을 되찾을 수 없는 예전 건은 null 이며, 그때는 주체 라벨만 보여준다.
   * @nullable
   */
  closedByName?: string | null;
  /**
   * 마감일시 (ISO 8601). 신규 등록은 한국시간 18:00 고정. 트레이드 공고는 씨마켓이 닫을 때가 마감이라 비어 있을 수 있다.
   * @nullable
   */
  deadline: string | null;
  /** 어느 길로 온 공고인가. domestic(국내) · trade(씨마켓 트레이드 — 인니 발주자, 채팅만 열림). 트레이드 공고의 마감·연장은 씨마켓이 관리한다. */
  channel: AdminProjectDtoChannel;
  /** 참여 업체 수. 이 공고에 열린 채팅방 개수이며 상세 화면의 "참여 업체" 와 같은 정의다. */
  participantCount: number;
  /** 참여 업체 요약(업체명·견적금액). 목록에서 마우스 오버로 "누가 얼마에" 를 보여준다. */
  participants: AdminProjectParticipantDto[];
  /**
   * 동일 지역만 허용 여부. true 이면 발주자 시/도 + 인접 2개 시/도 (총 3개 지역) 공급사만 참여 가능.
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /** 물품 목록 */
  items?: AdminProjectItemDto[];
  /** 첨부파일 목록 */
  attachments?: AttachmentMetadataDto[];
  /**
   * 삭제 시각. 값이 있으면 "삭제됨" 상태이며 일반 목록·발주기관·공급사 화면에서 보이지 않는다. 데이터는 지워지지 않는다.
   * @nullable
   */
  deletedAt?: string | null;
  /**
   * 삭제한 관리자 이름
   * @nullable
   */
  deletedByName?: string | null;
  /** 이 공고에 달린 운영 메모 개수. 목록에서 어느 공고에 인수인계 맥락이 있는지 한눈에 보여주기 위한 것이라, 0 이면 아이콘 자체를 그리지 않는다. */
  noteCount: number;
  /**
   * 가장 최근 메모. 목록의 마우스 오버 미리보기에 쓴다 — 메모가 있는지 알려면 상세로 들어가야 하는 동선을 없앤다. 메모가 없으면 null.
   * @nullable
   */
  latestNote?: AdminProjectDtoLatestNote;
  /** 발주기관 신원. 목록의 「발주기관」 칸은 `user.name` 이 아니라 이 값을 쓴다. */
  buyer: AdminProjectBuyerDto;
  /** 이 공고에 걸린 계약들. 취소분도 포함한다 — 목록에서 계약서로 바로 넘어가기 위한 것이라 "엎어진 계약을 확인하는" 동선도 같은 자리에서 처리한다. 계약이 없으면 빈 배열. */
  contracts: AdminProjectContractLinkDto[];
  /** 물품 매칭 요약(전체/매칭/발송가능 줄 수). */
  matchSummary: AdminProjectMatchSummaryDto;
  /**
   * 자동견적 진행 상태(`none`·`pending`·`processing`·`completed`·`failed`). `failed` 는 사람이 보지 않으면 드러나지 않아 목록에 표시한다.
   * @nullable
   */
  autoQuoteStatus?: string | null;
  /**
   * 예산 금액(원)
   * @nullable
   */
  budgetAmount?: number | null;
  /**
   * 공개 공고 여부. false 면 지정한 공급사만 본다 — 참여가 적은 이유가 된다.
   * @nullable
   */
  isPublic?: boolean | null;
}

/**
 * 견적 상태
 */
export type AdminQuoteDtoStatus =
  (typeof AdminQuoteDtoStatus)[keyof typeof AdminQuoteDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminQuoteDtoStatus = {
  pending: "pending",
  submitted: "submitted",
  withdrawn: "withdrawn",
  expired: "expired",
} as const;

export interface AdminQuoteDto {
  /** 견적 ID */
  id: string;
  /** 견적 금액 */
  totalAmount?: number;
  /** 견적 상태 */
  status?: AdminQuoteDtoStatus;
}

/**
 * 참여 노출 상태. visible=정상, hidden=마스터에만 흐리게
 */
export type AdminChatRoomDtoParticipationState =
  (typeof AdminChatRoomDtoParticipationState)[keyof typeof AdminChatRoomDtoParticipationState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminChatRoomDtoParticipationState = {
  visible: "visible",
  hidden: "hidden",
} as const;

export interface AdminChatRoomDto {
  /** 채팅방 ID */
  id: string;
  /** 견적 요청 ID */
  quote_request_id: string;
  /** 공급자 정보 */
  supplier: AdminUserSummaryDto;
  /** 구매자 정보 */
  buyer: AdminUserSummaryDto;
  /** 마지막 메시지 시간 */
  last_message_at?: string;
  /** 연관된 견적 정보 */
  quote?: AdminQuoteDto;
  /** 상태 */
  status?: string;
  /** 참여 노출 상태. visible=정상, hidden=마스터에만 흐리게 */
  participationState: AdminChatRoomDtoParticipationState;
  /** 계약이 체결된 참여인지. true 면 숨기기도 삭제도 막힌다. */
  hasContracted: boolean;
  /**
   * 감춘 시각 (ISO 8601). 정상 상태면 null.
   * @nullable
   */
  hiddenAt?: string | null;
}

export interface AdminProjectDetailResponseDto {
  project: AdminProjectDto;
  chatRooms: AdminChatRoomDto[];
}

export interface AdminTradeTranslatedItemDto {
  /** 공고 items 배열의 순번 */
  index: number;
  /** 번역한 품목명 */
  name: string;
  /**
   * 번역한 규격. 화면은 원문을 크게, 이 값을 작게 병기한다 — 규격의 근거는 원문이다.
   * @nullable
   */
  spec: string | null;
}

/**
 * 원문 언어
 */
export type AdminTradeTranslationDtoSourceLang =
  (typeof AdminTradeTranslationDtoSourceLang)[keyof typeof AdminTradeTranslationDtoSourceLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminTradeTranslationDtoSourceLang = {
  ko: "ko",
  id: "id",
} as const;

export interface AdminTradeTranslationDto {
  /** 원문 언어 */
  sourceLang: AdminTradeTranslationDtoSourceLang;
  /** 번역한 공고명 */
  projectName: string;
  /**
   * 번역한 상세. 원문이 비었으면 null
   * @nullable
   */
  description: string | null;
  /** 번역한 품목 */
  items: AdminTradeTranslatedItemDto[];
}

export interface AdminApplyAttachmentLineDto {
  /** 품명 */
  name: string;
  /** @nullable */
  spec1?: string | null;
  /** @nullable */
  unit?: string | null;
  /** 수량 */
  quantity: number;
  /**
   * 어드민이 고른 카탈로그 물품(후보 수락). 없으면 매칭 잡이 판정한다.
   * @nullable
   */
  itemId?: string | null;
  /**
   * 고른 후보 순위(1부터)
   * @nullable
   */
  candidateRank?: number | null;
}

export interface AdminApplyAttachmentLinesDto {
  lines: AdminApplyAttachmentLineDto[];
}

export interface AdminMatchItemResponseDto {
  /** 성공 여부 */
  success: boolean;
}

/**
 * 어떻게 골랐나. suggest=엔진이 낸 후보를 골랐다 · manual=직접 검색했다. 계측(item_match_events)과 별칭 학습에 쓴다.
 */
export type AdminMatchItemDtoSource =
  (typeof AdminMatchItemDtoSource)[keyof typeof AdminMatchItemDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminMatchItemDtoSource = {
  suggest: "suggest",
  manual: "manual",
} as const;

export interface AdminMatchItemDto {
  /** 표준 물품 UUID (items_v2_base.id) */
  baseItemId: string;
  /** 이 줄로 이미 견적을 낸 업체가 있는데도 물품을 바꾸겠다는 확인. 마스터 화면이 어긋날 견적을 보여주고 체크를 받은 뒤에 true 로 보낸다. 확인 없이 바꾸려 하면 409 로 되돌아온다. */
  confirmRematch?: boolean;
  /** 어떻게 골랐나. suggest=엔진이 낸 후보를 골랐다 · manual=직접 검색했다. 계측(item_match_events)과 별칭 학습에 쓴다. */
  source?: AdminMatchItemDtoSource;
  /** source=suggest 일 때 고른 후보 순위(1부터) */
  candidateRank?: number;
}

export interface AdminRegisterAndMatchItemResultDto {
  /** 생성된 표준 물품 UUID (items_v2_base.id) */
  itemId: string;
  /**
   * 자동 채번된 물품코드
   * @nullable
   */
  productCode: string | null;
  /** 등록된 물품명 */
  name: string;
}

export interface AdminRegisterAndMatchItemResponseDto {
  /** 성공 여부 */
  success: boolean;
  /** 등록 결과 */
  result: AdminRegisterAndMatchItemResultDto;
}

export interface AdminRegisterAndMatchItemDto {
  /** 상품명 (필수) */
  name: string;
  /** 제조사 (선택) */
  manufacturer?: string;
  /** 브랜드 (선택) */
  brand?: string;
  /** 품목코드 (선택) */
  code?: string;
  /** 단위 (필수) */
  unit: string;
  /** 정가 (필수) */
  price: number;
  /** 이미지 URL (선택) */
  imageUrl?: string;
  /** 카테고리 ID (필수, UUID) */
  categoryId: string;
  /** 규격1 (선택) */
  spec1?: string;
  /** 규격2 (선택) */
  spec2?: string;
  /** 규격3 (선택) */
  spec3?: string;
  /** 이 줄로 이미 견적을 낸 업체가 있는데도 물품을 바꾸겠다는 확인. 마스터 화면이 어긋날 견적을 보여주고 체크를 받은 뒤에 true 로 보낸다. 확인 없이 바꾸려 하면 409 로 되돌아온다. */
  confirmRematch?: boolean;
}

/**
 * 단가의 부가세 축. INCLUSIVE 면 부가세 포함가라 그대로 등재된다(가산하지 않는다)
 */
export type AdminQuotedPriceCandidateDtoTaxType =
  (typeof AdminQuotedPriceCandidateDtoTaxType)[keyof typeof AdminQuotedPriceCandidateDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminQuotedPriceCandidateDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

/**
 * 카탈로그 단가의 부가세 축
 * @nullable
 */
export type AdminQuotedPriceCandidateDtoCatalogTaxType =
  | (typeof AdminQuotedPriceCandidateDtoCatalogTaxType)[keyof typeof AdminQuotedPriceCandidateDtoCatalogTaxType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminQuotedPriceCandidateDtoCatalogTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface AdminQuotedPriceCandidateDto {
  /** 공급사 ID (users.id) */
  supplierId: string;
  /** 공급사명 */
  supplierName: string;
  /**
   * 그 줄에 제시한 단가. 견적서에 값이 없으면 null
   * @nullable
   */
  unitPrice: number | null;
  /** 단가의 부가세 축. INCLUSIVE 면 부가세 포함가라 그대로 등재된다(가산하지 않는다) */
  taxType: AdminQuotedPriceCandidateDtoTaxType;
  /**
   * 견적 제출 시각
   * @nullable
   */
  submittedAt: string | null;
  /** 이 공급사의 단가가 이미 카탈로그에 있는가. true 면 연결 버튼을 막는다 — 공급사가 스스로 관리하는 단가를 관리자가 덮지 않는다. */
  linked: boolean;
  /**
   * 카탈로그에 이미 있는 단가
   * @nullable
   */
  catalogPrice: number | null;
  /**
   * 카탈로그 단가의 부가세 축
   * @nullable
   */
  catalogTaxType: AdminQuotedPriceCandidateDtoCatalogTaxType;
}

export interface AdminQuotedPriceLineDto {
  /** 공고 줄 인덱스 */
  itemIndex: number;
  /** 공고 줄 이름 */
  itemName: string;
  /**
   * 매칭된 표준 물품 ID. null 이면 아직 매칭 전이라 연결할 대상이 없다
   * @nullable
   */
  itemId: string | null;
  /** 이 줄에 견적을 낸 업체들 */
  candidates: AdminQuotedPriceCandidateDto[];
}

/**
 * 그 단가의 부가세 축
 */
export type AdminLinkQuotedPriceResponseDtoTaxType =
  (typeof AdminLinkQuotedPriceResponseDtoTaxType)[keyof typeof AdminLinkQuotedPriceResponseDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminLinkQuotedPriceResponseDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface AdminLinkQuotedPriceResponseDto {
  /** 요청 성공 여부 */
  success: boolean;
  /** 이번에 새로 등재했는가. false 면 이미 단가가 있어 그대로 두었다는 뜻이다 */
  created: boolean;
  /** 등재된 표준 물품 ID */
  itemId: string;
  /** 공급사 ID */
  supplierId: string;
  /** 카탈로그에 남은 단가 */
  price: number;
  /** 그 단가의 부가세 축 */
  taxType: AdminLinkQuotedPriceResponseDtoTaxType;
}

export interface AdminExtendDeadlineResultDto {
  /** 견적 요청 ID */
  id: string;
  /** 연장된 마감일시 (ISO 8601) */
  deadline: string;
  /** 연장 후 상태. 마감일이 지나 ON_HOLD 로 내려가 있던 공고는 IN_PROGRESS 로 되살아납니다. */
  status: string;
}

export interface AdminExtendDeadlineResponseDto {
  /** 성공 여부 */
  success: boolean;
  /** 연장 결과 */
  result: AdminExtendDeadlineResultDto;
}

export interface AdminExtendDeadlineDto {
  /** 새 마감일시 (ISO 8601). 현재 시각과 기존 마감일시보다 뒤여야 하며, 한 번에 30일까지 연장할 수 있습니다. */
  deadline: string;
}

export interface AdminCloseProjectResultDto {
  /** 견적 요청 ID */
  id: string;
  /** 마감 후 상태 */
  status: string;
  /**
   * 마감 시각 (ISO 8601)
   * @nullable
   */
  closedAt: string | null;
  /**
   * 마감 사유
   * @nullable
   */
  closeReason: string | null;
}

export interface AdminCloseProjectResponseDto {
  /** 성공 여부 */
  success: boolean;
  /** 마감 결과 */
  result: AdminCloseProjectResultDto;
}

export interface AdminCloseProjectDto {
  /**
   * 마감 사유. 목록의 상태 위에 그대로 뜹니다.
   * @minLength 2
   * @maxLength 200
   */
  reason: string;
}

export interface AdminAgencyQuoteSubmissionResponseDto {
  /** 생성된 엔씨하이 견적 id */
  quoteResponseId: string;
  /** 생성된 견적 버전 id */
  versionId: string;
  /** 매입 대상이 된 공급사 상호 */
  sourceSupplierName: string;
  /** 그 공급사의 견적 총액 */
  sourceTotalAmount: number;
  /** 발주기관에게 제시되는 구매대행 총액 */
  saleTotalAmount: number;
  /** 중개 대비 발주기관 절감액 */
  buyerSavingAmount: number;
}

/**
 * 전환된 거래 모델
 */
export type AdminTransactionModelResponseDtoTransactionModel =
  (typeof AdminTransactionModelResponseDtoTransactionModel)[keyof typeof AdminTransactionModelResponseDtoTransactionModel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminTransactionModelResponseDtoTransactionModel = {
  brokerage: "brokerage",
  agency: "agency",
} as const;

export interface AdminTransactionModelResponseDto {
  /** 공고 ID */
  projectId: string;
  /** 전환된 거래 모델 */
  transactionModel: AdminTransactionModelResponseDtoTransactionModel;
  /** 전환 시점의 참여업체 수 */
  participantCount: number;
}

/**
 * 거래 모델. brokerage=중개(발주기관↔공급사 직접), agency=구매대행(엔씨하이가 사서 판다)
 */
export type AdminSetTransactionModelDtoTransactionModel =
  (typeof AdminSetTransactionModelDtoTransactionModel)[keyof typeof AdminSetTransactionModelDtoTransactionModel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSetTransactionModelDtoTransactionModel = {
  brokerage: "brokerage",
  agency: "agency",
} as const;

export interface AdminSetTransactionModelDto {
  /** 거래 모델. brokerage=중개(발주기관↔공급사 직접), agency=구매대행(엔씨하이가 사서 판다) */
  transactionModel: AdminSetTransactionModelDtoTransactionModel;
}

export interface AutoQuoteFailedSupplierDto {
  /** 공급자 ID */
  supplierId: string;
  /** 공급자명 */
  supplierName: string;
  /** 에러 메시지 */
  error: string;
}

export interface AutoQuoteTriggerResultDto {
  /** 견적 요청 ID */
  quoteRequestId: string;
  /** 적격 공급자 총 수 */
  totalEligibleSuppliers: number;
  /** 발송 성공 수 */
  successCount: number;
  /** 발송 실패 수 */
  failureCount: number;
  /** 이미 응답한 공급자 수 */
  alreadyRespondedCount: number;
  /** 실패한 공급자 목록 */
  failedSuppliers: AutoQuoteFailedSupplierDto[];
}

export interface AdminTriggerAutoQuotesResponseDto {
  /** 성공 여부 */
  success: boolean;
  /** 상세 결과 */
  result: AutoQuoteTriggerResultDto;
}

export interface AdminSimilarSupplierDto {
  /** 공급사 사용자 ID (알림톡 수신자) */
  supplierId: string;
  /** 업체명 */
  companyName: string;
  /** 이 업체를 뽑은 근거가 된 유사 품목명 */
  basisItemName: string;
  /** 근거가 된 공고 줄 이름 */
  requestItemName: string;
  /**
   * 근거 품목의 가장 최근 거래일
   * @nullable
   */
  lastTransactionDate?: string | null;
  /**
   * 알림톡을 받을 수 없는 이유(연락처 없음·수신 거부). null 이면 발송 가능하다.
   * @nullable
   */
  unreachableReason?: string | null;
  /**
   * 이 공고 건으로 마지막에 안내를 보낸 시각(ISO). null 이면 아직 보낸 적이 없다.
   * @nullable
   */
  lastNotifiedAt?: string | null;
  /** 이 공고 건으로 안내를 보낸 횟수 */
  notifiedCount: number;
}

export interface AdminSimilarSuppliersResponseDto {
  candidates: AdminSimilarSupplierDto[];
  /** 이미 이 공고에 참여 중이라 후보에서 제외한 업체 수(채팅방이 열렸거나 견적을 낸 곳). */
  excludedParticipantCount: number;
}

/**
 * 어느 길로 나갔나. auto_on_create=공고 등록 시 자동, auto_similar=공고 등록 시 비슷한 품목 업체로 자동 보충, admin_similar=마스터가 골라 보냄
 */
export type AdminSupplierNotificationDtoSource =
  (typeof AdminSupplierNotificationDtoSource)[keyof typeof AdminSupplierNotificationDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSupplierNotificationDtoSource = {
  auto_on_create: "auto_on_create",
  auto_similar: "auto_similar",
  admin_similar: "admin_similar",
} as const;

export interface AdminSupplierNotificationDto {
  /** 발송 기록 ID */
  id: string;
  /** 발송 회차 ID. 한 번의 발송(버튼 한 번)으로 나간 건들이 같은 값을 갖는다. */
  batchId: string;
  /** 받은 공급사 사용자 ID */
  supplierId: string;
  /** 받은 업체명 */
  companyName: string;
  /** 보낸 시각(ISO) */
  sentAt: string;
  /** 어느 길로 나갔나. auto_on_create=공고 등록 시 자동, auto_similar=공고 등록 시 비슷한 품목 업체로 자동 보충, admin_similar=마스터가 골라 보냄 */
  source: AdminSupplierNotificationDtoSource;
  /**
   * 보낸 관리자 이름. 자동 발송이면 null.
   * @nullable
   */
  sentByName?: string | null;
}

export interface AdminSupplierNotificationListDto {
  notifications: AdminSupplierNotificationDto[];
}

export interface AdminNotifySimilarSuppliersSummaryDto {
  /** 알림톡을 보낸 곳 */
  sent: number;
  /** 연락처가 없거나 카카오 알림을 꺼 둬서 보내지 못한 곳 */
  skipped: number;
  /** 발송 중 오류가 난 곳 */
  failed: number;
  /** 요청에는 있었지만 이미 참여 중이거나 공급사가 아니어서 제외한 ID 수 */
  ignored?: number;
}

export interface AdminNotifySimilarSuppliersResultDto {
  /** 성공 여부 */
  success: boolean;
  /** 발송 결과 */
  result: AdminNotifySimilarSuppliersSummaryDto;
}

export interface AdminNotifySimilarSuppliersDto {
  /** 안내를 보낼 공급사 사용자 ID 목록. 후보 조회 결과에서 마스터가 고른 것만 담는다. */
  supplierIds: string[];
}

export interface AdminProjectNoteListResponseDto {
  /** 최신순 메모 목록 */
  notes: AdminProjectNoteDto[];
}

export interface AdminProjectNoteResponseDto {
  /** 성공 여부 */
  success: boolean;
  /** 작성된 메모 */
  result: AdminProjectNoteDto;
}

export interface CreateAdminProjectNoteDto {
  /**
   * 메모 내용
   * @maxLength 2000
   */
  body: string;
}

/**
 * 바뀐 뒤 상태. visible=정상, hidden=숨김(마스터에만 흐리게)
 */
export type AdminParticipationVisibilityResponseDtoState =
  (typeof AdminParticipationVisibilityResponseDtoState)[keyof typeof AdminParticipationVisibilityResponseDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminParticipationVisibilityResponseDtoState = {
  visible: "visible",
  hidden: "hidden",
} as const;

/**
 * 바뀌기 전 상태. 이미 같은 상태였으면 생략된다.
 */
export type AdminParticipationVisibilityResponseDtoPreviousState =
  (typeof AdminParticipationVisibilityResponseDtoPreviousState)[keyof typeof AdminParticipationVisibilityResponseDtoPreviousState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminParticipationVisibilityResponseDtoPreviousState = {
  visible: "visible",
  hidden: "hidden",
} as const;

export interface AdminParticipationVisibilityResponseDto {
  /** 대상 참여의 채팅방 ID */
  chatRoomId: string;
  /** 바뀐 뒤 상태. visible=정상, hidden=숨김(마스터에만 흐리게) */
  state: AdminParticipationVisibilityResponseDtoState;
  /** 바뀌기 전 상태. 이미 같은 상태였으면 생략된다. */
  previousState?: AdminParticipationVisibilityResponseDtoPreviousState;
  /** 실제로 상태가 바뀌었는지. false 면 이미 그 상태였다는 뜻이다. */
  changed: boolean;
  /** 함께 표시된 견적 행 수. 견적을 내지 않고 방만 열린 참여는 0 이다. */
  quoteResponses: number;
}

export interface AdminParticipationDeletionResponseDto {
  /** 지운 참여의 채팅방 ID */
  chatRoomId: string;
  /** 이 참여가 속했던 공고 ID */
  quoteRequestId: string;
  /** 이 참여의 공급사 users.id */
  supplierId: string;
  /** 함께 사라진 견적 수 */
  quoteResponses: number;
  /** 함께 사라진 견적서 버전 수 */
  quoteVersions: number;
  /** 함께 사라진 대화 메시지 수. 되돌릴 수 없다. */
  chatMessages: number;
  /** 함께 사라진 대화방 수 */
  chatRooms: number;
}

export interface AdminInsurancePreviewTextDto {
  [key: string]: unknown;
}

/**
 * 변경할 정산 상태
 */
export type BatchUpdateSettlementStatusDtoStatus =
  (typeof BatchUpdateSettlementStatusDtoStatus)[keyof typeof BatchUpdateSettlementStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchUpdateSettlementStatusDtoStatus = {
  WAITING: "WAITING",
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  DEFERRED: "DEFERRED",
} as const;

export interface BatchUpdateSettlementStatusDto {
  /** 변경할 계약 ID 목록 */
  contractIds: string[];
  /** 변경할 정산 상태 */
  status: BatchUpdateSettlementStatusDtoStatus;
}

/**
 * 결제 수단
 */
export type AdminSettlementResponseDtoPaymentMethod =
  (typeof AdminSettlementResponseDtoPaymentMethod)[keyof typeof AdminSettlementResponseDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSettlementResponseDtoPaymentMethod = {
  CARD: "CARD",
  CASH: "CASH",
} as const;

/**
 * 정산 상태
 */
export type AdminSettlementResponseDtoSettlementStatus =
  (typeof AdminSettlementResponseDtoSettlementStatus)[keyof typeof AdminSettlementResponseDtoSettlementStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSettlementResponseDtoSettlementStatus = {
  WAITING: "WAITING",
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  DEFERRED: "DEFERRED",
} as const;

export interface AdminSettlementResponseDto {
  /** 계약 ID */
  id: string;
  /** 계약 상세 정보 */
  contract?: ContractResponseDto;
  /** 계약 번호 */
  contractNumber: string;
  /** 계약 생성 일시 */
  contractDate: string;
  /** 총 계약 금액 */
  totalAmount: number;
  /** 플랫폼 수수료 */
  commissionAmount: number;
  /**
   * 계약 건별로 직접 지정한 수수료 정액(원). null 이면 전역 요율로 계산한 값이다.
   * @nullable
   */
  commissionOverrideAmount?: number | null;
  /** 정산 예정 금액 (총액 - 수수료) */
  settlementAmount: number;
  /** 결제 수단 */
  paymentMethod: AdminSettlementResponseDtoPaymentMethod;
  /** 정산 상태 */
  settlementStatus: AdminSettlementResponseDtoSettlementStatus;
  /**
   * 정산 예정일 (구매확정일 + 15일)
   * @nullable
   */
  settlementExpectedDate?: string | null;
  /**
   * 구매확정 일시
   * @nullable
   */
  completedAt?: string | null;
  /**
   * 정산 지급 완료 일시
   * @nullable
   */
  settledAt?: string | null;
  /** 구매자(발주)명 */
  clientName: string;
  /** 공급자(수주)명 */
  supplierName: string;
  /** 공급자 사업자번호 */
  supplierBusinessNumber?: string;
  /** 비고 */
  note?: string;
}

export interface SettlementStatsResponseDto {
  /** 미수 수수료 합계 — 계약이 서서 청구됐으나 아직 받지 못한 수수료 */
  unpaidCommission: number;
  /** 누적 수납 수수료 — 업체에서 실제로 받은 수수료 */
  collectedCommission: number;
  /** 미수 건수 */
  unpaidCount: number;
  /** (레거시·대금 축) 정산 예정 총액. 직거래 전환으로 세모가 지급할 대금이 없어 화면에서 쓰지 않는다. */
  totalPendingAmount: number;
  /** (레거시·대금 축) 정산 완료 총액 */
  totalCompletedAmount: number;
  /** (레거시) 대기 건수 — `unpaidCount` 와 같은 값이다 */
  pendingCount: number;
  /** 수수료 청구액 합계 — 건별 10원 절사 후 합산이라 목록 표의 수수료 합과 정의가 같다. */
  totalCommission: number;
  /** 안심결제 매출 총액 */
  safePaymentRevenue: number;
  /** 직접결제 유통 총액 (GMV) */
  directPaymentGMV: number;
  /** 계약금액 합계 — 현재 필터에 해당하는 계약의 총액 합 */
  totalContractAmount: number;
}

export interface SettlementMonthSummaryDto {
  /** 계약(청구)월, KST 기준 */
  month: string;
  /** 그 달에 성립한 계약 건수(취소 제외) */
  contractCount: number;
  /** 계약금액 합계 */
  totalContractAmount: number;
  /** 수수료 청구액 합계 — 건별 10원 절사 후 합산 */
  totalCommission: number;
  /** 수납 완료 수수료(COMPLETED) */
  collectedCommission: number;
  /** 수납 완료 건수 */
  collectedCount: number;
  /** 미수 수수료(PENDING) */
  unpaidCommission: number;
  /** 미수 건수 */
  unpaidCount: number;
}

export interface SettlementMonthlySummaryResponseDto {
  /** 최근 달이 먼저. 계약이 한 건도 없는 달은 오지 않는다(화면이 0 으로 채운다). */
  months: SettlementMonthSummaryDto[];
}

export interface MonthlyBillingLineItemDto {
  /** 거래일자 (KST) */
  txDate: string;
  /** 그 날의 계약 건수 */
  txCount: number;
  /** 그 날의 계약금액 합계 */
  contractAmount: number;
  /** 그 날의 수수료 합계 (건별 10원 절사 후 합산, 부가세 포함) */
  commission: number;
  /** 공급가액 */
  supplyAmount: number;
  /** 세액 */
  taxAmount: number;
}

export interface MonthlyCommissionInvoiceDto {
  /** 공급기업 ID */
  supplierId: string;
  /** 공급기업 상호 */
  companyName: string;
  /** 사업자등록번호 */
  businessNumber: string;
  /** 대표자명 */
  ceoName: string;
  /** 사업장 주소 */
  addressFull: string;
  /** 업태 */
  businessType: string;
  /** 종목 */
  businessItem: string;
  /** 계산서 수신 이메일 (계산서 전용 → 담당자 → 계정 순) */
  email: string;
  /** 청구월 거래 건수 */
  txCount: number;
  /** 청구월 거래일자 수 */
  txDateCount: number;
  /** 계약금액 합계 */
  contractAmount: number;
  /** 수수료 청구액 (부가세 포함) */
  commission: number;
  /** 공급가액 */
  supplyAmount: number;
  /** 세액 */
  taxAmount: number;
  /** 거래일자별 명세 (오름차순) */
  lineItems: MonthlyBillingLineItemDto[];
  /** 계산서 품목칸을 거래일자별로 채울 수 있는지. 거래일자가 4개를 넘으면 false 가 되고 월합계 1줄로 접힌다. */
  itemizedByDate: boolean;
  /** 이 기업의 청구월 계약 중 이미 계산서가 발행된 건수 */
  issuedCount: number;
  /**
   * 마지막 발행 일시
   * @nullable
   */
  lastIssuedAt?: string | null;
}

export interface MonthlyBillingSummaryDto {
  /** 청구 대상 기업 수 */
  supplierCount: number;
  /** 거래 건수 합계 */
  txCount: number;
  /** 계약금액 합계 */
  contractAmount: number;
  /** 수수료 청구액 합계 */
  commission: number;
}

export interface MonthlyBillingResponseDto {
  /** 청구월 'YYYY-MM' */
  month: string;
  /** 기업별 청구서 */
  invoices: MonthlyCommissionInvoiceDto[];
  /** 조회 조건 합계 */
  summary: MonthlyBillingSummaryDto;
}

/**
 * 변경할 정산 상태
 */
export type UpdateSettlementStatusDtoStatus =
  (typeof UpdateSettlementStatusDtoStatus)[keyof typeof UpdateSettlementStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateSettlementStatusDtoStatus = {
  WAITING: "WAITING",
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  DEFERRED: "DEFERRED",
} as const;

export interface UpdateSettlementStatusDto {
  /** 변경할 정산 상태 */
  status: UpdateSettlementStatusDtoStatus;
}

export interface AdminContractResponseDto {
  /** 계약 ID */
  id: string;
  /** 계약 상세 정보 (전체 DTO) */
  contract?: ContractResponseDto;
  /** 계약 번호 */
  contractNumber: string;
  /** 계약 생성 일시 */
  createdAt: string;
  /** 총 계약 금액 */
  totalAmount: number;
  /** 계약 상태 */
  status: string;
  /** 프로젝트명 */
  projectName?: string;
  /** 카테고리 타입 */
  categoryType?: string;
  /** 구매자(발주)명 */
  buyerName: string;
  /** 공급자(수주)명 */
  supplierName: string;
  /**
   * PDF URL
   * @nullable
   */
  pdfUrl?: string | null;
  /** 채팅방 ID */
  chatRoomId?: string;
  /**
   * 씨마켓 회원 아이디 (씨마켓 연동 발주기관만)
   * @nullable
   */
  buyerExternalId?: string | null;
  /**
   * 씨마켓 기관명 (씨마켓 연동 발주기관만)
   * @nullable
   */
  buyerOrganizationName?: string | null;
  /**
   * 결제 방식 — 'prepaid'(선불, 엔씨하이 수취) | 'postpaid'(후불, 공급사 직접 수취)
   * @nullable
   */
  paymentMethod?: string | null;
  /**
   * 결제 수단 (카드/무통장 등). 후불은 결제 거래 자체가 없어 null
   * @nullable
   */
  paymentChannel?: string | null;
  /**
   * 엔씨하이(주) 입금 확인 일시. null 이면 아직 입금 전
   * @nullable
   */
  paidAt?: string | null;
  /**
   * 검수(구매확정) 완료 일시. null 이면 검수 전
   * @nullable
   */
  completedAt?: string | null;
  /**
   * 정산 상태 — WAITING | DEFERRED | COMPLETED
   * @nullable
   */
  settlementStatus?: string | null;
  /**
   * 공급사 대금 지급 일시. null 이면 아직 안 나감
   * @nullable
   */
  settledAt?: string | null;
  /**
   * 정산 예정일
   * @nullable
   */
  settlementExpectedAt?: string | null;
}

export interface RegenerateContractPdfResponseDto {
  /** 계약서 재생성 작업이 대기줄에 실렸는지 */
  enqueued: boolean;
  /** 품목을 바꿨는지 */
  itemsUpdated: boolean;
}

export interface AdminContractItemDto {
  /** 품명 */
  name: string;
  /** 수량 */
  quantity: number;
  /** 단위 */
  unit: string;
  /** 금액(공급가액) */
  amount: number;
  /** 단가 */
  unitPrice?: number;
  /** 규격1 */
  spec1?: string;
  /** 규격2 */
  spec2?: string;
  /** 규격3 */
  spec3?: string;
}

export interface RegenerateContractPdfDto {
  /** 교정한 계약 품목 전체. 주면 계약의 품목을 이 목록으로 바꾼 뒤 계약서를 다시 만든다. 생략하면 지금 계약 내용 그대로 다시 만들기만 한다. */
  items?: AdminContractItemDto[];
}

export interface UpdateContractCommissionDto {
  /**
   * 이 계약에만 적용할 수수료 정액(원). null 이면 override 를 해제하고 전역 요율 계산으로 되돌린다. 저장 시 10원 미만은 절사된다.
   * @minimum 0
   * @nullable
   */
  commissionOverrideAmount: number | null;
}

export interface PlatformFeePolicyResponseDto {
  /** 전역 수수료율(%) */
  feeRate: number;
  /**
   * 마지막 변경 시각(ISO)
   * @nullable
   */
  updatedAt: string | null;
}

export interface UpdatePlatformFeePolicyDto {
  /**
   * 전역 수수료율(%). 0 보다 크고 100 이하, 소수점 셋째 자리까지. 빈 값·0 은 거절한다 — 특정 계약의 수수료 면제는 계약 건별 정액(PATCH /admin/contracts/:id/commission)으로 한다. 변경해도 기존 계약은 재계산하지 않는다.
   * @minimum 0
   * @maximum 100
   * @exclusiveMinimum
   */
  feeRate: number;
}

/**
 * 현재 수치
 */
export type DashboardMetricDtoValue = { [key: string]: unknown };

export interface DashboardMetricDto {
  /** 현재 수치 */
  value: DashboardMetricDtoValue;
  /** 지난달 대비 변화량 (절대값 또는 퍼센트) */
  change: number;
  /** 변화 설명 (예: '+180 (지난달 대비)') */
  description: string;
}

export interface ChartDataPointDto {
  /** X축 라벨 (예: '1월') */
  name: string;
  /** 프로젝트 수 */
  projects: number;
  /** 계약 완료 수 */
  contracts: number;
}

export interface RecentActivityDto {
  /** 활동 ID */
  id: string;
  /** 아이콘 식별자 */
  icon: string;
  /** 활동 제목 */
  title: string;
  /** 활동 상세 설명 */
  description: string;
  /** 몇 분 전인지 */
  minutesAgo: number;
}

export interface AdminDashboardResponseDto {
  /** 총 회원수 지표 */
  totalUsers: DashboardMetricDto;
  /** 진행중 프로젝트 지표 */
  activeProjects: DashboardMetricDto;
  /** 계약 완료 지표 */
  completedContracts: DashboardMetricDto;
  /** 총 거래액 지표 */
  totalRevenue: DashboardMetricDto;
  /** 총 수수료 수익 지표 */
  totalCommission: DashboardMetricDto;
  /** 안심결제 매출 지표 */
  safePaymentRevenue: DashboardMetricDto;
  /** 직접결제 유통액 지표 */
  directPaymentGMV: DashboardMetricDto;
  /** 차트 데이터 */
  chartData: ChartDataPointDto[];
  /** 최근 활동 목록 */
  recentActivities: RecentActivityDto[];
}

/**
 * 약관 타입
 */
export type AdminTermsResponseDtoType =
  (typeof AdminTermsResponseDtoType)[keyof typeof AdminTermsResponseDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminTermsResponseDtoType = {
  terms: "terms",
  privacy: "privacy",
  marketing: "marketing",
} as const;

export interface AdminTermsResponseDto {
  /** 약관 ID (UUID) */
  id: string;
  /** 약관 타입 */
  type: AdminTermsResponseDtoType;
  /** 버전 */
  version: string;
  /** 약관 제목 */
  title: string;
  /** 약관 내용 */
  content: string;
  /** 필수 여부 */
  isRequired: boolean;
  /** 활성(공개) 여부 */
  isActive: boolean;
  /** 게시일 */
  publishedAt: string;
  /** 생성일 */
  createdAt: string;
  /** 수정일 */
  updatedAt: string;
}

/**
 * 약관 타입 (terms: 이용약관, privacy: 개인정보처리방침, marketing: 마케팅수신동의)
 */
export type CreateTermsDtoType =
  (typeof CreateTermsDtoType)[keyof typeof CreateTermsDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTermsDtoType = {
  terms: "terms",
  privacy: "privacy",
  marketing: "marketing",
} as const;

export interface CreateTermsDto {
  /** 약관 타입 (terms: 이용약관, privacy: 개인정보처리방침, marketing: 마케팅수신동의) */
  type: CreateTermsDtoType;
  /** 약관 버전 (Semantic Versioning 권장) */
  version: string;
  /** 약관 제목 */
  title: string;
  /** 약관 내용 (HTML 또는 Markdown) */
  content: string;
  /** 필수 동의 여부 */
  isRequired: boolean;
  /** 공개(활성) 여부. true일 경우 해당 타입의 기존 활성 약관은 비활성화됩니다. */
  isActive: boolean;
}

/**
 * 약관 타입 (terms: 이용약관, privacy: 개인정보처리방침, marketing: 마케팅수신동의)
 */
export type UpdateTermsDtoType =
  (typeof UpdateTermsDtoType)[keyof typeof UpdateTermsDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTermsDtoType = {
  terms: "terms",
  privacy: "privacy",
  marketing: "marketing",
} as const;

export interface UpdateTermsDto {
  /** 약관 제목 */
  title?: string;
  /** 약관 내용 */
  content?: string;
  /** 필수 동의 여부 */
  isRequired?: boolean;
  /** 약관 타입 (terms: 이용약관, privacy: 개인정보처리방침, marketing: 마케팅수신동의) */
  type?: UpdateTermsDtoType;
  /** 공개(활성) 여부. true로 변경 시 해당 타입의 다른 약관은 비활성화됩니다. */
  isActive?: boolean;
}

/**
 * Target Plan Type
 */
export type PromotionCodeDtoTargetPlanType =
  (typeof PromotionCodeDtoTargetPlanType)[keyof typeof PromotionCodeDtoTargetPlanType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromotionCodeDtoTargetPlanType = {
  FREE: "FREE",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
  TEST: "TEST",
} as const;

export interface PromotionCodeDto {
  /** Promotion ID */
  id: string;
  /** Promotion Code */
  code: string;
  /** Description */
  description?: string;
  /** Target Plan Type */
  targetPlanType: PromotionCodeDtoTargetPlanType;
  /** Duration in days */
  durationDays: number;
  /** Max uses total */
  maxUsesPerCode?: number;
  /** Current usage count */
  currentUses: number;
  /** Max uses per user */
  maxUsesPerUser: number;
  /** Valid from date */
  validFrom?: string;
  /** Valid until date */
  validUntil?: string;
  /** Is Active status */
  isActive: boolean;
  /** Created At */
  createdAt: string;
}

/**
 * Target Plan
 */
export type CreatePromotionDtoTargetPlanType =
  (typeof CreatePromotionDtoTargetPlanType)[keyof typeof CreatePromotionDtoTargetPlanType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePromotionDtoTargetPlanType = {
  FREE: "FREE",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
  TEST: "TEST",
} as const;

export interface CreatePromotionDto {
  /** Promotion Code (e.g. SEMO_LAUNCH_2026) */
  code: string;
  /** Description */
  description: string;
  /** Target Plan */
  targetPlanType: CreatePromotionDtoTargetPlanType;
  /** Duration in days */
  durationDays: number;
  /** Max uses total (null for infinite) */
  maxUsesPerCode?: number;
  /** Max uses per user */
  maxUsesPerUser: number;
  /** Valid from date */
  validFrom?: string;
  /** Valid until date */
  validUntil?: string;
}

export interface PromotionRedemptionDto {
  /** Redemption ID */
  id: string;
  /** Promotion Code ID */
  promotionCodeId: string;
  /** User ID */
  userId: string;
  /** User Name */
  userName?: string;
  /** User Phone */
  userPhone?: string;
  /** User Login ID */
  userLoginId?: string;
  /** Redeemed At */
  redeemedAt: string;
}

export interface UpdatePromotionDto {
  /** Is Active */
  isActive?: boolean;
  /** Increase max uses (add to current) */
  maxUsesPerCode?: number;
  /** Valid until date */
  validUntil?: string;
}

export interface AdminAgencyPartyDto {
  /** 구매대행을 쓸 수 있는 상태인가 */
  enabled: boolean;
  /**
   * 씨마켓 회원 ID
   * @nullable
   */
  cmarketMemberId: string | null;
  /**
   * 상호
   * @nullable
   */
  displayName: string | null;
  /**
   * 매입축 계정 id
   * @nullable
   */
  buyerUserId: string | null;
  /**
   * 판매축 계정 id
   * @nullable
   */
  supplierUserId: string | null;
  /**
   * 마지막 변경 시각
   * @nullable
   */
  updatedAt: string | null;
  /**
   * 못 쓰는 상태면 그 이유
   * @nullable
   */
  unavailableReason: string | null;
}

export interface AdminSetAgencyPartyDto {
  /** 엔씨하이의 씨마켓 회원 ID. 이 값으로 판매축(공급사)·매입축(발주기관) 계정을 함께 찾는다. */
  cmarketMemberId: string;
}

export type AdminPayoutDtoKind =
  (typeof AdminPayoutDtoKind)[keyof typeof AdminPayoutDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminPayoutDtoKind = {
  payment: "payment",
  offset: "offset",
} as const;

export type AdminPayoutDtoStatus =
  (typeof AdminPayoutDtoStatus)[keyof typeof AdminPayoutDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminPayoutDtoStatus = {
  scheduled: "scheduled",
  on_hold: "on_hold",
  paid: "paid",
  failed: "failed",
  canceled: "canceled",
} as const;

export interface AdminPayoutDto {
  id: string;
  purchaseContractId: string;
  /** 매입계약 번호 */
  contractNumber: string;
  supplierId: string;
  /** 공급기업 상호 */
  supplierName: string;
  kind: AdminPayoutDtoKind;
  /** 금액(부가세 포함). 방향은 kind 가 정한다. */
  amount: number;
  /** 매입계약 총액 */
  purchaseTotalAmount: number;
  status: AdminPayoutDtoStatus;
  /**
   * 지급 완료 시각
   * @nullable
   */
  paidAt: string | null;
  /**
   * 보류 사유
   * @nullable
   */
  holdReason: string | null;
  /**
   * 이체 결과 식별자
   * @nullable
   */
  transferRef: string | null;
  createdAt: string;
}

export interface AdminPayoutBalanceDto {
  contractAmount: number;
  /** 이미 나간 돈 — Σ(지급) − Σ(상계) */
  paidAmount: number;
  /** 아직 더 나갈 수 있는 돈 */
  remainingAmount: number;
}

export interface AdminMarkPayoutPaidDto {
  /** 이체 결과 식별자(은행 거래번호 등). 대사에 쓴다. */
  transferRef?: string;
}

export interface AdminHoldPayoutDto {
  /** 보류 사유 */
  reason: string;
}

/**
 * 걸린 이유
 */
export type ControlTowerFindingDtoCode =
  (typeof ControlTowerFindingDtoCode)[keyof typeof ControlTowerFindingDtoCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ControlTowerFindingDtoCode = {
  unmatched_items: "unmatched_items",
  no_supplier_pool: "no_supplier_pool",
  no_quotes_untouched: "no_quotes_untouched",
  no_quotes_after_outreach: "no_quotes_after_outreach",
  auto_quote_broken: "auto_quote_broken",
  status_stale: "status_stale",
} as const;

export type ControlTowerFindingDtoSeverity =
  (typeof ControlTowerFindingDtoSeverity)[keyof typeof ControlTowerFindingDtoSeverity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ControlTowerFindingDtoSeverity = {
  warning: "warning",
  critical: "critical",
} as const;

export interface ControlTowerFindingDto {
  /** 걸린 이유 */
  code: ControlTowerFindingDtoCode;
  severity: ControlTowerFindingDtoSeverity;
  /** 목록에 그대로 찍히는 한국어 한 줄 */
  message: string;
}

export type ControlTowerAlertDtoSeverity =
  (typeof ControlTowerAlertDtoSeverity)[keyof typeof ControlTowerAlertDtoSeverity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ControlTowerAlertDtoSeverity = {
  warning: "warning",
  critical: "critical",
} as const;

export type ControlTowerAlertDtoCodesItem =
  (typeof ControlTowerAlertDtoCodesItem)[keyof typeof ControlTowerAlertDtoCodesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ControlTowerAlertDtoCodesItem = {
  unmatched_items: "unmatched_items",
  no_supplier_pool: "no_supplier_pool",
  no_quotes_untouched: "no_quotes_untouched",
  no_quotes_after_outreach: "no_quotes_after_outreach",
  auto_quote_broken: "auto_quote_broken",
  status_stale: "status_stale",
} as const;

export interface ControlTowerAlertDto {
  id: string;
  quoteRequestId: string;
  /**
   * 견적요청 번호
   * @nullable
   */
  requestNumber?: string | null;
  projectName: string;
  severity: ControlTowerAlertDtoSeverity;
  codes: ControlTowerAlertDtoCodesItem[];
  findings: ControlTowerFindingDto[];
  /**
   * 마감일
   * @nullable
   */
  deadline?: string | null;
  /** 처음 걸린 시각 — 「며칠째 방치」의 기준 */
  firstDetectedAt: string;
  /**
   * 마스터가 확인한 시각. 확인해도 목록에서 빠지지 않는다
   * @nullable
   */
  acknowledgedAt?: string | null;
  /**
   * 이 시각까지 목록에서 내려가 있다
   * @nullable
   */
  snoozedUntil?: string | null;
  /** 운영 메모가 있는가 — 누가 이미 봤다는 표시일 뿐 해결 여부가 아니다 */
  hasAdminNote: boolean;
}

export interface ControlTowerListResponseDto {
  items: ControlTowerAlertDto[];
  total: number;
}

/**
 * 이유별 열린 건수. 어느 문제가 제일 많이 쌓이는지 보는 값
 */
export type ControlTowerSummaryResponseDtoByCode = { [key: string]: number };

export interface ControlTowerSummaryResponseDto {
  /** 지금 손봐야 할 심각 건수 */
  critical: number;
  /** 주의 건수 */
  warning: number;
  /** 이유별 열린 건수. 어느 문제가 제일 많이 쌓이는지 보는 값 */
  byCode: ControlTowerSummaryResponseDtoByCode;
  /** 급한 순 상위 몇 건 */
  top: ControlTowerAlertDto[];
}

export interface SnoozeAlertDto {
  /**
   * 몇 시간 뒤에 다시 올릴지
   * @minimum 1
   * @maximum 720
   */
  hours: number;
}

export interface ControlTowerScanResultDto {
  /** 훑어본 진행중 견적요청 수 */
  scanned: number;
  /** 지금 열려 있는 경고 수 */
  open: number;
  /** 이번 점검에서 해소되어 목록에서 내려간 수 */
  resolved: number;
}

export interface UploadedFileDto {
  /** 업로드된 파일의 공개 URL */
  url: string;
  /** 스토리지 경로 (재서명에 사용) */
  filePath: string;
  /** 원본 파일명 */
  fileName: string;
  /** 파일 크기 (바이트) */
  fileSize: number;
  /** MIME 타입 */
  mimeType?: string;
}

export interface TemporaryFileUploadResponseDto {
  /** 업로드된 파일들의 정보 배열 */
  attachments: UploadedFileDto[];
  /** 업로드 시각 (ISO 8601 형식) */
  uploadedAt: string;
  /** 만료 시각 (ISO 8601 형식) */
  expiresAt: string;
}

/**
 * 토큰 전달 방식
 */
export type AuthSupplierResponseDtoTokenType =
  (typeof AuthSupplierResponseDtoTokenType)[keyof typeof AuthSupplierResponseDtoTokenType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthSupplierResponseDtoTokenType = {
  bearer: "bearer",
  cookie: "cookie",
} as const;

export interface AuthSupplierResponseDto {
  /** 공급자 사용자 ID (UUID) */
  supplierId: string;
  /** Access Token */
  accessToken: string;
  /** Refresh Token */
  refreshToken: string;
  /** 토큰 만료 시간 (초) */
  expiresIn: number;
  /** 토큰 전달 방식 */
  tokenType: AuthSupplierResponseDtoTokenType;
  /** 신규 가입 여부 (true: 신규 가입, false: 기존 회원) */
  isNewUser?: boolean;
}

/**
 * 종류
 */
export type ExternalSupplierCertificationDtoKind =
  (typeof ExternalSupplierCertificationDtoKind)[keyof typeof ExternalSupplierCertificationDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalSupplierCertificationDtoKind = {
  CERTIFICATION: "CERTIFICATION",
  LICENSE: "LICENSE",
  CUSTOM: "CUSTOM",
} as const;

/**
 * 만료일 (YYYY-MM-DD)
 * @nullable
 */
export type ExternalSupplierCertificationDtoExpiresAt = {
  [key: string]: unknown;
} | null;

export interface ExternalSupplierCertificationDto {
  /**
   * 씨마켓 쪽 안정 키 (예: ins:0101 / license:L12 / custom:<uuid>). 재동기화 upsert 기준.
   * @maxLength 120
   */
  sourceKey: string;
  /**
   * 인증서/면허 명칭
   * @maxLength 200
   */
  name: string;
  /** 종류 */
  kind: ExternalSupplierCertificationDtoKind;
  /**
   * 만료일 (YYYY-MM-DD)
   * @nullable
   */
  expiresAt?: ExternalSupplierCertificationDtoExpiresAt;
  /** 씨마켓 마스터 승인 여부(masterCheckYn=Y). true 면 세모 프로필에 "검증됨" 으로 노출. */
  verified: boolean;
}

/**
 * 유효 인증 기준 만료일 (YYYY-MM-DD, 씨마켓의 만료일 없는 옛 서류 간주값 반영). 세모는 이 날짜가 지나면 숨긴다.
 * @nullable
 */
export type ExternalSupplierProcurementCategoryDtoValidUntil = {
  [key: string]: unknown;
} | null;

export interface ExternalSupplierProcurementCategoryDto {
  /**
   * 씨마켓 의무구매 토큰 (P1xx·Q1xx 는 P0·Q0 으로 묶어 보낸다)
   * @maxLength 10
   */
  code: string;
  /**
   * 표시 이름
   * @maxLength 50
   */
  label: string;
  /**
   * 유효 인증 기준 만료일 (YYYY-MM-DD, 씨마켓의 만료일 없는 옛 서류 간주값 반영). 세모는 이 날짜가 지나면 숨긴다.
   * @nullable
   */
  validUntil?: ExternalSupplierProcurementCategoryDtoValidUntil;
}

/**
 * 회사 홈페이지 URL (b2b_member.homepage)
 * @maxLength 500
 * @nullable
 */
export type SupplierInfoDtoHomepageUrl = { [key: string]: unknown } | null;

/**
 * 회사 소개 (b2b_member.gita)
 * @maxLength 4000
 * @nullable
 */
export type SupplierInfoDtoCompanyIntro = { [key: string]: unknown } | null;

/**
 * 개업연월일 (b2b_member.beginday, YYYY-MM-DD)
 * @nullable
 */
export type SupplierInfoDtoEstablishedAt = { [key: string]: unknown } | null;

/**
 * 회사 로고 이미지 URL (b2b_member.logo_file_key 의 signed URL). 씨마켓 member-files 는 비공개 버킷이라 이 주소는 1시간이면 죽는다 — 세모가 받는 즉시 자기 assets 로 복사해 두고, 저장하는 값은 그 사본 주소다(직인과 같은 처방).
 * @maxLength 2048
 * @nullable
 */
export type SupplierInfoDtoCompanyLogoUrl = { [key: string]: unknown } | null;

export interface SupplierInfoDto {
  /** C-Market 공급업체 로그인 ID */
  supplierId: string;
  /**
   * 회사명 (company_name)
   * @maxLength 100
   */
  companyName: string;
  /**
   * 사업자등록번호 (business_number)
   * @pattern ^\d{3}-\d{2}-\d{5}$
   */
  businessNumber: string;
  /**
   * 대표자명 (ceo_name)
   * @maxLength 100
   */
  ceoName: string;
  /**
   * 회사 주소 (address_full)
   * @maxLength 255
   */
  addressFull: string;
  /**
   * 우편번호 (zip_code)
   * @maxLength 10
   * @nullable
   */
  zipCode: string | null;
  /**
   * 업태/종목 (business_type)
   * @maxLength 100
   * @nullable
   */
  businessType: string | null;
  /**
   * 취급품목 (product_description)
   * @maxLength 255
   * @nullable
   */
  productDescription: string | null;
  /**
   * 회사 전화번호 (company_phone)
   * @maxLength 20
   */
  companyPhone: string;
  /**
   * 담당자명 (manager_name)
   * @maxLength 100
   */
  managerName: string;
  /**
   * 담당자 이메일 (contact_email)
   * @nullable
   */
  contactEmail: string | null;
  /**
   * 담당자 부서 (manager_department)
   * @maxLength 100
   * @nullable
   */
  managerDepartment: string | null;
  /**
   * 담당자 직위 (manager_position)
   * @maxLength 100
   * @nullable
   */
  managerPosition: string | null;
  /**
   * 회사 팩스 (company_fax)
   * @maxLength 20
   * @nullable
   */
  companyFax: string | null;
  /**
   * 담당자 휴대폰 (manager_phone)
   * @maxLength 20
   */
  managerPhone: string;
  /**
   * 은행명 (bank_name)
   * @maxLength 50
   * @nullable
   */
  bankName: string | null;
  /**
   * 계좌번호 (bank_account_number)
   * @maxLength 50
   * @nullable
   */
  bankAccountNumber: string | null;
  /**
   * 예금주 (bank_account_holder)
   * @maxLength 100
   * @nullable
   */
  bankAccountHolder: string | null;
  /**
   * 직인 이미지 URL (company_seal_url)
   * @maxLength 2048
   * @nullable
   */
  companySealUrl: string | null;
  /**
   * 세금계산서 전용 이메일 (tax_email). 담당자 이메일과 다른 칸이며, 계산서는 이쪽으로 발송한다.
   * @nullable
   */
  taxEmail?: string | null;
  /**
   * 종사업장번호 (business_license_number)
   * @maxLength 10
   * @nullable
   */
  businessLicenseNumber?: string | null;
  /**
   * 종사업장번호 사용 여부. null 은 "정보 없음" 으로 미사용(false)과 구분한다.
   * @nullable
   */
  businessLicenseNumberUsed?: boolean | null;
  /**
   * 종목 (business_item). businessType 은 업태다 — 종전처럼 합쳐 보내지 말고 나눠서 보낸다.
   * @maxLength 100
   * @nullable
   */
  businessItem?: string | null;
  /**
   * 기본주소 원본 (address_main). 주면 addressFull 파싱 대신 이 값을 그대로 저장한다.
   * @maxLength 255
   * @nullable
   */
  addressMain?: string | null;
  /**
   * 상세주소 원본 (address_detail). 주면 파싱 결과 대신 이 값을 저장한다.
   * @maxLength 255
   * @nullable
   */
  addressDetail?: string | null;
  /**
   * 우편번호 유형 (zip_type)
   * @maxLength 50
   * @nullable
   */
  zipType?: string | null;
  /**
   * 은행 코드 (bank_code). 은행명 문자열만으로는 이체 자동화가 안 된다.
   * @maxLength 10
   * @nullable
   */
  bankCode?: string | null;
  /**
   * 예금주 실명확인 완료 여부 (bank_account_verified). null 은 "확인 정보 없음" 으로 미확인(false)과 구분한다.
   * @nullable
   */
  bankAccountVerified?: boolean | null;
  /**
   * 파트너가 판정한 활성 여부 (users.is_active). false 면 세모에서도 비활성 처리한다. 보내지 않으면(null) 종전처럼 활성으로 본다.
   * @nullable
   */
  isActive?: boolean | null;
  /**
   * 회사 홈페이지 URL (b2b_member.homepage)
   * @maxLength 500
   * @nullable
   */
  homepageUrl?: SupplierInfoDtoHomepageUrl;
  /**
   * 회사 소개 (b2b_member.gita)
   * @maxLength 4000
   * @nullable
   */
  companyIntro?: SupplierInfoDtoCompanyIntro;
  /**
   * 개업연월일 (b2b_member.beginday, YYYY-MM-DD)
   * @nullable
   */
  establishedAt?: SupplierInfoDtoEstablishedAt;
  /**
   * 회사 로고 이미지 URL (b2b_member.logo_file_key 의 signed URL). 씨마켓 member-files 는 비공개 버킷이라 이 주소는 1시간이면 죽는다 — 세모가 받는 즉시 자기 assets 로 복사해 두고, 저장하는 값은 그 사본 주소다(직인과 같은 처방).
   * @maxLength 2048
   * @nullable
   */
  companyLogoUrl?: SupplierInfoDtoCompanyLogoUrl;
  /**
   * 씨마켓 회원프로필의 기업 인증서·면허 목록. 보내면 세모의 CMARKET 출처 인증서를 이 목록으로 통째 동기화한다(없어진 항목은 삭제). 보내지 않으면(null) 인증서는 건드리지 않는다.
   * @nullable
   */
  certifications?: ExternalSupplierCertificationDto[] | null;
  /**
   * 공공기관 의무구매 대상 인증 분야 — 씨마켓이 인증 토큰(b2b_ins_code.ins_value)·마스터 승인·유효기간으로 판정한 결과. 세모는 판정하지 않고 받은 그대로 둔다. 보내면 통째로 덮고(빈 배열 = 해당 분야 없음), 보내지 않으면(null) 건드리지 않는다.
   * @nullable
   */
  procurementCategories?: ExternalSupplierProcurementCategoryDto[] | null;
}

export interface AuthSupplierRequestDto {
  /** 공급자 정보 (C-Market 공급업체 데이터) */
  supplierInfo: SupplierInfoDto;
}

export interface SupplierSettingsDto {
  /** 자동견적 켜짐 (suppliers.auto_quote_enabled) */
  autoQuoteEnabled: boolean;
  /** 알림톡 수신 (suppliers.kakao_notification_enabled) */
  kakaoNotificationEnabled: boolean;
}

export interface UpdateSupplierMeDto {
  /** 자동 견적 발송 여부 */
  autoQuoteEnabled?: boolean;
  /** 카카오 알림톡 수신 여부 */
  kakaoNotificationEnabled?: boolean;
}

/**
 * 토큰 전달 방식
 */
export type AuthBuyerResponseDtoTokenType =
  (typeof AuthBuyerResponseDtoTokenType)[keyof typeof AuthBuyerResponseDtoTokenType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthBuyerResponseDtoTokenType = {
  bearer: "bearer",
  cookie: "cookie",
} as const;

export interface AuthBuyerResponseDto {
  /** 구매사 사용자 ID (UUID) */
  buyerId: string;
  /** Access Token */
  accessToken: string;
  /** Refresh Token */
  refreshToken: string;
  /** 토큰 만료 시간 (초) */
  expiresIn: number;
  /** 토큰 전달 방식 */
  tokenType: AuthBuyerResponseDtoTokenType;
  /** 신규 가입 여부 (true: 신규 가입, false: 기존 회원) */
  isNewUser?: boolean;
}

export interface BuyerInfoDto {
  /** 외부 시스템 발주기관 고유 ID */
  externalBuyerId: string;
  /**
   * 발주기관/구매사 회사명 (organization_name)
   * @maxLength 255
   */
  organizationName: string;
  /**
   * 사업자등록번호 (business_number)
   * @pattern ^\d{3}-\d{2}-\d{5}$
   */
  businessNumber: string;
  /**
   * 대표자명 (ceo_name)
   * @maxLength 100
   */
  ceoName: string;
  /**
   * 주소 (address_full)
   * @maxLength 255
   */
  addressFull: string;
  /**
   * 우편번호 (zip_code)
   * @maxLength 20
   * @nullable
   */
  zipCode: string | null;
  /**
   * 업태/종목 (business_type)
   * @maxLength 100
   * @nullable
   */
  businessType: string | null;
  /**
   * 회사 전화번호 (organization_phone)
   * @maxLength 20
   */
  organizationPhone: string;
  /**
   * 회사 팩스 (organization_fax)
   * @maxLength 20
   * @nullable
   */
  organizationFax: string | null;
  /**
   * 담당자명 (manager_name)
   * @maxLength 100
   */
  managerName: string;
  /**
   * 담당자 휴대폰 (manager_phone). 없으면 계정 연락처는 organizationPhone(대표전화)으로 폴백한다.
   * @maxLength 20
   * @nullable
   */
  managerPhone?: string | null;
  /**
   * 담당자 부서 (manager_department)
   * @maxLength 100
   * @nullable
   */
  managerDepartment: string | null;
  /**
   * 담당자 직위 (manager_position)
   * @maxLength 100
   * @nullable
   */
  managerPosition: string | null;
  /**
   * 담당자 이메일 (contact_email)
   * @nullable
   */
  contactEmail: string | null;
  /**
   * 세금계산서 전용 이메일 (tax_email). 담당자 이메일과 다른 칸이며, 계산서는 이쪽으로 발송한다.
   * @nullable
   */
  taxEmail?: string | null;
  /**
   * 종사업장번호 (business_license_number)
   * @maxLength 10
   * @nullable
   */
  businessLicenseNumber?: string | null;
  /**
   * 종사업장번호 사용 여부 (business_license_number_used). null 은 "정보 없음" 으로 미사용(false)과 구분한다.
   * @nullable
   */
  businessLicenseNumberUsed?: boolean | null;
  /**
   * 종목 (business_item). businessType 은 업태다 — 종전처럼 합쳐 보내지 말고 나눠서 보낸다.
   * @maxLength 100
   * @nullable
   */
  businessItem?: string | null;
  /**
   * 기본주소 원본 (address_main). 주면 addressFull 파싱 대신 이 값을 그대로 저장한다.
   * @maxLength 255
   * @nullable
   */
  addressMain?: string | null;
  /**
   * 상세주소 원본 (address_detail). 주면 파싱 결과 대신 이 값을 저장한다.
   * @maxLength 255
   * @nullable
   */
  addressDetail?: string | null;
  /**
   * 우편번호 유형 (zip_type)
   * @maxLength 50
   * @nullable
   */
  zipType?: string | null;
  /**
   * 파트너가 판정한 활성 여부 (users.is_active). false 면 세모에서도 비활성 처리한다. 보내지 않으면(null) 종전처럼 활성으로 본다 — 미전송 파트너가 회원을 통째로 잠그는 사고를 막는다.
   * @nullable
   */
  isActive?: boolean | null;
}

export interface AuthBuyerRequestDto {
  /** 발주기관 정보 (외부 파트너 시스템에서 전달하는 구매사 데이터) */
  buyerInfo: BuyerInfoDto;
}

export interface UpdateBuyerMeDto {
  /** 카카오 알림톡 수신 여부 */
  kakaoNotificationEnabled?: boolean;
}

/**
 * 공급자 정보 (토큰이 유효한 경우에만 반환)
 * @nullable
 */
export type EmbedTokenVerifyResponseDtoSupplierInfo = SupplierInfoDto | null;

/**
 * 인증된 사용자 역할
 * @nullable
 */
export type EmbedTokenVerifyResponseDtoUserType =
  | (typeof EmbedTokenVerifyResponseDtoUserType)[keyof typeof EmbedTokenVerifyResponseDtoUserType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmbedTokenVerifyResponseDtoUserType = {
  supplier: "supplier",
  buyer: "buyer",
} as const;

/**
 * 발주기관 정보 (buyer 토큰일 때만 반환)
 * @nullable
 */
export type EmbedTokenVerifyResponseDtoBuyerInfo = BuyerInfoDto | null;

export interface EmbedTokenVerifyResponseDto {
  /** JWT 토큰의 유효성 여부 */
  isValid: boolean;
  /**
   * 토큰에 포함된 공급자 사용자 ID (public.users.id, 유효하지 않으면 null)
   * @nullable
   */
  userId?: string | null;
  /** Access Token */
  accessToken?: string;
  /**
   * Refresh Token (deprecated — 기본적으로 반환되지 않으며, EMBED_RETURN_REFRESH_TOKEN=true일 때만 임시로 반환됩니다)
   * @deprecated
   */
  refreshToken?: string;
  /**
   * C-Market 공급업체 외부 ID (suppliers.supplier_id, 유효하지 않으면 null)
   * @nullable
   */
  supplierId?: string | null;
  /**
   * 토큰이 유효하지 않은 경우 오류 메시지
   * @nullable
   */
  message?: string | null;
  /**
   * 공급자 정보 (토큰이 유효한 경우에만 반환)
   * @nullable
   */
  supplierInfo?: EmbedTokenVerifyResponseDtoSupplierInfo;
  /**
   * 인증된 사용자 역할
   * @nullable
   */
  userType?: EmbedTokenVerifyResponseDtoUserType;
  /**
   * 외부 파트너 발주기관 ID (buyers.external_buyer_id)
   * @nullable
   */
  buyerId?: string | null;
  /**
   * 발주기관 정보 (buyer 토큰일 때만 반환)
   * @nullable
   */
  buyerInfo?: EmbedTokenVerifyResponseDtoBuyerInfo;
}

export interface EmbedTokenVerifyRequestDto {
  /** JWT 토큰 */
  token: string;
}

export interface GenerateAlimTalkLinksResponseDto {
  /** 이 단가로 제출 링크 (Auto Quote) */
  autoQuoteLink: string;
  /** 단가 수정 후 제출 링크 (Custom Quote) */
  customQuoteLink: string;
}

export interface GenerateAlimTalkLinksRequestDto {
  /** 견적 요청 ID (UUID) */
  quoteRequestId: string;
  /** Base URL (생략 시 서버 환경변수 사용) */
  origin?: string;
}

/**
 * Embed 인터페이스 타입
 */
export type EmbedType = (typeof EmbedType)[keyof typeof EmbedType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmbedType = {
  "quote-response": "quote-response",
  "quote-detail": "quote-detail",
  chat: "chat",
  dashboard: "dashboard",
  "dashboard-my-projects": "dashboard-my-projects",
  "dashboard-chat-list": "dashboard-chat-list",
  "dashboard-settlements": "dashboard-settlements",
  "dashboard-contracts": "dashboard-contracts",
  "dashboard-products": "dashboard-products",
  "dashboard-shipments": "dashboard-shipments",
  "dashboard-price-requests": "dashboard-price-requests",
  "buyer-quote-request-new": "buyer-quote-request-new",
  "buyer-dashboard": "buyer-dashboard",
  "buyer-chat-list": "buyer-chat-list",
} as const;

export interface EmbedJoinRequestDto {
  /** Embed 인터페이스 타입 */
  type: EmbedType;
  /** 임베드 대상 리소스 ID (dashboard 제외 필수) */
  targetId?: string;
  /** type='dashboard-price-requests' 전용 — 맨 위에 먼저 보일 세모 물품 id(최대 20, price-request-demand 의 itemId). 다른 type 은 무시 */
  itemIds?: string[];
  /** type='dashboard-shipments' 전용 — 바로 열 씨마켓 낙찰 건 `<공고 번호>:<낙찰 순번>`. 다른 type 은 무시 */
  award?: string;
  /** Embed base URL (개발용, EMBED_BASE_URL 환경변수가 없을 때만 사용) */
  origin?: string;
}

/**
 * 제안 단가의 부가세 축
 */
export type SupplierPriceProposalSummaryDtoTaxType =
  (typeof SupplierPriceProposalSummaryDtoTaxType)[keyof typeof SupplierPriceProposalSummaryDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierPriceProposalSummaryDtoTaxType = {
  INCLUSIVE: "INCLUSIVE",
  EXCLUSIVE: "EXCLUSIVE",
} as const;

export interface SupplierPriceProposalSummaryDto {
  id: string;
  /** 제안 단가(씨마켓 응찰가 그대로) */
  proposedPrice: number;
  /** 제안 단가의 부가세 축 */
  taxType: SupplierPriceProposalSummaryDtoTaxType;
  /**
   * 제안 시점의 내 단가(스냅샷)
   * @nullable
   */
  currentPrice: number | null;
  /** «2026.08.17 기록» — 응찰일(ISO) */
  quotedAt: string;
  /**
   * 씨마켓 공고번호
   * @nullable
   */
  bidNo: string | null;
  /** 그 응찰이 낙찰됐는지 */
  won: boolean;
}

export type SupplierItemPendingEditDtoChangedFieldsItem =
  (typeof SupplierItemPendingEditDtoChangedFieldsItem)[keyof typeof SupplierItemPendingEditDtoChangedFieldsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierItemPendingEditDtoChangedFieldsItem = {
  name: "name",
  imageUrl: "imageUrl",
  spec1: "spec1",
  spec2: "spec2",
  spec3: "spec3",
  unit: "unit",
  manufacturer: "manufacturer",
  brand: "brand",
} as const;

export interface SupplierItemPendingEditDto {
  /** 대기 중인 수정 요청 ID */
  id: string;
  /** 검토 중인 칸 */
  changedFields: SupplierItemPendingEditDtoChangedFieldsItem[];
  /** 제출 시각 */
  createdAt: string;
}

/**
 * 씨마켓 최신 응찰가 기반 단가 갱신 제안(대기 중인 것 하나). 행 안에 「기존 → 새 단가 [최신가격 반영] 날짜 기록」 으로 그린다. 없으면 null.
 * @nullable
 */
export type SupplierCategoryItemDtoPriceProposal =
  SupplierPriceProposalSummaryDto | null;

/**
 * 검토 중인 내 수정 요청(없으면 null)
 * @nullable
 */
export type SupplierCategoryItemDtoPendingEditRequest =
  SupplierItemPendingEditDto | null;

/**
 * 나의 단가(myPrice)가 어느 쪽으로 입력됐나 — items_v2_transactions.tax_type. EXCLUSIVE=공급가액(VAT 별도) · INCLUSIVE=부가세 포함. 단가는 입력한 그대로 저장되므로 화면은 이 축으로 공급가액·포함가를 나눠 보여 준다(2026-10-30). 단가를 등재한 적이 없으면 null.
 * @nullable
 */
export type SupplierCategoryItemDtoMyPriceTaxType =
  | (typeof SupplierCategoryItemDtoMyPriceTaxType)[keyof typeof SupplierCategoryItemDtoMyPriceTaxType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierCategoryItemDtoMyPriceTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface SupplierCategoryItemDto {
  /**
   * CAS 등록번호 — 상품명에서 추출한 값. 시약이 아니면 null (KOSHA 매칭 여부와 무관하게 채워진다)
   * @nullable
   */
  casNo?: string | null;
  /**
   * 국내 기존화학물질 고유번호 (KE 번호). KOSHA 미등록이거나 미부여면 null
   * @nullable
   */
  keNo?: string | null;
  /**
   * UN 번호 (국제 위험물 운송번호). 위험물이 아니면 null
   * @nullable
   */
  unNo?: string | null;
  /**
   * EC 번호 (EU EINECS/ELINCS)
   * @nullable
   */
  enNo?: string | null;
  /**
   * KOSHA 기준 국문 표준 물질명
   * @nullable
   */
  chemNameKor?: string | null;
  /** 품목 ID (items_v2_base.id - UUID) */
  id: string;
  /** 상품명 */
  name: string;
  /**
   * 카테고리 ID (items_v2_categories.id - UUID)
   * @nullable
   */
  categoryId: string | null;
  /** 카테고리 경로 (표시용) */
  categoryPath: string;
  /** 기준 가격 (정가) */
  price: number;
  /**
   * 최저가 거래 단가
   * @nullable
   */
  lowestPrice: number | null;
  /**
   * 최저가 거래 날짜
   * @nullable
   */
  lowestPriceDate: string | null;
  /**
   * 최저가 거래 공급자명
   * @nullable
   */
  lowestPriceSupplierName: string | null;
  /** 카테고리 레벨 (0-3) */
  level: number;
  /**
   * 부모 카테고리 UUID
   * @nullable
   */
  parentId: string | null;
  /**
   * 제조사
   * @nullable
   */
  manufacturer: string | null;
  /**
   * 브랜드
   * @nullable
   */
  brand: string | null;
  /**
   * 상품코드
   * @nullable
   */
  code: string | null;
  /** 단위 */
  unit: string;
  /**
   * 이미지 URL
   * @nullable
   */
  imageUrl: string | null;
  /**
   * 규격1
   * @nullable
   */
  spec1: string | null;
  /**
   * 규격2
   * @nullable
   */
  spec2: string | null;
  /**
   * 규격3
   * @nullable
   */
  spec3: string | null;
  /** 취급 공급자 수 */
  supplierCount: number;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /**
   * 나의 공급가 (items_v2_transactions.거래단가)
   * @nullable
   */
  myPrice: number | null;
  /**
   * 나의 단가(myPrice)가 어느 쪽으로 입력됐나 — items_v2_transactions.tax_type. EXCLUSIVE=공급가액(VAT 별도) · INCLUSIVE=부가세 포함. 단가는 입력한 그대로 저장되므로 화면은 이 축으로 공급가액·포함가를 나눠 보여 준다(2026-10-30). 단가를 등재한 적이 없으면 null.
   * @nullable
   */
  myPriceTaxType: SupplierCategoryItemDtoMyPriceTaxType;
  /** 판매 상태 (items_v2_transactions.status) */
  isSelling: boolean;
  /** 이 품목을 자동견적 대상으로 둘지 (items_v2_transactions.auto_quote_enabled). 등재 전이면 true — 새로 올리면 «공급사 설정을 따른다» 가 기본이다. */
  autoQuoteEnabled: boolean;
  /** 이 품목의 견적요청 알림톡 수신 여부 (items_v2_transactions.kakao_notification_enabled). */
  kakaoNotificationEnabled: boolean;
  /**
   * 단가 레코드 ID (items_v2_transactions.id)
   * @nullable
   */
  priceEntryId: string | null;
  /**
   * 재고 수량 (null = 재고 미관리)
   * @nullable
   */
  stockOnHand: number | null;
  /**
   * 판매 가능 수량 = on_hand − reserved (null = 재고 미관리)
   * @nullable
   */
  stockAvailable: number | null;
  /**
   * 납기(일)
   * @nullable
   */
  leadTimeDays: number | null;
  /**
   * 씨마켓 최신 응찰가 기반 단가 갱신 제안(대기 중인 것 하나). 행 안에 「기존 → 새 단가 [최신가격 반영] 날짜 기록」 으로 그린다. 없으면 null.
   * @nullable
   */
  priceProposal: SupplierCategoryItemDtoPriceProposal;
  /**
   * 내 단가 줄이 마지막으로 바뀐 때(items_v2_transactions.updated_at). 목록 정렬 축(「최근 업데이트순」)과 같은 값이라 「왜 이 순서인가」가 화면에서 읽힌다. 단가를 등재한 적이 없으면 null.
   * @nullable
   */
  myPriceUpdatedAt: string | null;
  /**
   * 내 단가를 마지막으로 확인한 때 — price_checked_at(단가를 바꾸거나 «이 단가 맞아요»), 없으면 거래일자·수정일. 30일이 지나면 물품관리 행에 «단가 확인 요망» 이 붙는다(자동견적은 막지 않는다). 단가를 등재한 적이 없으면 null.
   * @nullable
   */
  myPriceCheckedAt: string | null;
  /**
   * 그 변경이 어느 경로였나 — supplier_price_events.source 의 마지막 값. direct(판매자 센터 직접 편집·견적발 갱신) · excel(단가표 업로드) · undo(업로드 되돌리기) · cmarket_bid(씨마켓 공고 응찰가 반영). 트리거가 생기기 전에 등재된 줄은 이력이 없어 null — 그때는 날짜만 보여 준다. enum 으로 굳히지 않는다(모르는 출처를 버리지 않는다).
   * @nullable
   */
  myPriceLastChangeSource: string | null;
  /**
   * 검토 중인 내 수정 요청(없으면 null)
   * @nullable
   */
  pendingEditRequest: SupplierCategoryItemDtoPendingEditRequest;
}

/**
 * 판매 상태
 */
export type SupplierPriceResponseDtoStatus =
  (typeof SupplierPriceResponseDtoStatus)[keyof typeof SupplierPriceResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierPriceResponseDtoStatus = {
  active: "active",
  inactive: "inactive",
} as const;

/**
 * 단가의 부가세 축. EXCLUSIVE=공급가액(부가세 별도), INCLUSIVE=부가세 포함가
 */
export type SupplierPriceResponseDtoTaxType =
  (typeof SupplierPriceResponseDtoTaxType)[keyof typeof SupplierPriceResponseDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierPriceResponseDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface SupplierPriceResponseDto {
  /** 단가 ID */
  id: string;
  /** 물품 ID */
  itemId: string;
  /** 판매 단가 (₩) */
  price: number;
  /** 공급자 ID */
  supplierId: string;
  /** 판매 상태 */
  status: SupplierPriceResponseDtoStatus;
  /** 단가의 부가세 축. EXCLUSIVE=공급가액(부가세 별도), INCLUSIVE=부가세 포함가 */
  taxType: SupplierPriceResponseDtoTaxType;
  /** 이 품목을 자동견적 대상으로 둘지 (품목×공급사). 공급사 단위 설정과 AND 로 걸린다. */
  autoQuoteEnabled: boolean;
  /** 이 품목의 견적요청 알림톡 수신 여부 (품목×공급사). */
  kakaoNotificationEnabled: boolean;
  /** 마지막 수정 일시 */
  updatedAt: string;
}

export type UpdateSupplierItemSettingsDtoTaxType =
  (typeof UpdateSupplierItemSettingsDtoTaxType)[keyof typeof UpdateSupplierItemSettingsDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateSupplierItemSettingsDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface UpdateSupplierItemSettingsDto {
  /**
   * 나의 공급가 (₩, 원 단위 정수, 0 ~ 999,999,999)
   * @minimum 0
   * @maximum 999999999
   */
  price?: number;
  /** 단가 입력 축 — EXCLUSIVE(공급가액, VAT 별도) | INCLUSIVE(부가세 포함). price 와 함께 보낼 때만 반영된다. 미전달이면 기존 행은 축 유지, 새 행은 EXCLUSIVE. */
  taxType?: UpdateSupplierItemSettingsDtoTaxType;
  /** 판매 상태 */
  isSelling?: boolean;
  /** 이 품목을 자동견적 대상으로 둘지. 공급사 단위 설정(suppliers.auto_quote_enabled)과 AND 로 걸린다 — 끄면 공급사가 자동견적을 켜 두어도 이 품목만 매칭에서 빠진다. 미지정 시 기존 값 유지. */
  autoQuoteEnabled?: boolean;
  /** 이 품목의 견적요청 알림톡을 받을지. 끄면 이 품목만 발송 대상에서 빠진다. 미지정 시 기존 값 유지. */
  kakaoNotificationEnabled?: boolean;
  /** 재고 수량 (미전달이면 변경 없음, 0 이면 0 으로 설정) */
  stockOnHand?: number;
  /** 납기(일). 재고 수량이 있어야 저장된다 */
  leadTimeDays?: number;
}

/**
 * 추가 카테고리 IDs
 */
export type SupplierItemRequestResponseDtoAdditionalCategoryIds = {
  [key: string]: unknown;
};

/**
 * 상태 — needs_info 는 보완 요청(사유는 adminComment)
 */
export type SupplierItemRequestResponseDtoStatus =
  (typeof SupplierItemRequestResponseDtoStatus)[keyof typeof SupplierItemRequestResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierItemRequestResponseDtoStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  needs_info: "needs_info",
} as const;

export interface SupplierItemRequestResponseDto {
  /** 요청 ID */
  id: string;
  /** Supplier ID */
  supplierId: string;
  /** 상품명 */
  name: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /**
   * 단위
   * @nullable
   */
  unit: string | null;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 카테고리 ID */
  categoryId?: string;
  /** 추가 카테고리 IDs */
  additionalCategoryIds?: SupplierItemRequestResponseDtoAdditionalCategoryIds;
  /** 요청 사유 */
  requestReason?: string;
  /** 상태 — needs_info 는 보완 요청(사유는 adminComment) */
  status: SupplierItemRequestResponseDtoStatus;
  /** Admin 반려·보완 요청 사유 */
  adminComment?: string;
  /** 승인한 Admin ID */
  approvedByAdminId?: string;
  /** 승인 시 생성된 물품 ID */
  approvedItemId?: string;
  /** 생성 일시 */
  createdAt: string;
  /**
   * 수정 일시
   * @nullable
   */
  updatedAt: string | null;
}

export interface ResubmitSupplierItemRequestDto {
  /** 상품명 */
  name?: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 단위 */
  unit?: string;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 카테고리 ID */
  categoryId?: string;
  /** 요청 사유(보완 내용) */
  requestReason?: string;
}

/**
 * 추가 카테고리 IDs
 */
export type CreateSupplierItemRequestDtoAdditionalCategoryIds = {
  [key: string]: unknown;
};

export interface CreateSupplierItemRequestDto {
  /** 상품명 */
  name: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 단위 */
  unit?: string;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 카테고리 ID */
  categoryId?: string;
  /** 추가 카테고리 IDs */
  additionalCategoryIds?: CreateSupplierItemRequestDtoAdditionalCategoryIds;
  /** 요청 사유 */
  requestReason?: string;
  /** 요청이 나온 공고 ID(견적 작성 중 등록 요청이면). 승인 시 그 줄에 자동 매칭된다. */
  quoteRequestId?: string;
  /** 그 공고의 줄 순번(0부터) */
  itemIndex?: number;
}

export interface SupplierItemImageUploadResponseDto {
  /** 공개 이미지 URL */
  imageUrl: string;
  /** 스토리지 경로 */
  filePath: string;
  /** 원본 파일명 */
  fileName: string;
  /** 파일 크기(byte) */
  fileSize: number;
  /** MIME 타입 */
  mimeType: string;
}

/**
 * 상태 — needs_info 는 보완 요청(사유는 adminComment)
 */
export type SupplierItemEditRequestResponseDtoStatus =
  (typeof SupplierItemEditRequestResponseDtoStatus)[keyof typeof SupplierItemEditRequestResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierItemEditRequestResponseDtoStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  needs_info: "needs_info",
} as const;

export type SupplierItemEditRequestResponseDtoChangedFieldsItem =
  (typeof SupplierItemEditRequestResponseDtoChangedFieldsItem)[keyof typeof SupplierItemEditRequestResponseDtoChangedFieldsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierItemEditRequestResponseDtoChangedFieldsItem = {
  name: "name",
  imageUrl: "imageUrl",
  spec1: "spec1",
  spec2: "spec2",
  spec3: "spec3",
  unit: "unit",
  manufacturer: "manufacturer",
  brand: "brand",
} as const;

export interface SupplierItemEditRequestResponseDto {
  /** 요청 ID */
  id: string;
  /** 대상 물품 ID */
  itemId: string;
  /**
   * 대상 물품 품명(현재 마스터 값)
   * @nullable
   */
  itemName: string | null;
  /** 상태 — needs_info 는 보완 요청(사유는 adminComment) */
  status: SupplierItemEditRequestResponseDtoStatus;
  /** 고친 칸 이름 목록 */
  changedFields: SupplierItemEditRequestResponseDtoChangedFieldsItem[];
  /**
   * 승인 시 실제로 마스터에 반영한 칸. 대기·반려면 null
   * @nullable
   */
  appliedFields: string[] | null;
  /** 제안 값 — 고친 칸만 */
  proposed: ItemEditValuesDto;
  /** 제출 당시 마스터 값 — 같은 칸만 */
  before: ItemEditValuesDto;
  /**
   * 수정 사유
   * @nullable
   */
  requestReason: string | null;
  /**
   * 관리자 메모 · 반려/보완 사유
   * @nullable
   */
  adminComment: string | null;
  /**
   * 검토 시각
   * @nullable
   */
  reviewedAt: string | null;
  /** 제출 시각 */
  createdAt: string;
  /**
   * 갱신 시각
   * @nullable
   */
  updatedAt: string | null;
}

export interface ResubmitSupplierItemEditRequestDto {
  /** 고칠 값 */
  changes: ItemEditValuesDto;
  /** 수정 사유 */
  requestReason?: string;
}

export interface CreateSupplierItemEditRequestDto {
  /** 고칠 값 — 보낸 키만 반영 대상이 된다 */
  changes: ItemEditValuesDto;
  /** 수정 사유 — 관리자가 승인 여부를 판단하는 근거가 된다 */
  requestReason?: string;
}

/**
 * 나의 공급가 부가세 축
 */
export type StockRowMarginDtoSellingTaxType = { [key: string]: unknown };

export interface StockRowMarginDto {
  /** 나의 공급가(원) */
  sellingPrice: number;
  /** 나의 공급가 부가세 축 */
  sellingTaxType: StockRowMarginDtoSellingTaxType;
  /** 적용 수수료율(%) */
  feeRate: number;
  /** 공급가액 축으로 맞춘 판매 단가 */
  sellSupply: number;
  /** 공급가액 축으로 맞춘 매입 단가 */
  costSupply: number;
  /** 매출 총액(공급가액) */
  grossSupply: number;
  /** 세모 수수료(10원 절사) */
  fee: number;
  /** 실수령액 = 매출 − 수수료 */
  netReceipt: number;
  /** 매입 총액 */
  totalCost: number;
  /** 마진 금액 = 실수령액 − 매입 */
  marginAmount: number;
  /**
   * 마진율(실수령액 분모). 실수령액 0 이면 null
   * @nullable
   */
  marginRate: number | null;
  /** 과세 여부를 몰라 환산하지 않은 추정값이면 true — 화면에 「추정」 배지 */
  isEstimate: boolean;
}

/**
 * 입고 행의 마진 미리보기. 계산 불가면 null
 * @nullable
 */
export type StockBatchRowResultDtoMargin = StockRowMarginDto | null;

export interface StockBatchRowResultDto {
  index: number;
  ok: boolean;
  /** INVALID_QUANTITY | INVALID_COST | NO_STOCK_ROW | INSUFFICIENT_STOCK */
  code?: string;
  /** 사용자에게 그대로 보여 줄 문장 */
  message?: string;
  /** 저장된 원장 행 ID(저장된 경우) */
  transactionId?: string;
  /**
   * 입고 행의 마진 미리보기. 계산 불가면 null
   * @nullable
   */
  margin: StockBatchRowResultDtoMargin;
}

export interface StockBatchResultDto {
  /** 전부 저장됐으면 true */
  ok: boolean;
  /** 저장된 행 수 — 부분 적용 없음(0 또는 전체) */
  applied: number;
  rows: StockBatchRowResultDto[];
}

/**
 * IN 입고 · OUT 출고 · ADJUST 조정(부호 있는 수량)
 */
export type StockTransactionRowDtoKind =
  (typeof StockTransactionRowDtoKind)[keyof typeof StockTransactionRowDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StockTransactionRowDtoKind = {
  IN: "IN",
  OUT: "OUT",
  ADJUST: "ADJUST",
} as const;

/**
 * 매입단가(원). IN 에만. 부가세 축과 함께 적거나 함께 비운다
 */
export type StockTransactionRowDtoUnitCost = { [key: string]: unknown };

/**
 * 매입단가의 부가세 축 — EXCLUSIVE 공급가액 | INCLUSIVE 포함
 */
export type StockTransactionRowDtoCostTaxType =
  (typeof StockTransactionRowDtoCostTaxType)[keyof typeof StockTransactionRowDtoCostTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StockTransactionRowDtoCostTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

/**
 * 거래일 YYYY-MM-DD. 없으면 오늘
 */
export type StockTransactionRowDtoOccurredOn = { [key: string]: unknown };

/**
 * 거래처(자유 텍스트). 어디서 사 왔나
 */
export type StockTransactionRowDtoPartnerName = { [key: string]: unknown };

/**
 * 메모(해시태그 관행 권장: #긴급 #반품)
 */
export type StockTransactionRowDtoMemo = { [key: string]: unknown };

/**
 * 거래명세서·계산서 첨부 URL
 */
export type StockTransactionRowDtoAttachmentUrl = { [key: string]: unknown };

export interface StockTransactionRowDto {
  /** 물품 ID (items_v2_base.id) */
  itemId: string;
  /** IN 입고 · OUT 출고 · ADJUST 조정(부호 있는 수량) */
  kind: StockTransactionRowDtoKind;
  /** 수량. IN·OUT 은 양수, ADJUST 는 0 이 아닌 부호 있는 정수 */
  quantity: number;
  /** 매입단가(원). IN 에만. 부가세 축과 함께 적거나 함께 비운다 */
  unitCost?: StockTransactionRowDtoUnitCost;
  /** 매입단가의 부가세 축 — EXCLUSIVE 공급가액 | INCLUSIVE 포함 */
  costTaxType?: StockTransactionRowDtoCostTaxType;
  /** 거래일 YYYY-MM-DD. 없으면 오늘 */
  occurredOn?: StockTransactionRowDtoOccurredOn;
  /** 거래처(자유 텍스트). 어디서 사 왔나 */
  partnerName?: StockTransactionRowDtoPartnerName;
  /** 메모(해시태그 관행 권장: #긴급 #반품) */
  memo?: StockTransactionRowDtoMemo;
  /** 거래명세서·계산서 첨부 URL */
  attachmentUrl?: StockTransactionRowDtoAttachmentUrl;
}

export interface StockTransactionBatchDto {
  /** 최대 200행. 전부 성공하거나 전부 실패 */
  rows: StockTransactionRowDto[];
}

export type StockTransactionDtoKind =
  (typeof StockTransactionDtoKind)[keyof typeof StockTransactionDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StockTransactionDtoKind = {
  IN: "IN",
  OUT: "OUT",
  ADJUST: "ADJUST",
  CANCEL: "CANCEL",
} as const;

export interface StockTransactionDto {
  id: string;
  itemId: string;
  kind: StockTransactionDtoKind;
  /** 부호 있는 수량 변동 */
  qtyDelta: number;
  /** @nullable */
  unitCost: number | null;
  /** @nullable */
  costTaxType: string | null;
  /** 거래일 YYYY-MM-DD */
  occurredOn: string;
  /** @nullable */
  partnerName: string | null;
  /** @nullable */
  memo: string | null;
  /** @nullable */
  attachmentUrl: string | null;
  /**
   * 이 행이 취소한 원행 ID(CANCEL 일 때)
   * @nullable
   */
  cancelsTxId: string | null;
  createdAt: string;
}

export interface StockHistoryPageDto {
  items: StockTransactionDto[];
  /**
   * 다음 페이지 커서. null 이면 끝
   * @nullable
   */
  nextCursor: string | null;
}

export type PriceContextMyPriceDtoTaxType = { [key: string]: unknown };

export interface PriceContextMyPriceDto {
  price: number;
  taxType: PriceContextMyPriceDtoTaxType;
  /** active | inactive */
  status: string;
}

export type PriceContextLastCostDtoCostTaxType = { [key: string]: unknown };

export interface PriceContextLastCostDto {
  unitCost: number;
  costTaxType: PriceContextLastCostDtoCostTaxType;
  /** 입고일 YYYY-MM-DD */
  occurredOn: string;
  /** 원가의 나이(일) */
  ageDays: number;
  /** 90일 초과 — 「원가가 오래됐습니다」 */
  isStale: boolean;
  transactionId: string;
}

export interface PriceContextMarketLowDto {
  /** 타사 최저 실거래 단가(원). 상호는 싣지 않는다 */
  price: number;
  /** @nullable */
  date: string | null;
  /** 그 최저가가 내 거래면 true */
  isMine: boolean;
}

/**
 * @nullable
 */
export type PriceContextDtoMyPrice = PriceContextMyPriceDto | null;

/**
 * @nullable
 */
export type PriceContextDtoLastCost = PriceContextLastCostDto | null;

/**
 * 수량 1 기준 마진
 * @nullable
 */
export type PriceContextDtoMargin = StockRowMarginDto | null;

/**
 * @nullable
 */
export type PriceContextDtoMarketLow = PriceContextMarketLowDto | null;

export interface PriceContextDto {
  itemId: string;
  /** @nullable */
  myPrice: PriceContextDtoMyPrice;
  /** @nullable */
  lastCost: PriceContextDtoLastCost;
  /**
   * 수량 1 기준 마진
   * @nullable
   */
  margin: PriceContextDtoMargin;
  /** @nullable */
  marketLow: PriceContextDtoMarketLow;
}

export interface QuoteLineMatchInputDto {
  /** 품목명 */
  name: string;
  /** 규격1 */
  spec1?: string;
  /** 규격2 */
  spec2?: string;
  /** 규격3 */
  spec3?: string;
  /** 브랜드 */
  brand?: string;
  /** 제조사 */
  manufacturer?: string;
  /** 단위 */
  unit?: string;
  /** 수량 */
  quantity?: number;
}

export interface ExternalQuoteLineMatchRequestDto {
  /** 매칭할 줄(최대 100) */
  lines: QuoteLineMatchInputDto[];
  /** 줄당 후보 수(기본 3, 최대 10) */
  limit?: number;
  /** 요청 category_type(product·used·manufacturing·construction). kind 판정에 쓴다. */
  categoryType?: string;
  /** ⑤ LLM 검증을 켤지(기본 끔). 켜면 헷갈리는 줄마다 LLM 이 후보 중 같은 물품을 고르고 verifiedConfidence 로 확신을 준다. 줄 30개 이하일 때만 돈다. */
  verify?: boolean;
}

export interface ItemV2AutocompleteResponseDto {
  /**
   * CAS 등록번호 — 상품명에서 추출한 값. 시약이 아니면 null (KOSHA 매칭 여부와 무관하게 채워진다)
   * @nullable
   */
  casNo?: string | null;
  /**
   * 국내 기존화학물질 고유번호 (KE 번호). KOSHA 미등록이거나 미부여면 null
   * @nullable
   */
  keNo?: string | null;
  /**
   * UN 번호 (국제 위험물 운송번호). 위험물이 아니면 null
   * @nullable
   */
  unNo?: string | null;
  /**
   * EC 번호 (EU EINECS/ELINCS)
   * @nullable
   */
  enNo?: string | null;
  /**
   * KOSHA 기준 국문 표준 물질명
   * @nullable
   */
  chemNameKor?: string | null;
  /** 품목 ID (items_v2_base.id - UUID) */
  id: string;
  /** 상품명 */
  name: string;
  /**
   * 카테고리 ID (items_v2_categories.id - UUID, FK to normalized category table)
   * @nullable
   */
  categoryId: string | null;
  /** 카테고리 경로 (표시용) */
  categoryPath: string;
  /** 기준 가격 (정가) */
  price: number;
  /**
   * 최저가 거래 단가
   * @nullable
   */
  lowestPrice: number | null;
  /**
   * 최저가 거래 날짜
   * @nullable
   */
  lowestPriceDate: string | null;
  /**
   * 공급사별 단가 (supplierId 파라미터 제공 시에만 반환)
   * @nullable
   */
  supplierPrice?: number | null;
  /**
   * 공급사별 최근 거래 일자
   * @nullable
   */
  supplierLastTransactionDate?: string | null;
  /** 단위 */
  unit?: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 이 품목을 취급하는 공급사 수 (활성 거래이력 기준, 탈퇴/정지 계정 제외). 모든 환경에서 반환된다. */
  supplierCount?: number;
  /** 이 품목을 취급하는 공급사 중 자동견적(auto_quote_enabled)을 켠 공급사 수. supplierCount 의 부분집합이며, 자동견적을 켠 곳이 없으면 0. 집계 시점은 검색 색인 동기화 주기(매일 새벽)를 따른다. */
  autoQuoteSupplierCount?: number;
  /** 자동 견적 가능 여부 (supplierCount > 0, 즉 취급 공급사가 1곳 이상인지). 자동견적을 켠 공급사가 있는지는 autoQuoteSupplierCount 로 판단할 것. */
  canAutoQuote?: boolean;
}

export type ItemV2SortBy = (typeof ItemV2SortBy)[keyof typeof ItemV2SortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemV2SortBy = {
  name: "name",
  supplierCount: "supplierCount",
  autoQuoteSupplierCount: "autoQuoteSupplierCount",
} as const;

export type ItemV2CatalogEpoch =
  (typeof ItemV2CatalogEpoch)[keyof typeof ItemV2CatalogEpoch];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemV2CatalogEpoch = {
  legacy: "legacy",
  v2: "v2",
} as const;

/**
 * WON = 수량 1 구간 낙찰가 중앙값 / ALL_BIDS = 낙찰 표본이 모자라 SKU 전체 응찰가 가중중앙값으로 대신한 값
 */
export type StorefrontMarketBenchmarkDtoBasis =
  (typeof StorefrontMarketBenchmarkDtoBasis)[keyof typeof StorefrontMarketBenchmarkDtoBasis];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontMarketBenchmarkDtoBasis = {
  WON: "WON",
  ALL_BIDS: "ALL_BIDS",
} as const;

export interface StorefrontMarketBenchmarkDto {
  /** 기준 단가(원). 가격밴드는 VAT 포함이라 표시가와 같은 부가세 축으로 환산한 값이다 (공급가액 몰이면 ÷1.1, 면세·영세는 그대로) */
  medianPrice: number;
  /** 표본 수. basis=WON 이면 낙찰 관측 수, ALL_BIDS 면 응찰 관측 수 */
  sampleCount: number;
  /**
   * 관측 기간(일) — 첫 관측부터 기준일까지. 가격밴드는 창을 자르지 않고 최신성 가중(반감기 12개월)을 쓴다
   * @nullable
   */
  windowDays?: number | null;
  /** 가격밴드 기준일 YYYY-MM-DD */
  asOf: string;
  /** WON = 수량 1 구간 낙찰가 중앙값 / ALL_BIDS = 낙찰 표본이 모자라 SKU 전체 응찰가 가중중앙값으로 대신한 값 */
  basis: StorefrontMarketBenchmarkDtoBasis;
  /**
   * 마지막 관측일 YYYY-MM-DD. 오래된 기준값을 걸러 낼 때 쓴다
   * @nullable
   */
  lastObservedAt?: string | null;
  /**
   * 가격밴드 신뢰등급 A/B/C (표본·공급사 수·최신성). 몰의 가격 등급과는 다른 축
   * @nullable
   */
  reliabilityGrade?: string | null;
}

/**
 * 품목의 과세 상태. EXEMPT·ZERO_RATED 는 부가세가 0이라 총액이 표시가와 같다. null 이면 미확인이며, 그 경우 총액은 과세로 보고 계산하는 편이 안전하다
 * @nullable
 */
export type StorefrontItemResponseDtoTaxCategory =
  | (typeof StorefrontItemResponseDtoTaxCategory)[keyof typeof StorefrontItemResponseDtoTaxCategory]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontItemResponseDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

/**
 * 시장 기준값(세모 가격밴드). 같은 품명의 SKU 가 없거나 표본이 모자라면 null
 * @nullable
 */
export type StorefrontItemResponseDtoBenchmark =
  StorefrontMarketBenchmarkDto | null;

export interface StorefrontItemResponseDto {
  /** 품목 ID (items_v2_base.id) */
  itemId: string;
  /** 상품명 */
  name: string;
  /** 판매가(원). 마스터가 정한 가격 규칙이 적용된 값 */
  price: number;
  /**
   * 카테고리 ID
   * @nullable
   */
  categoryId?: string | null;
  /**
   * 카테고리명
   * @nullable
   */
  categoryName?: string | null;
  /**
   * 대분류(카테고리 계층 최상위) 이름. categoryName 은 말단 소분류라 개수가 많다(현재 253개). 목록 상단 카테고리 묶음에는 이 값을 쓴다(현재 20개). 계층이 3단을 넘으면 null.
   * @nullable
   */
  rootCategoryName?: string | null;
  /**
   * 제조사
   * @nullable
   */
  manufacturer?: string | null;
  /**
   * 브랜드
   * @nullable
   */
  brand?: string | null;
  /**
   * 단위
   * @nullable
   */
  unit?: string | null;
  /**
   * 규격 1
   * @nullable
   */
  spec1?: string | null;
  /**
   * 규격 2
   * @nullable
   */
  spec2?: string | null;
  /**
   * 규격 3
   * @nullable
   */
  spec3?: string | null;
  /**
   * 이미지 URL
   * @nullable
   */
  imageUrl?: string | null;
  /** 이 품목을 대는 공급사 수(익명). 2 이상이면 단가 리스트가 있고 price 는 그중 최저가다 */
  offerCount: number;
  /**
   * 가장 비싼 오퍼. 손님에게 «최대 N원 절약» 을 보여 줄 때 쓴다
   * @nullable
   */
  maxPrice?: number | null;
  /**
   * 표시가의 부가세 축(EXCLUSIVE=공급가액 / INCLUSIVE=부가세 포함). null 이면 미지정
   * @nullable
   */
  taxType?: string | null;
  /**
   * 품목의 과세 상태. EXEMPT·ZERO_RATED 는 부가세가 0이라 총액이 표시가와 같다. null 이면 미확인이며, 그 경우 총액은 과세로 보고 계산하는 편이 안전하다
   * @nullable
   */
  taxCategory?: StorefrontItemResponseDtoTaxCategory;
  /**
   * 시장 기준값(세모 가격밴드). 같은 품명의 SKU 가 없거나 표본이 모자라면 null
   * @nullable
   */
  benchmark?: StorefrontItemResponseDtoBenchmark;
  /**
   * MD 큐레이션 순위. 세모에 아직 원천이 없어 null
   * @nullable
   */
  mdRank?: number | null;
  /**
   * 최근 90일 공공기관 주문 건수. 주문자 구분(발주기관/기업)이 붙기 전까지 null
   * @nullable
   */
  popularity?: number | null;
}

export interface StorefrontItemListResponseDto {
  items: StorefrontItemResponseDto[];
  total: number;
  limit: number;
  offset: number;
}

export interface StorefrontCategoryChildDto {
  /** @nullable */
  categoryId?: string | null;
  /** @nullable */
  categoryName?: string | null;
  /** 이 소분류에 노출 중인 상품 수 */
  itemCount: number;
}

export interface StorefrontCategoryGroupDto {
  /** @nullable */
  rootCategoryId?: string | null;
  /**
   * 대분류 이름. 계층이 3단을 넘으면 null 이라 «기타» 로 묶인다
   * @nullable
   */
  rootCategoryName?: string | null;
  /** 이 대분류에 노출 중인 상품 수 */
  itemCount: number;
  children: StorefrontCategoryChildDto[];
}

export interface StorefrontCategoryListResponseDto {
  groups: StorefrontCategoryGroupDto[];
  /** 노출 중인 상품 총 수 */
  total: number;
}

export interface StorefrontPriceTierDto {
  /** 이 수량부터 */
  minQuantity: number;
  /** 구간 단가(원) */
  price: number;
}

/**
 * @nullable
 */
export type StorefrontOfferResponseDtoTaxCategory =
  | (typeof StorefrontOfferResponseDtoTaxCategory)[keyof typeof StorefrontOfferResponseDtoTaxCategory]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontOfferResponseDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

export interface StorefrontOfferResponseDto {
  /** 이 오퍼의 식별자. 주문할 때 이 값을 지정한다 */
  offerId: string;
  /** 판매가(원) */
  price: number;
  /** 가격 순위. 1 이 최저가 */
  priceRank: number;
  /** @nullable */
  taxType?: string | null;
  /** @nullable */
  taxCategory?: StorefrontOfferResponseDtoTaxCategory;
  /**
   * 공급사 ID(세모 suppliers.id). 파트너 API 키 호출에만 실린다
   * @nullable
   */
  supplierId?: string | null;
  /**
   * 공급사 상호. 파트너 API 키 호출에만 실린다
   * @nullable
   */
  supplierName?: string | null;
  /**
   * 수량 구간 단가(minQuantity 오름차순). 세모에 구간 단가 원천이 없어 null
   * @nullable
   */
  tiers?: StorefrontPriceTierDto[] | null;
  /**
   * 세모 공급자 신뢰도(0~100, 매일 03시 배치). 0 은 «집계 전» 이라 null
   * @nullable
   */
  trustScore?: number | null;
  /**
   * 최근 6개월 씨마켓 공고 낙찰 건수. 세모 DB 에 원천이 없어 null
   * @nullable
   */
  recentAwards?: number | null;
  /**
   * 납품 리드타임(일). 공급사가 재고 화면에 입력한 값(supplier_item_stock)
   * @nullable
   */
  leadDays?: number | null;
  /**
   * 공급사 «직접 구매» 수락 여부. 원천이 없어 null(몰은 null 을 «가능» 으로 본다)
   * @nullable
   */
  directPurchase?: boolean | null;
  /**
   * 공급사 단위 배송비(원). 배송비 정책 원천이 없어 null
   * @nullable
   */
  shippingFee?: number | null;
  /**
   * 이 금액(공급가액) 이상이면 배송비 면제. 원천이 없어 null
   * @nullable
   */
  freeShippingOver?: number | null;
}

export interface StorefrontOfferListResponseDto {
  offers: StorefrontOfferResponseDto[];
  /** 오퍼 수 */
  total: number;
  /** 최저가 */
  minPrice: number;
  /** 최고가 */
  maxPrice: number;
}

export interface StorefrontPointBalanceDto {
  balance: StorefrontPointSummaryDto;
  /** 원장 이력(최신순, 최대 100건) */
  entries: StorefrontPointEntryDto[];
}

export type StorefrontOrderItemDtoPriceTaxType =
  (typeof StorefrontOrderItemDtoPriceTaxType)[keyof typeof StorefrontOrderItemDtoPriceTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontOrderItemDtoPriceTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export type StorefrontOrderItemDtoTaxCategory =
  (typeof StorefrontOrderItemDtoTaxCategory)[keyof typeof StorefrontOrderItemDtoTaxCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontOrderItemDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

export interface StorefrontOrderItemDto {
  seq: number;
  itemId: string;
  /** @nullable */
  offeringId?: string | null;
  name: string;
  /** @nullable */
  spec?: string | null;
  /** @nullable */
  unit?: string | null;
  quantity: number;
  /** 주문 시점 판매가 스냅샷 */
  salePrice: number;
  priceTaxType: StorefrontOrderItemDtoPriceTaxType;
  taxCategory: StorefrontOrderItemDtoTaxCategory;
}

export interface ShipmentItemDto {
  itemId: string;
  name: string;
  quantity: number;
}

/**
 * 신고 종류(파손 · 수량 누락 · 오배송 · 미수령 · 기타)
 */
export type ShipmentDisputeDtoCode =
  (typeof ShipmentDisputeDtoCode)[keyof typeof ShipmentDisputeDtoCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentDisputeDtoCode = {
  DAMAGED: "DAMAGED",
  MISSING_ITEMS: "MISSING_ITEMS",
  WRONG_ITEM: "WRONG_ITEM",
  NOT_RECEIVED: "NOT_RECEIVED",
  OTHER: "OTHER",
} as const;

export interface ShipmentDisputeDto {
  /** 신고 종류(파손 · 수량 누락 · 오배송 · 미수령 · 기타) */
  code: ShipmentDisputeDtoCode;
  /**
   * 주문자가 적은 신고 내용
   * @nullable
   */
  note: string | null;
  /** 신고 시각 */
  at: string;
}

export interface ShipmentTrackingEventDto {
  /** @nullable */
  at?: string | null;
  /**
   * 위치(집화점·터미널 등)
   * @nullable
   */
  where?: string | null;
  /**
   * 처리 내용
   * @nullable
   */
  kind?: string | null;
  /**
   * 택배사 단계 1~6
   * @nullable
   */
  level?: number | null;
}

/**
 * 옛 화면 호환용 5값. 배달 출발·배송 예외는 `IN_TRANSIT`, 반송은 `CANCELED` 로 접힌다. 정확한 상태는 `deliveryStatus`.
 */
export type ShipmentDtoStatus =
  (typeof ShipmentDtoStatus)[keyof typeof ShipmentDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentDtoStatus = {
  READY: "READY",
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  DELIVERED: "DELIVERED",
  CANCELED: "CANCELED",
} as const;

/**
 * 배송 상태(정확한 값)
 */
export type ShipmentDtoDeliveryStatus =
  (typeof ShipmentDtoDeliveryStatus)[keyof typeof ShipmentDtoDeliveryStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentDtoDeliveryStatus = {
  READY: "READY",
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  EXCEPTION: "EXCEPTION",
  RETURNED: "RETURNED",
  CANCELED: "CANCELED",
} as const;

/**
 * 수령 상태. 몰 주문은 주문 단위 구매 확정이 쥐고 있어 송장에는 자동 확정 타이머가 없다. 주문자가 문제를 신고하면 `DISPUTED` — 신고가 풀릴 때까지 자동 구매확정이 보류된다.
 */
export type ShipmentDtoAcceptanceStatus =
  (typeof ShipmentDtoAcceptanceStatus)[keyof typeof ShipmentDtoAcceptanceStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentDtoAcceptanceStatus = {
  NOT_DUE: "NOT_DUE",
  AWAITING: "AWAITING",
  RECEIVED: "RECEIVED",
  AUTO_RECEIVED: "AUTO_RECEIVED",
  DISPUTED: "DISPUTED",
} as const;

/**
 * 마지막 문제 신고 기록(없으면 null). 지금 신고 중인지는 `acceptanceStatus` 가 `DISPUTED` 인지로 안다
 * @nullable
 */
export type ShipmentDtoDispute = ShipmentDisputeDto | null;

/**
 * @nullable
 */
export type ShipmentDtoExceptionCode =
  | (typeof ShipmentDtoExceptionCode)[keyof typeof ShipmentDtoExceptionCode]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentDtoExceptionCode = {
  DELAYED: "DELAYED",
  ATTEMPT_FAILED: "ATTEMPT_FAILED",
  HELD: "HELD",
  DAMAGED: "DAMAGED",
  LOST: "LOST",
  OTHER: "OTHER",
} as const;

export interface ShipmentDto {
  id: string;
  /** 주문 id(`storefront_orders.id`) */
  orderId: string;
  /** 보내는 공급사(사용자 id) */
  supplierId: string;
  /** @nullable */
  courierCode?: string | null;
  /** @nullable */
  courierName?: string | null;
  /** @nullable */
  trackingNo?: string | null;
  /** 옛 화면 호환용 5값. 배달 출발·배송 예외는 `IN_TRANSIT`, 반송은 `CANCELED` 로 접힌다. 정확한 상태는 `deliveryStatus`. */
  status: ShipmentDtoStatus;
  /** @nullable */
  shippedAt?: string | null;
  /** @nullable */
  deliveredAt?: string | null;
  /** @nullable */
  note?: string | null;
  createdAt: string;
  items: ShipmentItemDto[];
  /** 배송 상태(정확한 값) */
  deliveryStatus: ShipmentDtoDeliveryStatus;
  /** 수령 상태. 몰 주문은 주문 단위 구매 확정이 쥐고 있어 송장에는 자동 확정 타이머가 없다. 주문자가 문제를 신고하면 `DISPUTED` — 신고가 풀릴 때까지 자동 구매확정이 보류된다. */
  acceptanceStatus: ShipmentDtoAcceptanceStatus;
  /**
   * 마지막 문제 신고 기록(없으면 null). 지금 신고 중인지는 `acceptanceStatus` 가 `DISPUTED` 인지로 안다
   * @nullable
   */
  dispute: ShipmentDtoDispute;
  /** @nullable */
  exceptionCode: ShipmentDtoExceptionCode;
  /**
   * 택배사 조회 페이지 링크
   * @nullable
   */
  trackingUrl?: string | null;
  /**
   * 택배 조회 단계 1 준비중·2 집화·3 배송중·4 지점도착·5 배달출발·6 완료
   * @nullable
   */
  trackingLevel?: number | null;
  /**
   * 단계 문구(«배송중» 등). 조회 전이면 null
   * @nullable
   */
  trackingLabel?: string | null;
  /** 최근 택배 조회 이력(시간순) */
  trackingEvents: ShipmentTrackingEventDto[];
  /**
   * 마지막 조회 시도 시각
   * @nullable
   */
  lastSyncedAt?: string | null;
  /**
   * 마지막 조회 실패 사유. 성공이면 null
   * @nullable
   */
  syncError?: string | null;
  /** 송장 버전(낙관적 잠금용) */
  version: number;
  /** 사람이 봐야 하는 송장인가(배송 예외 · 조회 종료 · 조회 실패 · 문제 신고 중) */
  needsAttention: boolean;
}

export type StorefrontOrderDtoStatus =
  (typeof StorefrontOrderDtoStatus)[keyof typeof StorefrontOrderDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontOrderDtoStatus = {
  PLACED: "PLACED",
  QUOTING: "QUOTING",
  QUOTE_CLOSED: "QUOTE_CLOSED",
  SENT_TO_ERP: "SENT_TO_ERP",
  CONTRACTED: "CONTRACTED",
  SHIPPING: "SHIPPING",
  DELIVERED: "DELIVERED",
  INSPECTED: "INSPECTED",
  SETTLED: "SETTLED",
  CANCELED: "CANCELED",
} as const;

/**
 * 씨마켓몰 고객 유형. 종전 몰 주문은 null.
 * @nullable
 */
export type StorefrontOrderDtoCustomerType =
  | (typeof StorefrontOrderDtoCustomerType)[keyof typeof StorefrontOrderDtoCustomerType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontOrderDtoCustomerType = {
  INSTITUTION: "INSTITUTION",
  COMPANY: "COMPANY",
} as const;

/**
 * SUPPLIER_DIRECT = 공급사 판매 · CMARKET_AGENCY = 씨마켓 구매대행(최저가 고정).
 * @nullable
 */
export type StorefrontOrderDtoDealType =
  | (typeof StorefrontOrderDtoDealType)[keyof typeof StorefrontOrderDtoDealType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontOrderDtoDealType = {
  SUPPLIER_DIRECT: "SUPPLIER_DIRECT",
  CMARKET_AGENCY: "CMARKET_AGENCY",
} as const;

/**
 * @nullable
 */
export type StorefrontOrderDtoRoute =
  | (typeof StorefrontOrderDtoRoute)[keyof typeof StorefrontOrderDtoRoute]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontOrderDtoRoute = {
  SAFE: "SAFE",
  DIRECT: "DIRECT",
} as const;

/**
 * @nullable
 */
export type StorefrontOrderDtoPaymentMethod =
  | (typeof StorefrontOrderDtoPaymentMethod)[keyof typeof StorefrontOrderDtoPaymentMethod]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontOrderDtoPaymentMethod = {
  TAX_INVOICE: "TAX_INVOICE",
  CARD: "CARD",
  POINT: "POINT",
} as const;

export interface StorefrontOrderDto {
  /** 구매번호 */
  orderNo: string;
  status: StorefrontOrderDtoStatus;
  /** @nullable */
  employeeNo?: string | null;
  shipToName: string;
  shipToZip: string;
  shipToAddress: string;
  /** @nullable */
  shipToTel?: string | null;
  /** 공급가액 합계 */
  totalSupply: number;
  /** 부가세 합계 */
  totalVat: number;
  /** 발주기관이 내는 금액 */
  totalPayable: number;
  /**
   * KCL ERP 가 채번한 구매요구번호. 이 값이 들어오면 계약이 선다.
   * @nullable
   */
  erpRequisitionNo?: string | null;
  /** @nullable */
  erpSentAt?: string | null;
  /** @nullable */
  erpRequisitionedAt?: string | null;
  /** @nullable */
  canceledAt?: string | null;
  /**
   * 씨마켓몰 고객 유형. 종전 몰 주문은 null.
   * @nullable
   */
  customerType?: StorefrontOrderDtoCustomerType;
  /**
   * SUPPLIER_DIRECT = 공급사 판매 · CMARKET_AGENCY = 씨마켓 구매대행(최저가 고정).
   * @nullable
   */
  dealType?: StorefrontOrderDtoDealType;
  /** @nullable */
  route?: StorefrontOrderDtoRoute;
  /** @nullable */
  paymentMethod?: StorefrontOrderDtoPaymentMethod;
  /** @nullable */
  quoteNo?: string | null;
  createdAt: string;
  items: StorefrontOrderItemDto[];
  shipments?: ShipmentDto[];
}

export interface StorefrontOrderShipToDto {
  name: string;
  zip: string;
  address: string;
  tel?: string;
  /** 기관 사업장 코드. ERP 가 코드를 쓰면 이 값으로 넘어간다. */
  siteCode?: string;
}

export interface StorefrontOrderLineDto {
  /** 품목 id */
  itemId: string;
  /** 고른 오퍼 id. 한 품목을 여러 공급사가 대는 몰에서 필요하다. 없으면 대표(최저가) 오퍼로 확정한다. */
  offeringId?: string;
  quantity: number;
}

export interface StorefrontOrderPaymentDto {
  /** 씨마켓 저장카드 id(payment-options.cards[].id). paymentMethod=CARD 면 필수. */
  cardId?: number;
  /** 카드 결제 확인 비밀번호(숫자 6자리) — 그 카드가 requiresPassword 면 필수. */
  cardPassword?: string;
}

/**
 * 씨마켓몰 결제 경로. SAFE = 씨마켓 안전결제(씨마켓 수납·정산) · DIRECT = 공급사 직접구매(발주기관만). 없으면 SAFE.
 */
export type CreateStorefrontOrderDtoRoute =
  (typeof CreateStorefrontOrderDtoRoute)[keyof typeof CreateStorefrontOrderDtoRoute];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateStorefrontOrderDtoRoute = {
  SAFE: "SAFE",
  DIRECT: "DIRECT",
} as const;

/**
 * 씨마켓몰 결제수단. 발주기관은 TAX_INVOICE(후불)·CARD·POINT, 공급기업은 CARD·POINT 선불만. 발주기관이 안 보내면 TAX_INVOICE.
 */
export type CreateStorefrontOrderDtoPaymentMethod =
  (typeof CreateStorefrontOrderDtoPaymentMethod)[keyof typeof CreateStorefrontOrderDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateStorefrontOrderDtoPaymentMethod = {
  TAX_INVOICE: "TAX_INVOICE",
  CARD: "CARD",
  POINT: "POINT",
} as const;

export interface CreateStorefrontOrderDto {
  /** 주문자. KCL 몰은 ERP 사원번호, 씨마켓몰은 씨마켓 로그인 sub(«역할:그룹코드:회원ID») — 씨마켓몰은 이 값의 역할로 고객 유형(발주기관·공급기업)과 결제 규칙이 정해진다. */
  employeeNo?: string;
  /** 씨마켓몰 결제 주체의 씨마켓 **회원** id. 주문자가 씨마켓 직원(EMPLOYEE)이면 필수 — 소속 회원(SSO userinfo companyMemberId)의 저장카드·포인트로 결제한다. 발주기관·공급기업은 생략(보내면 본인이어야 한다). */
  payerMemberId?: string;
  shipTo: StorefrontOrderShipToDto;
  items: StorefrontOrderLineDto[];
  /** 몰이 만든 주문 키. 같은 키로 다시 보내면 새 주문 대신 **먼저 만든 주문**이 돌아온다. 네트워크가 끊겨 재시도할 때 같은 물건을 두 번 사는 것을 막는 자리다. */
  clientOrderKey?: string;
  /** 씨마켓몰 결제 경로. SAFE = 씨마켓 안전결제(씨마켓 수납·정산) · DIRECT = 공급사 직접구매(발주기관만). 없으면 SAFE. */
  route?: CreateStorefrontOrderDtoRoute;
  /** 씨마켓몰 결제수단. 발주기관은 TAX_INVOICE(후불)·CARD·POINT, 공급기업은 CARD·POINT 선불만. 발주기관이 안 보내면 TAX_INVOICE. */
  paymentMethod?: CreateStorefrontOrderDtoPaymentMethod;
  /** 몰이 발급한 견적서 번호. 주문과 견적서를 잇는 유일한 키다. */
  quoteNo?: string;
  /** 씨마켓몰 안전결제의 결제 입력. paymentMethod=CARD 면 cardId 필수(+잠금 카드는 cardPassword). POINT·TAX_INVOICE 는 없어도 된다. 결제는 주문 등록과 같은 요청에서 씨마켓이 승인한다 — 거절되면 주문은 남지 않고 402/400 으로 사유가 온다. */
  payment?: StorefrontOrderPaymentDto;
}

export interface StorefrontOrderListDto {
  orders: StorefrontOrderDto[];
  total: number;
  limit: number;
  offset: number;
}

export interface RequisitionedStorefrontOrderDto {
  /** KCL ERP 가 채번한 구매요구번호 */
  requisitionNo: string;
  /** 구매요구가 만들어진 시각. 씨마켓이 못 받은 경우가 있어 선택이며, 없으면 수신 시각으로 둔다. */
  requisitionedAt?: string;
}

export type InspectionDtoStatus =
  (typeof InspectionDtoStatus)[keyof typeof InspectionDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InspectionDtoStatus = {
  OPEN: "OPEN",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
} as const;

export interface InspectionDto {
  status: InspectionDtoStatus;
  /**
   * 담당자가 라벨을 촬영할 팝업 주소
   * @nullable
   */
  verificationUrl?: string | null;
  /** 대조 대상 줄 수 */
  targetCount: number;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  reportUrl?: string | null;
  /** @nullable */
  matchedCount?: number | null;
  /** @nullable */
  unmatchedCount?: number | null;
  createdAt: string;
}

export interface CompleteInspectionDto {
  /** 검수확인서 PDF 주소 */
  reportUrl?: string;
  /** 대조가 일치한 줄 수 */
  matchedCount?: number;
  /** 불일치 줄 수. **남아 있어도 완료로 처리한다** — 게이트는 «마쳤는가» 만 본다. */
  unmatchedCount?: number;
}

export interface CancelStorefrontOrderDto {
  /** 취소 사유 */
  reason?: string;
}

export interface StorefrontPaymentCardDto {
  /** 씨마켓 저장카드 id — 주문의 payment.cardId 로 보낸다. */
  id: number;
  cardNickname: string;
  maskedCardNumber: string;
  /** 결제 확인 비밀번호(숫자 6자리)가 걸린 카드 — 주문 때 payment.cardPassword 가 필요하다. */
  requiresPassword: boolean;
}

export interface StorefrontPaymentPointsDto {
  /** 몰 결제에 쓸 수 있는 포인트 합(보너스+충전+판매대금). */
  balance: number;
  bonusBalance: number;
  paidBalance: number;
  settlementBalance: number;
}

export interface StorefrontPaymentOptionsDto {
  cards: StorefrontPaymentCardDto[];
  points: StorefrontPaymentPointsDto;
}

export type StorefrontQuoteLineDtoPriceTaxType =
  (typeof StorefrontQuoteLineDtoPriceTaxType)[keyof typeof StorefrontQuoteLineDtoPriceTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontQuoteLineDtoPriceTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export type StorefrontQuoteLineDtoTaxCategory =
  (typeof StorefrontQuoteLineDtoTaxCategory)[keyof typeof StorefrontQuoteLineDtoTaxCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontQuoteLineDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

export interface StorefrontQuoteLineDto {
  itemId: string;
  /**
   * 확정된 세모 오퍼 id
   * @nullable
   */
  offerId: string | null;
  name: string;
  /** @nullable */
  spec: string | null;
  /** @nullable */
  unit: string | null;
  quantity: number;
  /** 세모 카탈로그가 확정한 판매가(원) */
  unitPrice: number;
  /** @nullable */
  supplierName: string | null;
  priceTaxType: StorefrontQuoteLineDtoPriceTaxType;
  taxCategory: StorefrontQuoteLineDtoTaxCategory;
}

export interface StorefrontQuoteSubscriptionDto {
  planKey: string;
  planName: string;
  people: number;
  frequencyLabel: string;
  /** 월 예상 금액(공급가액, 원). 구독 상품 단가표는 몰 설정(`config/subscriptions.ts`)에만 있어 세모는 이 값을 검증하지 못하고 범위만 본다. */
  monthlyEstimate: number;
}

export type StorefrontQuoteDtoKind =
  (typeof StorefrontQuoteDtoKind)[keyof typeof StorefrontQuoteDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontQuoteDtoKind = {
  CART: "CART",
  SUBSCRIPTION: "SUBSCRIPTION",
} as const;

/**
 * @nullable
 */
export type StorefrontQuoteDtoRoute =
  | (typeof StorefrontQuoteDtoRoute)[keyof typeof StorefrontQuoteDtoRoute]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontQuoteDtoRoute = {
  SAFE: "SAFE",
  DIRECT: "DIRECT",
} as const;

/**
 * @nullable
 */
export type StorefrontQuoteDtoSubscription =
  StorefrontQuoteSubscriptionDto | null;

export interface StorefrontQuoteDto {
  /** 견적번호(세모 채번) */
  quoteNo: string;
  kind: StorefrontQuoteDtoKind;
  /** 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 콜론을 포함하고 30자를 넘을 수 있다. 견적서의 소유는 이 값 하나로 가른다. */
  ownerKey: string;
  /** 발급 시각(ISO) */
  createdAt: string;
  /** 이 시각까지 견적 단가로 주문할 수 있다(ISO, 발급 + 7일) */
  validUntil: string;
  /** @nullable */
  route: StorefrontQuoteDtoRoute;
  lines: StorefrontQuoteLineDto[];
  /** 공급가액 합(배송비 제외) */
  supply: number;
  /** 배송비 합 */
  shipping: number;
  /** 부가세 — 과세 합계에서 한 번만 산출 */
  vat: number;
  /** 청구 총액 = 공급가액 + 배송비 + 부가세 */
  total: number;
  /** 얽힌 공급사 수(직접 구매 시 계약·계산서 수) */
  supplierCount: number;
  /** @nullable */
  subscription: StorefrontQuoteDtoSubscription;
}

export interface StorefrontQuoteLineRequestDto {
  /** 품목 id */
  itemId: string;
  /**
   * 몰이 고른 오퍼 id(피드의 `offerId`). 없거나 세모 오퍼 id 가 아니면(몰의 `base:` 임시 오퍼 등) 그 품목의 대표(최저가) 오퍼로 확정한다. 지정한 오퍼가 더 이상 팔리지 않으면 409.
   * @nullable
   */
  offerId?: string | null;
  quantity: number;
  /**
   * 견적서에 적을 공급처 표시명. 손님 등급에 따라 가릴지는 몰이 정한다(가린 손님이면 비운다). 표시용일 뿐 단가·공급사 확정에는 쓰지 않는다.
   * @nullable
   */
  supplierName?: string | null;
}

export type CreateStorefrontQuoteDtoKind =
  (typeof CreateStorefrontQuoteDtoKind)[keyof typeof CreateStorefrontQuoteDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateStorefrontQuoteDtoKind = {
  CART: "CART",
  SUBSCRIPTION: "SUBSCRIPTION",
} as const;

/**
 * 씨마켓 안전결제(SAFE) / 공급사 직접 구매(DIRECT). 몰이 정한 값을 적어 둔다.
 * @nullable
 */
export type CreateStorefrontQuoteDtoRoute =
  | (typeof CreateStorefrontQuoteDtoRoute)[keyof typeof CreateStorefrontQuoteDtoRoute]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateStorefrontQuoteDtoRoute = {
  SAFE: "SAFE",
  DIRECT: "DIRECT",
} as const;

export interface CreateStorefrontQuoteDto {
  /** 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 콜론을 포함하고 30자를 넘을 수 있다. 견적서의 소유는 이 값 하나로 가른다. */
  ownerKey: string;
  kind: CreateStorefrontQuoteDtoKind;
  /**
   * 씨마켓 안전결제(SAFE) / 공급사 직접 구매(DIRECT). 몰이 정한 값을 적어 둔다.
   * @nullable
   */
  route?: CreateStorefrontQuoteDtoRoute;
  /** CART 견적의 품목(1~200줄). SUBSCRIPTION 이면 보내지 않는다. */
  items?: StorefrontQuoteLineRequestDto[];
  /** 배송비 합(공급가액, 원). 공급사 배송비 규칙은 아직 세모 카탈로그에 없어 몰이 계산한 값을 받는다. 부가세는 세모가 (공급가액 + 배송비)에서 다시 계산한다. */
  shipping?: number;
  /** SUBSCRIPTION 견적의 설계값. CART 이면 보내지 않는다. */
  subscription?: StorefrontQuoteSubscriptionDto;
}

export interface StorefrontQuoteListDto {
  quotes: StorefrontQuoteDto[];
  total: number;
  limit: number;
  offset: number;
}

export interface SubscriptionFrequencyDto {
  label: string;
  /** 한 달에 몇 번 — 월 예상액(주기 금액 × 배수) 표시용. */
  multiplier: number;
  /**
   * 결제 간격(일). null 이면 달력 한 달(신청일의 일자가 닻, 짧은 달은 말일).
   * @nullable
   */
  intervalDays?: number | null;
}

export type SubscriptionPlanOfferDtoPriceTaxType =
  (typeof SubscriptionPlanOfferDtoPriceTaxType)[keyof typeof SubscriptionPlanOfferDtoPriceTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionPlanOfferDtoPriceTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export type SubscriptionPlanOfferDtoTaxCategory =
  (typeof SubscriptionPlanOfferDtoTaxCategory)[keyof typeof SubscriptionPlanOfferDtoTaxCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionPlanOfferDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

export interface SubscriptionPlanOfferDto {
  /** 세모 승인 오퍼 id */
  offeringId: string;
  /** 품목 id */
  itemId: string;
  name: string;
  /**
   * 지금 단가(원). null 이면 그 오퍼가 지금 팔리지 않아 신청·결제가 실패한다.
   * @nullable
   */
  unitPrice?: number | null;
  priceTaxType: SubscriptionPlanOfferDtoPriceTaxType;
  taxCategory: SubscriptionPlanOfferDtoTaxCategory;
}

/**
 * 인원과 무관한 기본료 품목(수량 1). 없으면 null.
 * @nullable
 */
export type SubscriptionPlanDtoBaseFee = SubscriptionPlanOfferDto | null;

export interface SubscriptionPlanDto {
  key: string;
  name: string;
  /** @nullable */
  description?: string | null;
  /** 손님이 «무엇이 오는지» 보는 표시용 목록 */
  includes: string[];
  frequencies: SubscriptionFrequencyDto[];
  /** frequencies 의 기본 선택 index */
  defaultFrequency: number;
  minPeople: number;
  maxPeople: number;
  /** 인원당 1개씩 담기는 품목(주문 줄 수량 = 인원). */
  perPerson: SubscriptionPlanOfferDto;
  /**
   * 인원과 무관한 기본료 품목(수량 1). 없으면 null.
   * @nullable
   */
  baseFee?: SubscriptionPlanDtoBaseFee;
  /** 두 오퍼 모두 지금 단가가 있어 신청할 수 있는가. */
  available: boolean;
}

export interface SubscriptionPlanListDto {
  plans: SubscriptionPlanDto[];
}

export interface SubscriptionPlanSummaryDto {
  key: string;
  name: string;
}

export interface SubscriptionFrequencySnapshotDto {
  label: string;
  /** 한 달에 몇 번 — 월 예상액(주기 금액 × 배수) 표시용. */
  multiplier: number;
  /**
   * 결제 간격(일). null 이면 달력 한 달(신청일의 일자가 닻, 짧은 달은 말일).
   * @nullable
   */
  intervalDays?: number | null;
  /** 신청 때 고른 frequencies index */
  index: number;
}

export interface SubscriptionShipToDto {
  name: string;
  zip: string;
  address: string;
  /** @nullable */
  tel?: string | null;
  /** @nullable */
  siteCode?: string | null;
}

export interface SubscriptionEstimateDto {
  /**
   * 한 주기 주문의 공급가액(지금 단가). 팔 수 없는 오퍼가 있으면 null.
   * @nullable
   */
  cycleSupply?: number | null;
  /** @nullable */
  cycleVat?: number | null;
  /**
   * 한 주기에 포인트로 빠지는 금액(공급가액 + 부가세).
   * @nullable
   */
  cyclePayable?: number | null;
  /**
   * 월 예상 공급가액 = 주기 공급가액 × 배수(표시용).
   * @nullable
   */
  monthlySupply?: number | null;
}

export type SubscriptionCycleDtoStatus =
  (typeof SubscriptionCycleDtoStatus)[keyof typeof SubscriptionCycleDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionCycleDtoStatus = {
  PENDING: "PENDING",
  ORDERED: "ORDERED",
  FAILED: "FAILED",
  SKIPPED: "SKIPPED",
} as const;

export interface SubscriptionCycleDto {
  cycleNo: number;
  /** 결제 예정 시각(ISO) */
  billingAt: string;
  status: SubscriptionCycleDtoStatus;
  /**
   * 이 주기로 선 몰 주문번호
   * @nullable
   */
  orderNo?: string | null;
  /** @nullable */
  failureReason?: string | null;
  /** 시도 횟수(재시도 포함) */
  attempts: number;
  /** @nullable */
  orderedAt?: string | null;
}

/**
 * ACTIVE = 결제 중 · PAYMENT_FAILED = 직전 주기 실패(매일 재시도) · PAUSED = 일시정지(손님 또는 3회 실패) · CANCELED = 해지.
 */
export type StorefrontSubscriptionDtoStatus =
  (typeof StorefrontSubscriptionDtoStatus)[keyof typeof StorefrontSubscriptionDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontSubscriptionDtoStatus = {
  ACTIVE: "ACTIVE",
  PAUSED: "PAUSED",
  CANCELED: "CANCELED",
  PAYMENT_FAILED: "PAYMENT_FAILED",
} as const;

export interface StorefrontSubscriptionDto {
  /** 구독 id(uuid) */
  id: string;
  /** ACTIVE = 결제 중 · PAYMENT_FAILED = 직전 주기 실패(매일 재시도) · PAUSED = 일시정지(손님 또는 3회 실패) · CANCELED = 해지. */
  status: StorefrontSubscriptionDtoStatus;
  /** 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 견적서·주문(employeeNo)과 같은 값이며 구독의 소유는 이 값 하나로 가른다. 포인트는 이 값의 회원ID 지갑에서 차감된다. */
  ownerKey: string;
  plan: SubscriptionPlanSummaryDto;
  people: number;
  frequency: SubscriptionFrequencySnapshotDto;
  shipTo: SubscriptionShipToDto;
  /**
   * 다음 결제(주문) 예정 시각(ISO). 해지면 null.
   * @nullable
   */
  nextBillingAt?: string | null;
  /**
   * 마지막으로 선 주문번호
   * @nullable
   */
  lastOrderNo?: string | null;
  /** @nullable */
  lastBilledAt?: string | null;
  /** @nullable */
  pausedAt?: string | null;
  /** @nullable */
  pauseReason?: string | null;
  /** @nullable */
  canceledAt?: string | null;
  /** @nullable */
  cancelReason?: string | null;
  /** 지금 단가로 본 예상 금액(미리보기) */
  estimate: SubscriptionEstimateDto;
  createdAt: string;
  updatedAt: string;
  /** 주기별 결제 기록(최신순). **상세에서만** 채운다. */
  cycles?: SubscriptionCycleDto[];
}

/**
 * ORDERED = 주기 주문·포인트 결제 완료 · FAILED = 실패(구독은 PAYMENT_FAILED 로 남고 내일 09:00 재시도, 충전 뒤 retry-payment 로 바로 재시도 가능) · PROCESSING = 결제 결과를 아직 모름(결제 진행 중·일시 오류) — 실패로 세지 않았고 같은 주문 키로 다시 확인한다. 다시 신청하지 말고 잠시 뒤 구독 상세(cycles)에서 결과를 본다.
 */
export type SubscriptionFirstCycleDtoStatus =
  (typeof SubscriptionFirstCycleDtoStatus)[keyof typeof SubscriptionFirstCycleDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionFirstCycleDtoStatus = {
  ORDERED: "ORDERED",
  FAILED: "FAILED",
  PROCESSING: "PROCESSING",
} as const;

export interface SubscriptionFirstCycleDto {
  /** ORDERED = 주기 주문·포인트 결제 완료 · FAILED = 실패(구독은 PAYMENT_FAILED 로 남고 내일 09:00 재시도, 충전 뒤 retry-payment 로 바로 재시도 가능) · PROCESSING = 결제 결과를 아직 모름(결제 진행 중·일시 오류) — 실패로 세지 않았고 같은 주문 키로 다시 확인한다. 다시 신청하지 말고 잠시 뒤 구독 상세(cycles)에서 결과를 본다. */
  status: SubscriptionFirstCycleDtoStatus;
  /** @nullable */
  orderNo?: string | null;
  /**
   * 실패 사유(잔액 부족 등) 또는 확인 중 안내(PROCESSING) — 손님에게 그대로 보여 줄 수 있는 말.
   * @nullable
   */
  failureReason?: string | null;
  /**
   * 실패의 HTTP 상태(402 = 포인트 부족 등). PROCESSING 이면 결과를 모르게 한 상태(503 등, 없으면 null). 성공이면 null.
   * @nullable
   */
  failureStatus?: number | null;
}

export interface CreateStorefrontSubscriptionResultDto {
  subscription: StorefrontSubscriptionDto;
  firstCycle: SubscriptionFirstCycleDto;
}

export interface CreateStorefrontSubscriptionDto {
  /** 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 견적서·주문(employeeNo)과 같은 값이며 구독의 소유는 이 값 하나로 가른다. 포인트는 이 값의 회원ID 지갑에서 차감된다. */
  ownerKey: string;
  /** 구독 상품 키(subscription-plans[].key) */
  planKey: string;
  /** 사무실 인원. 상품의 min~max 안이어야 한다. */
  people: number;
  /** 주기 index(subscription-plans[].frequencies). 없으면 상품 기본값. */
  frequencyIndex?: number;
  /** 매 주기 주문의 배송지. 신청 시점 스냅샷이다. */
  shipTo: StorefrontOrderShipToDto;
  /**
   * 신청 멱등키(권장). 같은 몰·같은 ownerKey 안에서 유일하다. 같은 키로 다시 보내면(시간 초과 뒤 재시도·두 번 클릭) 새 구독·새 결제를 만들지 않고 처음 신청의 구독과 첫 결제 결과를 돌려준다. 같은 키로 다른 상품을 보내면 409. 키가 없어도 같은 상품의 살아 있는(해지 아닌) 구독이 있으면 409 — 결제 실패 구독은 retry-payment, 정지 구독은 resume 으로 잇는다.
   * @maxLength 100
   */
  idempotencyKey?: string;
  /** 결제 주체 씨마켓 회원 id. ownerKey 가 씨마켓 직원(EMPLOYEE)이면 필수 — 소속 회원(SSO companyMemberId)의 포인트로 매 주기 결제한다. 발주기관·공급기업은 생략(보내면 본인이어야 한다). */
  payerMemberId?: string;
}

export interface StorefrontSubscriptionListDto {
  subscriptions: StorefrontSubscriptionDto[];
  total: number;
  limit: number;
  offset: number;
}

/**
 * ORDERED = 주기 주문·포인트 결제 완료 · FAILED = 실패(구독은 PAYMENT_FAILED 로 남고 내일 09:00 재시도, 충전 뒤 retry-payment 로 바로 재시도 가능) · PROCESSING = 결제 결과를 아직 모름(결제 진행 중·일시 오류) — 실패로 세지 않았고 같은 주문 키로 다시 확인한다. 다시 신청하지 말고 잠시 뒤 구독 상세(cycles)에서 결과를 본다.
 */
export type SubscriptionPaymentRetryDtoStatus =
  (typeof SubscriptionPaymentRetryDtoStatus)[keyof typeof SubscriptionPaymentRetryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionPaymentRetryDtoStatus = {
  ORDERED: "ORDERED",
  FAILED: "FAILED",
  PROCESSING: "PROCESSING",
} as const;

export interface SubscriptionPaymentRetryDto {
  /** ORDERED = 주기 주문·포인트 결제 완료 · FAILED = 실패(구독은 PAYMENT_FAILED 로 남고 내일 09:00 재시도, 충전 뒤 retry-payment 로 바로 재시도 가능) · PROCESSING = 결제 결과를 아직 모름(결제 진행 중·일시 오류) — 실패로 세지 않았고 같은 주문 키로 다시 확인한다. 다시 신청하지 말고 잠시 뒤 구독 상세(cycles)에서 결과를 본다. */
  status: SubscriptionPaymentRetryDtoStatus;
  /** @nullable */
  orderNo?: string | null;
  /**
   * 실패 사유(잔액 부족 등) 또는 확인 중 안내(PROCESSING) — 손님에게 그대로 보여 줄 수 있는 말.
   * @nullable
   */
  failureReason?: string | null;
  /**
   * 실패의 HTTP 상태(402 = 포인트 부족 등). PROCESSING 이면 결과를 모르게 한 상태(503 등, 없으면 null). 성공이면 null.
   * @nullable
   */
  failureStatus?: number | null;
  /** 다시 시도한 주기 번호 */
  cycleNo: number;
}

export interface RetryStorefrontSubscriptionPaymentResultDto {
  subscription: StorefrontSubscriptionDto;
  /** 이번 재시도의 결과. FAILED 여도 200 이다(실패 사유·상태는 여기에). */
  payment: SubscriptionPaymentRetryDto;
}

export interface SubscriptionOwnerDto {
  /** 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 견적서·주문(employeeNo)과 같은 값이며 구독의 소유는 이 값 하나로 가른다. 포인트는 이 값의 회원ID 지갑에서 차감된다. */
  ownerKey: string;
}

export interface CancelStorefrontSubscriptionDto {
  /** 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 견적서·주문(employeeNo)과 같은 값이며 구독의 소유는 이 값 하나로 가른다. 포인트는 이 값의 회원ID 지갑에서 차감된다. */
  ownerKey: string;
  /** 해지 사유 */
  reason?: string;
}

export interface UpdateStorefrontSubscriptionDto {
  /** 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 견적서·주문(employeeNo)과 같은 값이며 구독의 소유는 이 값 하나로 가른다. 포인트는 이 값의 회원ID 지갑에서 차감된다. */
  ownerKey: string;
  /** 바꿀 인원. 다음 주기 주문부터 적용된다. */
  people?: number;
  /** 바꿀 주기 index. 이미 잡힌 다음 결제일은 그대로 두고, 그 결제 뒤부터 새 주기로 간다. */
  frequencyIndex?: number;
}

export interface CourierDto {
  code: string;
  name: string;
}

export interface SupplierShipmentTargetShipToDto {
  name: string;
  zip: string;
  address: string;
  /** @nullable */
  tel?: string | null;
}

export interface SupplierShipmentTargetItemDto {
  id: string;
  name: string;
  /** @nullable */
  spec?: string | null;
  /** @nullable */
  unit?: string | null;
  /** 주문 수량 */
  quantity: number;
  /** 이미 송장에 실린 수량(취소 제외) */
  shippedQuantity: number;
}

export interface SupplierShipmentTargetDto {
  orderNo: string;
  /** 주문 상태 */
  orderStatus: string;
  orderedAt: string;
  shipTo: SupplierShipmentTargetShipToDto;
  /** 내 몫 품목 중 **아직 남은 것만**. 다 보낸 줄은 오지 않는다. */
  items: SupplierShipmentTargetItemDto[];
}

export interface QuoteRequestMallOrderDto {
  /** 몰 주문번호 */
  orderNo: string;
  /** 주문 상태 — `PLACED` · `QUOTING` · `QUOTE_CLOSED` · `SENT_TO_ERP` · `CONTRACTED` · `SHIPPING` · `DELIVERED` · `INSPECTED` · `SETTLED` · `CANCELED`. */
  status: string;
  /**
   * ERP 가 회신한 구매요구번호. 아직이면 null.
   * @nullable
   */
  erpRequisitionNo: string | null;
  /** 이 주문에 걸린 송장. 아직 없으면 빈 배열이다. */
  shipments: ShipmentDto[];
}

export interface ShipmentLineDto {
  /** 주문 품목 id(`storefront_order_items.id`) */
  itemId: string;
  /** 이 송장에 실은 수량 */
  quantity: number;
}

/**
 * 등록 시점 상태. 기본 `SHIPPED`(발송됨). `READY`(발송 준비)만 더 쓸 수 있다 — `IN_TRANSIT`·`DELIVERED` 는 400 `SHIPMENT_INVALID_INPUT`(도착 기록은 등록한 뒤 전달 완료 알리기로 남긴다).
 */
export type RegisterShipmentDtoStatus =
  (typeof RegisterShipmentDtoStatus)[keyof typeof RegisterShipmentDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterShipmentDtoStatus = {
  READY: "READY",
  SHIPPED: "SHIPPED",
} as const;

export interface RegisterShipmentDto {
  /** 택배사 코드. 목록은 `GET …/couriers`. 직접 배송이면 `DIRECT`. */
  courierCode?: string;
  /** 송장번호 */
  trackingNo?: string;
  /** 등록 시점 상태. 기본 `SHIPPED`(발송됨). `READY`(발송 준비)만 더 쓸 수 있다 — `IN_TRANSIT`·`DELIVERED` 는 400 `SHIPMENT_INVALID_INPUT`(도착 기록은 등록한 뒤 전달 완료 알리기로 남긴다). */
  status?: RegisterShipmentDtoStatus;
  /** 메모(분할 출고 사유 등) */
  note?: string;
  /** 이 송장에 실은 품목 */
  items: ShipmentLineDto[];
}

export interface ShipmentBulkResultRowDto {
  /** 보낸 행 번호 */
  rowNo: number;
  /** 주문번호(정리한 값) */
  orderNo: string;
  /** 등록됐는가 */
  ok: boolean;
  /**
   * 등록된 송장 id
   * @nullable
   */
  shipmentId: string | null;
  /**
   * 실패 코드 — ORDER_NO_REQUIRED · DUPLICATE_ROW · NOT_SHIPPABLE · COURIER_REQUIRED · UNKNOWN_COURIER · NOTHING_LEFT · REJECTED · FAILED · SKIPPED(택배사·송장번호가 모두 빈 줄 — 오류도 등록도 아닌 건너뜀)
   * @nullable
   */
  code: string | null;
  /**
   * 실패했을 때 사람이 읽는 이유
   * @nullable
   */
  message: string | null;
  /** 택배사·송장번호가 모두 비어 건너뛴 줄인가(ok=false · code=SKIPPED). 건너뜀은 failed 에 세지 않는다 */
  skipped: boolean;
}

export interface ShipmentBulkRegisterResultDto {
  /** 받은 줄 수 */
  total: number;
  /** 등록된 줄 수 */
  registered: number;
  /** 오류로 등록되지 않은 줄 수(건너뜀 제외) */
  failed: number;
  /** 택배사·송장번호가 모두 비어 건너뛴 줄 수. 송장 없이 직접 전달하는 줄은 택배사 칸에 «직접 납품»(몰은 «직접 배송»)이라고 적어야 등록된다 */
  skipped: number;
  /** 받은 순서 그대로, 줄마다의 결과 */
  results: ShipmentBulkResultRowDto[];
}

export interface ShipmentBulkRowDto {
  /** 엑셀 행 번호(머리글이 1행이라 데이터 첫 줄은 2) — 결과를 줄에 맞춰 돌려주는 데 쓴다 */
  rowNo: number;
  /** 몰 주문번호 */
  orderNo: string;
  /** 택배사 — 코드(CJ) · 이름(CJ대한통운) · 흔한 별칭(CJ택배, 우체국, GS25)을 모두 받는다. 송장번호를 적었으면 필수. */
  courier?: string;
  /** 송장번호(하이픈·공백은 뺀다). 송장 없이 직접 전달하면 택배사 칸에 «직접 납품»(몰은 «직접 배송»)이라고 적고 비운다. 택배사 칸이 비어 있으면 그 줄은 건너뛴다. */
  trackingNo?: string;
}

export interface ShipmentBulkRegisterDto {
  /** 줄마다 «그 주문에서 내가 보낼 남은 품목 전부» 를 한 송장으로 등록한다(최대 200줄). 나눠 보내려면 주문별 등록을 쓴다. */
  rows: ShipmentBulkRowDto[];
}

export type UpdateShipmentStatusDtoStatus =
  (typeof UpdateShipmentStatusDtoStatus)[keyof typeof UpdateShipmentStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateShipmentStatusDtoStatus = {
  READY: "READY",
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  DELIVERED: "DELIVERED",
  CANCELED: "CANCELED",
} as const;

export interface UpdateShipmentStatusDto {
  status: UpdateShipmentStatusDtoStatus;
  /**
   * 취소 사유 — status 가 CANCELED 일 때 필요하다(서버 규칙은 SHIPPING_REASON_RULES 가 켜진 뒤 적용: 없으면 400 SHIPMENT_REASON_REQUIRED). 다른 상태에서는 무시한다.
   * @maxLength 500
   */
  reason?: string;
}

/**
 * CMARKET = 씨마켓 구매대행(공급기업 주문) — 거래 상대는 씨마켓, 배송지는 주문 기업. INSTITUTION = 발주기관 직접 판매.
 */
export type MallUnitCounterpartyDtoKind =
  (typeof MallUnitCounterpartyDtoKind)[keyof typeof MallUnitCounterpartyDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MallUnitCounterpartyDtoKind = {
  CMARKET: "CMARKET",
  INSTITUTION: "INSTITUTION",
} as const;

export interface MallUnitCounterpartyDto {
  /** CMARKET = 씨마켓 구매대행(공급기업 주문) — 거래 상대는 씨마켓, 배송지는 주문 기업. INSTITUTION = 발주기관 직접 판매. */
  kind: MallUnitCounterpartyDtoKind;
  /** 거래 상대 표시명 */
  name: string;
}

export interface MallUnitShipToDto {
  name: string;
  zip: string;
  address: string;
  /** @nullable */
  tel?: string | null;
}

export type MallUnitLineDtoPriceTaxType =
  (typeof MallUnitLineDtoPriceTaxType)[keyof typeof MallUnitLineDtoPriceTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MallUnitLineDtoPriceTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export type MallUnitLineDtoTaxCategory =
  (typeof MallUnitLineDtoTaxCategory)[keyof typeof MallUnitLineDtoTaxCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MallUnitLineDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

export interface MallUnitLineDto {
  /** 주문 품목 id(`storefront_order_items.id`) — 송장 등록 때 이 id 를 쓴다 */
  id: string;
  /** 주문 안 순번 */
  seq: number;
  itemId: string;
  name: string;
  /** @nullable */
  spec?: string | null;
  /** @nullable */
  unit?: string | null;
  quantity: number;
  /** 몰 판매 단가(주문 시점 스냅샷) */
  salePrice: number;
  priceTaxType: MallUnitLineDtoPriceTaxType;
  taxCategory: MallUnitLineDtoTaxCategory;
}

/**
 * PENDING = 수락 대기 · ACCEPTED = 수락 · DECLINED = 내가 거절(주문 취소) · CANCELED = 다른 공급사 거절/손님 취소로 접힘
 */
export type MallUnitDtoStatus =
  (typeof MallUnitDtoStatus)[keyof typeof MallUnitDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MallUnitDtoStatus = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
  CANCELED: "CANCELED",
} as const;

/**
 * @nullable
 */
export type MallUnitDtoCustomerType =
  | (typeof MallUnitDtoCustomerType)[keyof typeof MallUnitDtoCustomerType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MallUnitDtoCustomerType = {
  INSTITUTION: "INSTITUTION",
  COMPANY: "COMPANY",
} as const;

/**
 * @nullable
 */
export type MallUnitDtoDealType =
  | (typeof MallUnitDtoDealType)[keyof typeof MallUnitDtoDealType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MallUnitDtoDealType = {
  SUPPLIER_DIRECT: "SUPPLIER_DIRECT",
  CMARKET_AGENCY: "CMARKET_AGENCY",
} as const;

/**
 * @nullable
 */
export type MallUnitDtoRoute =
  | (typeof MallUnitDtoRoute)[keyof typeof MallUnitDtoRoute]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MallUnitDtoRoute = {
  SAFE: "SAFE",
  DIRECT: "DIRECT",
} as const;

/**
 * @nullable
 */
export type MallUnitDtoPaymentMethod =
  | (typeof MallUnitDtoPaymentMethod)[keyof typeof MallUnitDtoPaymentMethod]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MallUnitDtoPaymentMethod = {
  TAX_INVOICE: "TAX_INVOICE",
  CARD: "CARD",
  POINT: "POINT",
} as const;

export interface MallUnitDto {
  /** 이행 단위 id */
  id: string;
  /** PENDING = 수락 대기 · ACCEPTED = 수락 · DECLINED = 내가 거절(주문 취소) · CANCELED = 다른 공급사 거절/손님 취소로 접힘 */
  status: MallUnitDtoStatus;
  orderNo: string;
  /** 주문 상태(MATCHED → CONTRACTED → SHIPPING → DELIVERED → INSPECTED / CANCELED) */
  orderStatus: string;
  storefrontSlug: string;
  storefrontName: string;
  /** @nullable */
  customerType?: MallUnitDtoCustomerType;
  /** @nullable */
  dealType?: MallUnitDtoDealType;
  /** @nullable */
  route?: MallUnitDtoRoute;
  /** @nullable */
  paymentMethod?: MallUnitDtoPaymentMethod;
  /**
   * 몰 견적서 번호
   * @nullable
   */
  quoteNo?: string | null;
  counterparty: MallUnitCounterpartyDto;
  shipTo: MallUnitShipToDto;
  /** 내 몫 품목만 */
  lines: MallUnitLineDto[];
  /** 내 몫 공급가액 합계 */
  supply: number;
  /** 내 몫 부가세 합계 */
  vat: number;
  /** supply + vat */
  payable: number;
  /** @nullable */
  declineReason?: string | null;
  /** @nullable */
  acceptedAt?: string | null;
  /** @nullable */
  declinedAt?: string | null;
  /** @nullable */
  canceledAt?: string | null;
  /**
   * 주문 취소 사유(취소된 주문만)
   * @nullable
   */
  orderCancelReason?: string | null;
  /** 주문 시각 */
  orderedAt: string;
  /** 단위 생성 시각(= 공급사 배정 시각) */
  createdAt: string;
}

export interface MallUnitListDto {
  units: MallUnitDto[];
  total: number;
  limit: number;
  offset: number;
}

export interface DeclineMallUnitDto {
  /**
   * 거절 사유. 손님과 씨마켓이 본다 — 주문 취소 사유에 그대로 남는다.
   * @minLength 2
   * @maxLength 500
   */
  reason: string;
}

export interface MyStorefrontDto {
  storefrontId: string;
  slug: string;
  name: string;
  /** 이 쇼핑몰에 허용된 내 품목 수 */
  allowedItemCount: number;
  /** 그중 단가를 입력해 실제 노출 중인 수 */
  pricedItemCount: number;
  /** 이 몰의 표시가 축. false 면 공급가액(부가세 별도)으로 표시된다 — 입력 칸의 라벨이 이 값을 따라간다 */
  includeVat: boolean;
}

export interface MyStorefrontPriceDto {
  storefrontId: string;
  itemId: string;
  /**
   * 내가 이 쇼핑몰용으로 적은 단가. null 이면 아직 안 적었다
   * @nullable
   */
  price?: number | null;
}

export interface SetStorefrontPriceResultDto {
  storefrontId: string;
  itemId: string;
  price: number;
  /** 이 값으로 쇼핑몰에 노출되는지 */
  isListed: boolean;
}

export interface SetStorefrontPriceDto {
  /** 이 쇼핑몰에서 팔 단가(수수료 포함가) */
  price: number;
}

/**
 * linked 면 내 단가가 바뀔 때 몰가도 따라간다
 */
export type MyStorefrontOfferingDtoPriceSource =
  (typeof MyStorefrontOfferingDtoPriceSource)[keyof typeof MyStorefrontOfferingDtoPriceSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MyStorefrontOfferingDtoPriceSource = {
  manual: "manual",
  linked: "linked",
} as const;

/**
 * 품목의 과세 상태. 면세·영세는 부가세가 붙지 않는다
 * @nullable
 */
export type MyStorefrontOfferingDtoTaxCategory =
  | (typeof MyStorefrontOfferingDtoTaxCategory)[keyof typeof MyStorefrontOfferingDtoTaxCategory]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MyStorefrontOfferingDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

/**
 * 노출 중 / 단가 미입력 / 노출 중지
 */
export type MyStorefrontOfferingDtoState =
  (typeof MyStorefrontOfferingDtoState)[keyof typeof MyStorefrontOfferingDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MyStorefrontOfferingDtoState = {
  listed: "listed",
  unpriced: "unpriced",
  inactive: "inactive",
} as const;

export interface MyStorefrontOfferingDto {
  offeringId: string;
  itemId: string;
  name: string;
  /** @nullable */
  manufacturer?: string | null;
  /** @nullable */
  spec1?: string | null;
  /** @nullable */
  unit?: string | null;
  /** @nullable */
  categoryName?: string | null;
  /** @nullable */
  imageUrl?: string | null;
  /**
   * 내 일반 공급가(참고용)
   * @nullable
   */
  basePrice?: number | null;
  /**
   * 내가 이 몰용으로 적어 넣은 값. 연동 중이면 비어 있다
   * @nullable
   */
  enteredPrice?: number | null;
  /**
   * 실제 노출가. 연동이면 내 단가에서 계산된다
   * @nullable
   */
  price?: number | null;
  /** linked 면 내 단가가 바뀔 때 몰가도 따라간다 */
  priceSource: MyStorefrontOfferingDtoPriceSource;
  /** 연동 가산율(만분율) */
  priceMarkupBp: number;
  /**
   * 내가 적어 넣은 값의 부가세 축(기록용)
   * @nullable
   */
  taxType?: string | null;
  /**
   * 품목의 과세 상태. 면세·영세는 부가세가 붙지 않는다
   * @nullable
   */
  taxCategory?: MyStorefrontOfferingDtoTaxCategory;
  /** 노출 중 / 단가 미입력 / 노출 중지 */
  state: MyStorefrontOfferingDtoState;
  isActive: boolean;
}

export interface MyStorefrontCountsDto {
  /** 허용된 전체 */
  all: number;
  /** 노출 중 */
  listed: number;
  /** 단가 미입력 */
  unpriced: number;
  /** 노출 중지 */
  inactive: number;
}

export interface MyStorefrontOfferingListDto {
  items: MyStorefrontOfferingDto[];
  total: number;
  /** 상태별 건수 — 화면 상단 퍼널에 쓴다 */
  counts: MyStorefrontCountsDto;
}

export interface CreateOfferingRequestResultDto {
  /** false 면 같은 요청이 이미 대기 중이라 새로 만들지 않았다 */
  created: boolean;
}

export interface CreateOfferingRequestDto {
  /** 이 몰에 올리고 싶은 품목 */
  itemId: string;
  /** 마스터에게 남길 한마디 */
  note?: string;
}

export interface CreateAddressDto {
  /**
   * 주소 라벨
   * @maxLength 50
   */
  label?: string;
  /** 기본 주소 설정 */
  isDefault: boolean;
  /**
   * 우편번호
   * @maxLength 10
   */
  postalCode: string;
  /**
   * 시/도
   * @maxLength 50
   */
  province: string;
  /**
   * 시/군/구
   * @maxLength 50
   */
  city: string;
  /**
   * 읍/면/동 (누락 시 null 저장)
   * @maxLength 50
   * @nullable
   */
  district?: string | null;
  /**
   * 도로명 주소
   * @maxLength 200
   */
  streetAddress: string;
  /**
   * 상세 주소
   * @maxLength 200
   */
  addressDetail?: string;
  /**
   * 수령인 이름
   * @maxLength 50
   */
  recipientName: string;
  /**
   * 수령인 연락처
   * @maxLength 20
   */
  recipientPhone?: string;
}

/**
 * 카테고리 타입
 */
export type CreateExternalQuoteRequestWithAddressDtoCategoryType =
  (typeof CreateExternalQuoteRequestWithAddressDtoCategoryType)[keyof typeof CreateExternalQuoteRequestWithAddressDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateExternalQuoteRequestWithAddressDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 예산 타입
 * @nullable
 */
export type CreateExternalQuoteRequestWithAddressDtoBudgetType =
  | (typeof CreateExternalQuoteRequestWithAddressDtoBudgetType)[keyof typeof CreateExternalQuoteRequestWithAddressDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateExternalQuoteRequestWithAddressDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type CreateExternalQuoteRequestWithAddressDtoPaymentMethod =
  (typeof CreateExternalQuoteRequestWithAddressDtoPaymentMethod)[keyof typeof CreateExternalQuoteRequestWithAddressDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateExternalQuoteRequestWithAddressDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다.
 */
export type CreateExternalQuoteRequestWithAddressDtoPreferredPaymentChannel =
  (typeof CreateExternalQuoteRequestWithAddressDtoPreferredPaymentChannel)[keyof typeof CreateExternalQuoteRequestWithAddressDtoPreferredPaymentChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateExternalQuoteRequestWithAddressDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 배송일 값 (사용자 입력값)
 * @nullable
 */
export type CreateExternalQuoteRequestWithAddressDtoDueDateValue =
  | (typeof CreateExternalQuoteRequestWithAddressDtoDueDateValue)[keyof typeof CreateExternalQuoteRequestWithAddressDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateExternalQuoteRequestWithAddressDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

/**
 * 공사 타입 (공사 카테고리 전용)
 * @nullable
 */
export type CreateExternalQuoteRequestWithAddressDtoConstructionType =
  ConstructionTypeLabelValue | null;

/**
 * 공간 타입 (공사 카테고리 전용)
 * @nullable
 */
export type CreateExternalQuoteRequestWithAddressDtoSpaceType =
  SpaceTypeLabelValue | null;

/**
 * 공사 면적 (공사 카테고리 전용)
 * @nullable
 */
export type CreateExternalQuoteRequestWithAddressDtoConstructionArea =
  ConstructionAreaLabelValue | null;

/**
 * 과업지시서 초안 (용역 전용). 항목마다 출처 USER(답함)·GUESS(시스템이 채움)·EMPTY(비어 있음)
 * @nullable
 */
export type CreateExternalQuoteRequestWithAddressDtoServiceSow =
  QuoteRequestServiceSowDto | null;

export interface CreateExternalQuoteRequestWithAddressDto {
  /** 프로젝트명 (물품 구매(product) 카테고리는 선택 — 미입력 시 물품 목록으로 자동 생성, 그 외 카테고리는 필수) */
  projectName?: string;
  /** 카테고리 타입 */
  categoryType: CreateExternalQuoteRequestWithAddressDtoCategoryType;
  /** 담당자 연락처 (필수) */
  managerContact: string;
  /** 담당자명 */
  managerName: string;
  /**
   * 주소 상세정보 (예: 동 101호, 3층 등의 추가 정보)
   * @nullable
   */
  addressDetail?: string | null;
  /**
   * 견적 요청 설명 및 추가 사항
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: CreateExternalQuoteRequestWithAddressDtoBudgetType;
  /**
   * 예산 금액 (원화)
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod?: CreateExternalQuoteRequestWithAddressDtoPaymentMethod;
  /** 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다. */
  preferredPaymentChannel?: CreateExternalQuoteRequestWithAddressDtoPreferredPaymentChannel;
  /**
   * 동일 지역만 선택 여부
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /** 바로 업체 찾기로 등록 — 6곳 방은 등록 직후 auto-match/start 가 연다(등록 이벤트의 자동 매칭은 건너뜀) */
  quickMatch?: boolean;
  /**
   * 배송일 값 (사용자 입력값)
   * @nullable
   */
  dueDateValue?: CreateExternalQuoteRequestWithAddressDtoDueDateValue;
  /**
   * 배송일 (ISO 8601 형식)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 업로드된 파일들의 메타데이터 배열
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /**
   * 항목 목록 (Product 카테고리에만 필수)
   * @nullable
   */
  items?: CreateQuoteRequestItemDto[] | null;
  /**
   * 추가 조건 (물품 구매 카테고리 전용)
   * @nullable
   */
  additionalConditions?: LabelValuePair[] | null;
  /**
   * 추가 요청사항 (모든 카테고리 선택 가능)
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
  /**
   * 공사 타입 (공사 카테고리 전용)
   * @nullable
   */
  constructionType?: CreateExternalQuoteRequestWithAddressDtoConstructionType;
  /**
   * 공간 타입 (공사 카테고리 전용)
   * @nullable
   */
  spaceType?: CreateExternalQuoteRequestWithAddressDtoSpaceType;
  /**
   * 공사 면적 (공사 카테고리 전용)
   * @nullable
   */
  constructionArea?: CreateExternalQuoteRequestWithAddressDtoConstructionArea;
  /**
   * 표준 내역서 줄 (공사·용역 카테고리 전용, 최대 500줄). items 와 별개로 저장되며 물품 매칭·알림 대상이 아니다
   * @nullable
   */
  boqLines?: QuoteRequestBoqLineDto[] | null;
  /**
   * 내역서 종목 키 (공사·용역 카테고리 전용). 공사는 종목 enum 값, 용역은 유형 이름 — GET /cost-estimate/work-types 의 type
   * @maxLength 60
   * @nullable
   */
  boqWorkType?: string | null;
  /**
   * 과업지시서 초안 (용역 전용). 항목마다 출처 USER(답함)·GUESS(시스템이 채움)·EMPTY(비어 있음)
   * @nullable
   */
  serviceSow?: CreateExternalQuoteRequestWithAddressDtoServiceSow;
  /**
   * 용역 유형 이름 (용역 전용) — GET /cost-estimate/work-types 의 용역 type. 업체 매칭이 이 값으로 자격을 고른다
   * @maxLength 50
   * @nullable
   */
  serviceType?: string | null;
  /** 신규/재사용할 주소 정보 (addresses 테이블에 upsert) */
  address: CreateAddressDto;
  /** 결제 방법. true=선결제, false=후불결제. 미전달 시 SEMO default(선결제). */
  isPrepaid?: boolean;
  /** 마감일시. ISO 8601, 시간대 필수(예: 2026-10-10T18:00:00+09:00). 현재 시각보다 뒤여야 합니다. 미전달 시 자동(물품 3일·그 외 5일 뒤 18:00). */
  deadline?: string;
}

/**
 * 변경 전 값
 * @nullable
 */
export type QuoteRequestFieldChangeDtoBefore = {
  [key: string]: unknown;
} | null;

/**
 * 변경 후 값
 * @nullable
 */
export type QuoteRequestFieldChangeDtoAfter = { [key: string]: unknown } | null;

export interface QuoteRequestFieldChangeDto {
  /** 영속 컬럼명 */
  field: string;
  /** 사람이 읽는 필드 이름 */
  label: string;
  /**
   * 변경 전 값
   * @nullable
   */
  before?: QuoteRequestFieldChangeDtoBefore;
  /**
   * 변경 후 값
   * @nullable
   */
  after?: QuoteRequestFieldChangeDtoAfter;
}

export interface QuoteRequestModificationDto {
  /** 수정 시각 (ISO 8601, UTC) */
  modifiedAt: string;
  /** 무엇이 바뀌었는지 한 줄 요약 */
  summary: string;
  /**
   * 수정 주체(발주기관 사용자 ID). 알 수 없으면 null
   * @nullable
   */
  modifiedBy?: string | null;
  /** 필드별 변경 내역 */
  changes: QuoteRequestFieldChangeDto[];
}

export interface QuoteRequestContractDocumentDto {
  /** 서류 코드 */
  paperCode: number;
  /** 서류명 */
  name: string;
  /** 서류 종류. `auto` 는 견적서 등에서 자동 생성돼 이미 파일이 있고, `auto_pending_input` 은 공급사가 값을 채우면 생성되며, `manual` 은 공급사가 파일을 직접 올린다. */
  kind: string;
  /** 진행 상태 — `pending`(제출 전) · `completed`(제출됨). */
  status: string;
  /**
   * 제출된 파일 주소. 아직 제출 전이면 null 이다.
   * @nullable
   */
  fileUrl: string | null;
  /**
   * 제출된 파일명
   * @nullable
   */
  fileName: string | null;
  /**
   * 제출 시각(ISO 8601)
   * @nullable
   */
  uploadedAt: string | null;
}

export interface QuoteRequestContractDocumentGroupDto {
  /** 계약 id */
  contractId: string;
  /** 계약번호 */
  contractNumber: string;
  /** 이 계약의 공급사 id */
  supplierId: string;
  /**
   * 공급사 상호
   * @nullable
   */
  supplierName: string | null;
  /** 아직 제출되지 않은 서류 수. 0 이면 다 냈다. */
  pendingCount: number;
  /** 이 계약에 걸린 서류 목록 */
  documents: QuoteRequestContractDocumentDto[];
}

/**
 * 카테고리 타입
 */
export type UpdateExternalQuoteRequestDtoCategoryType =
  (typeof UpdateExternalQuoteRequestDtoCategoryType)[keyof typeof UpdateExternalQuoteRequestDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateExternalQuoteRequestDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 예산 타입
 * @nullable
 */
export type UpdateExternalQuoteRequestDtoBudgetType =
  | (typeof UpdateExternalQuoteRequestDtoBudgetType)[keyof typeof UpdateExternalQuoteRequestDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateExternalQuoteRequestDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type UpdateExternalQuoteRequestDtoPaymentMethod =
  (typeof UpdateExternalQuoteRequestDtoPaymentMethod)[keyof typeof UpdateExternalQuoteRequestDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateExternalQuoteRequestDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다.
 */
export type UpdateExternalQuoteRequestDtoPreferredPaymentChannel =
  (typeof UpdateExternalQuoteRequestDtoPreferredPaymentChannel)[keyof typeof UpdateExternalQuoteRequestDtoPreferredPaymentChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateExternalQuoteRequestDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 배송일 값 (사용자 입력값)
 * @nullable
 */
export type UpdateExternalQuoteRequestDtoDueDateValue =
  | (typeof UpdateExternalQuoteRequestDtoDueDateValue)[keyof typeof UpdateExternalQuoteRequestDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateExternalQuoteRequestDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

/**
 * 공사 타입 (공사 카테고리 전용)
 * @nullable
 */
export type UpdateExternalQuoteRequestDtoConstructionType =
  ConstructionTypeLabelValue | null;

/**
 * 공간 타입 (공사 카테고리 전용)
 * @nullable
 */
export type UpdateExternalQuoteRequestDtoSpaceType = SpaceTypeLabelValue | null;

/**
 * 공사 면적 (공사 카테고리 전용)
 * @nullable
 */
export type UpdateExternalQuoteRequestDtoConstructionArea =
  ConstructionAreaLabelValue | null;

/**
 * 과업지시서 초안 (용역 전용). 항목마다 출처 USER(답함)·GUESS(시스템이 채움)·EMPTY(비어 있음)
 * @nullable
 */
export type UpdateExternalQuoteRequestDtoServiceSow =
  QuoteRequestServiceSowDto | null;

export interface UpdateExternalQuoteRequestDto {
  /** 프로젝트명 (물품 구매(product) 카테고리는 선택 — 미입력 시 물품 목록으로 자동 생성, 그 외 카테고리는 필수) */
  projectName?: string;
  /** 카테고리 타입 */
  categoryType?: UpdateExternalQuoteRequestDtoCategoryType;
  /** 담당자 연락처 (필수) */
  managerContact?: string;
  /** 담당자명 */
  managerName?: string;
  /** 주소 ID (addresses 테이블 외래키) */
  addressId?: string;
  /**
   * 주소 상세정보 (예: 동 101호, 3층 등의 추가 정보)
   * @nullable
   */
  addressDetail?: string | null;
  /**
   * 견적 요청 설명 및 추가 사항
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: UpdateExternalQuoteRequestDtoBudgetType;
  /**
   * 예산 금액 (원화)
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod?: UpdateExternalQuoteRequestDtoPaymentMethod;
  /** 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다. */
  preferredPaymentChannel?: UpdateExternalQuoteRequestDtoPreferredPaymentChannel;
  /**
   * 동일 지역만 선택 여부
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /** 바로 업체 찾기로 등록 — 6곳 방은 등록 직후 auto-match/start 가 연다(등록 이벤트의 자동 매칭은 건너뜀) */
  quickMatch?: boolean;
  /**
   * 배송일 값 (사용자 입력값)
   * @nullable
   */
  dueDateValue?: UpdateExternalQuoteRequestDtoDueDateValue;
  /**
   * 배송일 (ISO 8601 형식)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 업로드된 파일들의 메타데이터 배열
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /**
   * 항목 목록 (Product 카테고리에만 필수)
   * @nullable
   */
  items?: CreateQuoteRequestItemDto[] | null;
  /**
   * 추가 조건 (물품 구매 카테고리 전용)
   * @nullable
   */
  additionalConditions?: LabelValuePair[] | null;
  /**
   * 추가 요청사항 (모든 카테고리 선택 가능)
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
  /**
   * 공사 타입 (공사 카테고리 전용)
   * @nullable
   */
  constructionType?: UpdateExternalQuoteRequestDtoConstructionType;
  /**
   * 공간 타입 (공사 카테고리 전용)
   * @nullable
   */
  spaceType?: UpdateExternalQuoteRequestDtoSpaceType;
  /**
   * 공사 면적 (공사 카테고리 전용)
   * @nullable
   */
  constructionArea?: UpdateExternalQuoteRequestDtoConstructionArea;
  /**
   * 표준 내역서 줄 (공사·용역 카테고리 전용, 최대 500줄). items 와 별개로 저장되며 물품 매칭·알림 대상이 아니다
   * @nullable
   */
  boqLines?: QuoteRequestBoqLineDto[] | null;
  /**
   * 내역서 종목 키 (공사·용역 카테고리 전용). 공사는 종목 enum 값, 용역은 유형 이름 — GET /cost-estimate/work-types 의 type
   * @maxLength 60
   * @nullable
   */
  boqWorkType?: string | null;
  /**
   * 과업지시서 초안 (용역 전용). 항목마다 출처 USER(답함)·GUESS(시스템이 채움)·EMPTY(비어 있음)
   * @nullable
   */
  serviceSow?: UpdateExternalQuoteRequestDtoServiceSow;
  /**
   * 용역 유형 이름 (용역 전용) — GET /cost-estimate/work-types 의 용역 type. 업체 매칭이 이 값으로 자격을 고른다
   * @maxLength 50
   * @nullable
   */
  serviceType?: string | null;
  /** 결제 방법. true=선결제, false=후불결제. 미전달 시 기존 값 유지(PATCH 시맨틱). */
  isPrepaid?: boolean;
}

export interface ExtendExternalQuoteRequestDeadlineDto {
  /** 새 마감일시 (ISO 8601). 현재 시각보다 뒤여야 하며, 기존 마감일시보다 앞당길 수도 있습니다. 한 번에 30일까지 연장할 수 있습니다. */
  deadline: string;
}

export interface ContractShipmentBulkResultRowDto {
  /** 보낸 행 번호 */
  rowNo: number;
  /** 계약번호(정리한 값) */
  contractNo: string;
  /** 등록됐는가 */
  ok: boolean;
  /**
   * 등록된 송장 id
   * @nullable
   */
  shipmentId: string | null;
  /**
   * 실패 코드 — CONTRACT_NO_REQUIRED · DUPLICATE_ROW · NOT_SHIPPABLE · COURIER_REQUIRED · UNKNOWN_COURIER · NOTHING_LEFT · REJECTED · FAILED · SKIPPED(택배사·송장번호가 모두 빈 줄 — 오류도 등록도 아닌 건너뜀)
   * @nullable
   */
  code: string | null;
  /**
   * 실패했을 때 사람이 읽는 이유
   * @nullable
   */
  message: string | null;
  /** 택배사·송장번호가 모두 비어 건너뛴 줄인가(ok=false · code=SKIPPED). 건너뜀은 failed 에 세지 않는다 */
  skipped: boolean;
}

export interface ContractShipmentBulkRegisterResultDto {
  /** 받은 줄 수 */
  total: number;
  /** 등록된 줄 수 */
  registered: number;
  /** 오류로 등록되지 않은 줄 수(건너뜀 제외) */
  failed: number;
  /** 택배사·송장번호가 모두 비어 건너뛴 줄 수. 송장 없이 직접 전달하는 줄은 택배사 칸에 «직접 납품»(몰은 «직접 배송»)이라고 적어야 등록된다 */
  skipped: number;
  /** 받은 순서 그대로, 줄마다의 결과 */
  results: ContractShipmentBulkResultRowDto[];
}

export interface ContractShipmentBulkRowDto {
  /** 엑셀 행 번호(머리글이 1행이라 데이터 첫 줄은 2) — 결과를 줄에 맞춰 돌려주는 데 쓴다 */
  rowNo: number;
  /** 계약번호 */
  contractNo: string;
  /** 택배사 — 코드(CJ) · 이름(CJ대한통운) · 흔한 별칭(CJ택배, 우체국, GS25)을 모두 받는다. 송장번호를 적었으면 필수. */
  courier?: string;
  /** 송장번호(하이픈·공백은 뺀다). 송장 없이 직접 전달하면 택배사 칸에 «직접 납품»(몰은 «직접 배송»)이라고 적고 비운다. 택배사 칸이 비어 있으면 그 줄은 건너뛴다. */
  trackingNo?: string;
}

export interface ContractShipmentBulkRegisterDto {
  /** 줄마다 «그 계약에서 내가 보낼 남은 품목 전부» 를 한 송장으로 등록한다(최대 200줄). 나눠 보내려면 계약별 등록을 쓴다. */
  rows: ContractShipmentBulkRowDto[];
}

/**
 * 옛 화면 호환용 3값. 배송 중·배달 출발·배송 예외는 `SHIPPED`, 반송은 `CANCELED`(발송량에서 빠진다)로 접힌다. 정확한 상태는 `deliveryStatus`.
 */
export type RegisterContractShipmentResultDtoStatus =
  (typeof RegisterContractShipmentResultDtoStatus)[keyof typeof RegisterContractShipmentResultDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterContractShipmentResultDtoStatus = {
  SHIPPED: "SHIPPED",
  DELIVERED: "DELIVERED",
  CANCELED: "CANCELED",
} as const;

/**
 * 배송 상태(정확한 값). 택배사 데이터와 공급사 수기 처리가 움직인다.
 */
export type RegisterContractShipmentResultDtoDeliveryStatus =
  (typeof RegisterContractShipmentResultDtoDeliveryStatus)[keyof typeof RegisterContractShipmentResultDtoDeliveryStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterContractShipmentResultDtoDeliveryStatus = {
  READY: "READY",
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  EXCEPTION: "EXCEPTION",
  RETURNED: "RETURNED",
  CANCELED: "CANCELED",
} as const;

/**
 * 발주기관 수령 상태. 배송 완료 전 `NOT_DUE` → 대기 `AWAITING` → 확인 `RECEIVED` / 기한 경과 자동 확정 `AUTO_RECEIVED`. 받는 쪽이 문제를 신고하면 `DISPUTED`(자동 확정이 멈춘다).
 */
export type RegisterContractShipmentResultDtoAcceptanceStatus =
  (typeof RegisterContractShipmentResultDtoAcceptanceStatus)[keyof typeof RegisterContractShipmentResultDtoAcceptanceStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterContractShipmentResultDtoAcceptanceStatus = {
  NOT_DUE: "NOT_DUE",
  AWAITING: "AWAITING",
  RECEIVED: "RECEIVED",
  AUTO_RECEIVED: "AUTO_RECEIVED",
  DISPUTED: "DISPUTED",
} as const;

/**
 * 배송 예외 종류(배송 상태가 `EXCEPTION` 일 때)
 * @nullable
 */
export type RegisterContractShipmentResultDtoExceptionCode =
  | (typeof RegisterContractShipmentResultDtoExceptionCode)[keyof typeof RegisterContractShipmentResultDtoExceptionCode]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterContractShipmentResultDtoExceptionCode = {
  DELAYED: "DELAYED",
  ATTEMPT_FAILED: "ATTEMPT_FAILED",
  HELD: "HELD",
  DAMAGED: "DAMAGED",
  LOST: "LOST",
  OTHER: "OTHER",
} as const;

/**
 * 마지막 문제 신고 기록(없으면 null). 지금 신고 중인지는 `acceptanceStatus` 가 `DISPUTED` 인지로 안다
 * @nullable
 */
export type RegisterContractShipmentResultDtoDispute =
  ContractShipmentDisputeDto | null;

/**
 * 공급사 «전달 완료 알리기» 증빙(인수자 이름 등). 그 경로로 기록한 송장에만 있다
 * @nullable
 */
export type RegisterContractShipmentResultDtoDeliveryProof =
  ContractShipmentDeliveryProofDto | null;

export interface RegisterContractShipmentResultDto {
  id: string;
  contractId: string;
  /** 계약 안 순번(1부터) */
  shipmentNo: number;
  /** @nullable */
  courierCode: string | null;
  /** @nullable */
  courierName: string | null;
  /** @nullable */
  trackingNo: string | null;
  /**
   * 택배사 조회 페이지 링크(코드·번호가 있을 때)
   * @nullable
   */
  trackingUrl: string | null;
  /** 송장 전부(상자마다). 첫 송장 = trackingNo. 발송이 «도착» 이 되려면 모두 도착해야 한다 */
  trackingNumbers: ContractShipmentParcelDto[];
  /** 옛 화면 호환용 3값. 배송 중·배달 출발·배송 예외는 `SHIPPED`, 반송은 `CANCELED`(발송량에서 빠진다)로 접힌다. 정확한 상태는 `deliveryStatus`. */
  status: RegisterContractShipmentResultDtoStatus;
  shippedAt: string;
  /** @nullable */
  deliveredAt: string | null;
  /**
   * 발주기관 수령 확인 시각
   * @nullable
   */
  receivedAt: string | null;
  /** @nullable */
  note: string | null;
  items: ContractShipmentItemDto[];
  createdAt: string;
  /**
   * 택배 조회 단계 1 준비중·2 집화·3 배송중·4 지점도착·5 배달출발·6 완료. 조회 전이면 null
   * @nullable
   */
  trackingLevel: number | null;
  /**
   * 단계 문구(«배송중» 등). 조회 전이면 null
   * @nullable
   */
  trackingLabel: string | null;
  /** 조회 이벤트(시간순) */
  trackingEvents: ContractShipmentTrackingEventDto[];
  /**
   * 마지막 조회 시도 시각
   * @nullable
   */
  lastSyncedAt: string | null;
  /**
   * 마지막 조회 실패 사유(한도 초과 등). 성공이면 null
   * @nullable
   */
  syncError: string | null;
  /** 배송 상태(정확한 값). 택배사 데이터와 공급사 수기 처리가 움직인다. */
  deliveryStatus: RegisterContractShipmentResultDtoDeliveryStatus;
  /** 발주기관 수령 상태. 배송 완료 전 `NOT_DUE` → 대기 `AWAITING` → 확인 `RECEIVED` / 기한 경과 자동 확정 `AUTO_RECEIVED`. 받는 쪽이 문제를 신고하면 `DISPUTED`(자동 확정이 멈춘다). */
  acceptanceStatus: RegisterContractShipmentResultDtoAcceptanceStatus;
  /**
   * 배송 예외 종류(배송 상태가 `EXCEPTION` 일 때)
   * @nullable
   */
  exceptionCode: RegisterContractShipmentResultDtoExceptionCode;
  /**
   * 이 시각이 지나도 수령 확인이 없으면 자동 확정된다(배송 완료 후 대기 중일 때)
   * @nullable
   */
  autoReceiveAt: string | null;
  /**
   * 마지막 문제 신고 기록(없으면 null). 지금 신고 중인지는 `acceptanceStatus` 가 `DISPUTED` 인지로 안다
   * @nullable
   */
  dispute: RegisterContractShipmentResultDtoDispute;
  /** 송장 버전(낙관적 잠금용) */
  version: number;
  /** 사람이 봐야 하는 송장인가(배송 예외 · 조회 종료 · 조회 실패 · 문제 신고 중) */
  needsAttention: boolean;
  /** 택배사가 도착을 알려 주는 송장인가(송장번호 · 활성 택배사 · 조회 제공사 지원). false 면 공급사가 «전달 완료 알리기» 를 쓴다 */
  autoTracked: boolean;
  /**
   * 도착(DELIVERED)을 기록한 주체 — POLL·WEBHOOK 택배사 · SUPPLIER 공급사 알림 · BUYER·INSPECTION 기관 · ADMIN·SYSTEM 운영
   * @nullable
   */
  deliveredSource: string | null;
  /**
   * 수령 확인 출처(BUYER · AUTO · ADMIN · INSPECTION)
   * @nullable
   */
  receivedSource: string | null;
  /**
   * 등록 취소 사유(취소된 송장만)
   * @nullable
   */
  cancelReason: string | null;
  /**
   * 등록 취소 시각(취소된 송장만)
   * @nullable
   */
  canceledAt: string | null;
  /**
   * 공급사 «전달 완료 알리기» 증빙(인수자 이름 등). 그 경로로 기록한 송장에만 있다
   * @nullable
   */
  deliveryProof: RegisterContractShipmentResultDtoDeliveryProof;
  /** 재고 원장에 자동 출고로 남긴 줄 수(재고 행이 있는 카탈로그 품목만) */
  stockOutPosted: number;
  /** 재고 출고를 건너뛴 이유(재고 행 없음·부족 등). 발송 자체는 성공 */
  stockOutSkipped: string[];
}

export interface ContractShipmentLineDto {
  /** 계약 품목 순번(계약 items 배열의 0부터 시작하는 인덱스) */
  itemIndex: number;
  /** 이번 송장에 실은 수량 */
  quantity: number;
}

export interface RegisterContractShipmentDto {
  /** 택배사 코드. 목록은 `GET /external/storefronts/couriers` (몰 배송과 같은 어휘). 직접 배송이면 `DIRECT`. */
  courierCode?: string;
  /** 송장번호. 적으면 택배사가 필수 */
  trackingNo?: string;
  /** 발송 시각(ISO). 없으면 지금 */
  shippedAt?: string;
  /** 메모(부분 발송 사유 등) */
  note?: string;
  /** 이번 송장에 실은 품목 */
  items: ContractShipmentLineDto[];
}

/**
 * 상태 전이. DELIVERED(배송 완료) 또는 CANCELED(송장 취소 — 누적 발송량에서 빠진다)
 */
export type UpdateContractShipmentDtoStatus =
  (typeof UpdateContractShipmentDtoStatus)[keyof typeof UpdateContractShipmentDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateContractShipmentDtoStatus = {
  DELIVERED: "DELIVERED",
  CANCELED: "CANCELED",
} as const;

export interface UpdateContractShipmentDto {
  /** 택배사 코드 */
  courierCode?: string;
  /** 송장번호 */
  trackingNo?: string;
  /** 상태 전이. DELIVERED(배송 완료) 또는 CANCELED(송장 취소 — 누적 발송량에서 빠진다) */
  status?: UpdateContractShipmentDtoStatus;
  /** 메모 */
  note?: string;
  /** 등록 취소 사유 — status 가 CANCELED 일 때 필요하다(서버 규칙은 SHIPPING_REASON_RULES 가 켜진 뒤 적용: 없으면 SHIPMENT_REASON_REQUIRED). 송장 메모(note)와 별개다. */
  reason?: string;
}

/**
 * 결제 수단
 */
export type SupplierSettlementResponseDtoPaymentMethod =
  (typeof SupplierSettlementResponseDtoPaymentMethod)[keyof typeof SupplierSettlementResponseDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierSettlementResponseDtoPaymentMethod = {
  CARD: "CARD",
  CASH: "CASH",
} as const;

/**
 * 정산 상태
 */
export type SupplierSettlementResponseDtoSettlementStatus =
  (typeof SupplierSettlementResponseDtoSettlementStatus)[keyof typeof SupplierSettlementResponseDtoSettlementStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierSettlementResponseDtoSettlementStatus = {
  WAITING: "WAITING",
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  DEFERRED: "DEFERRED",
} as const;

export interface SupplierSettlementResponseDto {
  /** 계약 ID */
  id: string;
  /** 계약 번호 */
  contractNumber: string;
  /** 계약 생성 일시 */
  contractDate: string;
  /** 총 계약 금액 */
  totalAmount: number;
  /** 플랫폼 수수료 */
  commissionAmount: number;
  /** 정산 금액 (총액 - 수수료) */
  settlementAmount: number;
  /** 결제 수단 */
  paymentMethod: SupplierSettlementResponseDtoPaymentMethod;
  /** 정산 상태 */
  settlementStatus: SupplierSettlementResponseDtoSettlementStatus;
  /** 프로젝트명 */
  projectName?: string;
  /** 구매자명 */
  buyerName?: string;
  /** 구매확정 일시 */
  completedAt?: string;
  /** 정산 예정일 */
  settlementExpectedDate?: string;
}

export interface CmarketCardPaymentConfirmedDto {
  /** 확정된 계약 ID */
  contractId: string;
  /** 세모 결제 거래 ID (MOID) */
  moid: string;
  /** 이미 확정돼 있던 건인지 (웹훅 재전송·복구 스위퍼로 같은 통지가 두 번 온 경우 true) */
  alreadyConfirmed: boolean;
}

export interface CmarketCardPaymentCallbackDto {
  /** 씨마켓 결제창 번호 (b2b_card_payment_request.buy_idx) */
  cardPaymentRequestId: string;
  /** PG 거래번호(TID) */
  tid: string;
  /** 승인 금액 (VAT 포함). 견적 금액과 다르면 계약을 확정하지 않는다. */
  amount: number;
  /** 세모 견적 버전 ID — 대사(對査)용 참고값. 판정은 결제창 번호로 한다. */
  quoteResponseVersionId?: string;
}

export interface UpdateExternalAccountStatusResponseDto {
  /** 실제로 값이 바뀌었는지. 이미 같은 상태였으면 false — 파트너가 재시도해도 안전하다. */
  changed: boolean;
  /** 반영된 활성 여부 */
  isActive: boolean;
}

/**
 * 대상 계정 역할
 */
export type UpdateExternalAccountStatusDtoRole =
  (typeof UpdateExternalAccountStatusDtoRole)[keyof typeof UpdateExternalAccountStatusDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateExternalAccountStatusDtoRole = {
  buyer: "buyer",
  supplier: "supplier",
} as const;

export interface UpdateExternalAccountStatusDto {
  /** 대상 계정 역할 */
  role: UpdateExternalAccountStatusDtoRole;
  /** 파트너 시스템의 회원 고유 ID (가입 시 보낸 externalBuyerId / supplierId 와 같은 값) */
  externalId: string;
  /** 활성 여부. false 면 세모 계정을 비활성 처리한다. */
  isActive: boolean;
  /**
   * 변경 사유 (감사 로그용, 선택)
   * @nullable
   */
  reason?: string | null;
}

/**
 * 계약이 들고 있는 계산서 상태. NULL 은 아직 아무 사건도 반영되지 않은 상태다.
 * @nullable
 */
export type CmarketTaxInvoiceCallbackResultDtoTaxInvoiceStatus =
  | (typeof CmarketTaxInvoiceCallbackResultDtoTaxInvoiceStatus)[keyof typeof CmarketTaxInvoiceCallbackResultDtoTaxInvoiceStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketTaxInvoiceCallbackResultDtoTaxInvoiceStatus = {
  REQUESTED: "REQUESTED",
  ISSUED: "ISSUED",
  CANCELLED: "CANCELLED",
} as const;

export interface CmarketTaxInvoiceCallbackResultDto {
  /** 상태를 반영한 계약 ID */
  contractId: string;
  /**
   * 계약이 들고 있는 계산서 상태. NULL 은 아직 아무 사건도 반영되지 않은 상태다.
   * @nullable
   */
  taxInvoiceStatus: CmarketTaxInvoiceCallbackResultDtoTaxInvoiceStatus;
  /** 반영하지 않고 넘겼는지 여부. 발행완료 계약에 요청 통지가 재시도로 뒤늦게 닿았거나, 축 id 가 어긋나거나, 모르는 사건 종류가 온 경우 true — 셋 다 오류가 아니므로 씨마켓이 재시도하지 않도록 2xx 로 응답한다. */
  ignoredAsStale: boolean;
}

/**
 * REQUESTED=발주기관이 발행요청, ISSUED=공급기업이 발행, CANCELLED=발행취소. 모르는 값이 오면 반영하지 않고 ignoredAsStale=true 로 응답한다(400 을 내지 않는다).
 */
export type CmarketTaxInvoiceCallbackDtoEvent =
  (typeof CmarketTaxInvoiceCallbackDtoEvent)[keyof typeof CmarketTaxInvoiceCallbackDtoEvent];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketTaxInvoiceCallbackDtoEvent = {
  REQUESTED: "REQUESTED",
  ISSUED: "ISSUED",
  CANCELLED: "CANCELLED",
} as const;

/**
 * 팝빌 관리번호(과세분). 발행 전에는 비어 있다.
 * @nullable
 */
export type CmarketTaxInvoiceCallbackDtoMgtKeyTax = {
  [key: string]: unknown;
} | null;

/**
 * 팝빌 관리번호(면세분). 세모 계약은 과세로만 등록되므로 평시엔 비어 있다.
 * @nullable
 */
export type CmarketTaxInvoiceCallbackDtoMgtKeyTaxFree = {
  [key: string]: unknown;
} | null;

/**
 * 발주기관이 지정한 작성일자(ISO 8601). 발행 전에는 비어 있다.
 * @nullable
 */
export type CmarketTaxInvoiceCallbackDtoWriteDate = {
  [key: string]: unknown;
} | null;

export interface CmarketTaxInvoiceCallbackDto {
  /** 세모 계약 ID (씨마켓에 등록할 때 보낸 externalContractId) */
  externalContractId: string;
  /** 씨마켓 세금계산서 축 id (`SI{YYMMDD}{NNNNN}`) */
  taxInvoiceTargetId: string;
  /** REQUESTED=발주기관이 발행요청, ISSUED=공급기업이 발행, CANCELLED=발행취소. 모르는 값이 오면 반영하지 않고 ignoredAsStale=true 로 응답한다(400 을 내지 않는다). */
  event: CmarketTaxInvoiceCallbackDtoEvent;
  /**
   * 팝빌 관리번호(과세분). 발행 전에는 비어 있다.
   * @nullable
   */
  mgtKeyTax?: CmarketTaxInvoiceCallbackDtoMgtKeyTax;
  /**
   * 팝빌 관리번호(면세분). 세모 계약은 과세로만 등록되므로 평시엔 비어 있다.
   * @nullable
   */
  mgtKeyTaxFree?: CmarketTaxInvoiceCallbackDtoMgtKeyTaxFree;
  /**
   * 발주기관이 지정한 작성일자(ISO 8601). 발행 전에는 비어 있다.
   * @nullable
   */
  writeDate?: CmarketTaxInvoiceCallbackDtoWriteDate;
}

export interface CmarketFeeBillPaidResultDto {
  /** 세모 계약 ID */
  contractId: string;
  /** 이번 통지로 입금 완료로 바뀌었는가(이미 완료·보류·취소면 false) */
  changed: boolean;
  /** 세모 정산 상태 */
  settlementStatus: string;
}

/**
 * 납부 수단 — 계좌 입금 / 포인트
 */
export type CmarketFeeBillPaidDtoPaidVia =
  (typeof CmarketFeeBillPaidDtoPaidVia)[keyof typeof CmarketFeeBillPaidDtoPaidVia];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketFeeBillPaidDtoPaidVia = {
  BANK: "BANK",
  POINT: "POINT",
} as const;

export interface CmarketFeeBillPaidDto {
  /** 세모가 등록 때 준 청구 참조 */
  referenceId: string;
  /** 납부 수단 — 계좌 입금 / 포인트 */
  paidVia: CmarketFeeBillPaidDtoPaidVia;
  /** 씨마켓 납부 시각(ISO 8601) — 세모 입금일로 쓴다 */
  paidAt: string;
  /** 납부 금액(원) */
  amount: number;
}

export interface CmarketConcludedContractDto {
  /** 세모 계약 id — 씨마켓 알림의 중복 방지 키 */
  contractId: string;
  /** 씨마켓 회원 id(= 세모 suppliers.supplier_id, /external/suppliers/auth 로 보낸 supplierId) */
  supplierExternalId: string;
  /** 계약 상태 — 취소(CANCELED)를 알릴지는 씨마켓이 정한다 */
  status: string;
  /** 성사 시각(계약 생성 시각) ISO 8601 */
  concludedAt: string;
  /**
   * 공급사 화면의 견적 번호(종전 /external/contracts 의 quoteRequest.requestNumber 와 같은 값)
   * @nullable
   */
  requestNumber: string | null;
  /**
   * 견적 제목
   * @nullable
   */
  projectName: string | null;
}

export interface CmarketConcludedContractsPageDto {
  /** 성사 시각 오름차순 */
  items: CmarketConcludedContractDto[];
  /**
   * 다음 페이지 커서 — null 이면 마지막 페이지
   * @nullable
   */
  nextCursor: string | null;
}

/**
 * 카테고리
 */
export type AdminQuoteRequestListItemDtoCategoryType =
  (typeof AdminQuoteRequestListItemDtoCategoryType)[keyof typeof AdminQuoteRequestListItemDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminQuoteRequestListItemDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 상태. 계약이 걸린 건은 CONTRACT_IN_PROGRESS (상세와 같은 값), 그 외는 DB 원값
 */
export type AdminQuoteRequestListItemDtoStatus =
  (typeof AdminQuoteRequestListItemDtoStatus)[keyof typeof AdminQuoteRequestListItemDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminQuoteRequestListItemDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

export interface AdminQuoteRequestListItemDto {
  /** 견적요청 ID (세모 상세로 건너뛰는 키) */
  id: string;
  /** 공고번호 */
  requestNumber: string;
  /** 공고명 */
  projectName: string;
  /**
   * 발주기관명
   * @nullable
   */
  buyerName?: string | null;
  /**
   * 씨마켓 회원 ID. 세모에 직접 가입한 발주기관은 null (씨마켓 회원이 아님)
   * @nullable
   */
  buyerMemberId?: string | null;
  /** 카테고리 */
  categoryType: AdminQuoteRequestListItemDtoCategoryType;
  /** 상태. 계약이 걸린 건은 CONTRACT_IN_PROGRESS (상세와 같은 값), 그 외는 DB 원값 */
  status: AdminQuoteRequestListItemDtoStatus;
  /** 마감일시 (ISO 8601) */
  deadline: string;
  /**
   * 등록일시 (ISO 8601) — 정렬 키
   * @nullable
   */
  publishedAt?: string | null;
  /** 응답(응찰) 수 */
  responseCount: number;
  /**
   * 공개 여부. 표시용이며 이 목록의 필터로는 쓰이지 않는다
   * @nullable
   */
  isPublic?: boolean | null;
  /** 마감 여부 — 수동 마감(status=CLOSED)이거나 마감일이 지났다. `isClosed` 필터와 같은 규칙 */
  isClosed: boolean;
}

/**
 * 참여 노출 상태. visible=정상, hidden=숨김(운영자에게만 보인다, 사용자 화면에서는 빠져 있다)
 */
export type AdminChatRoomListItemDtoParticipationState =
  (typeof AdminChatRoomListItemDtoParticipationState)[keyof typeof AdminChatRoomListItemDtoParticipationState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminChatRoomListItemDtoParticipationState = {
  visible: "visible",
  hidden: "hidden",
} as const;

export interface AdminChatRoomListItemDto {
  /** 채팅방 ID */
  id: string;
  /** 견적요청 ID */
  quoteRequestId: string;
  /**
   * 발주기관 표시명
   * @nullable
   */
  buyerName?: string | null;
  /**
   * 공급사 표시명
   * @nullable
   */
  supplierName?: string | null;
  /**
   * 씨마켓 공급사 회원 ID (`suppliers.supplier_id`)
   * @nullable
   */
  externalSupplierId?: string | null;
  /**
   * 마지막 메시지 시각 (ISO 8601)
   * @nullable
   */
  lastMessageAt?: string | null;
  /** 메시지 수 */
  messageCount: number;
  /** 참여 노출 상태. visible=정상, hidden=숨김(운영자에게만 보인다, 사용자 화면에서는 빠져 있다) */
  participationState: AdminChatRoomListItemDtoParticipationState;
  /**
   * 감춘 시각 (ISO 8601). 정상 상태면 null.
   * @nullable
   */
  hiddenAt?: string | null;
  /** 계약이 체결된 참여인지. true 면 숨기기·삭제가 막힌다. */
  hasContracted: boolean;
}

/**
 * CREATED(새로 만듦) · UPDATED(바꿈) · UNCHANGED(이미 그 상태 — 재시도였거나 늦게 도착한 옛 버전)
 */
export type CreateTradeProjectResponseDtoOutcome =
  (typeof CreateTradeProjectResponseDtoOutcome)[keyof typeof CreateTradeProjectResponseDtoOutcome];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTradeProjectResponseDtoOutcome = {
  CREATED: "CREATED",
  UPDATED: "UPDATED",
  UNCHANGED: "UNCHANGED",
} as const;

export interface CreateTradeProjectResponseDto {
  /** 대상 자원 ID */
  id: string;
  /** CREATED(새로 만듦) · UPDATED(바꿈) · UNCHANGED(이미 그 상태 — 재시도였거나 늦게 도착한 옛 버전) */
  outcome: CreateTradeProjectResponseDtoOutcome;
  /** 세모 공고 ID (quote_requests.id). `id` 와 같다. */
  projectId: string;
  /** 이번 호출이 새로 만들었는가. false 면 기존 공고를 그대로 돌려준 것. */
  created: boolean;
}

/**
 * 발주자가 읽는 말. ko | id
 */
export type TradeBuyerDtoLang =
  (typeof TradeBuyerDtoLang)[keyof typeof TradeBuyerDtoLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeBuyerDtoLang = {
  ko: "ko",
  id: "id",
} as const;

export interface TradeBuyerDto {
  /** 씨마켓 회원 ID (b2b_member.member_id) */
  externalBuyerId: string;
  /** 발주 업체명 */
  organizationName: string;
  /** 국가 코드 (ISO 3166-1 alpha-2) */
  country?: string;
  /** 발주자가 읽는 말. ko | id */
  lang?: TradeBuyerDtoLang;
}

export interface TradeProjectItemDto {
  /** 품목명 */
  name: string;
  /** 규격 */
  spec?: string;
  /** 수량 */
  quantity: number;
  /** 단위 */
  unit?: string;
  /** 희망 단가 */
  targetPrice?: number;
  /** 통화 */
  currency?: string;
}

/**
 * 원문 언어. ko | id
 */
export type TradeProjectBodyDtoSourceLang =
  (typeof TradeProjectBodyDtoSourceLang)[keyof typeof TradeProjectBodyDtoSourceLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeProjectBodyDtoSourceLang = {
  ko: "ko",
  id: "id",
} as const;

export interface TradeProjectBodyDto {
  /** 프로젝트명 */
  name: string;
  /** 상세 요청 */
  description?: string;
  /** 마감일 (YYYY-MM-DD 또는 ISO 8601). 날짜만 오면 그날 한국시간 마감 시각으로 옮긴다. 보내지 않으면 비워 둔다 — 트레이드 공고는 씨마켓이 닫을 때가 마감이다. */
  deadline?: string;
  /** 원문 언어. ko | id */
  sourceLang?: TradeProjectBodyDtoSourceLang;
  /** 품목 목록 */
  items?: TradeProjectItemDto[];
}

export interface CreateTradeProjectRequestDto {
  /** 씨마켓 원본 키. `RFQ:<id>` 또는 `LISTING:<listingId>:<buyerMemberId>`. 같은 값으로 두 번 불러도 공고는 하나다. */
  externalRef: string;
  /** 씨마켓 원장의 버전(정수, 커질수록 새 것). 보내면 이후 PUT 이 이보다 새 버전만 적용한다. */
  sourceVersion?: number;
  buyer: TradeBuyerDto;
  project: TradeProjectBodyDto;
}

/**
 * CREATED(새로 만듦) · UPDATED(바꿈) · UNCHANGED(이미 그 상태 — 재시도였거나 늦게 도착한 옛 버전)
 */
export type ReplaceTradeProjectResponseDtoOutcome =
  (typeof ReplaceTradeProjectResponseDtoOutcome)[keyof typeof ReplaceTradeProjectResponseDtoOutcome];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReplaceTradeProjectResponseDtoOutcome = {
  CREATED: "CREATED",
  UPDATED: "UPDATED",
  UNCHANGED: "UNCHANGED",
} as const;

export interface ReplaceTradeProjectResponseDto {
  /** 대상 자원 ID */
  id: string;
  /** CREATED(새로 만듦) · UPDATED(바꿈) · UNCHANGED(이미 그 상태 — 재시도였거나 늦게 도착한 옛 버전) */
  outcome: ReplaceTradeProjectResponseDtoOutcome;
  /** 세모 공고 ID. `id` 와 같다. */
  projectId: string;
  /**
   * 반영 후 세모가 가진 씨마켓 원장 버전
   * @nullable
   */
  sourceVersion: number | null;
}

export interface ReplaceTradeProjectRequestDto {
  /** 씨마켓 원장의 버전(정수). 세모에 저장된 것보다 커야 적용된다 — 같거나 작으면 늦게 도착한 옛 요청으로 보고 UNCHANGED. */
  sourceVersion: number;
  project: TradeProjectBodyDto;
}

/**
 * CREATED(새로 만듦) · UPDATED(바꿈) · UNCHANGED(이미 그 상태 — 재시도였거나 늦게 도착한 옛 버전)
 */
export type UpdateTradeProjectResponseDtoOutcome =
  (typeof UpdateTradeProjectResponseDtoOutcome)[keyof typeof UpdateTradeProjectResponseDtoOutcome];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTradeProjectResponseDtoOutcome = {
  CREATED: "CREATED",
  UPDATED: "UPDATED",
  UNCHANGED: "UNCHANGED",
} as const;

/**
 * 끝난 방식 — 요청한 status 그대로(CLOSED | CANCELLED)
 */
export type UpdateTradeProjectResponseDtoEndState =
  (typeof UpdateTradeProjectResponseDtoEndState)[keyof typeof UpdateTradeProjectResponseDtoEndState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTradeProjectResponseDtoEndState = {
  CLOSED: "CLOSED",
  CANCELLED: "CANCELLED",
} as const;

export interface UpdateTradeProjectResponseDto {
  /** 대상 자원 ID */
  id: string;
  /** CREATED(새로 만듦) · UPDATED(바꿈) · UNCHANGED(이미 그 상태 — 재시도였거나 늦게 도착한 옛 버전) */
  outcome: UpdateTradeProjectResponseDtoOutcome;
  /** 세모 공고 ID. `id` 와 같다. */
  projectId: string;
  /** 반영 후 상태. 세모의 공고 상태는 CLOSED 하나이고, 취소는 closeReason 으로 가른다. */
  status: string;
  /** 끝난 방식 — 요청한 status 그대로(CLOSED | CANCELLED) */
  endState: UpdateTradeProjectResponseDtoEndState;
  /** 이번 호출이 상태를 바꿨는가. false 면 이미 그 상태였다(멱등). */
  changed: boolean;
}

/**
 * 끝내는 방식. CLOSED(마감) · CANCELLED(취소). 되돌리는 길은 없다 — 다시 열려면 새 externalRef 로 새 공고를 연다. 이 공고의 모든 대화방이 읽기 전용이 된다.
 */
export type UpdateTradeProjectRequestDtoStatus =
  (typeof UpdateTradeProjectRequestDtoStatus)[keyof typeof UpdateTradeProjectRequestDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTradeProjectRequestDtoStatus = {
  CLOSED: "CLOSED",
  CANCELLED: "CANCELLED",
} as const;

export interface UpdateTradeProjectRequestDto {
  /** 끝내는 방식. CLOSED(마감) · CANCELLED(취소). 되돌리는 길은 없다 — 다시 열려면 새 externalRef 로 새 공고를 연다. 이 공고의 모든 대화방이 읽기 전용이 된다. */
  status: UpdateTradeProjectRequestDtoStatus;
}

export interface TradeProjectSummaryDto {
  id: string;
  externalRef: string;
  status: string;
  /**
   * 끝난 방식. 진행 중이면 null
   * @nullable
   */
  endState: string | null;
  /** @nullable */
  sourceVersion: number | null;
  projectName: string;
  /** @nullable */
  deadline: string | null;
  /** 열린 방 수 */
  roomCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface TradeProjectPageDto {
  items: TradeProjectSummaryDto[];
  /**
   * 다음 쪽 커서. 끝이면 null
   * @nullable
   */
  nextCursor: string | null;
}

/**
 * CREATED(새로 만듦) · UPDATED(바꿈) · UNCHANGED(이미 그 상태 — 재시도였거나 늦게 도착한 옛 버전)
 */
export type CreateTradeRoomResponseDtoOutcome =
  (typeof CreateTradeRoomResponseDtoOutcome)[keyof typeof CreateTradeRoomResponseDtoOutcome];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTradeRoomResponseDtoOutcome = {
  CREATED: "CREATED",
  UPDATED: "UPDATED",
  UNCHANGED: "UNCHANGED",
} as const;

export interface CreateTradeRoomResponseDto {
  /** 대상 자원 ID */
  id: string;
  /** CREATED(새로 만듦) · UPDATED(바꿈) · UNCHANGED(이미 그 상태 — 재시도였거나 늦게 도착한 옛 버전) */
  outcome: CreateTradeRoomResponseDtoOutcome;
  /** 세모 대화방 ID (chat_rooms.id). `id` 와 같다. */
  chatRoomId: string;
  /** 이번 호출이 새로 열었는가. false 면 이미 있던 방이다. */
  created: boolean;
}

/**
 * 공급사가 읽는 말. ko | id
 */
export type TradeSupplierDtoLang =
  (typeof TradeSupplierDtoLang)[keyof typeof TradeSupplierDtoLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeSupplierDtoLang = {
  ko: "ko",
  id: "id",
} as const;

export interface TradeSupplierDto {
  /** 씨마켓 회원 ID (b2b_member.member_id) */
  supplierId: string;
  /** 공급사 상호 */
  companyName: string;
  /** 국가 코드 */
  country?: string;
  /** 공급사가 읽는 말. ko | id */
  lang?: TradeSupplierDtoLang;
}

export interface CreateTradeRoomRequestDto {
  supplier: TradeSupplierDto;
}

export interface TradeRoomSummaryDto {
  id: string;
  projectId: string;
  /** @nullable */
  supplierMemberId: string | null;
  /** IN_PROGRESS · read_only(닫힘) */
  status: string;
  /** @nullable */
  lastMessageAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface TradeRoomPageDto {
  items: TradeRoomSummaryDto[];
  /** @nullable */
  nextCursor: string | null;
}

/**
 * CREATED(새로 만듦) · UPDATED(바꿈) · UNCHANGED(이미 그 상태 — 재시도였거나 늦게 도착한 옛 버전)
 */
export type CloseTradeRoomResponseDtoOutcome =
  (typeof CloseTradeRoomResponseDtoOutcome)[keyof typeof CloseTradeRoomResponseDtoOutcome];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CloseTradeRoomResponseDtoOutcome = {
  CREATED: "CREATED",
  UPDATED: "UPDATED",
  UNCHANGED: "UNCHANGED",
} as const;

export interface CloseTradeRoomResponseDto {
  /** 대상 자원 ID */
  id: string;
  /** CREATED(새로 만듦) · UPDATED(바꿈) · UNCHANGED(이미 그 상태 — 재시도였거나 늦게 도착한 옛 버전) */
  outcome: CloseTradeRoomResponseDtoOutcome;
  status: string;
}

/**
 * 지금은 CLOSED 만 받는다. 방은 읽기 전용이 되고 되돌리는 길은 없다.
 */
export type CloseTradeRoomRequestDtoStatus =
  (typeof CloseTradeRoomRequestDtoStatus)[keyof typeof CloseTradeRoomRequestDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CloseTradeRoomRequestDtoStatus = {
  CLOSED: "CLOSED",
} as const;

export interface CloseTradeRoomRequestDto {
  /** 지금은 CLOSED 만 받는다. 방은 읽기 전용이 되고 되돌리는 길은 없다. */
  status: CloseTradeRoomRequestDtoStatus;
}

export interface TradeEmbedResponseDto {
  /** 임베드 URL. 토큰은 URL 조각(`#token=`)에 실린다 — 조각은 서버로 가지 않아 기록·Referer 에 남지 않는다. 1회용이고 수명이 짧다(약 120초). */
  embedUrl: string;
}

/**
 * 누가 여는가. buyer(인니 발주자) | supplier(한국 공급사)
 */
export type TradeEmbedRequestDtoRole =
  (typeof TradeEmbedRequestDtoRole)[keyof typeof TradeEmbedRequestDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeEmbedRequestDtoRole = {
  buyer: "buyer",
  supplier: "supplier",
} as const;

export interface TradeEmbedRequestDto {
  /** 누가 여는가. buyer(인니 발주자) | supplier(한국 공급사) */
  role: TradeEmbedRequestDtoRole;
  /** 씨마켓 회원 ID (b2b_member.member_id). 발주자는 `buyers.external_buyer_id`, 공급사는 `suppliers.supplier_id` 와 맞아야 한다. */
  externalId: string;
}

/**
 * CREATED(새로 만듦) · UPDATED(바꿈) · UNCHANGED(이미 그 상태 — 재시도였거나 늦게 도착한 옛 버전)
 */
export type RetranslateTradeMessageResponseDtoOutcome =
  (typeof RetranslateTradeMessageResponseDtoOutcome)[keyof typeof RetranslateTradeMessageResponseDtoOutcome];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RetranslateTradeMessageResponseDtoOutcome = {
  CREATED: "CREATED",
  UPDATED: "UPDATED",
  UNCHANGED: "UNCHANGED",
} as const;

export interface RetranslateTradeMessageResponseDto {
  /** 대상 자원 ID */
  id: string;
  /** CREATED(새로 만듦) · UPDATED(바꿈) · UNCHANGED(이미 그 상태 — 재시도였거나 늦게 도착한 옛 버전) */
  outcome: RetranslateTradeMessageResponseDtoOutcome;
  /** 반영 후 번역 상태. FAILED 가 아니던 메시지는 그대로 둔다(UNCHANGED). */
  translationStatus: string;
}

export interface TradeGlossaryEntryDto {
  ko: string;
  id: string;
  /** @nullable */
  note: string | null;
}

export interface TradeGlossaryDto {
  /** 세모 채팅 번역이 쓰는 용어집 정본. 씨마켓이 공고를 번역할 때 같은 표를 써야 한 품목이 한 이름으로 불린다. */
  entries: TradeGlossaryEntryDto[];
}

export interface TradeFailedTranslationDto {
  messageId: string;
  roomId: string;
  createdAt: string;
}

export interface TradeTranslationReconciliationDto {
  /** 창 안의 번역 대상 수 */
  totalCount: number;
  /** 창 안의 FAILED 수 */
  failedCount: number;
  /** FAILED 비율 (0–1) */
  failedRatio: number;
  /** 지금 PENDING 인 수 */
  pendingCount: number;
  /**
   * PENDING 체류 p95 (초)
   * @nullable
   */
  pendingP95Seconds: number | null;
  failed: TradeFailedTranslationDto[];
  /** @nullable */
  nextCursor: string | null;
}

export type TradeCompanyDtoCountry =
  (typeof TradeCompanyDtoCountry)[keyof typeof TradeCompanyDtoCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeCompanyDtoCountry = {
  KR: "KR",
  ID: "ID",
} as const;

export interface TradeCompanyDto {
  id: string;
  memberId: string;
  slug: string;
  country: TradeCompanyDtoCountry;
  /** @nullable */
  companyNameKo: string | null;
  /** @nullable */
  companyNameId: string | null;
  /** @nullable */
  summaryKo: string | null;
  /** @nullable */
  summaryId: string | null;
  /** @nullable */
  descriptionKo: string | null;
  /** @nullable */
  descriptionId: string | null;
  /** @nullable */
  industry: string | null;
  mainProducts: string[];
  /** @nullable */
  website: string | null;
  /** @nullable */
  contactEmail: string | null;
  isPublished: boolean;
  /** 글이 바뀔 때만 오른다 — 번역 캐시 키 */
  contentVersion: number;
  createdAt: string;
  updatedAt: string;
}

export type UpsertTradeCompanyRequestDtoCountry =
  (typeof UpsertTradeCompanyRequestDtoCountry)[keyof typeof UpsertTradeCompanyRequestDtoCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpsertTradeCompanyRequestDtoCountry = {
  KR: "KR",
  ID: "ID",
} as const;

export interface UpsertTradeCompanyRequestDto {
  country: UpsertTradeCompanyRequestDtoCountry;
  /**
   * @maxLength 200
   * @nullable
   */
  companyNameKo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  companyNameId?: string | null;
  /**
   * @maxLength 300
   * @nullable
   */
  summaryKo?: string | null;
  /**
   * @maxLength 300
   * @nullable
   */
  summaryId?: string | null;
  /**
   * @maxLength 20000
   * @nullable
   */
  descriptionKo?: string | null;
  /**
   * @maxLength 20000
   * @nullable
   */
  descriptionId?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  industry?: string | null;
  mainProducts: string[];
  /**
   * @maxLength 300
   * @nullable
   */
  website?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  contactEmail?: string | null;
  isPublished: boolean;
}

export interface TradeCompanyPageDto {
  items: TradeCompanyDto[];
  total: number;
}

export interface SetTradeCompanyPublicationRequestDto {
  isPublished: boolean;
}

export interface TradeRfqItemDto {
  id: string;
  sortOrder: number;
  name: string;
  /** @nullable */
  spec: string | null;
  quantity: number;
  unit: string;
  /** @nullable */
  targetPrice: number | null;
  /** @nullable */
  semoItemId: string | null;
  /** @nullable */
  semoItemManufacturer: string | null;
  /** @nullable */
  semoItemBrand: string | null;
  /** @nullable */
  semoItemCategoryPath: string | null;
}

export type TradeRfqDtoAuthorCountry =
  (typeof TradeRfqDtoAuthorCountry)[keyof typeof TradeRfqDtoAuthorCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeRfqDtoAuthorCountry = {
  KR: "KR",
  ID: "ID",
} as const;

export type TradeRfqDtoStatus =
  (typeof TradeRfqDtoStatus)[keyof typeof TradeRfqDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeRfqDtoStatus = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
} as const;

export type TradeRfqDtoSourceLang =
  (typeof TradeRfqDtoSourceLang)[keyof typeof TradeRfqDtoSourceLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeRfqDtoSourceLang = {
  ko: "ko",
  id: "id",
} as const;

export interface TradeRfqDto {
  id: string;
  authorMemberId: string;
  authorCountry: TradeRfqDtoAuthorCountry;
  status: TradeRfqDtoStatus;
  sourceLang: TradeRfqDtoSourceLang;
  /** @nullable */
  titleKo: string | null;
  /** @nullable */
  titleId: string | null;
  /** @nullable */
  descriptionKo: string | null;
  /** @nullable */
  descriptionId: string | null;
  itemName: string;
  quantity: number;
  unit: string;
  /** @nullable */
  targetPrice: number | null;
  /** @nullable */
  currency: string | null;
  /** @nullable */
  deadline: string | null;
  /** @nullable */
  semoItemId: string | null;
  /** @nullable */
  semoItemManufacturer: string | null;
  /** @nullable */
  semoItemBrand: string | null;
  /** @nullable */
  semoItemCategoryPath: string | null;
  items: TradeRfqItemDto[];
  /** @nullable */
  deliveryPlace: string | null;
  /** @nullable */
  deliveryDueDate: string | null;
  /** @nullable */
  category: string | null;
  budgetPublic: boolean;
  /** @nullable */
  deliveryMethod: string | null;
  /** @nullable */
  deliveryTimingMode: string | null;
  /** @nullable */
  deliveryRegion: string | null;
  /** @nullable */
  deliveryCity: string | null;
  /** @nullable */
  deliveryAddress: string | null;
  /** @nullable */
  deliveryAddressDetail: string | null;
  /** @nullable */
  contactName: string | null;
  /** @nullable */
  contactPhone: string | null;
  contentVersion: number;
  /** @nullable */
  closedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface TradeRfqItemInputDto {
  /** @maxLength 200 */
  name: string;
  /**
   * @maxLength 500
   * @nullable
   */
  spec?: string | null;
  quantity: number;
  /** @maxLength 30 */
  unit: string;
  /** @nullable */
  targetPrice?: number | null;
  /** @nullable */
  semoItemId?: string | null;
  /** @nullable */
  semoItemManufacturer?: string | null;
  /** @nullable */
  semoItemBrand?: string | null;
  /** @nullable */
  semoItemCategoryPath?: string | null;
}

/**
 * 작성 언어 — 어느 칸이 원문인가
 */
export type CreateTradeRfqRequestDtoSourceLang =
  (typeof CreateTradeRfqRequestDtoSourceLang)[keyof typeof CreateTradeRfqRequestDtoSourceLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTradeRfqRequestDtoSourceLang = {
  ko: "ko",
  id: "id",
} as const;

/**
 * @nullable
 */
export type CreateTradeRfqRequestDtoCurrency =
  | (typeof CreateTradeRfqRequestDtoCurrency)[keyof typeof CreateTradeRfqRequestDtoCurrency]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTradeRfqRequestDtoCurrency = {
  USD: "USD",
  IDR: "IDR",
  KRW: "KRW",
} as const;

/**
 * @nullable
 */
export type CreateTradeRfqRequestDtoCategory =
  | (typeof CreateTradeRfqRequestDtoCategory)[keyof typeof CreateTradeRfqRequestDtoCategory]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTradeRfqRequestDtoCategory = {
  OFFICE: "OFFICE",
  LAB: "LAB",
  MACHINERY: "MACHINERY",
  CHEMICAL: "CHEMICAL",
  ETC: "ETC",
} as const;

/**
 * @nullable
 */
export type CreateTradeRfqRequestDtoDeliveryMethod =
  | (typeof CreateTradeRfqRequestDtoDeliveryMethod)[keyof typeof CreateTradeRfqRequestDtoDeliveryMethod]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTradeRfqRequestDtoDeliveryMethod = {
  SEA_FOB: "SEA_FOB",
  SEA_CIF: "SEA_CIF",
  AIR: "AIR",
  NEGOTIATE: "NEGOTIATE",
} as const;

/**
 * @nullable
 */
export type CreateTradeRfqRequestDtoDeliveryTimingMode =
  | (typeof CreateTradeRfqRequestDtoDeliveryTimingMode)[keyof typeof CreateTradeRfqRequestDtoDeliveryTimingMode]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTradeRfqRequestDtoDeliveryTimingMode = {
  NEGOTIATE: "NEGOTIATE",
  SPECIFIC: "SPECIFIC",
} as const;

export interface CreateTradeRfqRequestDto {
  /** 작성 언어 — 어느 칸이 원문인가 */
  sourceLang: CreateTradeRfqRequestDtoSourceLang;
  /**
   * @maxLength 200
   * @nullable
   */
  titleKo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  titleId?: string | null;
  /** @nullable */
  descriptionKo?: string | null;
  /** @nullable */
  descriptionId?: string | null;
  /** @nullable */
  currency?: CreateTradeRfqRequestDtoCurrency;
  /**
   * ISO 8601
   * @nullable
   */
  deadline?: string | null;
  items: TradeRfqItemInputDto[];
  /** @nullable */
  deliveryPlace?: string | null;
  /**
   * YYYY-MM-DD
   * @nullable
   */
  deliveryDueDate?: string | null;
  /** @nullable */
  category?: CreateTradeRfqRequestDtoCategory;
  budgetPublic: boolean;
  /** @nullable */
  deliveryMethod?: CreateTradeRfqRequestDtoDeliveryMethod;
  /** @nullable */
  deliveryTimingMode?: CreateTradeRfqRequestDtoDeliveryTimingMode;
  /** @nullable */
  deliveryRegion?: string | null;
  /** @nullable */
  deliveryCity?: string | null;
  /** @nullable */
  deliveryAddress?: string | null;
  /** @nullable */
  deliveryAddressDetail?: string | null;
  /** @nullable */
  contactName?: string | null;
  /** @nullable */
  contactPhone?: string | null;
}

/**
 * @nullable
 */
export type TradeRfqListItemDtoAuthor = TradeCompanyDto | null;

export interface TradeRfqListItemDto {
  rfq: TradeRfqDto;
  /** @nullable */
  author: TradeRfqListItemDtoAuthor;
  proposalCount: number;
  itemCount: number;
  /**
   * 방과 함께 견적을 낸 공급사 수 — 상세만 채운다. 목록은 null.
   * @nullable
   */
  quoteCount: number | null;
  quoteCap: number;
}

export interface TradeCountDto {
  count: number;
}

export interface TradeProposalItemPriceDto {
  /** trade_rfq_items.id */
  rfqItemId: string;
  unitPrice: number;
}

export type TradeProposalDtoStatus =
  (typeof TradeProposalDtoStatus)[keyof typeof TradeProposalDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeProposalDtoStatus = {
  SUBMITTED: "SUBMITTED",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
} as const;

export type TradeProposalDtoSenderLang =
  (typeof TradeProposalDtoSenderLang)[keyof typeof TradeProposalDtoSenderLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeProposalDtoSenderLang = {
  ko: "ko",
  id: "id",
} as const;

export type TradeProposalDtoCurrency =
  (typeof TradeProposalDtoCurrency)[keyof typeof TradeProposalDtoCurrency];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeProposalDtoCurrency = {
  USD: "USD",
  IDR: "IDR",
  KRW: "KRW",
} as const;

/**
 * @nullable
 */
export type TradeProposalDtoRfqSnapshot = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type TradeProposalDtoShippingTerm =
  | (typeof TradeProposalDtoShippingTerm)[keyof typeof TradeProposalDtoShippingTerm]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeProposalDtoShippingTerm = {
  SEA_FOB: "SEA_FOB",
  SEA_CIF: "SEA_CIF",
  AIR: "AIR",
  NEGOTIATE: "NEGOTIATE",
} as const;

/**
 * @nullable
 */
export type TradeProposalDtoPaymentTerm =
  | (typeof TradeProposalDtoPaymentTerm)[keyof typeof TradeProposalDtoPaymentTerm]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeProposalDtoPaymentTerm = {
  PREPAY_100: "PREPAY_100",
  DEPOSIT_30: "DEPOSIT_30",
  LC_AT_SIGHT: "LC_AT_SIGHT",
  NET_30: "NET_30",
  NEGOTIATE: "NEGOTIATE",
} as const;

export interface TradeProposalDto {
  id: string;
  rfqId: string;
  proposerMemberId: string;
  status: TradeProposalDtoStatus;
  senderLang: TradeProposalDtoSenderLang;
  body: string;
  price: number;
  currency: TradeProposalDtoCurrency;
  /** @nullable */
  leadTimeDays: number | null;
  /** @nullable */
  rfqSnapshot: TradeProposalDtoRfqSnapshot;
  /** @nullable */
  shippingTerm: TradeProposalDtoShippingTerm;
  /** @nullable */
  paymentTerm: TradeProposalDtoPaymentTerm;
  /** @nullable */
  sampleAvailable: boolean | null;
  /** @nullable */
  itemPrices: TradeProposalItemPriceDto[] | null;
  contentVersion: number;
  /** @nullable */
  decidedAt: string | null;
  createdAt: string;
  /** @nullable */
  roomId: string | null;
}

export type CreateTradeProposalRequestDtoSenderLang =
  (typeof CreateTradeProposalRequestDtoSenderLang)[keyof typeof CreateTradeProposalRequestDtoSenderLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTradeProposalRequestDtoSenderLang = {
  ko: "ko",
  id: "id",
} as const;

export type CreateTradeProposalRequestDtoCurrency =
  (typeof CreateTradeProposalRequestDtoCurrency)[keyof typeof CreateTradeProposalRequestDtoCurrency];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTradeProposalRequestDtoCurrency = {
  USD: "USD",
  IDR: "IDR",
  KRW: "KRW",
} as const;

/**
 * 제출 순간의 RFQ 조건 사본(씨마켓 모양 그대로)
 */
export type CreateTradeProposalRequestDtoRfqSnapshot = {
  [key: string]: unknown;
};

/**
 * 운송 조건 — RFQ 의 deliveryMethod 와 같은 값
 * @nullable
 */
export type CreateTradeProposalRequestDtoShippingTerm =
  | (typeof CreateTradeProposalRequestDtoShippingTerm)[keyof typeof CreateTradeProposalRequestDtoShippingTerm]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTradeProposalRequestDtoShippingTerm = {
  SEA_FOB: "SEA_FOB",
  SEA_CIF: "SEA_CIF",
  AIR: "AIR",
  NEGOTIATE: "NEGOTIATE",
} as const;

/**
 * @nullable
 */
export type CreateTradeProposalRequestDtoPaymentTerm =
  | (typeof CreateTradeProposalRequestDtoPaymentTerm)[keyof typeof CreateTradeProposalRequestDtoPaymentTerm]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTradeProposalRequestDtoPaymentTerm = {
  PREPAY_100: "PREPAY_100",
  DEPOSIT_30: "DEPOSIT_30",
  LC_AT_SIGHT: "LC_AT_SIGHT",
  NET_30: "NET_30",
  NEGOTIATE: "NEGOTIATE",
} as const;

export interface CreateTradeProposalRequestDto {
  senderLang: CreateTradeProposalRequestDtoSenderLang;
  /** @maxLength 5000 */
  body: string;
  price: number;
  currency: CreateTradeProposalRequestDtoCurrency;
  /** @nullable */
  leadTimeDays?: number | null;
  /** 제출 순간의 RFQ 조건 사본(씨마켓 모양 그대로) */
  rfqSnapshot?: CreateTradeProposalRequestDtoRfqSnapshot;
  /**
   * 운송 조건 — RFQ 의 deliveryMethod 와 같은 값
   * @nullable
   */
  shippingTerm?: CreateTradeProposalRequestDtoShippingTerm;
  /** @nullable */
  paymentTerm?: CreateTradeProposalRequestDtoPaymentTerm;
  /** @nullable */
  sampleAvailable?: boolean | null;
  /**
   * 품목별 단가 — 그 RFQ 의 품목만. price 는 합계로 따로 보낸다
   * @nullable
   */
  itemPrices?: TradeProposalItemPriceDto[] | null;
}

export type TradeRoomV2DtoSource =
  (typeof TradeRoomV2DtoSource)[keyof typeof TradeRoomV2DtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeRoomV2DtoSource = {
  RFQ: "RFQ",
  LISTING: "LISTING",
  DIRECT: "DIRECT",
} as const;

export interface TradeRoomV2Dto {
  id: string;
  chatRoomId: string;
  source: TradeRoomV2DtoSource;
  /** @nullable */
  rfqId: string | null;
  /** @nullable */
  listingId: string | null;
  buyerMemberId: string;
  supplierMemberId: string;
  /** @nullable */
  status: string | null;
  createdAt: string;
}

export type TradeQuoteSubmissionDtoOutcome =
  (typeof TradeQuoteSubmissionDtoOutcome)[keyof typeof TradeQuoteSubmissionDtoOutcome];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeQuoteSubmissionDtoOutcome = {
  CREATED: "CREATED",
  EXISTING: "EXISTING",
} as const;

export interface TradeQuoteSubmissionDto {
  outcome: TradeQuoteSubmissionDtoOutcome;
  proposal: TradeProposalDto;
  room: TradeRoomV2Dto;
}

/**
 * @nullable
 */
export type TradeProposalListItemDtoProposer = TradeCompanyDto | null;

export interface TradeProposalListItemDto {
  proposal: TradeProposalDto;
  /** @nullable */
  proposer: TradeProposalListItemDtoProposer;
}

/**
 * @nullable
 */
export type TradeReceivedProposalDtoProposer = TradeCompanyDto | null;

export interface TradeReceivedProposalDto {
  proposal: TradeProposalDto;
  /** @nullable */
  proposer: TradeReceivedProposalDtoProposer;
  rfq: TradeRfqDto;
}

export interface TradeProposalDecisionDto {
  /** false 면 이미 결정됐거나 동시 요청의 패자(상태가 기대와 달랐다) */
  decided: boolean;
  proposal: TradeProposalDto;
  /** @nullable */
  roomId: string | null;
  /** @nullable */
  chatRoomId: string | null;
  /** @nullable */
  messageId: string | null;
}

export type DecideTradeProposalRequestDtoExpectedStatus =
  (typeof DecideTradeProposalRequestDtoExpectedStatus)[keyof typeof DecideTradeProposalRequestDtoExpectedStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DecideTradeProposalRequestDtoExpectedStatus = {
  SUBMITTED: "SUBMITTED",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
} as const;

export type DecideTradeProposalRequestDtoNextStatus =
  (typeof DecideTradeProposalRequestDtoNextStatus)[keyof typeof DecideTradeProposalRequestDtoNextStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DecideTradeProposalRequestDtoNextStatus = {
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
} as const;

export interface DecideTradeProposalRequestDto {
  expectedStatus: DecideTradeProposalRequestDtoExpectedStatus;
  nextStatus: DecideTradeProposalRequestDtoNextStatus;
  /**
   * 수락 안내 메시지(작성자 언어 원문). 주면 두 당사자의 직접 문의 방을 열고 같은 트랜잭션에 남긴다
   * @maxLength 2000
   */
  acceptMessage?: string;
}

export interface TradeListingItemDto {
  name: string;
  /** @nullable */
  spec: string | null;
  quantity: number;
  unit: string;
  /** @nullable */
  targetPrice: number | null;
  /** @nullable */
  currency: string | null;
}

export type TradeListingDtoStatus =
  (typeof TradeListingDtoStatus)[keyof typeof TradeListingDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeListingDtoStatus = {
  ACTIVE: "ACTIVE",
  CLOSED: "CLOSED",
  EXPIRED: "EXPIRED",
} as const;

export interface TradeListingDto {
  id: string;
  ownerMemberId: string;
  /** @nullable */
  titleKo: string | null;
  /** @nullable */
  titleId: string | null;
  /** @nullable */
  descriptionKo: string | null;
  /** @nullable */
  descriptionId: string | null;
  items: TradeListingItemDto[];
  /** @nullable */
  currency: string | null;
  status: TradeListingDtoStatus;
  seatsTotal: number;
  seatsUsed: number;
  expiresAt: string;
  /** @nullable */
  closedAt: string | null;
  contentVersion: number;
  waitingCount: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * @nullable
 */
export type TradeListingItemInputDtoCurrency =
  | (typeof TradeListingItemInputDtoCurrency)[keyof typeof TradeListingItemInputDtoCurrency]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeListingItemInputDtoCurrency = {
  USD: "USD",
  IDR: "IDR",
  KRW: "KRW",
} as const;

export interface TradeListingItemInputDto {
  /** @maxLength 200 */
  name: string;
  /** @nullable */
  spec?: string | null;
  quantity: number;
  unit: string;
  /** @nullable */
  targetPrice?: number | null;
  /** @nullable */
  currency?: TradeListingItemInputDtoCurrency;
}

/**
 * @nullable
 */
export type CreateTradeListingRequestDtoCurrency =
  | (typeof CreateTradeListingRequestDtoCurrency)[keyof typeof CreateTradeListingRequestDtoCurrency]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTradeListingRequestDtoCurrency = {
  USD: "USD",
  IDR: "IDR",
  KRW: "KRW",
} as const;

export interface CreateTradeListingRequestDto {
  /** @nullable */
  titleKo?: string | null;
  /** @nullable */
  titleId?: string | null;
  /** @nullable */
  descriptionKo?: string | null;
  /** @nullable */
  descriptionId?: string | null;
  items: TradeListingItemInputDto[];
  /** @nullable */
  currency?: CreateTradeListingRequestDtoCurrency;
  /**
   * @minimum 1
   * @maximum 1000
   */
  seatsTotal: number;
  /** ISO 8601 — 게재 만료 시각 */
  expiresAt: string;
}

export type TradeEndedListingDtoStatus =
  (typeof TradeEndedListingDtoStatus)[keyof typeof TradeEndedListingDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeEndedListingDtoStatus = {
  CLOSED: "CLOSED",
  EXPIRED: "EXPIRED",
} as const;

export interface TradeEndedListingDto {
  listingId: string;
  ownerMemberId: string;
  status: TradeEndedListingDtoStatus;
  unusedSeats: number;
  closedAt: string;
}

export interface TradeExpireResultDto {
  expired: TradeEndedListingDto[];
}

export interface ExpireTradeListingsRequestDto {
  /** @maximum 1000 */
  limit?: number;
}

export interface TradeListingClosureDto {
  listing: TradeListingDto;
  /** 미사용 자리 — 씨마켓이 이월 석으로 적립한다 */
  unusedSeats: number;
}

export interface TradeCapacitySeatedDto {
  buyerMemberId: string;
  /**
   * 방을 못 열었으면 null(자리는 되돌렸다)
   * @nullable
   */
  roomId: string | null;
}

export type TradeCapacityResultDtoOutcome =
  (typeof TradeCapacityResultDtoOutcome)[keyof typeof TradeCapacityResultDtoOutcome];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeCapacityResultDtoOutcome = {
  UPDATED: "UPDATED",
  UNCHANGED: "UNCHANGED",
} as const;

export interface TradeCapacityResultDto {
  outcome: TradeCapacityResultDtoOutcome;
  listing: TradeListingDto;
  seated: TradeCapacitySeatedDto[];
}

export interface AddTradeListingCapacityRequestDto {
  /**
   * @minimum 1
   * @maximum 50
   */
  seats: number;
}

export type TradeSeatDtoStatus =
  (typeof TradeSeatDtoStatus)[keyof typeof TradeSeatDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeSeatDtoStatus = {
  OPEN: "OPEN",
  RELEASED: "RELEASED",
} as const;

export interface TradeSeatDto {
  id: string;
  listingId: string;
  buyerMemberId: string;
  status: TradeSeatDtoStatus;
  /** @nullable */
  roomId: string | null;
  /** @nullable */
  chatRoomId: string | null;
  createdAt: string;
}

export type TakeTradeSeatResultDtoOutcome =
  (typeof TakeTradeSeatResultDtoOutcome)[keyof typeof TakeTradeSeatResultDtoOutcome];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TakeTradeSeatResultDtoOutcome = {
  CLAIMED: "CLAIMED",
  EXISTING: "EXISTING",
  FULL: "FULL",
} as const;

/**
 * @nullable
 */
export type TakeTradeSeatResultDtoSeat = TradeSeatDto | null;

export interface TakeTradeSeatResultDto {
  outcome: TakeTradeSeatResultDtoOutcome;
  /** @nullable */
  seat: TakeTradeSeatResultDtoSeat;
}

export type TradeWaitlistEntryDtoStatus =
  (typeof TradeWaitlistEntryDtoStatus)[keyof typeof TradeWaitlistEntryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeWaitlistEntryDtoStatus = {
  WAITING: "WAITING",
  SEATED: "SEATED",
  EXPIRED: "EXPIRED",
  FAILED: "FAILED",
  CANCELED: "CANCELED",
} as const;

export interface TradeWaitlistEntryDto {
  id: string;
  listingId: string;
  buyerMemberId: string;
  status: TradeWaitlistEntryDtoStatus;
  expiresAt: string;
  /** @nullable */
  seatedSeatId: string | null;
  /** @nullable */
  failureReason: string | null;
  /**
   * 1부터. WAITING 이 아니면 null
   * @nullable
   */
  position: number | null;
  createdAt: string;
}

export interface JoinTradeWaitlistRequestDto {
  /** ISO 8601 — 대기 만료 시각 */
  expiresAt: string;
}

export type TradeRoomOpenResultDtoOutcome =
  (typeof TradeRoomOpenResultDtoOutcome)[keyof typeof TradeRoomOpenResultDtoOutcome];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeRoomOpenResultDtoOutcome = {
  CREATED: "CREATED",
  UNCHANGED: "UNCHANGED",
} as const;

export interface TradeRoomOpenResultDto {
  outcome: TradeRoomOpenResultDtoOutcome;
  room: TradeRoomV2Dto;
}

export type CreateTradeRoomV2RequestDtoSource =
  (typeof CreateTradeRoomV2RequestDtoSource)[keyof typeof CreateTradeRoomV2RequestDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTradeRoomV2RequestDtoSource = {
  RFQ: "RFQ",
  LISTING: "LISTING",
  DIRECT: "DIRECT",
} as const;

export interface CreateTradeRoomV2RequestDto {
  source: CreateTradeRoomV2RequestDtoSource;
  /** source=RFQ — 행위자(한국 공급사)가 참여하는 RFQ */
  rfqId?: number;
  /** source=DIRECT — 상대 씨마켓 회원 id */
  counterpartMemberId?: string;
}

export type TradeMemberRoomDtoSource =
  (typeof TradeMemberRoomDtoSource)[keyof typeof TradeMemberRoomDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeMemberRoomDtoSource = {
  RFQ: "RFQ",
  LISTING: "LISTING",
  DIRECT: "DIRECT",
} as const;

export type TradeMemberRoomDtoMyRole =
  (typeof TradeMemberRoomDtoMyRole)[keyof typeof TradeMemberRoomDtoMyRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeMemberRoomDtoMyRole = {
  buyer: "buyer",
  supplier: "supplier",
} as const;

export interface TradeMemberRoomDto {
  roomId: string;
  chatRoomId: string;
  source: TradeMemberRoomDtoSource;
  /** @nullable */
  rfqId: string | null;
  /** @nullable */
  listingId: string | null;
  counterpartMemberId: string;
  myRole: TradeMemberRoomDtoMyRole;
  /** @nullable */
  status: string | null;
  /** @nullable */
  lastMessageAt: string | null;
  /**
   * 마지막 메시지 원문
   * @nullable
   */
  lastMessage: string | null;
  /** @nullable */
  lastMessageTranslated: string | null;
  /** @nullable */
  lastMessageTranslatedLang: string | null;
  /** @nullable */
  lastMessageIsMine: boolean | null;
  unreadCount: number;
  createdAt: string;
}

export interface TradeMemberRoomPageDto {
  items: TradeMemberRoomDto[];
  /** 내 모든 방의 미읽음 합(페이지와 무관) */
  unreadTotal: number;
}

export interface TradeEmbedUrlDto {
  embedUrl: string;
}

export interface TradeRoomMessageSentDto {
  /** 채팅 메시지 id */
  messageId: string;
}

export interface SendTradeRoomMessageRequestDto {
  /**
   * 보낼 글 — 행위자의 말로 쓴 원문
   * @maxLength 4000
   */
  text: string;
}

export interface TradeUnreadItemDto {
  /** 채팅방 id(커서) */
  roomId: string;
  /** 무역 방 id */
  tradeRoomId: string;
  buyerMemberId: string;
  supplierMemberId: string;
  /** 발주자가 아직 안 읽은 수 */
  unreadForBuyer: number;
  /** 공급사가 아직 안 읽은 수 */
  unreadForSupplier: number;
  /** @nullable */
  lastMessageAt: string | null;
}

export interface TradeUnreadPageDto {
  /** 미읽음이 있는 방만. 스냅샷이다 — 씨마켓은 직전과 비교해 늘어난 것만 알린다. */
  items: TradeUnreadItemDto[];
  /** @nullable */
  nextCursor: string | null;
}

export interface TradeBlockedDto {
  blocked: boolean;
}

/**
 * 문의 유형
 */
export type CreateContactInquiryDtoInquiryType =
  (typeof CreateContactInquiryDtoInquiryType)[keyof typeof CreateContactInquiryDtoInquiryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateContactInquiryDtoInquiryType = {
  bug: "bug",
  feedback: "feedback",
  supplier: "supplier",
  transaction: "transaction",
  general: "general",
} as const;

export interface CreateContactInquiryDto {
  /**
   * 문의자 이름
   * @minLength 2
   * @maxLength 50
   */
  name: string;
  /** 문의자 이메일 */
  email: string;
  /**
   * 문의자 전화번호
   * @maxLength 20
   */
  phone?: string;
  /**
   * 회사명/사업자명
   * @maxLength 100
   */
  company?: string;
  /** 문의 유형 */
  inquiryType: CreateContactInquiryDtoInquiryType;
  /**
   * 문의 내용
   * @minLength 10
   * @maxLength 2000
   */
  message: string;
}

/**
 * 이 견적의 대금이 흐르는 길. **화면이 어느 버튼·어느 창을 띄울지 이 값 하나로 정한다.**

- `SEMO_ESCROW`: 세모 안심결제. 발주기관이 먼저 결제하고, 승인되면 계약이 선다.
- `CONTRACT_FIRST`: 계약이 먼저 서고, 결제·계산서는 씨마켓에서 한다.

아래 `cardSelectable`·`cardPaymentAvailable` 은 `CONTRACT_FIRST` 일 때만 뜻이 있다 — 씨마켓 결제창에 대한 답이기 때문이다.
 */
export type VendorDirectEligibilityResponseDtoPaymentFlow =
  (typeof VendorDirectEligibilityResponseDtoPaymentFlow)[keyof typeof VendorDirectEligibilityResponseDtoPaymentFlow];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VendorDirectEligibilityResponseDtoPaymentFlow = {
  SEMO_ESCROW: "SEMO_ESCROW",
  CONTRACT_FIRST: "CONTRACT_FIRST",
} as const;

/**
 * 공고에서 고른 희망 결제수단(card/cash/undecided). 계약의 확정 채널과 비교해 안내를 띄우는 데 쓴다. null 은 기능 신설 이전 공고.
 * @nullable
 */
export type VendorDirectEligibilityResponseDtoRequestedPaymentChannel =
  | (typeof VendorDirectEligibilityResponseDtoRequestedPaymentChannel)[keyof typeof VendorDirectEligibilityResponseDtoRequestedPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VendorDirectEligibilityResponseDtoRequestedPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

export interface VendorDirectEligibilityResponseDto {
  /** 이 견적의 대금이 흐르는 길. **화면이 어느 버튼·어느 창을 띄울지 이 값 하나로 정한다.**

- `SEMO_ESCROW`: 세모 안심결제. 발주기관이 먼저 결제하고, 승인되면 계약이 선다.
- `CONTRACT_FIRST`: 계약이 먼저 서고, 결제·계산서는 씨마켓에서 한다.

아래 `cardSelectable`·`cardPaymentAvailable` 은 `CONTRACT_FIRST` 일 때만 뜻이 있다 — 씨마켓 결제창에 대한 답이기 때문이다. */
  paymentFlow: VendorDirectEligibilityResponseDtoPaymentFlow;
  /** **씨마켓 결제창**을 열 수 있는가(공급기업이 카드결제 가맹인가). false 여도 카드를 고를 수는 있다 — 그 경우 발주기관이 공급기업과 직접 카드로 결제한다. 카드 노출 여부는 이 값이 아니라 `cardSelectable` 로 정할 것. */
  cardPaymentAvailable: boolean;
  /** 카드를 결제수단으로 **고를 수 있는가**(발주기관이 씨마켓 회원인가). 씨마켓 회원과 일반 세모 회원은 구매 로직이 갈리므로, 미연동 발주기관에게는 카드 축이 없다. */
  cardSelectable: boolean;
  /**
   * 불가 사유(사용자 안내 문구). 사유를 밝힐 필요가 없는 경우(연동 미설정 등)는 null.
   * @nullable
   */
  reason: string | null;
  /**
   * 공고에서 고른 희망 결제수단(card/cash/undecided). 계약의 확정 채널과 비교해 안내를 띄우는 데 쓴다. null 은 기능 신설 이전 공고.
   * @nullable
   */
  requestedPaymentChannel: VendorDirectEligibilityResponseDtoRequestedPaymentChannel;
}

/**
 * 결제 상태
 */
export type DirectPaymentResponseDtoStatus =
  (typeof DirectPaymentResponseDtoStatus)[keyof typeof DirectPaymentResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DirectPaymentResponseDtoStatus = {
  APPROVED: "APPROVED",
  PENDING: "PENDING",
  FAILED: "FAILED",
} as const;

export interface DirectPaymentResponseDto {
  /** 주문번호 (Merchant Order ID) */
  moid: string;
  /** 결제 금액 */
  amount: number;
  /** 결제 상태 */
  status: DirectPaymentResponseDtoStatus;
  /** 생성 시간 */
  createdAt: string;
  /** PG 거래번호 (TID) */
  tid: string;
  /** 생성된 채팅 메시지 ID (채팅방에 즉시 렌더링용, 계약 메시지) */
  chatMessageId?: string;
  /** 생성된 계약 ID (채팅 메시지 렌더링용) */
  contractId?: string;
}

export interface DirectPaymentDto {
  /** 결제에 사용할 카드 ID */
  paymentCardId: string;
  /** 결제할 견적 응답 버전 ID */
  quoteResponseVersionId: string;
  /**
   * 할부 개월 수 (0=일시불, 2~12=할부)
   * @minimum 0
   * @maximum 12
   */
  cardQuota?: number;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
}

export interface CashPaymentResponseDto {
  /** 주문번호 (Merchant Order ID) */
  moid: string;
  /** 결제 금액 */
  amount: number;
  /** 세금 */
  taxAmount: number;
  /** 결제 상태 (현금결제는 항상 PENDING) */
  status: string;
  /** 입금 계좌(은행·계좌번호·예금주 한 줄). 같은 값이 채팅 입금 안내 카드에도 실린다 — 발주기관은 보통 그 카드를 보고 입금한다. */
  bankAccount: string;
  /** 안내 메시지 */
  message: string;
  /** 생성 시간 */
  createdAt: string;
  /** 결제 만료 시간 (3시간 후) */
  expiresAt: string;
  /** 생성된 채팅 메시지 ID (채팅방에 즉시 렌더링용) */
  chatMessageId?: string;
}

export interface CashPaymentDto {
  /** 결제할 견적 응답 버전 ID */
  quoteResponseVersionId: string;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
}

/**
 * 환불 상태
 */
export type RefundResponseDtoStatus =
  (typeof RefundResponseDtoStatus)[keyof typeof RefundResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefundResponseDtoStatus = {
  REQUESTED: "REQUESTED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
} as const;

export interface RefundResponseDto {
  /** 환불 ID */
  id: string;
  /** 결제 ID (MOID) */
  paymentTransactionId: string;
  /** 환불 상태 */
  status: RefundResponseDtoStatus;
  /** 환불 금액 (단위: 원) */
  refundAmount: number;
  /** 환불 사유 */
  refundReason: string;
  /** 환불 요청 시간 (ISO 8601) */
  requestedAt: string;
}

export interface RefundRequestDto {
  /**
   * 환불 사유
   * @maxLength 500
   */
  refundReason: string;
  /** 환불 금액 (단위: 원) */
  refundAmount: number;
  /** 환불 받을 은행명 (현금 결제 시 필수) */
  refundBank?: string;
  /** 환불 받을 계좌번호 (현금 결제 시 필수) */
  refundAccountNumber?: string;
  /** 환불 계좌 예금주 (현금 결제 시 필수) */
  refundAccountHolder?: string;
}

export interface VendorDirectPaymentResponseDto {
  /** 생성된 거래 ID (MOID) */
  moid: string;
  /** 결제 금액 */
  amount: number;
  /** 결제 상태. OFFLINE 은 즉시 APPROVED, CMARKET_CARD 는 결제 전이라 PENDING. */
  status: string;
  /** 채팅 메시지 ID */
  chatMessageId: string;
  /** 생성된 계약 ID (채팅 메시지 렌더링용) */
  contractId: string;
  /** PG 거래번호 (TID, 직접결제는 빈 문자열) */
  tid: string;
  /** 생성 시간 */
  createdAt: string;
  /** 씨마켓 결제 화면 링크 (CMARKET_CARD 전용). 발주기관을 이 주소로 보내 결제를 마치게 한다. */
  payUrl?: string;
  /** 씨마켓 결제창 번호 (CMARKET_CARD 전용). */
  cardPaymentRequestId?: string;
}

/**
 * 대금 처리 경로. 미지정 시 OFFLINE(기존 동작) — 구버전 클라이언트 호환.
 */
export type VendorDirectPaymentDtoPaymentRoute =
  (typeof VendorDirectPaymentDtoPaymentRoute)[keyof typeof VendorDirectPaymentDtoPaymentRoute];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VendorDirectPaymentDtoPaymentRoute = {
  OFFLINE: "OFFLINE",
  CMARKET_CARD: "CMARKET_CARD",
} as const;

/**
 * 업체와 직접 정리하기로 한 방식(cash/card). **기록만 하는 값이다** — 세모가 이 결제를 실행하지 않는다. 실제 결제는 업체 단말기·결제 링크·계좌이체 등 시스템 밖에서 이뤄지고, 여기에 남긴 값은 나중에 「무엇으로 정리했는지」를 아는 근거다.

OFFLINE 경로에서만 뜻이 있다. 미지정 시 cash(기존 동작).
 */
export type VendorDirectPaymentDtoSettlementChannel =
  (typeof VendorDirectPaymentDtoSettlementChannel)[keyof typeof VendorDirectPaymentDtoSettlementChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VendorDirectPaymentDtoSettlementChannel = {
  cash: "cash",
  card: "card",
} as const;

export interface VendorDirectPaymentDto {
  /** 결제를 진행할 견적 응답 버전의 ID */
  quoteResponseVersionId: string;
  /** 낙관적 UI 매칭용 임시 ID */
  tempId?: string;
  /** 대금 처리 경로. 미지정 시 OFFLINE(기존 동작) — 구버전 클라이언트 호환. */
  paymentRoute?: VendorDirectPaymentDtoPaymentRoute;
  /** 업체와 직접 정리하기로 한 방식(cash/card). **기록만 하는 값이다** — 세모가 이 결제를 실행하지 않는다. 실제 결제는 업체 단말기·결제 링크·계좌이체 등 시스템 밖에서 이뤄지고, 여기에 남긴 값은 나중에 「무엇으로 정리했는지」를 아는 근거다.

OFFLINE 경로에서만 뜻이 있다. 미지정 시 cash(기존 동작). */
  settlementChannel?: VendorDirectPaymentDtoSettlementChannel;
}

/**
 * 결제 타입 (CONTRACT | SUBSCRIPTION)
 */
export type PaymentTransactionHistoryDtoType =
  (typeof PaymentTransactionHistoryDtoType)[keyof typeof PaymentTransactionHistoryDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentTransactionHistoryDtoType = {
  CONTRACT: "CONTRACT",
  SUBSCRIPTION: "SUBSCRIPTION",
} as const;

/**
 * 결제 수단
 */
export type PaymentTransactionHistoryDtoPaymentMethod =
  (typeof PaymentTransactionHistoryDtoPaymentMethod)[keyof typeof PaymentTransactionHistoryDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentTransactionHistoryDtoPaymentMethod = {
  CARD: "CARD",
  CASH: "CASH",
  DIRECT: "DIRECT",
} as const;

/**
 * 결제 상태
 */
export type PaymentTransactionHistoryDtoStatus =
  (typeof PaymentTransactionHistoryDtoStatus)[keyof typeof PaymentTransactionHistoryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentTransactionHistoryDtoStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  FAILED: "FAILED",
  CANCELED: "CANCELED",
  EXPIRED: "EXPIRED",
} as const;

export interface PaymentTransactionHistoryDto {
  /** 결제 ID (MOID) */
  id: string;
  /** 결제 타입 (CONTRACT | SUBSCRIPTION) */
  type: PaymentTransactionHistoryDtoType;
  /** 결제 수단 */
  paymentMethod: PaymentTransactionHistoryDtoPaymentMethod;
  /**
   * 견적 응답 버전 ID
   * @nullable
   */
  quoteResponseVersionId: string | null;
  /**
   * 구독 ID (구독 결제인 경우)
   * @nullable
   */
  subscriptionId: string | null;
  /**
   * 프로젝트명 (견적 결제인 경우)
   * @nullable
   */
  projectName: string | null;
  /**
   * 공급자명 (업체명 또는 이름)
   * @nullable
   */
  supplierName: string | null;
  /** 결제 금액 */
  amount: number;
  /** 결제 상태 */
  status: PaymentTransactionHistoryDtoStatus;
  /**
   * 결제 승인 시간
   * @nullable
   */
  approvedAt: string | null;
  /** 결제 생성 시간 */
  createdAt: string;
  /**
   * 카드 ID (결제에 사용된 카드) - 현금결제 시 null
   * @nullable
   */
  paymentCardId: string | null;
  /**
   * 마스킹된 카드번호 - 현금결제 시 null
   * @nullable
   */
  maskedCardNumber: string | null;
  /**
   * 거래번호 (Innopay TID)
   * @nullable
   */
  tid: string | null;
  /**
   * 환불 ID (있을 경우)
   * @nullable
   */
  refundId: string | null;
}

/**
 * 환불 상태
 */
export type RefundHistoryDtoStatus =
  (typeof RefundHistoryDtoStatus)[keyof typeof RefundHistoryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefundHistoryDtoStatus = {
  REQUESTED: "REQUESTED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
} as const;

export interface RefundHistoryDto {
  /** 환불 ID */
  id: string;
  /** 결제 ID (MOID) */
  paymentTransactionId: string;
  /** 환불 상태 */
  status: RefundHistoryDtoStatus;
  /** 환불 금액 */
  refundAmount: number;
  /** 환불 사유 */
  refundReason: string;
  /** 환불 요청 시간 */
  requestedAt: string;
  /**
   * 환불 완료 시간
   * @nullable
   */
  completedAt: string | null;
  /**
   * 환불 실패 사유
   * @nullable
   */
  errorMessage: string | null;
}

export interface PaymentHistoryResponseDto {
  /** 결제 거래 내역 */
  transactions: PaymentTransactionHistoryDto[];
  /** 환불 내역 */
  refunds: RefundHistoryDto[];
  /** 총 결제 건수 */
  totalTransactions: number;
  /** 총 환불 건수 */
  totalRefunds: number;
  /** 총 결제 금액 */
  totalAmount: number;
  /** 총 환불 금액 */
  totalRefundAmount: number;
}

export interface CompletePaymentDto {
  /** 견적 응답 버전 ID (UUID) */
  quoteResponseVersionId: string;
  /** 구매자 ID (UUID) */
  buyerId: string;
  /** 프로젝트명 (알림 메시지에 포함) */
  projectName: string;
  /** 결제 금액 (KRW, 원) */
  amount: number;
}

export interface RegisterCardDto {
  /** 신용카드/체크카드 카드번호 13~19자리 (공백/하이픈 자동 제거, Luhn 체크섬 검증) */
  cardNum: string;
  /** 카드 유효기간 (YYMM 형식, 예: 2512 = 2025년 12월) */
  cardExpire: string;
  /** 등록자 이름 */
  buyerName: string;
  /** 카드인증 번호 (개인카드: 주민번호 앞 6자리, 법인카드: 사업자번호 10자리) */
  idNum: string;
  /** 카드 비밀번호 앞 2자리 */
  cardPwd: string;
}

export type SignupKeywordPreviewRequestDtoServiceProvincesItem =
  (typeof SignupKeywordPreviewRequestDtoServiceProvincesItem)[keyof typeof SignupKeywordPreviewRequestDtoServiceProvincesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignupKeywordPreviewRequestDtoServiceProvincesItem = {
  서울: "서울",
  부산: "부산",
  대구: "대구",
  인천: "인천",
  광주: "광주",
  대전: "대전",
  울산: "울산",
  세종: "세종",
  경기: "경기",
  강원: "강원",
  충북: "충북",
  충남: "충남",
  전북: "전북",
  전남: "전남",
  경북: "경북",
  경남: "경남",
  제주: "제주",
} as const;

export interface SignupKeywordPreviewRequestDto {
  industryKeywordCodes?: number[];
  freeKeywords?: string[];
  serviceProvinces?: SignupKeywordPreviewRequestDtoServiceProvincesItem[];
  nationwide?: boolean;
}

export interface SignupCheckRequestDto {
  /** 가입할 아이디(영소문자·숫자 6~20자) */
  userId?: string;
  /** 사업자등록번호(하이픈 무관) */
  businessNumber?: string;
}

export interface SignupVerifyBusinessRequestDto {
  businessNumber: string;
}

export interface SignupVerifyAccountRequestDto {
  /** 은행 코드 3자리 */
  bankCode: string;
  accountNumber: string;
  /** 예금주 — 비우면 은행이 준 이름을 돌려받아 칸을 채운다(씨마켓 가입과 같다) */
  accountHolder?: string;
}

export type SignupPreferencesDtoServiceProvincesItem =
  (typeof SignupPreferencesDtoServiceProvincesItem)[keyof typeof SignupPreferencesDtoServiceProvincesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignupPreferencesDtoServiceProvincesItem = {
  서울: "서울",
  부산: "부산",
  대구: "대구",
  인천: "인천",
  광주: "광주",
  대전: "대전",
  울산: "울산",
  세종: "세종",
  경기: "경기",
  강원: "강원",
  충북: "충북",
  충남: "충남",
  전북: "전북",
  전남: "전남",
  경북: "경북",
  경남: "경남",
  제주: "제주",
} as const;

/**
 * 보통 납기(일, 0~365)
 * @nullable
 */
export type SignupPreferencesDtoUsualLeadDays = {
  [key: string]: unknown;
} | null;

export type SignupPreferencesDtoNotifyChannelsItem =
  (typeof SignupPreferencesDtoNotifyChannelsItem)[keyof typeof SignupPreferencesDtoNotifyChannelsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignupPreferencesDtoNotifyChannelsItem = {
  KAKAO: "KAKAO",
  SMS: "SMS",
  EMAIL: "EMAIL",
} as const;

export interface SignupPreferencesDto {
  /** 납품·시공 가능 시·도(두 글자) */
  serviceProvinces?: SignupPreferencesDtoServiceProvincesItem[];
  /** 전국 납품·시공 */
  nationwide?: boolean;
  /**
   * 보통 납기(일, 0~365)
   * @nullable
   */
  usualLeadDays?: SignupPreferencesDtoUsualLeadDays;
  /** 맞춤 공고 알림 방법 */
  notifyChannels?: SignupPreferencesDtoNotifyChannelsItem[];
  /** 알림 받을 시각(KST 시, 0~23) */
  notifyHour?: number;
  /** 맞춤 공고·안내 수신 동의 */
  notifyConsent?: boolean;
}

export interface SignupAgreementsDto {
  service: boolean;
  privacy: boolean;
  /** 세모 이용 연계 */
  semo: boolean;
  /** 세모 정보 제공 */
  semoProvision: boolean;
  marketing: boolean;
  /** 세모 공급사 이용약관 */
  semoSupplierTerms: boolean;
  /** 6개월 뒤 월 3,300원 자동결제 */
  autoBilling: boolean;
}

export type SignupStartRequestDtoBusinessCategory =
  (typeof SignupStartRequestDtoBusinessCategory)[keyof typeof SignupStartRequestDtoBusinessCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignupStartRequestDtoBusinessCategory = {
  corporate: "corporate",
  individual: "individual",
} as const;

/**
 * 어떻게 알고 오셨나요(선택)
 */
export type SignupStartRequestDtoHeardFrom =
  (typeof SignupStartRequestDtoHeardFrom)[keyof typeof SignupStartRequestDtoHeardFrom];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignupStartRequestDtoHeardFrom = {
  CMARKET: "CMARKET",
  SEARCH: "SEARCH",
  REFERRAL: "REFERRAL",
  NOTICE: "NOTICE",
  BID_INBOX: "BID_INBOX",
  EVENT: "EVENT",
  SNS: "SNS",
  OTHER: "OTHER",
} as const;

export interface SignupStartRequestDto {
  userId: string;
  /** 8~18자(영문·숫자·!@#$%^&*) */
  password: string;
  businessCategory: SignupStartRequestDtoBusinessCategory;
  businessNumber: string;
  companyName: string;
  representativeName: string;
  businessType?: string;
  businessItem?: string;
  /** 주요 취급품목 */
  mainItems?: string;
  companyZipCode: string;
  companyAddressMain: string;
  companyAddressDetail?: string;
  regionState: string;
  regionCity: string;
  managerName: string;
  managerDepartment: string;
  managerPosition: string;
  managerPhone: string;
  /** 회사 전화 */
  managerTel: string;
  managerFax?: string;
  managerEmail: string;
  taxEmail?: string;
  bankCode: string;
  bankAccountNumber: string;
  bankAccountHolder: string;
  /** 취급 키워드 — 씨마켓 업종 키워드 코드(최대 10, GET /supplier-signup/keywords). 씨마켓 공고 알림·세모 공고함 맞춤에 쓴다 */
  industryKeywordCodes?: number[];
  /** 직접 적은 세부 취급 키워드(최대 20, 1~40자) — 세모 공고함 맞춤에만 쓴다(«니트릴 장갑») */
  freeKeywords?: string[];
  preferences?: SignupPreferencesDto;
  agreements: SignupAgreementsDto;
  /** 가입 경로 — 가입 화면으로 들어온 링크의 ref(nav·login·explore·캠페인 이름 등) */
  entryRef?: string;
  /** 어떻게 알고 오셨나요(선택) */
  heardFrom?: SignupStartRequestDtoHeardFrom;
  /** «기타» 등 직접 적은 말(100자) */
  heardFromNote?: string;
}

export type SignupCredentialRequestDtoSection =
  (typeof SignupCredentialRequestDtoSection)[keyof typeof SignupCredentialRequestDtoSection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignupCredentialRequestDtoSection = {
  LICENSE: "LICENSE",
  CERTIFICATION: "CERTIFICATION",
  IP: "IP",
  TRACK_RECORD: "TRACK_RECORD",
} as const;

/**
 * 지식재산권 종류
 */
export type SignupCredentialRequestDtoKind =
  (typeof SignupCredentialRequestDtoKind)[keyof typeof SignupCredentialRequestDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignupCredentialRequestDtoKind = {
  PATENT: "PATENT",
  UTILITY_MODEL: "UTILITY_MODEL",
  DESIGN: "DESIGN",
  TRADEMARK: "TRADEMARK",
} as const;

/**
 * 실적 구분
 */
export type SignupCredentialRequestDtoBizType =
  (typeof SignupCredentialRequestDtoBizType)[keyof typeof SignupCredentialRequestDtoBizType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignupCredentialRequestDtoBizType = {
  물품: "물품",
  공사: "공사",
  용역: "용역",
} as const;

export interface SignupCredentialRequestDto {
  section: SignupCredentialRequestDtoSection;
  /** 면허·인증서 이름 */
  name?: string;
  /** 발급기관 */
  issuer?: string;
  /** 면허·인증·등록 번호 */
  number?: string;
  /** 발급일 YYYY-MM-DD */
  issuedAt?: string;
  /** 만료일 YYYY-MM-DD */
  expiresAt?: string;
  /** 지식재산권 종류 */
  kind?: SignupCredentialRequestDtoKind;
  /** 지식재산권 명칭 · 실적 계약명 */
  title?: string;
  /** 등록일 YYYY-MM-DD */
  registeredAt?: string;
  /** 실적 구분 */
  bizType?: SignupCredentialRequestDtoBizType;
  /** 실적 발주처 */
  clientName?: string;
  /** 계약금액(원, 숫자) */
  amount?: string;
  /** 계약일 YYYY-MM-DD */
  contractedOn?: string;
  /** 완료일 YYYY-MM-DD */
  completedOn?: string;
}

export type SignupCredentialNoneRequestDtoSectionsItem =
  (typeof SignupCredentialNoneRequestDtoSectionsItem)[keyof typeof SignupCredentialNoneRequestDtoSectionsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignupCredentialNoneRequestDtoSectionsItem = {
  LICENSE: "LICENSE",
  CERTIFICATION: "CERTIFICATION",
  IP: "IP",
  TRACK_RECORD: "TRACK_RECORD",
} as const;

export interface SignupCredentialNoneRequestDto {
  /** «해당 없음» 칸 전체 목록(보낸 목록으로 바꾼다) */
  sections: SignupCredentialNoneRequestDtoSectionsItem[];
}

export interface SignupPayRequestDto {
  /** 카드번호(숫자만, 저장하지 않는다) */
  cardNumber: string;
  /** 유효기간 YYMM */
  expiry: string;
  /** 비밀번호 앞 2자리 */
  password2: string;
  /** 생년월일 6자리(개인카드) 또는 사업자번호 10자리(법인카드) */
  idNumber: string;
  /** 카드 소유자 이름 */
  holderName: string;
}

export interface AdminResolvePaidDto {
  /** 메모(관리자·시각과 함께 맨 위에 쌓인다) */
  note: string;
  /** 이노페이 거래번호(TID) — 이노페이 관리자 내역에서 확인 */
  innopayTid: string;
}

export interface AdminNoteDto {
  note?: string;
}

export interface AdminReasonDto {
  reason: string;
}

export interface AdminExtendTrialDto {
  /** 사유 */
  reason: string;
  /** 연장 일수(1~366) */
  days: number;
}

export interface AdminResolveChargeDto {
  /** 메모(관리자·시각과 함께 맨 위에 쌓인다) */
  note: string;
  /** true = 이노페이에 승인 있음(받음) · false = 안 받음 */
  paid: boolean;
  /** 받음이면 이노페이 거래번호(TID) */
  innopayTid?: string;
}

export type TemplateAttributeDtoDataType =
  (typeof TemplateAttributeDtoDataType)[keyof typeof TemplateAttributeDtoDataType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TemplateAttributeDtoDataType = {
  ENUM: "ENUM",
  NUMBER: "NUMBER",
  TEXT: "TEXT",
  BOOLEAN: "BOOLEAN",
} as const;

export type TemplateAttributeDtoScope =
  (typeof TemplateAttributeDtoScope)[keyof typeof TemplateAttributeDtoScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TemplateAttributeDtoScope = {
  ITEM: "ITEM",
  REQUEST: "REQUEST",
} as const;

export type TemplateAttributeDtoRole =
  (typeof TemplateAttributeDtoRole)[keyof typeof TemplateAttributeDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TemplateAttributeDtoRole = {
  IDENTIFY: "IDENTIFY",
  CHOOSE: "CHOOSE",
  CONDITION: "CONDITION",
  DOCUMENT: "DOCUMENT",
} as const;

export type TemplateAttributeDtoValueList =
  (typeof TemplateAttributeDtoValueList)[keyof typeof TemplateAttributeDtoValueList];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TemplateAttributeDtoValueList = {
  CLOSED: "CLOSED",
  SUGGESTED: "SUGGESTED",
  FREE: "FREE",
} as const;

export interface TemplateAttributeDto {
  key: string;
  name: string;
  dataType: TemplateAttributeDtoDataType;
  /** @nullable */
  unit?: string | null;
  scope: TemplateAttributeDtoScope;
  role: TemplateAttributeDtoRole;
  quoteRequired: boolean;
  /** @nullable */
  question?: string | null;
  /** @nullable */
  hint?: string | null;
  allowAny: boolean;
  valueList: TemplateAttributeDtoValueList;
  values: string[];
}

export type ProductClassTemplateDtoTemplateStatus =
  (typeof ProductClassTemplateDtoTemplateStatus)[keyof typeof ProductClassTemplateDtoTemplateStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductClassTemplateDtoTemplateStatus = {
  NONE: "NONE",
  DRAFT: "DRAFT",
  CONFIRMED: "CONFIRMED",
} as const;

export interface ProductClassTemplateDto {
  key: string;
  name: string;
  modelRequired: boolean;
  equivalentDefault: boolean;
  templateStatus: ProductClassTemplateDtoTemplateStatus;
  lexiconCatIds: string[];
  attributes: TemplateAttributeDto[];
}

/**
 * @nullable
 */
export type ResolveProductClassResponseDtoProductClass =
  ProductClassTemplateDto | null;

export interface ResolveProductClassResponseDto {
  /** @nullable */
  productClass?: ResolveProductClassResponseDtoProductClass;
}

export interface AdminBackfillRequestDto {
  /** 이 물품 id 다음부터(앞 쪽의 nextCursor) */
  afterId?: string;
  /** 한 번에 볼 물품 수(최대 500) */
  limit?: number;
}

/**
 * PICK 이 물품이 맞음(나머지 거절) · CONFIRM 확증으로 올림 · REJECT 거절(itemId 없으면 번호 전체) · MERGE_SUGGEST 병합 후보로 · MERGE 물품 병합 뒤 남긴 물품으로 옮김
 */
export type ResolveBarcodeClaimDtoAction =
  (typeof ResolveBarcodeClaimDtoAction)[keyof typeof ResolveBarcodeClaimDtoAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResolveBarcodeClaimDtoAction = {
  PICK: "PICK",
  CONFIRM: "CONFIRM",
  REJECT: "REJECT",
  MERGE_SUGGEST: "MERGE_SUGGEST",
  MERGE: "MERGE",
} as const;

export interface ResolveBarcodeClaimDto {
  /** PICK 이 물품이 맞음(나머지 거절) · CONFIRM 확증으로 올림 · REJECT 거절(itemId 없으면 번호 전체) · MERGE_SUGGEST 병합 후보로 · MERGE 물품 병합 뒤 남긴 물품으로 옮김 */
  action: ResolveBarcodeClaimDtoAction;
  itemId?: string;
  /** @maxLength 500 */
  note?: string;
}

/**
 * 판정
 */
export type VerifySupplierCredentialRequestDtoStatus =
  (typeof VerifySupplierCredentialRequestDtoStatus)[keyof typeof VerifySupplierCredentialRequestDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VerifySupplierCredentialRequestDtoStatus = {
  VERIFIED: "VERIFIED",
  REJECTED: "REJECTED",
} as const;

export interface VerifySupplierCredentialRequestDto {
  /** 판정 */
  status: VerifySupplierCredentialRequestDtoStatus;
  /** 반려 사유(REJECTED 때) */
  rejectionReason?: string;
}

export interface ReplaceMyKeywordsRequestDto {
  /** 씨마켓 업종 키워드 코드(최대 10, GET /supplier-signup/keywords) */
  codes: number[];
  /** 직접 적은 세부 키워드(최대 20, 1~40자) */
  free: string[];
}

export type SaveMyPreferencesRequestDtoNotifyChannelsItem =
  (typeof SaveMyPreferencesRequestDtoNotifyChannelsItem)[keyof typeof SaveMyPreferencesRequestDtoNotifyChannelsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SaveMyPreferencesRequestDtoNotifyChannelsItem = {
  KAKAO: "KAKAO",
  SMS: "SMS",
  EMAIL: "EMAIL",
} as const;

export interface SaveMyPreferencesRequestDto {
  /** 납품·시공 가능 시·도(두 글자 키 — 서울·부산·…·제주) */
  serviceProvinces: string[];
  /** 전국 납품·시공 */
  nationwide: boolean;
  /**
   * 보통 납기(일, 0~365). 모르면 null
   * @nullable
   */
  usualLeadDays?: number | null;
  /** 맞춤 공고 알림 방법 */
  notifyChannels: SaveMyPreferencesRequestDtoNotifyChannelsItem[];
  /** 알림 받을 시각(KST 0~23시) */
  notifyHour: number;
  /** 매일 아침 맞춤 공고 요약 받기 */
  digestEnabled: boolean;
  /** 맞춤 공고·안내 수신 동의(끄면 판매자 센터 알림함으로만) */
  notifyConsent: boolean;
}

export type CreateMyHelpRequestDtoReason =
  (typeof CreateMyHelpRequestDtoReason)[keyof typeof CreateMyHelpRequestDtoReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateMyHelpRequestDtoReason = {
  ZERO_MATCH: "ZERO_MATCH",
  FIRST_BID: "FIRST_BID",
  OTHER: "OTHER",
} as const;

/**
 * 화면 맥락(공고 키·키워드 수 등 — 작게만 남긴다)
 */
export type CreateMyHelpRequestDtoContext = { [key: string]: unknown };

export interface CreateMyHelpRequestDto {
  reason: CreateMyHelpRequestDtoReason;
  /** 남길 말(1,000자) */
  message?: string;
  /** 화면 맥락(공고 키·키워드 수 등 — 작게만 남긴다) */
  context?: CreateMyHelpRequestDtoContext;
}

export type AdminHelpRequestStatusDtoStatus =
  (typeof AdminHelpRequestStatusDtoStatus)[keyof typeof AdminHelpRequestStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminHelpRequestStatusDtoStatus = {
  DONE: "DONE",
  OPEN: "OPEN",
} as const;

export interface AdminHelpRequestStatusDto {
  status: AdminHelpRequestStatusDtoStatus;
  /** 처리 메모(500자) */
  adminNote?: string;
}

/**
 * Subscription plan type
 */
export type CreateSubscriptionDtoPlanType =
  (typeof CreateSubscriptionDtoPlanType)[keyof typeof CreateSubscriptionDtoPlanType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSubscriptionDtoPlanType = {
  FREE: "FREE",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
  TEST: "TEST",
} as const;

export interface CreateSubscriptionDto {
  /** Subscription plan type */
  planType: CreateSubscriptionDtoPlanType;
  /** Payment card ID (must be registered in payment module) */
  paymentCardId: string;
}

/**
 * Payment status
 */
export type SubscriptionPaymentResponseDtoStatus =
  (typeof SubscriptionPaymentResponseDtoStatus)[keyof typeof SubscriptionPaymentResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionPaymentResponseDtoStatus = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
} as const;

export interface SubscriptionPaymentResponseDto {
  /** Payment record ID */
  id: string;
  /** Subscription ID */
  subscriptionId: string;
  /** Payment amount in KRW */
  amount: number;
  /** Payment status */
  status: SubscriptionPaymentResponseDtoStatus;
  /**
   * Innopay transaction ID (TID)
   * @nullable
   */
  innopayTid: string | null;
  /**
   * Error message if payment failed
   * @nullable
   */
  errorMessage: string | null;
  /**
   * Paid at timestamp
   * @nullable
   */
  paidAt: string | null;
  /** Created at timestamp */
  createdAt: string;
}

/**
 * New subscription plan type
 */
export type ChangeSubscriptionPlanDtoNewPlanType =
  (typeof ChangeSubscriptionPlanDtoNewPlanType)[keyof typeof ChangeSubscriptionPlanDtoNewPlanType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangeSubscriptionPlanDtoNewPlanType = {
  FREE: "FREE",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
  TEST: "TEST",
} as const;

export interface ChangeSubscriptionPlanDto {
  /** New subscription plan type */
  newPlanType: ChangeSubscriptionPlanDtoNewPlanType;
  /** Payment card ID (required when upgrading from FREE to paid plan) */
  paymentCardId?: string;
}

export interface CancelSubscriptionDto {
  /** 구독 취소 사유 */
  reason?: string;
}

export interface PromotionRedemptionResponseDto {
  /** Success status */
  success: boolean;
  /** Result message */
  message: string;
  /** Extended plan expiration date */
  newExpirationDate?: string;
}

export interface RedeemPromotionDto {
  /** Promotion Code */
  code: string;
}

/**
 * 알람 타입
 */
export type NotificationResponseDtoType =
  (typeof NotificationResponseDtoType)[keyof typeof NotificationResponseDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationResponseDtoType = {
  quote_request_created: "quote_request_created",
  quote_response_received: "quote_response_received",
  quote_deadline_approaching: "quote_deadline_approaching",
  quote_reaction_viewed: "quote_reaction_viewed",
  quote_reaction_composing: "quote_reaction_composing",
  quote_reaction_read: "quote_reaction_read",
  quote_reaction_starred: "quote_reaction_starred",
  quote_reaction_result: "quote_reaction_result",
  payment_received: "payment_received",
  payment_expired: "payment_expired",
  cancellation_requested: "cancellation_requested",
  contract_cancellation_approved: "contract_cancellation_approved",
  refund_completed: "refund_completed",
  supplier_selected: "supplier_selected",
  contract_completed: "contract_completed",
  purchase_confirmed: "purchase_confirmed",
  contract_documents_ready: "contract_documents_ready",
  contract_restriction_flagged: "contract_restriction_flagged",
  contract_documents_pending: "contract_documents_pending",
  contract_shipped: "contract_shipped",
  mall_order_assigned: "mall_order_assigned",
  mall_subscription_payment_failed: "mall_subscription_payment_failed",
  mall_wish_price_drop: "mall_wish_price_drop",
  mall_wish_restock: "mall_wish_restock",
  mall_review_helpful: "mall_review_helpful",
  cmarket_bid_matched: "cmarket_bid_matched",
  shipment_registered: "shipment_registered",
  shipment_out_for_delivery: "shipment_out_for_delivery",
  shipment_delivered: "shipment_delivered",
  shipment_exception: "shipment_exception",
  shipment_auto_receive_due: "shipment_auto_receive_due",
  shipment_received: "shipment_received",
  shipment_canceled: "shipment_canceled",
  shipment_stale: "shipment_stale",
  shipment_disputed: "shipment_disputed",
  shipment_dispute_resolved: "shipment_dispute_resolved",
  excel_register_done: "excel_register_done",
  excel_register_rejected: "excel_register_rejected",
  item_request_rejected: "item_request_rejected",
  engagement_digest: "engagement_digest",
  gcm_buyer_wave: "gcm_buyer_wave",
  review_requested: "review_requested",
  review_completed: "review_completed",
  new_message_received: "new_message_received",
  chat_message_unanswered: "chat_message_unanswered",
  chat_reply_delayed: "chat_reply_delayed",
  user_signed_up: "user_signed_up",
  subscription_upgraded: "subscription_upgraded",
  subscription_payment_success: "subscription_payment_success",
  subscription_payment_failed: "subscription_payment_failed",
  subscription_expiring_soon: "subscription_expiring_soon",
} as const;

/**
 * 알람 카테고리
 */
export type NotificationResponseDtoCategory =
  (typeof NotificationResponseDtoCategory)[keyof typeof NotificationResponseDtoCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationResponseDtoCategory = {
  system: "system",
  project: "project",
  chat: "chat",
  payment: "payment",
  review: "review",
} as const;

/**
 * 내부 메타데이터
 */
export type NotificationResponseDtoMetadata = { [key: string]: unknown };

export interface NotificationResponseDto {
  /** 알람 ID */
  id: string;
  /** 알람 타입 */
  type: NotificationResponseDtoType;
  /** 알람 카테고리 */
  category: NotificationResponseDtoCategory;
  /** 알람 제목 */
  title: string;
  /** 알람 메시지 */
  message: string;
  /** 연결된 리소스 ID */
  resourceId?: string;
  /** Resource type for frontend navigation (quote_request, quote_response, chat_room, etc.) */
  resourceType?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽음 처리 시각 (ISO 8601) */
  readAt?: string;
  /** 알람 생성 시각 (ISO 8601) */
  createdAt: string;
  /** 내부 메타데이터 */
  metadata?: NotificationResponseDtoMetadata;
}

export interface UnreadCountResponseDto {
  /** 읽지 않은 알람 총 개수 (시스템 + 채팅) */
  count: number;
  /** 읽지 않은 시스템 알림 개수 */
  notificationCount: number;
  /** 읽지 않은 채팅 메시지 개수 */
  chatCount: number;
}

export interface MarkAllReadResponseDto {
  /** 처리 성공 여부 */
  success: boolean;
  /** 처리 메시지 */
  message: string;
}

export interface MarkAllNotificationsReadBodyDto {
  [key: string]: unknown;
}

export interface SubscriptionUserDto {
  /** 사용자 ID (public.users.id) */
  id: string;
  /** 읽지 않은 알림 개수 */
  unreadCount: number;
}

export interface RealtimeConnectionInfoDto {
  /** 연결 제공자 */
  provider: string;
  /** Supabase 프로젝트 참조 (선택) */
  projectRef?: string;
}

/**
 * 채널 타입
 */
export type RealtimeChannelDtoType =
  (typeof RealtimeChannelDtoType)[keyof typeof RealtimeChannelDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RealtimeChannelDtoType = {
  realtime: "realtime",
} as const;

export interface RealtimeChannelDto {
  /** 채널 타입 */
  type: RealtimeChannelDtoType;
  /** Supabase Realtime 채널명 */
  channelName: string;
  /** 수신 가능한 이벤트 목록 */
  events: string[];
  /** 연결 정보 */
  connectionInfo: RealtimeConnectionInfoDto;
}

export interface SubscriptionSettingsDto {
  /** 시스템 알림 활성화 (공지사항, 점검 등) */
  system: boolean;
  /** 프로젝트 알림 활성화 */
  project: boolean;
  /** 채팅 알림 활성화 */
  chat: boolean;
  /** 결제 알림 활성화 */
  payment: boolean;
  /** 리뷰 알림 활성화 */
  review: boolean;
  /** 설정 마지막 수정일 (ISO 8601) */
  updatedAt: string;
}

export interface SubscriptionMetaDto {
  /** 서버 시간 (ISO 8601) */
  serverTime: string;
  /** 캐시 권장 시간 (초) */
  ttlSeconds: number;
}

export interface NotificationSubscriptionInfoResponseDto {
  /** API 버전 */
  apiVersion: string;
  /** 사용자 정보 */
  user: SubscriptionUserDto;
  /** 구독 채널 목록 (현재 realtime만 지원, 향후 email/kakao/webhook 확장 가능) */
  channels: RealtimeChannelDto[];
  /** 카테고리별 알림 설정 (user_notification_settings 테이블 기반) */
  settings: SubscriptionSettingsDto;
  /** 메타 정보 */
  meta: SubscriptionMetaDto;
}

export interface PushSubscriptionKeysDto {
  p256dh: string;
  auth: string;
}

export interface PushSubscriptionDto {
  endpoint: string;
  keys: PushSubscriptionKeysDto;
  /** @nullable */
  expirationTime?: number | null;
}

export interface PushUnsubscribeDto {
  endpoint: string;
}

export interface WorkMatchRelatedTypeDto {
  /** 공사 유형 enum 값 */
  type: string;
  label: string;
  /** 요청 내용에서 찾은 낱말(근거) */
  keyword: string;
}

export interface WorkMatchCountsDto {
  /** 자격 맞는 업체 전체 */
  total: number;
  /** 같은 시·도 */
  sameProvince: number;
  /** 같은 시·군·구 */
  sameCity: number;
  /** 현장 주소를 알아 지역별로 셌나 */
  hasRegion: boolean;
  /** 실제 «바로 업체 찾기» 문턱(신뢰도 상위 30% 또는 그 유형 낙찰 1건 · 알림 받을 수 있는 계정)을 넘는 곳 — 전체 (2026-10-17) */
  eligible: number;
  /** 문턱을 넘는 곳 — 같은 시·도 */
  eligibleSameProvince: number;
  /** 문턱을 넘는 곳 — 같은 시·군·구 */
  eligibleSameCity: number;
}

/**
 * CERT=검증 면허·인증 · TEXT=사업자등록 업태·종목 기재 · ANY=면허 불문 유형의 검증 면허 보유
 */
export type WorkMatchNearbyDtoBasis =
  (typeof WorkMatchNearbyDtoBasis)[keyof typeof WorkMatchNearbyDtoBasis];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkMatchNearbyDtoBasis = {
  CERT: "CERT",
  TEXT: "TEXT",
  ANY: "ANY",
} as const;

export interface WorkMatchNearbyDto {
  /** @nullable */
  province: string | null;
  /** @nullable */
  city: string | null;
  /** CERT=검증 면허·인증 · TEXT=사업자등록 업태·종목 기재 · ANY=면허 불문 유형의 검증 면허 보유 */
  basis: WorkMatchNearbyDtoBasis;
}

export type WorkMatchPreviewDtoBizType =
  (typeof WorkMatchPreviewDtoBizType)[keyof typeof WorkMatchPreviewDtoBizType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkMatchPreviewDtoBizType = {
  공사: "공사",
  용역: "용역",
} as const;

export interface WorkMatchPreviewDto {
  bizType: WorkMatchPreviewDtoBizType;
  /** @nullable */
  type: string | null;
  /** @nullable */
  label: string | null;
  /** 자격으로 업체를 좁힐 수 있나 */
  qualifiable: boolean;
  /** 면허를 가리지 않는 공사 유형 */
  anyLicense: boolean;
  related: WorkMatchRelatedTypeDto[];
  counts: WorkMatchCountsDto;
  /** 가까운 순 몇 곳(회사 이름 없음) — 실제 «바로 업체 찾기» 와 같은 문턱·순서(같은 구 > 같은 시·도 > 이웃 시·도 > 그 밖) */
  nearby: WorkMatchNearbyDto[];
  /** «바로 업체 찾기» 버튼을 그릴지 — 자동 매칭 스위치(WORK_AUTO_MATCH_ENABLED)가 켜져 있나 */
  quickMatchAvailable: boolean;
}

export type WorkMatchPreviewRequestDtoCategoryType =
  (typeof WorkMatchPreviewRequestDtoCategoryType)[keyof typeof WorkMatchPreviewRequestDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkMatchPreviewRequestDtoCategoryType = {
  construction: "construction",
  manufacturing: "manufacturing",
} as const;

/**
 * 공사 유형 enum 값
 * @maxLength 64
 */
export type WorkMatchPreviewRequestDtoConstructionType = {
  [key: string]: unknown;
};

/**
 * 용역 유형(한글 이름)
 * @maxLength 50
 */
export type WorkMatchPreviewRequestDtoServiceType = { [key: string]: unknown };

/**
 * @maxLength 200
 */
export type WorkMatchPreviewRequestDtoProjectName = { [key: string]: unknown };

/**
 * 요청 내용(앞 5,000자만 본다)
 */
export type WorkMatchPreviewRequestDtoDescription = { [key: string]: unknown };

/**
 * 현장 시·도(주소의 province)
 * @maxLength 30
 */
export type WorkMatchPreviewRequestDtoProvince = { [key: string]: unknown };

/**
 * 현장 시·군·구(주소의 city)
 * @maxLength 40
 */
export type WorkMatchPreviewRequestDtoCity = { [key: string]: unknown };

export interface WorkMatchPreviewRequestDto {
  categoryType: WorkMatchPreviewRequestDtoCategoryType;
  /**
   * 공사 유형 enum 값
   * @maxLength 64
   */
  constructionType?: WorkMatchPreviewRequestDtoConstructionType;
  /**
   * 용역 유형(한글 이름)
   * @maxLength 50
   */
  serviceType?: WorkMatchPreviewRequestDtoServiceType;
  /** @maxLength 200 */
  projectName?: WorkMatchPreviewRequestDtoProjectName;
  /** 요청 내용(앞 5,000자만 본다) */
  description?: WorkMatchPreviewRequestDtoDescription;
  /**
   * 현장 시·도(주소의 province)
   * @maxLength 30
   */
  province?: WorkMatchPreviewRequestDtoProvince;
  /**
   * 현장 시·군·구(주소의 city)
   * @maxLength 40
   */
  city?: WorkMatchPreviewRequestDtoCity;
}

export type CmarketAiBidCandidateDtoKind =
  (typeof CmarketAiBidCandidateDtoKind)[keyof typeof CmarketAiBidCandidateDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketAiBidCandidateDtoKind = {
  construction: "construction",
  service: "service",
} as const;

export interface CmarketAiBidCandidateDto {
  /** 공사: ConstructionTypeEnum 값 · 용역: 용역 유형 이름 */
  type: string;
  label: string;
  kind: CmarketAiBidCandidateDtoKind;
  score: number;
  /** 제목에서 맞은 낱말(근거) */
  keywords: string[];
}

/**
 * CERT=검증 면허·인증 · TEXT=업종 글자 · ANY=면허 불문
 */
export type CmarketAiBidNearbyDtoBasis =
  (typeof CmarketAiBidNearbyDtoBasis)[keyof typeof CmarketAiBidNearbyDtoBasis];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketAiBidNearbyDtoBasis = {
  CERT: "CERT",
  TEXT: "TEXT",
  ANY: "ANY",
} as const;

export interface CmarketAiBidNearbyDto {
  /** @nullable */
  province: string | null;
  /** @nullable */
  city: string | null;
  /** CERT=검증 면허·인증 · TEXT=업종 글자 · ANY=면허 불문 */
  basis: CmarketAiBidNearbyDtoBasis;
}

export type CmarketAiBidPreviewDtoBizType =
  (typeof CmarketAiBidPreviewDtoBizType)[keyof typeof CmarketAiBidPreviewDtoBizType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketAiBidPreviewDtoBizType = {
  공사: "공사",
  용역: "용역",
} as const;

export interface CmarketAiBidPreviewDto {
  bizType: CmarketAiBidPreviewDtoBizType;
  /** @nullable */
  type: string | null;
  /** @nullable */
  label: string | null;
  qualifiable: boolean;
  anyLicense: boolean;
  related: WorkMatchRelatedTypeDto[];
  counts: WorkMatchCountsDto;
  nearby: CmarketAiBidNearbyDto[];
  /** «바로 업체 찾기» 스위치(WORK_AUTO_MATCH_ENABLED) */
  quickMatchAvailable: boolean;
}

export type CmarketAiBidCodeDtoSystem =
  (typeof CmarketAiBidCodeDtoSystem)[keyof typeof CmarketAiBidCodeDtoSystem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketAiBidCodeDtoSystem = {
  세부공종: "세부공종",
  세부품명번호: "세부품명번호",
} as const;

export interface CmarketAiBidCodeDto {
  system: CmarketAiBidCodeDtoSystem;
  /** 공사구분 또는 «용역» */
  group: string;
  code: string;
  name: string;
}

/**
 * @nullable
 */
export type CmarketAiBidWorkResponseDtoKind =
  | (typeof CmarketAiBidWorkResponseDtoKind)[keyof typeof CmarketAiBidWorkResponseDtoKind]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketAiBidWorkResponseDtoKind = {
  construction: "construction",
  service: "service",
} as const;

/**
 * 자격 맞는 업체 수 — 회사 이름 없음
 * @nullable
 */
export type CmarketAiBidWorkResponseDtoPreview = CmarketAiBidPreviewDto | null;

export interface CmarketAiBidWorkResponseDto {
  /** @nullable */
  kind: CmarketAiBidWorkResponseDtoKind;
  /** 종목 후보(최대 3, 점수순) */
  candidates: CmarketAiBidCandidateDto[];
  /**
   * 자격 맞는 업체 수 — 회사 이름 없음
   * @nullable
   */
  preview: CmarketAiBidWorkResponseDtoPreview;
  /** 조달청 표준 코드(없으면 빈 배열) */
  codes: CmarketAiBidCodeDto[];
}

/**
 * 공고 내용·과업 설명(앞 5,000자만 본다)
 */
export type CmarketAiBidWorkRequestDtoDescription = { [key: string]: unknown };

/**
 * 씨마켓에서 고른 갈래. 비우면 제목으로 판정
 */
export type CmarketAiBidWorkRequestDtoKind =
  (typeof CmarketAiBidWorkRequestDtoKind)[keyof typeof CmarketAiBidWorkRequestDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketAiBidWorkRequestDtoKind = {
  construction: "construction",
  service: "service",
} as const;

/**
 * 현장 시·도
 * @maxLength 30
 */
export type CmarketAiBidWorkRequestDtoProvince = { [key: string]: unknown };

/**
 * 현장 시·군·구
 * @maxLength 40
 */
export type CmarketAiBidWorkRequestDtoCity = { [key: string]: unknown };

export interface CmarketAiBidWorkRequestDto {
  /**
   * 공고명(200자까지 사용)
   * @maxLength 200
   */
  title: string;
  /** 공고 내용·과업 설명(앞 5,000자만 본다) */
  description?: CmarketAiBidWorkRequestDtoDescription;
  /** 씨마켓에서 고른 갈래. 비우면 제목으로 판정 */
  kind?: CmarketAiBidWorkRequestDtoKind;
  /**
   * 현장 시·도
   * @maxLength 30
   */
  province?: CmarketAiBidWorkRequestDtoProvince;
  /**
   * 현장 시·군·구
   * @maxLength 40
   */
  city?: CmarketAiBidWorkRequestDtoCity;
}

/**
 * 카테고리
 */
export type ActivityLogResponseDtoCategory =
  (typeof ActivityLogResponseDtoCategory)[keyof typeof ActivityLogResponseDtoCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityLogResponseDtoCategory = {
  auth: "auth",
  quote: "quote",
  chat: "chat",
  profile: "profile",
  payment: "payment",
  contract: "contract",
  security: "security",
  promotion: "promotion",
} as const;

/**
 * 추가 메타데이터
 */
export type ActivityLogResponseDtoMetadata = { [key: string]: unknown };

export interface ActivityLogResponseDto {
  /** 로그 ID */
  id: string;
  /** 카테고리 */
  category: ActivityLogResponseDtoCategory;
  /** 액션 타입 */
  action: string;
  /** 액션 한글 라벨 */
  actionLabel: string;
  /** 리소스 타입 */
  resourceType?: string;
  /** 리소스 ID */
  resourceId?: string;
  /** 추가 메타데이터 */
  metadata?: ActivityLogResponseDtoMetadata;
  /** 생성 시간 */
  createdAt: string;
}

export interface ReviewResponseDto {
  /** 리뷰 ID */
  id: string;
  /** 계약 ID */
  contractId: string;
  /** 리뷰 작성자 ID (구매자) */
  reviewerId: string;
  /** 리뷰 대상 ID (공급업체) */
  revieweeId: string;
  /** 좋은 점 태그 */
  positiveAspects: string[];
  /** 아쉬운 점 태그 */
  negativeAspects: string[];
  /** 상세 후기 */
  detailedReview: string;
  /**
   * 계산된 평점 (1-5)
   * @minimum 1
   * @maximum 5
   */
  calculatedRating: number;
  /** 작성 일시 */
  createdAt: string;
}

export interface SupplierReviewStatsDto {
  /** 공급업체 ID */
  supplierId: string;
  /**
   * 총 리뷰 수
   * @minimum 0
   */
  totalReviews: number;
  /**
   * 평균 평점 (1-5, 소수점 2자리)
   * @minimum 0
   * @maximum 5
   */
  averageRating: number;
  /**
   * 긍정 리뷰 수 (평점 4-5)
   * @minimum 0
   */
  positiveReviewCount: number;
  /**
   * 부정 리뷰 수 (평점 1-2)
   * @minimum 0
   */
  negativeReviewCount: number;
  /**
   * 최근 리뷰 작성 일시
   * @nullable
   */
  latestReviewDate: string | null;
}

export interface QuoteLineMatchRequestDto {
  /** 매칭할 줄(최대 100) */
  lines: QuoteLineMatchInputDto[];
  /** 줄당 후보 수(기본 3, 최대 10) */
  limit?: number;
  /** 요청 category_type(product·used·manufacturing·construction). kind 판정에 쓴다. */
  categoryType?: string;
}

export interface ExcelRegisterSubmitResultDto {
  batchId: string;
  /** 자동 매칭으로 넘어간 줄 */
  queued: number;
  /** 품목ID 로 바로 단가가 등록된 줄 */
  direct: number;
  directErrors: number;
  /** 같은 물품이 되풀이돼 뺀 행 */
  duplicateRows: number[];
}

/**
 * 세모 물품 id — 내려받은 단가표의 품목ID
 */
export type ExcelRegisterRowDtoItemId = { [key: string]: unknown };

/**
 * 상품명 — 품목ID 가 없으면 필수
 */
export type ExcelRegisterRowDtoName = { [key: string]: unknown };

export type ExcelRegisterRowDtoBrand = { [key: string]: unknown };

export type ExcelRegisterRowDtoManufacturer = { [key: string]: unknown };

export type ExcelRegisterRowDtoSpec1 = { [key: string]: unknown };

export type ExcelRegisterRowDtoSpec2 = { [key: string]: unknown };

/**
 * 포장상태
 */
export type ExcelRegisterRowDtoSpec3 = { [key: string]: unknown };

export type ExcelRegisterRowDtoUnit = { [key: string]: unknown };

export interface ExcelRegisterRowDto {
  /** 엑셀 행 번호(결과 안내용) */
  rowNo: number;
  /** 세모 물품 id — 내려받은 단가표의 품목ID */
  itemId?: ExcelRegisterRowDtoItemId;
  /** 상품명 — 품목ID 가 없으면 필수 */
  name?: ExcelRegisterRowDtoName;
  brand?: ExcelRegisterRowDtoBrand;
  manufacturer?: ExcelRegisterRowDtoManufacturer;
  spec1?: ExcelRegisterRowDtoSpec1;
  spec2?: ExcelRegisterRowDtoSpec2;
  /** 포장상태 */
  spec3?: ExcelRegisterRowDtoSpec3;
  unit?: ExcelRegisterRowDtoUnit;
  /** 내 단가(공급가액, 원) */
  unitPrice: number;
}

/**
 * 올린 파일 이름
 */
export type ExcelRegisterSubmitDtoFileName = { [key: string]: unknown };

/**
 * 큰 파일을 나눠 보낼 때 — 첫 조각이 받은 묶음 id
 */
export type ExcelRegisterSubmitDtoBatchId = { [key: string]: unknown };

export interface ExcelRegisterSubmitDto {
  /** 올린 파일 이름 */
  fileName?: ExcelRegisterSubmitDtoFileName;
  /** 큰 파일을 나눠 보낼 때 — 첫 조각이 받은 묶음 id */
  batchId?: ExcelRegisterSubmitDtoBatchId;
  /** 한 번에 최대 1000줄 */
  rows: ExcelRegisterRowDto[];
}

export interface ExcelBatchCountsDto {
  total: number;
  /** 아직 자동 매칭 전 */
  matching: number;
  /** 관리자 처리 전(매칭 전 포함) */
  pending: number;
  approved: number;
  rejected: number;
  needsInfo: number;
}

export type ExcelBatchViewDtoStatus =
  (typeof ExcelBatchViewDtoStatus)[keyof typeof ExcelBatchViewDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExcelBatchViewDtoStatus = {
  matching: "matching",
  ready: "ready",
  done: "done",
} as const;

export interface ExcelBatchViewDto {
  id: string;
  /** @nullable */
  fileName: string | null;
  createdAt: string;
  status: ExcelBatchViewDtoStatus;
  directRows: number;
  counts: ExcelBatchCountsDto;
}

/**
 * 품목ID
 * @nullable
 */
export type SupplierPriceUploadErrorDtoItemId = {
  [key: string]: unknown;
} | null;

export interface SupplierPriceUploadErrorDto {
  /** 엑셀 행 번호(헤더가 1행). 0 이면 행을 특정할 수 없는 오류다. */
  row: number;
  /**
   * 품목ID
   * @nullable
   */
  itemId: SupplierPriceUploadErrorDtoItemId;
  /** 사유 */
  reason: string;
}

export interface SupplierPriceBulkUploadResultDto {
  /** 공급사명 */
  supplierName: string;
  /** 파일의 데이터 행 수 */
  totalRows: number;
  /** 새로 등록된 단가 수 */
  createdCount: number;
  /** 기존 단가를 덮어쓴 수 */
  updatedCount: number;
  /** 신규단가가 비어 있어 손대지 않은 행 수(취급하지 않는 품목) */
  skippedCount: number;
  /** 오류로 빠진 행 수 */
  errorCount: number;
  /** 오류 목록(최대 100건) */
  errors: SupplierPriceUploadErrorDto[];
}

/**
 * EXCEL(엑셀 업로드) · AUDIT_SHEET(단가 점검 시트 반영) · CMARKET_PROPOSAL(씨마켓 최신 응찰가 제안 반영). 되돌리기는 종류를 가리지 않는다.
 */
export type SupplierPriceUploadBatchDtoKind =
  (typeof SupplierPriceUploadBatchDtoKind)[keyof typeof SupplierPriceUploadBatchDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierPriceUploadBatchDtoKind = {
  EXCEL: "EXCEL",
  AUDIT_SHEET: "AUDIT_SHEET",
  CMARKET_PROPOSAL: "CMARKET_PROPOSAL",
} as const;

export interface SupplierPriceUploadBatchDto {
  id: string;
  /** EXCEL(엑셀 업로드) · AUDIT_SHEET(단가 점검 시트 반영) · CMARKET_PROPOSAL(씨마켓 최신 응찰가 제안 반영). 되돌리기는 종류를 가리지 않는다. */
  kind: SupplierPriceUploadBatchDtoKind;
  /** @nullable */
  fileName: string | null;
  rowCount: number;
  createdCount: number;
  updatedCount: number;
  errorCount: number;
  createdAt: string;
  /**
   * 되돌린 시각. null 이면 아직 되돌리지 않음
   * @nullable
   */
  undoneAt: string | null;
  /** @nullable */
  undoneCount: number | null;
}

export interface SupplierPriceUndoResultDto {
  batchId: string;
  /** 복원된 행 수(등재 취소 포함) */
  restoredCount: number;
  /** 업로드 뒤 다른 경로로 바뀌어 건드리지 않은 품목 수 */
  skippedCount: number;
  /** 건너뛴 품목 ID */
  skippedItemIds: string[];
}

export interface SupplierPriceEventValueDto {
  /**
   * 거래단가(원). null = 등재 취소
   * @nullable
   */
  price: number | null;
  /**
   * 판매 상태: active | inactive
   * @nullable
   */
  status: string | null;
  /**
   * 부가세 축: EXCLUSIVE(공급가액) | INCLUSIVE(포함)
   * @nullable
   */
  taxType: string | null;
}

export interface SupplierPriceEventEvidenceDto {
  externalKey: string;
  /** 응찰 시각(ISO) */
  occurredAt: string;
  /** @nullable */
  bidNo: string | null;
  /** @nullable */
  buyerName: string | null;
  won: boolean;
  /** @nullable */
  quantity: number | null;
  /** @nullable */
  unit: string | null;
  /** @nullable */
  lineName: string | null;
}

/**
 * 변경 전. created 는 null
 * @nullable
 */
export type SupplierPriceEventDtoBefore = SupplierPriceEventValueDto | null;

/**
 * 응찰 근거(응찰일·공고번호·낙찰·기관). 못 찾으면 null
 * @nullable
 */
export type SupplierPriceEventDtoEvidence =
  SupplierPriceEventEvidenceDto | null;

export interface SupplierPriceEventDto {
  id: string;
  /**
   * 엑셀 업로드 배치 id. 배치 없는 변경은 null
   * @nullable
   */
  batchId: string | null;
  /** 변경 종류: created(등재) | price_changed(단가) | tax_type_changed(부가세 축) | activated | deactivated */
  action: string;
  /** excel(엑셀 업로드) | undo(업로드 되돌리기) | direct(단건 편집·견적발 갱신·운영 적재) */
  source: string;
  itemId: string;
  /**
   * 변경 전. created 는 null
   * @nullable
   */
  before: SupplierPriceEventDtoBefore;
  after: SupplierPriceEventValueDto;
  /** 반영 시각. 응찰 유래면 진짜 날짜는 evidence.occurredAt */
  createdAt: string;
  /**
   * 근거가 된 씨마켓 응찰 관측 키. 응찰 유래가 아니면 null
   * @nullable
   */
  observationKey?: string | null;
  /**
   * 응찰 근거(응찰일·공고번호·낙찰·기관). 못 찾으면 null
   * @nullable
   */
  evidence?: SupplierPriceEventDtoEvidence;
}

export interface SupplierPriceObservationDto {
  externalKey: string;
  /** 응찰 시각(ISO) */
  occurredAt: string;
  unitPrice: number;
  /** INCLUSIVE | EXCLUSIVE */
  taxType: string;
  /** @nullable */
  supplyUnitPrice: number | null;
  /** @nullable */
  quantity: number | null;
  /** @nullable */
  unit: string | null;
  won: boolean;
  /** @nullable */
  awardedAt: string | null;
  /** @nullable */
  bidNo: string | null;
  /** @nullable */
  buyerName: string | null;
  /** @nullable */
  lineName: string | null;
  /** @nullable */
  lineSpec: string | null;
  /** active | voided(철회·삭제) */
  status: string;
}

/**
 * 재고 정책. ignore = 재고 무관(기본) · skip_zero = 재고 0 으로 적어 둔 품목은 자동견적에서 제외
 */
export type SupplierStockPolicyDtoMode =
  (typeof SupplierStockPolicyDtoMode)[keyof typeof SupplierStockPolicyDtoMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierStockPolicyDtoMode = {
  ignore: "ignore",
  skip_zero: "skip_zero",
} as const;

export interface SupplierStockPolicyDto {
  /** 재고 정책. ignore = 재고 무관(기본) · skip_zero = 재고 0 으로 적어 둔 품목은 자동견적에서 제외 */
  mode: SupplierStockPolicyDtoMode;
}

/**
 * 공급사별 단가(supplierPrice)가 어느 쪽으로 입력됐나 — EXCLUSIVE(공급가액) | INCLUSIVE(부가세 포함). 단가가 없으면 null. 견적서 자동 입력이 이 축을 보고 견적 축을 정한다.
 * @nullable
 */
export type ItemV2SupplierPriceResponseDtoTaxType =
  | (typeof ItemV2SupplierPriceResponseDtoTaxType)[keyof typeof ItemV2SupplierPriceResponseDtoTaxType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemV2SupplierPriceResponseDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface ItemV2SupplierPriceResponseDto {
  /** 품목 ID (items_v2_base.id - UUID) */
  itemId: string;
  /** 공급사 ID */
  supplierId: string;
  /**
   * 공급사별 단가 (최근 거래가)
   * @nullable
   */
  supplierPrice: number | null;
  /**
   * 공급사별 단가(supplierPrice)가 어느 쪽으로 입력됐나 — EXCLUSIVE(공급가액) | INCLUSIVE(부가세 포함). 단가가 없으면 null. 견적서 자동 입력이 이 축을 보고 견적 축을 정한다.
   * @nullable
   */
  taxType: ItemV2SupplierPriceResponseDtoTaxType;
  /**
   * 공급사 최근 거래 일자
   * @nullable
   */
  lastTransactionDate: string | null;
  /** 거래 이력 존재 여부 */
  hasHistory: boolean;
  /**
   * 상품명 (참고용)
   * @nullable
   */
  itemName: string | null;
}

export interface SupplierItemsResponseDto {
  /** 품목 ID (items_v2_base.id - UUID) */
  itemId: string;
  /** 상품명 */
  name: string;
  /** 카테고리 경로 (cat1 > cat2) */
  categoryPath: string;
  /** 최근 거래 일자 (해당 공급사 기준) */
  lastTransactionDate: string;
  /** 최근 거래 단가 (해당 공급사 기준) */
  lastUnitPrice: number;
}

export type ItemSupplierComparisonDtoTaxType =
  (typeof ItemSupplierComparisonDtoTaxType)[keyof typeof ItemSupplierComparisonDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemSupplierComparisonDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface ItemSupplierComparisonDto {
  /** 공급사 ID */
  supplierId: string;
  /**
   * 공급사명
   * @nullable
   */
  supplierName: string | null;
  /**
   * 거래 단가 (원) — 업체가 입력한 그대로. 축은 taxType
   * @nullable
   */
  unitPrice: number | null;
  /** unitPrice 의 부가세 축. EXCLUSIVE=공급가액(부가세 별도), INCLUSIVE=부가세 포함가 */
  taxType: ItemSupplierComparisonDtoTaxType;
  /**
   * 공급가(VAT 별도) 기준 단가(원) — 포함가 X 는 ⌊(20X+11)/22⌋. 목록 순서·최저가 비교는 이 기준이다(2026-10-30)
   * @nullable
   */
  supplyUnitPrice: number | null;
  /**
   * 최근 거래일 (YYYYMMDD)
   * @nullable
   */
  transactionDate: string | null;
  /** 즉시납품 가능 — 공급사가 이 품목의 재고를 1 이상으로 등록해 둔 경우. 수량은 노출하지 않는다. */
  immediateDelivery: boolean;
}

/**
 * @nullable
 */
export type BarcodeItemDtoProductCode = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type BarcodeItemDtoSpec = { [key: string]: unknown } | null;

/**
 * 제조사 품번(spec3)
 * @nullable
 */
export type BarcodeItemDtoManufacturerPartNumber = {
  [key: string]: unknown;
} | null;

/**
 * @nullable
 */
export type BarcodeItemDtoUnit = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type BarcodeItemDtoManufacturer = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type BarcodeItemDtoBrand = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type BarcodeItemDtoImageUrl = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type BarcodeItemDtoStatus = { [key: string]: unknown } | null;

/**
 * 병합된 원본이었으면 그 id
 * @nullable
 */
export type BarcodeItemDtoMergedFromItemId = { [key: string]: unknown } | null;

export interface BarcodeItemDto {
  itemId: string;
  /** @nullable */
  productCode: BarcodeItemDtoProductCode;
  name: string;
  /** @nullable */
  spec: BarcodeItemDtoSpec;
  /**
   * 제조사 품번(spec3)
   * @nullable
   */
  manufacturerPartNumber: BarcodeItemDtoManufacturerPartNumber;
  /** @nullable */
  unit: BarcodeItemDtoUnit;
  /** @nullable */
  manufacturer: BarcodeItemDtoManufacturer;
  /** @nullable */
  brand: BarcodeItemDtoBrand;
  /** @nullable */
  imageUrl: BarcodeItemDtoImageUrl;
  /** @nullable */
  status: BarcodeItemDtoStatus;
  /**
   * 병합된 원본이었으면 그 id
   * @nullable
   */
  mergedFromItemId: BarcodeItemDtoMergedFromItemId;
}

/**
 * @nullable
 */
export type BarcodeMyPriceDtoPrice = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type BarcodeMyPriceDtoTaxType = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type BarcodeMyPriceDtoAutoQuoteEnabled = {
  [key: string]: unknown;
} | null;

export interface BarcodeMyPriceDto {
  priceEntryId: string;
  /** @nullable */
  price: BarcodeMyPriceDtoPrice;
  isSelling: boolean;
  /** @nullable */
  taxType: BarcodeMyPriceDtoTaxType;
  /** @nullable */
  autoQuoteEnabled: BarcodeMyPriceDtoAutoQuoteEnabled;
}

export type BarcodeMatchDtoMatchedBy =
  (typeof BarcodeMatchDtoMatchedBy)[keyof typeof BarcodeMatchDtoMatchedBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BarcodeMatchDtoMatchedBy = {
  BARCODE_PUBLIC: "BARCODE_PUBLIC",
  BARCODE_CANDIDATE: "BARCODE_CANDIDATE",
  BARCODE_PRIVATE: "BARCODE_PRIVATE",
  PRODUCT_CODE: "PRODUCT_CODE",
  PART_NUMBER: "PART_NUMBER",
  PART_NUMBER_PREFIX: "PART_NUMBER_PREFIX",
} as const;

/**
 * @nullable
 */
export type BarcodeMatchDtoMatchedValue = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type BarcodeMatchDtoBarcodeId = { [key: string]: unknown } | null;

/**
 * 내 단가 행. 없으면 미등재
 * @nullable
 */
export type BarcodeMatchDtoMyPrice = BarcodeMyPriceDto | null;

/**
 * 내 재고 가용 수량. 재고 물결(01) 연결 전까지 항상 null(= 모름, 0 아님)
 * @nullable
 */
export type BarcodeMatchDtoStockAvailable = { [key: string]: unknown } | null;

export interface BarcodeMatchDto {
  matchedBy: BarcodeMatchDtoMatchedBy;
  /** @nullable */
  matchedValue: BarcodeMatchDtoMatchedValue;
  /** @nullable */
  barcodeId: BarcodeMatchDtoBarcodeId;
  item: BarcodeItemDto;
  /**
   * 내 단가 행. 없으면 미등재
   * @nullable
   */
  myPrice: BarcodeMatchDtoMyPrice;
  /**
   * 내 재고 가용 수량. 재고 물결(01) 연결 전까지 항상 null(= 모름, 0 아님)
   * @nullable
   */
  stockAvailable: BarcodeMatchDtoStockAvailable;
}

/**
 * 유효한 GTIN 처럼 보이면 PUBLIC, 아니면 PRIVATE
 */
export type BarcodeLookupResponseDtoSuggestedScope =
  (typeof BarcodeLookupResponseDtoSuggestedScope)[keyof typeof BarcodeLookupResponseDtoSuggestedScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BarcodeLookupResponseDtoSuggestedScope = {
  PUBLIC: "PUBLIC",
  PRIVATE: "PRIVATE",
} as const;

/**
 * 자동 확정(바코드표·product_code 정확일치). 없으면 null
 * @nullable
 */
export type BarcodeLookupResponseDtoMatch = BarcodeMatchDto | null;

export interface BarcodeLookupResponseDto {
  code: string;
  /** 유효한 GTIN 처럼 보이면 PUBLIC, 아니면 PRIVATE */
  suggestedScope: BarcodeLookupResponseDtoSuggestedScope;
  /**
   * 자동 확정(바코드표·product_code 정확일치). 없으면 null
   * @nullable
   */
  match: BarcodeLookupResponseDtoMatch;
  /** 사람이 골라야 하는 후보(제조사 품번 정확·접두). 자동 확정하지 않는다 */
  candidates: BarcodeMatchDto[];
}

export type ItemBarcodeDtoScope =
  (typeof ItemBarcodeDtoScope)[keyof typeof ItemBarcodeDtoScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemBarcodeDtoScope = {
  PUBLIC: "PUBLIC",
  PRIVATE: "PRIVATE",
} as const;

/**
 * @nullable
 */
export type ItemBarcodeDtoSymbology =
  | (typeof ItemBarcodeDtoSymbology)[keyof typeof ItemBarcodeDtoSymbology]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemBarcodeDtoSymbology = {
  EAN13: "EAN13",
  EAN8: "EAN8",
  UPCA: "UPCA",
  GTIN14: "GTIN14",
} as const;

export interface ItemBarcodeDto {
  id: string;
  itemId: string;
  code: string;
  scope: ItemBarcodeDtoScope;
  /** @nullable */
  symbology: ItemBarcodeDtoSymbology;
  /** 내가 지울 수 있는가(PRIVATE 내 것만) */
  deletable: boolean;
  createdAt: string;
}

/**
 * PUBLIC=GTIN(EAN-13·EAN-8·UPC-A, 체크섬 검증) · PRIVATE=내 품번
 */
export type RegisterItemBarcodeDtoScope =
  (typeof RegisterItemBarcodeDtoScope)[keyof typeof RegisterItemBarcodeDtoScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterItemBarcodeDtoScope = {
  PUBLIC: "PUBLIC",
  PRIVATE: "PRIVATE",
} as const;

export interface RegisterItemBarcodeDto {
  code: string;
  /** PUBLIC=GTIN(EAN-13·EAN-8·UPC-A, 체크섬 검증) · PRIVATE=내 품번 */
  scope: RegisterItemBarcodeDtoScope;
}

export interface AdminExcelSetMatchDto {
  /**
   * 승인 때 연결할 세모 물품(자동 매칭 후보 중 하나). null = 새 물품으로 등록
   * @nullable
   */
  itemId: string | null;
}

export interface AdminExcelBulkApproveDto {
  /** 최대 200건 */
  requestIds: string[];
  /** 새 물품으로 등록하는 줄에 붙일 카테고리(말단) */
  categoryId?: string;
}

export interface AdminExcelBulkRejectDto {
  requestIds: string[];
  /** 반려 사유 — 업체에 보인다 */
  comment: string;
}

export interface ExchangeLinkCodeDto {
  /** 세모 웹에서 발급받은 연결코드 */
  code: string;
}

export interface ResolveItemInputDto {
  /** 자연어 품목 문자열 */
  text: string;
  /** 수량 */
  quantity?: number;
  /** 단위 */
  unit?: string;
  /** 규격 (선택). text 에 이미 적혀 있으면 생략한다 — 있으면 후보 재순위에 함께 쓴다. */
  spec?: string;
  /** 제조사·브랜드 (선택). 있으면 후보의 제조사와 대조한다. */
  manufacturer?: string;
}

export interface ResolveItemsRequestDto {
  items: ResolveItemInputDto[];
}

export interface SupplyCheckItemDto {
  /** 카탈로그 물품 ID (resolve_items 결과) */
  itemId: string;
  /** 품명 (표시·매칭 보조) */
  name: string;
  quantity: number;
}

export interface SupplyCheckRequestDto {
  items: SupplyCheckItemDto[];
}

export interface InstantQuoteItemDto {
  /** 카탈로그 물품 ID */
  itemId: string;
  name: string;
  quantity: number;
  unit?: string;
}

export interface CreateInstantQuoteRequestDto {
  items: InstantQuoteItemDto[];
  /** 납품 지역 코드 (법정동 시도 2자리) */
  deliveryRegionCode?: string;
  /** 희망 납기 (YYYY-MM-DD) */
  dueDate?: string;
  vatIncluded?: boolean;
}

export interface AttachGuestRequestDto {
  /** 게스트 토큰 (미리보기 URL 프래그먼트의 t) */
  guestToken: string;
}

export interface ClaimQuoteDocumentRequestDto {
  /** quote_response_versions.id */
  quoteVersionId: string;
}

export interface PriceRequestSampleBidDto {
  /** 공고 키 — 공고함 «공고 줄 → 내 단가» 창구의 :key */
  key: string;
  /** 줄 번호 — 같은 창구의 :lineNo */
  lineNo: number;
  /** 공고 제목 */
  title: string;
}

export interface PriceRequestDemandItemDto {
  /** 세모 물품 id(items_v2_base.id) */
  itemId: string;
  /** 품명 */
  itemName: string;
  /**
   * 규격
   * @nullable
   */
  spec: string | null;
  /**
   * 단위
   * @nullable
   */
  unit: string | null;
  /**
   * 조달청 물품분류번호(10자리). 비슷한 품목을 찾는 근거
   * @nullable
   */
  g2bClassCode: string | null;
  /**
   * 세모 카테고리 id
   * @nullable
   */
  categoryId: string | null;
  /** 이 물품이 줄에 들어 있는 열린 공고 수 */
  openBidCount: number;
  /**
   * 가장 가까운 마감(ISO)
   * @nullable
   */
  nearestCloseAt: string | null;
  /** 단가를 넣을 대표 줄 */
  sampleBid: PriceRequestSampleBidDto;
}

export interface PriceRequestDemandPageDto {
  items: PriceRequestDemandItemDto[];
  /**
   * 다음 페이지 커서. null 이면 끝
   * @nullable
   */
  nextAfter: string | null;
  /** 이름이 번호뿐이라 이번 페이지에서 뺀 물품 수 */
  skippedUnnamed: number;
}

export interface PriceRequestItemDto {
  /** 세모 물품 id(items_v2_base.id) */
  itemId: string;
  /** 품명 */
  itemName: string;
  /**
   * 규격
   * @nullable
   */
  spec: string | null;
  /**
   * 단위
   * @nullable
   */
  unit: string | null;
  /** 이 물품이 줄에 들어 있는 열린 공고 수 */
  openBidCount: number;
  /**
   * 가장 가까운 마감(ISO)
   * @nullable
   */
  nearestCloseAt: string | null;
  /** 단가를 넣을 대표 줄 — POST /external/bids/:key/lines/:lineNo/item-register 에 { mode: existing, itemId, unitPrice } 로 */
  sampleBid: PriceRequestSampleBidDto;
  /** 알림 링크가 추천한 물품(items=…)이라 맨 위에 올렸다 */
  recommended: boolean;
}

export interface SupplierPriceRequestPageDto {
  items: PriceRequestItemDto[];
  /**
   * 다음 쪽 커서(after 로 다시 보낸다). null 이면 끝
   * @nullable
   */
  nextAfter: string | null;
}

export interface BidHistoryItemDto {
  name: string;
}

export type BidHistoryRecordDtoOrgName = { [key: string]: unknown };

export type BidHistoryRecordDtoDemandOrgName = { [key: string]: unknown };

export type BidHistoryRecordDtoAmount = { [key: string]: unknown };

export type BidHistoryRecordDtoNoticeKind = { [key: string]: unknown };

export interface BidHistoryRecordDto {
  source: string;
  bid_no: string;
  round?: string;
  biz_type: string;
  title: string;
  org_name?: BidHistoryRecordDtoOrgName;
  demand_org_name?: BidHistoryRecordDtoDemandOrgName;
  items?: BidHistoryItemDto[];
  clsfc_nos?: string[];
  region_limits?: string[];
  notice_at: string;
  amount?: BidHistoryRecordDtoAmount;
  notice_kind?: BidHistoryRecordDtoNoticeKind;
}

export interface IngestBidHistoryDto {
  records: BidHistoryRecordDto[];
}

export type IngestBidItemDtoSpec = { [key: string]: unknown };

export type IngestBidItemDtoQty = { [key: string]: unknown };

export type IngestBidItemDtoUnit = { [key: string]: unknown };

export type IngestBidItemDtoRaw = { [key: string]: unknown };

export interface IngestBidItemDto {
  line_no?: number;
  name: string;
  spec?: IngestBidItemDtoSpec;
  qty?: IngestBidItemDtoQty;
  unit?: IngestBidItemDtoUnit;
  /** @nullable */
  class_code?: string | null;
  raw?: IngestBidItemDtoRaw;
}

export type IngestBidAttachmentDtoUrl = { [key: string]: unknown };

export type IngestBidAttachmentDtoDownloadSpec = { [key: string]: unknown };

export interface IngestBidAttachmentDto {
  name: string;
  url?: IngestBidAttachmentDtoUrl;
  download_spec?: IngestBidAttachmentDtoDownloadSpec;
}

export type IngestBidRecordDtoDemandOrgName = { [key: string]: unknown };

export type IngestBidRecordDtoNoticeAt = { [key: string]: unknown };

export type IngestBidRecordDtoCloseAt = { [key: string]: unknown };

export type IngestBidRecordDtoOpenAt = { [key: string]: unknown };

export type IngestBidRecordDtoEstimatedPrice = { [key: string]: unknown };

export type IngestBidRecordDtoBasePrice = { [key: string]: unknown };

export type IngestBidRecordDtoContractMethod = { [key: string]: unknown };

export type IngestBidRecordDtoBidMethod = { [key: string]: unknown };

export type IngestBidRecordDtoAwardMethod = { [key: string]: unknown };

export type IngestBidRecordDtoRegionLimits = { [key: string]: unknown };

export type IngestBidRecordDtoLicenseLimits = { [key: string]: unknown };

export type IngestBidRecordDtoSourceUrl = { [key: string]: unknown };

export type IngestBidRecordDtoMirrorUrls = { [key: string]: unknown };

export type IngestBidRecordDtoContact = { [key: string]: unknown };

export type IngestBidRecordDtoNoticeKind = { [key: string]: unknown };

export type IngestBidRecordDtoRaw = { [key: string]: unknown };

export type IngestBidRecordDtoFetchedAt = { [key: string]: unknown };

export interface IngestBidRecordDto {
  /** {SOURCE}:{공고번호}:{차수} */
  key: string;
  source: string;
  lane?: string;
  bid_no: string;
  round?: string;
  title: string;
  org_name?: string;
  demand_org_name?: IngestBidRecordDtoDemandOrgName;
  biz_type?: string;
  notice_at?: IngestBidRecordDtoNoticeAt;
  close_at?: IngestBidRecordDtoCloseAt;
  open_at?: IngestBidRecordDtoOpenAt;
  estimated_price?: IngestBidRecordDtoEstimatedPrice;
  base_price?: IngestBidRecordDtoBasePrice;
  contract_method?: IngestBidRecordDtoContractMethod;
  bid_method?: IngestBidRecordDtoBidMethod;
  award_method?: IngestBidRecordDtoAwardMethod;
  region_limits?: IngestBidRecordDtoRegionLimits;
  license_limits?: IngestBidRecordDtoLicenseLimits;
  source_url?: IngestBidRecordDtoSourceUrl;
  mirror_urls?: IngestBidRecordDtoMirrorUrls;
  items_status?: string;
  items?: IngestBidItemDto[];
  attachments?: IngestBidAttachmentDto[];
  contact?: IngestBidRecordDtoContact;
  notice_kind?: IngestBidRecordDtoNoticeKind;
  status?: string;
  raw?: IngestBidRecordDtoRaw;
  fetched_at?: IngestBidRecordDtoFetchedAt;
}

export type IngestExternalBidsDtoLane =
  (typeof IngestExternalBidsDtoLane)[keyof typeof IngestExternalBidsDtoLane];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IngestExternalBidsDtoLane = {
  API: "API",
  UNIFIED: "UNIFIED",
  TRACKED: "TRACKED",
} as const;

export interface IngestExternalBidsDto {
  /** 한 번에 최대 200건 */
  records: IngestBidRecordDto[];
  lane?: IngestExternalBidsDtoLane;
}

export interface RunBidAutoRegisterDto {
  /** true 면 쓰지 않고 세기만 한다 */
  dryRun?: boolean;
  /** 이번에 읽을 줄 수(최대 5,000) */
  limit?: number;
  /** dryRun=false 일 때 true 면 이 요청 안에서 한 배치를 돌리고 결과를 준다(아니면 큐에 넣는다) */
  wait?: boolean;
}

export interface BidPreferencesDto {
  /** 취급 카테고리 */
  categories: string[];
  /** 납품 가능 지역 */
  regions: string[];
  /** 관심 키워드 */
  keywords: string[];
  /** 금액대(화면 선택지 문자열) */
  budgetRange: string;
  /** 아침 다이제스트 */
  digestEnabled: boolean;
  /** 관심 공고 마감 D-1 알림 */
  savedDMinus1Enabled: boolean;
  /** 맞춤 공고 즉시 알림 */
  instantEnabled: boolean;
}

export type SetBidInterestDtoState =
  (typeof SetBidInterestDtoState)[keyof typeof SetBidInterestDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetBidInterestDtoState = {
  SAVED: "SAVED",
  HIDDEN: "HIDDEN",
  PREPARED: "PREPARED",
} as const;

export interface SetBidInterestDto {
  state: SetBidInterestDtoState;
  /** true=표시, false=해제 */
  on: boolean;
}

/**
 * existing: 세모 물품에 단가만 · new: 신규 물품 요청(관리자 승인)
 */
export type RegisterBidLineItemDtoMode =
  (typeof RegisterBidLineItemDtoMode)[keyof typeof RegisterBidLineItemDtoMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterBidLineItemDtoMode = {
  existing: "existing",
  new: "new",
} as const;

/**
 * 내 단가(공급가액, 원). existing 은 필수
 */
export type RegisterBidLineItemDtoUnitPrice = { [key: string]: unknown };

export type RegisterBidLineItemDtoSpec = { [key: string]: unknown };

export type RegisterBidLineItemDtoUnit = { [key: string]: unknown };

export type RegisterBidLineItemDtoBrand = { [key: string]: unknown };

/**
 * 카테고리(추정을 그대로 쓰면 그 id, 모르면 비움 — 관리자가 지정)
 */
export type RegisterBidLineItemDtoCategoryId = { [key: string]: unknown };

export interface RegisterBidLineItemDto {
  /** existing: 세모 물품에 단가만 · new: 신규 물품 요청(관리자 승인) */
  mode: RegisterBidLineItemDtoMode;
  /** existing 일 때 단가를 넣을 세모 물품 id */
  itemId?: string;
  /** 내 단가(공급가액, 원). existing 은 필수 */
  unitPrice?: RegisterBidLineItemDtoUnitPrice;
  /** new 일 때 품명(공고 값에서 고칠 수 있다) */
  name?: string;
  spec?: RegisterBidLineItemDtoSpec;
  unit?: RegisterBidLineItemDtoUnit;
  brand?: RegisterBidLineItemDtoBrand;
  /** 카테고리(추정을 그대로 쓰면 그 id, 모르면 비움 — 관리자가 지정) */
  categoryId?: RegisterBidLineItemDtoCategoryId;
}

export interface CreateBidItemRequestDto {
  /** 품목 줄의 품명(화면에서 수정 가능) */
  itemName: string;
  spec?: string;
  unit?: string;
  qty?: number;
  /** 운영에 남기는 메모 */
  note?: string;
}

/**
 * 마감(ISO)
 */
export type ExternalBidMetaDtoCloseAt = { [key: string]: unknown };

export interface ExternalBidMetaDto {
  /** 연결 기록의 bid_key — 씨마켓은 CMARKET:<공고번호> */
  key: string;
  source: string;
  /** 공고명 */
  title: string;
  /** 발주기관 */
  orgName: string;
  /** 마감(ISO) */
  closeAt?: ExternalBidMetaDtoCloseAt;
}

export type ExternalBidLineDtoSpec = { [key: string]: unknown };

export type ExternalBidLineDtoUnit = { [key: string]: unknown };

export type ExternalBidLineDtoQty = { [key: string]: unknown };

/**
 * 호출자가 이미 아는 세모 물품 id(씨마켓 공고 줄의 semo_item_id)
 */
export type ExternalBidLineDtoItemId = { [key: string]: unknown };

export interface ExternalBidLineDto {
  /** 공고 줄 번호(씨마켓 f_seq) */
  lineNo: number;
  /** 품명 */
  name: string;
  spec?: ExternalBidLineDtoSpec;
  unit?: ExternalBidLineDtoUnit;
  qty?: ExternalBidLineDtoQty;
  /** 호출자가 이미 아는 세모 물품 id(씨마켓 공고 줄의 semo_item_id) */
  itemId?: ExternalBidLineDtoItemId;
}

export interface BidLineContextRequestDto {
  bid: ExternalBidMetaDto;
  /** 공고 줄(최대 100) */
  lines: ExternalBidLineDto[];
}

export interface MyPricesRequestDto {
  /** 세모 물품 id(최대 500) */
  itemIds: string[];
}

export interface ConfirmMyPricesRequestDto {
  /** 세모 물품 id(최대 100) */
  itemIds: string[];
}

export interface BidLinePriceHistoryRequestDto {
  /** 최대 100줄 */
  lines: ExternalBidLineDto[];
}

/**
 * existing: 세모 물품에 단가만 · new: 신규 물품 요청(관리자 승인)
 */
export type RegisterExternalBidLineDtoMode =
  (typeof RegisterExternalBidLineDtoMode)[keyof typeof RegisterExternalBidLineDtoMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterExternalBidLineDtoMode = {
  existing: "existing",
  new: "new",
} as const;

/**
 * 내 단가(공급가액, 원). existing 은 필수
 */
export type RegisterExternalBidLineDtoUnitPrice = { [key: string]: unknown };

export type RegisterExternalBidLineDtoSpec = { [key: string]: unknown };

export type RegisterExternalBidLineDtoUnit = { [key: string]: unknown };

export type RegisterExternalBidLineDtoBrand = { [key: string]: unknown };

/**
 * 카테고리(추정을 그대로 쓰면 그 id, 모르면 비움 — 관리자가 지정)
 */
export type RegisterExternalBidLineDtoCategoryId = { [key: string]: unknown };

export interface RegisterExternalBidLineDto {
  /** existing: 세모 물품에 단가만 · new: 신규 물품 요청(관리자 승인) */
  mode: RegisterExternalBidLineDtoMode;
  /** existing 일 때 단가를 넣을 세모 물품 id */
  itemId?: string;
  /** 내 단가(공급가액, 원). existing 은 필수 */
  unitPrice?: RegisterExternalBidLineDtoUnitPrice;
  /** new 일 때 품명(공고 값에서 고칠 수 있다) */
  name?: string;
  spec?: RegisterExternalBidLineDtoSpec;
  unit?: RegisterExternalBidLineDtoUnit;
  brand?: RegisterExternalBidLineDtoBrand;
  /** 카테고리(추정을 그대로 쓰면 그 id, 모르면 비움 — 관리자가 지정) */
  categoryId?: RegisterExternalBidLineDtoCategoryId;
  bid: ExternalBidMetaDto;
  line: ExternalBidLineDto;
}

export interface CmarketLineCandidateDto {
  itemId: string;
  name: string;
  /** @nullable */
  spec: string | null;
  /** @nullable */
  unit: string | null;
  score: number;
}

export type CmarketLineResultDtoDecision =
  (typeof CmarketLineResultDtoDecision)[keyof typeof CmarketLineResultDtoDecision];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketLineResultDtoDecision = {
  ALREADY: "ALREADY",
  LINK: "LINK",
  REGISTER: "REGISTER",
  REVIEW: "REVIEW",
  SKIP: "SKIP",
  DEFER: "DEFER",
} as const;

/**
 * @nullable
 */
export type CmarketLineResultDtoMatchSource =
  | (typeof CmarketLineResultDtoMatchSource)[keyof typeof CmarketLineResultDtoMatchSource]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketLineResultDtoMatchSource = {
  "semo-auto": "semo-auto",
  "semo-register": "semo-register",
  "semo-review": "semo-review",
} as const;

export interface CmarketLineResultDto {
  bidNo: string;
  lineNo: number;
  decision: CmarketLineResultDtoDecision;
  /** @nullable */
  semoItemId: string | null;
  /** @nullable */
  matchSource: CmarketLineResultDtoMatchSource;
  /** @nullable */
  confidence: number | null;
  /** @nullable */
  reason: string | null;
  created: boolean;
  candidates: CmarketLineCandidateDto[];
}

/**
 * 판정별 줄 수
 */
export type CmarketLineResolveResultDtoCounts = { [key: string]: unknown };

export interface CmarketLineResolveResultDto {
  /** 실제로 썼나(스위치 켜짐 + dryRun=false) */
  applied: boolean;
  switchOn: boolean;
  /** 판정별 줄 수 */
  counts: CmarketLineResolveResultDtoCounts;
  lines: CmarketLineResultDto[];
}

/**
 * 규격(f_norm)
 */
export type CmarketLineResolveLineDtoSpec = { [key: string]: unknown };

/**
 * 단위(f_unit)
 */
export type CmarketLineResolveLineDtoUnit = { [key: string]: unknown };

/**
 * 업무구분(물품·용역·공사·기타). 비우면 물품
 */
export type CmarketLineResolveLineDtoBizType = { [key: string]: unknown };

/**
 * 공고명 — 새로 만든 물품의 출처로 남긴다
 */
export type CmarketLineResolveLineDtoTitle = { [key: string]: unknown };

/**
 * 발주기관명 — 새로 만든 물품의 출처로 남긴다
 */
export type CmarketLineResolveLineDtoOrgName = { [key: string]: unknown };

/**
 * 이미 붙은 세모 물품 id(있으면 판정하지 않는다)
 */
export type CmarketLineResolveLineDtoCurrentItemId = { [key: string]: unknown };

export interface CmarketLineResolveLineDto {
  /** 씨마켓 공고번호(buy_idx) */
  bidNo: string;
  /** 공고 줄 번호(f_seq) */
  lineNo: number;
  /** 품명(f_name) */
  name: string;
  /** 규격(f_norm) */
  spec?: CmarketLineResolveLineDtoSpec;
  /** 단위(f_unit) */
  unit?: CmarketLineResolveLineDtoUnit;
  /** 업무구분(물품·용역·공사·기타). 비우면 물품 */
  bizType?: CmarketLineResolveLineDtoBizType;
  /** 공고명 — 새로 만든 물품의 출처로 남긴다 */
  title?: CmarketLineResolveLineDtoTitle;
  /** 발주기관명 — 새로 만든 물품의 출처로 남긴다 */
  orgName?: CmarketLineResolveLineDtoOrgName;
  /** 이미 붙은 세모 물품 id(있으면 판정하지 않는다) */
  currentItemId?: CmarketLineResolveLineDtoCurrentItemId;
}

export interface CmarketLineResolveDto {
  /** @maxItems 200 */
  lines: CmarketLineResolveLineDto[];
  /** 기본 true(예행연습 — 아무것도 쓰지 않음). false 이고 세모 스위치(CMARKET_LINE_AUTO_LINK_ENABLED)가 켜져 있을 때만 신규 등록·열쇠 기억을 한다 */
  dryRun?: boolean;
}

export interface CmarketBidSyncResultDto {
  key: string;
  /** 원장에 쓴 공고 수(0이면 건너뜀) */
  upserted: number;
  /** 다시 쓴 품목 줄 수 */
  itemsReplaced: number;
}

/**
 * 규격(f_norm)
 */
export type CmarketBidSyncLineDtoSpec = { [key: string]: unknown };

/**
 * 수량(f_volume)
 */
export type CmarketBidSyncLineDtoQty = { [key: string]: unknown };

/**
 * 단위(f_unit)
 */
export type CmarketBidSyncLineDtoUnit = { [key: string]: unknown };

/**
 * 발주기관 예정단가(f_price)
 */
export type CmarketBidSyncLineDtoUnitPrice = { [key: string]: unknown };

/**
 * 물품 코드(f_code)
 */
export type CmarketBidSyncLineDtoProductCode = { [key: string]: unknown };

/**
 * 줄에 붙은 세모 물품 id(semo_item_id). 있으면 세모는 이름을 보지 않고 이 물품으로 «연결 일치» 판정한다
 */
export type CmarketBidSyncLineDtoItemId = { [key: string]: unknown };

/**
 * auto | suggest | manual | admin
 */
export type CmarketBidSyncLineDtoMatchSource = { [key: string]: unknown };

export type CmarketBidSyncLineDtoMatchConfidence = { [key: string]: unknown };

export interface CmarketBidSyncLineDto {
  /** 공고 줄 번호(f_seq) */
  lineNo: number;
  /** 품명(f_name) */
  name: string;
  /** 규격(f_norm) */
  spec?: CmarketBidSyncLineDtoSpec;
  /** 수량(f_volume) */
  qty?: CmarketBidSyncLineDtoQty;
  /** 단위(f_unit) */
  unit?: CmarketBidSyncLineDtoUnit;
  /** 발주기관 예정단가(f_price) */
  unitPrice?: CmarketBidSyncLineDtoUnitPrice;
  /** 물품 코드(f_code) */
  productCode?: CmarketBidSyncLineDtoProductCode;
  /** 줄에 붙은 세모 물품 id(semo_item_id). 있으면 세모는 이름을 보지 않고 이 물품으로 «연결 일치» 판정한다 */
  itemId?: CmarketBidSyncLineDtoItemId;
  /** auto | suggest | manual | admin */
  matchSource?: CmarketBidSyncLineDtoMatchSource;
  matchConfidence?: CmarketBidSyncLineDtoMatchConfidence;
}

/**
 * 파트너 고정 URL(만료 없음)
 */
export type CmarketBidSyncAttachmentDtoUrl = { [key: string]: unknown };

export interface CmarketBidSyncAttachmentDto {
  name: string;
  /** 파트너 고정 URL(만료 없음) */
  url?: CmarketBidSyncAttachmentDtoUrl;
}

export type CmarketBidSyncContactDtoDepartment = { [key: string]: unknown };

export type CmarketBidSyncContactDtoPhone = { [key: string]: unknown };

export interface CmarketBidSyncContactDto {
  department?: CmarketBidSyncContactDtoDepartment;
  phone?: CmarketBidSyncContactDtoPhone;
}

/**
 * 수요기관·부서
 */
export type CmarketBidSyncDtoDemandOrgName = { [key: string]: unknown };

/**
 * gjy_ok: A=물품 G=공사 S=용역 C=매각→기타
 */
export type CmarketBidSyncDtoBizType =
  (typeof CmarketBidSyncDtoBizType)[keyof typeof CmarketBidSyncDtoBizType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketBidSyncDtoBizType = {
  물품: "물품",
  용역: "용역",
  공사: "공사",
  기타: "기타",
} as const;

/**
 * 진행 중이면 open, 마감·취소·낙찰·유찰이면 closed
 */
export type CmarketBidSyncDtoStatus =
  (typeof CmarketBidSyncDtoStatus)[keyof typeof CmarketBidSyncDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketBidSyncDtoStatus = {
  open: "open",
  closed: "closed",
} as const;

/**
 * 공고 시작(ISO)
 */
export type CmarketBidSyncDtoNoticeAt = { [key: string]: unknown };

/**
 * 마감(ISO)
 */
export type CmarketBidSyncDtoCloseAt = { [key: string]: unknown };

/**
 * 개찰(ISO)
 */
export type CmarketBidSyncDtoOpenAt = { [key: string]: unknown };

/**
 * 예정가·예산(buy_price)
 */
export type CmarketBidSyncDtoEstimatedPrice = { [key: string]: unknown };

export type CmarketBidSyncDtoContractMethod = { [key: string]: unknown };

export type CmarketBidSyncDtoAwardMethod = { [key: string]: unknown };

export type CmarketBidSyncDtoBidMethod = { [key: string]: unknown };

/**
 * 재공고 등
 */
export type CmarketBidSyncDtoNoticeKind = { [key: string]: unknown };

/**
 * 씨마켓 공고 화면(공급사)
 */
export type CmarketBidSyncDtoUrl = { [key: string]: unknown };

export interface CmarketBidSyncDto {
  /** 공고번호(buy_idx) */
  bidNo: string;
  /** 공고명(f_name) */
  title: string;
  /** 발주기관(회사명) */
  orgName: string;
  /** 수요기관·부서 */
  demandOrgName?: CmarketBidSyncDtoDemandOrgName;
  /** gjy_ok: A=물품 G=공사 S=용역 C=매각→기타 */
  bizType: CmarketBidSyncDtoBizType;
  /** 진행 중이면 open, 마감·취소·낙찰·유찰이면 closed */
  status: CmarketBidSyncDtoStatus;
  /** 공고 시작(ISO) */
  noticeAt?: CmarketBidSyncDtoNoticeAt;
  /** 마감(ISO) */
  closeAt?: CmarketBidSyncDtoCloseAt;
  /** 개찰(ISO) */
  openAt?: CmarketBidSyncDtoOpenAt;
  /** 예정가·예산(buy_price) */
  estimatedPrice?: CmarketBidSyncDtoEstimatedPrice;
  contractMethod?: CmarketBidSyncDtoContractMethod;
  awardMethod?: CmarketBidSyncDtoAwardMethod;
  bidMethod?: CmarketBidSyncDtoBidMethod;
  /** 재공고 등 */
  noticeKind?: CmarketBidSyncDtoNoticeKind;
  /** 지역 제한(b2b_area) */
  regionLimits?: string[];
  /** 필요 면허(required_license 조각) */
  licenseLimits?: string[];
  /** 씨마켓 공고 화면(공급사) */
  url?: CmarketBidSyncDtoUrl;
  /** 품목 줄(최대 1000) */
  lines: CmarketBidSyncLineDto[];
  attachments?: CmarketBidSyncAttachmentDto[];
  contact?: CmarketBidSyncContactDto;
}

export interface CmarketBidAnnounceResultDto {
  /** 줄의 물품을 파는 공급사 수 */
  suppliers: number;
  /** 이번에 안내한 공급사 수 */
  notified: number;
  /** 이미 안내해 건너뛴 공급사 수 */
  skipped: number;
  /** 인앱에 더해 문자(SMS)까지 요청한 공급사 수 — 줄마다 공급가액이 가장 싼 2곳(휴대전화·수신 동의 있는 곳만) */
  texted: number;
}

export interface CmarketBidAnnounceLineDto {
  /** 공고 줄 번호(f_seq) */
  lineNo: number;
  /** 줄에 붙은 세모 물품 id */
  itemId: string;
}

/**
 * 마감(ISO)
 */
export type CmarketBidAnnounceDtoCloseAt = { [key: string]: unknown };

/**
 * 씨마켓 공고 화면 주소
 */
export type CmarketBidAnnounceDtoUrl = { [key: string]: unknown };

export interface CmarketBidAnnounceDto {
  bidNo: string;
  /** 공고명 */
  title: string;
  /** 발주기관 */
  orgName: string;
  /** 마감(ISO) */
  closeAt?: CmarketBidAnnounceDtoCloseAt;
  /** 씨마켓 공고 화면 주소 */
  url?: CmarketBidAnnounceDtoUrl;
  /** 세모 물품이 붙은 줄(최대 100) */
  lines: CmarketBidAnnounceLineDto[];
}

export interface CmarketMasterItemSummaryDto {
  itemId: string;
  name: string;
  /** @nullable */
  spec: string | null;
  /** @nullable */
  unit: string | null;
  /** @nullable */
  categoryId: string | null;
  /** @nullable */
  categoryName: string | null;
}

/**
 * 규격
 * @nullable
 */
export type CmarketCreateMasterItemDtoSpec = { [key: string]: unknown } | null;

/**
 * 제조사
 * @nullable
 */
export type CmarketCreateMasterItemDtoManufacturer = {
  [key: string]: unknown;
} | null;

/**
 * 브랜드
 * @nullable
 */
export type CmarketCreateMasterItemDtoBrand = { [key: string]: unknown } | null;

/**
 * 정가(원) — 공고 줄의 예정 단가. 없으면 0
 * @nullable
 */
export type CmarketCreateMasterItemDtoPrice = { [key: string]: unknown } | null;

export interface CmarketCreateMasterItemDto {
  /** 품명 */
  name: string;
  /** 단위 */
  unit: string;
  /** 세모 카테고리 id(items_v2_categories) */
  categoryId: string;
  /**
   * 규격
   * @nullable
   */
  spec?: CmarketCreateMasterItemDtoSpec;
  /**
   * 제조사
   * @nullable
   */
  manufacturer?: CmarketCreateMasterItemDtoManufacturer;
  /**
   * 브랜드
   * @nullable
   */
  brand?: CmarketCreateMasterItemDtoBrand;
  /**
   * 정가(원) — 공고 줄의 예정 단가. 없으면 0
   * @nullable
   */
  price?: CmarketCreateMasterItemDtoPrice;
}

export interface CmarketEnsureReagentItemResultDto {
  itemId: string;
  name: string;
  /** @nullable */
  spec: string | null;
  /** @nullable */
  unit: string | null;
  /** @nullable */
  categoryId: string | null;
  /** @nullable */
  categoryName: string | null;
  /** 이번 호출로 새로 만들었는가(false 면 이미 있던 물품) */
  created: boolean;
  /** 돌려준 물품의 제조사가 요청한 제조사와 같은가(새로 만들었으면 true). false 면 같은 제품번호의 다른 제조사 물품이다 */
  manufacturerMatched: boolean;
}

/**
 * CAS 번호
 * @nullable
 */
export type CmarketEnsureReagentItemDtoCas = { [key: string]: unknown } | null;

/**
 * 용량 표기
 * @nullable
 */
export type CmarketEnsureReagentItemDtoPack = { [key: string]: unknown } | null;

/**
 * 단위 — 없으면 EA
 * @nullable
 */
export type CmarketEnsureReagentItemDtoUnit = { [key: string]: unknown } | null;

/**
 * 정가(원) — 공고 줄의 예정 단가. 없으면 0
 * @nullable
 */
export type CmarketEnsureReagentItemDtoPrice = {
  [key: string]: unknown;
} | null;

export interface CmarketEnsureReagentItemDto {
  /** 품명(물질명) */
  name: string;
  /** 제조사 제품번호 */
  catalogNumber: string;
  /** 제조사 */
  manufacturer: string;
  /**
   * CAS 번호
   * @nullable
   */
  cas?: CmarketEnsureReagentItemDtoCas;
  /**
   * 용량 표기
   * @nullable
   */
  pack?: CmarketEnsureReagentItemDtoPack;
  /**
   * 단위 — 없으면 EA
   * @nullable
   */
  unit?: CmarketEnsureReagentItemDtoUnit;
  /**
   * 정가(원) — 공고 줄의 예정 단가. 없으면 0
   * @nullable
   */
  price?: CmarketEnsureReagentItemDtoPrice;
}

export interface CmarketMasterItemNamesDto {
  /** 세모 물품 id 목록(최대 500) */
  itemIds: string[];
}

export interface CmarketMasterCategoryDto {
  id: string;
  name: string;
  /** @nullable */
  level: number | null;
  /** 상위 이름까지 이어 붙인 경로 */
  path: string;
}

export interface CmarketKeywordStatsResultDto {
  /** 세모에 저장된 키워드 줄 수(찾은 회사의 교체 뒤 줄 수 합) */
  upserted: number;
  /** 세모 공급사를 못 찾아 건너뛴 회사 수 */
  unknownSuppliers: number;
}

/**
 * 키워드 유형 — G 공사 · S 용역
 */
export type CmarketKeywordStatDtoKeywordType =
  (typeof CmarketKeywordStatDtoKeywordType)[keyof typeof CmarketKeywordStatDtoKeywordType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketKeywordStatDtoKeywordType = {
  G: "G",
  S: "S",
} as const;

export interface CmarketKeywordStatDto {
  /** 씨마켓 키워드 코드(b2b_keyword_code.keyword_code) */
  keywordCode: number;
  /** 키워드 유형 — G 공사 · S 용역 */
  keywordType: CmarketKeywordStatDtoKeywordType;
  /**
   * 키워드 분류(keyword_class)
   * @nullable
   */
  keywordClass?: string | null;
  /** 키워드 이름(keyword_name) — 세모 공고 유형과 이름으로 잇는다 */
  keywordName: string;
  /** 집계 창 안 응찰 수(재공고 사본은 원 공고 하나로 1회) */
  joinCount: number;
  /** 그중 낙찰 수 */
  winCount: number;
  /**
   * 마지막 응찰 시각(ISO)
   * @nullable
   */
  lastJoinedAt?: string | null;
  /**
   * 마지막 낙찰 시각(ISO)
   * @nullable
   */
  lastWonAt?: string | null;
}

export interface CmarketSupplierKeywordStatsDto {
  /** 씨마켓 회원 아이디(member_id) = 세모 suppliers.supplier_id */
  externalId: string;
  /** 이 회사의 공사·용역 키워드 전부(회사 단위 전체 교체). 빈 배열이면 세모에 있던 이 회사 씨마켓 이력을 지운다 */
  stats: CmarketKeywordStatDto[];
}

export interface CmarketKeywordStatsBatchDto {
  /** 씨마켓 집계 시각(ISO) */
  asOf: string;
  /** 집계 창 시작(ISO) */
  windowFrom: string;
  suppliers: CmarketSupplierKeywordStatsDto[];
}

export interface SetBidAutoItemsCategoryDto {
  /** 자동등록 물품 id(최대 500) */
  itemIds: string[];
  categoryId: string;
}

export interface MergeBidAutoItemDto {
  /** 머지할 기존 물품 id */
  targetItemId: string;
}

export interface LandingStatsDto {
  /** 누적 견적 요청 수 */
  quoteRequests: number;
  /** 누적 제출 견적서 수 */
  quoteResponses: number;
  /** 누적 계약 수(취소 제외) */
  contracts: number;
  /** 참여 기업(공급사) 수 */
  suppliers: number;
}

export interface RecentContractDto {
  id: string;
  /**
   * 발주기관명 — 견적요청이 비공개면 null
   * @nullable
   */
  organizationName: string | null;
  /** @nullable */
  projectName: string | null;
  /**
   * «공기청정기 외 2종»
   * @nullable
   */
  itemSummary: string | null;
  /** 계약 시각(ISO) */
  contractedAt: string;
}

/**
 * 공사 / 용역
 */
export type CostWorkTypeDtoKind =
  (typeof CostWorkTypeDtoKind)[keyof typeof CostWorkTypeDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostWorkTypeDtoKind = {
  construction: "construction",
  service: "service",
} as const;

export interface CostWorkTypeDto {
  /** 종목 키 — 공사 = ConstructionTypeEnum 값, 용역 = 용역 유형 이름(한글) */
  type: string;
  /** 종목 한글 이름(용역은 키와 같음) */
  label: string;
  /** 공사 / 용역 */
  kind: CostWorkTypeDtoKind;
  /** 표준 내역서 줄 수(0 이면 아직 틀 없음) */
  lines: number;
}

/**
 * 공사 / 용역
 */
export type CostClassifyCandidateDtoKind =
  (typeof CostClassifyCandidateDtoKind)[keyof typeof CostClassifyCandidateDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostClassifyCandidateDtoKind = {
  construction: "construction",
  service: "service",
} as const;

export interface CostClassifyCandidateDto {
  /** 종목 키 — 공사 = ConstructionTypeEnum 값, 용역 = 용역 유형 이름(한글) */
  type: string;
  /** 종목 한글 이름(용역은 키와 같음) */
  label: string;
  /** 공사 / 용역 */
  kind: CostClassifyCandidateDtoKind;
  /** 표준 내역서 줄 수(0 이면 아직 틀 없음) */
  lines: number;
  /** 규칙 점수(높을수록 유력) */
  score: number;
  /** 맞은 낱말(괄호 꼬리 «(전기)» 면 그 낱말) */
  keywords: string[];
}

/**
 * 공사/용역 판정 — 판정 못 하면 null
 * @nullable
 */
export type CostClassifyDtoKind =
  | (typeof CostClassifyDtoKind)[keyof typeof CostClassifyDtoKind]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostClassifyDtoKind = {
  construction: "construction",
  service: "service",
} as const;

export interface CostClassifyDto {
  /** 분류에 쓴 제목(trim·200자 자름) */
  title: string;
  /**
   * 공사/용역 판정 — 판정 못 하면 null
   * @nullable
   */
  kind: CostClassifyDtoKind;
  /** 후보 최대 3개, 점수순 */
  candidates: CostClassifyCandidateDto[];
}

/**
 * 공종 / 자재 / 인건비 / 경비(LABOR·EXPENSE 는 용역)
 */
export type CostTemplateLineDtoSection =
  (typeof CostTemplateLineDtoSection)[keyof typeof CostTemplateLineDtoSection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostTemplateLineDtoSection = {
  WORK: "WORK",
  MATERIAL: "MATERIAL",
  LABOR: "LABOR",
  EXPENSE: "EXPENSE",
} as const;

/**
 * 단가 출처 — 용역 줄은 null
 * @nullable
 */
export type CostTemplateLineDtoSource =
  | (typeof CostTemplateLineDtoSource)[keyof typeof CostTemplateLineDtoSource]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostTemplateLineDtoSource = {
  G2B_WORK: "G2B_WORK",
  G2B_MATERIAL: "G2B_MATERIAL",
} as const;

export interface CostTemplateLineDto {
  lineNo: number;
  /** 공종 / 자재 / 인건비 / 경비(LABOR·EXPENSE 는 용역) */
  section: CostTemplateLineDtoSection;
  /** 대공종 코드 */
  majorCode: string;
  /** 대공종 이름 */
  majorName: string;
  /** 중공종 코드 */
  midCode: string;
  /** 중공종 이름 */
  midName: string;
  /**
   * 단가 출처 — 용역 줄은 null
   * @nullable
   */
  source: CostTemplateLineDtoSource;
  /**
   * 원장 코드 — 용역 줄은 null
   * @nullable
   */
  code: string | null;
  name: string;
  /** @nullable */
  spec: string | null;
  /** @nullable */
  unit: string | null;
  /**
   * 재료비 단가(원)
   * @nullable
   */
  materialPrice: number | null;
  /**
   * 노무비 단가(원)
   * @nullable
   */
  laborPrice: number | null;
  /**
   * 경비 단가(원)
   * @nullable
   */
  expensePrice: number | null;
  /**
   * 합계 단가(원)
   * @nullable
   */
  totalPrice: number | null;
  /**
   * «표준시장단가 2025-08-04» 등
   * @nullable
   */
  priceBasis: string | null;
  /**
   * 적용조건·비고
   * @nullable
   */
  note: string | null;
  /** 실제 공사 공고 내역서에 나온 공고 수 */
  bidFrequency: number;
}

/**
 * 공사 / 용역
 */
export type CostTemplateDtoKind =
  (typeof CostTemplateDtoKind)[keyof typeof CostTemplateDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostTemplateDtoKind = {
  construction: "construction",
  service: "service",
} as const;

export interface CostTemplateDto {
  /** 종목 키 */
  type: string;
  label: string;
  /** 공사 / 용역 */
  kind: CostTemplateDtoKind;
  /** 붙은 단가 기준의 고유 목록 */
  priceBases: string[];
  lines: CostTemplateLineDto[];
}

export type CostPriceBookEntryDtoSource =
  (typeof CostPriceBookEntryDtoSource)[keyof typeof CostPriceBookEntryDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostPriceBookEntryDtoSource = {
  G2B_WORK: "G2B_WORK",
  G2B_MATERIAL: "G2B_MATERIAL",
} as const;

export interface CostPriceBookEntryDto {
  source: CostPriceBookEntryDtoSource;
  code: string;
  /**
   * 공사구분(건축공사·토목공사…) — 자재는 null
   * @nullable
   */
  workClass: string | null;
  name: string;
  /** @nullable */
  spec: string | null;
  /** @nullable */
  unit: string | null;
  /** @nullable */
  materialPrice: number | null;
  /** @nullable */
  laborPrice: number | null;
  /** @nullable */
  expensePrice: number | null;
  /** @nullable */
  totalPrice: number | null;
  /** @nullable */
  priceBasis: string | null;
  /** @nullable */
  note: string | null;
}

export interface CostDocumentFactsDto {
  /**
   * 공사·사업 위치
   * @nullable
   */
  location: string | null;
  /**
   * 사업·공사 개요(200자에서 자름)
   * @nullable
   */
  overview: string | null;
  /**
   * 공사·용역 기간(60자에서 자름)
   * @nullable
   */
  period: string | null;
  /**
   * 기초금액(원, 부가세 포함)
   * @nullable
   */
  basePrice: number | null;
  /**
   * 추정가격(원, 부가세 별도)
   * @nullable
   */
  estimatedPrice: number | null;
  /**
   * 예산(원) — 기초금액 → 없으면 추정가격×1.1 반올림 → 없으면 사업예산·배정예산·사업비 류
   * @nullable
   */
  budget: number | null;
  /** 참가자격에서 찾은 면허·등록 이름(고유) */
  licenses: string[];
}

export type CostDocumentLineMatchDtoSource =
  (typeof CostDocumentLineMatchDtoSource)[keyof typeof CostDocumentLineMatchDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostDocumentLineMatchDtoSource = {
  G2B_WORK: "G2B_WORK",
  G2B_MATERIAL: "G2B_MATERIAL",
} as const;

export interface CostDocumentLineMatchDto {
  source: CostDocumentLineMatchDtoSource;
  code: string;
  name: string;
  /** @nullable */
  spec: string | null;
  /** @nullable */
  unit: string | null;
  /** @nullable */
  materialPrice: number | null;
  /** @nullable */
  laborPrice: number | null;
  /** @nullable */
  expensePrice: number | null;
  /** @nullable */
  totalPrice: number | null;
  /** @nullable */
  priceBasis: string | null;
  /** @nullable */
  note: string | null;
}

/**
 * 원장 단가(이름 정확 일치, 여럿이면 규격 일치 → 단가 있음 → 코드순) — 없으면 null
 * @nullable
 */
export type CostDocumentLineDtoMatch = CostDocumentLineMatchDto | null;

export interface CostDocumentLineDto {
  /**
   * 공종 머리(«1-1. 위생기구설비공사» 등) — 없으면 null
   * @nullable
   */
  section: string | null;
  /** 품명(글자마다 띄운 이름은 붙여서) */
  name: string;
  /** @nullable */
  spec: string | null;
  /** @nullable */
  unit: string | null;
  /**
   * 수량
   * @nullable
   */
  quantity: number | null;
  /**
   * 원장 단가(이름 정확 일치, 여럿이면 규격 일치 → 단가 있음 → 코드순) — 없으면 null
   * @nullable
   */
  match: CostDocumentLineDtoMatch;
}

export interface CostDocumentAiDto {
  /** AI 를 불렀고 성공했나 */
  used: boolean;
  /**
   * 안 썼으면 왜(키 없음·필요 없음·스캔본·엑셀·실패) — 썼으면 null
   * @nullable
   */
  reason: string | null;
}

export type CostDocumentAnalysisDtoFileType =
  (typeof CostDocumentAnalysisDtoFileType)[keyof typeof CostDocumentAnalysisDtoFileType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostDocumentAnalysisDtoFileType = {
  pdf: "pdf",
  excel: "excel",
} as const;

/**
 * 제목을 어디서 얻었나 — 문서 본문 / 파일 이름
 * @nullable
 */
export type CostDocumentAnalysisDtoTitleSource =
  | (typeof CostDocumentAnalysisDtoTitleSource)[keyof typeof CostDocumentAnalysisDtoTitleSource]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostDocumentAnalysisDtoTitleSource = {
  document: "document",
  filename: "filename",
} as const;

export interface CostDocumentAnalysisDto {
  fileName: string;
  fileType: CostDocumentAnalysisDtoFileType;
  /**
   * PDF 쪽수(엑셀은 null)
   * @nullable
   */
  pages: number | null;
  /** 뽑은 글자 수 */
  textChars: number;
  /** 원문 발췌 — 추출한 글자 앞 6,000자(공백 정규화). 엑셀은 고른 시트의 줄을 «칸 | 칸» 으로 이은 글자 앞 6,000자. 내역서 초안(draft-boq) 요청의 documents[].textExcerpt 로 그대로 보낸다 */
  textExcerpt: string;
  /** PDF 인데 쪽당 글자가 50자 미만(스캔본) — 아직 못 읽는다 */
  scanned: boolean;
  /**
   * 공사명·용역명
   * @nullable
   */
  title: string | null;
  /**
   * 제목을 어디서 얻었나 — 문서 본문 / 파일 이름
   * @nullable
   */
  titleSource: CostDocumentAnalysisDtoTitleSource;
  facts: CostDocumentFactsDto;
  /** 종목 후보 — classify 와 같은 모양(제목 → 제목+개요 → 면허 순) */
  classification: CostClassifyDto;
  /** 내역 줄(엑셀은 결정적으로, PDF 표는 AI 로 — 최대 2,000줄) */
  lines: CostDocumentLineDto[];
  ai: CostDocumentAiDto;
  /** 사람에게 보여 줄 주의 문구 */
  warnings: string[];
}

/**
 * @nullable
 */
export type DraftBoqLineDtoPriceSource =
  | (typeof DraftBoqLineDtoPriceSource)[keyof typeof DraftBoqLineDtoPriceSource]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DraftBoqLineDtoPriceSource = {
  G2B_WORK: "G2B_WORK",
  G2B_MATERIAL: "G2B_MATERIAL",
} as const;

/**
 * AI 초안 / 첨부 내역서 / 표준 내역서(AI 를 못 쓸 때) / 규칙(고객 설명 속 «품목 + 숫자 + 단위»)
 */
export type DraftBoqLineDtoOrigin =
  (typeof DraftBoqLineDtoOrigin)[keyof typeof DraftBoqLineDtoOrigin];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DraftBoqLineDtoOrigin = {
  AI: "AI",
  DOCUMENT: "DOCUMENT",
  TEMPLATE: "TEMPLATE",
  RULE: "RULE",
} as const;

export interface DraftBoqLineDto {
  /**
   * 구분 — 표준 내역서 줄은 «대공종 › 중공종», AI 추가 줄은 «추가 항목», 첨부 줄은 첨부의 공종 머리
   * @nullable
   */
  section: string | null;
  name: string;
  /** @nullable */
  spec: string | null;
  /** @nullable */
  unit: string | null;
  /**
   * 수량 — 입력에서 근거를 찾은 경우만, 아니면 null
   * @nullable
   */
  quantity: number | null;
  /** @nullable */
  priceSource: DraftBoqLineDtoPriceSource;
  /** @nullable */
  priceCode: string | null;
  /**
   * 원장 합계 단가 참고값(원)
   * @nullable
   */
  referenceUnitPrice: number | null;
  /** AI 초안 / 첨부 내역서 / 표준 내역서(AI 를 못 쓸 때) / 규칙(고객 설명 속 «품목 + 숫자 + 단위») */
  origin: DraftBoqLineDtoOrigin;
  /**
   * 근거 — 수량을 정한 입력 원문 인용(120자에서 자름) 또는 «첨부 ‘파일명’»
   * @nullable
   */
  basis: string | null;
  /** 사람이 확인해야 하나(수량 없음) */
  needsReview: boolean;
}

/**
 * @nullable
 */
export type DraftBoqDtoKind =
  | (typeof DraftBoqDtoKind)[keyof typeof DraftBoqDtoKind]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DraftBoqDtoKind = {
  construction: "construction",
  service: "service",
} as const;

export interface DraftBoqDto {
  /**
   * 고른 종목 키 — 못 고르면 null
   * @nullable
   */
  workType: string | null;
  /** @nullable */
  label: string | null;
  /** @nullable */
  kind: DraftBoqDtoKind;
  lines: DraftBoqLineDto[];
  /**
   * Σ(수량 × 참고 단가) — 둘 다 있는 줄만, 그런 줄이 없으면 null
   * @nullable
   */
  referenceTotal: number | null;
  /** 참고 합계에 들어간 줄 수 */
  pricedLines: number;
  ai: CostDocumentAiDto;
  warnings: string[];
}

export interface DraftBoqDocumentLineDto {
  /**
   * @maxLength 200
   * @nullable
   */
  section?: string | null;
  /**
   * @minLength 1
   * @maxLength 300
   */
  name: string;
  /**
   * @maxLength 500
   * @nullable
   */
  spec?: string | null;
  /**
   * @maxLength 30
   * @nullable
   */
  unit?: string | null;
  /**
   * @minimum 0
   * @nullable
   */
  quantity?: number | null;
}

export interface DraftBoqDocumentDto {
  /** @maxLength 200 */
  fileName: string;
  /**
   * analyze-document 의 textExcerpt(앞 3,000자를 AI 에 넘긴다)
   * @maxLength 8000
   */
  textExcerpt: string;
  /**
   * @minimum 0
   * @nullable
   */
  budget?: number | null;
  /**
   * 첨부에서 읽은 내역 줄 — 모든 첨부 합이 5줄 이상이면 AI 대신 그대로 쓴다
   * @maxItems 500
   */
  lines?: DraftBoqDocumentLineDto[];
}

/**
 * 견적요청 분야 — 공사 / 제조·용역
 */
export type DraftBoqRequestDtoCategoryType =
  (typeof DraftBoqRequestDtoCategoryType)[keyof typeof DraftBoqRequestDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DraftBoqRequestDtoCategoryType = {
  construction: "construction",
  manufacturing: "manufacturing",
} as const;

export interface DraftBoqRequestDto {
  /** 견적요청 분야 — 공사 / 제조·용역 */
  categoryType: DraftBoqRequestDtoCategoryType;
  /**
   * 공사명·용역명
   * @minLength 1
   * @maxLength 200
   */
  projectName: string;
  /**
   * 고객이 고른 종목 키(공사 enum 값·용역 이름) — 유효하면 무엇보다 우선
   * @maxLength 100
   * @nullable
   */
  workType?: string | null;
  /**
   * 공사 유형 enum 값(ConstructionTypeEnum)
   * @maxLength 100
   * @nullable
   */
  constructionType?: string | null;
  /**
   * 공간 라벨(예 «사무실»)
   * @maxLength 100
   * @nullable
   */
  spaceType?: string | null;
  /**
   * 시공 평수 라벨(예 «10~20평»)
   * @maxLength 100
   * @nullable
   */
  constructionArea?: string | null;
  /**
   * @maxLength 5000
   * @nullable
   */
  description?: string | null;
  /**
   * 추가 요청사항(각 200자 이하)
   * @maxItems 20
   */
  additionalRequests?: string[];
  /** @maxItems 5 */
  documents?: DraftBoqDocumentDto[];
}

/**
 * 이 말로 쓴 규격(spec1). 비우면 원문 규격을 보여 준다
 * @maxLength 500
 * @nullable
 */
export type PutItemTranslationDtoSpec = { [key: string]: unknown } | null;

export interface PutItemTranslationDto {
  /**
   * 이 말로 쓴 물품명
   * @maxLength 500
   */
  name: string;
  /**
   * 이 말로 쓴 규격(spec1). 비우면 원문 규격을 보여 준다
   * @maxLength 500
   * @nullable
   */
  spec?: PutItemTranslationDtoSpec;
}

/**
 * 나라. 휴대폰 국내 모양(0812…/090…)을 읽는 기준이자 가입 계정·회사의 나라
 */
export type GcmOtpRequestDtoCountry =
  (typeof GcmOtpRequestDtoCountry)[keyof typeof GcmOtpRequestDtoCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmOtpRequestDtoCountry = {
  ID: "ID",
  JP: "JP",
} as const;

export type GcmOtpRequestDtoPurpose =
  (typeof GcmOtpRequestDtoPurpose)[keyof typeof GcmOtpRequestDtoPurpose];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmOtpRequestDtoPurpose = {
  SIGNUP: "SIGNUP",
  LOGIN: "LOGIN",
  CONTACT: "CONTACT",
} as const;

export type GcmOtpRequestDtoChannel =
  (typeof GcmOtpRequestDtoChannel)[keyof typeof GcmOtpRequestDtoChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmOtpRequestDtoChannel = {
  EMAIL: "EMAIL",
  WHATSAPP: "WHATSAPP",
} as const;

export type GcmOtpRequestDtoLang =
  (typeof GcmOtpRequestDtoLang)[keyof typeof GcmOtpRequestDtoLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmOtpRequestDtoLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export interface GcmOtpRequestDto {
  /** 나라. 휴대폰 국내 모양(0812…/090…)을 읽는 기준이자 가입 계정·회사의 나라 */
  country?: GcmOtpRequestDtoCountry;
  purpose: GcmOtpRequestDtoPurpose;
  channel: GcmOtpRequestDtoChannel;
  target: string;
  lang?: GcmOtpRequestDtoLang;
}

/**
 * 나라. 휴대폰 국내 모양(0812…/090…)을 읽는 기준이자 가입 계정·회사의 나라
 */
export type GcmSignupDtoCountry =
  (typeof GcmSignupDtoCountry)[keyof typeof GcmSignupDtoCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmSignupDtoCountry = {
  ID: "ID",
  JP: "JP",
} as const;

export type GcmSignupDtoChannel =
  (typeof GcmSignupDtoChannel)[keyof typeof GcmSignupDtoChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmSignupDtoChannel = {
  EMAIL: "EMAIL",
  WHATSAPP: "WHATSAPP",
} as const;

export type GcmSignupDtoLang =
  (typeof GcmSignupDtoLang)[keyof typeof GcmSignupDtoLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmSignupDtoLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export interface GcmSignupDto {
  /** 나라. 휴대폰 국내 모양(0812…/090…)을 읽는 기준이자 가입 계정·회사의 나라 */
  country?: GcmSignupDtoCountry;
  name: string;
  channel: GcmSignupDtoChannel;
  target: string;
  code: string;
  lang?: GcmSignupDtoLang;
  agreeTerms: boolean;
  agreePrivacy: boolean;
  agreeCrossBorder: boolean;
  agreeMarketing: boolean;
}

/**
 * 나라. 휴대폰 국내 모양(0812…/090…)을 읽는 기준이자 가입 계정·회사의 나라
 */
export type GcmLoginDtoCountry =
  (typeof GcmLoginDtoCountry)[keyof typeof GcmLoginDtoCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmLoginDtoCountry = {
  ID: "ID",
  JP: "JP",
} as const;

export type GcmLoginDtoChannel =
  (typeof GcmLoginDtoChannel)[keyof typeof GcmLoginDtoChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmLoginDtoChannel = {
  EMAIL: "EMAIL",
  WHATSAPP: "WHATSAPP",
} as const;

export interface GcmLoginDto {
  /** 나라. 휴대폰 국내 모양(0812…/090…)을 읽는 기준이자 가입 계정·회사의 나라 */
  country?: GcmLoginDtoCountry;
  channel: GcmLoginDtoChannel;
  target: string;
  code: string;
}

export type GcmIdentifierDtoIdType =
  (typeof GcmIdentifierDtoIdType)[keyof typeof GcmIdentifierDtoIdType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmIdentifierDtoIdType = {
  NIB: "NIB",
  NPWP: "NPWP",
  AHU: "AHU",
  CORPORATE_NUMBER: "CORPORATE_NUMBER",
  INVOICE_REG: "INVOICE_REG",
  INSTITUTION_REG: "INSTITUTION_REG",
} as const;

export interface GcmIdentifierDto {
  idType: GcmIdentifierDtoIdType;
  value: string;
}

export interface GcmAddressDto {
  province?: string;
  city?: string;
  detail?: string;
  postalCode?: string;
}

export type GcmKbliDtoVersion =
  (typeof GcmKbliDtoVersion)[keyof typeof GcmKbliDtoVersion];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmKbliDtoVersion = {
  NUMBER_2020: "2020",
  NUMBER_2025: "2025",
} as const;

export interface GcmKbliDto {
  code: string;
  version: GcmKbliDtoVersion;
}

export type GcmPublicLinkDtoKind =
  (typeof GcmPublicLinkDtoKind)[keyof typeof GcmPublicLinkDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmPublicLinkDtoKind = {
  WEBSITE: "WEBSITE",
  SALES_CHANNEL: "SALES_CHANNEL",
  OFFICIAL_PROFILE: "OFFICIAL_PROFILE",
  NONE: "NONE",
} as const;

export interface GcmPublicLinkDto {
  kind: GcmPublicLinkDtoKind;
  url?: string;
}

export type GcmApplicantDtoRelation =
  (typeof GcmApplicantDtoRelation)[keyof typeof GcmApplicantDtoRelation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmApplicantDtoRelation = {
  REPRESENTATIVE: "REPRESENTATIVE",
  EMPLOYEE: "EMPLOYEE",
  DELEGATED_AGENCY: "DELEGATED_AGENCY",
} as const;

export interface GcmApplicantDto {
  relation: GcmApplicantDtoRelation;
  jobTitle: string;
  department?: string;
}

export type GcmOrgCreateDtoOrgType =
  (typeof GcmOrgCreateDtoOrgType)[keyof typeof GcmOrgCreateDtoOrgType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmOrgCreateDtoOrgType = {
  COMPANY: "COMPANY",
  SOLE_PROPRIETOR: "SOLE_PROPRIETOR",
  COOPERATIVE: "COOPERATIVE",
  INSTITUTION: "INSTITUTION",
  OTHER: "OTHER",
} as const;

/**
 * @nullable
 */
export type GcmOrgCreateDtoLegalForm =
  | (typeof GcmOrgCreateDtoLegalForm)[keyof typeof GcmOrgCreateDtoLegalForm]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmOrgCreateDtoLegalForm = {
  PT: "PT",
  PT_PERORANGAN: "PT_PERORANGAN",
  CV: "CV",
  FIRMA: "FIRMA",
  KOPERASI: "KOPERASI",
  YAYASAN: "YAYASAN",
  KABUSHIKI: "KABUSHIKI",
  GODO: "GODO",
  GOMEI: "GOMEI",
  GOSHI: "GOSHI",
  IPPAN_SHADAN: "IPPAN_SHADAN",
  IPPAN_ZAIDAN: "IPPAN_ZAIDAN",
  SOLE_PROPRIETOR: "SOLE_PROPRIETOR",
  OTHER: "OTHER",
} as const;

/**
 * @nullable
 */
export type GcmOrgCreateDtoPublicLink = GcmPublicLinkDto | null;

export type GcmOrgCreateDtoCountry =
  (typeof GcmOrgCreateDtoCountry)[keyof typeof GcmOrgCreateDtoCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmOrgCreateDtoCountry = {
  ID: "ID",
  JP: "JP",
} as const;

export interface GcmOrgCreateDto {
  orgType?: GcmOrgCreateDtoOrgType;
  legalName?: string;
  /** @nullable */
  legalForm?: GcmOrgCreateDtoLegalForm;
  /** @nullable */
  brandName?: string | null;
  identifiers?: GcmIdentifierDto[];
  address?: GcmAddressDto;
  kbli?: GcmKbliDto[];
  mainProducts?: string[];
  /** @nullable */
  establishedYear?: number | null;
  /** @nullable */
  contactPhone?: string | null;
  /** @nullable */
  contactEmail?: string | null;
  /** @nullable */
  publicLink?: GcmOrgCreateDtoPublicLink;
  applicant?: GcmApplicantDto;
  country?: GcmOrgCreateDtoCountry;
}

/**
 * 나라. 휴대폰 국내 모양(0812…/090…)을 읽는 기준이자 가입 계정·회사의 나라
 */
export type GcmJoinDtoCountry =
  (typeof GcmJoinDtoCountry)[keyof typeof GcmJoinDtoCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmJoinDtoCountry = {
  ID: "ID",
  JP: "JP",
} as const;

export type GcmJoinDtoIdType =
  (typeof GcmJoinDtoIdType)[keyof typeof GcmJoinDtoIdType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmJoinDtoIdType = {
  NIB: "NIB",
  NPWP: "NPWP",
  AHU: "AHU",
  CORPORATE_NUMBER: "CORPORATE_NUMBER",
  INVOICE_REG: "INVOICE_REG",
  INSTITUTION_REG: "INSTITUTION_REG",
} as const;

export interface GcmJoinDto {
  /** 나라. 휴대폰 국내 모양(0812…/090…)을 읽는 기준이자 가입 계정·회사의 나라 */
  country?: GcmJoinDtoCountry;
  idType: GcmJoinDtoIdType;
  value: string;
  applicant: GcmApplicantDto;
}

export type GcmOrgPatchDtoOrgType =
  (typeof GcmOrgPatchDtoOrgType)[keyof typeof GcmOrgPatchDtoOrgType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmOrgPatchDtoOrgType = {
  COMPANY: "COMPANY",
  SOLE_PROPRIETOR: "SOLE_PROPRIETOR",
  COOPERATIVE: "COOPERATIVE",
  INSTITUTION: "INSTITUTION",
  OTHER: "OTHER",
} as const;

/**
 * @nullable
 */
export type GcmOrgPatchDtoLegalForm =
  | (typeof GcmOrgPatchDtoLegalForm)[keyof typeof GcmOrgPatchDtoLegalForm]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmOrgPatchDtoLegalForm = {
  PT: "PT",
  PT_PERORANGAN: "PT_PERORANGAN",
  CV: "CV",
  FIRMA: "FIRMA",
  KOPERASI: "KOPERASI",
  YAYASAN: "YAYASAN",
  KABUSHIKI: "KABUSHIKI",
  GODO: "GODO",
  GOMEI: "GOMEI",
  GOSHI: "GOSHI",
  IPPAN_SHADAN: "IPPAN_SHADAN",
  IPPAN_ZAIDAN: "IPPAN_ZAIDAN",
  SOLE_PROPRIETOR: "SOLE_PROPRIETOR",
  OTHER: "OTHER",
} as const;

/**
 * @nullable
 */
export type GcmOrgPatchDtoPublicLink = GcmPublicLinkDto | null;

export interface GcmOrgPatchDto {
  orgType?: GcmOrgPatchDtoOrgType;
  legalName?: string;
  /** @nullable */
  legalForm?: GcmOrgPatchDtoLegalForm;
  /** @nullable */
  brandName?: string | null;
  identifiers?: GcmIdentifierDto[];
  address?: GcmAddressDto;
  kbli?: GcmKbliDto[];
  mainProducts?: string[];
  /** @nullable */
  establishedYear?: number | null;
  /** @nullable */
  contactPhone?: string | null;
  /** @nullable */
  contactEmail?: string | null;
  /** @nullable */
  publicLink?: GcmOrgPatchDtoPublicLink;
  applicant?: GcmApplicantDto;
}

export type GcmDocumentUploadDtoKind =
  (typeof GcmDocumentUploadDtoKind)[keyof typeof GcmDocumentUploadDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmDocumentUploadDtoKind = {
  NIB_CERT: "NIB_CERT",
  AHU_DEED: "AHU_DEED",
  NPWP_CARD: "NPWP_CARD",
  REGISTRY_CERT: "REGISTRY_CERT",
  INVOICE_REG_CERT: "INVOICE_REG_CERT",
  OPENING_NOTICE: "OPENING_NOTICE",
  INSTITUTION_REG: "INSTITUTION_REG",
  EMPLOYMENT_PROOF: "EMPLOYMENT_PROOF",
  DELEGATION_LETTER: "DELEGATION_LETTER",
  OTHER: "OTHER",
} as const;

export interface GcmDocumentUploadDto {
  kind: GcmDocumentUploadDtoKind;
}

export type GcmInviteDtoChannel =
  (typeof GcmInviteDtoChannel)[keyof typeof GcmInviteDtoChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmInviteDtoChannel = {
  EMAIL: "EMAIL",
  WHATSAPP: "WHATSAPP",
} as const;

export type GcmInviteDtoRole =
  (typeof GcmInviteDtoRole)[keyof typeof GcmInviteDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmInviteDtoRole = {
  ADMIN: "ADMIN",
  AUTHOR: "AUTHOR",
  PUBLISH_APPROVER: "PUBLISH_APPROVER",
  VIEWER: "VIEWER",
} as const;

export interface GcmInviteDto {
  channel: GcmInviteDtoChannel;
  target: string;
  role: GcmInviteDtoRole;
}

export type GcmMemberRoleDtoRole =
  (typeof GcmMemberRoleDtoRole)[keyof typeof GcmMemberRoleDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmMemberRoleDtoRole = {
  ADMIN: "ADMIN",
  AUTHOR: "AUTHOR",
  PUBLISH_APPROVER: "PUBLISH_APPROVER",
  VIEWER: "VIEWER",
} as const;

export interface GcmMemberRoleDto {
  role: GcmMemberRoleDtoRole;
}

export type AdminGcmIdentifierDtoVerifyStatus =
  (typeof AdminGcmIdentifierDtoVerifyStatus)[keyof typeof AdminGcmIdentifierDtoVerifyStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmIdentifierDtoVerifyStatus = {
  PENDING: "PENDING",
  MATCHED: "MATCHED",
  MISMATCH: "MISMATCH",
  UNDETERMINED: "UNDETERMINED",
  WAITING_OFFICIAL: "WAITING_OFFICIAL",
} as const;

export interface AdminGcmIdentifierDto {
  verifyStatus: AdminGcmIdentifierDtoVerifyStatus;
  note?: string;
}

export type AdminGcmOrgDecisionDtoDecision =
  (typeof AdminGcmOrgDecisionDtoDecision)[keyof typeof AdminGcmOrgDecisionDtoDecision];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmOrgDecisionDtoDecision = {
  APPROVE: "APPROVE",
  NEEDS_INFO: "NEEDS_INFO",
  HOLD: "HOLD",
  REJECT: "REJECT",
  WAITING_OFFICIAL: "WAITING_OFFICIAL",
} as const;

export interface AdminGcmOrgDecisionDto {
  decision: AdminGcmOrgDecisionDtoDecision;
  /** APPROVE 외에는 필수 — 회원에게 그대로 전달 */
  note?: string;
}

export type AdminGcmMembershipDecisionDtoDecision =
  (typeof AdminGcmMembershipDecisionDtoDecision)[keyof typeof AdminGcmMembershipDecisionDtoDecision];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmMembershipDecisionDtoDecision = {
  APPROVE: "APPROVE",
  REJECT: "REJECT",
} as const;

export interface AdminGcmMembershipDecisionDto {
  decision: AdminGcmMembershipDecisionDtoDecision;
  note?: string;
}

export interface GcmMatchLineDto {
  key: string;
  name: string;
  brand?: string;
  spec?: string;
  code?: string;
}

export type GcmMatchDtoLang =
  (typeof GcmMatchDtoLang)[keyof typeof GcmMatchDtoLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmMatchDtoLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export interface GcmMatchDto {
  lines: GcmMatchLineDto[];
  lang?: GcmMatchDtoLang;
}

export type GcmBulkItemRowDtoCurrency =
  (typeof GcmBulkItemRowDtoCurrency)[keyof typeof GcmBulkItemRowDtoCurrency];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmBulkItemRowDtoCurrency = {
  IDR: "IDR",
  JPY: "JPY",
  USD: "USD",
  KRW: "KRW",
} as const;

export type GcmBulkItemRowDtoLang =
  (typeof GcmBulkItemRowDtoLang)[keyof typeof GcmBulkItemRowDtoLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmBulkItemRowDtoLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export interface GcmBulkItemRowDto {
  /** @nullable */
  price?: number | null;
  currency?: GcmBulkItemRowDtoCurrency;
  isSelling?: boolean;
  /** @nullable */
  stockOnHand?: number | null;
  /** @nullable */
  leadTimeDays?: number | null;
  /** @nullable */
  minOrderQty?: number | null;
  /** @nullable */
  memo?: string | null;
  lang?: GcmBulkItemRowDtoLang;
  key: string;
  itemId: string;
}

export type GcmBulkItemsDtoLang =
  (typeof GcmBulkItemsDtoLang)[keyof typeof GcmBulkItemsDtoLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmBulkItemsDtoLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export interface GcmBulkItemsDto {
  rows: GcmBulkItemRowDto[];
  lang?: GcmBulkItemsDtoLang;
}

export interface GcmBulkRequestRowDto {
  name: string;
  manufacturer?: string;
  brand?: string;
  unit?: string;
  spec?: string;
  reason?: string;
  referenceUrl?: string;
  key: string;
}

export interface GcmBulkRequestsDto {
  requests: GcmBulkRequestRowDto[];
}

export type GcmMyItemDtoCurrency =
  (typeof GcmMyItemDtoCurrency)[keyof typeof GcmMyItemDtoCurrency];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmMyItemDtoCurrency = {
  IDR: "IDR",
  JPY: "JPY",
  USD: "USD",
  KRW: "KRW",
} as const;

export type GcmMyItemDtoLang =
  (typeof GcmMyItemDtoLang)[keyof typeof GcmMyItemDtoLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmMyItemDtoLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export interface GcmMyItemDto {
  /** @nullable */
  price?: number | null;
  currency?: GcmMyItemDtoCurrency;
  isSelling?: boolean;
  /** @nullable */
  stockOnHand?: number | null;
  /** @nullable */
  leadTimeDays?: number | null;
  /** @nullable */
  minOrderQty?: number | null;
  /** @nullable */
  memo?: string | null;
  lang?: GcmMyItemDtoLang;
}

export interface GcmItemRequestDto {
  name: string;
  manufacturer?: string;
  brand?: string;
  unit?: string;
  spec?: string;
  reason?: string;
  referenceUrl?: string;
}

export interface AdminGcmItemLinkDto {
  itemId: string;
}

export interface AdminGcmItemRejectDto {
  comment: string;
}

export type GcmItemImportRowDtoCurrency =
  (typeof GcmItemImportRowDtoCurrency)[keyof typeof GcmItemImportRowDtoCurrency];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmItemImportRowDtoCurrency = {
  IDR: "IDR",
  JPY: "JPY",
  USD: "USD",
  KRW: "KRW",
} as const;

export interface GcmItemImportRowDto {
  /** 시트의 줄 번호(1부터) */
  rowNo: number;
  name: string;
  brand?: string;
  spec?: string;
  unit?: string;
  code?: string;
  /** @nullable */
  price?: number | null;
  currency?: GcmItemImportRowDtoCurrency;
  /** @nullable */
  stockOnHand?: number | null;
  /** @nullable */
  leadTimeDays?: number | null;
  /** @nullable */
  minOrderQty?: number | null;
  /** 내보낸 파일의 물품 ID — 매칭 없이 저장 */
  itemId?: string;
}

export type GcmItemImportDtoLang =
  (typeof GcmItemImportDtoLang)[keyof typeof GcmItemImportDtoLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmItemImportDtoLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export interface GcmItemImportDto {
  fileName: string;
  /** 나눠 올릴 때 둘째 묶음부터 — 첫 응답의 batchId */
  batchId?: string;
  rows: GcmItemImportRowDto[];
  lang?: GcmItemImportDtoLang;
}

export interface AdminGcmBulkLinkRowDto {
  requestId: string;
  itemId: string;
}

export interface AdminGcmBulkLinkDto {
  items: AdminGcmBulkLinkRowDto[];
}

export interface AdminGcmBulkRejectDto {
  requestIds: string[];
  comment: string;
}

export interface AdminGcmBulkCreateDto {
  requestIds: string[];
  /** 새 마스터 물품의 카테고리 */
  categoryId: string;
}

export type GcmProfileDtoLang =
  (typeof GcmProfileDtoLang)[keyof typeof GcmProfileDtoLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmProfileDtoLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export interface GcmProfileDto {
  name?: string;
  lang?: GcmProfileDtoLang;
  marketingAgreed?: boolean;
}

export type GcmContactOtpDtoChannel =
  (typeof GcmContactOtpDtoChannel)[keyof typeof GcmContactOtpDtoChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmContactOtpDtoChannel = {
  EMAIL: "EMAIL",
  WHATSAPP: "WHATSAPP",
} as const;

export type GcmContactOtpDtoLang =
  (typeof GcmContactOtpDtoLang)[keyof typeof GcmContactOtpDtoLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmContactOtpDtoLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export interface GcmContactOtpDto {
  channel: GcmContactOtpDtoChannel;
  target: string;
  lang?: GcmContactOtpDtoLang;
}

export type GcmContactConfirmDtoChannel =
  (typeof GcmContactConfirmDtoChannel)[keyof typeof GcmContactConfirmDtoChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmContactConfirmDtoChannel = {
  EMAIL: "EMAIL",
  WHATSAPP: "WHATSAPP",
} as const;

export interface GcmContactConfirmDto {
  channel: GcmContactConfirmDtoChannel;
  target: string;
  code: string;
}

export interface GcmDeletionDto {
  reason?: string;
}

export interface AdminRequiredNoteDto {
  note: string;
}

export interface GcmNotificationsReadDto {
  ids?: string[];
  all?: boolean;
}

/**
 * @nullable
 */
export type PriceAuditRowDtoApplyResult =
  | (typeof PriceAuditRowDtoApplyResult)[keyof typeof PriceAuditRowDtoApplyResult]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceAuditRowDtoApplyResult = {
  APPLIED: "APPLIED",
  CONFLICT: "CONFLICT",
  SKIPPED: "SKIPPED",
} as const;

export interface PriceAuditRowDto {
  id: string;
  itemId: string;
  /** @nullable */
  itemName: string | null;
  /** @nullable */
  itemSpec: string | null;
  /**
   * 시트 생성 시 내 단가
   * @nullable
   */
  currentPrice: number | null;
  /** @nullable */
  currentTaxType: string | null;
  /** @nullable */
  currentStatus: string | null;
  /**
   * 거래일자
   * @nullable
   */
  priceDatedOn: string | null;
  /**
   * 타사 최저가(숫자만, 자기 것 제외)
   * @nullable
   */
  marketLow: number | null;
  /**
   * null = 아직 안 채움
   * @nullable
   */
  newPrice: number | null;
  confirmedUnchanged: boolean;
  /** @nullable */
  note: string | null;
  /** @nullable */
  filledAt: string | null;
  /** @nullable */
  applyResult: PriceAuditRowDtoApplyResult;
}

export type PriceAuditSheetDetailDtoStatus =
  (typeof PriceAuditSheetDetailDtoStatus)[keyof typeof PriceAuditSheetDetailDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceAuditSheetDetailDtoStatus = {
  DRAFT: "DRAFT",
  APPLIED: "APPLIED",
  DISCARDED: "DISCARDED",
} as const;

/**
 * {staleDays, categoryId, autoQuoteOnly, limit}
 */
export type PriceAuditSheetDetailDtoCriteria = { [key: string]: unknown };

export interface PriceAuditSheetDetailDto {
  id: string;
  title: string;
  status: PriceAuditSheetDetailDtoStatus;
  /** {staleDays, categoryId, autoQuoteOnly, limit} */
  criteria: PriceAuditSheetDetailDtoCriteria;
  /**
   * 운영자가 밀어 준 시트면 그 운영자 id
   * @nullable
   */
  createdByAdmin: string | null;
  rowCount: number;
  /**
   * 반영이 만든 업로드 배치. 되돌리기는 upload-batches/:id/undo
   * @nullable
   */
  appliedBatchId: string | null;
  /** @nullable */
  appliedAt: string | null;
  /** @nullable */
  appliedCount: number | null;
  /** @nullable */
  conflictCount: number | null;
  /** @nullable */
  discardedAt: string | null;
  createdAt: string;
  updatedAt: string;
  rows: PriceAuditRowDto[];
}

export interface PriceAuditCriteriaDto {
  /** 이 일수보다 오래된 거래일자만. 없으면 전부(낡은 순). */
  staleDays?: number;
  /** items_v2_base.category_id — 그 분류의 하위 분류까지 포함 */
  categoryId?: string;
  /** 자동견적 대상 품목만 */
  autoQuoteOnly?: boolean;
  /** 최대 행 수(기본 200, 상한 500) */
  limit?: number;
}

export interface CreatePriceAuditSheetDto {
  /**
   * 시트 제목. 없으면 «YYYY-MM-DD 단가 점검»
   * @maxLength 100
   */
  title?: string;
  criteria?: PriceAuditCriteriaDto;
}

export type PriceAuditSheetDtoStatus =
  (typeof PriceAuditSheetDtoStatus)[keyof typeof PriceAuditSheetDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceAuditSheetDtoStatus = {
  DRAFT: "DRAFT",
  APPLIED: "APPLIED",
  DISCARDED: "DISCARDED",
} as const;

/**
 * {staleDays, categoryId, autoQuoteOnly, limit}
 */
export type PriceAuditSheetDtoCriteria = { [key: string]: unknown };

export interface PriceAuditSheetDto {
  id: string;
  title: string;
  status: PriceAuditSheetDtoStatus;
  /** {staleDays, categoryId, autoQuoteOnly, limit} */
  criteria: PriceAuditSheetDtoCriteria;
  /**
   * 운영자가 밀어 준 시트면 그 운영자 id
   * @nullable
   */
  createdByAdmin: string | null;
  rowCount: number;
  /**
   * 반영이 만든 업로드 배치. 되돌리기는 upload-batches/:id/undo
   * @nullable
   */
  appliedBatchId: string | null;
  /** @nullable */
  appliedAt: string | null;
  /** @nullable */
  appliedCount: number | null;
  /** @nullable */
  conflictCount: number | null;
  /** @nullable */
  discardedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PatchPriceAuditRowDto {
  /**
   * 신규단가(>0). null 이면 채운 값을 지운다. 0 은 단가가 될 수 없다.
   * @nullable
   */
  newPrice?: number | null;
  /** 「변동 없음」 확인. true 면 신규단가는 지워진다. */
  confirmedUnchanged?: boolean;
  /**
   * @maxLength 500
   * @nullable
   */
  note?: string | null;
}

export interface PriceAuditConflictDto {
  rowId: string;
  itemId: string;
  /** @nullable */
  expectedPrice: number | null;
  /** @nullable */
  actualPrice: number | null;
}

export type PriceAuditApplyResultDtoStatus =
  (typeof PriceAuditApplyResultDtoStatus)[keyof typeof PriceAuditApplyResultDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceAuditApplyResultDtoStatus = {
  DRAFT: "DRAFT",
  APPLIED: "APPLIED",
  DISCARDED: "DISCARDED",
} as const;

export interface PriceAuditApplyResultDto {
  sheetId: string;
  status: PriceAuditApplyResultDtoStatus;
  /** @nullable */
  appliedBatchId: string | null;
  appliedCount: number;
  skippedCount: number;
  conflictCount: number;
  conflicts: PriceAuditConflictDto[];
}

export interface AdminCreatePriceAuditSheetDto {
  /**
   * 시트 제목. 없으면 «YYYY-MM-DD 단가 점검»
   * @maxLength 100
   */
  title?: string;
  criteria?: PriceAuditCriteriaDto;
  /** 시트를 받을 공급사(users.id) */
  supplierUserId: string;
}

export type PriceObservationIgnoredDtoReason =
  (typeof PriceObservationIgnoredDtoReason)[keyof typeof PriceObservationIgnoredDtoReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceObservationIgnoredDtoReason = {
  "unknown-item": "unknown-item",
  "supplier-unmapped": "supplier-unmapped",
  "invalid-price": "invalid-price",
  "invalid-date": "invalid-date",
} as const;

export interface PriceObservationIgnoredDto {
  externalKey: string;
  reason: PriceObservationIgnoredDtoReason;
}

/**
 * 업체(씨마켓 로그인 id)별 새로 생긴 제안 수 — 씨마켓 벨 알림의 근거
 */
export type PriceObservationIngestResultDtoProposalsBySupplier = {
  [key: string]: number;
};

export interface PriceObservationIngestResultDto {
  /** 관측 로그에 새로 생긴 수 */
  accepted: number;
  /** 관측 로그에서 갱신된 수 */
  updated: number;
  /** 업체가 동의한 덮어쓰기로 현재가가 바뀐 수 */
  catalogUpdated: number;
  /** 없던 단가가 새로 등재된 수 */
  inserted: number;
  /** 제안으로 남긴 수 */
  proposed: number;
  /** 기존 단가를 그대로 둔 수 */
  kept: number;
  ignored: PriceObservationIgnoredDto[];
  /** 업체(씨마켓 로그인 id)별 새로 생긴 제안 수 — 씨마켓 벨 알림의 근거 */
  proposalsBySupplier: PriceObservationIngestResultDtoProposalsBySupplier;
}

/**
 * 상호
 */
export type PriceObservationSupplierDtoName = { [key: string]: unknown };

export interface PriceObservationSupplierDto {
  /** 씨마켓 로그인 id (= 세모 suppliers.supplier_id) */
  externalId: string;
  /** 상호 */
  name?: PriceObservationSupplierDtoName;
  /** 업체가 응찰 화면의 «응찰 단가를 세모 물품관리에 일괄 반영» 스위치를 켰는가. true 면 현재가를 덮어쓴다(동의한 것). false/없음이면 «없으면 등재, 있고 더 최신·다르면 제안, 아니면 둔다». */
  updateCatalog?: boolean;
}

export type PriceObservationBuyerDtoExternalId = { [key: string]: unknown };

export type PriceObservationBuyerDtoName = { [key: string]: unknown };

export interface PriceObservationBuyerDto {
  externalId?: PriceObservationBuyerDtoExternalId;
  name?: PriceObservationBuyerDtoName;
}

export type PriceObservationLineTextDtoName = { [key: string]: unknown };

export type PriceObservationLineTextDtoSpec = { [key: string]: unknown };

export interface PriceObservationLineTextDto {
  name?: PriceObservationLineTextDtoName;
  spec?: PriceObservationLineTextDtoSpec;
}

/**
 * 세모 물품 id(items_v2_base.id). 없으면 아직 물품이 정해지지 않은 줄 — line.name 으로 이력만 남긴다
 * @nullable
 */
export type PriceObservationInputDtoItemId = { [key: string]: unknown } | null;

/**
 * 응찰 철회·공고 삭제면 voided
 */
export type PriceObservationInputDtoStatus =
  (typeof PriceObservationInputDtoStatus)[keyof typeof PriceObservationInputDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceObservationInputDtoStatus = {
  active: "active",
  voided: "voided",
} as const;

/**
 * 낙찰 확정 시각(ISO)
 */
export type PriceObservationInputDtoAwardedAt = { [key: string]: unknown };

/**
 * unitPrice 의 부가세 축
 */
export type PriceObservationInputDtoTaxType =
  (typeof PriceObservationInputDtoTaxType)[keyof typeof PriceObservationInputDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceObservationInputDtoTaxType = {
  INCLUSIVE: "INCLUSIVE",
  EXCLUSIVE: "EXCLUSIVE",
} as const;

/**
 * 공급가 단가(guds_unt_splpc)
 */
export type PriceObservationInputDtoSupplyUnitPrice = {
  [key: string]: unknown;
};

export type PriceObservationInputDtoQuantity = { [key: string]: unknown };

export type PriceObservationInputDtoUnit = { [key: string]: unknown };

/**
 * 씨마켓 공고번호
 */
export type PriceObservationInputDtoBidNo = { [key: string]: unknown };

export interface PriceObservationInputDto {
  /** 씨마켓 줄 키 — 멱등키. cmarket:bid:{buy_idx}:{buy_seq}:{guds_seq} */
  externalKey: string;
  /**
   * 세모 물품 id(items_v2_base.id). 없으면 아직 물품이 정해지지 않은 줄 — line.name 으로 이력만 남긴다
   * @nullable
   */
  itemId?: PriceObservationInputDtoItemId;
  /** 응찰 철회·공고 삭제면 voided */
  status?: PriceObservationInputDtoStatus;
  /** 낙찰 여부. 낙찰 확정 시 true, 낙찰 취소 시 false */
  won?: boolean;
  /** 낙찰 확정 시각(ISO) */
  awardedAt?: PriceObservationInputDtoAwardedAt;
  /** 응찰 단가(씨마켓 guds_untpc, 부가세 포함 그대로) */
  unitPrice: number;
  /** unitPrice 의 부가세 축 */
  taxType: PriceObservationInputDtoTaxType;
  /** 공급가 단가(guds_unt_splpc) */
  supplyUnitPrice?: PriceObservationInputDtoSupplyUnitPrice;
  quantity?: PriceObservationInputDtoQuantity;
  unit?: PriceObservationInputDtoUnit;
  supplier?: PriceObservationSupplierDto;
  buyer?: PriceObservationBuyerDto;
  /** 씨마켓 공고번호 */
  bidNo?: PriceObservationInputDtoBidNo;
  line?: PriceObservationLineTextDto;
  /** 응찰 시각(ISO) — «YYYY.MM.DD 기록» 의 그 날짜 */
  occurredAt: string;
}

export interface PriceObservationBatchDto {
  /** 한 번에 최대 200건 */
  observations: PriceObservationInputDto[];
}

export interface PriceObservationStatusResultDto {
  /** 상태가 바뀐 관측 수 */
  updated: number;
  /** 철회로 닫힌 대기 제안 수 */
  dismissedProposals: number;
}

export type PriceObservationStatusDtoStatus =
  (typeof PriceObservationStatusDtoStatus)[keyof typeof PriceObservationStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceObservationStatusDtoStatus = {
  active: "active",
  voided: "voided",
} as const;

/**
 * 낙찰 확정 시각(ISO). 낙찰 취소면 null
 */
export type PriceObservationStatusDtoAwardedAt = { [key: string]: unknown };

export interface PriceObservationStatusDto {
  /** 관측 열쇠(externalKey) 목록, 최대 500 */
  externalKeys?: string[];
  /** 공고번호 — supplierExternalId 와 함께 (공고, 공급사) 축 */
  bidNo?: string;
  /** 씨마켓 로그인 id */
  supplierExternalId?: string;
  /** (공고, 공급사) 축에서 건드리지 않을 열쇠 — 새 응찰의 열쇠 */
  excludeExternalKeys?: string[];
  status?: PriceObservationStatusDtoStatus;
  /** 낙찰 여부 */
  won?: boolean;
  /** 낙찰 확정 시각(ISO). 낙찰 취소면 null */
  awardedAt?: PriceObservationStatusDtoAwardedAt;
}

export type SupplierPriceProposalDtoTaxType =
  (typeof SupplierPriceProposalDtoTaxType)[keyof typeof SupplierPriceProposalDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierPriceProposalDtoTaxType = {
  INCLUSIVE: "INCLUSIVE",
  EXCLUSIVE: "EXCLUSIVE",
} as const;

export type SupplierPriceProposalDtoStatus =
  (typeof SupplierPriceProposalDtoStatus)[keyof typeof SupplierPriceProposalDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierPriceProposalDtoStatus = {
  pending: "pending",
  applied: "applied",
  dismissed: "dismissed",
  superseded: "superseded",
} as const;

export interface SupplierPriceProposalDto {
  id: string;
  itemId: string;
  proposedPrice: number;
  taxType: SupplierPriceProposalDtoTaxType;
  /** @nullable */
  currentPrice: number | null;
  /** 응찰일(ISO) — «YYYY.MM.DD 기록» */
  quotedAt: string;
  /** @nullable */
  bidNo: string | null;
  won: boolean;
  status: SupplierPriceProposalDtoStatus;
  createdAt: string;
}

export interface SupplierPriceProposalCountDto {
  /** 대기 중인 제안 수 */
  pending: number;
}

export type SupplierPriceProposalApplyResultDtoTaxType =
  (typeof SupplierPriceProposalApplyResultDtoTaxType)[keyof typeof SupplierPriceProposalApplyResultDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierPriceProposalApplyResultDtoTaxType = {
  INCLUSIVE: "INCLUSIVE",
  EXCLUSIVE: "EXCLUSIVE",
} as const;

export interface SupplierPriceProposalApplyResultDto {
  proposalId: string;
  itemId: string;
  price: number;
  taxType: SupplierPriceProposalApplyResultDtoTaxType;
  /** 반영된 거래일자(=응찰일) */
  transactionDate: string;
  /**
   * 되돌리기용 업로드 배치 id
   * @nullable
   */
  appliedBatchId: string | null;
}

export interface WebhookSubscriptionWithSecretResponseDto {
  id: string;
  url: string;
  topics: string[];
  isActive: boolean;
  /** @nullable */
  disabledReason: string | null;
  /** @nullable */
  disabledAt: string | null;
  consecutiveFailures: number;
  /** @nullable */
  lastSuccessAt: string | null;
  createdAt: string;
  updatedAt: string;
  /** 서명 비밀키 평문. 이 응답에서만 노출된다. 잃어버리면 [비밀키 회전] 으로 새로 받는다. */
  secret: string;
}

export type CreateWebhookSubscriptionDtoTopicsItem =
  (typeof CreateWebhookSubscriptionDtoTopicsItem)[keyof typeof CreateWebhookSubscriptionDtoTopicsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateWebhookSubscriptionDtoTopicsItem = {
  "contract/awarded": "contract/awarded",
  "shipment/shipped": "shipment/shipped",
  "shipment/delivered": "shipment/delivered",
  "shipment/exception": "shipment/exception",
  "shipment/received": "shipment/received",
  "shipment/disputed": "shipment/disputed",
  "shipment/dispute_resolved": "shipment/dispute_resolved",
  "shipment/canceled": "shipment/canceled",
} as const;

export interface CreateWebhookSubscriptionDto {
  /** 수신 URL. https 만 허용. 사설/내부 주소로 해석되면 거부된다. */
  url: string;
  /** 구독 토픽 */
  topics: CreateWebhookSubscriptionDtoTopicsItem[];
}

export interface WebhookSubscriptionResponseDto {
  id: string;
  url: string;
  topics: string[];
  isActive: boolean;
  /** @nullable */
  disabledReason: string | null;
  /** @nullable */
  disabledAt: string | null;
  consecutiveFailures: number;
  /** @nullable */
  lastSuccessAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export type UpdateWebhookSubscriptionDtoTopicsItem =
  (typeof UpdateWebhookSubscriptionDtoTopicsItem)[keyof typeof UpdateWebhookSubscriptionDtoTopicsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateWebhookSubscriptionDtoTopicsItem = {
  "contract/awarded": "contract/awarded",
  "shipment/shipped": "shipment/shipped",
  "shipment/delivered": "shipment/delivered",
  "shipment/exception": "shipment/exception",
  "shipment/received": "shipment/received",
  "shipment/disputed": "shipment/disputed",
  "shipment/dispute_resolved": "shipment/dispute_resolved",
  "shipment/canceled": "shipment/canceled",
} as const;

export interface UpdateWebhookSubscriptionDto {
  /** 수신 URL(https) */
  url?: string;
  /** 구독 토픽 */
  topics?: UpdateWebhookSubscriptionDtoTopicsItem[];
  /** true 로 보내면 자동 정지된 구독을 재활성화한다(사유·연속 실패 초기화). false 면 정지. */
  isActive?: boolean;
}

export type WebhookDeliveryResponseDtoStatus =
  (typeof WebhookDeliveryResponseDtoStatus)[keyof typeof WebhookDeliveryResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebhookDeliveryResponseDtoStatus = {
  PENDING: "PENDING",
  DELIVERED: "DELIVERED",
  RETRYING: "RETRYING",
  HELD: "HELD",
  DEAD: "DEAD",
} as const;

export interface WebhookDeliveryResponseDto {
  id: string;
  subscriptionId: string;
  /** 봉투 id(= 사건 id). 재배달돼도 같다. */
  eventId: string;
  topic: string;
  status: WebhookDeliveryResponseDtoStatus;
  attemptCount: number;
  /** @nullable */
  lastStatusCode: number | null;
  /** @nullable */
  lastError: string | null;
  nextAttemptAt: string;
  /** @nullable */
  deliveredAt: string | null;
  createdAt: string;
}

export interface WebhookTestResultDto {
  delivery: WebhookDeliveryResponseDto;
  /** delivered | retry | hold | dead | auth_failure */
  outcome: string;
  /** @nullable */
  statusCode: number | null;
}

export interface ShippingCourierDto {
  /** 택배사 코드 */
  code: string;
  /** 택배사 이름 */
  name: string;
  /** 자동 조회가 되는 택배사인가(직접배송·기타는 false) */
  autoTracked: boolean;
}

export interface SuggestedCouriersDto {
  /** 송장번호 모양으로 추린 택배사 후보(확정이 아니다 — 공급사가 고른다) */
  couriers: ShippingCourierDto[];
}

export interface ShippingParcelEventDto {
  /**
   * 발생 시각(ISO)
   * @nullable
   */
  at?: string | null;
  /**
   * 위치
   * @nullable
   */
  where?: string | null;
  /**
   * 처리 내용
   * @nullable
   */
  kind?: string | null;
}

/**
 * 이 송장(상자)만의 배송 상태. 발송이 이미 끝났거나(사람이 «배송 완료» 등) 준비중이면 발송 상태를 따른다
 */
export type ShippingParcelDtoDeliveryStatus =
  (typeof ShippingParcelDtoDeliveryStatus)[keyof typeof ShippingParcelDtoDeliveryStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShippingParcelDtoDeliveryStatus = {
  READY: "READY",
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  EXCEPTION: "EXCEPTION",
  RETURNED: "RETURNED",
  CANCELED: "CANCELED",
} as const;

/**
 * 마지막 이력 한 줄
 * @nullable
 */
export type ShippingParcelDtoLastEvent = ShippingParcelEventDto | null;

export interface ShippingParcelDto {
  /** 이 발송 안 송장 순번(1부터) */
  seq: number;
  /** 송장번호(숫자·영문만) */
  trackingNo: string;
  /**
   * 택배사 공식 조회 페이지 링크
   * @nullable
   */
  trackingUrl?: string | null;
  /** 이 송장(상자)만의 배송 상태. 발송이 이미 끝났거나(사람이 «배송 완료» 등) 준비중이면 발송 상태를 따른다 */
  deliveryStatus: ShippingParcelDtoDeliveryStatus;
  /**
   * 예외 분류(EXCEPTION 일 때만)
   * @nullable
   */
  exceptionCode?: string | null;
  /**
   * 택배사 단계 1~6
   * @nullable
   */
  trackingLevel?: number | null;
  /**
   * 단계 문구(«배송중» 등)
   * @nullable
   */
  trackingLabel?: string | null;
  /**
   * 이 송장의 배송 완료 시각
   * @nullable
   */
  deliveredAt?: string | null;
  /**
   * 마지막 이력 한 줄
   * @nullable
   */
  lastEvent?: ShippingParcelDtoLastEvent;
  /**
   * 마지막 조회 실패·결과 없음 사유(성공이면 null)
   * @nullable
   */
  syncError?: string | null;
}

export interface ShippingDeliveryProofDto {
  /** 공급사가 적은 건넨 일시 */
  handedAt: string;
  /** 받은 분(인수자) 이름 */
  receiverName: string;
  /**
   * 인수자 부서
   * @nullable
   */
  receiverDept?: string | null;
  /**
   * 메모
   * @nullable
   */
  note?: string | null;
}

/**
 * 신고 종류 — DAMAGED 파손 · MISSING_ITEMS 수량 누락 · WRONG_ITEM 오배송 · NOT_RECEIVED 미수령 · OTHER 기타
 */
export type ShippingShipmentDisputeDtoCode =
  (typeof ShippingShipmentDisputeDtoCode)[keyof typeof ShippingShipmentDisputeDtoCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShippingShipmentDisputeDtoCode = {
  DAMAGED: "DAMAGED",
  MISSING_ITEMS: "MISSING_ITEMS",
  WRONG_ITEM: "WRONG_ITEM",
  NOT_RECEIVED: "NOT_RECEIVED",
  OTHER: "OTHER",
} as const;

export interface ShippingShipmentDisputeDto {
  /** 신고 종류 — DAMAGED 파손 · MISSING_ITEMS 수량 누락 · WRONG_ITEM 오배송 · NOT_RECEIVED 미수령 · OTHER 기타 */
  code: ShippingShipmentDisputeDtoCode;
  /**
   * 받는 쪽이 적은 신고 내용
   * @nullable
   */
  note?: string | null;
  /** 신고 시각 */
  at: string;
}

export interface TrackingEventDto {
  /**
   * 발생 시각(ISO)
   * @nullable
   */
  at?: string | null;
  /**
   * 위치(집화점·터미널 등)
   * @nullable
   */
  where?: string | null;
  /**
   * 처리 내용
   * @nullable
   */
  kind?: string | null;
  /**
   * 택배사 단계 1~6
   * @nullable
   */
  level?: number | null;
  /**
   * 어느 송장의 이력인가(송장이 여러 개인 발송만)
   * @nullable
   */
  trackingNo?: string | null;
}

export interface ShippingShipmentLineDto {
  /** 품목 식별자 — 계약은 items 배열 순번, 몰 주문은 주문 품목 id */
  lineKey: string;
  /**
   * 계약 품목 순번(계약일 때만, 0부터)
   * @nullable
   */
  lineIndex?: number | null;
  /**
   * 몰 주문 품목 id(몰 주문일 때만)
   * @nullable
   */
  orderItemId?: string | null;
  /**
   * 품명(등록 순간의 스냅샷)
   * @nullable
   */
  itemName?: string | null;
  /**
   * 단위
   * @nullable
   */
  unit?: string | null;
  /** 이 송장에 실은 수량 */
  quantity: number;
  /**
   * 카탈로그 품목 id(있을 때만)
   * @nullable
   */
  itemId?: string | null;
}

/**
 * 배송 대상 종류
 */
export type ShippingShipmentDtoSubjectKind =
  (typeof ShippingShipmentDtoSubjectKind)[keyof typeof ShippingShipmentDtoSubjectKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShippingShipmentDtoSubjectKind = {
  CONTRACT: "CONTRACT",
  MALL_ORDER: "MALL_ORDER",
  CMARKET_AWARD: "CMARKET_AWARD",
} as const;

/**
 * 배송 상태(택배사 데이터가 움직이는 축)
 */
export type ShippingShipmentDtoDeliveryStatus =
  (typeof ShippingShipmentDtoDeliveryStatus)[keyof typeof ShippingShipmentDtoDeliveryStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShippingShipmentDtoDeliveryStatus = {
  READY: "READY",
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  EXCEPTION: "EXCEPTION",
  RETURNED: "RETURNED",
  CANCELED: "CANCELED",
} as const;

/**
 * 인수 상태(받는 쪽이 확정하는 축)
 */
export type ShippingShipmentDtoAcceptanceStatus =
  (typeof ShippingShipmentDtoAcceptanceStatus)[keyof typeof ShippingShipmentDtoAcceptanceStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShippingShipmentDtoAcceptanceStatus = {
  NOT_DUE: "NOT_DUE",
  AWAITING: "AWAITING",
  RECEIVED: "RECEIVED",
  AUTO_RECEIVED: "AUTO_RECEIVED",
  DISPUTED: "DISPUTED",
} as const;

/**
 * 공급사 «전달 완료 알리기» 증빙(인수자 이름 등). 그 경로로 도착을 기록한 송장에만 있다
 * @nullable
 */
export type ShippingShipmentDtoDeliveryProof = ShippingDeliveryProofDto | null;

/**
 * 마지막 문제 신고 기록(없으면 null). 지금 신고 중인지는 acceptanceStatus 가 DISPUTED 인지로 안다 — 해결된 뒤에도 기록은 남는다
 * @nullable
 */
export type ShippingShipmentDtoDispute = ShippingShipmentDisputeDto | null;

export interface ShippingShipmentDto {
  /** 송장 id */
  id: string;
  /** 배송 대상 종류 */
  subjectKind: ShippingShipmentDtoSubjectKind;
  /** 배송 대상 id(계약 id 또는 몰 주문 id) */
  subjectId: string;
  /**
   * 배송 대상 번호(계약번호 또는 몰 주문번호) — 화면 표시용
   * @nullable
   */
  subjectNo?: string | null;
  /** (대상, 공급사) 안에서 1부터 — «1차 발송, 2차 발송» */
  shipmentNo: number;
  /**
   * 택배사 코드
   * @nullable
   */
  courierCode?: string | null;
  /**
   * 택배사 이름
   * @nullable
   */
  courierName?: string | null;
  /**
   * 첫 송장번호(숫자·영문만) — 송장이 여러 개면 trackingNumbers 에 모두 있다
   * @nullable
   */
  trackingNo?: string | null;
  /**
   * 택배사 공식 조회 페이지 링크(첫 송장)
   * @nullable
   */
  trackingUrl?: string | null;
  /** 이 발송의 송장(상자마다 한 장) 전부와 송장별 조회 상태. 발송이 «도착» 이 되려면 모든 송장이 도착해야 한다. 번호가 없으면 빈 배열 */
  trackingNumbers: ShippingParcelDto[];
  /** 배송 상태(택배사 데이터가 움직이는 축) */
  deliveryStatus: ShippingShipmentDtoDeliveryStatus;
  /**
   * 예외 분류(배송 상태가 EXCEPTION 일 때만)
   * @nullable
   */
  exceptionCode?: string | null;
  /**
   * 출고 시각
   * @nullable
   */
  shippedAt?: string | null;
  /**
   * 배송 완료 시각
   * @nullable
   */
  deliveredAt?: string | null;
  /** 인수 상태(받는 쪽이 확정하는 축) */
  acceptanceStatus: ShippingShipmentDtoAcceptanceStatus;
  /**
   * 수령 확인 시각
   * @nullable
   */
  receivedAt?: string | null;
  /**
   * 수령 확인 출처(BUYER · AUTO · ADMIN · INSPECTION)
   * @nullable
   */
  receivedSource?: string | null;
  /**
   * 도착(DELIVERED)을 기록한 주체 — POLL·WEBHOOK 택배사 · SUPPLIER 공급사 알림 · BUYER·INSPECTION 기관 · ADMIN·SYSTEM 운영. DELIVERED 가 아니면 null
   * @nullable
   */
  deliveredSource?: string | null;
  /**
   * 공급사 «전달 완료 알리기» 증빙(인수자 이름 등). 그 경로로 도착을 기록한 송장에만 있다
   * @nullable
   */
  deliveryProof?: ShippingShipmentDtoDeliveryProof;
  /**
   * 도착 전 수령 확인 때 발주기관이 적은 받은 날(YYYY-MM-DD)
   * @nullable
   */
  receivedOn?: string | null;
  /**
   * 등록 취소 사유(취소된 송장만)
   * @nullable
   */
  cancelReason?: string | null;
  /**
   * 등록 취소 시각(취소된 송장만)
   * @nullable
   */
  canceledAt?: string | null;
  /**
   * 이 시각이 지나도 확인이 없으면 자동 확정(없으면 자동 확정 없음)
   * @nullable
   */
  autoReceiveAt?: string | null;
  /**
   * 마지막 문제 신고 기록(없으면 null). 지금 신고 중인지는 acceptanceStatus 가 DISPUTED 인지로 안다 — 해결된 뒤에도 기록은 남는다
   * @nullable
   */
  dispute?: ShippingShipmentDtoDispute;
  /**
   * 택배 조회 단계 1 준비중·2 집화·3 배송중·4 지점도착·5 배달출발·6 완료
   * @nullable
   */
  trackingLevel?: number | null;
  /**
   * 단계 문구(«배송중» 등). 조회 전이면 null
   * @nullable
   */
  trackingLabel?: string | null;
  /** 최근 이력(시간순, 최대 30건) */
  events: TrackingEventDto[];
  /**
   * 마지막 이력 시각
   * @nullable
   */
  lastCheckpointAt?: string | null;
  /**
   * 마지막 조회 시도 시각
   * @nullable
   */
  lastPolledAt?: string | null;
  /**
   * 마지막 조회 실패 사유. 성공이면 null
   * @nullable
   */
  syncError?: string | null;
  /** 조회 종료 표시가 달렸는가(사람이 확인해야 한다) */
  stale: boolean;
  /** 지금 사람이 봐야 하는가(예외 · 조회 종료 · 조회 실패 · 문제 신고 중) */
  needsAttention: boolean;
  /** 배송이 끝난 송장인가(배송 완료 · 반송 · 취소) */
  finished: boolean;
  /** 택배사가 도착을 알려 주는 송장인가(송장번호 있음 · 택배사 활성 · 조회 제공사 지원). false 면 공급사가 «전달 완료 알리기» 를 쓴다 */
  autoTracked: boolean;
  /** 운영 «수령 강제 처리» 를 앞에 둘 송장인가(도착했거나 추적 불가). 서버는 사유가 있으면 그 밖에도 받는다 */
  canForceReceive: boolean;
  /**
   * 메모
   * @nullable
   */
  note?: string | null;
  /** 낙관적 잠금 버전 — 수정·수령 확인 때 되돌려 보낸다 */
  version: number;
  /** 등록 시각 */
  createdAt: string;
  /** 실린 품목 */
  items: ShippingShipmentLineDto[];
}

export interface ShipmentPageDto {
  /** 송장 목록 */
  items: ShippingShipmentDto[];
  /** 조건에 맞는 전체 건수 */
  total: number;
  /** 현재 페이지(1부터) */
  page: number;
  /** 페이지 크기 */
  limit: number;
}

export interface CheckpointDto {
  /**
   * 발생 시각
   * @nullable
   */
  occurredAt?: string | null;
  /**
   * 택배사 단계 1~6
   * @nullable
   */
  level?: number | null;
  /**
   * 위치
   * @nullable
   */
  location?: string | null;
  /**
   * 처리 내용
   * @nullable
   */
  message?: string | null;
  /** 조회 제공사 */
  provider: string;
  /**
   * 어느 송장의 이력인가(송장이 여러 개인 발송만)
   * @nullable
   */
  trackingNo?: string | null;
}

/**
 * 어느 축의 변경인가
 */
export type StatusLogDtoAxis =
  (typeof StatusLogDtoAxis)[keyof typeof StatusLogDtoAxis];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StatusLogDtoAxis = {
  DELIVERY: "DELIVERY",
  ACCEPTANCE: "ACCEPTANCE",
} as const;

export interface StatusLogDto {
  /** 어느 축의 변경인가 */
  axis: StatusLogDtoAxis;
  /**
   * 이전 상태
   * @nullable
   */
  fromStatus?: string | null;
  /** 바뀐 상태 */
  toStatus: string;
  /** 변경 출처(SUPPLIER · BUYER · POLL · WEBHOOK · AUTO · ADMIN · INSPECTION · MIGRATION · SYSTEM) */
  source: string;
  /**
   * 사유(강제 처리·자동 확정 등)
   * @nullable
   */
  reason?: string | null;
  /** 변경 시각 */
  at: string;
}

export interface ShipmentDetailDto {
  /** 송장 */
  shipment: ShippingShipmentDto;
  /** 택배사 이력(시간순) */
  checkpoints: CheckpointDto[];
  /**
   * 상태 변경 로그(공급사·관리자에게만. 발주기관은 null)
   * @nullable
   */
  statusLog?: StatusLogDto[] | null;
}

export interface RefreshResultDto {
  /** 갱신 뒤 송장 */
  shipment: ShippingShipmentDto;
  /** 조회 결과 — APPLIED 반영 · NOT_FOUND 결과 없음 · FAILED 실패 · THROTTLED 방금 조회함 · DISABLED 자동 조회 꺼짐 · PAUSED 제공사 쉬는 중 · NOT_TRACKABLE 조회 불가 송장 · FINISHED 끝난 송장 */
  outcome: string;
  /**
   * THROTTLED 일 때 몇 초 뒤에 다시 누를 수 있는가
   * @nullable
   */
  retryAfterSeconds?: number | null;
}

export interface CorrectShipmentDto {
  /** 택배사 코드. 보내지 않으면 그대로, 빈 문자열이면 비움 */
  courierCode?: string;
  /** 송장번호. 보내지 않으면 그대로, 빈 문자열이면 비움 */
  trackingNo?: string;
  /**
   * 송장번호 «전체 목록»(상자마다 하나, 최대 30개). 보내면 trackingNo 대신 이것으로 바꾼다 — 빈 배열이면 번호 비움. 바뀌면 이력은 지우고 새로 조회한다
   * @maxItems 30
   */
  trackingNos?: string[];
  /** 메모. 보내지 않으면 그대로, 빈 문자열이면 비움 */
  note?: string;
  /** 화면이 본 버전 — 그 사이 바뀌었으면 409 */
  expectedVersion?: number;
}

/**
 * 바꿀 상태
 */
export type ChangeShipmentStatusDtoStatus =
  (typeof ChangeShipmentStatusDtoStatus)[keyof typeof ChangeShipmentStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangeShipmentStatusDtoStatus = {
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  CANCELED: "CANCELED",
} as const;

export interface ChangeShipmentStatusDto {
  /** 바꿀 상태 */
  status: ChangeShipmentStatusDtoStatus;
  /** 사유 — 등록 취소(CANCELED)에는 필요하다(서버 규칙은 SHIPPING_REASON_RULES 가 켜진 뒤 적용: 없으면 SHIPMENT_REASON_REQUIRED) */
  reason?: string;
  /** 화면이 본 버전 — 그 사이 바뀌었으면 409 */
  expectedVersion?: number;
}

export interface ClaimDeliveredDto {
  /** 건넨 일시(ISO 8601). 미래면 SHIPMENT_INVALID_INPUT. 증빙에만 남고 자동 수령 기산점은 처리 시각이다 */
  handedAt: string;
  /**
   * 받은 분(인수자) 이름 — 필수
   * @maxLength 60
   */
  receiverName: string;
  /**
   * 인수자 부서
   * @maxLength 60
   */
  receiverDept?: string;
  /**
   * 메모
   * @maxLength 500
   */
  note?: string;
  /** 화면이 본 버전 — 그 사이 바뀌었으면 409 */
  expectedVersion?: number;
}

export interface ReceiveShipmentDto {
  /** 화면이 본 버전 — 그 사이 바뀌었으면 409 */
  expectedVersion?: number;
  /**
   * 확인 사유 — 추적 택배를 도착 전에 수령 확인할 때 필요하다(서버 규칙은 SHIPPING_REASON_RULES 가 켜진 뒤 적용: 없으면 SHIPMENT_REASON_REQUIRED)
   * @maxLength 500
   */
  reason?: string;
  /** 받은 날(YYYY-MM-DD, 한국 날짜). 미래면 SHIPMENT_INVALID_INPUT */
  receivedOn?: string;
}

/**
 * 신고 종류 — DAMAGED 파손 · MISSING_ITEMS 수량 누락 · WRONG_ITEM 오배송 · NOT_RECEIVED 미수령 · OTHER 기타
 */
export type DisputeShipmentDtoCode =
  (typeof DisputeShipmentDtoCode)[keyof typeof DisputeShipmentDtoCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DisputeShipmentDtoCode = {
  DAMAGED: "DAMAGED",
  MISSING_ITEMS: "MISSING_ITEMS",
  WRONG_ITEM: "WRONG_ITEM",
  NOT_RECEIVED: "NOT_RECEIVED",
  OTHER: "OTHER",
} as const;

export interface DisputeShipmentDto {
  /** 신고 종류 — DAMAGED 파손 · MISSING_ITEMS 수량 누락 · WRONG_ITEM 오배송 · NOT_RECEIVED 미수령 · OTHER 기타 */
  code: DisputeShipmentDtoCode;
  /** 신고 내용(최대 500자). 종류가 OTHER 면 반드시 적는다 */
  note?: string;
  /** 화면이 본 버전 — 그 사이 바뀌었으면 409 */
  expectedVersion?: number;
}

export interface WithdrawDisputeDto {
  /** 화면이 본 버전 — 그 사이 바뀌었으면 409 */
  expectedVersion?: number;
}

export interface ShippingAutoReceiveDaysDto {
  /** 계약 송장 — 0 이면 자동 수령 없음 */
  CONTRACT: number;
  /** 몰 주문 송장 — 0 이면 자동 수령 없음 */
  MALL_ORDER: number;
  /** 씨마켓 낙찰 건 송장 — 0 이면 자동 수령 없음(받은 확인은 납품 검수가 맡는다) */
  CMARKET_AWARD: number;
}

export interface ShippingPolicyFlagsDto {
  /** SHIPPING_SUPPLIER_DELIVERY_LOCK */
  supplierDeliveryLock: boolean;
  /** SHIPPING_REASON_RULES */
  reasonRules: boolean;
  /** SHIPPING_COMPLETED_CONTRACT_LOCK */
  completedContractLock: boolean;
  /** SHIPPING_OPS_ALERTS_ENABLED — 켜져 있어야 «세모 운영팀» 문구를 쓴다 */
  opsAlerts: boolean;
  /** SHIPPING_DISPUTE_IN_TRANSIT */
  disputeInTransit: boolean;
  /** SHIPPING_WORKBENCH */
  workbench: boolean;
  /** SHIPPING_DELIVERY_GATE */
  deliveryGate: boolean;
}

export interface ShippingPolicyDto {
  /** 대상 종류별 자동 수령 일수(달력 일). 0 이하면 자동 수령 없음 */
  autoReceiveDays: ShippingAutoReceiveDaysDto;
  /** 자동 수령 기한의 최소 예고 일수 — 기한은 어떤 경로로도 «지금 + 이 일수» 보다 빠르지 않다 */
  autoReceiveMinNoticeDays: number;
  /** 배송 기능 플래그(서버 환경 변수 값). 화면 문구 분기에 쓴다 */
  flags: ShippingPolicyFlagsDto;
}

export interface ForcePreviewDto {
  /** 미리보는 목표 상태 */
  target: string;
  /** 택배사가 도착을 알려 주는 송장인가 */
  tracked: boolean;
  /** «수령 강제 처리» 를 앞에 둘 송장인가(도착·추적 불가) */
  canForceReceive: boolean;
  /** 추적 중인 송장을 강제로 바꾸는 것이라 확인창에서 사유를 한 번 더 확인해야 하나 */
  needsExtraConfirm: boolean;
  /**
   * 목표가 DELIVERED 일 때, 지금 처리하면 걸리는 자동 수령 기한(autoReceiveDeadline). 자동 수령이 없으면 null
   * @nullable
   */
  autoReceiveAt?: string | null;
  /** 도착 알림을 받을 쪽이 있나(발주기관) */
  willNotifyBuyer: boolean;
}

/**
 * 강제로 바꿀 상태
 */
export type AdminForceStatusDtoStatus =
  (typeof AdminForceStatusDtoStatus)[keyof typeof AdminForceStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminForceStatusDtoStatus = {
  READY: "READY",
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  EXCEPTION: "EXCEPTION",
  RETURNED: "RETURNED",
  CANCELED: "CANCELED",
} as const;

/**
 * 예외 분류(상태가 EXCEPTION 일 때 필수)
 */
export type AdminForceStatusDtoExceptionCode =
  (typeof AdminForceStatusDtoExceptionCode)[keyof typeof AdminForceStatusDtoExceptionCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminForceStatusDtoExceptionCode = {
  DELAYED: "DELAYED",
  ATTEMPT_FAILED: "ATTEMPT_FAILED",
  HELD: "HELD",
  DAMAGED: "DAMAGED",
  LOST: "LOST",
  OTHER: "OTHER",
} as const;

export interface AdminForceStatusDto {
  /** 강제로 바꿀 상태 */
  status: AdminForceStatusDtoStatus;
  /** 사유(필수) — 상태 로그에 ADMIN 으로 남는다 */
  reason: string;
  /** 예외 분류(상태가 EXCEPTION 일 때 필수) */
  exceptionCode?: AdminForceStatusDtoExceptionCode;
}

export interface ShippingAdminReasonDto {
  /** 사유(필수) — 상태 로그에 ADMIN 으로 남는다 */
  reason: string;
}

/**
 * 서킷 브레이커 상태
 */
export type ProviderStateDtoBreakerState =
  (typeof ProviderStateDtoBreakerState)[keyof typeof ProviderStateDtoBreakerState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProviderStateDtoBreakerState = {
  closed: "closed",
  open: "open",
  half_open: "half_open",
} as const;

export interface ProviderStateDto {
  /** 서킷 브레이커 상태 */
  breakerState: ProviderStateDtoBreakerState;
  /**
   * 쉬는 중이면 언제까지
   * @nullable
   */
  pausedUntil?: string | null;
  /** 연속 실패 횟수 */
  consecutiveFailures: number;
  /** 오늘(KST) 호출 수 */
  callsToday: number;
  /**
   * 마지막 오류
   * @nullable
   */
  lastError?: string | null;
  /**
   * 마지막 성공 시각
   * @nullable
   */
  lastSuccessAt?: string | null;
}

/**
 * 한도·서킷 상태
 * @nullable
 */
export type ProviderOverviewDtoState = ProviderStateDto | null;

export interface ProviderOverviewDto {
  /** 제공사 이름 */
  name: string;
  /** 상태 키 */
  stateKey: string;
  /** 키가 설정돼 조회할 수 있는가 */
  enabled: boolean;
  /**
   * 한도·서킷 상태
   * @nullable
   */
  state?: ProviderOverviewDtoState;
}

export interface FailedEventDto {
  /** 이벤트 id */
  id: string;
  /** 이벤트 종류 */
  eventType: string;
  /** 실패 횟수 */
  retryCount: number;
  /**
   * 마지막 오류
   * @nullable
   */
  lastError?: string | null;
  /** 발생 시각 */
  createdAt: string;
  /** 이미 끝낸 소비자(다시 넣어도 이 소비자는 다시 부르지 않는다) */
  done: string[];
}

/**
 * 이유 — UNKNOWN_COURIER 모르는 택배사 · UNKNOWN_SHIPMENT 우리 송장이 아님 · EMPTY 이력도 단계도 없음
 */
export type ShippingCallbackIgnoredDtoReason =
  (typeof ShippingCallbackIgnoredDtoReason)[keyof typeof ShippingCallbackIgnoredDtoReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShippingCallbackIgnoredDtoReason = {
  UNKNOWN_COURIER: "UNKNOWN_COURIER",
  UNKNOWN_SHIPMENT: "UNKNOWN_SHIPMENT",
  EMPTY: "EMPTY",
} as const;

export interface ShippingCallbackIgnoredDto {
  /** 반영하지 않은 송장번호 */
  trackingNo: string;
  /** 이유 — UNKNOWN_COURIER 모르는 택배사 · UNKNOWN_SHIPMENT 우리 송장이 아님 · EMPTY 이력도 단계도 없음 */
  reason: ShippingCallbackIgnoredDtoReason;
}

export interface ShippingCallbackResultDto {
  /** 본문에 든 송장 수 */
  received: number;
  /** 장부에 반영한 송장 수 */
  applied: number;
  /** 반영하지 않은 송장과 이유 */
  ignored: ShippingCallbackIgnoredDto[];
}

export interface WishItemDto {
  itemId: string;
  createdAt: string;
  /**
   * 찜할 때의 몰 판매가
   * @nullable
   */
  priceAtWish?: number | null;
  /**
   * 마지막으로 알린 가격(가격 내림 기준)
   * @nullable
   */
  notifiedPrice?: number | null;
  /**
   * 마지막 점검 때 본 가격
   * @nullable
   */
  lastPrice?: number | null;
  /** 마지막 점검 때 몰에서 팔고 있었나 */
  lastAvailable: boolean;
}

export interface WishListResponseDto {
  items: WishItemDto[];
}

export interface WishToggleResponseDto {
  itemId: string;
  wished: boolean;
}

export interface ReactionOwnerBodyDto {
  /** 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 몰 서버가 SSO 세션에서만 채운다. */
  ownerKey: string;
}

export interface RecordItemViewDto {
  /** 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 몰 서버가 SSO 세션에서만 채운다. */
  ownerKey: string;
  /** 연 상품(품목) id */
  itemId: string;
}

export type SocialProofDtoKind =
  (typeof SocialProofDtoKind)[keyof typeof SocialProofDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocialProofDtoKind = {
  REORDER: "REORDER",
  BUY: "BUY",
} as const;

export interface SocialProofDto {
  kind: SocialProofDtoKind;
  /** 기관 수(2 이상만 내려간다) */
  orgCount: number;
  /** 대학·연구기관·학교·의료기관·지자체·공공기관·기관 */
  orgType: string;
  windowDays: number;
  text: string;
}

/**
 * @nullable
 */
export type ItemSignalDtoSocialProof = SocialProofDto | null;

export interface ItemSignalDto {
  itemId: string;
  wished: boolean;
  /** @nullable */
  socialProof?: ItemSignalDtoSocialProof;
}

export interface ItemSignalsResponseDto {
  items: ItemSignalDto[];
}

export interface ItemSignalsRequestDto {
  /** 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 몰 서버가 SSO 세션에서만 채운다. 없으면 찜 여부는 모두 false. */
  ownerKey?: string;
  /** 물을 상품 id(최대 200) */
  itemIds: string[];
}

export interface SocialProofRankEntryDto {
  itemId: string;
  socialProof: SocialProofDto;
}

export interface SocialProofRankingResponseDto {
  items: SocialProofRankEntryDto[];
}

export type ReactionAlertDtoKind =
  (typeof ReactionAlertDtoKind)[keyof typeof ReactionAlertDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReactionAlertDtoKind = {
  WISH_PRICE_DROP: "WISH_PRICE_DROP",
  WISH_RESTOCK: "WISH_RESTOCK",
  REVIEW_HELPFUL: "REVIEW_HELPFUL",
} as const;

export type ReactionAlertDtoPayload = { [key: string]: unknown };

export interface ReactionAlertDto {
  id: string;
  kind: ReactionAlertDtoKind;
  title: string;
  body: string;
  payload: ReactionAlertDtoPayload;
  createdAt: string;
}

export interface ReactionAlertListResponseDto {
  items: ReactionAlertDto[];
}

export interface ReviewDto {
  id: string;
  itemId: string;
  /** 익명 작성자 표기(기관명 없음) */
  authorLabel: string;
  body: string;
  photoUrls: string[];
  helpfulCount: number;
  createdAt: string;
  helpedByMe: boolean;
  mine: boolean;
}

export interface ReviewableOrderDto {
  orderId: string;
  orderNo: string;
  status: string;
  /** @nullable */
  confirmedAt?: string | null;
}

export interface ReviewPageResponseDto {
  items: ReviewDto[];
  total: number;
  page: number;
  limit: number;
  reviewableOrders: ReviewableOrderDto[];
}

export interface CreateReviewDto {
  /** 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 몰 서버가 SSO 세션에서만 채운다. */
  ownerKey: string;
  /** 구매확정한 주문번호 */
  orderNo: string;
  /** 후기 본문(10~1000자) */
  body: string;
}

export interface ReviewHelpfulResponseDto {
  reviewId: string;
  helpfulCount: number;
  helpedByMe: boolean;
}

export interface ReviewHelpfulDto {
  /** 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 몰 서버가 SSO 세션에서만 채운다. */
  ownerKey: string;
  /** true = 도움돼요 누름, false = 거두기 */
  on: boolean;
}

export interface ReviewReportResponseDto {
  reviewId: string;
  reported: boolean;
  /** 신고가 쌓여 숨겨졌나 */
  hidden: boolean;
}

export type ReviewReportDtoReason =
  (typeof ReviewReportDtoReason)[keyof typeof ReviewReportDtoReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewReportDtoReason = {
  SPAM: "SPAM",
  ABUSE: "ABUSE",
  PRIVACY: "PRIVACY",
  UNRELATED: "UNRELATED",
  OTHER: "OTHER",
} as const;

export interface ReviewReportDto {
  /** 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 몰 서버가 SSO 세션에서만 채운다. */
  ownerKey: string;
  reason: ReviewReportDtoReason;
}

export interface ReviewDeleteResponseDto {
  reviewId: string;
}

export interface RevisitBreakdownDto {
  label: string;
  count: number;
}

export interface TopWishedItemDto {
  itemId: string;
  name: string;
  wishes: number;
}

export interface SupplierStorefrontReactionDto {
  storefrontId: string;
  slug: string;
  name: string;
  /** 최근 7일 새 찜(공급사 자기 찜 제외) */
  wishesThisWeek: number;
  /** 최근 7일 서로 다른 날 2번 이상 내 상품을 본 기관 수 */
  revisitOrgCount: number;
  revisitBreakdown: RevisitBreakdownDto[];
  topItems: TopWishedItemDto[];
}

export interface SupplierReactionSummaryDto {
  windowDays: number;
  wishesThisWeek: number;
  revisitOrgCount: number;
  storefronts: SupplierStorefrontReactionDto[];
}

export interface ShareLinkFlagsDto {
  showPrice: boolean;
  showStock: boolean;
  showStockNumber: boolean;
  showLeadTime: boolean;
  includeVat: boolean;
}

/**
 * @nullable
 */
export type ShareLinkRecipientDtoOrg = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type ShareLinkRecipientDtoEmail = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type ShareLinkRecipientDtoPhone = { [key: string]: unknown } | null;

export interface ShareLinkRecipientDto {
  /** @nullable */
  org: ShareLinkRecipientDtoOrg;
  /** @nullable */
  email: ShareLinkRecipientDtoEmail;
  /** @nullable */
  phone: ShareLinkRecipientDtoPhone;
}

/**
 * @nullable
 */
export type ShareLinkStatsDtoLastViewedAt = { [key: string]: unknown } | null;

export interface ShareLinkStatsDto {
  /** 사람 열람 수(봇 제외) */
  viewCount: number;
  /** 메신저 미리보기 봇 열람 수 */
  botViewCount: number;
  verifyCount: number;
  addToCartCount: number;
  quoteRequestCount: number;
  blockedCount: number;
  /** @nullable */
  lastViewedAt: ShareLinkStatsDtoLastViewedAt;
}

/**
 * @nullable
 */
export type ShareLinkCreatedDtoLabel = { [key: string]: unknown } | null;

export type ShareLinkCreatedDtoScope =
  (typeof ShareLinkCreatedDtoScope)[keyof typeof ShareLinkCreatedDtoScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShareLinkCreatedDtoScope = {
  SELECTED: "SELECTED",
  CATEGORY: "CATEGORY",
  ALL_SELLING: "ALL_SELLING",
} as const;

/**
 * @nullable
 */
export type ShareLinkCreatedDtoCategoryId = { [key: string]: unknown } | null;

/**
 * SELECTED 스코프 품목 수(발급 응답에서만)
 * @nullable
 */
export type ShareLinkCreatedDtoItemCount = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type ShareLinkCreatedDtoRevokedAt = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type ShareLinkCreatedDtoMaxViews = { [key: string]: unknown } | null;

export type ShareLinkCreatedDtoStatus =
  (typeof ShareLinkCreatedDtoStatus)[keyof typeof ShareLinkCreatedDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShareLinkCreatedDtoStatus = {
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  REVOKED: "REVOKED",
} as const;

/**
 * 재발급이면 옛 링크 id
 */
export type ShareLinkCreatedDtoReissuedFromId = { [key: string]: unknown };

export interface ShareLinkCreatedDto {
  id: string;
  /** @nullable */
  label: ShareLinkCreatedDtoLabel;
  scope: ShareLinkCreatedDtoScope;
  /** @nullable */
  categoryId: ShareLinkCreatedDtoCategoryId;
  /**
   * SELECTED 스코프 품목 수(발급 응답에서만)
   * @nullable
   */
  itemCount: ShareLinkCreatedDtoItemCount;
  flags: ShareLinkFlagsDto;
  recipient: ShareLinkRecipientDto;
  requireVerify: boolean;
  expiresAt: string;
  /** @nullable */
  revokedAt: ShareLinkCreatedDtoRevokedAt;
  /** @nullable */
  maxViews: ShareLinkCreatedDtoMaxViews;
  createdAt: string;
  status: ShareLinkCreatedDtoStatus;
  stats: ShareLinkStatsDto;
  /** 토큰 원문 — 이 응답 한 번만 내려간다 */
  token: string;
  /** 수신자에게 보낼 URL */
  url: string;
  /** 재발급이면 옛 링크 id */
  reissuedFromId?: ShareLinkCreatedDtoReissuedFromId;
}

export type CreateShareLinkDtoScope =
  (typeof CreateShareLinkDtoScope)[keyof typeof CreateShareLinkDtoScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateShareLinkDtoScope = {
  SELECTED: "SELECTED",
  CATEGORY: "CATEGORY",
  ALL_SELLING: "ALL_SELLING",
} as const;

export interface CreateShareLinkDto {
  /** 링크 라벨(수신처 메모 등) */
  label?: string;
  scope: CreateShareLinkDtoScope;
  /** CATEGORY 스코프의 카테고리 */
  categoryId?: string;
  /** SELECTED 스코프의 품목 (최대 500) */
  itemIds?: string[];
  /** 단가 노출. 기본 숨김 */
  showPrice?: boolean;
  /** 재고 충분 여부 노출 */
  showStock?: boolean;
  /** 재고 수치 노출(기본 숨김) */
  showStockNumber?: boolean;
  showLeadTime?: boolean;
  /** 단가를 부가세 포함으로 보일지 */
  includeVat?: boolean;
  recipientOrg?: string;
  /** 수신자 이메일 — 확인 코드가 여기로 간다 */
  recipientEmail?: string;
  recipientPhone?: string;
  /** 수신자 확인(이메일 일회용 코드). 켜면 recipientEmail 필수 */
  requireVerify?: boolean;
  /** 만료(일). 1~90. 무기한 없음 */
  expiresInDays?: number;
  /** 사람 열람 상한. 넘으면 링크가 닫힌다 */
  maxViews?: number;
}

/**
 * @nullable
 */
export type ShareLinkSummaryDtoLabel = { [key: string]: unknown } | null;

export type ShareLinkSummaryDtoScope =
  (typeof ShareLinkSummaryDtoScope)[keyof typeof ShareLinkSummaryDtoScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShareLinkSummaryDtoScope = {
  SELECTED: "SELECTED",
  CATEGORY: "CATEGORY",
  ALL_SELLING: "ALL_SELLING",
} as const;

/**
 * @nullable
 */
export type ShareLinkSummaryDtoCategoryId = { [key: string]: unknown } | null;

/**
 * SELECTED 스코프 품목 수(발급 응답에서만)
 * @nullable
 */
export type ShareLinkSummaryDtoItemCount = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type ShareLinkSummaryDtoRevokedAt = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type ShareLinkSummaryDtoMaxViews = { [key: string]: unknown } | null;

export type ShareLinkSummaryDtoStatus =
  (typeof ShareLinkSummaryDtoStatus)[keyof typeof ShareLinkSummaryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShareLinkSummaryDtoStatus = {
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  REVOKED: "REVOKED",
} as const;

export interface ShareLinkSummaryDto {
  id: string;
  /** @nullable */
  label: ShareLinkSummaryDtoLabel;
  scope: ShareLinkSummaryDtoScope;
  /** @nullable */
  categoryId: ShareLinkSummaryDtoCategoryId;
  /**
   * SELECTED 스코프 품목 수(발급 응답에서만)
   * @nullable
   */
  itemCount: ShareLinkSummaryDtoItemCount;
  flags: ShareLinkFlagsDto;
  recipient: ShareLinkRecipientDto;
  requireVerify: boolean;
  expiresAt: string;
  /** @nullable */
  revokedAt: ShareLinkSummaryDtoRevokedAt;
  /** @nullable */
  maxViews: ShareLinkSummaryDtoMaxViews;
  createdAt: string;
  status: ShareLinkSummaryDtoStatus;
  stats: ShareLinkStatsDto;
}

export interface ShareLinkListDto {
  items: ShareLinkSummaryDto[];
  total: number;
  limit: number;
  offset: number;
}

/**
 * @nullable
 */
export type ShareLinkItemRowDtoSpec = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type ShareLinkItemRowDtoProductCode = { [key: string]: unknown } | null;

/**
 * 내 단가(원). 발급자 화면이라 그대로
 */
export type ShareLinkItemRowDtoPrice = { [key: string]: unknown };

export interface ShareLinkItemRowDto {
  itemId: string;
  name: string;
  /** @nullable */
  spec: ShareLinkItemRowDtoSpec;
  /** @nullable */
  productCode: ShareLinkItemRowDtoProductCode;
  /** 내 단가(원). 발급자 화면이라 그대로 */
  price?: ShareLinkItemRowDtoPrice;
  selling: boolean;
}

/**
 * @nullable
 */
export type ShareLinkDetailDtoLabel = { [key: string]: unknown } | null;

export type ShareLinkDetailDtoScope =
  (typeof ShareLinkDetailDtoScope)[keyof typeof ShareLinkDetailDtoScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShareLinkDetailDtoScope = {
  SELECTED: "SELECTED",
  CATEGORY: "CATEGORY",
  ALL_SELLING: "ALL_SELLING",
} as const;

/**
 * @nullable
 */
export type ShareLinkDetailDtoCategoryId = { [key: string]: unknown } | null;

/**
 * SELECTED 스코프 품목 수(발급 응답에서만)
 * @nullable
 */
export type ShareLinkDetailDtoItemCount = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type ShareLinkDetailDtoRevokedAt = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type ShareLinkDetailDtoMaxViews = { [key: string]: unknown } | null;

export type ShareLinkDetailDtoStatus =
  (typeof ShareLinkDetailDtoStatus)[keyof typeof ShareLinkDetailDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShareLinkDetailDtoStatus = {
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  REVOKED: "REVOKED",
} as const;

/**
 * @nullable
 */
export type ShareLinkDetailDtoCategoryName = { [key: string]: unknown } | null;

export interface ShareLinkDetailDto {
  id: string;
  /** @nullable */
  label: ShareLinkDetailDtoLabel;
  scope: ShareLinkDetailDtoScope;
  /** @nullable */
  categoryId: ShareLinkDetailDtoCategoryId;
  /**
   * SELECTED 스코프 품목 수(발급 응답에서만)
   * @nullable
   */
  itemCount: ShareLinkDetailDtoItemCount;
  flags: ShareLinkFlagsDto;
  recipient: ShareLinkRecipientDto;
  requireVerify: boolean;
  expiresAt: string;
  /** @nullable */
  revokedAt: ShareLinkDetailDtoRevokedAt;
  /** @nullable */
  maxViews: ShareLinkDetailDtoMaxViews;
  createdAt: string;
  status: ShareLinkDetailDtoStatus;
  stats: ShareLinkStatsDto;
  /** @nullable */
  categoryName: ShareLinkDetailDtoCategoryName;
  items: ShareLinkItemRowDto[];
}

export interface SharePublicItemInputDto {
  itemId: string;
  quantity: number;
  unit?: string;
}

export interface SharePublicPreviewQuoteDto {
  items: SharePublicItemInputDto[];
}

export interface SharePublicVerifyDto {
  code: string;
}

export interface SharePublicQuoteRequestDto {
  items: SharePublicItemInputDto[];
  /** 납품 지역 코드(시도 2자리) */
  deliveryRegionCode?: string;
  dueDate?: string;
}

export type SharePublicEventDtoKind =
  (typeof SharePublicEventDtoKind)[keyof typeof SharePublicEventDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharePublicEventDtoKind = {
  ADD_TO_CART: "ADD_TO_CART",
} as const;

export interface SharePublicEventDto {
  kind: SharePublicEventDtoKind;
}

export type SiteSummaryDtoStatus =
  (typeof SiteSummaryDtoStatus)[keyof typeof SiteSummaryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteSummaryDtoStatus = {
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  ARCHIVED: "ARCHIVED",
} as const;

export type SiteSummaryDtoPlan =
  (typeof SiteSummaryDtoPlan)[keyof typeof SiteSummaryDtoPlan];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteSummaryDtoPlan = {
  BASIC: "BASIC",
  STANDARD: "STANDARD",
  PRO: "PRO",
} as const;

export type SiteSummaryDtoRenderMode =
  (typeof SiteSummaryDtoRenderMode)[keyof typeof SiteSummaryDtoRenderMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteSummaryDtoRenderMode = {
  BLOCKS: "BLOCKS",
  SHELL: "SHELL",
} as const;

export interface SiteSummaryDto {
  id: string;
  slug: string;
  name: string;
  status: SiteSummaryDtoStatus;
  plan: SiteSummaryDtoPlan;
  renderMode: SiteSummaryDtoRenderMode;
  /** @nullable */
  primaryHostname: string | null;
  /** 켜진 기능 코드 */
  enabledFeatures: string[];
  /** 회수되지 않은 담당자 수 */
  memberCount: number;
  createdAt: string;
}

export interface ProvisionedSiteMemberDto {
  email: string;
  name: string;
  role: string;
}

export interface ProvisionedSiteDto {
  id: string;
  slug: string;
  name: string;
  /** 바로 서비스되는 서브도메인 */
  hostname: string;
  enabledFeatures: string[];
  members: ProvisionedSiteMemberDto[];
}

export interface SiteCoOwnerDto {
  /** 이메일 */
  email: string;
  /** 이름 */
  name: string;
}

/**
 * 플랜 — 만들 때 켜 줄 기능 묶음
 */
export type CreateSiteDtoPlan =
  (typeof CreateSiteDtoPlan)[keyof typeof CreateSiteDtoPlan];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSiteDtoPlan = {
  BASIC: "BASIC",
  STANDARD: "STANDARD",
  PRO: "PRO",
} as const;

/**
 * SHELL = 고객 원본 HTML 그대로(기본), BLOCKS = 블록 렌더러
 */
export type CreateSiteDtoRenderMode =
  (typeof CreateSiteDtoRenderMode)[keyof typeof CreateSiteDtoRenderMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSiteDtoRenderMode = {
  BLOCKS: "BLOCKS",
  SHELL: "SHELL",
} as const;

export interface CreateSiteDto {
  /** 슬러그 — 서브도메인이 된다. 영소문자·숫자·하이픈, 하이픈으로 시작·끝 불가 */
  slug: string;
  /** 회사·단체 이름 */
  name: string;
  /** 플랜 — 만들 때 켜 줄 기능 묶음 */
  plan: CreateSiteDtoPlan;
  /** SHELL = 고객 원본 HTML 그대로(기본), BLOCKS = 블록 렌더러 */
  renderMode?: CreateSiteDtoRenderMode;
  /** 대표 담당자 이메일 */
  ownerEmail: string;
  /** 대표 담당자 이름 */
  ownerName: string;
  /** 대표 담당자 외에 함께 오너로 둘 사람들(최대 9명) */
  coOwners?: SiteCoOwnerDto[];
  /** 이 사이트의 주인인 세모 공급사 계정(users.id). 납품실적·신뢰 배지가 이 연결로 흐른다. */
  supplierUserId?: string;
}

export type SiteFeatureStateDtoFeatureCode =
  (typeof SiteFeatureStateDtoFeatureCode)[keyof typeof SiteFeatureStateDtoFeatureCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteFeatureStateDtoFeatureCode = {
  WEBSITE: "WEBSITE",
  BOARD: "BOARD",
  CHAT: "CHAT",
  HERO_SELF_EDIT: "HERO_SELF_EDIT",
  MARKETING: "MARKETING",
  MEMBERS: "MEMBERS",
  DOCS: "DOCS",
  RECRUIT: "RECRUIT",
  I18N: "I18N",
  PROOF: "PROOF",
  TRUST: "TRUST",
  COMMERCE: "COMMERCE",
  VISITS: "VISITS",
} as const;

export type SiteFeatureStateDtoConfig = { [key: string]: unknown };

export interface SiteFeatureStateDto {
  featureCode: SiteFeatureStateDtoFeatureCode;
  enabled: boolean;
  config: SiteFeatureStateDtoConfig;
  /** @nullable */
  updatedAt: string | null;
}

export type SiteDomainDtoType =
  (typeof SiteDomainDtoType)[keyof typeof SiteDomainDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteDomainDtoType = {
  SUBDOMAIN: "SUBDOMAIN",
  CUSTOM: "CUSTOM",
} as const;

export type SiteDomainDtoStatus =
  (typeof SiteDomainDtoStatus)[keyof typeof SiteDomainDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteDomainDtoStatus = {
  PENDING: "PENDING",
  VERIFIED: "VERIFIED",
  FAILED: "FAILED",
} as const;

export interface SiteDomainDto {
  id: string;
  hostname: string;
  type: SiteDomainDtoType;
  status: SiteDomainDtoStatus;
  isPrimary: boolean;
  /**
   * TXT 레코드에 심을 값(커스텀 도메인만)
   * @nullable
   */
  verificationToken: string | null;
  /** @nullable */
  verifiedAt: string | null;
  createdAt: string;
}

export type SiteMemberDtoRole =
  (typeof SiteMemberDtoRole)[keyof typeof SiteMemberDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteMemberDtoRole = {
  OWNER: "OWNER",
  MANAGER: "MANAGER",
  EDITOR: "EDITOR",
  VIEWER: "VIEWER",
} as const;

export interface SiteMemberDto {
  id: string;
  email: string;
  name: string;
  role: SiteMemberDtoRole;
  invitedAt: string;
  /** @nullable */
  acceptedAt: string | null;
  /** @nullable */
  revokedAt: string | null;
}

export type SiteDetailDtoStatus =
  (typeof SiteDetailDtoStatus)[keyof typeof SiteDetailDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteDetailDtoStatus = {
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  ARCHIVED: "ARCHIVED",
} as const;

export type SiteDetailDtoPlan =
  (typeof SiteDetailDtoPlan)[keyof typeof SiteDetailDtoPlan];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteDetailDtoPlan = {
  BASIC: "BASIC",
  STANDARD: "STANDARD",
  PRO: "PRO",
} as const;

export type SiteDetailDtoRenderMode =
  (typeof SiteDetailDtoRenderMode)[keyof typeof SiteDetailDtoRenderMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteDetailDtoRenderMode = {
  BLOCKS: "BLOCKS",
  SHELL: "SHELL",
} as const;

export type SiteDetailDtoTheme = { [key: string]: unknown };

export interface SiteDetailDto {
  id: string;
  slug: string;
  name: string;
  status: SiteDetailDtoStatus;
  plan: SiteDetailDtoPlan;
  renderMode: SiteDetailDtoRenderMode;
  /** @nullable */
  supplierUserId: string | null;
  /** @nullable */
  primaryHostname: string | null;
  createdAt: string;
  updatedAt: string;
  /** 전 기능 코드(행이 없는 것도 꺼짐으로) */
  features: SiteFeatureStateDto[];
  enabledFeatures: string[];
  domains: SiteDomainDto[];
  theme: SiteDetailDtoTheme;
  members: SiteMemberDto[];
}

export type SiteStatusDtoStatus =
  (typeof SiteStatusDtoStatus)[keyof typeof SiteStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteStatusDtoStatus = {
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  ARCHIVED: "ARCHIVED",
} as const;

export interface SiteStatusDto {
  id: string;
  status: SiteStatusDtoStatus;
}

export type SetSiteStatusDtoStatus =
  (typeof SetSiteStatusDtoStatus)[keyof typeof SetSiteStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetSiteStatusDtoStatus = {
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  ARCHIVED: "ARCHIVED",
} as const;

export interface SetSiteStatusDto {
  status: SetSiteStatusDtoStatus;
}

export interface SiteEnabledFeaturesDto {
  /** 갱신 뒤 켜져 있는 기능 전체 */
  enabled: string[];
}

export type SiteFeatureToggleDtoFeatureCode =
  (typeof SiteFeatureToggleDtoFeatureCode)[keyof typeof SiteFeatureToggleDtoFeatureCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteFeatureToggleDtoFeatureCode = {
  WEBSITE: "WEBSITE",
  BOARD: "BOARD",
  CHAT: "CHAT",
  HERO_SELF_EDIT: "HERO_SELF_EDIT",
  MARKETING: "MARKETING",
  MEMBERS: "MEMBERS",
  DOCS: "DOCS",
  RECRUIT: "RECRUIT",
  I18N: "I18N",
  PROOF: "PROOF",
  TRUST: "TRUST",
  COMMERCE: "COMMERCE",
  VISITS: "VISITS",
} as const;

/**
 * 기능별 설정. 없으면 기존 설정을 그대로 둔다.
 */
export type SiteFeatureToggleDtoConfig = { [key: string]: unknown };

export interface SiteFeatureToggleDto {
  featureCode: SiteFeatureToggleDtoFeatureCode;
  /** 켤지 끌지 */
  enabled: boolean;
  /** 기능별 설정. 없으면 기존 설정을 그대로 둔다. */
  config?: SiteFeatureToggleDtoConfig;
}

export interface SetSiteFeaturesDto {
  /** 바꿀 기능만 담는다(부분 갱신) */
  features: SiteFeatureToggleDto[];
}

export type SiteThemeDtoTokens = { [key: string]: unknown };

export interface SiteThemeDto {
  tokens: SiteThemeDtoTokens;
}

/**
 * CSS 변수 값. brand·surface·ink 는 저장 전에 대비(4.5:1)를 검사한다.
 */
export type SetSiteThemeDtoTokens = { [key: string]: unknown };

export interface SetSiteThemeDto {
  /** CSS 변수 값. brand·surface·ink 는 저장 전에 대비(4.5:1)를 검사한다. */
  tokens: SetSiteThemeDtoTokens;
}

export type SiteDomainVerificationDtoStatus =
  (typeof SiteDomainVerificationDtoStatus)[keyof typeof SiteDomainVerificationDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteDomainVerificationDtoStatus = {
  PENDING: "PENDING",
  VERIFIED: "VERIFIED",
  FAILED: "FAILED",
} as const;

export type SiteDomainVerificationDtoRecordType =
  (typeof SiteDomainVerificationDtoRecordType)[keyof typeof SiteDomainVerificationDtoRecordType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteDomainVerificationDtoRecordType = {
  TXT: "TXT",
} as const;

export interface SiteDomainVerificationDto {
  id: string;
  hostname: string;
  status: SiteDomainVerificationDtoStatus;
  recordType: SiteDomainVerificationDtoRecordType;
  /** 고객사 DNS 에 추가할 레코드 이름 */
  recordName: string;
  /** 레코드 값 */
  recordValue: string;
}

export interface AddSiteDomainDto {
  /** 고객사 소유 호스트 */
  hostname: string;
}

/**
 * 소유 확인 결과를 사람이 적는다
 */
export type UpdateSiteDomainDtoStatus =
  (typeof UpdateSiteDomainDtoStatus)[keyof typeof UpdateSiteDomainDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateSiteDomainDtoStatus = {
  PENDING: "PENDING",
  VERIFIED: "VERIFIED",
  FAILED: "FAILED",
} as const;

export interface UpdateSiteDomainDto {
  /** 소유 확인 결과를 사람이 적는다 */
  status?: UpdateSiteDomainDtoStatus;
  /** 대표 도메인으로 세운다(VERIFIED 만 가능) */
  isPrimary?: boolean;
}

export type InviteSiteMemberDtoRole =
  (typeof InviteSiteMemberDtoRole)[keyof typeof InviteSiteMemberDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InviteSiteMemberDtoRole = {
  OWNER: "OWNER",
  MANAGER: "MANAGER",
  EDITOR: "EDITOR",
  VIEWER: "VIEWER",
} as const;

export interface InviteSiteMemberDto {
  email: string;
  name: string;
  role: InviteSiteMemberDtoRole;
}

export type SetSiteMemberRoleDtoRole =
  (typeof SetSiteMemberRoleDtoRole)[keyof typeof SetSiteMemberRoleDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetSiteMemberRoleDtoRole = {
  OWNER: "OWNER",
  MANAGER: "MANAGER",
  EDITOR: "EDITOR",
  VIEWER: "VIEWER",
} as const;

export interface SetSiteMemberRoleDto {
  role: SetSiteMemberRoleDtoRole;
}

export type SiteDataSourceDtoKind =
  (typeof SiteDataSourceDtoKind)[keyof typeof SiteDataSourceDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteDataSourceDtoKind = {
  SEMO: "SEMO",
  SUPABASE: "SUPABASE",
} as const;

export type SiteDataSourceDtoStatus =
  (typeof SiteDataSourceDtoStatus)[keyof typeof SiteDataSourceDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteDataSourceDtoStatus = {
  UNVERIFIED: "UNVERIFIED",
  OK: "OK",
  ERROR: "ERROR",
} as const;

export interface SiteDataSourceDto {
  siteId: string;
  kind: SiteDataSourceDtoKind;
  /** @nullable */
  supabaseUrl: string | null;
  /** @nullable */
  tablePrefix: string | null;
  /** 키 등록 여부 — 키 자체는 절대 내려가지 않는다 */
  hasServiceKey: boolean;
  status: SiteDataSourceDtoStatus;
  /** @nullable */
  lastCheckedAt: string | null;
  /** @nullable */
  lastError: string | null;
  /** @nullable */
  updatedAt: string | null;
}

/**
 * SEMO = 세모 DB(외부 연결 제거), SUPABASE = 사이트가 가진 Supabase
 */
export type UpsertSiteDataSourceDtoKind =
  (typeof UpsertSiteDataSourceDtoKind)[keyof typeof UpsertSiteDataSourceDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpsertSiteDataSourceDtoKind = {
  SEMO: "SEMO",
  SUPABASE: "SUPABASE",
} as const;

export interface UpsertSiteDataSourceDto {
  /** SEMO = 세모 DB(외부 연결 제거), SUPABASE = 사이트가 가진 Supabase */
  kind: UpsertSiteDataSourceDtoKind;
  /** Supabase 프로젝트 주소(경로 없이) */
  supabaseUrl?: string;
  /** service_role 키. 봉인 저장되며 응답에 실리지 않는다. 비우면 기존 키를 유지한다. */
  serviceKey?: string;
  /** 표 접두어(<prefix>_site_account). 비우면 사이트 슬러그. */
  tablePrefix?: string;
}

export type SiteDataSourceTestResultDtoStatus =
  (typeof SiteDataSourceTestResultDtoStatus)[keyof typeof SiteDataSourceTestResultDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteDataSourceTestResultDtoStatus = {
  UNVERIFIED: "UNVERIFIED",
  OK: "OK",
  ERROR: "ERROR",
} as const;

export interface SiteDataSourceTestResultDto {
  ok: boolean;
  status: SiteDataSourceTestResultDtoStatus;
  checkedAt: string;
  /** @nullable */
  accounts: number | null;
  /** @nullable */
  pendingAccounts: number | null;
  /** @nullable */
  entries: number | null;
  /** @nullable */
  error: string | null;
}

export interface SiteRosterRoleDto {
  /** OWNER · MANAGER · MEMBER */
  role: string;
  /**
   * MANAGER 의 담당 범위(COHORT:24 등)
   * @nullable
   */
  scope: string | null;
}

export type SiteRosterAccountDtoStatus =
  (typeof SiteRosterAccountDtoStatus)[keyof typeof SiteRosterAccountDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteRosterAccountDtoStatus = {
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
} as const;

export interface SiteRosterAccountDto {
  id: string;
  loginId: string;
  name: string;
  /** @nullable */
  cohort: string | null;
  /** @nullable */
  phone: string | null;
  /** @nullable */
  org: string | null;
  /** local · kakao · google */
  provider: string;
  status: SiteRosterAccountDtoStatus;
  roles: SiteRosterRoleDto[];
  /** @nullable */
  lastLoginAt: string | null;
  createdAt: string;
}

export interface SiteRosterCountsDto {
  pending: number;
  active: number;
  suspended: number;
}

export interface SiteRosterPageDto {
  items: SiteRosterAccountDto[];
  /** 필터 적용 뒤 전체 건수 */
  total: number;
  counts: SiteRosterCountsDto;
}

export type SetSiteRosterStatusDtoStatus =
  (typeof SetSiteRosterStatusDtoStatus)[keyof typeof SetSiteRosterStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetSiteRosterStatusDtoStatus = {
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
} as const;

export interface SetSiteRosterStatusDto {
  status: SetSiteRosterStatusDtoStatus;
}

export interface SiteApplicationNoteDto {
  /** 기록 id */
  id: string;
  /** 연락 내용 */
  body: string;
  /**
   * 적은 사람 이름
   * @nullable
   */
  authorName?: string | null;
  /** 적은 시각 */
  createdAt: string;
}

/**
 * FORM = 신청 폼, DIRECT = 직접 컨택
 */
export type SiteApplicationDtoOrigin =
  (typeof SiteApplicationDtoOrigin)[keyof typeof SiteApplicationDtoOrigin];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteApplicationDtoOrigin = {
  FORM: "FORM",
  DIRECT: "DIRECT",
} as const;

/**
 * 유입 채널 — utm·리퍼러로 코드가 판정한 값
 */
export type SiteApplicationDtoSourceChannel =
  (typeof SiteApplicationDtoSourceChannel)[keyof typeof SiteApplicationDtoSourceChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteApplicationDtoSourceChannel = {
  CMARKET_BANNER: "CMARKET_BANNER",
  CMARKET_POPUP: "CMARKET_POPUP",
  CMARKET_SUPPORT_AD: "CMARKET_SUPPORT_AD",
  BLOG: "BLOG",
  OTHER_CAMPAIGN: "OTHER_CAMPAIGN",
  REFERRAL: "REFERRAL",
  DIRECT: "DIRECT",
  OUTBOUND: "OUTBOUND",
} as const;

/**
 * 처리 상태
 */
export type SiteApplicationDtoStatus =
  (typeof SiteApplicationDtoStatus)[keyof typeof SiteApplicationDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteApplicationDtoStatus = {
  RECEIVED: "RECEIVED",
  CONTACTED: "CONTACTED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
} as const;

export interface SiteApplicationDto {
  /** 신청 번호 */
  id: string;
  /** FORM = 신청 폼, DIRECT = 직접 컨택 */
  origin: SiteApplicationDtoOrigin;
  /** 회사·단체 이름 */
  company: string;
  /**
   * 취급 품목·만들고 싶은 것(직접 컨택은 비어 있을 수 있다)
   * @nullable
   */
  product?: string | null;
  /**
   * 담당자 이름
   * @nullable
   */
  contactName?: string | null;
  /**
   * 이메일
   * @nullable
   */
  email?: string | null;
  /**
   * 연락처
   * @nullable
   */
  phone?: string | null;
  /**
   * 이미 세모 공급사로 가입한 회사라면 그 계정 id
   * @nullable
   */
  supplierUserId?: string | null;
  /**
   * 원하는 홈페이지(자유 입력)
   * @nullable
   */
  wish?: string | null;
  /** 유입 채널 — utm·리퍼러로 코드가 판정한 값 */
  sourceChannel: SiteApplicationDtoSourceChannel;
  /**
   * utm_source
   * @nullable
   */
  sourceSite?: string | null;
  /**
   * utm_medium
   * @nullable
   */
  sourceMedium?: string | null;
  /**
   * utm_campaign
   * @nullable
   */
  sourceCampaign?: string | null;
  /**
   * utm_content
   * @nullable
   */
  sourceContent?: string | null;
  /**
   * 씨마켓 접점 원장(promo_touch) id
   * @nullable
   */
  sourceClickId?: string | null;
  /**
   * 첫 진입 리퍼러
   * @nullable
   */
  sourceReferrer?: string | null;
  /** 처리 상태 */
  status: SiteApplicationDtoStatus;
  /** 연락 기록 — 최근 것이 앞 */
  notes: SiteApplicationNoteDto[];
  /**
   * 다음 연락일(YYYY-MM-DD)
   * @nullable
   */
  nextContactOn?: string | null;
  /**
   * 승인 후 만들어진 사이트 id
   * @nullable
   */
  siteId?: string | null;
  /**
   * 승인 후 만들어진 사이트 이름
   * @nullable
   */
  siteName?: string | null;
  /**
   * 처리한 시각
   * @nullable
   */
  reviewedAt?: string | null;
  /** 접수된 시각 */
  createdAt: string;
}

export interface CreateDirectSiteApplicationDto {
  /** 회사·단체 이름 */
  company: string;
  /** 취급 품목·하는 일(모르면 비움) */
  product?: string;
  /** 담당자 이름 */
  contactName?: string;
  /** 이메일 */
  email?: string;
  /** 연락처 */
  phone?: string;
  /** 이미 세모 공급사로 가입한 회사라면 그 계정 id(users.id) */
  supplierUserId?: string;
  /** 다음 연락일(YYYY-MM-DD) */
  nextContactOn?: string;
  /** 첫 연락 내용 — 연락 기록 첫 줄이 된다 */
  firstNote?: string;
}

export interface AddSiteApplicationNoteDto {
  /** 연락 내용 */
  body: string;
  /**
   * 다음 연락일(YYYY-MM-DD). 기록을 남길 때마다 새로 정한다 — null 이면 잡힌 약속 없음.
   * @nullable
   */
  nextContactOn?: string | null;
}

/**
 * 처리 상태
 */
export type ReviewSiteApplicationDtoStatus =
  (typeof ReviewSiteApplicationDtoStatus)[keyof typeof ReviewSiteApplicationDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewSiteApplicationDtoStatus = {
  RECEIVED: "RECEIVED",
  CONTACTED: "CONTACTED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
} as const;

export interface ReviewSiteApplicationDto {
  /** 처리 상태 */
  status: ReviewSiteApplicationDtoStatus;
}

export type SiteContextDtoRenderMode =
  (typeof SiteContextDtoRenderMode)[keyof typeof SiteContextDtoRenderMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteContextDtoRenderMode = {
  BLOCKS: "BLOCKS",
  SHELL: "SHELL",
} as const;

/**
 * CSS 변수 값
 */
export type SiteContextDtoTheme = { [key: string]: unknown };

export interface SiteContextDto {
  siteId: string;
  slug: string;
  name: string;
  renderMode: SiteContextDtoRenderMode;
  /** 요청한 호스트(정규화) */
  hostname: string;
  /** @nullable */
  primaryHostname: string | null;
  /** 켜진 기능 코드 — 렌더러가 이걸로 경로를 연다 */
  enabledFeatures: string[];
  /** CSS 변수 값 */
  theme: SiteContextDtoTheme;
}

/**
 * 접수 결과 — inserted 는 새로 저장, duplicate 는 같은 내용이 이미 있음(둘 다 성공이다)
 */
export type SiteApplicationSubmitResultDtoOutcome =
  (typeof SiteApplicationSubmitResultDtoOutcome)[keyof typeof SiteApplicationSubmitResultDtoOutcome];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteApplicationSubmitResultDtoOutcome = {
  inserted: "inserted",
  duplicate: "duplicate",
} as const;

export interface SiteApplicationSubmitResultDto {
  /** 접수 결과 — inserted 는 새로 저장, duplicate 는 같은 내용이 이미 있음(둘 다 성공이다) */
  outcome: SiteApplicationSubmitResultDtoOutcome;
}

export interface SubmitSiteApplicationDto {
  /** 신청 번호 — 신청자 쪽(하이세모 서버)이 만든다. 같은 값으로 다시 보내면 중복 접수되지 않는다. */
  id: string;
  /** 회사·단체 이름 */
  company: string;
  /** 취급 품목·만들고 싶은 것 */
  product: string;
  /** 담당자 이름 */
  contactName: string;
  /** 연락받을 이메일 */
  email: string;
  /** 어떤 홈페이지를 원하는지(자유 입력, 선택) */
  wish?: string;
  /** utm_source — cmarket · blog 등 */
  sourceSite?: string;
  /** utm_medium — dashboard_banner · popup · signup_complete 등 */
  sourceMedium?: string;
  /** utm_campaign — 씨마켓 배너 id 등 */
  sourceCampaign?: string;
  /** utm_content — 소재 구분(선택) */
  sourceContent?: string;
  /** 씨마켓 접점 원장(promo_touch) id — 배너를 누른 회원과 신청을 잇는다 */
  sourceClickId?: string;
  /** 첫 진입 리퍼러(origin+path) */
  sourceReferrer?: string;
}

export interface PulseAcceptedDto {
  accepted: boolean;
}

export interface PulseEventDto {
  /** 이벤트 종류 view·contact·item */
  t?: string;
  /** 페이지 경로(허용 쿼리·해시만) */
  p?: string;
  /** 페이지 제목 */
  ti?: string;
  /** 다른 사이트에서 왔으면 그 호스트 */
  r?: string;
  /** 같은 사이트 안 이동이면 '1' */
  in?: string;
  /** 캠페인 출처(utm_source) */
  us?: string;
  /** 캠페인 매체(utm_medium) */
  um?: string;
  /** 브라우저 시간대(Intl) */
  tz?: string;
  /** 제품 번호(item) */
  ir?: string;
  /** 제품 이름(item) */
  il?: string;
  /** 연락 버튼 종류(contact) — 집계에는 쓰지 않는다 */
  ct?: string;
}

export interface PulseInquiryResultDto {
  received: boolean;
}

export interface PulseInquiryDto {
  /** 문의 종류(contact·project·admission_apply …) */
  kind?: string;
  /** full(내용까지) · signal(왔다만) */
  mode?: string;
  name?: string;
  contact?: string;
  message?: string;
  /** 문의를 보낸 페이지 경로 */
  p?: string;
  /** 함정칸 — 차 있으면 저장하지 않는다 */
  hp?: string;
}

export interface PulseReactionKindDto {
  code: string;
  label: string;
  emoji: string;
}

/**
 * 대상 → { 반응 코드: 개수 }
 */
export type PulseReactionCountsDtoCounts = { [key: string]: unknown };

export interface PulseReactionCountsDto {
  enabled: boolean;
  kinds: PulseReactionKindDto[];
  /** 대상 → { 반응 코드: 개수 } */
  counts: PulseReactionCountsDtoCounts;
}

export interface PulseReactResultDto {
  /** 이번에 새로 셌나(이미 누른 브라우저면 false) */
  counted: boolean;
  total: number;
}

export interface PulseReactDto {
  /** 반응 대상(게시물 id 등) */
  target?: string;
  /** 반응 종류 코드(congrats·cheer …) */
  kind?: string;
  /** 브라우저 무작위 값 — 서버는 해시만 남긴다 */
  rid?: string;
}

export interface PulseBridgeBadgeDto {
  ref: string;
  institutions: number;
}

export interface PulseBridgeDto {
  /** 숫자 출처(기관 조회 기록)가 연결됐나 — false 면 배지를 숨긴다 */
  connected: boolean;
  windowDays: number;
  badges: PulseBridgeBadgeDto[];
}

export interface SitePulseReactionKindDto {
  code: string;
  label: string;
  emoji: string;
}

export interface SaveSitePulseSettingsDto {
  /** 처음 저장할 때만 — 비우면 자동으로 만든다. 이미 있으면 바뀌지 않는다 */
  publicKey?: string;
  /** 이 호스트에서 온 요청만 받는다. example.com 은 www 도 받는다, *.example.com 은 하위 전부 */
  allowedHosts: string[];
  visitsEnabled: boolean;
  inquiriesEnabled: boolean;
  reactionsEnabled: boolean;
  bridgeEnabled: boolean;
  weeklyReportEnabled: boolean;
  reactionKinds?: SitePulseReactionKindDto[];
}

export type SitePulseRecipientDtoPhone = { [key: string]: unknown };

export type SitePulseRecipientDtoEmail = { [key: string]: unknown };

export type SitePulseRecipientDtoChannelsItem =
  (typeof SitePulseRecipientDtoChannelsItem)[keyof typeof SitePulseRecipientDtoChannelsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SitePulseRecipientDtoChannelsItem = {
  SMS: "SMS",
  EMAIL: "EMAIL",
} as const;

export type SitePulseRecipientDtoNoticesItem =
  (typeof SitePulseRecipientDtoNoticesItem)[keyof typeof SitePulseRecipientDtoNoticesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SitePulseRecipientDtoNoticesItem = {
  INQUIRY: "INQUIRY",
  WEEKLY: "WEEKLY",
} as const;

export interface SitePulseRecipientDto {
  name: string;
  phone?: SitePulseRecipientDtoPhone;
  email?: SitePulseRecipientDtoEmail;
  channels: SitePulseRecipientDtoChannelsItem[];
  /** INQUIRY = 새 문의 즉시, WEEKLY = 월요일 09:00 주간 성적표 */
  notices: SitePulseRecipientDtoNoticesItem[];
}

export type SitePulseItemLinkDtoLabel = { [key: string]: unknown };

export interface SitePulseItemLinkDto {
  /** 고객 사이트의 제품 번호 */
  externalRef: string;
  /** 세모 물품 id(items_v2_base.id) */
  semoItemId: string;
  label?: SitePulseItemLinkDtoLabel;
}

export interface SiteAuthConfigDto {
  enabled: boolean;
  /** @nullable */
  kakaoClientId: string | null;
  /** @nullable */
  redirectUri: string | null;
}

/**
 * @nullable
 */
export type SiteAccountMemberDtoMemberType =
  | (typeof SiteAccountMemberDtoMemberType)[keyof typeof SiteAccountMemberDtoMemberType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteAccountMemberDtoMemberType = {
  PERSONAL: "PERSONAL",
  BUSINESS: "BUSINESS",
} as const;

export interface SiteAccountMemberDto {
  id: string;
  /** @nullable */
  nickname: string | null;
  /** @nullable */
  profileImageUrl: string | null;
  /** @nullable */
  email: string | null;
  /** @nullable */
  name: string | null;
  /** @nullable */
  phone: string | null;
  /** @nullable */
  memberType: SiteAccountMemberDtoMemberType;
  /** @nullable */
  businessName: string | null;
  /** @nullable */
  businessNumber: string | null;
  interests: string[];
  marketingAgreed: boolean;
  profileCompleted: boolean;
  joinedAt: string;
}

export interface SiteLoginResultDto {
  token: string;
  expiresAt: string;
  isNew: boolean;
  member: SiteAccountMemberDto;
}

export interface SiteKakaoLoginDto {
  /** 카카오가 돌려준 인가 코드 */
  code?: string;
  /** 인가 요청에 쓴 Redirect URI — 등록한 것과 글자 하나까지 같아야 한다 */
  redirectUri?: string;
}

export interface SiteSessionDto {
  /** 사이트 로그인 토큰(sa1.…) */
  token?: string;
}

export type SiteProfileDtoMemberType =
  (typeof SiteProfileDtoMemberType)[keyof typeof SiteProfileDtoMemberType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteProfileDtoMemberType = {
  PERSONAL: "PERSONAL",
  BUSINESS: "BUSINESS",
} as const;

export interface SiteProfileDto {
  /** 사이트 로그인 토큰(sa1.…) */
  token?: string;
  name?: string;
  phone?: string;
  memberType?: SiteProfileDtoMemberType;
  businessName?: string;
  businessNumber?: string;
  /** 쉼표로 — 주거,사무실 */
  interests?: string;
  /** [필수] 이용약관 — '1' */
  agreeTerms?: string;
  /** [필수] 개인정보 수집·이용 — '1' */
  agreePrivacy?: string;
  /** [선택] 소식 받기 — '1' */
  agreeMarketing?: string;
}

export interface SiteWithdrawResultDto {
  withdrawn: boolean;
}

export interface SaveSiteAuthSettingsDto {
  /** 카카오 로그인 켜기 */
  kakaoEnabled: boolean;
  /**
   * 카카오 REST API 키(앱 › 플랫폼 키) — 브라우저에 보이는 값이라 비밀이 아니다
   * @nullable
   */
  kakaoRestApiKey?: string | null;
  /**
   * 클라이언트 시크릿 — 안 보내면 그대로, 빈 글이면 지운다. 저장 뒤에는 다시 보이지 않는다
   * @nullable
   */
  kakaoClientSecret?: string | null;
  /** 카카오 콘솔에 등록한 Redirect URI 와 똑같이(https 전체 주소) */
  redirectUris: string[];
}

export interface ScanResultDto {
  scanned: number;
  eligible: number;
  queuedNew: number;
  expired: number;
}

export type DispatchEntryDtoStatus =
  (typeof DispatchEntryDtoStatus)[keyof typeof DispatchEntryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DispatchEntryDtoStatus = {
  PLANNED: "PLANNED",
  SENT: "SENT",
  FAILED: "FAILED",
  SKIPPED: "SKIPPED",
} as const;

export interface DispatchEntryDto {
  supplierId: string;
  supplierName: string;
  status: DispatchEntryDtoStatus;
  /** @nullable */
  channel: string | null;
  /** @nullable */
  skipReason: string | null;
  alertCount: number;
  moreCount: number;
  /** 이번 드라이런에서 처음 «보냈을 것»으로 잡힌 공고 수 */
  newAlerts: number;
  bidKeys: string[];
  /** @nullable */
  batchId: string | null;
  /** @nullable */
  error: string | null;
}

export type DispatchResultDtoMode =
  (typeof DispatchResultDtoMode)[keyof typeof DispatchResultDtoMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DispatchResultDtoMode = {
  DRYRUN: "DRYRUN",
  LIVE: "LIVE",
} as const;

export interface DispatchResultDto {
  mode: DispatchResultDtoMode;
  runDate: string;
  quietHours: boolean;
  candidates: number;
  expired: number;
  planned: number;
  sent: number;
  skipped: number;
  failed: number;
  entries: DispatchEntryDto[];
}

export interface ExpireStaleResultDto {
  before: string;
  beforeIso: string;
  expired: number;
}

export interface BidAlertPolicyDto {
  minCodeMatchedLines: number;
  minScore: number;
  minDaysLeft: number;
  maxBidsPerMessage: number;
  /** @nullable */
  alimtalkTemplateCode: string | null;
  alimtalkEnabled: boolean;
  quietHours: string;
}

export interface BidAlertTallyDto {
  batches: number;
  PLANNED: number;
  SENT: number;
  FAILED: number;
  SKIPPED: number;
  /** 묶음에 실린 알림 수 합계 */
  alerts: number;
}

export interface BidAlertTodayDto {
  dryrun: BidAlertTallyDto;
  live: BidAlertTallyDto;
}

/**
 * 알림 상태별 건수 (QUEUED·SENT·SKIPPED·EXPIRED …)
 */
export type BidAlertStatsDtoAlerts = { [key: string]: number };

export interface BidAlertStatsDto {
  runDate: string;
  /** BID_ALERTS_SEND_ENABLED=true 일 때만 실발송 */
  sendEnabled: boolean;
  policy: BidAlertPolicyDto;
  /** 알림 상태별 건수 (QUEUED·SENT·SKIPPED·EXPIRED …) */
  alerts: BidAlertStatsDtoAlerts;
  today: BidAlertTodayDto;
}

export type BidAlertBatchDtoMode =
  (typeof BidAlertBatchDtoMode)[keyof typeof BidAlertBatchDtoMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BidAlertBatchDtoMode = {
  DRYRUN: "DRYRUN",
  LIVE: "LIVE",
} as const;

export type BidAlertBatchDtoStatus =
  (typeof BidAlertBatchDtoStatus)[keyof typeof BidAlertBatchDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BidAlertBatchDtoStatus = {
  PLANNED: "PLANNED",
  SENT: "SENT",
  FAILED: "FAILED",
  SKIPPED: "SKIPPED",
} as const;

/**
 * 조립한 문안·변수
 */
export type BidAlertBatchDtoSummary = { [key: string]: unknown };

export interface BidAlertBatchDto {
  id: string;
  supplierId: string;
  runDate: string;
  mode: BidAlertBatchDtoMode;
  status: BidAlertBatchDtoStatus;
  /** @nullable */
  channel: string | null;
  /** @nullable */
  skipReason: string | null;
  alertCount: number;
  moreCount: number;
  bidKeys: string[];
  /** 조립한 문안·변수 */
  summary: BidAlertBatchDtoSummary;
  /** @nullable */
  error: string | null;
  /** @nullable */
  sentAt: string | null;
  createdAt: string;
}

export type GcmRequestCreateDtoRequestType =
  (typeof GcmRequestCreateDtoRequestType)[keyof typeof GcmRequestCreateDtoRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmRequestCreateDtoRequestType = {
  PURCHASE: "PURCHASE",
  SELL: "SELL",
  DISTRIBUTION_PARTNER: "DISTRIBUTION_PARTNER",
  OEM_ODM: "OEM_ODM",
  SOURCING_RESEARCH: "SOURCING_RESEARCH",
  TECH_COOPERATION: "TECH_COOPERATION",
} as const;

export type GcmRequestCreateDtoLang =
  (typeof GcmRequestCreateDtoLang)[keyof typeof GcmRequestCreateDtoLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmRequestCreateDtoLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export type GcmRequestCreateDtoFields = { [key: string]: unknown };

export type GcmRequestCreateDtoFieldSources = { [key: string]: unknown };

export interface GcmRequestCreateDto {
  requestType: GcmRequestCreateDtoRequestType;
  orgId?: string;
  lang?: GcmRequestCreateDtoLang;
  fields?: GcmRequestCreateDtoFields;
  fieldSources?: GcmRequestCreateDtoFieldSources;
  purposeText?: string;
}

export type GcmAssistTurnDtoRole =
  (typeof GcmAssistTurnDtoRole)[keyof typeof GcmAssistTurnDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmAssistTurnDtoRole = {
  user: "user",
  assistant: "assistant",
} as const;

export interface GcmAssistTurnDto {
  role: GcmAssistTurnDtoRole;
  /** @maxLength 2000 */
  text: string;
}

export type GcmRequestAiAssistDtoRequestType =
  (typeof GcmRequestAiAssistDtoRequestType)[keyof typeof GcmRequestAiAssistDtoRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmRequestAiAssistDtoRequestType = {
  PURCHASE: "PURCHASE",
  SELL: "SELL",
  DISTRIBUTION_PARTNER: "DISTRIBUTION_PARTNER",
  OEM_ODM: "OEM_ODM",
  SOURCING_RESEARCH: "SOURCING_RESEARCH",
  TECH_COOPERATION: "TECH_COOPERATION",
} as const;

export type GcmRequestAiAssistDtoLang =
  (typeof GcmRequestAiAssistDtoLang)[keyof typeof GcmRequestAiAssistDtoLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmRequestAiAssistDtoLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export type GcmRequestAiAssistDtoFields = { [key: string]: unknown };

export interface GcmRequestAiAssistDto {
  requestType?: GcmRequestAiAssistDtoRequestType;
  lang: GcmRequestAiAssistDtoLang;
  /** @maxLength 2000 */
  message: string;
  /** @maxItems 20 */
  history: GcmAssistTurnDto[];
  fields?: GcmRequestAiAssistDtoFields;
  /** @maxItems 200 */
  asked?: string[];
  develop?: boolean;
}

export type GcmRequestAssistGuideDtoRequestType =
  (typeof GcmRequestAssistGuideDtoRequestType)[keyof typeof GcmRequestAssistGuideDtoRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmRequestAssistGuideDtoRequestType = {
  PURCHASE: "PURCHASE",
  SELL: "SELL",
  DISTRIBUTION_PARTNER: "DISTRIBUTION_PARTNER",
  OEM_ODM: "OEM_ODM",
  SOURCING_RESEARCH: "SOURCING_RESEARCH",
  TECH_COOPERATION: "TECH_COOPERATION",
} as const;

export type GcmRequestAssistGuideDtoFields = { [key: string]: unknown };

export interface GcmRequestAssistGuideDto {
  requestType?: GcmRequestAssistGuideDtoRequestType;
  fields?: GcmRequestAssistGuideDtoFields;
  /** @maxItems 200 */
  asked?: string[];
  develop?: boolean;
}

export type GcmRequestPatchDtoFields = { [key: string]: unknown };

export type GcmRequestPatchDtoFieldSources = { [key: string]: unknown };

export type GcmRequestPatchDtoRequestType =
  (typeof GcmRequestPatchDtoRequestType)[keyof typeof GcmRequestPatchDtoRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmRequestPatchDtoRequestType = {
  PURCHASE: "PURCHASE",
  SELL: "SELL",
  DISTRIBUTION_PARTNER: "DISTRIBUTION_PARTNER",
  OEM_ODM: "OEM_ODM",
  SOURCING_RESEARCH: "SOURCING_RESEARCH",
  TECH_COOPERATION: "TECH_COOPERATION",
} as const;

export interface GcmRequestPatchDto {
  fields?: GcmRequestPatchDtoFields;
  fieldSources?: GcmRequestPatchDtoFieldSources;
  /** @nullable */
  orgId?: string | null;
  /** @nullable */
  purposeText?: string | null;
  requestType?: GcmRequestPatchDtoRequestType;
}

export type GcmRequestSubmitDtoVisibility =
  (typeof GcmRequestSubmitDtoVisibility)[keyof typeof GcmRequestSubmitDtoVisibility];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmRequestSubmitDtoVisibility = {
  ANONYMOUS_SUMMARY: "ANONYMOUS_SUMMARY",
} as const;

export interface GcmRequestSubmitDto {
  visibility: GcmRequestSubmitDtoVisibility;
  agreeDisclaimer: boolean;
}

export type GcmRequestEvidenceUploadDtoClaimKind =
  (typeof GcmRequestEvidenceUploadDtoClaimKind)[keyof typeof GcmRequestEvidenceUploadDtoClaimKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmRequestEvidenceUploadDtoClaimKind = {
  PURCHASE_APPROVED: "PURCHASE_APPROVED",
  PAYMENT_PATH: "PAYMENT_PATH",
  DISTRIBUTION_CAPABILITY: "DISTRIBUTION_CAPABILITY",
  ITEM_EXPERIENCE: "ITEM_EXPERIENCE",
  PERMIT_VALID: "PERMIT_VALID",
  OTHER: "OTHER",
} as const;

export interface GcmRequestEvidenceUploadDto {
  claimKind: GcmRequestEvidenceUploadDtoClaimKind;
  note?: string;
}

export type AdminGcmRequestSCheckDtoResult =
  (typeof AdminGcmRequestSCheckDtoResult)[keyof typeof AdminGcmRequestSCheckDtoResult];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmRequestSCheckDtoResult = {
  PASS: "PASS",
  FAIL: "FAIL",
  UNCONFIRMED: "UNCONFIRMED",
} as const;

export interface AdminGcmRequestSCheckDto {
  result: AdminGcmRequestSCheckDtoResult;
  note?: string;
}

export type AdminGcmRequestEvidenceDtoStatus =
  (typeof AdminGcmRequestEvidenceDtoStatus)[keyof typeof AdminGcmRequestEvidenceDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmRequestEvidenceDtoStatus = {
  PENDING: "PENDING",
  VERIFIED: "VERIFIED",
  MISMATCH: "MISMATCH",
} as const;

export interface AdminGcmRequestEvidenceDto {
  status: AdminGcmRequestEvidenceDtoStatus;
  note?: string;
}

export type AdminGcmRequestRiskDtoRiskStatus =
  (typeof AdminGcmRequestRiskDtoRiskStatus)[keyof typeof AdminGcmRequestRiskDtoRiskStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmRequestRiskDtoRiskStatus = {
  NORMAL: "NORMAL",
  EXTRA_REVIEW: "EXTRA_REVIEW",
  PUBLISH_HOLD: "PUBLISH_HOLD",
} as const;

export interface AdminGcmRequestRiskDto {
  riskStatus: AdminGcmRequestRiskDtoRiskStatus;
  note: string;
}

export type AdminGcmRequestDecisionDtoDecision =
  (typeof AdminGcmRequestDecisionDtoDecision)[keyof typeof AdminGcmRequestDecisionDtoDecision];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmRequestDecisionDtoDecision = {
  APPROVE_S: "APPROVE_S",
  PUBLISH_GENERAL: "PUBLISH_GENERAL",
  NEEDS_INFO: "NEEDS_INFO",
  HOLD: "HOLD",
  REJECT: "REJECT",
  REOPEN: "REOPEN",
} as const;

export interface AdminGcmRequestDecisionDto {
  decision: AdminGcmRequestDecisionDtoDecision;
  note?: string;
}

export interface GcmBidIngestItemDto {
  name: string;
  qty?: number;
  unit?: string;
  spec?: string;
}

export type GcmBidIngestRecordDtoRaw = { [key: string]: unknown };

export interface GcmBidIngestRecordDto {
  /** 수집 레인 이름 — 멱등 키 앞쪽 */
  sourceKey: string;
  /** 그 출처 안의 공고 번호 — 멱등 키 뒤쪽 */
  sourceBidId: string;
  /** ISO-3166 alpha-2 — ID·JP 만(아니면 400 GCM_COUNTRY_UNSUPPORTED) */
  country?: string;
  title: string;
  buyerName?: string;
  budget?: number;
  currency?: string;
  deadlineAt?: string;
  publishedAt?: string;
  sourceName: string;
  sourceUrl?: string;
  items?: GcmBidIngestItemDto[];
  raw?: GcmBidIngestRecordDtoRaw;
}

export interface GcmBidIngestDto {
  records: GcmBidIngestRecordDto[];
}

export interface AdminGcmBidInboxSettingDto {
  /**
   * 이 날(그 나라 현지 날짜)까지 무료. null = 무료 기간 없음(바로 구독 필요). 빠뜨리면 400
   * @nullable
   */
  freeUntil: string | null;
}

export interface AdminGcmBidLineRegisterDto {
  /** true(기본) 면 연결·등록을 하지 않고 세기만 한다 — 매칭률과 앞쪽 결정 30줄을 돌려준다. false 면 실제로 잇고 등록한다 */
  dryRun?: boolean;
  /** 이번에 읽을 줄 수(기본 500, 최대 5,000) */
  limit?: number;
}

export interface GcmQuoteLineDto {
  name: string;
  qty: number;
  /** 통화 단위 그대로의 단가 */
  unitPrice: number;
}

export type GcmParticipateDtoCurrency =
  (typeof GcmParticipateDtoCurrency)[keyof typeof GcmParticipateDtoCurrency];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmParticipateDtoCurrency = {
  USD: "USD",
  KRW: "KRW",
} as const;

export interface GcmParticipateDto {
  currency: GcmParticipateDtoCurrency;
  lines: GcmQuoteLineDto[];
  /** 발주 후 납기(일) */
  leadTimeDays: number;
  /** 이 날까지 견적 유효 */
  validUntil: string;
  /** 결제·포장·인코텀즈 등 추가 조건(연락처 금지) */
  note?: string;
}

export interface GcmReasonDto {
  reason?: string;
}

export interface GcmConfirmContractDto {
  contractDate: string;
  note?: string;
}

export interface AdminGcmRefundDto {
  reason: string;
}

export type GcmFeeScheduleItemDtoEventType =
  (typeof GcmFeeScheduleItemDtoEventType)[keyof typeof GcmFeeScheduleItemDtoEventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmFeeScheduleItemDtoEventType = {
  GCM_JOIN: "GCM_JOIN",
  GCM_CONTACT: "GCM_CONTACT",
  GCM_CONTRACT: "GCM_CONTRACT",
} as const;

export interface GcmFeeScheduleItemDto {
  eventType: GcmFeeScheduleItemDtoEventType;
  amountExVatKrw: number;
  /** @nullable */
  usdLabel?: string | null;
  /** @nullable */
  effectiveFrom?: string | null;
  /** @nullable */
  note?: string | null;
}

export interface AdminGcmFeeScheduleDto {
  items: GcmFeeScheduleItemDto[];
}

export interface AdminGcmNoteDto {
  note: string;
}

/**
 * 원문 말. 없으면 요청자는 계정 말, 한국 기업·에이전트는 ko
 */
export type GcmDealMessageCreateDtoLang =
  (typeof GcmDealMessageCreateDtoLang)[keyof typeof GcmDealMessageCreateDtoLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmDealMessageCreateDtoLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export interface GcmDealMessageCreateDto {
  /** @maxLength 4000 */
  body: string;
  /** 원문 말. 없으면 요청자는 계정 말, 한국 기업·에이전트는 ko */
  lang?: GcmDealMessageCreateDtoLang;
}

export interface GcmPrepHelpDto {
  /**
   * 무엇이 막혔는지(연락처·회사명은 쓰지 않는다 — 에이전트에겐 가려서 보인다)
   * @maxLength 2000
   */
  note?: string;
}

export interface GcmPrepSuggestionDto {
  /**
   * @minLength 1
   * @maxLength 4000
   */
  body: string;
}

export interface GcmActivityRequestDto {
  /** 요청 번호 */
  requestNo: string;
  /**
   * 내 회사 요청일 때만(상세 링크용). 남의 요청은 null
   * @nullable
   */
  id: string | null;
  /** 요청 유형(PURCHASE·SELL …) */
  requestType: string;
  /** 제목(연락처·회사명은 가려진다) */
  title: string;
  /** 첫 품목 최대 3개 */
  items: string[];
  /** 전체 품목 수 */
  itemCount: number;
  /**
   * 도시·주·나라
   * @nullable
   */
  destinationText: string | null;
  /**
   * 예산 규모 구간 문구(원값 아님) — «USD 20k–50k»
   * @nullable
   */
  budgetText: string | null;
  /**
   * 등급(S·A·B·C·D)
   * @nullable
   */
  grade: string | null;
  /** 참여한 한국 기업 수(거절 제외) */
  joinedCompanies: number;
  /** 보는 사람 회사(또는 본인)의 요청인가 */
  mine: boolean;
}

export interface GcmActivityKoreanBidDto {
  key: string;
  /** 출처 코드 — G2B·CMARKET·SEMO … */
  source: string;
  /** 출처 표시 이름 */
  sourceLabel: string;
  /** 공고명(한국어 원문) */
  title: string;
  /**
   * 공개 입찰 공고의 발주기관명. 세모·씨마켓 출처는 항상 null
   * @nullable
   */
  organizationName: string | null;
  /** 마감 시각(ISO) */
  closingAt: string;
  /**
   * 추정가격·예산(원)
   * @nullable
   */
  amount: number | null;
  /**
   * 물품·용역·공사
   * @nullable
   */
  bizType: string | null;
}

export interface GcmActivityContractDto {
  /** 첫 품목명 */
  itemName: string;
  /** 첫 품목 말고 몇 종 더 */
  moreItems: number;
  /** 한국어 요약 «공기청정기 외 2종» */
  itemSummary: string;
  /**
   * 계약 금액(원)
   * @nullable
   */
  amount: number | null;
  /** 계약 시각(ISO) */
  contractedAt: string;
}

export interface GcmActivityMonthlyActiveDto {
  /** 최근 30일 활동 공급사 수 */
  suppliers: number;
  /** 최근 30일 활동 기관·구매자 수 */
  buyers: number;
  windowDays: number;
  /** 집계한 시각(ISO) */
  asOf: string;
}

/**
 * 숫자의 출처 — sample 은 운영이 아닌 환경에서 씨마켓에 닿지 못할 때의 표본 값
 */
export type GcmActivityActiveCompaniesDtoSource =
  (typeof GcmActivityActiveCompaniesDtoSource)[keyof typeof GcmActivityActiveCompaniesDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmActivityActiveCompaniesDtoSource = {
  cmarket: "cmarket",
  sample: "sample",
} as const;

export interface GcmActivityActiveCompaniesDto {
  /** 창 안에 씨마켓 공고에 한 번이라도 응찰한 공급사 수 */
  suppliers: number;
  /** 창 안에 씨마켓에 공고를 한 번이라도 올린 발주 계정 수 */
  buyers: number;
  /**
   * 보유 기업 수 — 씨마켓에서 탈퇴하지 않은 기업 회원 전체(창과 무관). 전광판 큰 숫자. 씨마켓이 아직 주지 않으면 null
   * @nullable
   */
  registeredSuppliers: number | null;
  /**
   * 보유 발주기관 수 — 탈퇴하지 않은 발주기관 회원 전체(창과 무관). 씨마켓이 아직 주지 않으면 null
   * @nullable
   */
  registeredBuyers: number | null;
  windowDays: number;
  /** 씨마켓이 집계한 시각(ISO) */
  asOf: string;
  /** 숫자의 출처 — sample 은 운영이 아닌 환경에서 씨마켓에 닿지 못할 때의 표본 값 */
  source: GcmActivityActiveCompaniesDtoSource;
}

export interface GcmActivityContractTotalsDto {
  /** 계약 건수(취소 제외) */
  count: number;
  /** 계약 금액 합(원) */
  amount: number;
}

/**
 * 최근 30일(720시간) 계약 건수·금액 합(원)
 * @nullable
 */
export type GcmActivityStatsDtoContracts30d =
  GcmActivityContractTotalsDto | null;

export interface GcmActivityStatsDto {
  /**
   * 지금 열려 있는 한국 공고·프로젝트 전체 수(공고함 원장 + 세모 공개 견적요청)
   * @nullable
   */
  openBids: number | null;
  /**
   * 그중 지금부터 7일(168시간) 안에 마감되는 수
   * @nullable
   */
  closingIn7Days: number | null;
  /**
   * 그중 한국 시간(Asia/Seoul)으로 오늘 안에 마감되는 수
   * @nullable
   */
  closingToday: number | null;
  /**
   * 최근 30일(720시간) 계약 건수·금액 합(원)
   * @nullable
   */
  contracts30d: GcmActivityStatsDtoContracts30d;
  /**
   * 한국 시간(Asia/Seoul) 이번 달 1일 0시 이후 계약 건수
   * @nullable
   */
  contractsThisMonth: number | null;
}

export interface GcmActivityLocalBidDto {
  /**
   * 상세(`/tenders/:id`) 링크용 공고 id. 표본 줄은 null
   * @nullable
   */
  id: string | null;
  /** 공고명(그 나라 말 원문) */
  title: string;
  /**
   * 발주처
   * @nullable
   */
  buyerName: string | null;
  /**
   * 마감 시각(ISO). 마감일이 없는 출처는 null
   * @nullable
   */
  deadlineAt: string | null;
  /**
   * 공고일(ISO)
   * @nullable
   */
  publishedAt: string | null;
  /**
   * 예산 — currency 의 통화 그대로(환산하지 않는다)
   * @nullable
   */
  budget: number | null;
  /**
   * 통화 코드(IDR·JPY …)
   * @nullable
   */
  currency: string | null;
  /** 출처 이름 */
  sourceName: string;
}

/**
 * 보는 사람의 공고함 나라 — 승인된 회사의 나라
 */
export type GcmActivityLocalBidsDtoCountry =
  (typeof GcmActivityLocalBidsDtoCountry)[keyof typeof GcmActivityLocalBidsDtoCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmActivityLocalBidsDtoCountry = {
  ID: "ID",
  JP: "JP",
} as const;

export interface GcmActivityLocalBidsDto {
  /** 보는 사람의 공고함 나라 — 승인된 회사의 나라 */
  country: GcmActivityLocalBidsDtoCountry;
  /** 그 나라의 열린 공고 수(마감이 없거나 지금 이후) */
  total: number;
  /** 그중 공고일이 최근 7일 안인 수 — 공고일이 없는 출처는 세지 않는다 */
  newThisWeek: number;
  /** 무료 기간이 끝났고 구독이 없는 사람 — 공고함 목록이 402 를 내는 사람이다. 수만 싣고 items 는 항상 빈 목록 */
  locked: boolean;
  /** 열린 공고 최대 12건 — 최근에 올라온 줄에서 출처별로 번갈아 고른다 */
  items: GcmActivityLocalBidDto[];
}

/**
 * 세모 자체 30일 활동 수. 집계에 실패하면 null — 전광판은 activeCompanies 가 없을 때만 이 값을 쓴다
 * @nullable
 */
export type GcmActivityDtoMonthlyActive = GcmActivityMonthlyActiveDto | null;

/**
 * 씨마켓 고객사 수 — 보유 기업 수(전광판 큰 숫자)와 최근 1년 활동 수. 씨마켓에 닿지 못하면 null
 * @nullable
 */
export type GcmActivityDtoActiveCompanies =
  GcmActivityActiveCompaniesDto | null;

/**
 * 보는 사람 나라의 공고(인니 회사면 인니 공고, 일본 회사면 일본 공고). 승인된 회사·소속이 없거나 읽기에 실패하면 null
 * @nullable
 */
export type GcmActivityDtoLocalBids = GcmActivityLocalBidsDto | null;

export interface GcmActivityDto {
  requests: GcmActivityRequestDto[];
  koreanBids: GcmActivityKoreanBidDto[];
  recentContracts: GcmActivityContractDto[];
  /**
   * 세모 자체 30일 활동 수. 집계에 실패하면 null — 전광판은 activeCompanies 가 없을 때만 이 값을 쓴다
   * @nullable
   */
  monthlyActive: GcmActivityDtoMonthlyActive;
  /**
   * 씨마켓 고객사 수 — 보유 기업 수(전광판 큰 숫자)와 최근 1년 활동 수. 씨마켓에 닿지 못하면 null
   * @nullable
   */
  activeCompanies: GcmActivityDtoActiveCompanies;
  /** 전광판 숫자 — 실패한 칸만 null */
  stats: GcmActivityStatsDto;
  /**
   * 보는 사람 나라의 공고(인니 회사면 인니 공고, 일본 회사면 일본 공고). 승인된 회사·소속이 없거나 읽기에 실패하면 null
   * @nullable
   */
  localBids: GcmActivityDtoLocalBids;
  /** 응답을 만든 시각(ISO) */
  generatedAt: string;
  /** 표본 값으로 채운 구역 이름 — 운영이 아닌 환경에서만 실린다(실제 집계 아님) */
  sampleSections?: string[];
}

/**
 * 본 화면 — COMPANY 회사 카드 · QUOTE 견적 · ITEM 품목
 */
export type GcmReactionViewsDtoSurface =
  (typeof GcmReactionViewsDtoSurface)[keyof typeof GcmReactionViewsDtoSurface];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmReactionViewsDtoSurface = {
  COMPANY: "COMPANY",
  QUOTE: "QUOTE",
  ITEM: "ITEM",
} as const;

/**
 * 화면의 나라(회사가 여럿일 때 그 나라 회사로 센다)
 */
export type GcmReactionViewsDtoCountry =
  (typeof GcmReactionViewsDtoCountry)[keyof typeof GcmReactionViewsDtoCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmReactionViewsDtoCountry = {
  ID: "ID",
  JP: "JP",
} as const;

export interface GcmReactionViewsDto {
  /** 본 화면 — COMPANY 회사 카드 · QUOTE 견적 · ITEM 품목 */
  surface: GcmReactionViewsDtoSurface;
  /**
   * ITEM — 본 세모 마스터 품목 id
   * @maxItems 30
   */
  itemIds?: string[];
  /** COMPANY·QUOTE — 바이어 요청 id */
  requestId?: string;
  /**
   * COMPANY·QUOTE — 본 한국 후보 id
   * @maxItems 10
   */
  candidateIds?: string[];
  /** 화면의 나라(회사가 여럿일 때 그 나라 회사로 센다) */
  country?: GcmReactionViewsDtoCountry;
}

/**
 * 누른 화면 — SELLABLE 홈 «바로 판매 가능한 제품» · MATCH_ITEMS «바로 매칭 가능한 품목»
 */
export type GcmWaveDtoSurface =
  (typeof GcmWaveDtoSurface)[keyof typeof GcmWaveDtoSurface];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmWaveDtoSurface = {
  SELLABLE: "SELLABLE",
  MATCH_ITEMS: "MATCH_ITEMS",
} as const;

/**
 * 화면의 나라
 */
export type GcmWaveDtoCountry =
  (typeof GcmWaveDtoCountry)[keyof typeof GcmWaveDtoCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmWaveDtoCountry = {
  ID: "ID",
  JP: "JP",
} as const;

export interface GcmWaveDto {
  /** 세모 마스터 품목 id */
  itemId: string;
  /** 누른 화면 — SELLABLE 홈 «바로 판매 가능한 제품» · MATCH_ITEMS «바로 매칭 가능한 품목» */
  surface: GcmWaveDtoSurface;
  /** 이어 주고 싶은 내 요청(열린 요청일 때만 쓰인다) */
  requestId?: string;
  /** 화면의 나라 */
  country?: GcmWaveDtoCountry;
}

/**
 * 정해진 문구 열쇠
 */
export type GcmQuickReactionDtoKey =
  (typeof GcmQuickReactionDtoKey)[keyof typeof GcmQuickReactionDtoKey];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmQuickReactionDtoKey = {
  THANKS: "THANKS",
  INTERESTED: "INTERESTED",
  QUOTE_PLEASE: "QUOTE_PLEASE",
  MORE_INFO: "MORE_INFO",
  CHECKING: "CHECKING",
  QUOTE_SOON: "QUOTE_SOON",
} as const;

export interface GcmQuickReactionDto {
  /** 정해진 문구 열쇠 */
  key: GcmQuickReactionDtoKey;
}

export interface TrendBlockedTermCreateDto {
  /** 연예인·그룹 이름(저장 때 소문자·공백 하나로 정규화) */
  term: string;
  /** @nullable */
  note?: string | null;
}

export type TrendAssetCreateDtoSource =
  (typeof TrendAssetCreateDtoSource)[keyof typeof TrendAssetCreateDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendAssetCreateDtoSource = {
  OWN: "OWN",
  BRAND: "BRAND",
  PUBLIC_RANKING: "PUBLIC_RANKING",
} as const;

export type TrendAssetCreateDtoAllowedChannelsItem =
  (typeof TrendAssetCreateDtoAllowedChannelsItem)[keyof typeof TrendAssetCreateDtoAllowedChannelsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendAssetCreateDtoAllowedChannelsItem = {
  CATALOG: "CATALOG",
  BUYER_KIT: "BUYER_KIT",
  SNS: "SNS",
  PAID_ADS: "PAID_ADS",
} as const;

export type TrendAssetCreateDtoKind =
  (typeof TrendAssetCreateDtoKind)[keyof typeof TrendAssetCreateDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendAssetCreateDtoKind = {
  IMAGE: "IMAGE",
  VIDEO_LINK: "VIDEO_LINK",
} as const;

export interface TrendAssetCreateDto {
  /**
   * VIDEO_LINK — youtube.com·youtu.be·tiktok.com·instagram.com 공식 링크(https)
   * @nullable
   */
  videoUrl?: string | null;
  /** @nullable */
  captionId?: string | null;
  /** @nullable */
  captionKo?: string | null;
  source?: TrendAssetCreateDtoSource;
  /**
   * PUBLIC_RANKING 출처 화면
   * @nullable
   */
  sourceUrl?: string | null;
  containsPerson?: boolean;
  /** @nullable */
  licensorName?: string | null;
  /** 허락 지역(나라 코드) */
  allowedRegions?: string[];
  allowedChannels?: TrendAssetCreateDtoAllowedChannelsItem[];
  /**
   * 허락 시작 시각(ISO 8601)
   * @nullable
   */
  licenseStartsAt?: string | null;
  /**
   * 허락 만료 시각(ISO 8601)
   * @nullable
   */
  licenseExpiresAt?: string | null;
  allowBuyerReuse?: boolean;
  agencyConsentConfirmed?: boolean;
  kind: TrendAssetCreateDtoKind;
}

export type TrendAssetPatchDtoSource =
  (typeof TrendAssetPatchDtoSource)[keyof typeof TrendAssetPatchDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendAssetPatchDtoSource = {
  OWN: "OWN",
  BRAND: "BRAND",
  PUBLIC_RANKING: "PUBLIC_RANKING",
} as const;

export type TrendAssetPatchDtoAllowedChannelsItem =
  (typeof TrendAssetPatchDtoAllowedChannelsItem)[keyof typeof TrendAssetPatchDtoAllowedChannelsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendAssetPatchDtoAllowedChannelsItem = {
  CATALOG: "CATALOG",
  BUYER_KIT: "BUYER_KIT",
  SNS: "SNS",
  PAID_ADS: "PAID_ADS",
} as const;

export interface TrendAssetPatchDto {
  /**
   * VIDEO_LINK — youtube.com·youtu.be·tiktok.com·instagram.com 공식 링크(https)
   * @nullable
   */
  videoUrl?: string | null;
  /** @nullable */
  captionId?: string | null;
  /** @nullable */
  captionKo?: string | null;
  source?: TrendAssetPatchDtoSource;
  /**
   * PUBLIC_RANKING 출처 화면
   * @nullable
   */
  sourceUrl?: string | null;
  containsPerson?: boolean;
  /** @nullable */
  licensorName?: string | null;
  /** 허락 지역(나라 코드) */
  allowedRegions?: string[];
  allowedChannels?: TrendAssetPatchDtoAllowedChannelsItem[];
  /**
   * 허락 시작 시각(ISO 8601)
   * @nullable
   */
  licenseStartsAt?: string | null;
  /**
   * 허락 만료 시각(ISO 8601)
   * @nullable
   */
  licenseExpiresAt?: string | null;
  allowBuyerReuse?: boolean;
  agencyConsentConfirmed?: boolean;
}

export interface TrendReviewNoteDto {
  /** 반려는 필수 */
  note?: string;
}

export interface TrendTextEntryDto {
  /** 칸 이름(돌려줄 때 그대로) */
  field: string;
  text: string;
}

export interface TrendTextCheckDto {
  /** @maxItems 30 */
  texts: TrendTextEntryDto[];
}

export type TrendPickDtoCategory =
  (typeof TrendPickDtoCategory)[keyof typeof TrendPickDtoCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendPickDtoCategory = {
  SKINCARE: "SKINCARE",
  MAKEUP: "MAKEUP",
  HAIR_BODY: "HAIR_BODY",
  FOOD: "FOOD",
  BEVERAGE: "BEVERAGE",
  HEALTH: "HEALTH",
  LIVING: "LIVING",
  OTHER: "OTHER",
} as const;

export type TrendPickDtoBpomStatus =
  (typeof TrendPickDtoBpomStatus)[keyof typeof TrendPickDtoBpomStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendPickDtoBpomStatus = {
  REGISTERED: "REGISTERED",
  IMPORTER_NEEDED: "IMPORTER_NEEDED",
  UNKNOWN: "UNKNOWN",
} as const;

export type TrendPickDtoHalalStatus =
  (typeof TrendPickDtoHalalStatus)[keyof typeof TrendPickDtoHalalStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendPickDtoHalalStatus = {
  CERTIFIED: "CERTIFIED",
  NOT_CERTIFIED: "NOT_CERTIFIED",
  UNKNOWN: "UNKNOWN",
} as const;

export interface TrendPickDto {
  category?: TrendPickDtoCategory;
  sortOrder?: number;
  /** 인니어 제품명(필수) */
  productNameId?: string;
  /** @nullable */
  productNameKo?: string | null;
  /** @nullable */
  productNameEn?: string | null;
  brandName?: string;
  /** @nullable */
  makerName?: string | null;
  /** @nullable */
  descriptionKo?: string | null;
  /** @nullable */
  descriptionId?: string | null;
  /** @nullable */
  descriptionEn?: string | null;
  /**
   * 세모 마스터 품목 id(items_v2_base.id)
   * @nullable
   */
  itemId?: string | null;
  /**
   * 공급사 id(suppliers.id)
   * @nullable
   */
  supplierId?: string | null;
  /**
   * 화제 근거(인니어) — 예 «Terlaris #1 toner di Shopee ID»
   * @nullable
   */
  trendNoteId?: string | null;
  /** @nullable */
  trendNoteKo?: string | null;
  /** @nullable */
  trendSourceUrl?: string | null;
  /**
   * 예 «2026 Q2»
   * @nullable
   */
  trendPeriod?: string | null;
  bpomStatus?: TrendPickDtoBpomStatus;
  /** @nullable */
  bpomNumber?: string | null;
  /**
   * 인니 등록사 이름
   * @nullable
   */
  bpomHolder?: string | null;
  halalStatus?: TrendPickDtoHalalStatus;
  /** @nullable */
  halalBody?: string | null;
}

export type TrendPickStatusDtoStatus =
  (typeof TrendPickStatusDtoStatus)[keyof typeof TrendPickStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendPickStatusDtoStatus = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
  ARCHIVED: "ARCHIVED",
} as const;

export interface TrendPickStatusDto {
  status: TrendPickStatusDtoStatus;
}

export interface InsurerBidRecordsResultDto {
  received: number;
  saved: number;
  /** 보험 가입 공고가 아니라 버린 줄 */
  skippedNotInsurance: number;
  /** 세모 공급사에 못 이은 줄(저장은 한다) */
  unlinked: number;
}

export interface InsurerBidRecordDto {
  /** 씨마켓 공고번호(buy_idx) */
  bidNo: string;
  /** 응찰 회원 아이디(b2b_buy_join.join_id) — 세모 공급사 연결 열쇠 */
  memberId: string;
  /** 응찰 회사명(join_com) */
  companyName: string;
  /** 공고명(f_name) — 세모가 이 글로 보험 종목을 정한다 */
  title: string;
  /**
   * 발주기관(mem_com)
   * @nullable
   */
  orgName?: string | null;
  /** 낙찰(success_yn = Y) */
  won: boolean;
  /**
   * 공고일(ISO)
   * @nullable
   */
  noticedAt?: string | null;
}

export interface InsurerBidRecordsBatchDto {
  records: InsurerBidRecordDto[];
}

/**
 * 인증번호의 용도 — 그 용도로만 쓸 수 있다(GCM_PAUSE 글로벌 연결 내리기 · GCM_RESUME 다시 열기 · OWNER_PHONE_CHANGE 대표 번호 바꾸기)
 */
export type OwnerKeyIssueCodeDtoPurpose =
  (typeof OwnerKeyIssueCodeDtoPurpose)[keyof typeof OwnerKeyIssueCodeDtoPurpose];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OwnerKeyIssueCodeDtoPurpose = {
  GCM_PAUSE: "GCM_PAUSE",
  GCM_RESUME: "GCM_RESUME",
  OWNER_PHONE_CHANGE: "OWNER_PHONE_CHANGE",
} as const;

export interface OwnerKeyIssueCodeDto {
  /** 인증번호의 용도 — 그 용도로만 쓸 수 있다(GCM_PAUSE 글로벌 연결 내리기 · GCM_RESUME 다시 열기 · OWNER_PHONE_CHANGE 대표 번호 바꾸기) */
  purpose: OwnerKeyIssueCodeDtoPurpose;
}

export interface OwnerKeyNewPhoneCodeDto {
  /** 지금 대표 번호로 간 인증번호(OWNER_PHONE_CHANGE) 6자리 */
  code: string;
  /** 새 대표 번호(국내 휴대폰) — 이 번호로 확인용 인증번호가 간다 */
  newPhone: string;
}

export interface OwnerKeyConfirmPhoneDto {
  /** 새 번호로 간 확인용 인증번호 6자리 */
  code: string;
}

export interface GcmPlatformStateDto {
  /** true 면 글로벌씨마켓 화면이 내려가 있다(점검 화면). 읽지 못했을 때도 화면은 내린 것으로 본다 */
  paused: boolean;
}

export interface AdminSetGcmPlatformStateDto {
  /** true = 내리기, false = 다시 열기 */
  paused: boolean;
  /** 대표 휴대폰으로 간 인증번호 6자리 — 내리기는 GCM_PAUSE, 다시 열기는 GCM_RESUME 용도로 받은 것 */
  code: string;
}

export interface WeeklyViewerKindDto {
  /** 기관 유형 — university·research·public·local_gov·school·hospital·company·unknown */
  kind: string;
  /** 보이는 이름(대학·연구기관·공공기관·지자체·학교·병원·기업·기관) */
  label: string;
  /** 이번 주 이 유형 기관 수 */
  count: number;
}

export interface WeeklyViewersThisWeekDto {
  /** 이번 주(월~오늘, KST) 회사를 본 기관 수 */
  orgCount: number;
  kinds: WeeklyViewerKindDto[];
  /** 본 기관의 시도(기관 수 많은 순, 모르는 곳은 뺌) */
  provinces: string[];
}

export interface WeeklyViewersLastWeekDto {
  /** 지난주(월~일) 회사를 본 기관 수 */
  orgCount: number;
  /** 지난주 같은 기간(월~오늘과 같은 요일) 기관 수 — 비교용 */
  samePeriodOrgCount: number;
}

export interface WeeklyViewedItemDto {
  /** 세모 물품 id(items_v2_base.id) */
  itemId: string;
  /** 물품 이름 */
  name: string;
  /** 이번 주 이 물품 상세를 본 기관 수 */
  orgCount: number;
}

export interface SupplierWeeklyViewersDto {
  /** 이번 주 월요일(KST, YYYY-MM-DD) */
  weekStart: string;
  /** 오늘(KST, YYYY-MM-DD) */
  today: string;
  thisWeek: WeeklyViewersThisWeekDto;
  lastWeek: WeeklyViewersLastWeekDto;
  topItems: WeeklyViewedItemDto[];
  /** 기관 조회 기록이 켜져 있다(BUYER_SUPPLIER_VIEW_TRACKING) */
  tracking: boolean;
}

export interface CmarketDirectoryResultDto {
  /** 저장한 회사 수 */
  upserted: number;
  /** 아이디·상호가 비어 건너뛴 회사 수 */
  invalid: number;
}

export interface CmarketCompanyDto {
  /** 씨마켓 회원 아이디(member_id) — 동의 뒤 세모 suppliers.supplier_id 와 같다 */
  memberId: string;
  /** 상호 */
  companyName: string;
  /**
   * 시·도
   * @nullable
   */
  province?: string | null;
  /**
   * 시·군·구
   * @nullable
   */
  city?: string | null;
  /**
   * 업태
   * @nullable
   */
  businessType?: string | null;
  /**
   * 종목
   * @nullable
   */
  businessItem?: string | null;
  /**
   * 취급 품목(자유 문장)
   * @nullable
   */
  productDescription?: string | null;
  /** 면허 이름 목록 */
  licenses?: string[];
  /** 인증 이름 목록 */
  certifications?: string[];
  /** 씨마켓 관심 분류 이름 목록 */
  interestCategories?: string[];
  /** 세모 약관 + 개인정보 제3자 제공 둘 다 동의 */
  semoConsented: boolean;
  /** 씨마켓 활성(승인·미탈퇴) */
  active: boolean;
}

export interface CmarketDirectoryBatchDto {
  /** 씨마켓 집계 시각(ISO) */
  asOf: string;
  /** 회사 목록(최대 500곳) */
  companies: CmarketCompanyDto[];
}

export interface CmarketAwardReceivedDto {
  /** 세모 낙찰 사본 id */
  awardId: string;
}

export interface CmarketAwardInspectionContactDto {
  /**
   * 검수 담당 이름(개인정보 — 링크 문자에만 쓴다)
   * @nullable
   */
  name?: string | null;
  /**
   * 검수 담당 전화번호(개인정보 — 검수 링크를 받는 번호). 숫자만 남긴다
   * @nullable
   */
  phone?: string | null;
}

/**
 * 품명(비면 «N번 품목», 500자 넘으면 자른다)
 */
export type CmarketAwardLineDtoName = { [key: string]: unknown };

export interface CmarketAwardLineDto {
  /** 공고 줄 순번(1부터) */
  lineNo: number;
  /** 품명(비면 «N번 품목», 500자 넘으면 자른다) */
  name: CmarketAwardLineDtoName;
  /**
   * 규격
   * @nullable
   */
  spec?: string | null;
  /**
   * 단위
   * @nullable
   */
  unit?: string | null;
  /** 계약 수량. 씨마켓은 수량이 비면 0 을 보낸다 — 0 인 줄은 받고 송장·검수 줄에서는 뺀다 */
  quantity: number;
  /**
   * 단가 — 총액 응찰 공고는 null
   * @nullable
   */
  unitPrice?: number | null;
  /**
   * 씨마켓 공고 줄에 붙은 세모 물품 id(semo_item_id) 그대로 — uuid 가 아니면 비운다
   * @nullable
   */
  semoItemId?: string | null;
  /**
   * 연결 출처(auto·suggest·manual·admin)
   * @nullable
   */
  semoMatchSource?: string | null;
}

/**
 * 기관 그룹 코드(cate_set). 씨마켓은 숫자로 보낸다(없으면 null) — 글자로 바꿔 받는다
 * @nullable
 */
export type CmarketAwardRequestDtoGroupCode = { [key: string]: unknown } | null;

/**
 * 기관 이름(비면 «발주기관»)
 * @nullable
 */
export type CmarketAwardRequestDtoBuyerOrgName = {
  [key: string]: unknown;
} | null;

/**
 * 공급사 사업자번호
 * @nullable
 */
export type CmarketAwardRequestDtoSupplierBizNo = {
  [key: string]: unknown;
} | null;

/**
 * 공급사 상호(비면 «공급사»)
 * @nullable
 */
export type CmarketAwardRequestDtoSupplierName = {
  [key: string]: unknown;
} | null;

/**
 * 공고 종류 — 씨마켓 낙찰 사본은 물품만 PRODUCT 로 보낸다(gjy_ok A 도 받는다). 검수는 물품만
 */
export type CmarketAwardRequestDtoCategoryType = { [key: string]: unknown };

/**
 * 계약(낙찰 확정) 시각 ISO8601(UTC). 씨마켓에 값이 없으면 null — 받은 시각으로 둔다
 * @nullable
 */
export type CmarketAwardRequestDtoContractedAt = {
  [key: string]: unknown;
} | null;

export type CmarketAwardRequestDtoStatus =
  (typeof CmarketAwardRequestDtoStatus)[keyof typeof CmarketAwardRequestDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketAwardRequestDtoStatus = {
  CONTRACTED: "CONTRACTED",
  CANCELLED: "CANCELLED",
} as const;

export interface CmarketAwardRequestDto {
  /** 씨마켓 공고 번호 */
  cmarketBidNo: string;
  /** 낙찰 순번(1부터) — 씨마켓 낙찰 사본은 winnerSeq 로 보낸다 */
  winnerSeq: number;
  /**
   * 기관 ERP 구매(발주) 번호
   * @nullable
   */
  purchaseNo?: string | null;
  /**
   * 기관 그룹 코드(cate_set). 씨마켓은 숫자로 보낸다(없으면 null) — 글자로 바꿔 받는다
   * @nullable
   */
  groupCode?: CmarketAwardRequestDtoGroupCode;
  /**
   * 기관 이름(비면 «발주기관»)
   * @nullable
   */
  buyerOrgName?: CmarketAwardRequestDtoBuyerOrgName;
  /** 기관 담당 씨마켓 회원 id */
  buyerMemberId: string;
  /**
   * 기관 부서
   * @nullable
   */
  buyerDept?: string | null;
  /** 공급사 씨마켓 회원 id(낙찰 응찰의 join_id = b2b_member.member_id) — /external/suppliers/auth 의 supplierId 와 같은 값 */
  supplierMemberId: string;
  /**
   * 공급사 사업자번호
   * @nullable
   */
  supplierBizNo?: CmarketAwardRequestDtoSupplierBizNo;
  /**
   * 공급사 상호(비면 «공급사»)
   * @nullable
   */
  supplierName?: CmarketAwardRequestDtoSupplierName;
  /** 공고 종류 — 씨마켓 낙찰 사본은 물품만 PRODUCT 로 보낸다(gjy_ok A 도 받는다). 검수는 물품만 */
  categoryType: CmarketAwardRequestDtoCategoryType;
  /**
   * 계약(낙찰 확정) 시각 ISO8601(UTC). 씨마켓에 값이 없으면 null — 받은 시각으로 둔다
   * @nullable
   */
  contractedAt?: CmarketAwardRequestDtoContractedAt;
  /**
   * 납품 기한(YYYY-MM-DD). 모양이 다르면 비운다
   * @nullable
   */
  deliveryDueDate?: string | null;
  /**
   * 납품 장소
   * @nullable
   */
  deliveryPlace?: string | null;
  inspectionContact?: CmarketAwardInspectionContactDto;
  status: CmarketAwardRequestDtoStatus;
  lines: CmarketAwardLineDto[];
}

export interface CmarketAwardTargetLineDto {
  lineNo: number;
  /** 송장 줄 식별자(줄 순번 문자열) */
  lineKey: string;
  name: string;
  /** @nullable */
  spec?: string | null;
  /** @nullable */
  unit?: string | null;
  /** 계약 수량 */
  quantity: number;
  /** 보낸 수량(취소·반송 제외) */
  shipped: number;
  /** 남은 수량 */
  remaining: number;
}

export interface CmarketAwardShipmentRecordLineDto {
  lineKey: string;
  name: string;
  quantity: number;
  /** @nullable */
  unit?: string | null;
}

export interface CmarketAwardShipmentRecordDto {
  shipmentId: string;
  /** 이 낙찰 건 안의 차수(1부터) */
  shipmentNo: number;
  /** @nullable */
  courierCode?: string | null;
  /** @nullable */
  courierName?: string | null;
  /** 송장번호 전부(상자마다). 직접 납품·번호 없이 보냈으면 빈 배열 */
  trackingNos: string[];
  /** 그 가운데 배송 완료된 송장 수 */
  deliveredParcels: number;
  /** 발송 상태 — 모든 송장이 도착해야 DELIVERED */
  deliveryStatus: string;
  acceptanceStatus: string;
  /** @nullable */
  shippedAt?: string | null;
  /** @nullable */
  deliveredAt?: string | null;
  lines: CmarketAwardShipmentRecordLineDto[];
}

export type CmarketAwardTargetDtoStatus =
  (typeof CmarketAwardTargetDtoStatus)[keyof typeof CmarketAwardTargetDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketAwardTargetDtoStatus = {
  CONTRACTED: "CONTRACTED",
  CANCELLED: "CANCELLED",
} as const;

export interface CmarketAwardTargetDto {
  awardId: string;
  cmarketBidNo: string;
  winnerSeq: number;
  /** 화면 번호(공고 번호, 순번 2 이상이면 «-순번») */
  displayNo: string;
  buyerOrgName: string;
  /** @nullable */
  buyerDept?: string | null;
  contractedAt: string;
  /** @nullable */
  deliveryDueDate?: string | null;
  /** @nullable */
  deliveryPlace?: string | null;
  status: CmarketAwardTargetDtoStatus;
  lines: CmarketAwardTargetLineDto[];
  remainingTotal: number;
  fullyShipped: boolean;
  /** 보낸 기록(차수 순, 등록 취소 제외) — 나눠 보내도 발주기관 검수는 모두 도착한 뒤 한 번 요청된다 */
  shipments: CmarketAwardShipmentRecordDto[];
}

export interface CmarketAwardShipmentResultDto {
  shipmentId: string;
  /** 이 낙찰 건 안의 차수(1부터) */
  shipmentNo: number;
  deliveryStatus: string;
  /** @nullable */
  courierName?: string | null;
  /** @nullable */
  trackingNo?: string | null;
  /** 이 발송의 송장번호 전부 */
  trackingNos: string[];
  /** 같은 멱등키로 이미 만든 송장을 돌려준 것인가 */
  replayed: boolean;
}

export interface CmarketAwardShipmentLineDto {
  /** 낙찰 줄 순번(문자열) */
  lineKey: string;
  /** 이 송장에 실은 수량 */
  quantity: number;
}

export type RegisterCmarketAwardShipmentDtoStatus =
  (typeof RegisterCmarketAwardShipmentDtoStatus)[keyof typeof RegisterCmarketAwardShipmentDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterCmarketAwardShipmentDtoStatus = {
  READY: "READY",
  SHIPPED: "SHIPPED",
} as const;

export interface RegisterCmarketAwardShipmentDto {
  /** 택배사 코드(`GET /shipping/couriers`). 직접 배송이면 `DIRECT` — 도착은 등록한 뒤 «전달 완료 알리기»로 남긴다. */
  courierCode?: string;
  /** 송장번호 */
  trackingNo?: string;
  /** 송장번호 여러 개(상자마다, 최대 30개). trackingNo 와 합치고 같은 번호는 한 번만 — 하나만 넣어도 된다 */
  trackingNos?: string[];
  status?: RegisterCmarketAwardShipmentDtoStatus;
  /** 메모(분할 납품 사유 등) */
  note?: string;
  /** 비우면 남은 수량 전부를 한 송장으로 */
  items?: CmarketAwardShipmentLineDto[];
  /** 같은 요청 두 번(더블 클릭·재시도)에도 송장은 한 장 */
  idempotencyKey?: string;
}

export type UploadInspectionPhotoDtoKind =
  (typeof UploadInspectionPhotoDtoKind)[keyof typeof UploadInspectionPhotoDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UploadInspectionPhotoDtoKind = {
  OVERALL: "OVERALL",
  LABEL: "LABEL",
} as const;

export interface UploadInspectionPhotoDto {
  kind: UploadInspectionPhotoDtoKind;
  /** 라벨 사진이면 줄 순번 */
  lineNo?: number;
}

/**
 * 사람이 정한 판정(맞음 · 다름 · 안 봄)
 */
export type EditInspectionLineDtoVerdict =
  (typeof EditInspectionLineDtoVerdict)[keyof typeof EditInspectionLineDtoVerdict];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EditInspectionLineDtoVerdict = {
  MATCH: "MATCH",
  MISMATCH: "MISMATCH",
  NOT_CHECKED: "NOT_CHECKED",
} as const;

export interface EditInspectionLineDto {
  /** 받은 수량(계약 수량으로 채워 두고 다르면 고친다) */
  receivedQuantity?: number;
  /** 사람이 정한 판정(맞음 · 다름 · 안 봄) */
  verdict?: EditInspectionLineDtoVerdict;
  /**
   * «다름» 사유
   * @nullable
   */
  mismatchReason?: string | null;
  /**
   * 휴대폰에서 읽은 바코드 원문(빈 값이면 지움)
   * @nullable
   */
  barcodeRaw?: string | null;
  /**
   * 바코드 종류(ean_13 · code_128 · data_matrix …)
   * @nullable
   */
  barcodeSymbology?: string | null;
}

export type SubmitInspectionDtoOverall =
  (typeof SubmitInspectionDtoOverall)[keyof typeof SubmitInspectionDtoOverall];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubmitInspectionDtoOverall = {
  PASS: "PASS",
  CONDITIONAL: "CONDITIONAL",
  FAIL: "FAIL",
} as const;

export interface SubmitInspectionDto {
  /** 받는 번호로 온 6자리 확인번호 */
  code: string;
  /** 확인자 이름(검수조서에 찍힌다) */
  confirmerName: string;
  overall: SubmitInspectionDtoOverall;
  /** 검수 의견 */
  opinion?: string;
}

export interface InspectionLinkResponseDto {
  /** 검수 화면 주소(새 창으로 연다 — 씨마켓 임베드 창은 카메라 허용이 없다) */
  url: string;
  /** 링크 만료(보낸 뒤면 읽기 전용 끝) 시각 */
  expiresAt: string;
}

export interface AdminRehearsalDto {
  /** 씨마켓 공고 번호 */
  cmarketBidNo: string;
  winnerSeq: number;
}

export interface AdminCancelInspectionDto {
  reason: string;
}

export interface AdminRecipientDto {
  /** 받는 휴대폰 번호(숫자만 남긴다) */
  phone: string;
}

/**
 * 인증 컨텍스트
 */
export type NiceInitResponseDtoContext =
  (typeof NiceInitResponseDtoContext)[keyof typeof NiceInitResponseDtoContext];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NiceInitResponseDtoContext = {
  signup: "signup",
  reauthentication: "reauthentication",
} as const;

export interface NiceInitResponseDto {
  /** 토큰 버전 ID */
  tokenVersionId: string;
  /** 암호화된 데이터 */
  encData: string;
  /** 무결성 검증값 */
  integrityValue: string;
  /** 요청 번호 */
  requestNo?: string;
  /** 인증 컨텍스트 */
  context: NiceInitResponseDtoContext;
}

/**
 * 인증 컨텍스트
 */
export type NiceInitRequestDtoContext =
  (typeof NiceInitRequestDtoContext)[keyof typeof NiceInitRequestDtoContext];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NiceInitRequestDtoContext = {
  signup: "signup",
  reauthentication: "reauthentication",
} as const;

export interface NiceInitRequestDto {
  /** 인증 컨텍스트 */
  context: NiceInitRequestDtoContext;
}

/**
 * 성별
 */
export type NicePersonalDataDtoGender =
  (typeof NicePersonalDataDtoGender)[keyof typeof NicePersonalDataDtoGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NicePersonalDataDtoGender = {
  M: "M",
  F: "F",
} as const;

export interface NicePersonalDataDto {
  /** 성명 */
  name: string;
  /** 휴대폰 번호 (하이픈 제거) */
  phone: string;
  /** 생년월일 (YYYYMMDD) */
  birthDate: string;
  /** 성별 */
  gender: NicePersonalDataDtoGender;
}

/**
 * 인증 컨텍스트
 */
export type NiceCallbackResponseDtoContext =
  (typeof NiceCallbackResponseDtoContext)[keyof typeof NiceCallbackResponseDtoContext];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NiceCallbackResponseDtoContext = {
  signup: "signup",
  reauthentication: "reauthentication",
} as const;

export interface NiceCallbackResponseDto {
  /** 요청 번호 */
  requestNo: string;
  /** CI 해시 */
  ciHash: string;
  /** DI 해시 */
  diHash: string;
  /** 인증 완료 여부 */
  isCompleted: boolean;
  /**
   * 인증 완료 시각
   * @nullable
   */
  verifiedAt: string | null;
  /** 개인정보 */
  personalData?: NicePersonalDataDto;
  /** 메시지 */
  message?: string;
  /** 인증 컨텍스트 */
  context: NiceCallbackResponseDtoContext;
}

/**
 * 인증 컨텍스트
 */
export type NiceCallbackRequestDtoContext =
  (typeof NiceCallbackRequestDtoContext)[keyof typeof NiceCallbackRequestDtoContext];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NiceCallbackRequestDtoContext = {
  signup: "signup",
  reauthentication: "reauthentication",
} as const;

export interface NiceCallbackRequestDto {
  /** 암호화된 응답 데이터 */
  encData: string;
  /** 무결성 검증값 */
  integrityValue: string;
  /** 인증 컨텍스트 */
  context: NiceCallbackRequestDtoContext;
  /** 토큰 버전 ID */
  tokenVersionId?: string;
}

export interface SendDigestNowResultDto {
  /** 벨 알림 한 건씩 받은 사람 수 */
  sent: number;
  /** 보내기 실패로 되돌린 사람 수 */
  failed: number;
  /** 집은 사람 × 종류 줄 수 */
  claimedRows: number;
  /** ENGAGEMENT_DIGEST=off 로 꺼져 있었다 */
  disabled: boolean;
}

export type ChatControllerGetRoomsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: ChatControllerGetRoomsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 읽음 상태 필터
   */
  readStatus?: ChatControllerGetRoomsReadStatus;
  /**
   * 계약 여부 필터 — quoted: 계약 전(견적 참여), contracted: 계약 완료
   */
  contractStatus?: ChatControllerGetRoomsContractStatus;
};

export type ChatControllerGetRoomsSortOrder =
  (typeof ChatControllerGetRoomsSortOrder)[keyof typeof ChatControllerGetRoomsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatControllerGetRoomsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ChatControllerGetRoomsReadStatus =
  (typeof ChatControllerGetRoomsReadStatus)[keyof typeof ChatControllerGetRoomsReadStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatControllerGetRoomsReadStatus = {
  all: "all",
  read: "read",
  unread: "unread",
} as const;

export type ChatControllerGetRoomsContractStatus =
  (typeof ChatControllerGetRoomsContractStatus)[keyof typeof ChatControllerGetRoomsContractStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatControllerGetRoomsContractStatus = {
  all: "all",
  quoted: "quoted",
  contracted: "contracted",
} as const;

export type ChatControllerGetRooms200AllOfData = {
  items: ChatRoomResponseDto[];
  meta: PaginationMetaDto;
};

export type ChatControllerGetRooms200AllOf = {
  data?: ChatControllerGetRooms200AllOfData;
};

export type ChatControllerGetRooms200 = BaseResponseDto &
  ChatControllerGetRooms200AllOf;

export type ChatControllerGetRoom200AllOf = {
  data?: ChatRoomResponseDto;
};

export type ChatControllerGetRoom200 = BaseResponseDto &
  ChatControllerGetRoom200AllOf;

export type ChatControllerGetMessagesParams = {
  /**
   * 페이지네이션 커서 (메시지 ID)
   */
  before?: string;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
};

export type ChatControllerGetMessages200AllOf = {
  data?: ChatMessagesResponseDto;
};

export type ChatControllerGetMessages200 = BaseResponseDto &
  ChatControllerGetMessages200AllOf;

export type ChatControllerSendMessage200AllOf = {
  data?: BaseChatMessageResponseDto;
};

export type ChatControllerSendMessage200 = BaseResponseDto &
  ChatControllerSendMessage200AllOf;

export type ChatControllerRequestContractDocuments200AllOf = {
  data?: GeneratedContractDocumentDto[];
};

export type ChatControllerRequestContractDocuments200 = BaseResponseDto &
  ChatControllerRequestContractDocuments200AllOf;

export type ChatControllerSubmitContractDocumentInput200AllOf = {
  data?: ContractDocumentItemDto;
};

export type ChatControllerSubmitContractDocumentInput200 = BaseResponseDto &
  ChatControllerSubmitContractDocumentInput200AllOf;

export type ChatControllerSubmitContractDocumentBuyerConfirmation200AllOf = {
  data?: ContractDocumentItemDto;
};

export type ChatControllerSubmitContractDocumentBuyerConfirmation200 =
  BaseResponseDto &
    ChatControllerSubmitContractDocumentBuyerConfirmation200AllOf;

export type ChatControllerUploadContractDocumentFileBody = {
  file?: Blob;
};

export type ChatControllerUploadContractDocumentFile200AllOf = {
  data?: ContractDocumentItemDto;
};

export type ChatControllerUploadContractDocumentFile200 = BaseResponseDto &
  ChatControllerUploadContractDocumentFile200AllOf;

export type ChatControllerUploadFileBody = {
  file?: Blob;
};

export type ChatControllerUploadFile200AllOf = {
  data?: AttachmentMessageResponseDto;
};

export type ChatControllerUploadFile200 = BaseResponseDto &
  ChatControllerUploadFile200AllOf;

export type ChatControllerSubmitQuoteRevision200AllOf = {
  data?: QuoteMessageResponseDto;
};

export type ChatControllerSubmitQuoteRevision200 = BaseResponseDto &
  ChatControllerSubmitQuoteRevision200AllOf;

export type QuoteResponsesControllerCreate201AllOf = {
  data?: QuoteResponseFlowResultDto;
};

export type QuoteResponsesControllerCreate201 = BaseResponseDto &
  QuoteResponsesControllerCreate201AllOf;

export type QuoteResponsesControllerFindOne200AllOf = {
  data?: QuoteResponseResponseDto;
};

export type QuoteResponsesControllerFindOne200 = BaseResponseDto &
  QuoteResponsesControllerFindOne200AllOf;

export type QuoteResponsesControllerDownloadPdf200AllOf = {
  data?: PdfUrlResponseDto;
};

export type QuoteResponsesControllerDownloadPdf200 = BaseResponseDto &
  QuoteResponsesControllerDownloadPdf200AllOf;

export type QuoteResponsesControllerUploadAttachmentsBody = {
  files?: Blob[];
};

export type QuoteResponsesControllerUploadAttachments201AllOf = {
  data?: AttachmentMetadataDto[];
};

export type QuoteResponsesControllerUploadAttachments201 = BaseResponseDto &
  QuoteResponsesControllerUploadAttachments201AllOf;

export type PdfControllerGenerateQuotePdf201AllOf = {
  data?: PdfGenerationResponseDto;
};

export type PdfControllerGenerateQuotePdf201 = BaseResponseDto &
  PdfControllerGenerateQuotePdf201AllOf;

export type PdfControllerGenerateContractPdf201AllOf = {
  data?: PdfGenerationResponseDto;
};

export type PdfControllerGenerateContractPdf201 = BaseResponseDto &
  PdfControllerGenerateContractPdf201AllOf;

export type AuthSessionControllerGetSystemConfig200AllOf = {
  data?: SystemConfigResponseDto;
};

export type AuthSessionControllerGetSystemConfig200 = BaseResponseDto &
  AuthSessionControllerGetSystemConfig200AllOf;

export type AuthSessionControllerLogin201AllOf = {
  data?: LoginResponseDto;
};

export type AuthSessionControllerLogin201 = BaseResponseDto &
  AuthSessionControllerLogin201AllOf;

export type AuthSessionControllerSignup201AllOf = {
  data?: SignupResponseDto;
};

export type AuthSessionControllerSignup201 = BaseResponseDto &
  AuthSessionControllerSignup201AllOf;

export type AuthSessionControllerRefresh201AllOf = {
  data?: RefreshResponseDto;
};

export type AuthSessionControllerRefresh201 = BaseResponseDto &
  AuthSessionControllerRefresh201AllOf;

export type AuthSessionControllerLogout201AllOf = {
  data?: LogoutResponseDto;
};

export type AuthSessionControllerLogout201 = BaseResponseDto &
  AuthSessionControllerLogout201AllOf;

export type AuthSessionControllerGetCurrentUser200AllOf = {
  data?: UserInfoDto;
};

export type AuthSessionControllerGetCurrentUser200 = BaseResponseDto &
  AuthSessionControllerGetCurrentUser200AllOf;

export type AuthSessionControllerGetLatestTerms200AllOf = {
  data?: TermsDefinitionResponseDto[];
};

export type AuthSessionControllerGetLatestTerms200 = BaseResponseDto &
  AuthSessionControllerGetLatestTerms200AllOf;

export type AuthPasswordControllerChangePassword200AllOfData = {
  [key: string]: unknown;
};

export type AuthPasswordControllerChangePassword200AllOf = {
  data?: AuthPasswordControllerChangePassword200AllOfData;
};

export type AuthPasswordControllerChangePassword200 = BaseResponseDto &
  AuthPasswordControllerChangePassword200AllOf;

export type AuthPasswordControllerVerifyCiHash200AllOf = {
  data?: VerifyCiHashApiResponse;
};

export type AuthPasswordControllerVerifyCiHash200 = BaseResponseDto &
  AuthPasswordControllerVerifyCiHash200AllOf;

export type AuthPasswordControllerConfirmPasswordReset200AllOf = {
  data?: ConfirmPasswordResetApiResponse;
};

export type AuthPasswordControllerConfirmPasswordReset200 = BaseResponseDto &
  AuthPasswordControllerConfirmPasswordReset200AllOf;

export type AuthIdentityControllerFindUserId200AllOf = {
  data?: FindUserIdResponseDto;
};

export type AuthIdentityControllerFindUserId200 = BaseResponseDto &
  AuthIdentityControllerFindUserId200AllOf;

export type AuthIdentityControllerCheckUserIdAvailability200AllOf = {
  data?: CheckUserIdAvailabilityResponseDto;
};

export type AuthIdentityControllerCheckUserIdAvailability200 = BaseResponseDto &
  AuthIdentityControllerCheckUserIdAvailability200AllOf;

export type BuyerProfileControllerUpdateMyProfile200AllOf = {
  data?: UserResponseDto;
};

export type BuyerProfileControllerUpdateMyProfile200 = BaseResponseDto &
  BuyerProfileControllerUpdateMyProfile200AllOf;

export type BuyerProfileControllerUploadProfileImageBody = {
  /** 프로필 이미지 파일 (JPEG, PNG, GIF, WebP - 최대 5MB) */
  file: Blob;
};

export type BuyerProfileControllerUploadProfileImage201AllOf = {
  data?: ProfileImageUploadResponseDto;
};

export type BuyerProfileControllerUploadProfileImage201 = BaseResponseDto &
  BuyerProfileControllerUploadProfileImage201AllOf;

export type BuyerProfileControllerGetVerificationDate200AllOf = {
  data?: VerificationDateResponseDto;
};

export type BuyerProfileControllerGetVerificationDate200 = BaseResponseDto &
  BuyerProfileControllerGetVerificationDate200AllOf;

export type BuyerAddressControllerGetMyAddresses200AllOf = {
  data?: AddressResponseDto[];
};

export type BuyerAddressControllerGetMyAddresses200 = BaseResponseDto &
  BuyerAddressControllerGetMyAddresses200AllOf;

export type BuyerAddressControllerUpsertAddress201AllOf = {
  data?: AddressResponseDto;
};

export type BuyerAddressControllerUpsertAddress201 = BaseResponseDto &
  BuyerAddressControllerUpsertAddress201AllOf;

export type UserSettingsControllerSendEmailVerificationCode200AllOf = {
  data?: SendVerificationCodeResponseDto;
};

export type UserSettingsControllerSendEmailVerificationCode200 =
  BaseResponseDto & UserSettingsControllerSendEmailVerificationCode200AllOf;

export type UserSettingsControllerVerifyEmailCode200AllOf = {
  data?: EmailVerificationResponseDto;
};

export type UserSettingsControllerVerifyEmailCode200 = BaseResponseDto &
  UserSettingsControllerVerifyEmailCode200AllOf;

export type UserSettingsControllerGetNotificationSettings200AllOf = {
  data?: NotificationSettingsResponseDto;
};

export type UserSettingsControllerGetNotificationSettings200 = BaseResponseDto &
  UserSettingsControllerGetNotificationSettings200AllOf;

export type UserSettingsControllerUpdateNotificationSettings200AllOf = {
  data?: NotificationSettingsResponseDto;
};

export type UserSettingsControllerUpdateNotificationSettings200 =
  BaseResponseDto & UserSettingsControllerUpdateNotificationSettings200AllOf;

export type UserSettingsControllerGetMarketingConsent200AllOf = {
  data?: MarketingConsentResponseDto;
};

export type UserSettingsControllerGetMarketingConsent200 = BaseResponseDto &
  UserSettingsControllerGetMarketingConsent200AllOf;

export type UserSettingsControllerUpdateMarketingConsent200AllOf = {
  data?: MarketingConsentResponseDto;
};

export type UserSettingsControllerUpdateMarketingConsent200 = BaseResponseDto &
  UserSettingsControllerUpdateMarketingConsent200AllOf;

export type UserSettingsControllerToggleAutoQuote200AllOf = {
  data?: UserResponseDto;
};

export type UserSettingsControllerToggleAutoQuote200 = BaseResponseDto &
  UserSettingsControllerToggleAutoQuote200AllOf;

export type SupplierProfileControllerGetMyProfile200AllOf = {
  data?: MySupplierProfileDto;
};

export type SupplierProfileControllerGetMyProfile200 = BaseResponseDto &
  SupplierProfileControllerGetMyProfile200AllOf;

export type SupplierProfileControllerUpdateMyProfile200AllOf = {
  data?: MySupplierProfileDto;
};

export type SupplierProfileControllerUpdateMyProfile200 = BaseResponseDto &
  SupplierProfileControllerUpdateMyProfile200AllOf;

export type SupplierProfileControllerUploadLogoBody = {
  /** 로고 이미지 (JPEG, PNG, GIF, WebP — 최대 5MB) */
  file: Blob;
};

export type SupplierProfileControllerUploadLogo200AllOf = {
  data?: SupplierLogoUploadResponseDto;
};

export type SupplierProfileControllerUploadLogo200 = BaseResponseDto &
  SupplierProfileControllerUploadLogo200AllOf;

export type SupplierProfileControllerAddCertificationBody = {
  /** 인증서 명칭 */
  name: string;
  /** 발급 기관 */
  issuer?: string;
  /** 인증 번호 */
  certNumber?: string;
  /** 발급일 (YYYY-MM-DD) */
  issuedAt?: string;
  /** 만료일 (YYYY-MM-DD) */
  expiresAt?: string;
  /** 인증서 파일 (PDF 또는 이미지 — 최대 20MB) */
  file?: Blob;
};

export type SupplierProfileControllerAddCertification200AllOf = {
  data?: SupplierCertificationDto;
};

export type SupplierProfileControllerAddCertification200 = BaseResponseDto &
  SupplierProfileControllerAddCertification200AllOf;

export type SupplierProfileControllerDeleteCertification200AllOfData = {
  [key: string]: unknown;
};

export type SupplierProfileControllerDeleteCertification200AllOf = {
  data?: SupplierProfileControllerDeleteCertification200AllOfData;
};

export type SupplierProfileControllerDeleteCertification200 = BaseResponseDto &
  SupplierProfileControllerDeleteCertification200AllOf;

export type SupplierProfileControllerGetPublicProfileParams = {
  /**
   * 채팅방 문맥 — 있으면 그 방의 계약 여부로 공개를 판정
   */
  chatRoomId?: string;
};

export type SupplierProfileControllerGetPublicProfile200AllOf = {
  data?: SupplierPublicProfileDto;
};

export type SupplierProfileControllerGetPublicProfile200 = BaseResponseDto &
  SupplierProfileControllerGetPublicProfile200AllOf;

export type AdminSupplierCertificationsControllerListCertifications200AllOf = {
  data?: SupplierCertificationDto;
};

export type AdminSupplierCertificationsControllerListCertifications200 =
  BaseResponseDto &
    AdminSupplierCertificationsControllerListCertifications200AllOf;

export type AdminSupplierCertificationsControllerVerifyCertification200AllOf = {
  data?: SupplierCertificationDto;
};

export type AdminSupplierCertificationsControllerVerifyCertification200 =
  BaseResponseDto &
    AdminSupplierCertificationsControllerVerifyCertification200AllOf;

export type ContractsControllerGetMyContractsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: ContractsControllerGetMyContractsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  statuses?: ContractsControllerGetMyContractsStatusesItem[];
};

export type ContractsControllerGetMyContractsSortOrder =
  (typeof ContractsControllerGetMyContractsSortOrder)[keyof typeof ContractsControllerGetMyContractsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractsControllerGetMyContractsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ContractsControllerGetMyContractsStatusesItem =
  (typeof ContractsControllerGetMyContractsStatusesItem)[keyof typeof ContractsControllerGetMyContractsStatusesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractsControllerGetMyContractsStatusesItem = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
} as const;

export type ContractsControllerGetMyContracts200AllOfData = {
  items: ContractListResponseDto[];
  meta: PaginationMetaDto;
};

export type ContractsControllerGetMyContracts200AllOf = {
  data?: ContractsControllerGetMyContracts200AllOfData;
};

export type ContractsControllerGetMyContracts200 = BaseResponseDto &
  ContractsControllerGetMyContracts200AllOf;

export type ContractsControllerDownloadPdf200AllOf = {
  data?: PdfUrlResponseDto;
};

export type ContractsControllerDownloadPdf200 = BaseResponseDto &
  ContractsControllerDownloadPdf200AllOf;

export type ContractsControllerDownloadCancellationPdf200AllOf = {
  data?: PdfUrlResponseDto;
};

export type ContractsControllerDownloadCancellationPdf200 = BaseResponseDto &
  ContractsControllerDownloadCancellationPdf200AllOf;

export type ContractsControllerCreateContract201AllOf = {
  data?: ContractResponseDto;
};

export type ContractsControllerCreateContract201 = BaseResponseDto &
  ContractsControllerCreateContract201AllOf;

export type ContractsControllerGetCardPaymentStatus200AllOf = {
  data?: ContractCardPaymentStatusResponseDto;
};

export type ContractsControllerGetCardPaymentStatus200 = BaseResponseDto &
  ContractsControllerGetCardPaymentStatus200AllOf;

export type ContractsControllerListShipments200AllOf = {
  data?: ContractShipmentListDto;
};

export type ContractsControllerListShipments200 = BaseResponseDto &
  ContractsControllerListShipments200AllOf;

export type ContractsControllerReceiveShipment200AllOf = {
  data?: ContractShipmentDto;
};

export type ContractsControllerReceiveShipment200 = BaseResponseDto &
  ContractsControllerReceiveShipment200AllOf;

export type ContractsControllerSyncShipment200AllOf = {
  data?: ContractShipmentDto;
};

export type ContractsControllerSyncShipment200 = BaseResponseDto &
  ContractsControllerSyncShipment200AllOf;

export type ContractsControllerGetContract200AllOf = {
  data?: ContractResponseDto;
};

export type ContractsControllerGetContract200 = BaseResponseDto &
  ContractsControllerGetContract200AllOf;

export type ContractsControllerCancelContract204AllOfData = {
  [key: string]: unknown;
};

export type ContractsControllerCancelContract204AllOf = {
  data?: ContractsControllerCancelContract204AllOfData;
};

export type ContractsControllerCancelContract204 = BaseResponseDto &
  ContractsControllerCancelContract204AllOf;

export type ContractsControllerCompleteContract200AllOfData = {
  [key: string]: unknown;
};

export type ContractsControllerCompleteContract200AllOf = {
  data?: ContractsControllerCompleteContract200AllOfData;
};

export type ContractsControllerCompleteContract200 = BaseResponseDto &
  ContractsControllerCompleteContract200AllOf;

export type ContractsControllerRequestCancellation200AllOfData = {
  [key: string]: unknown;
};

export type ContractsControllerRequestCancellation200AllOf = {
  data?: ContractsControllerRequestCancellation200AllOfData;
};

export type ContractsControllerRequestCancellation200 = BaseResponseDto &
  ContractsControllerRequestCancellation200AllOf;

export type ContractsControllerConfirmCancellation200AllOfData = {
  [key: string]: unknown;
};

export type ContractsControllerConfirmCancellation200AllOf = {
  data?: ContractsControllerConfirmCancellation200AllOfData;
};

export type ContractsControllerConfirmCancellation200 = BaseResponseDto &
  ContractsControllerConfirmCancellation200AllOf;

export type ContractsControllerRejectCancellationBody = {
  rejectionReason: string;
};

export type ContractsControllerRejectCancellation200AllOfData = {
  [key: string]: unknown;
};

export type ContractsControllerRejectCancellation200AllOf = {
  data?: ContractsControllerRejectCancellation200AllOfData;
};

export type ContractsControllerRejectCancellation200 = BaseResponseDto &
  ContractsControllerRejectCancellation200AllOf;

export type QuoteRequestsControllerCreate201AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type QuoteRequestsControllerCreate201 = BaseResponseDto &
  QuoteRequestsControllerCreate201AllOf;

export type QuoteRequestsControllerFindMyQuotesParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: QuoteRequestsControllerFindMyQuotesSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 상태 필터
   */
  statuses?: QuoteRequestsControllerFindMyQuotesStatusesItem[];
};

export type QuoteRequestsControllerFindMyQuotesSortOrder =
  (typeof QuoteRequestsControllerFindMyQuotesSortOrder)[keyof typeof QuoteRequestsControllerFindMyQuotesSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestsControllerFindMyQuotesSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type QuoteRequestsControllerFindMyQuotesStatusesItem =
  (typeof QuoteRequestsControllerFindMyQuotesStatusesItem)[keyof typeof QuoteRequestsControllerFindMyQuotesStatusesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestsControllerFindMyQuotesStatusesItem = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

export type QuoteRequestsControllerFindMyQuotes200AllOfData = {
  items: QuoteRequestListItemDto[];
  meta: PaginationMetaDto;
};

export type QuoteRequestsControllerFindMyQuotes200AllOf = {
  data?: QuoteRequestsControllerFindMyQuotes200AllOfData;
};

export type QuoteRequestsControllerFindMyQuotes200 = BaseResponseDto &
  QuoteRequestsControllerFindMyQuotes200AllOf;

export type QuoteRequestsControllerCheckAutoQuote200AllOf = {
  data?: CheckAutoQuoteResponseDto;
};

export type QuoteRequestsControllerCheckAutoQuote200 = BaseResponseDto &
  QuoteRequestsControllerCheckAutoQuote200AllOf;

export type QuoteRequestsControllerFindPublicParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: QuoteRequestsControllerFindPublicSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 상태 필터
   */
  statuses?: QuoteRequestsControllerFindPublicStatusesItem[];
};

export type QuoteRequestsControllerFindPublicSortOrder =
  (typeof QuoteRequestsControllerFindPublicSortOrder)[keyof typeof QuoteRequestsControllerFindPublicSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestsControllerFindPublicSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type QuoteRequestsControllerFindPublicStatusesItem =
  (typeof QuoteRequestsControllerFindPublicStatusesItem)[keyof typeof QuoteRequestsControllerFindPublicStatusesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestsControllerFindPublicStatusesItem = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

export type QuoteRequestsControllerFindPublic200AllOfData = {
  items: QuoteRequestListItemDto[];
  meta: PaginationMetaDto;
};

export type QuoteRequestsControllerFindPublic200AllOf = {
  data?: QuoteRequestsControllerFindPublic200AllOfData;
};

export type QuoteRequestsControllerFindPublic200 = BaseResponseDto &
  QuoteRequestsControllerFindPublic200AllOf;

export type QuoteRequestsControllerFindMyRecentItemsParams = {
  limit: string;
};

export type QuoteRequestsControllerFindMyRecentItems200AllOf = {
  data?: RecentItemDto[];
};

export type QuoteRequestsControllerFindMyRecentItems200 = BaseResponseDto &
  QuoteRequestsControllerFindMyRecentItems200AllOf;

export type QuoteRequestsControllerFindOne200AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type QuoteRequestsControllerFindOne200 = BaseResponseDto &
  QuoteRequestsControllerFindOne200AllOf;

export type QuoteRequestsControllerUpdate200AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type QuoteRequestsControllerUpdate200 = BaseResponseDto &
  QuoteRequestsControllerUpdate200AllOf;

export type QuoteRequestsControllerExtendDeadline200AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type QuoteRequestsControllerExtendDeadline200 = BaseResponseDto &
  QuoteRequestsControllerExtendDeadline200AllOf;

export type QuoteRequestsControllerCloseQuoteRequest200AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type QuoteRequestsControllerCloseQuoteRequest200 = BaseResponseDto &
  QuoteRequestsControllerCloseQuoteRequest200AllOf;

export type PublicQuoteRequestsControllerFindPublicParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: PublicQuoteRequestsControllerFindPublicSortOrder;
  /**
   * 검색어
   */
  search?: string;
};

export type PublicQuoteRequestsControllerFindPublicSortOrder =
  (typeof PublicQuoteRequestsControllerFindPublicSortOrder)[keyof typeof PublicQuoteRequestsControllerFindPublicSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublicQuoteRequestsControllerFindPublicSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type PublicQuoteRequestsControllerFindPublic200AllOfData = {
  items: QuoteRequestListItemDto[];
  meta: PaginationMetaDto;
};

export type PublicQuoteRequestsControllerFindPublic200AllOf = {
  data?: PublicQuoteRequestsControllerFindPublic200AllOfData;
};

export type PublicQuoteRequestsControllerFindPublic200 = BaseResponseDto &
  PublicQuoteRequestsControllerFindPublic200AllOf;

export type QuoteReactionsBuyerControllerGetView200AllOf = {
  data?: BuyerRequestReactionsDto;
};

export type QuoteReactionsBuyerControllerGetView200 = BaseResponseDto &
  QuoteReactionsBuyerControllerGetView200AllOf;

export type QuoteReactionsBuyerControllerMarkRead200AllOf = {
  data?: MarkReadResponseDto;
};

export type QuoteReactionsBuyerControllerMarkRead200 = BaseResponseDto &
  QuoteReactionsBuyerControllerMarkRead200AllOf;

export type QuoteReactionsBuyerControllerSetStar200AllOf = {
  data?: SetStarResponseDto;
};

export type QuoteReactionsBuyerControllerSetStar200 = BaseResponseDto &
  QuoteReactionsBuyerControllerSetStar200AllOf;

export type QuoteReactionsBuyerControllerSetFeedback200AllOf = {
  data?: FeedbackSettingDto;
};

export type QuoteReactionsBuyerControllerSetFeedback200 = BaseResponseDto &
  QuoteReactionsBuyerControllerSetFeedback200AllOf;

export type QuoteReactionsBuyerControllerGetDelivery200AllOf = {
  data?: DeliveryReactionDto;
};

export type QuoteReactionsBuyerControllerGetDelivery200 = BaseResponseDto &
  QuoteReactionsBuyerControllerGetDelivery200AllOf;

export type QuoteReactionsBuyerControllerAddDelivery200AllOf = {
  data?: DeliveryReactionDto;
};

export type QuoteReactionsBuyerControllerAddDelivery200 = BaseResponseDto &
  QuoteReactionsBuyerControllerAddDelivery200AllOf;

export type QuoteReactionsSupplierControllerTouch200AllOf = {
  data?: TouchPresenceResponseDto;
};

export type QuoteReactionsSupplierControllerTouch200 = BaseResponseDto &
  QuoteReactionsSupplierControllerTouch200AllOf;

export type QuoteReactionsSupplierControllerGetRequestView200AllOf = {
  data?: SupplierRequestReactionsDto;
};

export type QuoteReactionsSupplierControllerGetRequestView200 =
  BaseResponseDto & QuoteReactionsSupplierControllerGetRequestView200AllOf;

export type QuoteReactionsSupplierControllerGetSignalsParams = {
  /**
   * 견적 요청 id 들(쉼표로, 최대 200개)
   */
  ids: string[];
};

export type QuoteReactionsSupplierControllerGetSignals200AllOf = {
  data?: SupplierSignalDto[];
};

export type QuoteReactionsSupplierControllerGetSignals200 = BaseResponseDto &
  QuoteReactionsSupplierControllerGetSignals200AllOf;

export type QuoteReactionsSupplierControllerGetDeliveryBadges200AllOf = {
  data?: DeliveryBadgeDto[];
};

export type QuoteReactionsSupplierControllerGetDeliveryBadges200 =
  BaseResponseDto & QuoteReactionsSupplierControllerGetDeliveryBadges200AllOf;

export type AdminStorefrontsControllerListPointBalances200AllOf = {
  data?: AdminPointBalanceListDto;
};

export type AdminStorefrontsControllerListPointBalances200 = BaseResponseDto &
  AdminStorefrontsControllerListPointBalances200AllOf;

export type AdminStorefrontsControllerGetPointLedger200AllOf = {
  data?: AdminPointLedgerDto;
};

export type AdminStorefrontsControllerGetPointLedger200 = BaseResponseDto &
  AdminStorefrontsControllerGetPointLedger200AllOf;

export type AdminStorefrontsControllerChargePoints201AllOf = {
  data?: AdminPointMutationResultDto;
};

export type AdminStorefrontsControllerChargePoints201 = BaseResponseDto &
  AdminStorefrontsControllerChargePoints201AllOf;

export type AdminStorefrontsControllerDeductPoints201AllOf = {
  data?: AdminPointMutationResultDto;
};

export type AdminStorefrontsControllerDeductPoints201 = BaseResponseDto &
  AdminStorefrontsControllerDeductPoints201AllOf;

export type AdminStorefrontsControllerList200AllOf = {
  data?: AdminStorefrontDto[];
};

export type AdminStorefrontsControllerList200 = BaseResponseDto &
  AdminStorefrontsControllerList200AllOf;

export type AdminStorefrontsControllerCreate201AllOf = {
  data?: AdminStorefrontDto;
};

export type AdminStorefrontsControllerCreate201 = BaseResponseDto &
  AdminStorefrontsControllerCreate201AllOf;

export type AdminStorefrontsControllerUpdate200AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontsControllerUpdate200 = BaseResponseDto &
  AdminStorefrontsControllerUpdate200AllOf;

export type AdminStorefrontsControllerListSuppliers200AllOf = {
  data?: StorefrontSupplierDto[];
};

export type AdminStorefrontsControllerListSuppliers200 = BaseResponseDto &
  AdminStorefrontsControllerListSuppliers200AllOf;

export type AdminStorefrontsControllerLinkSupplier201AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontsControllerLinkSupplier201 = BaseResponseDto &
  AdminStorefrontsControllerLinkSupplier201AllOf;

export type AdminStorefrontsControllerUnlinkSupplier200AllOf = {
  data?: UnlinkSupplierResultDto;
};

export type AdminStorefrontsControllerUnlinkSupplier200 = BaseResponseDto &
  AdminStorefrontsControllerUnlinkSupplier200AllOf;

export type AdminStorefrontsControllerListCandidatesParams = {
  supplierId: string;
  q?: string;
  offset?: unknown;
  /**
   * 최대 1000
   */
  limit?: unknown;
};

export type AdminStorefrontsControllerListCandidates200AllOf = {
  data?: CandidateListResponseDto;
};

export type AdminStorefrontsControllerListCandidates200 = BaseResponseDto &
  AdminStorefrontsControllerListCandidates200AllOf;

export type AdminStorefrontsControllerListOfferings200AllOf = {
  data?: AdminOfferingDto[];
};

export type AdminStorefrontsControllerListOfferings200 = BaseResponseDto &
  AdminStorefrontsControllerListOfferings200AllOf;

export type AdminStorefrontsControllerAddOfferings201AllOf = {
  data?: AddOfferingsResultDto;
};

export type AdminStorefrontsControllerAddOfferings201 = BaseResponseDto &
  AdminStorefrontsControllerAddOfferings201AllOf;

export type AdminStorefrontsControllerUpdateOffering200AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontsControllerUpdateOffering200 = BaseResponseDto &
  AdminStorefrontsControllerUpdateOffering200AllOf;

export type AdminStorefrontsControllerRemoveOffering200AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontsControllerRemoveOffering200 = BaseResponseDto &
  AdminStorefrontsControllerRemoveOffering200AllOf;

export type AdminStorefrontsControllerListOrdersParams = {
  status?: string;
  offset?: unknown;
  limit?: unknown;
};

export type AdminStorefrontsControllerListOrders200AllOf = {
  data?: AdminStorefrontOrderListDto;
};

export type AdminStorefrontsControllerListOrders200 = BaseResponseDto &
  AdminStorefrontsControllerListOrders200AllOf;

export type AdminStorefrontsControllerListPaymentAttentionParams = {
  offset?: unknown;
  limit?: unknown;
};

export type AdminStorefrontsControllerListPaymentAttention200AllOf = {
  data?: AdminOrderPaymentAttentionListDto;
};

export type AdminStorefrontsControllerListPaymentAttention200 =
  BaseResponseDto & AdminStorefrontsControllerListPaymentAttention200AllOf;

export type AdminStorefrontsControllerForceReleaseInspection201AllOf = {
  data?: ForceReleaseInspectionResultDto;
};

export type AdminStorefrontsControllerForceReleaseInspection201 =
  BaseResponseDto & AdminStorefrontsControllerForceReleaseInspection201AllOf;

export type AdminStorefrontsControllerForceDeliver201AllOf = {
  data?: ForceOrderActionResultDto;
};

export type AdminStorefrontsControllerForceDeliver201 = BaseResponseDto &
  AdminStorefrontsControllerForceDeliver201AllOf;

export type AdminStorefrontsControllerForceConfirm201AllOf = {
  data?: ForceOrderActionResultDto;
};

export type AdminStorefrontsControllerForceConfirm201 = BaseResponseDto &
  AdminStorefrontsControllerForceConfirm201AllOf;

export type AdminStorefrontsControllerGetDirectFee200AllOf = {
  data?: AdminStorefrontDirectFeeDto;
};

export type AdminStorefrontsControllerGetDirectFee200 = BaseResponseDto &
  AdminStorefrontsControllerGetDirectFee200AllOf;

export type AdminStorefrontsControllerUpdateDirectFee200AllOf = {
  data?: AdminStorefrontDirectFeeDto;
};

export type AdminStorefrontsControllerUpdateDirectFee200 = BaseResponseDto &
  AdminStorefrontsControllerUpdateDirectFee200AllOf;

export type AdminStorefrontsControllerListOrderUnitFees200AllOf = {
  data?: AdminMallUnitFeeListDto;
};

export type AdminStorefrontsControllerListOrderUnitFees200 = BaseResponseDto &
  AdminStorefrontsControllerListOrderUnitFees200AllOf;

export type AdminStorefrontsControllerUpdateOrderUnitFee200AllOf = {
  data?: UpdateMallUnitFeeResultDto;
};

export type AdminStorefrontsControllerUpdateOrderUnitFee200 = BaseResponseDto &
  AdminStorefrontsControllerUpdateOrderUnitFee200AllOf;

export type AdminStorefrontBulkControllerBulkOffer200AllOf = {
  data?: BulkOfferResultDto;
};

export type AdminStorefrontBulkControllerBulkOffer200 = BaseResponseDto &
  AdminStorefrontBulkControllerBulkOffer200AllOf;

export type AdminStorefrontBulkControllerBulkActive200AllOf = {
  data?: BulkActiveResultDto;
};

export type AdminStorefrontBulkControllerBulkActive200 = BaseResponseDto &
  AdminStorefrontBulkControllerBulkActive200AllOf;

export type AdminStorefrontBulkControllerBulkPrices200AllOf = {
  data?: BulkPriceResultDto;
};

export type AdminStorefrontBulkControllerBulkPrices200 = BaseResponseDto &
  AdminStorefrontBulkControllerBulkPrices200AllOf;

export type AdminStorefrontBulkControllerListBatchesParams = {
  offset?: unknown;
  limit?: unknown;
};

export type AdminStorefrontBulkControllerListBatches200AllOf = {
  data?: BatchListResponseDto;
};

export type AdminStorefrontBulkControllerListBatches200 = BaseResponseDto &
  AdminStorefrontBulkControllerListBatches200AllOf;

export type AdminStorefrontBulkControllerUndoBatch200AllOf = {
  data?: UndoBatchResultDto;
};

export type AdminStorefrontBulkControllerUndoBatch200 = BaseResponseDto &
  AdminStorefrontBulkControllerUndoBatch200AllOf;

export type AdminStorefrontBulkControllerListRules200AllOf = {
  data?: RuleDto[];
};

export type AdminStorefrontBulkControllerListRules200 = BaseResponseDto &
  AdminStorefrontBulkControllerListRules200AllOf;

export type AdminStorefrontBulkControllerCreateRule201AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontBulkControllerCreateRule201 = BaseResponseDto &
  AdminStorefrontBulkControllerCreateRule201AllOf;

export type AdminStorefrontBulkControllerUpdateRule200AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontBulkControllerUpdateRule200 = BaseResponseDto &
  AdminStorefrontBulkControllerUpdateRule200AllOf;

export type AdminStorefrontBulkControllerRemoveRule200AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontBulkControllerRemoveRule200 = BaseResponseDto &
  AdminStorefrontBulkControllerRemoveRule200AllOf;

export type AdminStorefrontBulkControllerApplyRules200AllOf = {
  data?: ApplyRulesResultDto;
};

export type AdminStorefrontBulkControllerApplyRules200 = BaseResponseDto &
  AdminStorefrontBulkControllerApplyRules200AllOf;

export type AdminStorefrontBulkControllerListExclusions200AllOf = {
  data?: ExclusionDto[];
};

export type AdminStorefrontBulkControllerListExclusions200 = BaseResponseDto &
  AdminStorefrontBulkControllerListExclusions200AllOf;

export type AdminStorefrontBulkControllerAddExclusion201AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontBulkControllerAddExclusion201 = BaseResponseDto &
  AdminStorefrontBulkControllerAddExclusion201AllOf;

export type AdminStorefrontBulkControllerRemoveExclusion200AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontBulkControllerRemoveExclusion200 = BaseResponseDto &
  AdminStorefrontBulkControllerRemoveExclusion200AllOf;

export type AdminStorefrontBulkControllerListRequestsParams = {
  status?: string;
  offset?: unknown;
  limit?: unknown;
};

export type AdminStorefrontBulkControllerListRequests200AllOf = {
  data?: RequestListResponseDto;
};

export type AdminStorefrontBulkControllerListRequests200 = BaseResponseDto &
  AdminStorefrontBulkControllerListRequests200AllOf;

export type AdminStorefrontBulkControllerDecideRequest200AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontBulkControllerDecideRequest200 = BaseResponseDto &
  AdminStorefrontBulkControllerDecideRequest200AllOf;

export type AdminPriceAxisControllerGetStatus200AllOf = {
  data?: SupplierPriceAxisStatusDto;
};

export type AdminPriceAxisControllerGetStatus200 = BaseResponseDto &
  AdminPriceAxisControllerGetStatus200AllOf;

export type AdminPriceAxisControllerSetSupplierAxis200AllOf = {
  data?: SetSupplierPriceAxisResultDto;
};

export type AdminPriceAxisControllerSetSupplierAxis200 = BaseResponseDto &
  AdminPriceAxisControllerSetSupplierAxis200AllOf;

export type AdminPriceAxisControllerSetTaxCategory200AllOf = {
  data?: SetTaxCategoryResultDto;
};

export type AdminPriceAxisControllerSetTaxCategory200 = BaseResponseDto &
  AdminPriceAxisControllerSetTaxCategory200AllOf;

export type AdminPriceAxisControllerListBatchesParams = {
  supplierId?: string;
  limit?: unknown;
};

export type AdminPriceAxisControllerListBatches200AllOf = {
  data?: PriceAxisBatchDto[];
};

export type AdminPriceAxisControllerListBatches200 = BaseResponseDto &
  AdminPriceAxisControllerListBatches200AllOf;

export type AdminPriceAxisControllerUndoBatch200AllOf = {
  data?: UndoPriceAxisResultDto;
};

export type AdminPriceAxisControllerUndoBatch200 = BaseResponseDto &
  AdminPriceAxisControllerUndoBatch200AllOf;

export type AdminTrustScoresControllerRecalculateTrustScores200AllOf = {
  data?: RecalculateTrustScoresResponseDto;
};

export type AdminTrustScoresControllerRecalculateTrustScores200 =
  BaseResponseDto & AdminTrustScoresControllerRecalculateTrustScores200AllOf;

export type AdminSuppliersControllerGetSuppliersParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 기준 — 신뢰 점수(trust_score)·6요소 점수·백분위, 활동 수(participation_count=참여 대화방·quote_count=낸 견적·contract_count=취소 아닌 계약), 가입일(created_at)
   */
  sortBy?: AdminSuppliersControllerGetSuppliersSortBy;
  /**
   * 정렬 순서
   */
  sortOrder?: AdminSuppliersControllerGetSuppliersSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 최소 신뢰 점수 (0-100)
   * @minimum 0
   * @maximum 100
   */
  minTrustScore?: number;
  /**
   * 최대 신뢰 점수 (0-100)
   * @minimum 0
   * @maximum 100
   */
  maxTrustScore?: number;
  /**
   * 백분위 구간 (1, 5, 10, 15, 20, 30, null)
   * @nullable
   */
  percentileTier?: AdminSuppliersControllerGetSuppliersPercentileTier;
  /**
   * 세모 가입 창구(가입비·구독)로 온 기업만 — true 일 때만 거른다. 이 보기에선 참여·견적·계약 수를 싣지 않고, 그 셋으로 정렬하면 가입일 순이 된다
   */
  semoSignup?: boolean;
};

export type AdminSuppliersControllerGetSuppliersSortBy =
  (typeof AdminSuppliersControllerGetSuppliersSortBy)[keyof typeof AdminSuppliersControllerGetSuppliersSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSuppliersControllerGetSuppliersSortBy = {
  trust_score: "trust_score",
  certification_total_score: "certification_total_score",
  total_participation_score: "total_participation_score",
  contract_count_score: "contract_count_score",
  total_amount_score: "total_amount_score",
  total_commission_score: "total_commission_score",
  recent_participation_score: "recent_participation_score",
  trust_percentile: "trust_percentile",
  participation_count: "participation_count",
  quote_count: "quote_count",
  contract_count: "contract_count",
  created_at: "created_at",
} as const;

export type AdminSuppliersControllerGetSuppliersSortOrder =
  (typeof AdminSuppliersControllerGetSuppliersSortOrder)[keyof typeof AdminSuppliersControllerGetSuppliersSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSuppliersControllerGetSuppliersSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminSuppliersControllerGetSuppliersPercentileTier =
  | (typeof AdminSuppliersControllerGetSuppliersPercentileTier)[keyof typeof AdminSuppliersControllerGetSuppliersPercentileTier]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSuppliersControllerGetSuppliersPercentileTier = {
  NUMBER_1: 1,
  NUMBER_5: 5,
  NUMBER_10: 10,
  NUMBER_15: 15,
  NUMBER_20: 20,
  NUMBER_30: 30,
} as const;

export type AdminSuppliersControllerGetSuppliers200AllOfData = {
  items: SupplierWithTrustScoreDto[];
  meta: PaginationMetaDto;
};

export type AdminSuppliersControllerGetSuppliers200AllOf = {
  data?: AdminSuppliersControllerGetSuppliers200AllOfData;
};

export type AdminSuppliersControllerGetSuppliers200 = BaseResponseDto &
  AdminSuppliersControllerGetSuppliers200AllOf;

export type AdminSuppliersControllerGetSupplier200AllOf = {
  data?: SupplierWithTrustScoreDto;
};

export type AdminSuppliersControllerGetSupplier200 = BaseResponseDto &
  AdminSuppliersControllerGetSupplier200AllOf;

export type AdminSuppliersControllerGetSupplierEmbedUrl201AllOf = {
  data?: EmbedJoinResponseDto;
};

export type AdminSuppliersControllerGetSupplierEmbedUrl201 = BaseResponseDto &
  AdminSuppliersControllerGetSupplierEmbedUrl201AllOf;

export type AdminBuyersControllerGetBuyersParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 기준 컬럼 (구매자는 3개만 지원)
   */
  sortBy?: AdminBuyersControllerGetBuyersSortBy;
  /**
   * 정렬 순서
   */
  sortOrder?: AdminBuyersControllerGetBuyersSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 최소 신뢰 점수 (0-100)
   * @minimum 0
   * @maximum 100
   */
  minTrustScore?: number;
  /**
   * 최대 신뢰 점수 (0-100)
   * @minimum 0
   * @maximum 100
   */
  maxTrustScore?: number;
  /**
   * 백분위 구간 (1, 5, 10, 15, 20, 30, null = 하위 70%)
   * @nullable
   */
  percentileTier?: AdminBuyersControllerGetBuyersPercentileTier;
};

export type AdminBuyersControllerGetBuyersSortBy =
  (typeof AdminBuyersControllerGetBuyersSortBy)[keyof typeof AdminBuyersControllerGetBuyersSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminBuyersControllerGetBuyersSortBy = {
  trust_score: "trust_score",
  trust_percentile: "trust_percentile",
  created_at: "created_at",
} as const;

export type AdminBuyersControllerGetBuyersSortOrder =
  (typeof AdminBuyersControllerGetBuyersSortOrder)[keyof typeof AdminBuyersControllerGetBuyersSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminBuyersControllerGetBuyersSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminBuyersControllerGetBuyersPercentileTier =
  | (typeof AdminBuyersControllerGetBuyersPercentileTier)[keyof typeof AdminBuyersControllerGetBuyersPercentileTier]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminBuyersControllerGetBuyersPercentileTier = {
  NUMBER_1: 1,
  NUMBER_5: 5,
  NUMBER_10: 10,
  NUMBER_15: 15,
  NUMBER_20: 20,
  NUMBER_30: 30,
} as const;

export type AdminBuyersControllerGetBuyers200AllOfData = {
  items: BuyerWithTrustScoreDto[];
  meta: PaginationMetaDto;
};

export type AdminBuyersControllerGetBuyers200AllOf = {
  data?: AdminBuyersControllerGetBuyers200AllOfData;
};

export type AdminBuyersControllerGetBuyers200 = BaseResponseDto &
  AdminBuyersControllerGetBuyers200AllOf;

export type AdminBuyersControllerGetBuyerById200AllOf = {
  data?: BuyerDetailDto;
};

export type AdminBuyersControllerGetBuyerById200 = BaseResponseDto &
  AdminBuyersControllerGetBuyerById200AllOf;

export type AdminPaymentControllerGetRefundsParams = {
  /**
   * Offset for pagination
   */
  offset?: unknown;
  /**
   * Limit for pagination
   */
  limit?: unknown;
  /**
   * Refund Status Filter
   */
  status?: string;
  /**
   * Search term (Reason, ID)
   */
  search?: string;
};

export type AdminPaymentControllerGetRefunds200AllOfData = {
  items: RefundDetailedResponseDto[];
  meta: PaginationMetaDto;
};

export type AdminPaymentControllerGetRefunds200AllOf = {
  data?: AdminPaymentControllerGetRefunds200AllOfData;
};

export type AdminPaymentControllerGetRefunds200 = BaseResponseDto &
  AdminPaymentControllerGetRefunds200AllOf;

export type AdminPaymentControllerGetUserPayments200AllOf = {
  data?: PaymentTransactionResponseDto[];
};

export type AdminPaymentControllerGetUserPayments200 = BaseResponseDto &
  AdminPaymentControllerGetUserPayments200AllOf;

export type AdminPaymentControllerGetStuckPayments200AllOfData = {
  items: PendingCashPaymentDto[];
  meta: PaginationMetaDto;
};

export type AdminPaymentControllerGetStuckPayments200AllOf = {
  data?: AdminPaymentControllerGetStuckPayments200AllOfData;
};

export type AdminPaymentControllerGetStuckPayments200 = BaseResponseDto &
  AdminPaymentControllerGetStuckPayments200AllOf;

export type AdminPaymentControllerGetCashPaymentsParams = {
  /**
   * Offset for pagination
   */
  offset?: unknown;
  /**
   * Limit for pagination
   */
  limit?: unknown;
  /**
   * Payment Status Filter
   */
  status?: AdminPaymentControllerGetCashPaymentsStatus;
  /**
   * Search term (MOID, Buyer Name, Project Name)
   */
  search?: string;
};

export type AdminPaymentControllerGetCashPaymentsStatus =
  (typeof AdminPaymentControllerGetCashPaymentsStatus)[keyof typeof AdminPaymentControllerGetCashPaymentsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminPaymentControllerGetCashPaymentsStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  FAILED: "FAILED",
  CANCELED: "CANCELED",
  EXPIRED: "EXPIRED",
} as const;

export type AdminPaymentControllerGetCashPayments200AllOfData = {
  items: AdminCashPaymentDto[];
  meta: PaginationMetaDto;
};

export type AdminPaymentControllerGetCashPayments200AllOf = {
  data?: AdminPaymentControllerGetCashPayments200AllOfData;
};

export type AdminPaymentControllerGetCashPayments200 = BaseResponseDto &
  AdminPaymentControllerGetCashPayments200AllOf;

export type AdminPaymentControllerGetPendingCashPayments200AllOfData = {
  items: PendingCashPaymentDto[];
  meta: PaginationMetaDto;
};

export type AdminPaymentControllerGetPendingCashPayments200AllOf = {
  data?: AdminPaymentControllerGetPendingCashPayments200AllOfData;
};

export type AdminPaymentControllerGetPendingCashPayments200 = BaseResponseDto &
  AdminPaymentControllerGetPendingCashPayments200AllOf;

export type AdminCategoriesControllerBulkUploadCategoriesBody = {
  /** 카테고리 일괄 등록 엑셀 파일 (.xlsx) */
  file?: Blob;
};

export type AdminCategoriesControllerBulkUploadCategories200AllOf = {
  data?: AdminBulkUploadResultDto;
};

export type AdminCategoriesControllerBulkUploadCategories200 = BaseResponseDto &
  AdminCategoriesControllerBulkUploadCategories200AllOf;

export type AdminCategoriesControllerGetCategoryTree200AllOf = {
  data?: CategoryTreeNodeDto[];
};

export type AdminCategoriesControllerGetCategoryTree200 = BaseResponseDto &
  AdminCategoriesControllerGetCategoryTree200AllOf;

export type AdminCategoriesControllerGetItemsByCategoryParams = {
  categoryId: string;
  includeDescendants: boolean;
  limit: number;
  offset: number;
};

export type AdminCategoriesControllerGetItemsByCategory200AllOfData = {
  items: AdminCategoryItemDto[];
  meta: PaginationMetaDto;
};

export type AdminCategoriesControllerGetItemsByCategory200AllOf = {
  data?: AdminCategoriesControllerGetItemsByCategory200AllOfData;
};

export type AdminCategoriesControllerGetItemsByCategory200 = BaseResponseDto &
  AdminCategoriesControllerGetItemsByCategory200AllOf;

export type AdminCategoriesControllerGetCategoryById200AllOf = {
  data?: CategoryResponseDto;
};

export type AdminCategoriesControllerGetCategoryById200 = BaseResponseDto &
  AdminCategoriesControllerGetCategoryById200AllOf;

export type AdminCategoriesControllerUpdateCategory200AllOf = {
  data?: CategoryResponseDto;
};

export type AdminCategoriesControllerUpdateCategory200 = BaseResponseDto &
  AdminCategoriesControllerUpdateCategory200AllOf;

export type AdminCategoriesControllerCreateCategory201AllOf = {
  data?: CategoryResponseDto;
};

export type AdminCategoriesControllerCreateCategory201 = BaseResponseDto &
  AdminCategoriesControllerCreateCategory201AllOf;

export type AdminCategoriesControllerReorderCategory200AllOf = {
  data?: CategoryResponseDto;
};

export type AdminCategoriesControllerReorderCategory200 = BaseResponseDto &
  AdminCategoriesControllerReorderCategory200AllOf;

export type AdminItemsControllerGetFrequentCategoriesParams = {
  limit?: number;
};

export type AdminItemsControllerGetFrequentCategories200AllOf = {
  data?: FrequentCategoryDto[];
};

export type AdminItemsControllerGetFrequentCategories200 = BaseResponseDto &
  AdminItemsControllerGetFrequentCategories200AllOf;

export type AdminItemsControllerFindDuplicateCandidatesParams = {
  /**
   * 유사도 임계값 (0.0 ~ 1.0, 기본값: 0.8)
   */
  threshold?: number;
  /**
   * 카테고리 ID (해당 카테고리가 포함된 중복 그룹 조회)
   */
  categoryId?: string;
  /**
   * 검색어 (상품명/브랜드 등에 포함된 중복 그룹 조회)
   */
  search?: string;
  /**
   * 가져올 그룹 수 (기본값: 20)
   */
  limit?: number;
  /**
   * 건너뛸 그룹 수 (기본값: 0)
   */
  offset?: number;
  /**
   * 구간 하한(포함) — 그룹 최고 유사도 기준. 임계값(threshold)과는 별개다: 임계값을 올리면 약한 구성원이 잘려 그룹이 통째로 사라지므로, 구간 선택에는 이 값을 쓴다.
   */
  minScore?: number;
  /**
   * 구간 상한(미포함) — 그룹 최고 유사도 기준. 비우면 상한 없음.
   */
  maxScore?: number;
};

export type AdminItemsControllerFindDuplicateCandidates200AllOfData = {
  items: DuplicateItemCandidateDto[];
  meta: PaginationMetaDto;
};

export type AdminItemsControllerFindDuplicateCandidates200AllOf = {
  data?: AdminItemsControllerFindDuplicateCandidates200AllOfData;
};

export type AdminItemsControllerFindDuplicateCandidates200 = BaseResponseDto &
  AdminItemsControllerFindDuplicateCandidates200AllOf;

export type AdminItemsControllerGetDuplicateCandidateBandsParams = {
  threshold?: number;
  categoryId?: string;
  search?: string;
};

export type AdminItemsControllerGetDuplicateCandidateBands200AllOf = {
  data?: DuplicateCandidateBandDto[];
};

export type AdminItemsControllerGetDuplicateCandidateBands200 =
  BaseResponseDto & AdminItemsControllerGetDuplicateCandidateBands200AllOf;

export type AdminItemsControllerTriggerDuplicateRecalculation202AllOf = {
  data?: BaseResponseDto;
};

export type AdminItemsControllerTriggerDuplicateRecalculation202 =
  BaseResponseDto & AdminItemsControllerTriggerDuplicateRecalculation202AllOf;

export type AdminItemsControllerCancelDuplicateRecalculation200AllOf = {
  data?: BaseResponseDto;
};

export type AdminItemsControllerCancelDuplicateRecalculation200 =
  BaseResponseDto & AdminItemsControllerCancelDuplicateRecalculation200AllOf;

export type AdminItemsControllerGetDuplicateRecalculationStatus200AllOf = {
  data?: DuplicateRecalculationStatusDto;
};

export type AdminItemsControllerGetDuplicateRecalculationStatus200 =
  BaseResponseDto & AdminItemsControllerGetDuplicateRecalculationStatus200AllOf;

export type AdminItemsControllerPreviewMerge200AllOf = {
  data?: MergePreviewResponseDto;
};

export type AdminItemsControllerPreviewMerge200 = BaseResponseDto &
  AdminItemsControllerPreviewMerge200AllOf;

export type AdminItemsControllerMergeItems200AllOf = {
  data?: MergeItemsResponseDto;
};

export type AdminItemsControllerMergeItems200 = BaseResponseDto &
  AdminItemsControllerMergeItems200AllOf;

export type AdminItemsControllerExportItemsParams = {
  /**
   * 선택된 카테고리 ID 목록 (콤마 구분). 지정하지 않으면 전체 다운로드
   */
  categoryIds?: string;
  /**
   * 하위 카테고리 포함 여부 (기본값: true)
   */
  includeDescendants?: string;
};

export type AdminItemsControllerBulkUploadProductsBody = {
  /** 상품 일괄 등록 엑셀 파일 (.xlsx) */
  file?: Blob;
};

export type AdminItemsControllerBulkUploadProducts200AllOf = {
  data?: AdminBulkUploadResultDto;
};

export type AdminItemsControllerBulkUploadProducts200 = BaseResponseDto &
  AdminItemsControllerBulkUploadProducts200AllOf;

export type AdminItemsControllerUploadProductImageBody = {
  /** 상품 이미지 (JPG, PNG, GIF, WEBP, BMP / 최대 5MB) */
  file: Blob;
};

export type AdminItemsControllerUploadProductImage201AllOf = {
  data?: AdminProductImageUploadResponseDto;
};

export type AdminItemsControllerUploadProductImage201 = BaseResponseDto &
  AdminItemsControllerUploadProductImage201AllOf;

export type AdminItemsControllerCreateProduct201AllOf = {
  data?: CreateProductResponseDto;
};

export type AdminItemsControllerCreateProduct201 = BaseResponseDto &
  AdminItemsControllerCreateProduct201AllOf;

export type AdminItemsControllerGetItemsParams = {
  /**
   * 조회 개수 (기본 50)
   */
  limit?: number;
  /**
   * 페이지네이션 오프셋 (기본 0)
   */
  offset?: number;
  /**
   * 커서 (다음 페이지 조회를 위한 Base64 인코딩 값)
   */
  cursor?: string;
  /**
   * 카테고리 ID (선택 시 해당 카테고리 내 물품 조회)
   */
  categoryId?: string;
  /**
   * 하위 카테고리 포함 여부 (기본 true)
   */
  includeDescendants?: boolean;
  /**
   * 검색어 (상품명 등)
   */
  search?: string;
  /**
   * 정렬 기준 컬럼
   */
  sortBy?: AdminItemsControllerGetItemsSortBy;
  /**
   * 정렬 순서
   */
  sortOrder?: AdminItemsControllerGetItemsSortOrder;
};

export type AdminItemsControllerGetItemsSortBy =
  (typeof AdminItemsControllerGetItemsSortBy)[keyof typeof AdminItemsControllerGetItemsSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminItemsControllerGetItemsSortBy = {
  name: "name",
  price: "price",
  updated_at: "updated_at",
  supplier_count: "supplier_count",
  code: "code",
} as const;

export type AdminItemsControllerGetItemsSortOrder =
  (typeof AdminItemsControllerGetItemsSortOrder)[keyof typeof AdminItemsControllerGetItemsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminItemsControllerGetItemsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminItemsControllerGetItems200AllOfData = {
  items: AdminCategoryItemDto[];
  meta: PaginationMetaDto;
};

export type AdminItemsControllerGetItems200AllOf = {
  data?: AdminItemsControllerGetItems200AllOfData;
};

export type AdminItemsControllerGetItems200 = BaseResponseDto &
  AdminItemsControllerGetItems200AllOf;

export type AdminItemsControllerFindRequestsParams = {
  limit?: number;
  offset?: number;
  /**
   * 요청일 정렬. 기본 desc(최신순) — 대기 큐는 asc 로 오래 기다린 요청부터 본다.
   */
  sortOrder?: AdminItemsControllerFindRequestsSortOrder;
  status?: AdminItemsControllerFindRequestsStatus;
};

export type AdminItemsControllerFindRequestsSortOrder =
  (typeof AdminItemsControllerFindRequestsSortOrder)[keyof typeof AdminItemsControllerFindRequestsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminItemsControllerFindRequestsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminItemsControllerFindRequestsStatus =
  (typeof AdminItemsControllerFindRequestsStatus)[keyof typeof AdminItemsControllerFindRequestsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminItemsControllerFindRequestsStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  needs_info: "needs_info",
} as const;

export type AdminItemsControllerFindRequests200AllOfData = {
  items: SupplierItemRequestSummaryDto[];
  meta: PaginationMetaDto;
};

export type AdminItemsControllerFindRequests200AllOf = {
  data?: AdminItemsControllerFindRequests200AllOfData;
};

export type AdminItemsControllerFindRequests200 = BaseResponseDto &
  AdminItemsControllerFindRequests200AllOf;

export type AdminItemsControllerFindRequestById200AllOf = {
  data?: SupplierItemRequestDetailResponseDto;
};

export type AdminItemsControllerFindRequestById200 = BaseResponseDto &
  AdminItemsControllerFindRequestById200AllOf;

export type AdminItemsControllerApproveRequest200AllOf = {
  data?: ApprovalResultResponseDto;
};

export type AdminItemsControllerApproveRequest200 = BaseResponseDto &
  AdminItemsControllerApproveRequest200AllOf;

export type AdminItemsControllerRejectRequest200AllOf = {
  data?: RejectionResultResponseDto;
};

export type AdminItemsControllerRejectRequest200 = BaseResponseDto &
  AdminItemsControllerRejectRequest200AllOf;

export type AdminItemsControllerFindRequestMatchCandidatesParams = {
  /**
   * 후보 수 (기본 5, 최대 10)
   */
  limit?: number;
};

export type AdminItemsControllerFindRequestMatchCandidates200AllOf = {
  data?: QuoteLineMatchResultDto;
};

export type AdminItemsControllerFindRequestMatchCandidates200 =
  BaseResponseDto & AdminItemsControllerFindRequestMatchCandidates200AllOf;

export type AdminItemsControllerLinkRequest200AllOf = {
  data?: ApprovalResultResponseDto;
};

export type AdminItemsControllerLinkRequest200 = BaseResponseDto &
  AdminItemsControllerLinkRequest200AllOf;

export type AdminItemsControllerRequestInfo200AllOf = {
  data?: InfoRequestResultResponseDto;
};

export type AdminItemsControllerRequestInfo200 = BaseResponseDto &
  AdminItemsControllerRequestInfo200AllOf;

export type AdminItemsControllerFindEditRequestsParams = {
  limit?: number;
  offset?: number;
  /**
   * 요청일 정렬. 대기(pending)는 기본 asc(오래 기다린 순), 그 밖은 desc(최신순).
   */
  sortOrder?: AdminItemsControllerFindEditRequestsSortOrder;
  status?: AdminItemsControllerFindEditRequestsStatus;
};

export type AdminItemsControllerFindEditRequestsSortOrder =
  (typeof AdminItemsControllerFindEditRequestsSortOrder)[keyof typeof AdminItemsControllerFindEditRequestsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminItemsControllerFindEditRequestsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminItemsControllerFindEditRequestsStatus =
  (typeof AdminItemsControllerFindEditRequestsStatus)[keyof typeof AdminItemsControllerFindEditRequestsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminItemsControllerFindEditRequestsStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  needs_info: "needs_info",
} as const;

export type AdminItemsControllerFindEditRequests200AllOfData = {
  items: SupplierItemEditRequestSummaryDto[];
  meta: PaginationMetaDto;
};

export type AdminItemsControllerFindEditRequests200AllOf = {
  data?: AdminItemsControllerFindEditRequests200AllOfData;
};

export type AdminItemsControllerFindEditRequests200 = BaseResponseDto &
  AdminItemsControllerFindEditRequests200AllOf;

export type AdminItemsControllerCountEditRequests200AllOf = {
  data?: SupplierItemEditRequestCountsDto;
};

export type AdminItemsControllerCountEditRequests200 = BaseResponseDto &
  AdminItemsControllerCountEditRequests200AllOf;

export type AdminItemsControllerFindEditRequestById200AllOf = {
  data?: SupplierItemEditRequestSummaryDto;
};

export type AdminItemsControllerFindEditRequestById200 = BaseResponseDto &
  AdminItemsControllerFindEditRequestById200AllOf;

export type AdminItemsControllerApproveEditRequest200AllOf = {
  data?: SupplierItemEditRequestSummaryDto;
};

export type AdminItemsControllerApproveEditRequest200 = BaseResponseDto &
  AdminItemsControllerApproveEditRequest200AllOf;

export type AdminItemsControllerRejectEditRequest200AllOf = {
  data?: SupplierItemEditRequestSummaryDto;
};

export type AdminItemsControllerRejectEditRequest200 = BaseResponseDto &
  AdminItemsControllerRejectEditRequest200AllOf;

export type AdminItemsControllerRequestInfoEditRequest200AllOf = {
  data?: SupplierItemEditRequestSummaryDto;
};

export type AdminItemsControllerRequestInfoEditRequest200 = BaseResponseDto &
  AdminItemsControllerRequestInfoEditRequest200AllOf;

export type AdminItemsControllerUpdateProduct200AllOf = {
  data?: UpdateProductResponseDto;
};

export type AdminItemsControllerUpdateProduct200 = BaseResponseDto &
  AdminItemsControllerUpdateProduct200AllOf;

export type AdminItemsControllerFindProductById200AllOf = {
  data?: GetProductResponseDto;
};

export type AdminItemsControllerFindProductById200 = BaseResponseDto &
  AdminItemsControllerFindProductById200AllOf;

export type AdminItemsControllerDeleteProduct200AllOf = {
  data?: DeleteProductResponseDto;
};

export type AdminItemsControllerDeleteProduct200 = BaseResponseDto &
  AdminItemsControllerDeleteProduct200AllOf;

export type AdminItemsControllerGetVendorStats200AllOf = {
  data?: VendorStatsResponseDto[];
};

export type AdminItemsControllerGetVendorStats200 = BaseResponseDto &
  AdminItemsControllerGetVendorStats200AllOf;

export type AdminItemsControllerSyncSupplierCounts200AllOf = {
  data?: DeleteProductResponseDto;
};

export type AdminItemsControllerSyncSupplierCounts200 = BaseResponseDto &
  AdminItemsControllerSyncSupplierCounts200AllOf;

export type AdminItemsControllerGetSyncSupplierCountsStatus200AllOf = {
  data?: DuplicateRecalculationStatusDto;
};

export type AdminItemsControllerGetSyncSupplierCountsStatus200 =
  BaseResponseDto & AdminItemsControllerGetSyncSupplierCountsStatus200AllOf;

export type AdminItemsControllerSyncMsdsCatalog202AllOf = {
  data?: MsdsCatalogSyncStartedDto;
};

export type AdminItemsControllerSyncMsdsCatalog202 = BaseResponseDto &
  AdminItemsControllerSyncMsdsCatalog202AllOf;

export type AdminItemsControllerGetMsdsCatalogStatus200AllOf = {
  data?: MsdsCatalogStatusDto;
};

export type AdminItemsControllerGetMsdsCatalogStatus200 = BaseResponseDto &
  AdminItemsControllerGetMsdsCatalogStatus200AllOf;

export type AdminAuthControllerAdminSignup201AllOf = {
  data?: AdminSignupResponseDto;
};

export type AdminAuthControllerAdminSignup201 = BaseResponseDto &
  AdminAuthControllerAdminSignup201AllOf;

export type AdminAuthControllerAdminLogin200AllOf = {
  data?: AdminLoginResponseDto;
};

export type AdminAuthControllerAdminLogin200 = BaseResponseDto &
  AdminAuthControllerAdminLogin200AllOf;

export type AdminPriceBandControllerGetPriceBandsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: AdminPriceBandControllerGetPriceBandsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 신뢰등급 필터 (미지정 시 A/B/C 전체)
   */
  grade?: AdminPriceBandControllerGetPriceBandsGrade;
};

export type AdminPriceBandControllerGetPriceBandsSortOrder =
  (typeof AdminPriceBandControllerGetPriceBandsSortOrder)[keyof typeof AdminPriceBandControllerGetPriceBandsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminPriceBandControllerGetPriceBandsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminPriceBandControllerGetPriceBandsGrade =
  (typeof AdminPriceBandControllerGetPriceBandsGrade)[keyof typeof AdminPriceBandControllerGetPriceBandsGrade];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminPriceBandControllerGetPriceBandsGrade = {
  A: "A",
  B: "B",
  C: "C",
} as const;

export type AdminPriceBandControllerGetPriceBands200AllOfData = {
  items: PriceBandListItemDto[];
  meta: PaginationMetaDto;
};

export type AdminPriceBandControllerGetPriceBands200AllOf = {
  data?: AdminPriceBandControllerGetPriceBands200AllOfData;
};

export type AdminPriceBandControllerGetPriceBands200 = BaseResponseDto &
  AdminPriceBandControllerGetPriceBands200AllOf;

export type AdminPriceBandControllerGetPriceBandDetail200AllOf = {
  data?: PriceBandDetailDto;
};

export type AdminPriceBandControllerGetPriceBandDetail200 = BaseResponseDto &
  AdminPriceBandControllerGetPriceBandDetail200AllOf;

export type AdminProjectsControllerGetProjectsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: AdminProjectsControllerGetProjectsSortOrder;
  /**
   * 검색어. 공고명·설명뿐 아니라 목록에 보이는 값으로도 찾을 수 있어야 한다 — 견적번호(`request_number`), 발주기관명(`buyers.organization_name`·`users.name`), 공급기업명(`suppliers.company_name`, 채팅방으로 이어진 공고)을 함께 훑는다. 회사 이름은 다른 표에 있어 먼저 id 를 모아 온 뒤 거르며, 한 번에 모으는 양에 상한이 있다(초과 시 서버 로그에 경고).
   */
  search?: string;
  /**
 * 상태 필터.

- `IN_PROGRESS` — 진행중
- `CLOSED` — 마감 전부. DB 의 `ON_HOLD`(마감일 경과로 스케줄러가 내린 값)와 `CLOSED`(사람이 누른 값)를 함께 뜻한다.
- `DEADLINE_PASSED` — 마감 «안쪽» 중 아무도 누르지 않은 것만(`ON_HOLD`)
- `CLOSED_BY_BUYER` — 발주기관이 직접 [마감하기] 를 누른 것만
- `CLOSED_BY_ADMIN` — 관리자가 대신 마감한 것만

뒤 세 값은 마감 한 칸을 **주체**로 다시 가른다 — 시간이 지나 저절로 내려간 건, 발주기관이 스스로 끝낸 건, 관리자가 대신 끝낸 건은 이후에 할 일이 서로 다르다. 계약까지 갔는지는 이 필터가 아니라 응답의 `status`(계약 파생값)로 가른다 — 마감 목록을 열어 그 안에서 계약 여부를 훑는 게 이 화면을 쓰는 방식이라, 계약 건을 필터에서 빼면 찾던 것이 목록에서 사라진다. (`ON_HOLD` 로 들어와도 마감 전부로 받아준다)
 */
  status?: AdminProjectsControllerGetProjectsStatus;
  /**
   * "삭제됨" 탭. true 면 삭제된 프로젝트만, 기본값(false)이면 살아있는 것만 조회한다.
   */
  deleted?: boolean;
  /**
   * 자동견적 진행 상태 필터(`quote_requests.auto_quote_status`). 쉼표로 여러 값을 줄 수 있다. `none,failed` 가 실제로 쓰이는 조합이다 — 발송이 안 나갔거나 실패한 공고는 사람이 보지 않으면 드러나지 않는다.
   */
  autoQuote?: string;
  /**
   * 매칭이 남은 공고만. 파생 컬럼 `unmatched_item_count > 0` 으로 거른다 — 페이지를 받아 온 뒤 거르면 총 건수와 페이지 수가 어긋난다.
   */
  unmatched?: boolean;
  /**
   * 마감 48시간 이내인데 견적이 0건인 진행중 공고만. 자동견적이 닿지 않았거나 매칭이 비어 있는 건이 대부분 여기 걸린다.
   */
  stalled?: boolean;
  /**
   * 가입 경로 필터(`users.source`). 씨마켓 연동 건과 세모 직가입 건을 가른다.
   */
  source?: AdminProjectsControllerGetProjectsSource;
};

export type AdminProjectsControllerGetProjectsSortOrder =
  (typeof AdminProjectsControllerGetProjectsSortOrder)[keyof typeof AdminProjectsControllerGetProjectsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectsControllerGetProjectsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminProjectsControllerGetProjectsStatus =
  (typeof AdminProjectsControllerGetProjectsStatus)[keyof typeof AdminProjectsControllerGetProjectsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectsControllerGetProjectsStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  CLOSED: "CLOSED",
  DEADLINE_PASSED: "DEADLINE_PASSED",
  CLOSED_BY_BUYER: "CLOSED_BY_BUYER",
  CLOSED_BY_ADMIN: "CLOSED_BY_ADMIN",
} as const;

export type AdminProjectsControllerGetProjectsSource =
  (typeof AdminProjectsControllerGetProjectsSource)[keyof typeof AdminProjectsControllerGetProjectsSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectsControllerGetProjectsSource = {
  direct: "direct",
  cmarket: "cmarket",
} as const;

export type AdminProjectsControllerGetProjects200AllOfData = {
  items: AdminProjectDto[];
  meta: PaginationMetaDto;
};

export type AdminProjectsControllerGetProjects200AllOf = {
  data?: AdminProjectsControllerGetProjects200AllOfData;
};

export type AdminProjectsControllerGetProjects200 = BaseResponseDto &
  AdminProjectsControllerGetProjects200AllOf;

export type AdminProjectsControllerGetProjectDetail200AllOf = {
  data?: AdminProjectDetailResponseDto;
};

export type AdminProjectsControllerGetProjectDetail200 = BaseResponseDto &
  AdminProjectsControllerGetProjectDetail200AllOf;

export type AdminProjectsControllerDeleteProject200AllOfData = {
  [key: string]: unknown;
};

export type AdminProjectsControllerDeleteProject200AllOf = {
  data?: AdminProjectsControllerDeleteProject200AllOfData;
};

export type AdminProjectsControllerDeleteProject200 = BaseResponseDto &
  AdminProjectsControllerDeleteProject200AllOf;

export type AdminProjectsControllerTranslateTradeProject200AllOf = {
  data?: AdminTradeTranslationDto;
};

export type AdminProjectsControllerTranslateTradeProject200 = BaseResponseDto &
  AdminProjectsControllerTranslateTradeProject200AllOf;

export type AdminProjectsControllerGetMatchCandidatesParams = {
  /**
   * 이미 매칭된 줄도 다시 판정한다. 기본 false(미매칭 물품 줄만).
   */
  includeMatched?: boolean;
  /**
   * 줄당 후보 수(1~10, 기본 3)
   */
  limit?: number;
};

export type AdminProjectsControllerGetMatchCandidates200AllOf = {
  data?: QuoteLineMatchResultDto[];
};

export type AdminProjectsControllerGetMatchCandidates200 = BaseResponseDto &
  AdminProjectsControllerGetMatchCandidates200AllOf;

export type AdminProjectsControllerMatchItem200AllOf = {
  data?: AdminMatchItemResponseDto;
};

export type AdminProjectsControllerMatchItem200 = BaseResponseDto &
  AdminProjectsControllerMatchItem200AllOf;

export type AdminProjectsControllerRegisterAndMatchItem200AllOf = {
  data?: AdminRegisterAndMatchItemResponseDto;
};

export type AdminProjectsControllerRegisterAndMatchItem200 = BaseResponseDto &
  AdminProjectsControllerRegisterAndMatchItem200AllOf;

export type AdminProjectsControllerGetQuotedPrices200AllOf = {
  data?: AdminQuotedPriceLineDto[];
};

export type AdminProjectsControllerGetQuotedPrices200 = BaseResponseDto &
  AdminProjectsControllerGetQuotedPrices200AllOf;

export type AdminProjectsControllerLinkQuotedPrice200AllOf = {
  data?: AdminLinkQuotedPriceResponseDto;
};

export type AdminProjectsControllerLinkQuotedPrice200 = BaseResponseDto &
  AdminProjectsControllerLinkQuotedPrice200AllOf;

export type AdminProjectsControllerExtendDeadline200AllOf = {
  data?: AdminExtendDeadlineResponseDto;
};

export type AdminProjectsControllerExtendDeadline200 = BaseResponseDto &
  AdminProjectsControllerExtendDeadline200AllOf;

export type AdminProjectsControllerCloseProject200AllOf = {
  data?: AdminCloseProjectResponseDto;
};

export type AdminProjectsControllerCloseProject200 = BaseResponseDto &
  AdminProjectsControllerCloseProject200AllOf;

export type AdminProjectsControllerSubmitAgencyQuote201AllOf = {
  data?: AdminAgencyQuoteSubmissionResponseDto;
};

export type AdminProjectsControllerSubmitAgencyQuote201 = BaseResponseDto &
  AdminProjectsControllerSubmitAgencyQuote201AllOf;

export type AdminProjectsControllerSetTransactionModel200AllOf = {
  data?: AdminTransactionModelResponseDto;
};

export type AdminProjectsControllerSetTransactionModel200 = BaseResponseDto &
  AdminProjectsControllerSetTransactionModel200AllOf;

export type AdminProjectsControllerTriggerAutoQuotes200AllOf = {
  data?: AdminTriggerAutoQuotesResponseDto;
};

export type AdminProjectsControllerTriggerAutoQuotes200 = BaseResponseDto &
  AdminProjectsControllerTriggerAutoQuotes200AllOf;

export type AdminProjectsControllerGetSimilarSuppliers200AllOf = {
  data?: AdminSimilarSuppliersResponseDto;
};

export type AdminProjectsControllerGetSimilarSuppliers200 = BaseResponseDto &
  AdminProjectsControllerGetSimilarSuppliers200AllOf;

export type AdminProjectsControllerGetSupplierNotifications200AllOf = {
  data?: AdminSupplierNotificationListDto;
};

export type AdminProjectsControllerGetSupplierNotifications200 =
  BaseResponseDto & AdminProjectsControllerGetSupplierNotifications200AllOf;

export type AdminProjectsControllerNotifySimilarSuppliers200AllOf = {
  data?: AdminNotifySimilarSuppliersResultDto;
};

export type AdminProjectsControllerNotifySimilarSuppliers200 = BaseResponseDto &
  AdminProjectsControllerNotifySimilarSuppliers200AllOf;

export type AdminProjectsControllerGetProjectNotes200AllOf = {
  data?: AdminProjectNoteListResponseDto;
};

export type AdminProjectsControllerGetProjectNotes200 = BaseResponseDto &
  AdminProjectsControllerGetProjectNotes200AllOf;

export type AdminProjectsControllerCreateProjectNote200AllOf = {
  data?: AdminProjectNoteResponseDto;
};

export type AdminProjectsControllerCreateProjectNote200 = BaseResponseDto &
  AdminProjectsControllerCreateProjectNote200AllOf;

export type AdminProjectsControllerDeleteProjectNote200AllOfData = {
  [key: string]: unknown;
};

export type AdminProjectsControllerDeleteProjectNote200AllOf = {
  data?: AdminProjectsControllerDeleteProjectNote200AllOfData;
};

export type AdminProjectsControllerDeleteProjectNote200 = BaseResponseDto &
  AdminProjectsControllerDeleteProjectNote200AllOf;

export type AdminProjectsControllerHideParticipation200AllOf = {
  data?: AdminParticipationVisibilityResponseDto;
};

export type AdminProjectsControllerHideParticipation200 = BaseResponseDto &
  AdminProjectsControllerHideParticipation200AllOf;

export type AdminProjectsControllerUnhideParticipation200AllOf = {
  data?: AdminParticipationVisibilityResponseDto;
};

export type AdminProjectsControllerUnhideParticipation200 = BaseResponseDto &
  AdminProjectsControllerUnhideParticipation200AllOf;

export type AdminProjectsControllerDeleteParticipation200AllOf = {
  data?: AdminParticipationDeletionResponseDto;
};

export type AdminProjectsControllerDeleteParticipation200 = BaseResponseDto &
  AdminProjectsControllerDeleteParticipation200AllOf;

export type AdminProjectsControllerRestoreProject200AllOfData = {
  [key: string]: unknown;
};

export type AdminProjectsControllerRestoreProject200AllOf = {
  data?: AdminProjectsControllerRestoreProject200AllOfData;
};

export type AdminProjectsControllerRestoreProject200 = BaseResponseDto &
  AdminProjectsControllerRestoreProject200AllOf;

export type AdminSettlementControllerExportHometaxParams = {
  status?: string;
  paymentMethod?: string;
  startDate?: string;
  endDate?: string;
  searchTerm?: string;
};

export type AdminSettlementControllerGetSettlementsParams = {
  status?: string;
  paymentMethod?: string;
  searchTerm?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  page?: number;
};

export type AdminSettlementControllerGetSettlements200AllOfData = {
  items: AdminSettlementResponseDto[];
  meta: PaginationMetaDto;
};

export type AdminSettlementControllerGetSettlements200AllOf = {
  data?: AdminSettlementControllerGetSettlements200AllOfData;
};

export type AdminSettlementControllerGetSettlements200 = BaseResponseDto &
  AdminSettlementControllerGetSettlements200AllOf;

export type AdminSettlementControllerGetStatsParams = {
  status?: string;
  searchTerm?: string;
  startDate?: string;
  endDate?: string;
};

export type AdminSettlementControllerGetStats200AllOf = {
  data?: SettlementStatsResponseDto;
};

export type AdminSettlementControllerGetStats200 = BaseResponseDto &
  AdminSettlementControllerGetStats200AllOf;

export type AdminSettlementControllerGetMonthlySummaryParams = {
  startDate?: string;
  endDate?: string;
};

export type AdminSettlementControllerGetMonthlySummary200AllOf = {
  data?: SettlementMonthlySummaryResponseDto;
};

export type AdminSettlementControllerGetMonthlySummary200 = BaseResponseDto &
  AdminSettlementControllerGetMonthlySummary200AllOf;

export type AdminSettlementControllerGetMonthlyBillingParams = {
  month: string;
  includeIssued?: boolean;
  searchTerm?: string;
  supplierId?: string;
};

export type AdminSettlementControllerGetMonthlyBilling200AllOf = {
  data?: MonthlyBillingResponseDto;
};

export type AdminSettlementControllerGetMonthlyBilling200 = BaseResponseDto &
  AdminSettlementControllerGetMonthlyBilling200AllOf;

export type AdminSettlementControllerExportMonthlyTaxInvoicesParams = {
  month: string;
  includeIssued?: boolean;
  searchTerm?: string;
  /**
   * 쉼표로 구분한 공급기업 ID. 비우면 조회된 전체.
   */
  supplierIds?: string;
};

export type AdminSettlementControllerGetSettlement200AllOf = {
  data?: AdminSettlementResponseDto;
};

export type AdminSettlementControllerGetSettlement200 = BaseResponseDto &
  AdminSettlementControllerGetSettlement200AllOf;

export type AdminContractControllerRecreateDocumentRequestMessage200AllOfData =
  { [key: string]: unknown };

export type AdminContractControllerRecreateDocumentRequestMessage200AllOf = {
  data?: AdminContractControllerRecreateDocumentRequestMessage200AllOfData;
};

export type AdminContractControllerRecreateDocumentRequestMessage200 =
  BaseResponseDto &
    AdminContractControllerRecreateDocumentRequestMessage200AllOf;

export type AdminContractControllerGetContractsParams = {
  /**
   * 계약 상태 (IN_PROGRESS, COMPLETED, CANCELED 등)
   */
  status?: string;
  /**
   * 계약번호 검색
   */
  searchTerm?: string;
  limit?: number;
  offset?: number;
};

export type AdminContractControllerGetContracts200AllOfData = {
  items: AdminContractResponseDto[];
  meta: PaginationMetaDto;
};

export type AdminContractControllerGetContracts200AllOf = {
  data?: AdminContractControllerGetContracts200AllOfData;
};

export type AdminContractControllerGetContracts200 = BaseResponseDto &
  AdminContractControllerGetContracts200AllOf;

export type AdminContractControllerGetContract200AllOf = {
  data?: AdminContractResponseDto;
};

export type AdminContractControllerGetContract200 = BaseResponseDto &
  AdminContractControllerGetContract200AllOf;

export type AdminContractControllerRegeneratePdf200AllOf = {
  data?: RegenerateContractPdfResponseDto;
};

export type AdminContractControllerRegeneratePdf200 = BaseResponseDto &
  AdminContractControllerRegeneratePdf200AllOf;

export type AdminFeePolicyControllerGetPolicy200AllOf = {
  data?: PlatformFeePolicyResponseDto;
};

export type AdminFeePolicyControllerGetPolicy200 = BaseResponseDto &
  AdminFeePolicyControllerGetPolicy200AllOf;

export type AdminFeePolicyControllerUpdatePolicy200AllOf = {
  data?: PlatformFeePolicyResponseDto;
};

export type AdminFeePolicyControllerUpdatePolicy200 = BaseResponseDto &
  AdminFeePolicyControllerUpdatePolicy200AllOf;

export type AdminMatchingControllerGetMetricsParams = {
  /**
   * 집계 기간(일, 기본 14, 최대 180)
   */
  days?: string;
};

export type AdminTermsControllerCreateTerms201AllOf = {
  data?: AdminTermsResponseDto;
};

export type AdminTermsControllerCreateTerms201 = BaseResponseDto &
  AdminTermsControllerCreateTerms201AllOf;

export type AdminTermsControllerGetAllTerms200AllOf = {
  data?: AdminTermsResponseDto[];
};

export type AdminTermsControllerGetAllTerms200 = BaseResponseDto &
  AdminTermsControllerGetAllTerms200AllOf;

export type AdminTermsControllerGetTermsById200AllOf = {
  data?: AdminTermsResponseDto;
};

export type AdminTermsControllerGetTermsById200 = BaseResponseDto &
  AdminTermsControllerGetTermsById200AllOf;

export type AdminTermsControllerUpdateTerms200AllOf = {
  data?: AdminTermsResponseDto;
};

export type AdminTermsControllerUpdateTerms200 = BaseResponseDto &
  AdminTermsControllerUpdateTerms200AllOf;

export type AdminPromotionControllerCreate201AllOf = {
  data?: PromotionCodeDto;
};

export type AdminPromotionControllerCreate201 = BaseResponseDto &
  AdminPromotionControllerCreate201AllOf;

export type AdminPromotionControllerFindAllParams = {
  offset?: number;
  limit?: number;
};

export type AdminPromotionControllerFindAll200AllOfData = {
  items: PromotionCodeDto[];
  meta: PaginationMetaDto;
};

export type AdminPromotionControllerFindAll200AllOf = {
  data?: AdminPromotionControllerFindAll200AllOfData;
};

export type AdminPromotionControllerFindAll200 = BaseResponseDto &
  AdminPromotionControllerFindAll200AllOf;

export type AdminPromotionControllerFindOne200AllOf = {
  data?: PromotionCodeDto;
};

export type AdminPromotionControllerFindOne200 = BaseResponseDto &
  AdminPromotionControllerFindOne200AllOf;

export type AdminPromotionControllerUpdate200AllOf = {
  data?: PromotionCodeDto;
};

export type AdminPromotionControllerUpdate200 = BaseResponseDto &
  AdminPromotionControllerUpdate200AllOf;

export type AdminPromotionControllerGetRedemptionHistoryParams = {
  offset?: number;
  limit?: number;
};

export type AdminPromotionControllerGetRedemptionHistory200AllOfData = {
  items: PromotionRedemptionDto[];
  meta: PaginationMetaDto;
};

export type AdminPromotionControllerGetRedemptionHistory200AllOf = {
  data?: AdminPromotionControllerGetRedemptionHistory200AllOfData;
};

export type AdminPromotionControllerGetRedemptionHistory200 = BaseResponseDto &
  AdminPromotionControllerGetRedemptionHistory200AllOf;

export type AdminAgencyPartyControllerGet200AllOf = {
  data?: AdminAgencyPartyDto;
};

export type AdminAgencyPartyControllerGet200 = BaseResponseDto &
  AdminAgencyPartyControllerGet200AllOf;

export type AdminAgencyPartyControllerSet200AllOf = {
  data?: AdminAgencyPartyDto;
};

export type AdminAgencyPartyControllerSet200 = BaseResponseDto &
  AdminAgencyPartyControllerSet200AllOf;

export type AdminAgencyPartyControllerClear200AllOf = {
  data?: AdminAgencyPartyDto;
};

export type AdminAgencyPartyControllerClear200 = BaseResponseDto &
  AdminAgencyPartyControllerClear200AllOf;

export type AdminAgencyPayoutsControllerListParams = {
  /**
   * 지급 상태
   */
  status?: AdminAgencyPayoutsControllerListStatus;
  /**
   * 공급기업 id (users.id)
   */
  supplierId?: string;
  page?: number;
  limit?: number;
};

export type AdminAgencyPayoutsControllerListStatus =
  (typeof AdminAgencyPayoutsControllerListStatus)[keyof typeof AdminAgencyPayoutsControllerListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminAgencyPayoutsControllerListStatus = {
  scheduled: "scheduled",
  on_hold: "on_hold",
  paid: "paid",
  failed: "failed",
  canceled: "canceled",
} as const;

export type AdminAgencyPayoutsControllerList200AllOfData = {
  items: AdminPayoutDto[];
  meta: PaginationMetaDto;
};

export type AdminAgencyPayoutsControllerList200AllOf = {
  data?: AdminAgencyPayoutsControllerList200AllOfData;
};

export type AdminAgencyPayoutsControllerList200 = BaseResponseDto &
  AdminAgencyPayoutsControllerList200AllOf;

export type AdminAgencyPayoutsControllerBalance200AllOf = {
  data?: AdminPayoutBalanceDto;
};

export type AdminAgencyPayoutsControllerBalance200 = BaseResponseDto &
  AdminAgencyPayoutsControllerBalance200AllOf;

export type AdminAgencyPayoutsControllerMarkPaid200AllOf = {
  data?: AdminPayoutDto;
};

export type AdminAgencyPayoutsControllerMarkPaid200 = BaseResponseDto &
  AdminAgencyPayoutsControllerMarkPaid200AllOf;

export type AdminAgencyPayoutsControllerHold200AllOf = {
  data?: AdminPayoutDto;
};

export type AdminAgencyPayoutsControllerHold200 = BaseResponseDto &
  AdminAgencyPayoutsControllerHold200AllOf;

export type ControlTowerControllerListParams = {
  code?: ControlTowerControllerListCode;
  severity?: ControlTowerControllerListSeverity;
  limit?: number;
  offset?: number;
};

export type ControlTowerControllerListCode =
  (typeof ControlTowerControllerListCode)[keyof typeof ControlTowerControllerListCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ControlTowerControllerListCode = {
  unmatched_items: "unmatched_items",
  no_supplier_pool: "no_supplier_pool",
  no_quotes_untouched: "no_quotes_untouched",
  no_quotes_after_outreach: "no_quotes_after_outreach",
  auto_quote_broken: "auto_quote_broken",
  status_stale: "status_stale",
} as const;

export type ControlTowerControllerListSeverity =
  (typeof ControlTowerControllerListSeverity)[keyof typeof ControlTowerControllerListSeverity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ControlTowerControllerListSeverity = {
  warning: "warning",
  critical: "critical",
} as const;

export type ControlTowerControllerList200AllOf = {
  data?: ControlTowerListResponseDto;
};

export type ControlTowerControllerList200 = BaseResponseDto &
  ControlTowerControllerList200AllOf;

export type ControlTowerControllerSummary200AllOf = {
  data?: ControlTowerSummaryResponseDto;
};

export type ControlTowerControllerSummary200 = BaseResponseDto &
  ControlTowerControllerSummary200AllOf;

export type ControlTowerControllerAcknowledge200AllOf = {
  data?: null;
};

export type ControlTowerControllerAcknowledge200 = BaseResponseDto &
  ControlTowerControllerAcknowledge200AllOf;

export type ControlTowerControllerSnooze200AllOf = {
  data?: null;
};

export type ControlTowerControllerSnooze200 = BaseResponseDto &
  ControlTowerControllerSnooze200AllOf;

export type ControlTowerControllerScan200AllOf = {
  data?: ControlTowerScanResultDto;
};

export type ControlTowerControllerScan200 = BaseResponseDto &
  ControlTowerControllerScan200AllOf;

export type StorageControllerUploadTemporaryFilesBody = {
  /**
   * 업로드할 파일 (최대 10개, 각 파일 최대 20MB)
   * @maxItems 10
   */
  files: Blob[];
};

export type StorageControllerUploadTemporaryFiles201AllOf = {
  data?: TemporaryFileUploadResponseDto;
};

export type StorageControllerUploadTemporaryFiles201 = BaseResponseDto &
  StorageControllerUploadTemporaryFiles201AllOf;

export type ExternalSuppliersControllerAuthenticateSupplier201AllOf = {
  data?: AuthSupplierResponseDto;
};

export type ExternalSuppliersControllerAuthenticateSupplier201 =
  BaseResponseDto & ExternalSuppliersControllerAuthenticateSupplier201AllOf;

export type ExternalSuppliersControllerGetSupplierSettings200AllOf = {
  data?: SupplierSettingsDto;
};

export type ExternalSuppliersControllerGetSupplierSettings200 =
  BaseResponseDto & ExternalSuppliersControllerGetSupplierSettings200AllOf;

export type ExternalBuyersControllerAuthenticateBuyer201AllOf = {
  data?: AuthBuyerResponseDto;
};

export type ExternalBuyersControllerAuthenticateBuyer201 = BaseResponseDto &
  ExternalBuyersControllerAuthenticateBuyer201AllOf;

export type ExternalEmbedControllerVerifyEmbedToken200AllOf = {
  data?: EmbedTokenVerifyResponseDto;
};

export type ExternalEmbedControllerVerifyEmbedToken200 = BaseResponseDto &
  ExternalEmbedControllerVerifyEmbedToken200AllOf;

export type ExternalEmbedControllerGenerateAlimTalkLinks201AllOf = {
  data?: GenerateAlimTalkLinksResponseDto;
};

export type ExternalEmbedControllerGenerateAlimTalkLinks201 = BaseResponseDto &
  ExternalEmbedControllerGenerateAlimTalkLinks201AllOf;

export type ExternalEmbedControllerGetEmbedUrl201AllOf = {
  data?: EmbedJoinResponseDto;
};

export type ExternalEmbedControllerGetEmbedUrl201 = BaseResponseDto &
  ExternalEmbedControllerGetEmbedUrl201AllOf;

export type ExternalCategoriesControllerGetCategoryTreeParams = {
  /**
   * 조회 모드
   */
  mode?: ExternalCategoriesControllerGetCategoryTreeMode;
};

export type ExternalCategoriesControllerGetCategoryTreeMode =
  (typeof ExternalCategoriesControllerGetCategoryTreeMode)[keyof typeof ExternalCategoriesControllerGetCategoryTreeMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalCategoriesControllerGetCategoryTreeMode = {
  all: "all",
  dealing: "dealing",
} as const;

export type ExternalCategoriesControllerGetCategoryTree200AllOf = {
  data?: CategoryTreeNodeDto[];
};

export type ExternalCategoriesControllerGetCategoryTree200 = BaseResponseDto &
  ExternalCategoriesControllerGetCategoryTree200AllOf;

export type ExternalItemsControllerGetItemsParams = {
  /**
   * 조회 개수 (기본 20)
   */
  limit?: number;
  /**
   * 페이지네이션 오프셋 (기본 0)
   */
  offset?: number;
  /**
   * 카테고리 ID
   */
  categoryId?: string;
  /**
   * 하위 카테고리 포함 여부 (기본 true)
   */
  includeDescendants?: boolean;
  /**
   * 내 상품만 보기 여부
   */
  onlyMyProducts?: boolean;
  /**
   * 내 취급 카테고리 상품만 보기 여부
   */
  onlyMyCategories?: boolean;
  /**
   * 판매상태 필터. 지정하면 내 상품 범위로 좁혀서 조회한다(판매 여부는 내가 등재한 물품에만 있는 성질이라서).
   */
  sellingStatus?: ExternalItemsControllerGetItemsSellingStatus;
  /**
   * 검색어 (상품명, 브랜드, 코드 등)
   */
  search?: string;
  /**
   * 정렬 기준
   */
  sortBy?: ExternalItemsControllerGetItemsSortBy;
  /**
   * 정렬 순서
   */
  sortOrder?: ExternalItemsControllerGetItemsSortOrder;
};

export type ExternalItemsControllerGetItemsSellingStatus =
  (typeof ExternalItemsControllerGetItemsSellingStatus)[keyof typeof ExternalItemsControllerGetItemsSellingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalItemsControllerGetItemsSellingStatus = {
  all: "all",
  selling: "selling",
  stopped: "stopped",
} as const;

export type ExternalItemsControllerGetItemsSortBy =
  (typeof ExternalItemsControllerGetItemsSortBy)[keyof typeof ExternalItemsControllerGetItemsSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalItemsControllerGetItemsSortBy = {
  name: "name",
  price: "price",
  updated_at: "updated_at",
  supplier_count: "supplier_count",
} as const;

export type ExternalItemsControllerGetItemsSortOrder =
  (typeof ExternalItemsControllerGetItemsSortOrder)[keyof typeof ExternalItemsControllerGetItemsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalItemsControllerGetItemsSortOrder = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type ExternalItemsControllerGetItems200AllOfData = {
  items: SupplierCategoryItemDto[];
  meta: PaginationMetaDto;
};

export type ExternalItemsControllerGetItems200AllOf = {
  data?: ExternalItemsControllerGetItems200AllOfData;
};

export type ExternalItemsControllerGetItems200 = BaseResponseDto &
  ExternalItemsControllerGetItems200AllOf;

export type ExternalItemsControllerUpdateSettings200AllOf = {
  data?: SupplierPriceResponseDto;
};

export type ExternalItemsControllerUpdateSettings200 = BaseResponseDto &
  ExternalItemsControllerUpdateSettings200AllOf;

export type ExternalItemsControllerResubmitRequest200AllOf = {
  data?: SupplierItemRequestResponseDto;
};

export type ExternalItemsControllerResubmitRequest200 = BaseResponseDto &
  ExternalItemsControllerResubmitRequest200AllOf;

export type ExternalItemsControllerCreateRequest201AllOf = {
  data?: SupplierItemRequestResponseDto;
};

export type ExternalItemsControllerCreateRequest201 = BaseResponseDto &
  ExternalItemsControllerCreateRequest201AllOf;

export type ExternalItemsControllerGetMyRequestsParams = {
  /**
   * 조회 개수 (기본 20)
   */
  limit?: number;
  /**
   * 페이지네이션 오프셋 (기본 0)
   */
  offset?: number;
  /**
   * 카테고리 ID
   */
  categoryId?: string;
  /**
   * 하위 카테고리 포함 여부 (기본 true)
   */
  includeDescendants?: boolean;
  /**
   * 내 상품만 보기 여부
   */
  onlyMyProducts?: boolean;
  /**
   * 내 취급 카테고리 상품만 보기 여부
   */
  onlyMyCategories?: boolean;
  /**
   * 판매상태 필터. 지정하면 내 상품 범위로 좁혀서 조회한다(판매 여부는 내가 등재한 물품에만 있는 성질이라서).
   */
  sellingStatus?: ExternalItemsControllerGetMyRequestsSellingStatus;
  /**
   * 검색어 (상품명, 브랜드, 코드 등)
   */
  search?: string;
  /**
   * 정렬 기준
   */
  sortBy?: ExternalItemsControllerGetMyRequestsSortBy;
  /**
   * 정렬 순서
   */
  sortOrder?: ExternalItemsControllerGetMyRequestsSortOrder;
};

export type ExternalItemsControllerGetMyRequestsSellingStatus =
  (typeof ExternalItemsControllerGetMyRequestsSellingStatus)[keyof typeof ExternalItemsControllerGetMyRequestsSellingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalItemsControllerGetMyRequestsSellingStatus = {
  all: "all",
  selling: "selling",
  stopped: "stopped",
} as const;

export type ExternalItemsControllerGetMyRequestsSortBy =
  (typeof ExternalItemsControllerGetMyRequestsSortBy)[keyof typeof ExternalItemsControllerGetMyRequestsSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalItemsControllerGetMyRequestsSortBy = {
  name: "name",
  price: "price",
  updated_at: "updated_at",
  supplier_count: "supplier_count",
} as const;

export type ExternalItemsControllerGetMyRequestsSortOrder =
  (typeof ExternalItemsControllerGetMyRequestsSortOrder)[keyof typeof ExternalItemsControllerGetMyRequestsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalItemsControllerGetMyRequestsSortOrder = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type ExternalItemsControllerGetMyRequests200AllOfData = {
  items: SupplierItemRequestResponseDto[];
  meta: PaginationMetaDto;
};

export type ExternalItemsControllerGetMyRequests200AllOf = {
  data?: ExternalItemsControllerGetMyRequests200AllOfData;
};

export type ExternalItemsControllerGetMyRequests200 = BaseResponseDto &
  ExternalItemsControllerGetMyRequests200AllOf;

export type ExternalItemsControllerUploadEditRequestImageBody = {
  /** 물품 사진 (JPG, PNG, GIF, WEBP, BMP / 최대 5MB) */
  file: Blob;
};

export type ExternalItemsControllerUploadEditRequestImage201AllOf = {
  data?: SupplierItemImageUploadResponseDto;
};

export type ExternalItemsControllerUploadEditRequestImage201 = BaseResponseDto &
  ExternalItemsControllerUploadEditRequestImage201AllOf;

export type ExternalItemsControllerGetMyEditRequestsParams = {
  limit?: number;
  offset?: number;
  status?: ExternalItemsControllerGetMyEditRequestsStatus;
};

export type ExternalItemsControllerGetMyEditRequestsStatus =
  (typeof ExternalItemsControllerGetMyEditRequestsStatus)[keyof typeof ExternalItemsControllerGetMyEditRequestsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalItemsControllerGetMyEditRequestsStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  needs_info: "needs_info",
} as const;

export type ExternalItemsControllerGetMyEditRequests200AllOfData = {
  items: SupplierItemEditRequestResponseDto[];
  meta: PaginationMetaDto;
};

export type ExternalItemsControllerGetMyEditRequests200AllOf = {
  data?: ExternalItemsControllerGetMyEditRequests200AllOfData;
};

export type ExternalItemsControllerGetMyEditRequests200 = BaseResponseDto &
  ExternalItemsControllerGetMyEditRequests200AllOf;

export type ExternalItemsControllerResubmitEditRequest200AllOf = {
  data?: SupplierItemEditRequestResponseDto;
};

export type ExternalItemsControllerResubmitEditRequest200 = BaseResponseDto &
  ExternalItemsControllerResubmitEditRequest200AllOf;

export type ExternalItemsControllerCreateEditRequest201AllOf = {
  data?: SupplierItemEditRequestResponseDto;
};

export type ExternalItemsControllerCreateEditRequest201 = BaseResponseDto &
  ExternalItemsControllerCreateEditRequest201AllOf;

export type ExternalStockControllerCreateTransactions200AllOf = {
  data?: StockBatchResultDto;
};

export type ExternalStockControllerCreateTransactions200 = BaseResponseDto &
  ExternalStockControllerCreateTransactions200AllOf;

export type ExternalStockControllerListTransactionsParams = {
  /**
   * 이 품목만
   */
  itemId?: string;
  kind?: ExternalStockControllerListTransactionsKind;
  /**
   * 거래일 시작 YYYY-MM-DD
   */
  from?: string;
  /**
   * 거래일 끝 YYYY-MM-DD
   */
  to?: string;
  /**
   * 최대 200, 기본 50
   */
  limit?: number;
  /**
   * 이전 응답의 nextCursor
   */
  cursor?: string;
};

export type ExternalStockControllerListTransactionsKind =
  (typeof ExternalStockControllerListTransactionsKind)[keyof typeof ExternalStockControllerListTransactionsKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalStockControllerListTransactionsKind = {
  IN: "IN",
  OUT: "OUT",
  ADJUST: "ADJUST",
  CANCEL: "CANCEL",
} as const;

export type ExternalStockControllerListTransactions200AllOf = {
  data?: StockHistoryPageDto;
};

export type ExternalStockControllerListTransactions200 = BaseResponseDto &
  ExternalStockControllerListTransactions200AllOf;

export type ExternalStockControllerPreviewTransactions200AllOf = {
  data?: StockBatchResultDto;
};

export type ExternalStockControllerPreviewTransactions200 = BaseResponseDto &
  ExternalStockControllerPreviewTransactions200AllOf;

export type ExternalStockControllerCancelTransaction200AllOf = {
  data?: StockTransactionDto;
};

export type ExternalStockControllerCancelTransaction200 = BaseResponseDto &
  ExternalStockControllerCancelTransaction200AllOf;

export type ExternalStockControllerPriceContext200AllOf = {
  data?: PriceContextDto;
};

export type ExternalStockControllerPriceContext200 = BaseResponseDto &
  ExternalStockControllerPriceContext200AllOf;

export type ExternalItemSearchControllerMatch200AllOf = {
  data?: QuoteLineMatchResultDto[];
};

export type ExternalItemSearchControllerMatch200 = BaseResponseDto &
  ExternalItemSearchControllerMatch200AllOf;

export type ExternalItemSearchControllerSearchParams = {
  /**
   * 검색어 (최소 2글자)
   * @minLength 2
   */
  q: string;
  /**
   * 결과 개수 (기본: 10, 최대: 50)
   * @minimum 1
   * @maximum 50
   */
  limit?: number;
  /**
   * 결과 오프셋 (기본: 0). limit 상한(50) 너머로 페이징할 때 사용 — offset=50 이면 51번째부터 반환한다. 응답은 그대로 배열이며, 반환 건수가 limit 과 같으면 다음 페이지가 있을 수 있다.
   * @minimum 0
   */
  offset?: number;
  /**
   * 공급사 ID (선택사항 - 공급사별 단가 조회 시 필요)
   */
  supplierId?: string;
  /**
   * 카테고리 ID 필터 (선택사항). 지정 시 해당 카테고리 품목만 검색한다. 쉼표 구분 또는 반복 쿼리 파라미터(categoryIds=a&categoryIds=b) 모두 허용.
   */
  categoryIds?: string[];
  /**
   * 정렬 기준
   */
  sortBy?: ItemV2SortBy;
  /**
   * 정렬 순서
   */
  sortOrder?: ExternalItemSearchControllerSearchSortOrder;
  /**
   * 카탈로그 epoch 필터. legacy=2026-05-19 이전 등록 품목, v2=이후 등록 품목. 미지정 시 전체.
   */
  catalogEpoch?: ItemV2CatalogEpoch;
};

export type ExternalItemSearchControllerSearchSortOrder =
  (typeof ExternalItemSearchControllerSearchSortOrder)[keyof typeof ExternalItemSearchControllerSearchSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalItemSearchControllerSearchSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ExternalItemSearchControllerSearch200AllOf = {
  data?: ItemV2AutocompleteResponseDto[];
};

export type ExternalItemSearchControllerSearch200 = BaseResponseDto &
  ExternalItemSearchControllerSearch200AllOf;

export type ExternalStorefrontControllerGetItemsParams = {
  /**
   * 상품명·제조사 검색
   */
  q?: string;
  /**
   * 소분류(말단) 한정
   */
  categoryId?: string;
  /**
   * 대분류 한정. 쇼핑몰의 대분류 탭이 이 값으로 서버 조회를 한 번 한다
   */
  rootCategoryId?: string;
  /**
   * 기본은 카테고리→품명. 목록을 잘라 받을 때 정렬은 서버 몫이다
   */
  sort?: ExternalStorefrontControllerGetItemsSort;
  offset?: unknown;
  limit?: unknown;
};

export type ExternalStorefrontControllerGetItemsSort =
  (typeof ExternalStorefrontControllerGetItemsSort)[keyof typeof ExternalStorefrontControllerGetItemsSort];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalStorefrontControllerGetItemsSort = {
  recommended: "recommended",
  price_asc: "price_asc",
  price_desc: "price_desc",
  name: "name",
} as const;

export type ExternalStorefrontControllerGetItems200AllOf = {
  data?: StorefrontItemListResponseDto;
};

export type ExternalStorefrontControllerGetItems200 = BaseResponseDto &
  ExternalStorefrontControllerGetItems200AllOf;

export type ExternalStorefrontControllerGetCategories200AllOf = {
  data?: StorefrontCategoryListResponseDto;
};

export type ExternalStorefrontControllerGetCategories200 = BaseResponseDto &
  ExternalStorefrontControllerGetCategories200AllOf;

export type ExternalStorefrontControllerGetItem200AllOf = {
  data?: StorefrontItemResponseDto;
};

export type ExternalStorefrontControllerGetItem200 = BaseResponseDto &
  ExternalStorefrontControllerGetItem200AllOf;

export type ExternalStorefrontControllerGetItemOffers200AllOf = {
  data?: StorefrontOfferListResponseDto;
};

export type ExternalStorefrontControllerGetItemOffers200 = BaseResponseDto &
  ExternalStorefrontControllerGetItemOffers200AllOf;

export type ExternalStorefrontOrdersControllerGetPointBalance200AllOf = {
  data?: StorefrontPointBalanceDto;
};

export type ExternalStorefrontOrdersControllerGetPointBalance200 =
  BaseResponseDto & ExternalStorefrontOrdersControllerGetPointBalance200AllOf;

export type ExternalStorefrontOrdersControllerCreateOrder201AllOf = {
  data?: StorefrontOrderDto;
};

export type ExternalStorefrontOrdersControllerCreateOrder201 = BaseResponseDto &
  ExternalStorefrontOrdersControllerCreateOrder201AllOf;

export type ExternalStorefrontOrdersControllerListOrdersParams = {
  employeeNo?: string;
  offset?: unknown;
  limit?: unknown;
};

export type ExternalStorefrontOrdersControllerListOrders200AllOf = {
  data?: StorefrontOrderListDto;
};

export type ExternalStorefrontOrdersControllerListOrders200 = BaseResponseDto &
  ExternalStorefrontOrdersControllerListOrders200AllOf;

export type ExternalStorefrontOrdersControllerGetOrder200AllOf = {
  data?: StorefrontOrderDto;
};

export type ExternalStorefrontOrdersControllerGetOrder200 = BaseResponseDto &
  ExternalStorefrontOrdersControllerGetOrder200AllOf;

export type ExternalStorefrontOrdersControllerApplyRequisition200AllOf = {
  data?: StorefrontOrderDto;
};

export type ExternalStorefrontOrdersControllerApplyRequisition200 =
  BaseResponseDto & ExternalStorefrontOrdersControllerApplyRequisition200AllOf;

export type ExternalStorefrontOrdersControllerGetInspection200AllOf = {
  data?: InspectionDto;
};

export type ExternalStorefrontOrdersControllerGetInspection200 =
  BaseResponseDto & ExternalStorefrontOrdersControllerGetInspection200AllOf;

export type ExternalStorefrontOrdersControllerCompleteInspection200AllOf = {
  data?: StorefrontOrderDto;
};

export type ExternalStorefrontOrdersControllerCompleteInspection200 =
  BaseResponseDto &
    ExternalStorefrontOrdersControllerCompleteInspection200AllOf;

export type ExternalStorefrontOrdersControllerCancelOrder200AllOf = {
  data?: StorefrontOrderDto;
};

export type ExternalStorefrontOrdersControllerCancelOrder200 = BaseResponseDto &
  ExternalStorefrontOrdersControllerCancelOrder200AllOf;

export type ExternalStorefrontPaymentOptionsControllerGetPaymentOptionsParams =
  {
    /**
     * 결제 주체 씨마켓 회원 id. 주문자가 씨마켓 직원(EMPLOYEE)이면 필수 — 소속 회원(SSO companyMemberId)의 카드·포인트를 돌려준다.
     */
    payerMemberId?: unknown;
    ownerKey: unknown;
  };

export type ExternalStorefrontPaymentOptionsControllerGetPaymentOptions200AllOf =
  {
    data?: StorefrontPaymentOptionsDto;
  };

export type ExternalStorefrontPaymentOptionsControllerGetPaymentOptions200 =
  BaseResponseDto &
    ExternalStorefrontPaymentOptionsControllerGetPaymentOptions200AllOf;

export type ExternalStorefrontQuotesControllerCreateQuote201AllOf = {
  data?: StorefrontQuoteDto;
};

export type ExternalStorefrontQuotesControllerCreateQuote201 = BaseResponseDto &
  ExternalStorefrontQuotesControllerCreateQuote201AllOf;

export type ExternalStorefrontQuotesControllerListQuotesParams = {
  offset?: unknown;
  limit?: unknown;
  ownerKey: unknown;
};

export type ExternalStorefrontQuotesControllerListQuotes200AllOf = {
  data?: StorefrontQuoteListDto;
};

export type ExternalStorefrontQuotesControllerListQuotes200 = BaseResponseDto &
  ExternalStorefrontQuotesControllerListQuotes200AllOf;

export type ExternalStorefrontQuotesControllerGetQuoteParams = {
  ownerKey: unknown;
};

export type ExternalStorefrontQuotesControllerGetQuote200AllOf = {
  data?: StorefrontQuoteDto;
};

export type ExternalStorefrontQuotesControllerGetQuote200 = BaseResponseDto &
  ExternalStorefrontQuotesControllerGetQuote200AllOf;

export type ExternalStorefrontSubscriptionsControllerListPlans200AllOf = {
  data?: SubscriptionPlanListDto;
};

export type ExternalStorefrontSubscriptionsControllerListPlans200 =
  BaseResponseDto & ExternalStorefrontSubscriptionsControllerListPlans200AllOf;

export type ExternalStorefrontSubscriptionsControllerSubscribe201AllOf = {
  data?: CreateStorefrontSubscriptionResultDto;
};

export type ExternalStorefrontSubscriptionsControllerSubscribe201 =
  BaseResponseDto & ExternalStorefrontSubscriptionsControllerSubscribe201AllOf;

export type ExternalStorefrontSubscriptionsControllerListMineParams = {
  offset?: unknown;
  limit?: unknown;
  ownerKey: unknown;
};

export type ExternalStorefrontSubscriptionsControllerListMine200AllOf = {
  data?: StorefrontSubscriptionListDto;
};

export type ExternalStorefrontSubscriptionsControllerListMine200 =
  BaseResponseDto & ExternalStorefrontSubscriptionsControllerListMine200AllOf;

export type ExternalStorefrontSubscriptionsControllerGetMineParams = {
  ownerKey: unknown;
};

export type ExternalStorefrontSubscriptionsControllerGetMine200AllOf = {
  data?: StorefrontSubscriptionDto;
};

export type ExternalStorefrontSubscriptionsControllerGetMine200 =
  BaseResponseDto & ExternalStorefrontSubscriptionsControllerGetMine200AllOf;

export type ExternalStorefrontSubscriptionsControllerUpdate200AllOf = {
  data?: StorefrontSubscriptionDto;
};

export type ExternalStorefrontSubscriptionsControllerUpdate200 =
  BaseResponseDto & ExternalStorefrontSubscriptionsControllerUpdate200AllOf;

export type ExternalStorefrontSubscriptionsControllerRetryPayment200AllOf = {
  data?: RetryStorefrontSubscriptionPaymentResultDto;
};

export type ExternalStorefrontSubscriptionsControllerRetryPayment200 =
  BaseResponseDto &
    ExternalStorefrontSubscriptionsControllerRetryPayment200AllOf;

export type ExternalStorefrontSubscriptionsControllerPause200AllOf = {
  data?: StorefrontSubscriptionDto;
};

export type ExternalStorefrontSubscriptionsControllerPause200 =
  BaseResponseDto & ExternalStorefrontSubscriptionsControllerPause200AllOf;

export type ExternalStorefrontSubscriptionsControllerResume200AllOf = {
  data?: StorefrontSubscriptionDto;
};

export type ExternalStorefrontSubscriptionsControllerResume200 =
  BaseResponseDto & ExternalStorefrontSubscriptionsControllerResume200AllOf;

export type ExternalStorefrontSubscriptionsControllerCancel200AllOf = {
  data?: StorefrontSubscriptionDto;
};

export type ExternalStorefrontSubscriptionsControllerCancel200 =
  BaseResponseDto & ExternalStorefrontSubscriptionsControllerCancel200AllOf;

export type ExternalSupplierShipmentsControllerListCouriers200AllOf = {
  data?: CourierDto[];
};

export type ExternalSupplierShipmentsControllerListCouriers200 =
  BaseResponseDto & ExternalSupplierShipmentsControllerListCouriers200AllOf;

export type ExternalSupplierShipmentsControllerListMyTargets200AllOf = {
  data?: SupplierShipmentTargetDto[];
};

export type ExternalSupplierShipmentsControllerListMyTargets200 =
  BaseResponseDto & ExternalSupplierShipmentsControllerListMyTargets200AllOf;

export type ExternalSupplierShipmentsControllerList200AllOf = {
  data?: ShipmentDto[];
};

export type ExternalSupplierShipmentsControllerList200 = BaseResponseDto &
  ExternalSupplierShipmentsControllerList200AllOf;

export type ExternalSupplierShipmentsControllerRegister201AllOf = {
  data?: ShipmentDto;
};

export type ExternalSupplierShipmentsControllerRegister201 = BaseResponseDto &
  ExternalSupplierShipmentsControllerRegister201AllOf;

export type ExternalSupplierShipmentsControllerFindMallOrder200AllOf = {
  data?: QuoteRequestMallOrderDto;
};

export type ExternalSupplierShipmentsControllerFindMallOrder200 =
  BaseResponseDto & ExternalSupplierShipmentsControllerFindMallOrder200AllOf;

export type ExternalSupplierShipmentsControllerRegisterBulk200AllOf = {
  data?: ShipmentBulkRegisterResultDto;
};

export type ExternalSupplierShipmentsControllerRegisterBulk200 =
  BaseResponseDto & ExternalSupplierShipmentsControllerRegisterBulk200AllOf;

export type ExternalSupplierShipmentsControllerUpdateStatus200AllOf = {
  data?: ShipmentDto;
};

export type ExternalSupplierShipmentsControllerUpdateStatus200 =
  BaseResponseDto & ExternalSupplierShipmentsControllerUpdateStatus200AllOf;

export type ExternalSupplierMallUnitsControllerListParams = {
  status?: ExternalSupplierMallUnitsControllerListStatus;
  offset?: unknown;
  limit?: unknown;
};

export type ExternalSupplierMallUnitsControllerListStatus =
  (typeof ExternalSupplierMallUnitsControllerListStatus)[keyof typeof ExternalSupplierMallUnitsControllerListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalSupplierMallUnitsControllerListStatus = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
  CANCELED: "CANCELED",
} as const;

export type ExternalSupplierMallUnitsControllerList200AllOf = {
  data?: MallUnitListDto;
};

export type ExternalSupplierMallUnitsControllerList200 = BaseResponseDto &
  ExternalSupplierMallUnitsControllerList200AllOf;

export type ExternalSupplierMallUnitsControllerGet200AllOf = {
  data?: MallUnitDto;
};

export type ExternalSupplierMallUnitsControllerGet200 = BaseResponseDto &
  ExternalSupplierMallUnitsControllerGet200AllOf;

export type ExternalSupplierMallUnitsControllerAccept200AllOf = {
  data?: MallUnitDto;
};

export type ExternalSupplierMallUnitsControllerAccept200 = BaseResponseDto &
  ExternalSupplierMallUnitsControllerAccept200AllOf;

export type ExternalSupplierMallUnitsControllerDecline200AllOf = {
  data?: MallUnitDto;
};

export type ExternalSupplierMallUnitsControllerDecline200 = BaseResponseDto &
  ExternalSupplierMallUnitsControllerDecline200AllOf;

export type ExternalSupplierStorefrontsControllerListMine200AllOf = {
  data?: MyStorefrontDto[];
};

export type ExternalSupplierStorefrontsControllerListMine200 = BaseResponseDto &
  ExternalSupplierStorefrontsControllerListMine200AllOf;

export type ExternalSupplierStorefrontsControllerListMyPricesParams = {
  /**
   * 쉼표로 구분한 품목 UUID 목록
   */
  itemIds: string;
};

export type ExternalSupplierStorefrontsControllerListMyPrices200AllOf = {
  data?: MyStorefrontPriceDto[];
};

export type ExternalSupplierStorefrontsControllerListMyPrices200 =
  BaseResponseDto & ExternalSupplierStorefrontsControllerListMyPrices200AllOf;

export type ExternalSupplierStorefrontsControllerSetPrice200AllOf = {
  data?: SetStorefrontPriceResultDto;
};

export type ExternalSupplierStorefrontsControllerSetPrice200 = BaseResponseDto &
  ExternalSupplierStorefrontsControllerSetPrice200AllOf;

export type ExternalSupplierStorefrontsControllerListMyOfferingsParams = {
  state?: ExternalSupplierStorefrontsControllerListMyOfferingsState;
  q?: string;
  offset?: unknown;
  limit?: unknown;
};

export type ExternalSupplierStorefrontsControllerListMyOfferingsState =
  (typeof ExternalSupplierStorefrontsControllerListMyOfferingsState)[keyof typeof ExternalSupplierStorefrontsControllerListMyOfferingsState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalSupplierStorefrontsControllerListMyOfferingsState = {
  all: "all",
  listed: "listed",
  unpriced: "unpriced",
  inactive: "inactive",
} as const;

export type ExternalSupplierStorefrontsControllerListMyOfferings200AllOf = {
  data?: MyStorefrontOfferingListDto;
};

export type ExternalSupplierStorefrontsControllerListMyOfferings200 =
  BaseResponseDto &
    ExternalSupplierStorefrontsControllerListMyOfferings200AllOf;

export type ExternalSupplierStorefrontsControllerBulkSetPrices200AllOf = {
  data?: BulkPriceResultDto;
};

export type ExternalSupplierStorefrontsControllerBulkSetPrices200 =
  BaseResponseDto & ExternalSupplierStorefrontsControllerBulkSetPrices200AllOf;

export type ExternalSupplierStorefrontsControllerBulkSetActive200AllOf = {
  data?: BulkActiveResultDto;
};

export type ExternalSupplierStorefrontsControllerBulkSetActive200 =
  BaseResponseDto & ExternalSupplierStorefrontsControllerBulkSetActive200AllOf;

export type ExternalSupplierStorefrontsControllerRequestOffering201AllOf = {
  data?: CreateOfferingRequestResultDto;
};

export type ExternalSupplierStorefrontsControllerRequestOffering201 =
  BaseResponseDto &
    ExternalSupplierStorefrontsControllerRequestOffering201AllOf;

export type ExternalSupplierStorefrontsControllerListMyRequestsParams = {
  status?: string;
  offset?: unknown;
  limit?: unknown;
};

export type ExternalSupplierStorefrontsControllerListMyRequests200AllOf = {
  data?: RequestListResponseDto;
};

export type ExternalSupplierStorefrontsControllerListMyRequests200 =
  BaseResponseDto & ExternalSupplierStorefrontsControllerListMyRequests200AllOf;

export type ExternalFilesControllerUploadTemporaryFilesBody = {
  /**
   * 업로드할 파일 (최대 10개, 각 파일 최대 20MB)
   * @maxItems 10
   */
  files: Blob[];
};

export type ExternalFilesControllerUploadTemporaryFiles201AllOf = {
  data?: TemporaryFileUploadResponseDto;
};

export type ExternalFilesControllerUploadTemporaryFiles201 = BaseResponseDto &
  ExternalFilesControllerUploadTemporaryFiles201AllOf;

export type ExternalQuoteRequestsControllerCreateWithAddress201AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type ExternalQuoteRequestsControllerCreateWithAddress201 =
  BaseResponseDto & ExternalQuoteRequestsControllerCreateWithAddress201AllOf;

export type ExternalQuoteRequestsControllerFindAllParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: ExternalQuoteRequestsControllerFindAllSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 견적 요청 상태 필터
   */
  status?: ExternalQuoteRequestsControllerFindAllStatusItem[];
  /**
   * 마감 여부 필터 (서버 시각 기준)
   */
  isClosed?: boolean;
};

export type ExternalQuoteRequestsControllerFindAllSortOrder =
  (typeof ExternalQuoteRequestsControllerFindAllSortOrder)[keyof typeof ExternalQuoteRequestsControllerFindAllSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalQuoteRequestsControllerFindAllSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ExternalQuoteRequestsControllerFindAllStatusItem =
  (typeof ExternalQuoteRequestsControllerFindAllStatusItem)[keyof typeof ExternalQuoteRequestsControllerFindAllStatusItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalQuoteRequestsControllerFindAllStatusItem = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

export type ExternalQuoteRequestsControllerFindAll200AllOfData = {
  items: QuoteRequestListItemDto[];
  meta: PaginationMetaDto;
};

export type ExternalQuoteRequestsControllerFindAll200AllOf = {
  data?: ExternalQuoteRequestsControllerFindAll200AllOfData;
};

export type ExternalQuoteRequestsControllerFindAll200 = BaseResponseDto &
  ExternalQuoteRequestsControllerFindAll200AllOf;

export type ExternalQuoteRequestsControllerFindMineParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: ExternalQuoteRequestsControllerFindMineSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 견적 요청 상태 필터
   */
  status?: ExternalQuoteRequestsControllerFindMineStatusItem[];
  /**
   * 마감 여부 필터 (서버 시각 기준)
   */
  isClosed?: boolean;
};

export type ExternalQuoteRequestsControllerFindMineSortOrder =
  (typeof ExternalQuoteRequestsControllerFindMineSortOrder)[keyof typeof ExternalQuoteRequestsControllerFindMineSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalQuoteRequestsControllerFindMineSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ExternalQuoteRequestsControllerFindMineStatusItem =
  (typeof ExternalQuoteRequestsControllerFindMineStatusItem)[keyof typeof ExternalQuoteRequestsControllerFindMineStatusItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalQuoteRequestsControllerFindMineStatusItem = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

export type ExternalQuoteRequestsControllerFindMine200AllOfData = {
  items: QuoteRequestListItemDto[];
  meta: PaginationMetaDto;
};

export type ExternalQuoteRequestsControllerFindMine200AllOf = {
  data?: ExternalQuoteRequestsControllerFindMine200AllOfData;
};

export type ExternalQuoteRequestsControllerFindMine200 = BaseResponseDto &
  ExternalQuoteRequestsControllerFindMine200AllOf;

export type ExternalQuoteRequestsControllerFindRespondedParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: ExternalQuoteRequestsControllerFindRespondedSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 견적 요청 상태 필터
   */
  status?: ExternalQuoteRequestsControllerFindRespondedStatusItem[];
  /**
   * 마감 여부 필터 (서버 시각 기준)
   */
  isClosed?: boolean;
};

export type ExternalQuoteRequestsControllerFindRespondedSortOrder =
  (typeof ExternalQuoteRequestsControllerFindRespondedSortOrder)[keyof typeof ExternalQuoteRequestsControllerFindRespondedSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalQuoteRequestsControllerFindRespondedSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ExternalQuoteRequestsControllerFindRespondedStatusItem =
  (typeof ExternalQuoteRequestsControllerFindRespondedStatusItem)[keyof typeof ExternalQuoteRequestsControllerFindRespondedStatusItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalQuoteRequestsControllerFindRespondedStatusItem = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

export type ExternalQuoteRequestsControllerFindResponded200AllOfData = {
  items: QuoteRequestListItemDto[];
  meta: PaginationMetaDto;
};

export type ExternalQuoteRequestsControllerFindResponded200AllOf = {
  data?: ExternalQuoteRequestsControllerFindResponded200AllOfData;
};

export type ExternalQuoteRequestsControllerFindResponded200 = BaseResponseDto &
  ExternalQuoteRequestsControllerFindResponded200AllOf;

export type ExternalQuoteRequestsControllerFindOne200AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type ExternalQuoteRequestsControllerFindOne200 = BaseResponseDto &
  ExternalQuoteRequestsControllerFindOne200AllOf;

export type ExternalQuoteRequestsControllerUpdateOne200AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type ExternalQuoteRequestsControllerUpdateOne200 = BaseResponseDto &
  ExternalQuoteRequestsControllerUpdateOne200AllOf;

export type ExternalQuoteRequestsControllerFindModifications200AllOf = {
  data?: QuoteRequestModificationDto[];
};

export type ExternalQuoteRequestsControllerFindModifications200 =
  BaseResponseDto & ExternalQuoteRequestsControllerFindModifications200AllOf;

export type ExternalQuoteRequestsControllerFindContractDocuments200AllOf = {
  data?: QuoteRequestContractDocumentGroupDto[];
};

export type ExternalQuoteRequestsControllerFindContractDocuments200 =
  BaseResponseDto &
    ExternalQuoteRequestsControllerFindContractDocuments200AllOf;

export type ExternalQuoteRequestsControllerExtendDeadline200AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type ExternalQuoteRequestsControllerExtendDeadline200 = BaseResponseDto &
  ExternalQuoteRequestsControllerExtendDeadline200AllOf;

export type ExternalContractsControllerRegisterShipmentsBulk200AllOf = {
  data?: ContractShipmentBulkRegisterResultDto;
};

export type ExternalContractsControllerRegisterShipmentsBulk200 =
  BaseResponseDto & ExternalContractsControllerRegisterShipmentsBulk200AllOf;

export type ExternalContractsControllerListShipments200AllOf = {
  data?: ContractShipmentListDto;
};

export type ExternalContractsControllerListShipments200 = BaseResponseDto &
  ExternalContractsControllerListShipments200AllOf;

export type ExternalContractsControllerRegisterShipment201AllOf = {
  data?: RegisterContractShipmentResultDto;
};

export type ExternalContractsControllerRegisterShipment201 = BaseResponseDto &
  ExternalContractsControllerRegisterShipment201AllOf;

export type ExternalContractsControllerSyncShipment200AllOf = {
  data?: ContractShipmentDto;
};

export type ExternalContractsControllerSyncShipment200 = BaseResponseDto &
  ExternalContractsControllerSyncShipment200AllOf;

export type ExternalContractsControllerUpdateShipment200AllOf = {
  data?: ContractShipmentDto;
};

export type ExternalContractsControllerUpdateShipment200 = BaseResponseDto &
  ExternalContractsControllerUpdateShipment200AllOf;

export type ExternalContractsControllerGetContracts200AllOf = {
  data?: ContractListResponseDto[];
};

export type ExternalContractsControllerGetContracts200 = BaseResponseDto &
  ExternalContractsControllerGetContracts200AllOf;

export type ExternalContractsControllerGetMyContractsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: ExternalContractsControllerGetMyContractsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  statuses?: ExternalContractsControllerGetMyContractsStatusesItem[];
};

export type ExternalContractsControllerGetMyContractsSortOrder =
  (typeof ExternalContractsControllerGetMyContractsSortOrder)[keyof typeof ExternalContractsControllerGetMyContractsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalContractsControllerGetMyContractsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ExternalContractsControllerGetMyContractsStatusesItem =
  (typeof ExternalContractsControllerGetMyContractsStatusesItem)[keyof typeof ExternalContractsControllerGetMyContractsStatusesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalContractsControllerGetMyContractsStatusesItem = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
} as const;

export type ExternalContractsControllerGetMyContracts200AllOfData = {
  items: ContractListResponseDto[];
  meta: PaginationMetaDto;
};

export type ExternalContractsControllerGetMyContracts200AllOf = {
  data?: ExternalContractsControllerGetMyContracts200AllOfData;
};

export type ExternalContractsControllerGetMyContracts200 = BaseResponseDto &
  ExternalContractsControllerGetMyContracts200AllOf;

export type ExternalContractsControllerGetSettlements200AllOf = {
  data?: SupplierSettlementResponseDto[];
};

export type ExternalContractsControllerGetSettlements200 = BaseResponseDto &
  ExternalContractsControllerGetSettlements200AllOf;

export type ExternalContractsControllerGetContract200AllOf = {
  data?: ContractResponseDto;
};

export type ExternalContractsControllerGetContract200 = BaseResponseDto &
  ExternalContractsControllerGetContract200AllOf;

export type ExternalContractsControllerRequestCancellation200AllOfData = {
  [key: string]: unknown;
};

export type ExternalContractsControllerRequestCancellation200AllOf = {
  data?: ExternalContractsControllerRequestCancellation200AllOfData;
};

export type ExternalContractsControllerRequestCancellation200 =
  BaseResponseDto & ExternalContractsControllerRequestCancellation200AllOf;

export type ExternalPaymentsControllerConfirmCardPayment201AllOf = {
  data?: CmarketCardPaymentConfirmedDto;
};

export type ExternalPaymentsControllerConfirmCardPayment201 = BaseResponseDto &
  ExternalPaymentsControllerConfirmCardPayment201AllOf;

export type ExternalAccountStatusControllerUpdateStatus200AllOf = {
  data?: UpdateExternalAccountStatusResponseDto;
};

export type ExternalAccountStatusControllerUpdateStatus200 = BaseResponseDto &
  ExternalAccountStatusControllerUpdateStatus200AllOf;

export type ExternalTaxInvoicesControllerApplyTaxInvoiceEvent200AllOf = {
  data?: CmarketTaxInvoiceCallbackResultDto;
};

export type ExternalTaxInvoicesControllerApplyTaxInvoiceEvent200 =
  BaseResponseDto & ExternalTaxInvoicesControllerApplyTaxInvoiceEvent200AllOf;

export type ExternalCmarketFeeBillsControllerApplyPaid200AllOf = {
  data?: CmarketFeeBillPaidResultDto;
};

export type ExternalCmarketFeeBillsControllerApplyPaid200 = BaseResponseDto &
  ExternalCmarketFeeBillsControllerApplyPaid200AllOf;

export type ExternalCmarketContractsControllerListConcludedParams = {
  /**
   * 이 시각 이후(포함)에 성사된 계약만. ISO 8601. 최근 93일 안이어야 한다.
   */
  since: string;
  /**
   * 직전 응답의 nextCursor 를 그대로. 없으면 첫 페이지. 다음 페이지를 부를 때 since 는 첫 페이지와 같게 보낸다.
   */
  cursor?: string;
  /**
   * 한 페이지 줄 수(1..500).
   */
  limit?: number;
};

export type ExternalCmarketContractsControllerListConcluded200AllOf = {
  data?: CmarketConcludedContractsPageDto;
};

export type ExternalCmarketContractsControllerListConcluded200 =
  BaseResponseDto & ExternalCmarketContractsControllerListConcluded200AllOf;

export type ExternalAdminQuoteRequestsControllerFindAllParams = {
  /**
   * 페이지 (1부터)
   */
  page?: number;
  /**
   * 페이지 크기
   * @maximum 100
   */
  limit?: number;
  /**
   * 통합 검색 — 공고번호 · 공고명 · 발주기관명
   */
  search?: string;
  /**
   * 상태 (다중). 쉼표 구분 또는 반복 파라미터. `CONTRACT_IN_PROGRESS` 는 계약이 걸린 건을 고른다
   */
  status?: ExternalAdminQuoteRequestsControllerFindAllStatusItem[];
  /**
   * 카테고리 (단일). 미지정이면 전체
   */
  categoryType?: ExternalAdminQuoteRequestsControllerFindAllCategoryType;
  /**
   * 등록일 시작 (ISO 8601, 포함)
   */
  publishedFrom?: string;
  /**
   * 등록일 끝 (ISO 8601, 포함)
   */
  publishedTo?: string;
  /**
   * 마감일 시작 (ISO 8601, 포함) — `publishedFrom` 과 다른 축이다
   */
  deadlineFrom?: string;
  /**
   * 마감일 끝 (ISO 8601, 포함)
   */
  deadlineTo?: string;
  /**
   * 마감 여부 (서버 시각 기준). `true` = 수동 마감(status=CLOSED) **또는** 마감일 경과, `false` = 그 반대. 진행중·마감 탭은 이 값 하나로 거세요
   */
  isClosed?: boolean;
};

export type ExternalAdminQuoteRequestsControllerFindAllStatusItem =
  (typeof ExternalAdminQuoteRequestsControllerFindAllStatusItem)[keyof typeof ExternalAdminQuoteRequestsControllerFindAllStatusItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalAdminQuoteRequestsControllerFindAllStatusItem = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

export type ExternalAdminQuoteRequestsControllerFindAllCategoryType =
  (typeof ExternalAdminQuoteRequestsControllerFindAllCategoryType)[keyof typeof ExternalAdminQuoteRequestsControllerFindAllCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalAdminQuoteRequestsControllerFindAllCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

export type ExternalAdminQuoteRequestsControllerFindAll200AllOfData = {
  items: AdminQuoteRequestListItemDto[];
  meta: PaginationMetaDto;
};

export type ExternalAdminQuoteRequestsControllerFindAll200AllOf = {
  data?: ExternalAdminQuoteRequestsControllerFindAll200AllOfData;
};

export type ExternalAdminQuoteRequestsControllerFindAll200 = BaseResponseDto &
  ExternalAdminQuoteRequestsControllerFindAll200AllOf;

export type ExternalAdminQuoteRequestsControllerDeleteOne200AllOfData = {
  [key: string]: unknown;
};

export type ExternalAdminQuoteRequestsControllerDeleteOne200AllOf = {
  data?: ExternalAdminQuoteRequestsControllerDeleteOne200AllOfData;
};

export type ExternalAdminQuoteRequestsControllerDeleteOne200 = BaseResponseDto &
  ExternalAdminQuoteRequestsControllerDeleteOne200AllOf;

export type ExternalAdminQuoteRequestsControllerRestoreOne200AllOfData = {
  [key: string]: unknown;
};

export type ExternalAdminQuoteRequestsControllerRestoreOne200AllOf = {
  data?: ExternalAdminQuoteRequestsControllerRestoreOne200AllOfData;
};

export type ExternalAdminQuoteRequestsControllerRestoreOne200 =
  BaseResponseDto & ExternalAdminQuoteRequestsControllerRestoreOne200AllOf;

export type ExternalAdminChatControllerFindRoomsParams = {
  /**
   * 견적요청 UUID
   */
  quoteRequestId?: string;
  /**
   * 공고번호. 씨마켓 bid id('AA0014_2') 형태도 받는다 — '_' 뒤를 떼고 SE 접두사를 붙여 해석한다.
   */
  requestNumber?: string;
  /**
   * 씨마켓 공급사 회원 ID (SEMO `suppliers.supplier_id`)
   */
  externalSupplierId?: string;
  /**
   * 페이지 (1부터)
   */
  page?: number;
  /**
   * 페이지 크기
   * @maximum 100
   */
  limit?: number;
};

export type ExternalAdminChatControllerFindRooms200AllOfData = {
  items: AdminChatRoomListItemDto[];
  meta: PaginationMetaDto;
};

export type ExternalAdminChatControllerFindRooms200AllOf = {
  data?: ExternalAdminChatControllerFindRooms200AllOfData;
};

export type ExternalAdminChatControllerFindRooms200 = BaseResponseDto &
  ExternalAdminChatControllerFindRooms200AllOf;

export type ExternalAdminChatControllerFindMessagesParams = {
  /**
   * 커서. 이 메시지보다 이전 것을 가져온다(기존 `before` 와 같다)
   */
  cursor?: string;
  /**
   * 페이지 크기
   * @maximum 100
   */
  limit?: number;
};

export type ExternalAdminChatControllerFindMessages200AllOf = {
  data?: ChatMessagesResponseDto;
};

export type ExternalAdminChatControllerFindMessages200 = BaseResponseDto &
  ExternalAdminChatControllerFindMessages200AllOf;

export type ExternalAdminParticipationsControllerHide200AllOf = {
  data?: AdminParticipationVisibilityResponseDto;
};

export type ExternalAdminParticipationsControllerHide200 = BaseResponseDto &
  ExternalAdminParticipationsControllerHide200AllOf;

export type ExternalAdminParticipationsControllerUnhide200AllOf = {
  data?: AdminParticipationVisibilityResponseDto;
};

export type ExternalAdminParticipationsControllerUnhide200 = BaseResponseDto &
  ExternalAdminParticipationsControllerUnhide200AllOf;

export type ExternalAdminParticipationsControllerRemove200AllOf = {
  data?: AdminParticipationDeletionResponseDto;
};

export type ExternalAdminParticipationsControllerRemove200 = BaseResponseDto &
  ExternalAdminParticipationsControllerRemove200AllOf;

export type ExternalTradeControllerCreateProject200AllOf = {
  data?: CreateTradeProjectResponseDto;
};

export type ExternalTradeControllerCreateProject200 = BaseResponseDto &
  ExternalTradeControllerCreateProject200AllOf;

export type ExternalTradeControllerListProjectsParams = {
  /**
   * 앞 응답의 nextCursor. 처음이면 비운다.
   */
  cursor?: string;
  /**
   * 한 번에 받을 수 (1–100, 기본 50)
   */
  limit?: number;
  /**
   * 이 시각 이후 바뀐 공고만 (ISO 8601). 짝 맞추기 배치가 쓴다.
   */
  updatedSince?: string;
};

export type ExternalTradeControllerListProjects200AllOf = {
  data?: TradeProjectPageDto;
};

export type ExternalTradeControllerListProjects200 = BaseResponseDto &
  ExternalTradeControllerListProjects200AllOf;

export type ExternalTradeControllerReplaceProject200AllOf = {
  data?: ReplaceTradeProjectResponseDto;
};

export type ExternalTradeControllerReplaceProject200 = BaseResponseDto &
  ExternalTradeControllerReplaceProject200AllOf;

export type ExternalTradeControllerUpdateProject200AllOf = {
  data?: UpdateTradeProjectResponseDto;
};

export type ExternalTradeControllerUpdateProject200 = BaseResponseDto &
  ExternalTradeControllerUpdateProject200AllOf;

export type ExternalTradeControllerGetProject200AllOf = {
  data?: TradeProjectSummaryDto;
};

export type ExternalTradeControllerGetProject200 = BaseResponseDto &
  ExternalTradeControllerGetProject200AllOf;

export type ExternalTradeControllerCreateRoom200AllOf = {
  data?: CreateTradeRoomResponseDto;
};

export type ExternalTradeControllerCreateRoom200 = BaseResponseDto &
  ExternalTradeControllerCreateRoom200AllOf;

export type ExternalTradeControllerListRoomsOfProjectParams = {
  /**
   * 앞 응답의 nextCursor. 처음이면 비운다.
   */
  cursor?: string;
  /**
   * 한 번에 받을 수 (1–100, 기본 50)
   */
  limit?: number;
};

export type ExternalTradeControllerListRoomsOfProject200AllOf = {
  data?: TradeRoomPageDto;
};

export type ExternalTradeControllerListRoomsOfProject200 = BaseResponseDto &
  ExternalTradeControllerListRoomsOfProject200AllOf;

export type ExternalTradeControllerCloseRoom200AllOf = {
  data?: CloseTradeRoomResponseDto;
};

export type ExternalTradeControllerCloseRoom200 = BaseResponseDto &
  ExternalTradeControllerCloseRoom200AllOf;

export type ExternalTradeControllerCreateEmbedUrl200AllOf = {
  data?: TradeEmbedResponseDto;
};

export type ExternalTradeControllerCreateEmbedUrl200 = BaseResponseDto &
  ExternalTradeControllerCreateEmbedUrl200AllOf;

export type ExternalTradeControllerRetranslate200AllOf = {
  data?: RetranslateTradeMessageResponseDto;
};

export type ExternalTradeControllerRetranslate200 = BaseResponseDto &
  ExternalTradeControllerRetranslate200AllOf;

export type ExternalTradeControllerGlossary200AllOf = {
  data?: TradeGlossaryDto;
};

export type ExternalTradeControllerGlossary200 = BaseResponseDto &
  ExternalTradeControllerGlossary200AllOf;

export type ExternalTradeControllerReconcileProjectsParams = {
  /**
   * 앞 응답의 nextCursor. 처음이면 비운다.
   */
  cursor?: string;
  /**
   * 한 번에 받을 수 (1–100, 기본 50)
   */
  limit?: number;
  /**
   * 이 시각 이후 바뀐 공고만 (ISO 8601). 짝 맞추기 배치가 쓴다.
   */
  updatedSince?: string;
};

export type ExternalTradeControllerReconcileProjects200AllOf = {
  data?: TradeProjectPageDto;
};

export type ExternalTradeControllerReconcileProjects200 = BaseResponseDto &
  ExternalTradeControllerReconcileProjects200AllOf;

export type ExternalTradeControllerReconcileRoomsParams = {
  /**
   * 앞 응답의 nextCursor. 처음이면 비운다.
   */
  cursor?: string;
  /**
   * 한 번에 받을 수 (1–100, 기본 50)
   */
  limit?: number;
  /**
   * 이 시각 이후 바뀐 방만 (ISO 8601)
   */
  updatedSince?: string;
};

export type ExternalTradeControllerReconcileRooms200AllOf = {
  data?: TradeRoomPageDto;
};

export type ExternalTradeControllerReconcileRooms200 = BaseResponseDto &
  ExternalTradeControllerReconcileRooms200AllOf;

export type ExternalTradeControllerReconcileTranslationsParams = {
  /**
   * 앞 응답의 nextCursor. 처음이면 비운다.
   */
  cursor?: string;
  /**
   * 한 번에 받을 수 (1–100, 기본 50)
   */
  limit?: number;
  /**
   * 이 시각 이후 FAILED 만 (ISO 8601)
   */
  since?: string;
};

export type ExternalTradeControllerReconcileTranslations200AllOf = {
  data?: TradeTranslationReconciliationDto;
};

export type ExternalTradeControllerReconcileTranslations200 = BaseResponseDto &
  ExternalTradeControllerReconcileTranslations200AllOf;

export type ExternalTradeDomainControllerMyCompany200AllOf = {
  data?: TradeCompanyDto;
};

export type ExternalTradeDomainControllerMyCompany200 = BaseResponseDto &
  ExternalTradeDomainControllerMyCompany200AllOf;

export type ExternalTradeDomainControllerUpsertMyCompany200AllOf = {
  data?: TradeCompanyDto;
};

export type ExternalTradeDomainControllerUpsertMyCompany200 = BaseResponseDto &
  ExternalTradeDomainControllerUpsertMyCompany200AllOf;

export type ExternalTradeDomainControllerCompanyBySlug200AllOf = {
  data?: TradeCompanyDto;
};

export type ExternalTradeDomainControllerCompanyBySlug200 = BaseResponseDto &
  ExternalTradeDomainControllerCompanyBySlug200AllOf;

export type ExternalTradeDomainControllerCompaniesBatchParams = {
  /**
   * 쉼표로 이은 씨마켓 회원 id (최대 100)
   */
  memberIds: string;
};

export type ExternalTradeDomainControllerCompaniesBatch200AllOf = {
  data?: TradeCompanyDto;
};

export type ExternalTradeDomainControllerCompaniesBatch200 = BaseResponseDto &
  ExternalTradeDomainControllerCompaniesBatch200AllOf;

export type ExternalTradeDomainControllerPublishedCompaniesParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  country?: ExternalTradeDomainControllerPublishedCompaniesCountry;
  /**
   * 상호·한 줄 소개 부분일치
   */
  q?: string;
};

export type ExternalTradeDomainControllerPublishedCompaniesCountry =
  (typeof ExternalTradeDomainControllerPublishedCompaniesCountry)[keyof typeof ExternalTradeDomainControllerPublishedCompaniesCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalTradeDomainControllerPublishedCompaniesCountry = {
  KR: "KR",
  ID: "ID",
} as const;

export type ExternalTradeDomainControllerPublishedCompanies200AllOf = {
  data?: TradeCompanyPageDto;
};

export type ExternalTradeDomainControllerPublishedCompanies200 =
  BaseResponseDto & ExternalTradeDomainControllerPublishedCompanies200AllOf;

export type ExternalTradeDomainControllerAdminCompaniesParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  country?: ExternalTradeDomainControllerAdminCompaniesCountry;
  /**
   * 상호·한 줄 소개 부분일치
   */
  q?: string;
  isPublished?: boolean;
};

export type ExternalTradeDomainControllerAdminCompaniesCountry =
  (typeof ExternalTradeDomainControllerAdminCompaniesCountry)[keyof typeof ExternalTradeDomainControllerAdminCompaniesCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalTradeDomainControllerAdminCompaniesCountry = {
  KR: "KR",
  ID: "ID",
} as const;

export type ExternalTradeDomainControllerAdminCompanies200AllOf = {
  data?: TradeCompanyPageDto;
};

export type ExternalTradeDomainControllerAdminCompanies200 = BaseResponseDto &
  ExternalTradeDomainControllerAdminCompanies200AllOf;

export type ExternalTradeDomainControllerSetPublication200AllOf = {
  data?: TradeCompanyDto;
};

export type ExternalTradeDomainControllerSetPublication200 = BaseResponseDto &
  ExternalTradeDomainControllerSetPublication200AllOf;

export type ExternalTradeDomainControllerCreateRfq200AllOf = {
  data?: TradeRfqDto;
};

export type ExternalTradeDomainControllerCreateRfq200 = BaseResponseDto &
  ExternalTradeDomainControllerCreateRfq200AllOf;

export type ExternalTradeDomainControllerListRfqsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  country?: ExternalTradeDomainControllerListRfqsCountry;
  status?: ExternalTradeDomainControllerListRfqsStatus;
  /**
   * 제목·품목명 부분일치(원문만)
   */
  q?: string;
};

export type ExternalTradeDomainControllerListRfqsCountry =
  (typeof ExternalTradeDomainControllerListRfqsCountry)[keyof typeof ExternalTradeDomainControllerListRfqsCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalTradeDomainControllerListRfqsCountry = {
  KR: "KR",
  ID: "ID",
} as const;

export type ExternalTradeDomainControllerListRfqsStatus =
  (typeof ExternalTradeDomainControllerListRfqsStatus)[keyof typeof ExternalTradeDomainControllerListRfqsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalTradeDomainControllerListRfqsStatus = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
} as const;

export type ExternalTradeDomainControllerListRfqs200AllOf = {
  data?: TradeRfqListItemDto;
};

export type ExternalTradeDomainControllerListRfqs200 = BaseResponseDto &
  ExternalTradeDomainControllerListRfqs200AllOf;

export type ExternalTradeDomainControllerOpenPublicRfqCount200AllOf = {
  data?: TradeCountDto;
};

export type ExternalTradeDomainControllerOpenPublicRfqCount200 =
  BaseResponseDto & ExternalTradeDomainControllerOpenPublicRfqCount200AllOf;

export type ExternalTradeDomainControllerMyRfqsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type ExternalTradeDomainControllerMyRfqs200AllOf = {
  data?: TradeRfqListItemDto;
};

export type ExternalTradeDomainControllerMyRfqs200 = BaseResponseDto &
  ExternalTradeDomainControllerMyRfqs200AllOf;

export type ExternalTradeDomainControllerMyRfqCountParams = {
  status?: ExternalTradeDomainControllerMyRfqCountStatus;
};

export type ExternalTradeDomainControllerMyRfqCountStatus =
  (typeof ExternalTradeDomainControllerMyRfqCountStatus)[keyof typeof ExternalTradeDomainControllerMyRfqCountStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalTradeDomainControllerMyRfqCountStatus = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
} as const;

export type ExternalTradeDomainControllerMyRfqCount200AllOf = {
  data?: TradeCountDto;
};

export type ExternalTradeDomainControllerMyRfqCount200 = BaseResponseDto &
  ExternalTradeDomainControllerMyRfqCount200AllOf;

export type ExternalTradeDomainControllerRfqDetailParams = {
  /**
   * true 면 작성 기업이 비공개일 때 author 를 null 로(공개 상세)
   */
  publishedAuthorOnly?: boolean;
};

export type ExternalTradeDomainControllerRfqDetail200AllOf = {
  data?: TradeRfqListItemDto;
};

export type ExternalTradeDomainControllerRfqDetail200 = BaseResponseDto &
  ExternalTradeDomainControllerRfqDetail200AllOf;

export type ExternalTradeDomainControllerCloseRfq200AllOf = {
  data?: TradeRfqListItemDto;
};

export type ExternalTradeDomainControllerCloseRfq200 = BaseResponseDto &
  ExternalTradeDomainControllerCloseRfq200AllOf;

export type ExternalTradeDomainControllerCreateProposal200AllOf = {
  data?: TradeProposalDto;
};

export type ExternalTradeDomainControllerCreateProposal200 = BaseResponseDto &
  ExternalTradeDomainControllerCreateProposal200AllOf;

export type ExternalTradeDomainControllerListProposalsParams = {
  /**
   * 이 제안자 것만(권한 분기)
   */
  proposerMemberId?: string;
};

export type ExternalTradeDomainControllerListProposals200AllOf = {
  data?: TradeProposalListItemDto;
};

export type ExternalTradeDomainControllerListProposals200 = BaseResponseDto &
  ExternalTradeDomainControllerListProposals200AllOf;

export type ExternalTradeDomainControllerSubmitQuote200AllOf = {
  data?: TradeQuoteSubmissionDto;
};

export type ExternalTradeDomainControllerSubmitQuote200 = BaseResponseDto &
  ExternalTradeDomainControllerSubmitQuote200AllOf;

export type ExternalTradeDomainControllerProposal200AllOf = {
  data?: TradeProposalDto;
};

export type ExternalTradeDomainControllerProposal200 = BaseResponseDto &
  ExternalTradeDomainControllerProposal200AllOf;

export type ExternalTradeDomainControllerReceivedProposalsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  status?: ExternalTradeDomainControllerReceivedProposalsStatus;
};

export type ExternalTradeDomainControllerReceivedProposalsStatus =
  (typeof ExternalTradeDomainControllerReceivedProposalsStatus)[keyof typeof ExternalTradeDomainControllerReceivedProposalsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalTradeDomainControllerReceivedProposalsStatus = {
  SUBMITTED: "SUBMITTED",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
} as const;

export type ExternalTradeDomainControllerReceivedProposals200AllOf = {
  data?: TradeReceivedProposalDto;
};

export type ExternalTradeDomainControllerReceivedProposals200 =
  BaseResponseDto & ExternalTradeDomainControllerReceivedProposals200AllOf;

export type ExternalTradeDomainControllerReceivedProposalCountParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  status?: ExternalTradeDomainControllerReceivedProposalCountStatus;
};

export type ExternalTradeDomainControllerReceivedProposalCountStatus =
  (typeof ExternalTradeDomainControllerReceivedProposalCountStatus)[keyof typeof ExternalTradeDomainControllerReceivedProposalCountStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalTradeDomainControllerReceivedProposalCountStatus = {
  SUBMITTED: "SUBMITTED",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
} as const;

export type ExternalTradeDomainControllerReceivedProposalCount200AllOf = {
  data?: TradeCountDto;
};

export type ExternalTradeDomainControllerReceivedProposalCount200 =
  BaseResponseDto & ExternalTradeDomainControllerReceivedProposalCount200AllOf;

export type ExternalTradeDomainControllerDecideProposal200AllOf = {
  data?: TradeProposalDecisionDto;
};

export type ExternalTradeDomainControllerDecideProposal200 = BaseResponseDto &
  ExternalTradeDomainControllerDecideProposal200AllOf;

export type ExternalTradeDomainControllerCreateListing200AllOf = {
  data?: TradeListingDto;
};

export type ExternalTradeDomainControllerCreateListing200 = BaseResponseDto &
  ExternalTradeDomainControllerCreateListing200AllOf;

export type ExternalTradeDomainControllerActiveListingsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type ExternalTradeDomainControllerActiveListings200AllOf = {
  data?: TradeListingDto;
};

export type ExternalTradeDomainControllerActiveListings200 = BaseResponseDto &
  ExternalTradeDomainControllerActiveListings200AllOf;

export type ExternalTradeDomainControllerEndedListingsParams = {
  /**
   * ISO 8601 — 이 시각 이후 끝난 게재
   */
  since: string;
  /**
   * 이 id 다음부터(커서)
   */
  afterId?: number;
  /**
   * @maximum 500
   */
  limit?: number;
};

export type ExternalTradeDomainControllerEndedListings200AllOf = {
  data?: TradeEndedListingDto;
};

export type ExternalTradeDomainControllerEndedListings200 = BaseResponseDto &
  ExternalTradeDomainControllerEndedListings200AllOf;

export type ExternalTradeDomainControllerExpireDue200AllOf = {
  data?: TradeExpireResultDto;
};

export type ExternalTradeDomainControllerExpireDue200 = BaseResponseDto &
  ExternalTradeDomainControllerExpireDue200AllOf;

export type ExternalTradeDomainControllerMyListingsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type ExternalTradeDomainControllerMyListings200AllOf = {
  data?: TradeListingDto;
};

export type ExternalTradeDomainControllerMyListings200 = BaseResponseDto &
  ExternalTradeDomainControllerMyListings200AllOf;

export type ExternalTradeDomainControllerListing200AllOf = {
  data?: TradeListingDto;
};

export type ExternalTradeDomainControllerListing200 = BaseResponseDto &
  ExternalTradeDomainControllerListing200AllOf;

export type ExternalTradeDomainControllerCloseListing200AllOf = {
  data?: TradeListingClosureDto;
};

export type ExternalTradeDomainControllerCloseListing200 = BaseResponseDto &
  ExternalTradeDomainControllerCloseListing200AllOf;

export type ExternalTradeDomainControllerAddCapacity200AllOf = {
  data?: TradeCapacityResultDto;
};

export type ExternalTradeDomainControllerAddCapacity200 = BaseResponseDto &
  ExternalTradeDomainControllerAddCapacity200AllOf;

export type ExternalTradeDomainControllerTakeSeat200AllOf = {
  data?: TakeTradeSeatResultDto;
};

export type ExternalTradeDomainControllerTakeSeat200 = BaseResponseDto &
  ExternalTradeDomainControllerTakeSeat200AllOf;

export type ExternalTradeDomainControllerOpenSeats200AllOf = {
  data?: TradeSeatDto;
};

export type ExternalTradeDomainControllerOpenSeats200 = BaseResponseDto &
  ExternalTradeDomainControllerOpenSeats200AllOf;

export type ExternalTradeDomainControllerMySeat200AllOf = {
  /** @nullable */
  data?: TradeSeatDto;
};

export type ExternalTradeDomainControllerMySeat200 = BaseResponseDto &
  ExternalTradeDomainControllerMySeat200AllOf;

export type ExternalTradeDomainControllerMyWaitlist200AllOf = {
  /** @nullable */
  data?: TradeWaitlistEntryDto;
};

export type ExternalTradeDomainControllerMyWaitlist200 = BaseResponseDto &
  ExternalTradeDomainControllerMyWaitlist200AllOf;

export type ExternalTradeDomainControllerJoinWaitlist200AllOf = {
  data?: TradeWaitlistEntryDto;
};

export type ExternalTradeDomainControllerJoinWaitlist200 = BaseResponseDto &
  ExternalTradeDomainControllerJoinWaitlist200AllOf;

export type ExternalTradeDomainControllerOpenRoom200AllOf = {
  data?: TradeRoomOpenResultDto;
};

export type ExternalTradeDomainControllerOpenRoom200 = BaseResponseDto &
  ExternalTradeDomainControllerOpenRoom200AllOf;

export type ExternalTradeDomainControllerMyRoomsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type ExternalTradeDomainControllerMyRooms200AllOf = {
  data?: TradeMemberRoomPageDto;
};

export type ExternalTradeDomainControllerMyRooms200 = BaseResponseDto &
  ExternalTradeDomainControllerMyRooms200AllOf;

export type ExternalTradeDomainControllerRoom200AllOf = {
  data?: TradeRoomV2Dto;
};

export type ExternalTradeDomainControllerRoom200 = BaseResponseDto &
  ExternalTradeDomainControllerRoom200AllOf;

export type ExternalTradeDomainControllerEmbed200AllOf = {
  data?: TradeEmbedUrlDto;
};

export type ExternalTradeDomainControllerEmbed200 = BaseResponseDto &
  ExternalTradeDomainControllerEmbed200AllOf;

export type ExternalTradeDomainControllerSendMessage200AllOf = {
  data?: TradeRoomMessageSentDto;
};

export type ExternalTradeDomainControllerSendMessage200 = BaseResponseDto &
  ExternalTradeDomainControllerSendMessage200AllOf;

export type ExternalTradeDomainControllerUnreadParams = {
  /**
   * 이 채팅방 id 다음부터(커서)
   */
  cursor?: string;
  /**
   * @maximum 500
   */
  limit?: number;
};

export type ExternalTradeDomainControllerUnread200AllOf = {
  data?: TradeUnreadPageDto;
};

export type ExternalTradeDomainControllerUnread200 = BaseResponseDto &
  ExternalTradeDomainControllerUnread200AllOf;

export type ExternalTradeDomainControllerBlockedBetweenParams = {
  a: string;
  b: string;
};

export type ExternalTradeDomainControllerBlockedBetween200AllOf = {
  data?: TradeBlockedDto;
};

export type ExternalTradeDomainControllerBlockedBetween200 = BaseResponseDto &
  ExternalTradeDomainControllerBlockedBetween200AllOf;

export type ContactControllerCreateInquiry200AllOfData = {
  [key: string]: unknown;
};

export type ContactControllerCreateInquiry200AllOf = {
  data?: ContactControllerCreateInquiry200AllOfData;
};

export type ContactControllerCreateInquiry200 = BaseResponseDto &
  ContactControllerCreateInquiry200AllOf;

export type PaymentControllerGetVendorDirectEligibilityParams = {
  quoteResponseVersionId: string;
};

export type PaymentControllerGetVendorDirectEligibility200AllOf = {
  data?: VendorDirectEligibilityResponseDto;
};

export type PaymentControllerGetVendorDirectEligibility200 = BaseResponseDto &
  PaymentControllerGetVendorDirectEligibility200AllOf;

export type PaymentControllerPayWithCard201AllOf = {
  data?: DirectPaymentResponseDto;
};

export type PaymentControllerPayWithCard201 = BaseResponseDto &
  PaymentControllerPayWithCard201AllOf;

export type PaymentControllerPayWithCash201AllOf = {
  data?: CashPaymentResponseDto;
};

export type PaymentControllerPayWithCash201 = BaseResponseDto &
  PaymentControllerPayWithCash201AllOf;

export type PaymentControllerRequestRefund201AllOf = {
  data?: RefundResponseDto;
};

export type PaymentControllerRequestRefund201 = BaseResponseDto &
  PaymentControllerRequestRefund201AllOf;

export type PaymentControllerVendorDirectPay201AllOf = {
  data?: VendorDirectPaymentResponseDto;
};

export type PaymentControllerVendorDirectPay201 = BaseResponseDto &
  PaymentControllerVendorDirectPay201AllOf;

export type PaymentControllerGetPaymentHistory200AllOf = {
  data?: PaymentHistoryResponseDto;
};

export type PaymentControllerGetPaymentHistory200 = BaseResponseDto &
  PaymentControllerGetPaymentHistory200AllOf;

export type PaymentNotificationControllerGetTransaction200AllOf = {
  data?: PaymentTransactionResponseDto;
};

export type PaymentNotificationControllerGetTransaction200 = BaseResponseDto &
  PaymentNotificationControllerGetTransaction200AllOf;

export type PaymentCardControllerRegisterCard201AllOf = {
  data?: PaymentCardDto;
};

export type PaymentCardControllerRegisterCard201 = BaseResponseDto &
  PaymentCardControllerRegisterCard201AllOf;

export type PaymentCardControllerGetUserCards200AllOf = {
  data?: PaymentCardDto[];
};

export type PaymentCardControllerGetUserCards200 = BaseResponseDto &
  PaymentCardControllerGetUserCards200AllOf;

export type AdminSupplierSignupControllerOrdersParams = {
  status?: string;
  /**
   * 회사명·씨마켓 아이디·사업자번호(숫자 3자리 이상)
   */
  search?: string;
  page?: number;
  limit?: number;
};

export type AdminSupplierSignupControllerSubscriptionsParams = {
  status?: string;
  /**
   * 회사명·씨마켓 아이디·사업자번호(숫자 3자리 이상)
   */
  search?: string;
  page?: number;
  limit?: number;
};

export type ProductClassesControllerResolveParams = {
  /**
   * 문장·품명(예: «복사용지 사주세요»)
   */
  q: string;
};

export type ProductClassesControllerResolve200AllOf = {
  data?: ResolveProductClassResponseDto;
};

export type ProductClassesControllerResolve200 = BaseResponseDto &
  ProductClassesControllerResolve200AllOf;

export type AdminBarcodeLedgerControllerListParams = {
  /**
   * 탭 — 기본 충돌
   */
  status?: AdminBarcodeLedgerControllerListStatus;
  /**
   * 바코드 번호(8·12·13·14자리 또는 GS1 값)로 찾기
   */
  q?: string;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
};

export type AdminBarcodeLedgerControllerListStatus =
  (typeof AdminBarcodeLedgerControllerListStatus)[keyof typeof AdminBarcodeLedgerControllerListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminBarcodeLedgerControllerListStatus = {
  CONFLICT: "CONFLICT",
  CANDIDATE: "CANDIDATE",
  CONFIRMED: "CONFIRMED",
  REJECTED: "REJECTED",
} as const;

export type SupplierSelfServiceControllerPerformanceParams = {
  /**
   * month = 이번 달(KST) · 30d = 최근 30일
   */
  period?: SupplierSelfServiceControllerPerformancePeriod;
};

export type SupplierSelfServiceControllerPerformancePeriod =
  (typeof SupplierSelfServiceControllerPerformancePeriod)[keyof typeof SupplierSelfServiceControllerPerformancePeriod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierSelfServiceControllerPerformancePeriod = {
  month: "month",
  "30d": "30d",
} as const;

export type AdminSupplierHelpRequestsControllerListParams = {
  status?: AdminSupplierHelpRequestsControllerListStatus;
  page?: number;
  limit?: number;
};

export type AdminSupplierHelpRequestsControllerListStatus =
  (typeof AdminSupplierHelpRequestsControllerListStatus)[keyof typeof AdminSupplierHelpRequestsControllerListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSupplierHelpRequestsControllerListStatus = {
  OPEN: "OPEN",
  DONE: "DONE",
  ALL: "ALL",
} as const;

export type SubscriptionControllerCreateSubscription201AllOf = {
  data?: SubscriptionResponseDto;
};

export type SubscriptionControllerCreateSubscription201 = BaseResponseDto &
  SubscriptionControllerCreateSubscription201AllOf;

export type SubscriptionControllerGetCurrentUserSubscription200AllOf = {
  data?: SubscriptionResponseDto;
};

export type SubscriptionControllerGetCurrentUserSubscription200 =
  BaseResponseDto & SubscriptionControllerGetCurrentUserSubscription200AllOf;

export type SubscriptionControllerGetPaymentHistory200AllOf = {
  data?: SubscriptionPaymentResponseDto[];
};

export type SubscriptionControllerGetPaymentHistory200 = BaseResponseDto &
  SubscriptionControllerGetPaymentHistory200AllOf;

export type PromotionControllerValidateCode200AllOf = {
  data?: PromotionCodeDto;
};

export type PromotionControllerValidateCode200 = BaseResponseDto &
  PromotionControllerValidateCode200AllOf;

export type PromotionControllerRedeem201AllOf = {
  data?: PromotionRedemptionResponseDto;
};

export type PromotionControllerRedeem201 = BaseResponseDto &
  PromotionControllerRedeem201AllOf;

export type NotificationsControllerGetNotificationsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: NotificationsControllerGetNotificationsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 알람 카테고리 필터
   */
  category?: NotificationsControllerGetNotificationsCategory;
  /**
   * 읽음 상태 필터
   */
  isRead?: boolean;
};

export type NotificationsControllerGetNotificationsSortOrder =
  (typeof NotificationsControllerGetNotificationsSortOrder)[keyof typeof NotificationsControllerGetNotificationsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationsControllerGetNotificationsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type NotificationsControllerGetNotificationsCategory =
  (typeof NotificationsControllerGetNotificationsCategory)[keyof typeof NotificationsControllerGetNotificationsCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationsControllerGetNotificationsCategory = {
  system: "system",
  project: "project",
  chat: "chat",
  payment: "payment",
  review: "review",
} as const;

export type NotificationsControllerGetNotifications200AllOfData = {
  items: NotificationResponseDto[];
  meta: PaginationMetaDto;
};

export type NotificationsControllerGetNotifications200AllOf = {
  data?: NotificationsControllerGetNotifications200AllOfData;
};

export type NotificationsControllerGetNotifications200 = BaseResponseDto &
  NotificationsControllerGetNotifications200AllOf;

export type NotificationsControllerGetUnreadCount200AllOf = {
  data?: UnreadCountResponseDto;
};

export type NotificationsControllerGetUnreadCount200 = BaseResponseDto &
  NotificationsControllerGetUnreadCount200AllOf;

export type NotificationsControllerMarkAllAsRead200AllOf = {
  data?: MarkAllReadResponseDto;
};

export type NotificationsControllerMarkAllAsRead200 = BaseResponseDto &
  NotificationsControllerMarkAllAsRead200AllOf;

export type NotificationsControllerMarkAsRead200AllOf = {
  data?: MarkReadResponseDto;
};

export type NotificationsControllerMarkAsRead200 = BaseResponseDto &
  NotificationsControllerMarkAsRead200AllOf;

export type NotificationsControllerGetSubscriptionInfo200AllOf = {
  data?: NotificationSubscriptionInfoResponseDto;
};

export type NotificationsControllerGetSubscriptionInfo200 = BaseResponseDto &
  NotificationsControllerGetSubscriptionInfo200AllOf;

export type WorkMatchPreviewControllerPreview200AllOf = {
  data?: WorkMatchPreviewDto;
};

export type WorkMatchPreviewControllerPreview200 = BaseResponseDto &
  WorkMatchPreviewControllerPreview200AllOf;

export type ExternalCmarketAiBidControllerWork200AllOf = {
  data?: CmarketAiBidWorkResponseDto;
};

export type ExternalCmarketAiBidControllerWork200 = BaseResponseDto &
  ExternalCmarketAiBidControllerWork200AllOf;

export type ActivityLogsControllerGetMyActivityLogsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: ActivityLogsControllerGetMyActivityLogsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 활동 카테고리 필터
   */
  category?: ActivityLogsControllerGetMyActivityLogsCategory;
  /**
   * 조회 시작 날짜 (ISO8601)
   */
  from?: string;
  /**
   * 조회 종료 날짜 (ISO8601)
   */
  to?: string;
};

export type ActivityLogsControllerGetMyActivityLogsSortOrder =
  (typeof ActivityLogsControllerGetMyActivityLogsSortOrder)[keyof typeof ActivityLogsControllerGetMyActivityLogsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityLogsControllerGetMyActivityLogsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ActivityLogsControllerGetMyActivityLogsCategory =
  (typeof ActivityLogsControllerGetMyActivityLogsCategory)[keyof typeof ActivityLogsControllerGetMyActivityLogsCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityLogsControllerGetMyActivityLogsCategory = {
  auth: "auth",
  quote: "quote",
  chat: "chat",
  profile: "profile",
  payment: "payment",
  contract: "contract",
  security: "security",
  promotion: "promotion",
} as const;

export type ActivityLogsControllerGetMyActivityLogs200AllOfData = {
  items: ActivityLogResponseDto[];
  meta: PaginationMetaDto;
};

export type ActivityLogsControllerGetMyActivityLogs200AllOf = {
  data?: ActivityLogsControllerGetMyActivityLogs200AllOfData;
};

export type ActivityLogsControllerGetMyActivityLogs200 = BaseResponseDto &
  ActivityLogsControllerGetMyActivityLogs200AllOf;

export type AdminActivityLogsControllerGetAllActivityLogsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: AdminActivityLogsControllerGetAllActivityLogsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 활동 카테고리 필터
   */
  category?: AdminActivityLogsControllerGetAllActivityLogsCategory;
  /**
   * 조회 시작 날짜 (ISO8601)
   */
  from?: string;
  /**
   * 조회 종료 날짜 (ISO8601)
   */
  to?: string;
  /**
   * 특정 사용자 ID로 필터
   */
  userId?: string;
};

export type AdminActivityLogsControllerGetAllActivityLogsSortOrder =
  (typeof AdminActivityLogsControllerGetAllActivityLogsSortOrder)[keyof typeof AdminActivityLogsControllerGetAllActivityLogsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminActivityLogsControllerGetAllActivityLogsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminActivityLogsControllerGetAllActivityLogsCategory =
  (typeof AdminActivityLogsControllerGetAllActivityLogsCategory)[keyof typeof AdminActivityLogsControllerGetAllActivityLogsCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminActivityLogsControllerGetAllActivityLogsCategory = {
  auth: "auth",
  quote: "quote",
  chat: "chat",
  profile: "profile",
  payment: "payment",
  contract: "contract",
  security: "security",
  promotion: "promotion",
} as const;

export type AdminActivityLogsControllerGetAllActivityLogs200AllOfData = {
  items: ActivityLogResponseDto[];
  meta: PaginationMetaDto;
};

export type AdminActivityLogsControllerGetAllActivityLogs200AllOf = {
  data?: AdminActivityLogsControllerGetAllActivityLogs200AllOfData;
};

export type AdminActivityLogsControllerGetAllActivityLogs200 = BaseResponseDto &
  AdminActivityLogsControllerGetAllActivityLogs200AllOf;

export type AdminActivityLogsControllerGetStatsParams = {
  from: string;
  to: string;
};

export type AdminActivityLogsControllerGetResourceLogsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: AdminActivityLogsControllerGetResourceLogsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 활동 카테고리 필터
   */
  category?: AdminActivityLogsControllerGetResourceLogsCategory;
  /**
   * 조회 시작 날짜 (ISO8601)
   */
  from?: string;
  /**
   * 조회 종료 날짜 (ISO8601)
   */
  to?: string;
  /**
   * 특정 사용자 ID로 필터
   */
  userId?: string;
};

export type AdminActivityLogsControllerGetResourceLogsSortOrder =
  (typeof AdminActivityLogsControllerGetResourceLogsSortOrder)[keyof typeof AdminActivityLogsControllerGetResourceLogsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminActivityLogsControllerGetResourceLogsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminActivityLogsControllerGetResourceLogsCategory =
  (typeof AdminActivityLogsControllerGetResourceLogsCategory)[keyof typeof AdminActivityLogsControllerGetResourceLogsCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminActivityLogsControllerGetResourceLogsCategory = {
  auth: "auth",
  quote: "quote",
  chat: "chat",
  profile: "profile",
  payment: "payment",
  contract: "contract",
  security: "security",
  promotion: "promotion",
} as const;

export type AdminActivityLogsControllerGetResourceLogs200AllOfData = {
  items: ActivityLogResponseDto[];
  meta: PaginationMetaDto;
};

export type AdminActivityLogsControllerGetResourceLogs200AllOf = {
  data?: AdminActivityLogsControllerGetResourceLogs200AllOfData;
};

export type AdminActivityLogsControllerGetResourceLogs200 = BaseResponseDto &
  AdminActivityLogsControllerGetResourceLogs200AllOf;

export type ReviewsControllerGetReviewsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 기준
   */
  sortBy?: ReviewsControllerGetReviewsSortBy;
  /**
   * 정렬 순서
   */
  sortOrder?: ReviewsControllerGetReviewsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 리뷰 작성자 ID로 필터링
   */
  reviewerId?: string;
  /**
   * 리뷰 대상 ID (공급업체)로 필터링
   */
  revieweeId?: string;
  /**
   * 계약 ID로 필터링
   */
  contractId?: string;
  /**
   * 최소 평점 (1-5)
   * @minimum 1
   * @maximum 5
   */
  minRating?: number;
  /**
   * 최대 평점 (1-5)
   * @minimum 1
   * @maximum 5
   */
  maxRating?: number;
  /**
   * 삭제된 리뷰 포함 여부
   */
  includeDeleted?: boolean;
};

export type ReviewsControllerGetReviewsSortBy =
  (typeof ReviewsControllerGetReviewsSortBy)[keyof typeof ReviewsControllerGetReviewsSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewsControllerGetReviewsSortBy = {
  created_at: "created_at",
  calculated_rating: "calculated_rating",
} as const;

export type ReviewsControllerGetReviewsSortOrder =
  (typeof ReviewsControllerGetReviewsSortOrder)[keyof typeof ReviewsControllerGetReviewsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewsControllerGetReviewsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ReviewsControllerGetReviews200AllOfData = {
  items: ReviewResponseDto[];
  meta: PaginationMetaDto;
};

export type ReviewsControllerGetReviews200AllOf = {
  data?: ReviewsControllerGetReviews200AllOfData;
};

export type ReviewsControllerGetReviews200 = BaseResponseDto &
  ReviewsControllerGetReviews200AllOf;

export type ReviewsControllerGetReview200AllOf = {
  data?: ReviewResponseDto;
};

export type ReviewsControllerGetReview200 = BaseResponseDto &
  ReviewsControllerGetReview200AllOf;

export type ReviewsControllerDeleteReview200AllOfData = {
  [key: string]: unknown;
};

export type ReviewsControllerDeleteReview200AllOf = {
  data?: ReviewsControllerDeleteReview200AllOfData;
};

export type ReviewsControllerDeleteReview200 = BaseResponseDto &
  ReviewsControllerDeleteReview200AllOf;

export type ReviewsControllerGetSupplierStats200AllOf = {
  data?: SupplierReviewStatsDto;
};

export type ReviewsControllerGetSupplierStats200 = BaseResponseDto &
  ReviewsControllerGetSupplierStats200AllOf;

export type ItemsV2ControllerMatchLines200AllOf = {
  data?: QuoteLineMatchResultDto[];
};

export type ItemsV2ControllerMatchLines200 = BaseResponseDto &
  ItemsV2ControllerMatchLines200AllOf;

export type ItemsV2ControllerSubmitExcelRegister200AllOf = {
  data?: ExcelRegisterSubmitResultDto;
};

export type ItemsV2ControllerSubmitExcelRegister200 = BaseResponseDto &
  ItemsV2ControllerSubmitExcelRegister200AllOf;

export type ItemsV2ControllerListExcelRegisterBatches200AllOf = {
  data?: ExcelBatchViewDto[];
};

export type ItemsV2ControllerListExcelRegisterBatches200 = BaseResponseDto &
  ItemsV2ControllerListExcelRegisterBatches200AllOf;

export type ItemsV2ControllerBulkUploadSupplierPricesBody = {
  /** 단가 엑셀(.xlsx) */
  file?: Blob;
};

export type ItemsV2ControllerBulkUploadSupplierPrices200AllOf = {
  data?: SupplierPriceBulkUploadResultDto;
};

export type ItemsV2ControllerBulkUploadSupplierPrices200 = BaseResponseDto &
  ItemsV2ControllerBulkUploadSupplierPrices200AllOf;

export type ItemsV2ControllerListMyUploadBatchesParams = {
  /**
   * 최대 100, 기본 20
   */
  limit?: string;
};

export type ItemsV2ControllerListMyUploadBatches200AllOf = {
  data?: SupplierPriceUploadBatchDto[];
};

export type ItemsV2ControllerListMyUploadBatches200 = BaseResponseDto &
  ItemsV2ControllerListMyUploadBatches200AllOf;

export type ItemsV2ControllerUndoMyUploadBatch200AllOf = {
  data?: SupplierPriceUndoResultDto;
};

export type ItemsV2ControllerUndoMyUploadBatch200 = BaseResponseDto &
  ItemsV2ControllerUndoMyUploadBatch200AllOf;

export type ItemsV2ControllerListMyPriceHistoryParams = {
  /**
   * 이 품목만. 없으면 내 전체 최근 변경
   */
  itemId?: string;
  /**
   * 최대 200, 기본 50
   */
  limit?: number;
};

export type ItemsV2ControllerListMyPriceHistory200AllOf = {
  data?: SupplierPriceEventDto[];
};

export type ItemsV2ControllerListMyPriceHistory200 = BaseResponseDto &
  ItemsV2ControllerListMyPriceHistory200AllOf;

export type ItemsV2ControllerListMyPriceObservationsParams = {
  /**
   * 품목 id
   */
  itemId: string;
  /**
   * 최대 500, 기본 200
   */
  limit?: number;
};

export type ItemsV2ControllerListMyPriceObservations200AllOf = {
  data?: SupplierPriceObservationDto[];
};

export type ItemsV2ControllerListMyPriceObservations200 = BaseResponseDto &
  ItemsV2ControllerListMyPriceObservations200AllOf;

export type ItemsV2ControllerGetMyStockPolicy200AllOf = {
  data?: SupplierStockPolicyDto;
};

export type ItemsV2ControllerGetMyStockPolicy200 = BaseResponseDto &
  ItemsV2ControllerGetMyStockPolicy200AllOf;

export type ItemsV2ControllerSetMyStockPolicy200AllOf = {
  data?: SupplierStockPolicyDto;
};

export type ItemsV2ControllerSetMyStockPolicy200 = BaseResponseDto &
  ItemsV2ControllerSetMyStockPolicy200AllOf;

export type ItemsV2ControllerAutocompleteParams = {
  /**
   * 검색 키워드 (최소 2자)
   * @minLength 2
   * @maxLength 100
   */
  q: string;
  /**
   * 결과 개수 (기본값: 10, 최대: 50)
   * @minimum 1
   * @maximum 50
   */
  limit?: number;
  /**
   * 결과 오프셋 (기본: 0). limit 상한(50) 너머로 페이징할 때 사용 — offset=50 이면 51번째부터 반환한다. 응답은 그대로 배열이며, 반환 건수가 limit 과 같으면 다음 페이지가 있을 수 있다.
   * @minimum 0
   */
  offset?: number;
  /**
   * 공급사 ID (선택사항 - 공급사별 단가 조회 시 필요)
   */
  supplierId?: string;
  /**
   * 카테고리 ID 필터 (선택사항). 지정 시 해당 카테고리 품목만 검색한다. 쉼표 구분 또는 반복 쿼리 파라미터(categoryIds=a&categoryIds=b) 모두 허용.
   */
  categoryIds?: string[];
  /**
   * 정렬 기준 (기본값: name)
   */
  sortBy?: ItemV2SortBy;
  /**
   * 정렬 순서 (기본값: ASC)
   */
  sortOrder?: ItemsV2ControllerAutocompleteSortOrder;
  /**
   * 카탈로그 epoch 필터. legacy=2026-05-19 이전 등록 품목, v2=이후 등록 품목. 미지정 시 전체.
   */
  catalogEpoch?: ItemV2CatalogEpoch;
  /**
   * 채우기(선택). split = 띄어쓰기 없는 품명(«복사용지A480g/더블에이/…»)을 나눈 낱말로 한 번 더 찾아, 기존 결과 뒤에 최대 3건 붙인다(응답은 limit+3 건까지). 기존 결과·순서는 그대로. 첫 쪽(offset=0)에서 서버 스위치가 켜졌을 때만 동작하고, 아니면 무시한다.
   */
  fill?: ItemsV2ControllerAutocompleteFill;
};

export type ItemsV2ControllerAutocompleteSortOrder =
  (typeof ItemsV2ControllerAutocompleteSortOrder)[keyof typeof ItemsV2ControllerAutocompleteSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemsV2ControllerAutocompleteSortOrder = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type ItemsV2ControllerAutocompleteFill =
  (typeof ItemsV2ControllerAutocompleteFill)[keyof typeof ItemsV2ControllerAutocompleteFill];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemsV2ControllerAutocompleteFill = {
  split: "split",
} as const;

export type ItemsV2ControllerAutocomplete200AllOf = {
  data?: ItemV2AutocompleteResponseDto[];
};

export type ItemsV2ControllerAutocomplete200 = BaseResponseDto &
  ItemsV2ControllerAutocomplete200AllOf;

export type ItemsV2ControllerGetPopularParams = {
  limit?: string;
};

export type ItemsV2ControllerGetPopular200AllOf = {
  data?: ItemV2AutocompleteResponseDto[];
};

export type ItemsV2ControllerGetPopular200 = BaseResponseDto &
  ItemsV2ControllerGetPopular200AllOf;

export type ItemsV2ControllerGetSupplierPriceParams = {
  /**
   * 품목 ID (items_v2_base.id - UUID)
   */
  itemId: string;
  /**
   * 공급사 ID
   */
  supplierId: string;
};

export type ItemsV2ControllerGetSupplierPrice200AllOf = {
  data?: ItemV2SupplierPriceResponseDto;
};

export type ItemsV2ControllerGetSupplierPrice200 = BaseResponseDto &
  ItemsV2ControllerGetSupplierPrice200AllOf;

export type ItemsV2ControllerGetSupplierItems200AllOf = {
  data?: SupplierItemsResponseDto[];
};

export type ItemsV2ControllerGetSupplierItems200 = BaseResponseDto &
  ItemsV2ControllerGetSupplierItems200AllOf;

export type ItemsV2ControllerGetItemSupplierComparison200AllOf = {
  data?: ItemSupplierComparisonDto[];
};

export type ItemsV2ControllerGetItemSupplierComparison200 = BaseResponseDto &
  ItemsV2ControllerGetItemSupplierComparison200AllOf;

export type ItemsV2ControllerFindById200AllOf = {
  data?: ItemV2AutocompleteResponseDto;
};

export type ItemsV2ControllerFindById200 = BaseResponseDto &
  ItemsV2ControllerFindById200AllOf;

export type ItemBarcodeControllerLookupParams = {
  /**
   * 스캔값(바코드·상품코드·품번)
   */
  code: string;
};

export type ItemBarcodeControllerLookup200AllOf = {
  data?: BarcodeLookupResponseDto;
};

export type ItemBarcodeControllerLookup200 = BaseResponseDto &
  ItemBarcodeControllerLookup200AllOf;

export type ItemBarcodeControllerList200AllOf = {
  data?: ItemBarcodeDto[];
};

export type ItemBarcodeControllerList200 = BaseResponseDto &
  ItemBarcodeControllerList200AllOf;

export type ItemBarcodeControllerRegister201AllOf = {
  data?: ItemBarcodeDto;
};

export type ItemBarcodeControllerRegister201 = BaseResponseDto &
  ItemBarcodeControllerRegister201AllOf;

export type AdminExcelRegisterControllerListParams = {
  status?: AdminExcelRegisterControllerListStatus;
  band?: AdminExcelRegisterControllerListBand;
  /**
   * 묶음(올린 파일) 하나만
   */
  batchId?: string;
  limit?: number;
  offset?: number;
};

export type AdminExcelRegisterControllerListStatus =
  (typeof AdminExcelRegisterControllerListStatus)[keyof typeof AdminExcelRegisterControllerListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminExcelRegisterControllerListStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  needs_info: "needs_info",
  all: "all",
} as const;

export type AdminExcelRegisterControllerListBand =
  (typeof AdminExcelRegisterControllerListBand)[keyof typeof AdminExcelRegisterControllerListBand];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminExcelRegisterControllerListBand = {
  auto: "auto",
  suggest: "suggest",
  new: "new",
  matching: "matching",
} as const;

export type ChatgptControllerGetResultsParams = {
  guestToken: string;
};

export type ExternalPriceRequestDemandControllerPageParams = {
  /**
   * 이전 응답의 nextAfter — 처음이면 비운다
   */
  after?: string;
  /**
   * 한 번에 받을 물품 수(1~500, 기본 500)
   */
  limit?: number;
};

export type ExternalPriceRequestDemandControllerPage200AllOf = {
  data?: PriceRequestDemandPageDto;
};

export type ExternalPriceRequestDemandControllerPage200 = BaseResponseDto &
  ExternalPriceRequestDemandControllerPage200AllOf;

export type SupplierPriceRequestsControllerListParams = {
  /**
   * 이전 응답의 nextAfter — 처음이면 비운다
   */
  after?: string;
  /**
   * 한 쪽 물품 수(1~100, 기본 50). 추천 물품은 이 수와 따로 첫 쪽 위에 붙는다
   */
  limit?: number;
  /**
   * 품명·규격 검색(띄어쓰기 무시 — «복사 용지» 로 «복사용지» 도 찾는다)
   * @maxLength 100
   */
  q?: string;
  /**
   * 씨마켓 알림이 이 회원에게 추천한 세모 물품 id(쉼표로 잇기, 최대 20개). 첫 쪽 맨 위에 넘긴 순서대로 — 아직 단가가 필요한 것만. 다음 쪽에도 같은 값을 넘기면 중복으로 나오지 않는다. `items=a,b` 와 `items=a&items=b` 둘 다 받는다
   */
  items?: string[];
};

export type SupplierPriceRequestsControllerList200AllOf = {
  data?: SupplierPriceRequestPageDto;
};

export type SupplierPriceRequestsControllerList200 = BaseResponseDto &
  SupplierPriceRequestsControllerList200AllOf;

export type ExternalBidIngestControllerBackfillWorkTypesParams = {
  limit: string;
};

export type ExternalBidsControllerInboxParams = {
  /**
   * 탭: recommended(맞춤) · all(전체) · saved(관심) · prepared(참여함)
   */
  tab?: ExternalBidsControllerInboxTab;
  /**
   * 이전 페이지가 준 nextCursor
   */
  cursor?: string;
  /**
   * 출처 코드(콤마 구분). 비우면 전체
   */
  source?: string;
  /**
   * 공고명·기관 검색
   */
  q?: string;
  /**
   * 업무구분(콤마 구분): 물품,용역,공사
   */
  bizType?: string;
  /**
   * 비우면 전부
   * @minimum 1
   * @maximum 50000
   */
  limit?: number;
  /**
   * 집계(inbox/counts)에서만 본다. 1 이면 대시보드 카드 요약(어제 이후 새 맞춤 수·마감 임박 한 건·물품 유무·계산 시각)을 같이 준다
   */
  card?: ExternalBidsControllerInboxCard;
};

export type ExternalBidsControllerInboxTab =
  (typeof ExternalBidsControllerInboxTab)[keyof typeof ExternalBidsControllerInboxTab];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalBidsControllerInboxTab = {
  recommended: "recommended",
  all: "all",
  saved: "saved",
  prepared: "prepared",
} as const;

export type ExternalBidsControllerInboxCard =
  (typeof ExternalBidsControllerInboxCard)[keyof typeof ExternalBidsControllerInboxCard];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalBidsControllerInboxCard = {
  NUMBER_1: "1",
} as const;

export type ExternalBidsControllerCountsParams = {
  /**
   * 탭: recommended(맞춤) · all(전체) · saved(관심) · prepared(참여함)
   */
  tab?: ExternalBidsControllerCountsTab;
  /**
   * 이전 페이지가 준 nextCursor
   */
  cursor?: string;
  /**
   * 출처 코드(콤마 구분). 비우면 전체
   */
  source?: string;
  /**
   * 공고명·기관 검색
   */
  q?: string;
  /**
   * 업무구분(콤마 구분): 물품,용역,공사
   */
  bizType?: string;
  /**
   * 비우면 전부
   * @minimum 1
   * @maximum 50000
   */
  limit?: number;
  /**
   * 집계(inbox/counts)에서만 본다. 1 이면 대시보드 카드 요약(어제 이후 새 맞춤 수·마감 임박 한 건·물품 유무·계산 시각)을 같이 준다
   */
  card?: ExternalBidsControllerCountsCard;
};

export type ExternalBidsControllerCountsTab =
  (typeof ExternalBidsControllerCountsTab)[keyof typeof ExternalBidsControllerCountsTab];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalBidsControllerCountsTab = {
  recommended: "recommended",
  all: "all",
  saved: "saved",
  prepared: "prepared",
} as const;

export type ExternalBidsControllerCountsCard =
  (typeof ExternalBidsControllerCountsCard)[keyof typeof ExternalBidsControllerCountsCard];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalBidsControllerCountsCard = {
  NUMBER_1: "1",
} as const;

export type ExternalCmarketBidsControllerResolveLines200AllOf = {
  data?: CmarketLineResolveResultDto;
};

export type ExternalCmarketBidsControllerResolveLines200 = BaseResponseDto &
  ExternalCmarketBidsControllerResolveLines200AllOf;

export type ExternalCmarketBidsControllerSync200AllOf = {
  data?: CmarketBidSyncResultDto;
};

export type ExternalCmarketBidsControllerSync200 = BaseResponseDto &
  ExternalCmarketBidsControllerSync200AllOf;

export type ExternalCmarketBidsControllerAnnounce200AllOf = {
  data?: CmarketBidAnnounceResultDto;
};

export type ExternalCmarketBidsControllerAnnounce200 = BaseResponseDto &
  ExternalCmarketBidsControllerAnnounce200AllOf;

export type ExternalCmarketBidsControllerCreateMasterItem201AllOf = {
  data?: CmarketMasterItemSummaryDto;
};

export type ExternalCmarketBidsControllerCreateMasterItem201 = BaseResponseDto &
  ExternalCmarketBidsControllerCreateMasterItem201AllOf;

export type ExternalCmarketBidsControllerEnsureReagentItem200AllOf = {
  data?: CmarketEnsureReagentItemResultDto;
};

export type ExternalCmarketBidsControllerEnsureReagentItem200 =
  BaseResponseDto & ExternalCmarketBidsControllerEnsureReagentItem200AllOf;

export type ExternalCmarketBidsControllerMasterItemNames200AllOf = {
  data?: CmarketMasterItemSummaryDto[];
};

export type ExternalCmarketBidsControllerMasterItemNames200 = BaseResponseDto &
  ExternalCmarketBidsControllerMasterItemNames200AllOf;

export type ExternalCmarketBidsControllerMasterCategoriesParams = {
  /**
   * 이름 일부. 비우면 최상위부터
   */
  q?: string;
};

export type ExternalCmarketBidsControllerMasterCategories200AllOf = {
  data?: CmarketMasterCategoryDto[];
};

export type ExternalCmarketBidsControllerMasterCategories200 = BaseResponseDto &
  ExternalCmarketBidsControllerMasterCategories200AllOf;

export type ExternalCmarketKeywordStatsControllerReceive200AllOf = {
  data?: CmarketKeywordStatsResultDto;
};

export type ExternalCmarketKeywordStatsControllerReceive200 = BaseResponseDto &
  ExternalCmarketKeywordStatsControllerReceive200AllOf;

export type BidCoverageControllerReportParams = {
  limit: string;
  concurrency: string;
};

export type BidCoverageControllerRecomputeParams = {
  full: string;
  since: string;
  supplier: string;
  concurrency: string;
  wait: string;
};

export type BidCoverageControllerRecomputeStatusParams = {
  limit: string;
};

export type AdminBidItemRequestsControllerQueueParams = {
  lane?: AdminBidItemRequestsControllerQueueLane;
  status?: AdminBidItemRequestsControllerQueueStatus;
  limit?: number;
  offset?: number;
};

export type AdminBidItemRequestsControllerQueueLane =
  (typeof AdminBidItemRequestsControllerQueueLane)[keyof typeof AdminBidItemRequestsControllerQueueLane];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminBidItemRequestsControllerQueueLane = {
  all: "all",
  ready: "ready",
  compare: "compare",
  check: "check",
} as const;

export type AdminBidItemRequestsControllerQueueStatus =
  (typeof AdminBidItemRequestsControllerQueueStatus)[keyof typeof AdminBidItemRequestsControllerQueueStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminBidItemRequestsControllerQueueStatus = {
  pending: "pending",
  needs_info: "needs_info",
  all: "all",
} as const;

export type AdminBidAutoItemsControllerListParams = {
  tab?: AdminBidAutoItemsControllerListTab;
  /**
   * 조달청 분류 앞자리(접두 일치)
   */
  classCode?: string;
  /**
   * 품명 검색
   */
  search?: string;
  /**
   * 출처 공고 key
   */
  bidKey?: string;
  limit?: number;
  offset?: number;
};

export type AdminBidAutoItemsControllerListTab =
  (typeof AdminBidAutoItemsControllerListTab)[keyof typeof AdminBidAutoItemsControllerListTab];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminBidAutoItemsControllerListTab = {
  review: "review",
  uncategorized: "uncategorized",
  processed: "processed",
  all: "all",
} as const;

export type PublicLandingControllerGetStats200AllOf = {
  data?: LandingStatsDto;
};

export type PublicLandingControllerGetStats200 = BaseResponseDto &
  PublicLandingControllerGetStats200AllOf;

export type PublicLandingControllerGetRecentContractsParams = {
  /**
   * 최대 20, 기본 8
   */
  limit?: string;
};

export type PublicLandingControllerGetRecentContracts200AllOf = {
  data?: RecentContractDto[];
};

export type PublicLandingControllerGetRecentContracts200 = BaseResponseDto &
  PublicLandingControllerGetRecentContracts200AllOf;

export type CostEstimateControllerListWorkTypes200AllOf = {
  data?: CostWorkTypeDto[];
};

export type CostEstimateControllerListWorkTypes200 = BaseResponseDto &
  CostEstimateControllerListWorkTypes200AllOf;

export type CostEstimateControllerClassifyParams = {
  /**
   * 공고 제목(200자까지 사용)
   */
  title: string;
};

export type CostEstimateControllerClassify200AllOf = {
  data?: CostClassifyDto;
};

export type CostEstimateControllerClassify200 = BaseResponseDto &
  CostEstimateControllerClassify200AllOf;

export type CostEstimateControllerGetTemplate200AllOf = {
  data?: CostTemplateDto;
};

export type CostEstimateControllerGetTemplate200 = BaseResponseDto &
  CostEstimateControllerGetTemplate200AllOf;

export type CostEstimateControllerSearchPricesParams = {
  /**
   * 검색어(공백 = AND)
   */
  q: string;
  source?: CostEstimateControllerSearchPricesSource;
  /**
   * 기본 30, 최대 100
   */
  limit?: string;
};

export type CostEstimateControllerSearchPricesSource =
  (typeof CostEstimateControllerSearchPricesSource)[keyof typeof CostEstimateControllerSearchPricesSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostEstimateControllerSearchPricesSource = {
  G2B_WORK: "G2B_WORK",
  G2B_MATERIAL: "G2B_MATERIAL",
} as const;

export type CostEstimateControllerSearchPrices200AllOf = {
  data?: CostPriceBookEntryDto[];
};

export type CostEstimateControllerSearchPrices200 = BaseResponseDto &
  CostEstimateControllerSearchPrices200AllOf;

export type CostEstimateControllerAnalyzeDocumentBody = {
  /** 공고문·과업지시서(PDF) 또는 내역서(xlsx·xls), 20MB 이하 */
  file: Blob;
};

export type CostEstimateControllerAnalyzeDocument200AllOf = {
  data?: CostDocumentAnalysisDto;
};

export type CostEstimateControllerAnalyzeDocument200 = BaseResponseDto &
  CostEstimateControllerAnalyzeDocument200AllOf;

export type CostEstimateControllerDraftBoq200AllOf = {
  data?: DraftBoqDto;
};

export type CostEstimateControllerDraftBoq200 = BaseResponseDto &
  CostEstimateControllerDraftBoq200AllOf;

export type GcmControllerLookupParams = {
  /**
   * 나라. 휴대폰 국내 모양(0812…/090…)을 읽는 기준이자 가입 계정·회사의 나라
   */
  country?: GcmControllerLookupCountry;
  idType: GcmControllerLookupIdType;
  value: string;
};

export type GcmControllerLookupCountry =
  (typeof GcmControllerLookupCountry)[keyof typeof GcmControllerLookupCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmControllerLookupCountry = {
  ID: "ID",
  JP: "JP",
} as const;

export type GcmControllerLookupIdType =
  (typeof GcmControllerLookupIdType)[keyof typeof GcmControllerLookupIdType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmControllerLookupIdType = {
  NIB: "NIB",
  NPWP: "NPWP",
  AHU: "AHU",
  CORPORATE_NUMBER: "CORPORATE_NUMBER",
  INVOICE_REG: "INVOICE_REG",
  INSTITUTION_REG: "INSTITUTION_REG",
} as const;

export type AdminGcmControllerListParams = {
  status?: AdminGcmControllerListStatus;
  /**
   * 비우면 전체 나라
   */
  country?: AdminGcmControllerListCountry;
  page?: number;
  limit?: number;
};

export type AdminGcmControllerListStatus =
  (typeof AdminGcmControllerListStatus)[keyof typeof AdminGcmControllerListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmControllerListStatus = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  PENDING_CHECK: "PENDING_CHECK",
  NEEDS_INFO: "NEEDS_INFO",
  APPROVED: "APPROVED",
  ON_HOLD: "ON_HOLD",
  REJECTED: "REJECTED",
  SUSPENDED: "SUSPENDED",
} as const;

export type AdminGcmControllerListCountry =
  (typeof AdminGcmControllerListCountry)[keyof typeof AdminGcmControllerListCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmControllerListCountry = {
  ID: "ID",
  JP: "JP",
} as const;

export type GcmItemsControllerSearchParams = {
  q: string;
  limit?: number;
  offset?: number;
  lang?: GcmItemsControllerSearchLang;
};

export type GcmItemsControllerSearchLang =
  (typeof GcmItemsControllerSearchLang)[keyof typeof GcmItemsControllerSearchLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmItemsControllerSearchLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export type GcmItemsControllerListMineParams = {
  q?: string;
  page?: number;
  limit?: number;
  lang?: GcmItemsControllerListMineLang;
};

export type GcmItemsControllerListMineLang =
  (typeof GcmItemsControllerListMineLang)[keyof typeof GcmItemsControllerListMineLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmItemsControllerListMineLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export type GcmItemsControllerHistoryParams = {
  limit?: number;
  before?: string;
};

export type AdminGcmItemsControllerListParams = {
  status?: AdminGcmItemsControllerListStatus;
  /**
   * 엑셀 파일 하나의 줄만(1-g)
   */
  batchId?: string;
  band?: AdminGcmItemsControllerListBand;
  /**
   * 엑셀로 온 줄만
   */
  fromImport?: boolean;
  page?: number;
  limit?: number;
};

export type AdminGcmItemsControllerListStatus =
  (typeof AdminGcmItemsControllerListStatus)[keyof typeof AdminGcmItemsControllerListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmItemsControllerListStatus = {
  PENDING: "PENDING",
  LINKED: "LINKED",
  REJECTED: "REJECTED",
} as const;

export type AdminGcmItemsControllerListBand =
  (typeof AdminGcmItemsControllerListBand)[keyof typeof AdminGcmItemsControllerListBand];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmItemsControllerListBand = {
  auto: "auto",
  suggest: "suggest",
  new: "new",
  pending: "pending",
} as const;

export type AdminGcmOpsControllerUsersParams = {
  q?: string;
  status?: string;
  page?: number;
  limit?: number;
};

export type AdminGcmOpsControllerDeletionsParams = {
  q?: string;
  status?: string;
  page?: number;
  limit?: number;
};

export type AdminGcmOpsControllerChangesParams = {
  q?: string;
  status?: string;
  page?: number;
  limit?: number;
};

export type GcmNotificationsControllerListParams = {
  limit?: number;
  before?: string;
  unreadOnly?: boolean;
};

export type PriceAuditSheetsControllerCreate201AllOf = {
  data?: PriceAuditSheetDetailDto;
};

export type PriceAuditSheetsControllerCreate201 = BaseResponseDto &
  PriceAuditSheetsControllerCreate201AllOf;

export type PriceAuditSheetsControllerListParams = {
  /**
   * 최대 100, 기본 20
   */
  limit?: string;
};

export type PriceAuditSheetsControllerList200AllOf = {
  data?: PriceAuditSheetDto[];
};

export type PriceAuditSheetsControllerList200 = BaseResponseDto &
  PriceAuditSheetsControllerList200AllOf;

export type PriceAuditSheetsControllerGet200AllOf = {
  data?: PriceAuditSheetDetailDto;
};

export type PriceAuditSheetsControllerGet200 = BaseResponseDto &
  PriceAuditSheetsControllerGet200AllOf;

export type PriceAuditSheetsControllerPatchRow200AllOf = {
  data?: PriceAuditRowDto;
};

export type PriceAuditSheetsControllerPatchRow200 = BaseResponseDto &
  PriceAuditSheetsControllerPatchRow200AllOf;

export type PriceAuditSheetsControllerApply200AllOf = {
  data?: PriceAuditApplyResultDto;
};

export type PriceAuditSheetsControllerApply200 = BaseResponseDto &
  PriceAuditSheetsControllerApply200AllOf;

export type PriceAuditSheetsControllerDiscard200AllOf = {
  data?: PriceAuditSheetDto;
};

export type PriceAuditSheetsControllerDiscard200 = BaseResponseDto &
  PriceAuditSheetsControllerDiscard200AllOf;

export type AdminPriceAuditSheetsControllerCreate201AllOf = {
  data?: PriceAuditSheetDetailDto;
};

export type AdminPriceAuditSheetsControllerCreate201 = BaseResponseDto &
  AdminPriceAuditSheetsControllerCreate201AllOf;

export type AdminPriceAuditSheetsControllerListParams = {
  supplierUserId: string;
  limit?: string;
};

export type AdminPriceAuditSheetsControllerList200AllOf = {
  data?: PriceAuditSheetDto[];
};

export type AdminPriceAuditSheetsControllerList200 = BaseResponseDto &
  AdminPriceAuditSheetsControllerList200AllOf;

export type ExternalPriceObservationsControllerReceive200AllOf = {
  data?: PriceObservationIngestResultDto;
};

export type ExternalPriceObservationsControllerReceive200 = BaseResponseDto &
  ExternalPriceObservationsControllerReceive200AllOf;

export type ExternalPriceObservationsControllerUpdateStatus200AllOf = {
  data?: PriceObservationStatusResultDto;
};

export type ExternalPriceObservationsControllerUpdateStatus200 =
  BaseResponseDto & ExternalPriceObservationsControllerUpdateStatus200AllOf;

export type SupplierPriceProposalsControllerListParams = {
  /**
   * 최대 500, 기본 100
   */
  limit?: string;
};

export type SupplierPriceProposalsControllerList200AllOf = {
  data?: SupplierPriceProposalDto[];
};

export type SupplierPriceProposalsControllerList200 = BaseResponseDto &
  SupplierPriceProposalsControllerList200AllOf;

export type SupplierPriceProposalsControllerCount200AllOf = {
  data?: SupplierPriceProposalCountDto;
};

export type SupplierPriceProposalsControllerCount200 = BaseResponseDto &
  SupplierPriceProposalsControllerCount200AllOf;

export type SupplierPriceProposalsControllerApply200AllOf = {
  data?: SupplierPriceProposalApplyResultDto;
};

export type SupplierPriceProposalsControllerApply200 = BaseResponseDto &
  SupplierPriceProposalsControllerApply200AllOf;

export type ExternalWebhooksControllerCreate201AllOf = {
  data?: WebhookSubscriptionWithSecretResponseDto;
};

export type ExternalWebhooksControllerCreate201 = BaseResponseDto &
  ExternalWebhooksControllerCreate201AllOf;

export type ExternalWebhooksControllerList200AllOf = {
  data?: WebhookSubscriptionResponseDto[];
};

export type ExternalWebhooksControllerList200 = BaseResponseDto &
  ExternalWebhooksControllerList200AllOf;

export type ExternalWebhooksControllerUpdate200AllOf = {
  data?: WebhookSubscriptionResponseDto;
};

export type ExternalWebhooksControllerUpdate200 = BaseResponseDto &
  ExternalWebhooksControllerUpdate200AllOf;

export type ExternalWebhooksControllerRotateSecret200AllOf = {
  data?: WebhookSubscriptionWithSecretResponseDto;
};

export type ExternalWebhooksControllerRotateSecret200 = BaseResponseDto &
  ExternalWebhooksControllerRotateSecret200AllOf;

export type ExternalWebhooksControllerSendTest200AllOf = {
  data?: WebhookTestResultDto;
};

export type ExternalWebhooksControllerSendTest200 = BaseResponseDto &
  ExternalWebhooksControllerSendTest200AllOf;

export type ExternalWebhooksControllerListDeliveriesParams = {
  /**
   * 상태 필터
   */
  status?: ExternalWebhooksControllerListDeliveriesStatus;
  /**
   * 최대 개수(기본 50, 최대 200)
   */
  limit?: number;
};

export type ExternalWebhooksControllerListDeliveriesStatus =
  (typeof ExternalWebhooksControllerListDeliveriesStatus)[keyof typeof ExternalWebhooksControllerListDeliveriesStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalWebhooksControllerListDeliveriesStatus = {
  PENDING: "PENDING",
  DELIVERED: "DELIVERED",
  RETRYING: "RETRYING",
  HELD: "HELD",
  DEAD: "DEAD",
} as const;

export type ExternalWebhooksControllerListDeliveries200AllOf = {
  data?: WebhookDeliveryResponseDto[];
};

export type ExternalWebhooksControllerListDeliveries200 = BaseResponseDto &
  ExternalWebhooksControllerListDeliveries200AllOf;

export type ExternalWebhooksControllerRetry200AllOf = {
  data?: WebhookDeliveryResponseDto;
};

export type ExternalWebhooksControllerRetry200 = BaseResponseDto &
  ExternalWebhooksControllerRetry200AllOf;

export type ShippingControllerListCouriers200AllOf = {
  data?: ShippingCourierDto[];
};

export type ShippingControllerListCouriers200 = BaseResponseDto &
  ShippingControllerListCouriers200AllOf;

export type ShippingControllerSuggestCouriersParams = {
  /**
   * 송장번호
   */
  trackingNo: string;
};

export type ShippingControllerSuggestCouriers200AllOf = {
  data?: SuggestedCouriersDto;
};

export type ShippingControllerSuggestCouriers200 = BaseResponseDto &
  ShippingControllerSuggestCouriers200AllOf;

export type ShippingControllerListMineParams = {
  /**
   * 배송 상태 필터(쉼표로 여러 개)
   */
  deliveryStatuses?: ShippingControllerListMineDeliveryStatusesItem[];
  /**
   * 인수 상태 필터(쉼표로 여러 개)
   */
  acceptanceStatuses?: ShippingControllerListMineAcceptanceStatusesItem[];
  /**
   * 확인이 필요한 송장만(예외 · 조회 종료 · 조회 실패 · 문제 신고 중)
   */
  attentionOnly?: boolean;
  /**
   * 송장번호 일부
   */
  q?: string;
  /**
   * 페이지 번호(1부터)
   */
  page?: number;
  /**
   * 페이지 크기
   * @maximum 100
   */
  limit?: number;
};

export type ShippingControllerListMineDeliveryStatusesItem =
  (typeof ShippingControllerListMineDeliveryStatusesItem)[keyof typeof ShippingControllerListMineDeliveryStatusesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShippingControllerListMineDeliveryStatusesItem = {
  READY: "READY",
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  EXCEPTION: "EXCEPTION",
  RETURNED: "RETURNED",
  CANCELED: "CANCELED",
} as const;

export type ShippingControllerListMineAcceptanceStatusesItem =
  (typeof ShippingControllerListMineAcceptanceStatusesItem)[keyof typeof ShippingControllerListMineAcceptanceStatusesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShippingControllerListMineAcceptanceStatusesItem = {
  NOT_DUE: "NOT_DUE",
  AWAITING: "AWAITING",
  RECEIVED: "RECEIVED",
  AUTO_RECEIVED: "AUTO_RECEIVED",
  DISPUTED: "DISPUTED",
} as const;

export type ShippingControllerListMine200AllOf = {
  data?: ShipmentPageDto;
};

export type ShippingControllerListMine200 = BaseResponseDto &
  ShippingControllerListMine200AllOf;

export type ShippingControllerGetDetail200AllOf = {
  data?: ShipmentDetailDto;
};

export type ShippingControllerGetDetail200 = BaseResponseDto &
  ShippingControllerGetDetail200AllOf;

export type ShippingControllerCorrect200AllOf = {
  data?: ShippingShipmentDto;
};

export type ShippingControllerCorrect200 = BaseResponseDto &
  ShippingControllerCorrect200AllOf;

export type ShippingControllerRefresh200AllOf = {
  data?: RefreshResultDto;
};

export type ShippingControllerRefresh200 = BaseResponseDto &
  ShippingControllerRefresh200AllOf;

export type ShippingControllerChangeStatus200AllOf = {
  data?: ShippingShipmentDto;
};

export type ShippingControllerChangeStatus200 = BaseResponseDto &
  ShippingControllerChangeStatus200AllOf;

export type ShippingControllerClaimDelivered200AllOf = {
  data?: ShippingShipmentDto;
};

export type ShippingControllerClaimDelivered200 = BaseResponseDto &
  ShippingControllerClaimDelivered200AllOf;

export type ShippingControllerReceive200AllOf = {
  data?: ShippingShipmentDto;
};

export type ShippingControllerReceive200 = BaseResponseDto &
  ShippingControllerReceive200AllOf;

export type ShippingControllerDispute200AllOf = {
  data?: ShippingShipmentDto;
};

export type ShippingControllerDispute200 = BaseResponseDto &
  ShippingControllerDispute200AllOf;

export type ShippingControllerWithdrawDispute200AllOf = {
  data?: ShippingShipmentDto;
};

export type ShippingControllerWithdrawDispute200 = BaseResponseDto &
  ShippingControllerWithdrawDispute200AllOf;

export type ShippingPolicyControllerGet200AllOf = {
  data?: ShippingPolicyDto;
};

export type ShippingPolicyControllerGet200 = BaseResponseDto &
  ShippingPolicyControllerGet200AllOf;

export type AdminShippingControllerListParams = {
  /**
   * 배송 상태 필터(쉼표로 여러 개)
   */
  deliveryStatuses?: AdminShippingControllerListDeliveryStatusesItem[];
  /**
   * 인수 상태 필터(쉼표로 여러 개)
   */
  acceptanceStatuses?: AdminShippingControllerListAcceptanceStatusesItem[];
  /**
   * 확인이 필요한 송장만(예외 · 조회 종료 · 조회 실패 · 문제 신고 중)
   */
  attentionOnly?: boolean;
  /**
   * 송장번호 일부
   */
  q?: string;
  /**
   * 페이지 번호(1부터)
   */
  page?: number;
  /**
   * 페이지 크기
   * @maximum 100
   */
  limit?: number;
  /**
   * 공급사 id
   */
  supplierId?: string;
  /**
   * 발주기관 id
   */
  buyerId?: string;
  /**
   * 배송 대상 종류
   */
  subjectKind?: AdminShippingControllerListSubjectKind;
  /**
   * 배송 대상 id
   */
  subjectId?: string;
};

export type AdminShippingControllerListDeliveryStatusesItem =
  (typeof AdminShippingControllerListDeliveryStatusesItem)[keyof typeof AdminShippingControllerListDeliveryStatusesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminShippingControllerListDeliveryStatusesItem = {
  READY: "READY",
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  EXCEPTION: "EXCEPTION",
  RETURNED: "RETURNED",
  CANCELED: "CANCELED",
} as const;

export type AdminShippingControllerListAcceptanceStatusesItem =
  (typeof AdminShippingControllerListAcceptanceStatusesItem)[keyof typeof AdminShippingControllerListAcceptanceStatusesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminShippingControllerListAcceptanceStatusesItem = {
  NOT_DUE: "NOT_DUE",
  AWAITING: "AWAITING",
  RECEIVED: "RECEIVED",
  AUTO_RECEIVED: "AUTO_RECEIVED",
  DISPUTED: "DISPUTED",
} as const;

export type AdminShippingControllerListSubjectKind =
  (typeof AdminShippingControllerListSubjectKind)[keyof typeof AdminShippingControllerListSubjectKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminShippingControllerListSubjectKind = {
  CONTRACT: "CONTRACT",
  MALL_ORDER: "MALL_ORDER",
  CMARKET_AWARD: "CMARKET_AWARD",
} as const;

export type AdminShippingControllerList200AllOf = {
  data?: ShipmentPageDto;
};

export type AdminShippingControllerList200 = BaseResponseDto &
  AdminShippingControllerList200AllOf;

export type AdminShippingControllerDetail200AllOf = {
  data?: ShipmentDetailDto;
};

export type AdminShippingControllerDetail200 = BaseResponseDto &
  AdminShippingControllerDetail200AllOf;

export type AdminShippingControllerForcePreviewParams = {
  /**
   * 강제로 바꿀 상태
   */
  target: AdminShippingControllerForcePreviewTarget;
};

export type AdminShippingControllerForcePreviewTarget =
  (typeof AdminShippingControllerForcePreviewTarget)[keyof typeof AdminShippingControllerForcePreviewTarget];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminShippingControllerForcePreviewTarget = {
  READY: "READY",
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  EXCEPTION: "EXCEPTION",
  RETURNED: "RETURNED",
  CANCELED: "CANCELED",
} as const;

export type AdminShippingControllerForcePreview200AllOf = {
  data?: ForcePreviewDto;
};

export type AdminShippingControllerForcePreview200 = BaseResponseDto &
  AdminShippingControllerForcePreview200AllOf;

export type AdminShippingControllerForceStatus200AllOf = {
  data?: ShippingShipmentDto;
};

export type AdminShippingControllerForceStatus200 = BaseResponseDto &
  AdminShippingControllerForceStatus200AllOf;

export type AdminShippingControllerForceReceive200AllOf = {
  data?: ShippingShipmentDto;
};

export type AdminShippingControllerForceReceive200 = BaseResponseDto &
  AdminShippingControllerForceReceive200AllOf;

export type AdminShippingControllerDismissDispute200AllOf = {
  data?: ShippingShipmentDto;
};

export type AdminShippingControllerDismissDispute200 = BaseResponseDto &
  AdminShippingControllerDismissDispute200AllOf;

export type AdminShippingControllerRecheck200AllOfData = {
  [key: string]: unknown;
};

export type AdminShippingControllerRecheck200AllOf = {
  data?: AdminShippingControllerRecheck200AllOfData;
};

export type AdminShippingControllerRecheck200 = BaseResponseDto &
  AdminShippingControllerRecheck200AllOf;

export type AdminShippingControllerProviders200AllOf = {
  data?: ProviderOverviewDto[];
};

export type AdminShippingControllerProviders200 = BaseResponseDto &
  AdminShippingControllerProviders200AllOf;

export type AdminShippingControllerResume200AllOfData = {
  [key: string]: unknown;
};

export type AdminShippingControllerResume200AllOf = {
  data?: AdminShippingControllerResume200AllOfData;
};

export type AdminShippingControllerResume200 = BaseResponseDto &
  AdminShippingControllerResume200AllOf;

export type AdminShippingControllerFailedEventsParams = {
  limit: string;
};

export type AdminShippingControllerFailedEvents200AllOf = {
  data?: FailedEventDto[];
};

export type AdminShippingControllerFailedEvents200 = BaseResponseDto &
  AdminShippingControllerFailedEvents200AllOf;

export type AdminShippingControllerRequeue200AllOfData = {
  [key: string]: unknown;
};

export type AdminShippingControllerRequeue200AllOf = {
  data?: AdminShippingControllerRequeue200AllOfData;
};

export type AdminShippingControllerRequeue200 = BaseResponseDto &
  AdminShippingControllerRequeue200AllOf;

export type ShippingCallbackControllerReceiveParams = {
  token: string;
};

/**
 * provider 가 정한 본문. semo: { items: [{ courierCode | providerCourierCode, trackingNo, level?, complete?, events: [{ occurredAt, level?, location?, message? }] }] }
 */
export type ShippingCallbackControllerReceiveBody = { [key: string]: unknown };

export type ShippingCallbackControllerReceive200AllOf = {
  data?: ShippingCallbackResultDto;
};

export type ShippingCallbackControllerReceive200 = BaseResponseDto &
  ShippingCallbackControllerReceive200AllOf;

export type ExternalStorefrontReactionsControllerListWishesParams = {
  /**
   * 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 몰 서버가 SSO 세션에서만 채운다.
   */
  ownerKey: string;
};

export type ExternalStorefrontReactionsControllerListWishes200AllOf = {
  data?: WishListResponseDto;
};

export type ExternalStorefrontReactionsControllerListWishes200 =
  BaseResponseDto & ExternalStorefrontReactionsControllerListWishes200AllOf;

export type ExternalStorefrontReactionsControllerAddWish200AllOf = {
  data?: WishToggleResponseDto;
};

export type ExternalStorefrontReactionsControllerAddWish200 = BaseResponseDto &
  ExternalStorefrontReactionsControllerAddWish200AllOf;

export type ExternalStorefrontReactionsControllerRemoveWishParams = {
  /**
   * 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 몰 서버가 SSO 세션에서만 채운다.
   */
  ownerKey: string;
};

export type ExternalStorefrontReactionsControllerRemoveWish200AllOf = {
  data?: WishToggleResponseDto;
};

export type ExternalStorefrontReactionsControllerRemoveWish200 =
  BaseResponseDto & ExternalStorefrontReactionsControllerRemoveWish200AllOf;

export type ExternalStorefrontReactionsControllerSignals200AllOf = {
  data?: ItemSignalsResponseDto;
};

export type ExternalStorefrontReactionsControllerSignals200 = BaseResponseDto &
  ExternalStorefrontReactionsControllerSignals200AllOf;

export type ExternalStorefrontReactionsControllerRankingParams = {
  /**
   * 최대 60
   */
  limit?: number;
};

export type ExternalStorefrontReactionsControllerRanking200AllOf = {
  data?: SocialProofRankingResponseDto;
};

export type ExternalStorefrontReactionsControllerRanking200 = BaseResponseDto &
  ExternalStorefrontReactionsControllerRanking200AllOf;

export type ExternalStorefrontReactionsControllerAlertsParams = {
  /**
   * 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 몰 서버가 SSO 세션에서만 채운다.
   */
  ownerKey: string;
};

export type ExternalStorefrontReactionsControllerAlerts200AllOf = {
  data?: ReactionAlertListResponseDto;
};

export type ExternalStorefrontReactionsControllerAlerts200 = BaseResponseDto &
  ExternalStorefrontReactionsControllerAlerts200AllOf;

export type ExternalStorefrontReviewsControllerListParams = {
  /**
   * 몰 신원 키 = 씨마켓 OIDC `sub`(«ROLE:groupCode:memberId»). 몰 서버가 SSO 세션에서만 채운다. 주면 «도움돼요» 누름·쓸 수 있는 주문이 실린다.
   */
  ownerKey?: string;
  page?: number;
  /**
   * 최대 50
   */
  limit?: number;
};

export type ExternalStorefrontReviewsControllerList200AllOf = {
  data?: ReviewPageResponseDto;
};

export type ExternalStorefrontReviewsControllerList200 = BaseResponseDto &
  ExternalStorefrontReviewsControllerList200AllOf;

export type ExternalStorefrontReviewsControllerCreate201AllOf = {
  data?: ReviewDto;
};

export type ExternalStorefrontReviewsControllerCreate201 = BaseResponseDto &
  ExternalStorefrontReviewsControllerCreate201AllOf;

export type ExternalStorefrontReviewsControllerHelpful200AllOf = {
  data?: ReviewHelpfulResponseDto;
};

export type ExternalStorefrontReviewsControllerHelpful200 = BaseResponseDto &
  ExternalStorefrontReviewsControllerHelpful200AllOf;

export type ExternalStorefrontReviewsControllerReport200AllOf = {
  data?: ReviewReportResponseDto;
};

export type ExternalStorefrontReviewsControllerReport200 = BaseResponseDto &
  ExternalStorefrontReviewsControllerReport200AllOf;

export type ExternalStorefrontReviewsControllerRemove200AllOf = {
  data?: ReviewDeleteResponseDto;
};

export type ExternalStorefrontReviewsControllerRemove200 = BaseResponseDto &
  ExternalStorefrontReviewsControllerRemove200AllOf;

export type SupplierStorefrontReactionsControllerMine200AllOf = {
  data?: SupplierReactionSummaryDto;
};

export type SupplierStorefrontReactionsControllerMine200 = BaseResponseDto &
  SupplierStorefrontReactionsControllerMine200AllOf;

export type ExternalShareLinksControllerCreate201AllOf = {
  data?: ShareLinkCreatedDto;
};

export type ExternalShareLinksControllerCreate201 = BaseResponseDto &
  ExternalShareLinksControllerCreate201AllOf;

export type ExternalShareLinksControllerListParams = {
  includeRevoked?: boolean;
  limit?: number;
  offset?: number;
};

export type ExternalShareLinksControllerList200AllOf = {
  data?: ShareLinkListDto;
};

export type ExternalShareLinksControllerList200 = BaseResponseDto &
  ExternalShareLinksControllerList200AllOf;

export type ExternalShareLinksControllerGet200AllOf = {
  data?: ShareLinkDetailDto;
};

export type ExternalShareLinksControllerGet200 = BaseResponseDto &
  ExternalShareLinksControllerGet200AllOf;

export type ExternalShareLinksControllerRevoke200AllOf = {
  data?: ShareLinkSummaryDto;
};

export type ExternalShareLinksControllerRevoke200 = BaseResponseDto &
  ExternalShareLinksControllerRevoke200AllOf;

export type ExternalShareLinksControllerReissue201AllOf = {
  data?: ShareLinkCreatedDto;
};

export type ExternalShareLinksControllerReissue201 = BaseResponseDto &
  ExternalShareLinksControllerReissue201AllOf;

export type SharePublicControllerViewParams = {
  /**
   * @maximum 100
   */
  limit?: number;
  offset?: number;
};

export type AdminSitesControllerList200AllOf = {
  data?: SiteSummaryDto[];
};

export type AdminSitesControllerList200 = BaseResponseDto &
  AdminSitesControllerList200AllOf;

export type AdminSitesControllerCreate201AllOf = {
  data?: ProvisionedSiteDto;
};

export type AdminSitesControllerCreate201 = BaseResponseDto &
  AdminSitesControllerCreate201AllOf;

export type AdminSitesControllerGetDetail200AllOf = {
  data?: SiteDetailDto;
};

export type AdminSitesControllerGetDetail200 = BaseResponseDto &
  AdminSitesControllerGetDetail200AllOf;

export type AdminSitesControllerSetStatus200AllOf = {
  data?: SiteStatusDto;
};

export type AdminSitesControllerSetStatus200 = BaseResponseDto &
  AdminSitesControllerSetStatus200AllOf;

export type AdminSitesControllerSetFeatures200AllOf = {
  data?: SiteEnabledFeaturesDto;
};

export type AdminSitesControllerSetFeatures200 = BaseResponseDto &
  AdminSitesControllerSetFeatures200AllOf;

export type AdminSitesControllerSetTheme200AllOf = {
  data?: SiteThemeDto;
};

export type AdminSitesControllerSetTheme200 = BaseResponseDto &
  AdminSitesControllerSetTheme200AllOf;

export type AdminSitesControllerAddDomain201AllOf = {
  data?: SiteDomainVerificationDto;
};

export type AdminSitesControllerAddDomain201 = BaseResponseDto &
  AdminSitesControllerAddDomain201AllOf;

export type AdminSitesControllerUpdateDomain200AllOf = {
  data?: SiteDomainDto;
};

export type AdminSitesControllerUpdateDomain200 = BaseResponseDto &
  AdminSitesControllerUpdateDomain200AllOf;

export type AdminSitesControllerListMembers200AllOf = {
  data?: SiteMemberDto[];
};

export type AdminSitesControllerListMembers200 = BaseResponseDto &
  AdminSitesControllerListMembers200AllOf;

export type AdminSitesControllerInvite201AllOf = {
  data?: SiteMemberDto;
};

export type AdminSitesControllerInvite201 = BaseResponseDto &
  AdminSitesControllerInvite201AllOf;

export type AdminSitesControllerSetMemberRole200AllOf = {
  data?: SiteMemberDto;
};

export type AdminSitesControllerSetMemberRole200 = BaseResponseDto &
  AdminSitesControllerSetMemberRole200AllOf;

export type AdminSitesControllerRevokeMember200AllOf = {
  data?: SiteMemberDto;
};

export type AdminSitesControllerRevokeMember200 = BaseResponseDto &
  AdminSitesControllerRevokeMember200AllOf;

export type AdminSiteDataControllerGetDataSource200AllOf = {
  data?: SiteDataSourceDto;
};

export type AdminSiteDataControllerGetDataSource200 = BaseResponseDto &
  AdminSiteDataControllerGetDataSource200AllOf;

export type AdminSiteDataControllerUpsertDataSource200AllOf = {
  data?: SiteDataSourceDto;
};

export type AdminSiteDataControllerUpsertDataSource200 = BaseResponseDto &
  AdminSiteDataControllerUpsertDataSource200AllOf;

export type AdminSiteDataControllerRemoveDataSource200AllOf = {
  data?: SiteDataSourceDto;
};

export type AdminSiteDataControllerRemoveDataSource200 = BaseResponseDto &
  AdminSiteDataControllerRemoveDataSource200AllOf;

export type AdminSiteDataControllerTestDataSource200AllOf = {
  data?: SiteDataSourceTestResultDto;
};

export type AdminSiteDataControllerTestDataSource200 = BaseResponseDto &
  AdminSiteDataControllerTestDataSource200AllOf;

export type AdminSiteDataControllerListRosterParams = {
  status?: AdminSiteDataControllerListRosterStatus;
  /**
   * 이름·아이디·전화·소속 검색
   */
  q?: string;
  /**
   * @maximum 200
   */
  limit?: number;
  offset?: number;
};

export type AdminSiteDataControllerListRosterStatus =
  (typeof AdminSiteDataControllerListRosterStatus)[keyof typeof AdminSiteDataControllerListRosterStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSiteDataControllerListRosterStatus = {
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
} as const;

export type AdminSiteDataControllerListRoster200AllOf = {
  data?: SiteRosterPageDto;
};

export type AdminSiteDataControllerListRoster200 = BaseResponseDto &
  AdminSiteDataControllerListRoster200AllOf;

export type AdminSiteDataControllerSetRosterStatus200AllOf = {
  data?: SiteRosterAccountDto;
};

export type AdminSiteDataControllerSetRosterStatus200 = BaseResponseDto &
  AdminSiteDataControllerSetRosterStatus200AllOf;

export type AdminSiteApplicationsControllerList200AllOf = {
  data?: SiteApplicationDto[];
};

export type AdminSiteApplicationsControllerList200 = BaseResponseDto &
  AdminSiteApplicationsControllerList200AllOf;

export type AdminSiteApplicationsControllerCreateDirect200AllOf = {
  data?: SiteApplicationDto;
};

export type AdminSiteApplicationsControllerCreateDirect200 = BaseResponseDto &
  AdminSiteApplicationsControllerCreateDirect200AllOf;

export type AdminSiteApplicationsControllerAddNote200AllOf = {
  data?: SiteApplicationDto;
};

export type AdminSiteApplicationsControllerAddNote200 = BaseResponseDto &
  AdminSiteApplicationsControllerAddNote200AllOf;

export type AdminSiteApplicationsControllerReview200AllOf = {
  data?: SiteApplicationDto;
};

export type AdminSiteApplicationsControllerReview200 = BaseResponseDto &
  AdminSiteApplicationsControllerReview200AllOf;

export type PublicSitesControllerGetContextParams = {
  /**
   * 헤더 X-Site-Host 대신 쿼리로도 받는다
   */
  host?: string;
};

export type PublicSitesControllerGetContext200AllOf = {
  data?: SiteContextDto;
};

export type PublicSitesControllerGetContext200 = BaseResponseDto &
  PublicSitesControllerGetContext200AllOf;

export type PublicSiteApplicationsControllerSubmit201AllOf = {
  data?: SiteApplicationSubmitResultDto;
};

export type PublicSiteApplicationsControllerSubmit201 = BaseResponseDto &
  PublicSiteApplicationsControllerSubmit201AllOf;

export type PublicSitePulseControllerEvents200AllOf = {
  data?: PulseAcceptedDto;
};

export type PublicSitePulseControllerEvents200 = BaseResponseDto &
  PublicSitePulseControllerEvents200AllOf;

export type PublicSitePulseControllerInquiries201AllOf = {
  data?: PulseInquiryResultDto;
};

export type PublicSitePulseControllerInquiries201 = BaseResponseDto &
  PublicSitePulseControllerInquiries201AllOf;

export type PublicSitePulseControllerReactionCounts200AllOf = {
  data?: PulseReactionCountsDto;
};

export type PublicSitePulseControllerReactionCounts200 = BaseResponseDto &
  PublicSitePulseControllerReactionCounts200AllOf;

export type PublicSitePulseControllerReact200AllOf = {
  data?: PulseReactResultDto;
};

export type PublicSitePulseControllerReact200 = BaseResponseDto &
  PublicSitePulseControllerReact200AllOf;

export type PublicSitePulseControllerBridge200AllOf = {
  data?: PulseBridgeDto;
};

export type PublicSitePulseControllerBridge200 = BaseResponseDto &
  PublicSitePulseControllerBridge200AllOf;

export type AdminSitePulseControllerReportParams = {
  /**
   * last = 지난주(월~일), current = 이번 주 월요일부터 오늘까지
   */
  period?: AdminSitePulseControllerReportPeriod;
  /**
   * 그 주(YYYY-MM-DD, 아무 날이나 — 그 주 월요일로 맞춘다)
   */
  weekStart?: string;
};

export type AdminSitePulseControllerReportPeriod =
  (typeof AdminSitePulseControllerReportPeriod)[keyof typeof AdminSitePulseControllerReportPeriod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSitePulseControllerReportPeriod = {
  last: "last",
  current: "current",
} as const;

export type PublicSiteAccountsControllerConfig200AllOf = {
  data?: SiteAuthConfigDto;
};

export type PublicSiteAccountsControllerConfig200 = BaseResponseDto &
  PublicSiteAccountsControllerConfig200AllOf;

export type PublicSiteAccountsControllerKakao200AllOf = {
  data?: SiteLoginResultDto;
};

export type PublicSiteAccountsControllerKakao200 = BaseResponseDto &
  PublicSiteAccountsControllerKakao200AllOf;

export type PublicSiteAccountsControllerMe200AllOf = {
  data?: SiteAccountMemberDto;
};

export type PublicSiteAccountsControllerMe200 = BaseResponseDto &
  PublicSiteAccountsControllerMe200AllOf;

export type PublicSiteAccountsControllerSaveProfile200AllOf = {
  data?: SiteAccountMemberDto;
};

export type PublicSiteAccountsControllerSaveProfile200 = BaseResponseDto &
  PublicSiteAccountsControllerSaveProfile200AllOf;

export type PublicSiteAccountsControllerWithdraw200AllOf = {
  data?: SiteWithdrawResultDto;
};

export type PublicSiteAccountsControllerWithdraw200 = BaseResponseDto &
  PublicSiteAccountsControllerWithdraw200AllOf;

export type AdminSiteAccountsControllerAccountsParams = {
  page?: number;
  /**
   * @maximum 100
   */
  limit?: number;
};

export type AdminBidAlertsControllerScan200AllOf = {
  data?: ScanResultDto;
};

export type AdminBidAlertsControllerScan200 = BaseResponseDto &
  AdminBidAlertsControllerScan200AllOf;

export type AdminBidAlertsControllerDispatchParams = {
  /**
   * 1 이면 스위치와 무관하게 드라이런
   */
  dry?: string;
};

export type AdminBidAlertsControllerDispatch200AllOf = {
  data?: DispatchResultDto;
};

export type AdminBidAlertsControllerDispatch200 = BaseResponseDto &
  AdminBidAlertsControllerDispatch200AllOf;

export type AdminBidAlertsControllerExpireStaleParams = {
  /**
   * KST 날짜 YYYY-MM-DD. 이 날짜 이전에 큐에 들어온 QUEUED 후보를 EXPIRED 로
   */
  before: string;
};

export type AdminBidAlertsControllerExpireStale200AllOf = {
  data?: ExpireStaleResultDto;
};

export type AdminBidAlertsControllerExpireStale200 = BaseResponseDto &
  AdminBidAlertsControllerExpireStale200AllOf;

export type AdminBidAlertsControllerStats200AllOf = {
  data?: BidAlertStatsDto;
};

export type AdminBidAlertsControllerStats200 = BaseResponseDto &
  AdminBidAlertsControllerStats200AllOf;

export type AdminBidAlertsControllerBatchesParams = {
  /**
   * KST 날짜 YYYY-MM-DD. 없으면 최근순 전체
   */
  date?: string;
  mode?: AdminBidAlertsControllerBatchesMode;
  /**
   * 최대 1000, 기본 200
   */
  limit?: number;
};

export type AdminBidAlertsControllerBatchesMode =
  (typeof AdminBidAlertsControllerBatchesMode)[keyof typeof AdminBidAlertsControllerBatchesMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminBidAlertsControllerBatchesMode = {
  DRYRUN: "DRYRUN",
  LIVE: "LIVE",
} as const;

export type AdminBidAlertsControllerBatches200AllOf = {
  data?: BidAlertBatchDto[];
};

export type AdminBidAlertsControllerBatches200 = BaseResponseDto &
  AdminBidAlertsControllerBatches200AllOf;

export type GcmRequestsControllerListParams = {
  orgId?: string;
  status?: GcmRequestsControllerListStatus;
};

export type GcmRequestsControllerListStatus =
  (typeof GcmRequestsControllerListStatus)[keyof typeof GcmRequestsControllerListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmRequestsControllerListStatus = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  NEEDS_INFO: "NEEDS_INFO",
  PUBLISHED_GENERAL: "PUBLISHED_GENERAL",
  S_APPROVED: "S_APPROVED",
  ON_HOLD: "ON_HOLD",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
  EXPIRED: "EXPIRED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
} as const;

export type AdminGcmRequestsControllerListParams = {
  status?: AdminGcmRequestsControllerListStatus;
  grade?: AdminGcmRequestsControllerListGrade;
  type?: AdminGcmRequestsControllerListType;
  risk?: AdminGcmRequestsControllerListRisk;
  page?: number;
  limit?: number;
};

export type AdminGcmRequestsControllerListStatus =
  (typeof AdminGcmRequestsControllerListStatus)[keyof typeof AdminGcmRequestsControllerListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmRequestsControllerListStatus = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  NEEDS_INFO: "NEEDS_INFO",
  PUBLISHED_GENERAL: "PUBLISHED_GENERAL",
  S_APPROVED: "S_APPROVED",
  ON_HOLD: "ON_HOLD",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
  EXPIRED: "EXPIRED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
} as const;

export type AdminGcmRequestsControllerListGrade =
  (typeof AdminGcmRequestsControllerListGrade)[keyof typeof AdminGcmRequestsControllerListGrade];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmRequestsControllerListGrade = {
  D: "D",
  C: "C",
  B: "B",
  A: "A",
  S: "S",
  NA: "NA",
} as const;

export type AdminGcmRequestsControllerListType =
  (typeof AdminGcmRequestsControllerListType)[keyof typeof AdminGcmRequestsControllerListType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmRequestsControllerListType = {
  PURCHASE: "PURCHASE",
  SELL: "SELL",
  DISTRIBUTION_PARTNER: "DISTRIBUTION_PARTNER",
  OEM_ODM: "OEM_ODM",
  SOURCING_RESEARCH: "SOURCING_RESEARCH",
  TECH_COOPERATION: "TECH_COOPERATION",
} as const;

export type AdminGcmRequestsControllerListRisk =
  (typeof AdminGcmRequestsControllerListRisk)[keyof typeof AdminGcmRequestsControllerListRisk];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmRequestsControllerListRisk = {
  NORMAL: "NORMAL",
  EXTRA_REVIEW: "EXTRA_REVIEW",
  PUBLISH_HOLD: "PUBLISH_HOLD",
} as const;

export type GcmBidsControllerListParams = {
  /**
   * 보는 공고함 나라 — 여러 나라 회사에 속할 때만. 없으면 승인된 회사의 (첫) 나라
   */
  country?: GcmBidsControllerListCountry;
  /**
   * 제목·발주기관·출처 검색
   */
  q?: string;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 50
   */
  limit?: number;
  sort?: GcmBidsControllerListSort;
};

export type GcmBidsControllerListCountry =
  (typeof GcmBidsControllerListCountry)[keyof typeof GcmBidsControllerListCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmBidsControllerListCountry = {
  ID: "ID",
  JP: "JP",
} as const;

export type GcmBidsControllerListSort =
  (typeof GcmBidsControllerListSort)[keyof typeof GcmBidsControllerListSort];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmBidsControllerListSort = {
  deadline: "deadline",
  newest: "newest",
} as const;

export type GcmBidsControllerGetParams = {
  /**
   * 보는 공고함 나라 — 여러 나라 회사에 속할 때만. 없으면 승인된 회사의 (첫) 나라
   */
  country?: GcmBidsControllerGetCountry;
};

export type GcmBidsControllerGetCountry =
  (typeof GcmBidsControllerGetCountry)[keyof typeof GcmBidsControllerGetCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmBidsControllerGetCountry = {
  ID: "ID",
  JP: "JP",
} as const;

export type GcmOffersControllerOpenRequestsParams = {
  specialty?: string;
};

export type AdminGcmDealsControllerMessageBlocksParams = {
  surface?: AdminGcmDealsControllerMessageBlocksSurface;
  reason?: AdminGcmDealsControllerMessageBlocksReason;
  page?: number;
  limit?: number;
};

export type AdminGcmDealsControllerMessageBlocksSurface =
  (typeof AdminGcmDealsControllerMessageBlocksSurface)[keyof typeof AdminGcmDealsControllerMessageBlocksSurface];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmDealsControllerMessageBlocksSurface = {
  DEAL_MESSAGE: "DEAL_MESSAGE",
  QUOTE: "QUOTE",
  PREP_REQUEST: "PREP_REQUEST",
  PREP_SUGGESTION: "PREP_SUGGESTION",
} as const;

export type AdminGcmDealsControllerMessageBlocksReason =
  (typeof AdminGcmDealsControllerMessageBlocksReason)[keyof typeof AdminGcmDealsControllerMessageBlocksReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmDealsControllerMessageBlocksReason = {
  CONTACT: "CONTACT",
  ADDRESS: "ADDRESS",
  COMPANY: "COMPANY",
  REGISTRATION_NUMBER: "REGISTRATION_NUMBER",
  PERSON_NAME: "PERSON_NAME",
  BANK: "BANK",
} as const;

export type AdminGcmDealsControllerFeesParams = {
  status?: AdminGcmDealsControllerFeesStatus;
  type?: AdminGcmDealsControllerFeesType;
  page?: number;
  limit?: number;
};

export type AdminGcmDealsControllerFeesStatus =
  (typeof AdminGcmDealsControllerFeesStatus)[keyof typeof AdminGcmDealsControllerFeesStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmDealsControllerFeesStatus = {
  PENDING: "PENDING",
  CHARGED: "CHARGED",
  INSUFFICIENT: "INSUFFICIENT",
  DUPLICATE: "DUPLICATE",
  REFUNDED: "REFUNDED",
  FAILED: "FAILED",
  SKIPPED_UNCONFIGURED: "SKIPPED_UNCONFIGURED",
} as const;

export type AdminGcmDealsControllerFeesType =
  (typeof AdminGcmDealsControllerFeesType)[keyof typeof AdminGcmDealsControllerFeesType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmDealsControllerFeesType = {
  GCM_JOIN: "GCM_JOIN",
  GCM_CONTACT: "GCM_CONTACT",
  GCM_CONTRACT: "GCM_CONTRACT",
} as const;

export type GcmRequestMessagesControllerListParams = {
  /**
   * 폴링 — 이 시각(ISO) 뒤의 글만
   */
  after?: string;
};

export type GcmOfferMessagesControllerListParams = {
  /**
   * 폴링 — 이 시각(ISO) 뒤의 글만
   */
  after?: string;
};

export type GcmActivityControllerGetSellableParams = {
  /**
   * 화면 언어(출처 이름 표기). 생략하면 회원의 언어
   */
  lang?: GcmActivityControllerGetSellableLang;
  /**
   * «그 나라 공고» 구역의 나라 — 여러 나라 회사에 속할 때만. 없으면 승인된 회사의 (첫) 나라(공고함 GET /gcm/bids 와 같은 규칙). 내 회사 나라가 아니면 그 구역만 null
   */
  country?: GcmActivityControllerGetSellableCountry;
};

export type GcmActivityControllerGetSellableLang =
  (typeof GcmActivityControllerGetSellableLang)[keyof typeof GcmActivityControllerGetSellableLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmActivityControllerGetSellableLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export type GcmActivityControllerGetSellableCountry =
  (typeof GcmActivityControllerGetSellableCountry)[keyof typeof GcmActivityControllerGetSellableCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmActivityControllerGetSellableCountry = {
  ID: "ID",
  JP: "JP",
} as const;

export type GcmActivityControllerGetParams = {
  /**
   * 화면 언어(출처 이름 표기). 생략하면 회원의 언어
   */
  lang?: GcmActivityControllerGetLang;
  /**
   * «그 나라 공고» 구역의 나라 — 여러 나라 회사에 속할 때만. 없으면 승인된 회사의 (첫) 나라(공고함 GET /gcm/bids 와 같은 규칙). 내 회사 나라가 아니면 그 구역만 null
   */
  country?: GcmActivityControllerGetCountry;
};

export type GcmActivityControllerGetLang =
  (typeof GcmActivityControllerGetLang)[keyof typeof GcmActivityControllerGetLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmActivityControllerGetLang = {
  id: "id",
  ko: "ko",
  en: "en",
  ja: "ja",
} as const;

export type GcmActivityControllerGetCountry =
  (typeof GcmActivityControllerGetCountry)[keyof typeof GcmActivityControllerGetCountry];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmActivityControllerGetCountry = {
  ID: "ID",
  JP: "JP",
} as const;

export type GcmActivityControllerGet200AllOf = {
  data?: GcmActivityDto;
};

export type GcmActivityControllerGet200 = BaseResponseDto &
  GcmActivityControllerGet200AllOf;

export type AdminGcmTrendTermsControllerListParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
};

export type AdminGcmTrendPicksControllerExpiringParams = {
  /**
   * @minimum 1
   * @maximum 90
   */
  days?: number;
};

export type AdminGcmTrendPicksControllerListParams = {
  status?: AdminGcmTrendPicksControllerListStatus;
  expiring?: AdminGcmTrendPicksControllerListExpiring;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
};

export type AdminGcmTrendPicksControllerListStatus =
  (typeof AdminGcmTrendPicksControllerListStatus)[keyof typeof AdminGcmTrendPicksControllerListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmTrendPicksControllerListStatus = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
  ARCHIVED: "ARCHIVED",
} as const;

export type AdminGcmTrendPicksControllerListExpiring =
  (typeof AdminGcmTrendPicksControllerListExpiring)[keyof typeof AdminGcmTrendPicksControllerListExpiring];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminGcmTrendPicksControllerListExpiring = {
  true: "true",
  false: "false",
} as const;

export type GcmTrendPicksControllerListParams = {
  category?: GcmTrendPicksControllerListCategory;
  /**
   * 다음 페이지(앞 응답의 nextCursor)
   */
  cursor?: string;
  /**
   * @minimum 1
   * @maximum 50
   */
  limit?: number;
};

export type GcmTrendPicksControllerListCategory =
  (typeof GcmTrendPicksControllerListCategory)[keyof typeof GcmTrendPicksControllerListCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GcmTrendPicksControllerListCategory = {
  SKINCARE: "SKINCARE",
  MAKEUP: "MAKEUP",
  HAIR_BODY: "HAIR_BODY",
  FOOD: "FOOD",
  BEVERAGE: "BEVERAGE",
  HEALTH: "HEALTH",
  LIVING: "LIVING",
  OTHER: "OTHER",
} as const;

export type ExternalInsurerBidRecordsControllerIngest200AllOf = {
  data?: InsurerBidRecordsResultDto;
};

export type ExternalInsurerBidRecordsControllerIngest200 = BaseResponseDto &
  ExternalInsurerBidRecordsControllerIngest200AllOf;

export type AdminOwnerKeyControllerEventsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
};

export type GcmPlatformStateControllerGet200AllOf = {
  data?: GcmPlatformStateDto;
};

export type GcmPlatformStateControllerGet200 = BaseResponseDto &
  GcmPlatformStateControllerGet200AllOf;

export type SupplierWeeklyViewersControllerGetWeeklyViewers200AllOf = {
  data?: SupplierWeeklyViewersDto;
};

export type SupplierWeeklyViewersControllerGetWeeklyViewers200 =
  BaseResponseDto & SupplierWeeklyViewersControllerGetWeeklyViewers200AllOf;

export type ExternalCmarketDirectoryControllerReceive200AllOf = {
  data?: CmarketDirectoryResultDto;
};

export type ExternalCmarketDirectoryControllerReceive200 = BaseResponseDto &
  ExternalCmarketDirectoryControllerReceive200AllOf;

export type ExternalCmarketAwardsControllerReceive200AllOf = {
  data?: CmarketAwardReceivedDto;
};

export type ExternalCmarketAwardsControllerReceive200 = BaseResponseDto &
  ExternalCmarketAwardsControllerReceive200AllOf;

export type SupplierCmarketAwardsControllerListMine200AllOf = {
  data?: CmarketAwardTargetDto[];
};

export type SupplierCmarketAwardsControllerListMine200 = BaseResponseDto &
  SupplierCmarketAwardsControllerListMine200AllOf;

export type SupplierCmarketAwardsControllerByRefParams = {
  award: unknown;
};

export type SupplierCmarketAwardsControllerByRef200AllOf = {
  data?: CmarketAwardTargetDto;
};

export type SupplierCmarketAwardsControllerByRef200 = BaseResponseDto &
  SupplierCmarketAwardsControllerByRef200AllOf;

export type SupplierCmarketAwardsControllerRegister201AllOf = {
  data?: CmarketAwardShipmentResultDto;
};

export type SupplierCmarketAwardsControllerRegister201 = BaseResponseDto &
  SupplierCmarketAwardsControllerRegister201AllOf;

export type ExternalCmarketInspectionLinkControllerLink200AllOf = {
  data?: InspectionLinkResponseDto;
};

export type ExternalCmarketInspectionLinkControllerLink200 = BaseResponseDto &
  ExternalCmarketInspectionLinkControllerLink200AllOf;

export type AdminReceiptInspectionsControllerListParams = {
  status?: AdminReceiptInspectionsControllerListStatus;
  /**
   * 예행연습만(true) · 빼고(false)
   */
  rehearsal?: boolean;
  page?: number;
  limit?: number;
};

export type AdminReceiptInspectionsControllerListStatus =
  (typeof AdminReceiptInspectionsControllerListStatus)[keyof typeof AdminReceiptInspectionsControllerListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminReceiptInspectionsControllerListStatus = {
  OPEN: "OPEN",
  SUBMITTED: "SUBMITTED",
  CANCELLED: "CANCELLED",
} as const;

export type NiceAuthControllerInitializeAuth200AllOf = {
  data?: NiceInitResponseDto;
};

export type NiceAuthControllerInitializeAuth200 = BaseResponseDto &
  NiceAuthControllerInitializeAuth200AllOf;

export type NiceAuthControllerProcessCallback200AllOf = {
  data?: NiceCallbackResponseDto;
};

export type NiceAuthControllerProcessCallback200 = BaseResponseDto &
  NiceAuthControllerProcessCallback200AllOf;

export type NiceAuthControllerBridgeNiceCallbackParams = {
  context: string;
};

export type NiceAuthControllerBridgeNiceCallbackGetParams = {
  context: string;
};

export type AdminEngagementDigestControllerSendNowParams = {
  /**
   * 1 이면 오늘 쌓인 반응까지 지금 보낸다(스테이징 확인용). 기본은 어제까지 — 매일 09:00 크론과 같다.
   */
  includeToday?: string;
};

export type AdminEngagementDigestControllerSendNow200AllOf = {
  data?: SendDigestNowResultDto;
};

export type AdminEngagementDigestControllerSendNow200 = BaseResponseDto &
  AdminEngagementDigestControllerSendNow200AllOf;
